const localites = {
    "de": [
        {
            "code": "1000",
            "localite": "Lausanne 25"
        },
        {
            "code": "1000",
            "localite": "Lausanne 26"
        },
        {
            "code": "1000",
            "localite": "Lausanne 27"
        },
        {
            "code": "1003",
            "localite": "Lausanne"
        },
        {
            "code": "1004",
            "localite": "Lausanne"
        },
        {
            "code": "1005",
            "localite": "Lausanne"
        },
        {
            "code": "1006",
            "localite": "Lausanne"
        },
        {
            "code": "1007",
            "localite": "Lausanne"
        },
        {
            "code": "1008",
            "localite": "Jouxtens-Mézery"
        },
        {
            "code": "1008",
            "localite": "Prilly"
        },
        {
            "code": "1009",
            "localite": "Pully"
        },
        {
            "code": "1010",
            "localite": "Lausanne"
        },
        {
            "code": "1011",
            "localite": "Lausanne"
        },
        {
            "code": "1012",
            "localite": "Lausanne"
        },
        {
            "code": "1015",
            "localite": "Lausanne"
        },
        {
            "code": "1018",
            "localite": "Lausanne"
        },
        {
            "code": "1020",
            "localite": "Renens VD"
        },
        {
            "code": "1022",
            "localite": "Chavannes-près-Renens"
        },
        {
            "code": "1023",
            "localite": "Crissier"
        },
        {
            "code": "1024",
            "localite": "Ecublens VD"
        },
        {
            "code": "1025",
            "localite": "St-Sulpice VD"
        },
        {
            "code": "1026",
            "localite": "Denges"
        },
        {
            "code": "1026",
            "localite": "Echandens"
        },
        {
            "code": "1027",
            "localite": "Lonay"
        },
        {
            "code": "1028",
            "localite": "Préverenges"
        },
        {
            "code": "1029",
            "localite": "Villars-Ste-Croix"
        },
        {
            "code": "1030",
            "localite": "Bussigny"
        },
        {
            "code": "1031",
            "localite": "Mex VD"
        },
        {
            "code": "1032",
            "localite": "Romanel-sur-Lausanne"
        },
        {
            "code": "1033",
            "localite": "Cheseaux-sur-Lausanne"
        },
        {
            "code": "1034",
            "localite": "Boussens"
        },
        {
            "code": "1035",
            "localite": "Bournens"
        },
        {
            "code": "1036",
            "localite": "Sullens"
        },
        {
            "code": "1037",
            "localite": "Etagnières"
        },
        {
            "code": "1038",
            "localite": "Bercher"
        },
        {
            "code": "1040",
            "localite": "Echallens"
        },
        {
            "code": "1040",
            "localite": "St-Barthélemy VD"
        },
        {
            "code": "1040",
            "localite": "Villars-le-Terroir"
        },
        {
            "code": "1041",
            "localite": "Bottens"
        },
        {
            "code": "1041",
            "localite": "Dommartin"
        },
        {
            "code": "1041",
            "localite": "Montaubion-Chardonney"
        },
        {
            "code": "1041",
            "localite": "Naz"
        },
        {
            "code": "1041",
            "localite": "Poliez-Pittet"
        },
        {
            "code": "1041",
            "localite": "Poliez-le-Grand"
        },
        {
            "code": "1042",
            "localite": "Assens"
        },
        {
            "code": "1042",
            "localite": "Bettens"
        },
        {
            "code": "1042",
            "localite": "Bioley-Orjulaz"
        },
        {
            "code": "1043",
            "localite": "Sugnens"
        },
        {
            "code": "1044",
            "localite": "Fey"
        },
        {
            "code": "1045",
            "localite": "Ogens"
        },
        {
            "code": "1046",
            "localite": "Rueyres"
        },
        {
            "code": "1047",
            "localite": "Oppens"
        },
        {
            "code": "1052",
            "localite": "Le Mont-sur-Lausanne"
        },
        {
            "code": "1053",
            "localite": "Bretigny-sur-Morrens"
        },
        {
            "code": "1053",
            "localite": "Cugy VD"
        },
        {
            "code": "1054",
            "localite": "Morrens VD"
        },
        {
            "code": "1055",
            "localite": "Froideville"
        },
        {
            "code": "1058",
            "localite": "Villars-Tiercelin"
        },
        {
            "code": "1059",
            "localite": "Peney-le-Jorat"
        },
        {
            "code": "1061",
            "localite": "Villars-Mendraz"
        },
        {
            "code": "1062",
            "localite": "Sottens"
        },
        {
            "code": "1063",
            "localite": "Boulens"
        },
        {
            "code": "1063",
            "localite": "Chapelle-sur-Moudon"
        },
        {
            "code": "1063",
            "localite": "Martherenges"
        },
        {
            "code": "1063",
            "localite": "Peyres-Possens"
        },
        {
            "code": "1066",
            "localite": "Epalinges"
        },
        {
            "code": "1068",
            "localite": "Les Monts-de-Pully"
        },
        {
            "code": "1070",
            "localite": "Puidoux"
        },
        {
            "code": "1071",
            "localite": "Chexbres"
        },
        {
            "code": "1071",
            "localite": "Rivaz"
        },
        {
            "code": "1071",
            "localite": "St-Saphorin (Lavaux)"
        },
        {
            "code": "1072",
            "localite": "Forel (Lavaux)"
        },
        {
            "code": "1073",
            "localite": "Mollie-Margot"
        },
        {
            "code": "1073",
            "localite": "Savigny"
        },
        {
            "code": "1076",
            "localite": "Ferlens VD"
        },
        {
            "code": "1077",
            "localite": "Servion"
        },
        {
            "code": "1078",
            "localite": "Essertes"
        },
        {
            "code": "1080",
            "localite": "Les Cullayes"
        },
        {
            "code": "1081",
            "localite": "Montpreveyres"
        },
        {
            "code": "1082",
            "localite": "Corcelles-le-Jorat"
        },
        {
            "code": "1083",
            "localite": "Mézières VD"
        },
        {
            "code": "1084",
            "localite": "Carrouge VD"
        },
        {
            "code": "1085",
            "localite": "Vulliens"
        },
        {
            "code": "1088",
            "localite": "Ropraz"
        },
        {
            "code": "1090",
            "localite": "La Croix (Lutry)"
        },
        {
            "code": "1091",
            "localite": "Aran"
        },
        {
            "code": "1091",
            "localite": "Chenaux"
        },
        {
            "code": "1091",
            "localite": "Grandvaux"
        },
        {
            "code": "1092",
            "localite": "Belmont-sur-Lausanne"
        },
        {
            "code": "1093",
            "localite": "La Conversion"
        },
        {
            "code": "1094",
            "localite": "Paudex"
        },
        {
            "code": "1095",
            "localite": "Lutry"
        },
        {
            "code": "1096",
            "localite": "Cully"
        },
        {
            "code": "1096",
            "localite": "Villette (Lavaux)"
        },
        {
            "code": "1097",
            "localite": "Riex"
        },
        {
            "code": "1098",
            "localite": "Epesses"
        },
        {
            "code": "1110",
            "localite": "Morges"
        },
        {
            "code": "1112",
            "localite": "Echichens"
        },
        {
            "code": "1113",
            "localite": "St-Saphorin-sur-Morges"
        },
        {
            "code": "1114",
            "localite": "Colombier VD"
        },
        {
            "code": "1115",
            "localite": "Vullierens"
        },
        {
            "code": "1116",
            "localite": "Cottens VD"
        },
        {
            "code": "1117",
            "localite": "Grancy"
        },
        {
            "code": "1121",
            "localite": "Bremblens"
        },
        {
            "code": "1122",
            "localite": "Romanel-sur-Morges"
        },
        {
            "code": "1123",
            "localite": "Aclens"
        },
        {
            "code": "1124",
            "localite": "Gollion"
        },
        {
            "code": "1125",
            "localite": "Monnaz"
        },
        {
            "code": "1126",
            "localite": "Vaux-sur-Morges"
        },
        {
            "code": "1127",
            "localite": "Clarmont"
        },
        {
            "code": "1128",
            "localite": "Reverolle"
        },
        {
            "code": "1131",
            "localite": "Tolochenaz"
        },
        {
            "code": "1132",
            "localite": "Lully VD"
        },
        {
            "code": "1134",
            "localite": "Chigny"
        },
        {
            "code": "1134",
            "localite": "Vufflens-le-Château"
        },
        {
            "code": "1135",
            "localite": "Denens"
        },
        {
            "code": "1136",
            "localite": "Bussy-Chardonney"
        },
        {
            "code": "1141",
            "localite": "Sévery"
        },
        {
            "code": "1142",
            "localite": "Pampigny"
        },
        {
            "code": "1143",
            "localite": "Apples"
        },
        {
            "code": "1144",
            "localite": "Ballens"
        },
        {
            "code": "1145",
            "localite": "Bière"
        },
        {
            "code": "1146",
            "localite": "Mollens VD"
        },
        {
            "code": "1147",
            "localite": "Montricher"
        },
        {
            "code": "1148",
            "localite": "Chavannes-le-Veyron"
        },
        {
            "code": "1148",
            "localite": "Cuarnens"
        },
        {
            "code": "1148",
            "localite": "L'Isle"
        },
        {
            "code": "1148",
            "localite": "La Coudre"
        },
        {
            "code": "1148",
            "localite": "La Praz"
        },
        {
            "code": "1148",
            "localite": "Mauraz"
        },
        {
            "code": "1148",
            "localite": "Moiry VD"
        },
        {
            "code": "1148",
            "localite": "Mont-la-Ville"
        },
        {
            "code": "1148",
            "localite": "Villars-Bozon"
        },
        {
            "code": "1149",
            "localite": "Berolle"
        },
        {
            "code": "1162",
            "localite": "St-Prex"
        },
        {
            "code": "1163",
            "localite": "Etoy"
        },
        {
            "code": "1164",
            "localite": "Buchillon"
        },
        {
            "code": "1165",
            "localite": "Allaman"
        },
        {
            "code": "1166",
            "localite": "Perroy"
        },
        {
            "code": "1167",
            "localite": "Lussy-sur-Morges"
        },
        {
            "code": "1168",
            "localite": "Villars-sous-Yens"
        },
        {
            "code": "1169",
            "localite": "Yens"
        },
        {
            "code": "1170",
            "localite": "Aubonne"
        },
        {
            "code": "1172",
            "localite": "Bougy-Villars"
        },
        {
            "code": "1173",
            "localite": "Féchy"
        },
        {
            "code": "1174",
            "localite": "Montherod"
        },
        {
            "code": "1174",
            "localite": "Pizy"
        },
        {
            "code": "1175",
            "localite": "Lavigny"
        },
        {
            "code": "1176",
            "localite": "St-Livres"
        },
        {
            "code": "1180",
            "localite": "Rolle"
        },
        {
            "code": "1180",
            "localite": "Tartegnin"
        },
        {
            "code": "1182",
            "localite": "Gilly"
        },
        {
            "code": "1183",
            "localite": "Bursins"
        },
        {
            "code": "1184",
            "localite": "Luins"
        },
        {
            "code": "1184",
            "localite": "Vinzel"
        },
        {
            "code": "1185",
            "localite": "Mont-sur-Rolle"
        },
        {
            "code": "1186",
            "localite": "Essertines-sur-Rolle"
        },
        {
            "code": "1187",
            "localite": "St-Oyens"
        },
        {
            "code": "1188",
            "localite": "Gimel"
        },
        {
            "code": "1188",
            "localite": "St-George"
        },
        {
            "code": "1189",
            "localite": "Saubraz"
        },
        {
            "code": "1195",
            "localite": "Bursinel"
        },
        {
            "code": "1195",
            "localite": "Dully"
        },
        {
            "code": "1196",
            "localite": "Gland"
        },
        {
            "code": "1197",
            "localite": "Prangins"
        },
        {
            "code": "1201",
            "localite": "Genève"
        },
        {
            "code": "1202",
            "localite": "Genève"
        },
        {
            "code": "1203",
            "localite": "Genève"
        },
        {
            "code": "1204",
            "localite": "Genève"
        },
        {
            "code": "1205",
            "localite": "Genève"
        },
        {
            "code": "1206",
            "localite": "Genève"
        },
        {
            "code": "1207",
            "localite": "Genève"
        },
        {
            "code": "1208",
            "localite": "Genève"
        },
        {
            "code": "1209",
            "localite": "Genève"
        },
        {
            "code": "1212",
            "localite": "Grand-Lancy"
        },
        {
            "code": "1213",
            "localite": "Onex"
        },
        {
            "code": "1213",
            "localite": "Petit-Lancy"
        },
        {
            "code": "1214",
            "localite": "Vernier"
        },
        {
            "code": "1215",
            "localite": "Genève"
        },
        {
            "code": "1216",
            "localite": "Cointrin"
        },
        {
            "code": "1217",
            "localite": "Meyrin"
        },
        {
            "code": "1218",
            "localite": "Le Grand-Saconnex"
        },
        {
            "code": "1219",
            "localite": "Aïre"
        },
        {
            "code": "1219",
            "localite": "Châtelaine"
        },
        {
            "code": "1219",
            "localite": "Le Lignon"
        },
        {
            "code": "1220",
            "localite": "Les Avanchets"
        },
        {
            "code": "1222",
            "localite": "Vésenaz"
        },
        {
            "code": "1223",
            "localite": "Cologny"
        },
        {
            "code": "1224",
            "localite": "Chêne-Bougeries"
        },
        {
            "code": "1225",
            "localite": "Chêne-Bourg"
        },
        {
            "code": "1226",
            "localite": "Thônex"
        },
        {
            "code": "1227",
            "localite": "Carouge GE"
        },
        {
            "code": "1227",
            "localite": "Les Acacias"
        },
        {
            "code": "1228",
            "localite": "Plan-les-Ouates"
        },
        {
            "code": "1231",
            "localite": "Conches"
        },
        {
            "code": "1232",
            "localite": "Confignon"
        },
        {
            "code": "1233",
            "localite": "Bernex"
        },
        {
            "code": "1234",
            "localite": "Vessy"
        },
        {
            "code": "1236",
            "localite": "Cartigny"
        },
        {
            "code": "1237",
            "localite": "Avully"
        },
        {
            "code": "1239",
            "localite": "Collex"
        },
        {
            "code": "1241",
            "localite": "Puplinge"
        },
        {
            "code": "1242",
            "localite": "Satigny"
        },
        {
            "code": "1243",
            "localite": "Presinge"
        },
        {
            "code": "1244",
            "localite": "Choulex"
        },
        {
            "code": "1245",
            "localite": "Collonge-Bellerive"
        },
        {
            "code": "1246",
            "localite": "Corsier GE"
        },
        {
            "code": "1247",
            "localite": "Anières"
        },
        {
            "code": "1248",
            "localite": "Hermance"
        },
        {
            "code": "1251",
            "localite": "Gy"
        },
        {
            "code": "1252",
            "localite": "Meinier"
        },
        {
            "code": "1253",
            "localite": "Vandoeuvres"
        },
        {
            "code": "1254",
            "localite": "Jussy"
        },
        {
            "code": "1255",
            "localite": "Veyrier"
        },
        {
            "code": "1256",
            "localite": "Troinex"
        },
        {
            "code": "1257",
            "localite": "La Croix-de-Rozon"
        },
        {
            "code": "1258",
            "localite": "Perly"
        },
        {
            "code": "1260",
            "localite": "Nyon"
        },
        {
            "code": "1261",
            "localite": "Le Vaud"
        },
        {
            "code": "1261",
            "localite": "Longirod"
        },
        {
            "code": "1261",
            "localite": "Marchissy"
        },
        {
            "code": "1262",
            "localite": "Eysins"
        },
        {
            "code": "1263",
            "localite": "Crassier"
        },
        {
            "code": "1264",
            "localite": "St-Cergue"
        },
        {
            "code": "1265",
            "localite": "La Cure"
        },
        {
            "code": "1266",
            "localite": "Duillier"
        },
        {
            "code": "1267",
            "localite": "Coinsins"
        },
        {
            "code": "1267",
            "localite": "Vich"
        },
        {
            "code": "1268",
            "localite": "Begnins"
        },
        {
            "code": "1268",
            "localite": "Burtigny"
        },
        {
            "code": "1269",
            "localite": "Bassins"
        },
        {
            "code": "1270",
            "localite": "Trélex"
        },
        {
            "code": "1271",
            "localite": "Givrins"
        },
        {
            "code": "1272",
            "localite": "Genolier"
        },
        {
            "code": "1273",
            "localite": "Arzier-Le Muids"
        },
        {
            "code": "1274",
            "localite": "Grens"
        },
        {
            "code": "1274",
            "localite": "Signy"
        },
        {
            "code": "1275",
            "localite": "Chéserex"
        },
        {
            "code": "1276",
            "localite": "Gingins"
        },
        {
            "code": "1277",
            "localite": "Arnex-sur-Nyon"
        },
        {
            "code": "1277",
            "localite": "Borex"
        },
        {
            "code": "1278",
            "localite": "La Rippe"
        },
        {
            "code": "1279",
            "localite": "Bogis-Bossey"
        },
        {
            "code": "1279",
            "localite": "Chavannes-de-Bogis"
        },
        {
            "code": "1281",
            "localite": "Russin"
        },
        {
            "code": "1283",
            "localite": "Dardagny"
        },
        {
            "code": "1283",
            "localite": "La Plaine"
        },
        {
            "code": "1284",
            "localite": "Chancy"
        },
        {
            "code": "1285",
            "localite": "Athenaz (Avusy)"
        },
        {
            "code": "1286",
            "localite": "Soral"
        },
        {
            "code": "1287",
            "localite": "Laconnex"
        },
        {
            "code": "1288",
            "localite": "Aire-la-Ville"
        },
        {
            "code": "1290",
            "localite": "Chavannes-des-Bois"
        },
        {
            "code": "1290",
            "localite": "Versoix"
        },
        {
            "code": "1291",
            "localite": "Commugny"
        },
        {
            "code": "1292",
            "localite": "Chambésy"
        },
        {
            "code": "1293",
            "localite": "Bellevue"
        },
        {
            "code": "1294",
            "localite": "Genthod"
        },
        {
            "code": "1295",
            "localite": "Mies"
        },
        {
            "code": "1295",
            "localite": "Tannay"
        },
        {
            "code": "1296",
            "localite": "Coppet"
        },
        {
            "code": "1297",
            "localite": "Founex"
        },
        {
            "code": "1298",
            "localite": "Céligny"
        },
        {
            "code": "1299",
            "localite": "Crans VD"
        },
        {
            "code": "1302",
            "localite": "Vufflens-la-Ville"
        },
        {
            "code": "1303",
            "localite": "Penthaz"
        },
        {
            "code": "1304",
            "localite": "Allens"
        },
        {
            "code": "1304",
            "localite": "Cossonay-Ville"
        },
        {
            "code": "1304",
            "localite": "Dizy"
        },
        {
            "code": "1304",
            "localite": "Senarclens"
        },
        {
            "code": "1305",
            "localite": "Penthalaz"
        },
        {
            "code": "1306",
            "localite": "Daillens"
        },
        {
            "code": "1307",
            "localite": "Lussery-Villars"
        },
        {
            "code": "1308",
            "localite": "La Chaux (Cossonay)"
        },
        {
            "code": "1312",
            "localite": "Eclépens"
        },
        {
            "code": "1313",
            "localite": "Ferreyres"
        },
        {
            "code": "1315",
            "localite": "La Sarraz"
        },
        {
            "code": "1316",
            "localite": "Chevilly"
        },
        {
            "code": "1317",
            "localite": "Orny"
        },
        {
            "code": "1318",
            "localite": "Pompaples"
        },
        {
            "code": "1321",
            "localite": "Arnex-sur-Orbe"
        },
        {
            "code": "1322",
            "localite": "Croy"
        },
        {
            "code": "1323",
            "localite": "Romainmôtier"
        },
        {
            "code": "1324",
            "localite": "Premier"
        },
        {
            "code": "1325",
            "localite": "Vaulion"
        },
        {
            "code": "1326",
            "localite": "Juriens"
        },
        {
            "code": "1329",
            "localite": "Bretonnières"
        },
        {
            "code": "1337",
            "localite": "Vallorbe"
        },
        {
            "code": "1338",
            "localite": "Ballaigues"
        },
        {
            "code": "1341",
            "localite": "L'Orient"
        },
        {
            "code": "1342",
            "localite": "Le Pont"
        },
        {
            "code": "1343",
            "localite": "Les Charbonnières"
        },
        {
            "code": "1344",
            "localite": "L'Abbaye"
        },
        {
            "code": "1345",
            "localite": "Le Lieu"
        },
        {
            "code": "1345",
            "localite": "Le Séchey"
        },
        {
            "code": "1346",
            "localite": "Les Bioux"
        },
        {
            "code": "1347",
            "localite": "Le Sentier"
        },
        {
            "code": "1347",
            "localite": "Le Solliat"
        },
        {
            "code": "1348",
            "localite": "Le Brassus"
        },
        {
            "code": "1350",
            "localite": "Orbe"
        },
        {
            "code": "1352",
            "localite": "Agiez"
        },
        {
            "code": "1353",
            "localite": "Bofflens"
        },
        {
            "code": "1354",
            "localite": "Montcherand"
        },
        {
            "code": "1355",
            "localite": "L'Abergement"
        },
        {
            "code": "1355",
            "localite": "Sergey"
        },
        {
            "code": "1356",
            "localite": "La Russille"
        },
        {
            "code": "1356",
            "localite": "Les Clées"
        },
        {
            "code": "1357",
            "localite": "Lignerolle"
        },
        {
            "code": "1358",
            "localite": "Valeyres-sous-Rances"
        },
        {
            "code": "1372",
            "localite": "Bavois"
        },
        {
            "code": "1373",
            "localite": "Chavornay"
        },
        {
            "code": "1374",
            "localite": "Corcelles-sur-Chavornay"
        },
        {
            "code": "1375",
            "localite": "Penthéréaz"
        },
        {
            "code": "1376",
            "localite": "Eclagnens"
        },
        {
            "code": "1376",
            "localite": "Goumoens-la-Ville"
        },
        {
            "code": "1376",
            "localite": "Goumoens-le-Jux"
        },
        {
            "code": "1377",
            "localite": "Oulens-sous-Echallens"
        },
        {
            "code": "1400",
            "localite": "Cheseaux-Noréaz"
        },
        {
            "code": "1400",
            "localite": "Yverdon-les-Bains"
        },
        {
            "code": "1404",
            "localite": "Cuarny"
        },
        {
            "code": "1404",
            "localite": "Villars-Epeney"
        },
        {
            "code": "1405",
            "localite": "Pomy"
        },
        {
            "code": "1406",
            "localite": "Cronay"
        },
        {
            "code": "1407",
            "localite": "Bioley-Magnoux"
        },
        {
            "code": "1407",
            "localite": "Donneloye"
        },
        {
            "code": "1407",
            "localite": "Gossens"
        },
        {
            "code": "1407",
            "localite": "Mézery-près-Donneloye"
        },
        {
            "code": "1408",
            "localite": "Prahins"
        },
        {
            "code": "1409",
            "localite": "Chanéaz"
        },
        {
            "code": "1410",
            "localite": "Correvon"
        },
        {
            "code": "1410",
            "localite": "Denezy"
        },
        {
            "code": "1410",
            "localite": "Prévondavaux"
        },
        {
            "code": "1410",
            "localite": "St-Cierges"
        },
        {
            "code": "1410",
            "localite": "Thierrens"
        },
        {
            "code": "1412",
            "localite": "Ursins"
        },
        {
            "code": "1412",
            "localite": "Valeyres-sous-Ursins"
        },
        {
            "code": "1413",
            "localite": "Orzens"
        },
        {
            "code": "1415",
            "localite": "Démoret"
        },
        {
            "code": "1415",
            "localite": "Molondin"
        },
        {
            "code": "1416",
            "localite": "Pailly"
        },
        {
            "code": "1417",
            "localite": "Epautheyres"
        },
        {
            "code": "1417",
            "localite": "Essertines-sur-Yverdon"
        },
        {
            "code": "1418",
            "localite": "Vuarrens"
        },
        {
            "code": "1420",
            "localite": "Fiez"
        },
        {
            "code": "1421",
            "localite": "Fontaines-sur-Grandson"
        },
        {
            "code": "1421",
            "localite": "Grandevent"
        },
        {
            "code": "1422",
            "localite": "Grandson"
        },
        {
            "code": "1423",
            "localite": "Fontanezier"
        },
        {
            "code": "1423",
            "localite": "Romairon"
        },
        {
            "code": "1423",
            "localite": "Vaugondry"
        },
        {
            "code": "1423",
            "localite": "Villars-Burquin"
        },
        {
            "code": "1424",
            "localite": "Champagne"
        },
        {
            "code": "1425",
            "localite": "Onnens VD"
        },
        {
            "code": "1426",
            "localite": "Concise"
        },
        {
            "code": "1426",
            "localite": "Corcelles-près-Concise"
        },
        {
            "code": "1427",
            "localite": "Bonvillars"
        },
        {
            "code": "1428",
            "localite": "Mutrux"
        },
        {
            "code": "1428",
            "localite": "Provence"
        },
        {
            "code": "1429",
            "localite": "Giez"
        },
        {
            "code": "1430",
            "localite": "Orges"
        },
        {
            "code": "1431",
            "localite": "Novalles"
        },
        {
            "code": "1431",
            "localite": "Vugelles-La Mothe"
        },
        {
            "code": "1432",
            "localite": "Belmont-sur-Yverdon"
        },
        {
            "code": "1432",
            "localite": "Gressy"
        },
        {
            "code": "1433",
            "localite": "Suchy"
        },
        {
            "code": "1434",
            "localite": "Ependes VD"
        },
        {
            "code": "1435",
            "localite": "Essert-Pittet"
        },
        {
            "code": "1436",
            "localite": "Chamblon"
        },
        {
            "code": "1436",
            "localite": "Treycovagnes"
        },
        {
            "code": "1437",
            "localite": "Suscévaz"
        },
        {
            "code": "1438",
            "localite": "Mathod"
        },
        {
            "code": "1439",
            "localite": "Rances"
        },
        {
            "code": "1441",
            "localite": "Valeyres-sous-Montagny"
        },
        {
            "code": "1442",
            "localite": "Montagny-près-Yverdon"
        },
        {
            "code": "1443",
            "localite": "Champvent"
        },
        {
            "code": "1443",
            "localite": "Essert-sous-Champvent"
        },
        {
            "code": "1443",
            "localite": "Villars-sous-Champvent"
        },
        {
            "code": "1445",
            "localite": "Vuiteboeuf"
        },
        {
            "code": "1446",
            "localite": "Baulmes"
        },
        {
            "code": "1450",
            "localite": "La Sagne (Ste-Croix)"
        },
        {
            "code": "1450",
            "localite": "Le Château-de-Ste-Croix"
        },
        {
            "code": "1450",
            "localite": "Ste-Croix"
        },
        {
            "code": "1452",
            "localite": "Les Rasses"
        },
        {
            "code": "1453",
            "localite": "Bullet"
        },
        {
            "code": "1453",
            "localite": "Mauborget"
        },
        {
            "code": "1454",
            "localite": "L'Auberson"
        },
        {
            "code": "1454",
            "localite": "La Vraconnaz"
        },
        {
            "code": "1462",
            "localite": "Yvonand"
        },
        {
            "code": "1463",
            "localite": "Rovray"
        },
        {
            "code": "1464",
            "localite": "Chavannes-le-Chêne"
        },
        {
            "code": "1464",
            "localite": "Chêne-Pâquier"
        },
        {
            "code": "1468",
            "localite": "Cheyres"
        },
        {
            "code": "1470",
            "localite": "Bollion"
        },
        {
            "code": "1470",
            "localite": "Estavayer-le-Lac"
        },
        {
            "code": "1470",
            "localite": "Lully FR"
        },
        {
            "code": "1470",
            "localite": "Seiry"
        },
        {
            "code": "1473",
            "localite": "Châtillon FR"
        },
        {
            "code": "1473",
            "localite": "Font"
        },
        {
            "code": "1474",
            "localite": "Châbles FR"
        },
        {
            "code": "1475",
            "localite": "Autavaux"
        },
        {
            "code": "1475",
            "localite": "Forel FR"
        },
        {
            "code": "1475",
            "localite": "Montbrelloz"
        },
        {
            "code": "1482",
            "localite": "Cugy FR"
        },
        {
            "code": "1483",
            "localite": "Frasses"
        },
        {
            "code": "1483",
            "localite": "Montet (Broye)"
        },
        {
            "code": "1483",
            "localite": "Vesin"
        },
        {
            "code": "1484",
            "localite": "Aumont"
        },
        {
            "code": "1484",
            "localite": "Granges-de-Vesin"
        },
        {
            "code": "1485",
            "localite": "Nuvilly"
        },
        {
            "code": "1486",
            "localite": "Vuissens"
        },
        {
            "code": "1489",
            "localite": "Murist"
        },
        {
            "code": "1509",
            "localite": "Vucherens"
        },
        {
            "code": "1510",
            "localite": "Moudon"
        },
        {
            "code": "1510",
            "localite": "Syens"
        },
        {
            "code": "1512",
            "localite": "Chavannes-sur-Moudon"
        },
        {
            "code": "1513",
            "localite": "Hermenches"
        },
        {
            "code": "1513",
            "localite": "Rossenges"
        },
        {
            "code": "1514",
            "localite": "Bussy-sur-Moudon"
        },
        {
            "code": "1515",
            "localite": "Neyruz-sur-Moudon"
        },
        {
            "code": "1515",
            "localite": "Villars-le-Comte"
        },
        {
            "code": "1521",
            "localite": "Curtilles"
        },
        {
            "code": "1522",
            "localite": "Lucens"
        },
        {
            "code": "1522",
            "localite": "Oulens-sur-Lucens"
        },
        {
            "code": "1523",
            "localite": "Granges-près-Marnand"
        },
        {
            "code": "1524",
            "localite": "Marnand"
        },
        {
            "code": "1525",
            "localite": "Henniez"
        },
        {
            "code": "1525",
            "localite": "Seigneux"
        },
        {
            "code": "1526",
            "localite": "Cremin"
        },
        {
            "code": "1526",
            "localite": "Forel-sur-Lucens"
        },
        {
            "code": "1527",
            "localite": "Villeneuve FR"
        },
        {
            "code": "1528",
            "localite": "Praratoud"
        },
        {
            "code": "1528",
            "localite": "Surpierre"
        },
        {
            "code": "1529",
            "localite": "Cheiry"
        },
        {
            "code": "1530",
            "localite": "Payerne"
        },
        {
            "code": "1532",
            "localite": "Fétigny"
        },
        {
            "code": "1533",
            "localite": "Ménières"
        },
        {
            "code": "1534",
            "localite": "Chapelle (Broye)"
        },
        {
            "code": "1534",
            "localite": "Sassel"
        },
        {
            "code": "1535",
            "localite": "Combremont-le-Grand"
        },
        {
            "code": "1536",
            "localite": "Combremont-le-Petit"
        },
        {
            "code": "1537",
            "localite": "Champtauroz"
        },
        {
            "code": "1538",
            "localite": "Treytorrens (Payerne)"
        },
        {
            "code": "1541",
            "localite": "Bussy FR"
        },
        {
            "code": "1541",
            "localite": "Morens FR"
        },
        {
            "code": "1541",
            "localite": "Sévaz"
        },
        {
            "code": "1542",
            "localite": "Rueyres-les-Prés"
        },
        {
            "code": "1543",
            "localite": "Grandcour"
        },
        {
            "code": "1544",
            "localite": "Gletterens"
        },
        {
            "code": "1545",
            "localite": "Chevroux"
        },
        {
            "code": "1551",
            "localite": "Vers-chez-Perrin"
        },
        {
            "code": "1552",
            "localite": "Trey"
        },
        {
            "code": "1553",
            "localite": "Châtonnaye"
        },
        {
            "code": "1554",
            "localite": "Rossens VD"
        },
        {
            "code": "1554",
            "localite": "Sédeilles"
        },
        {
            "code": "1555",
            "localite": "Villarzel"
        },
        {
            "code": "1562",
            "localite": "Corcelles-près-Payerne"
        },
        {
            "code": "1563",
            "localite": "Dompierre FR"
        },
        {
            "code": "1564",
            "localite": "Domdidier"
        },
        {
            "code": "1565",
            "localite": "Missy"
        },
        {
            "code": "1565",
            "localite": "Vallon"
        },
        {
            "code": "1566",
            "localite": "Les Friques"
        },
        {
            "code": "1566",
            "localite": "St-Aubin FR"
        },
        {
            "code": "1567",
            "localite": "Delley"
        },
        {
            "code": "1568",
            "localite": "Portalban"
        },
        {
            "code": "1580",
            "localite": "Avenches"
        },
        {
            "code": "1580",
            "localite": "Donatyre"
        },
        {
            "code": "1580",
            "localite": "Oleyres"
        },
        {
            "code": "1583",
            "localite": "Villarepos"
        },
        {
            "code": "1584",
            "localite": "Villars-le-Grand"
        },
        {
            "code": "1585",
            "localite": "Bellerive VD"
        },
        {
            "code": "1585",
            "localite": "Cotterd"
        },
        {
            "code": "1585",
            "localite": "Salavaux"
        },
        {
            "code": "1586",
            "localite": "Vallamand"
        },
        {
            "code": "1587",
            "localite": "Constantine"
        },
        {
            "code": "1587",
            "localite": "Montmagny"
        },
        {
            "code": "1588",
            "localite": "Cudrefin"
        },
        {
            "code": "1589",
            "localite": "Chabrey"
        },
        {
            "code": "1595",
            "localite": "Clavaleyres"
        },
        {
            "code": "1595",
            "localite": "Faoug"
        },
        {
            "code": "1607",
            "localite": "Les Tavernes"
        },
        {
            "code": "1607",
            "localite": "Les Thioleyres"
        },
        {
            "code": "1607",
            "localite": "Palézieux"
        },
        {
            "code": "1607",
            "localite": "Palézieux-Village"
        },
        {
            "code": "1608",
            "localite": "Bussigny-sur-Oron"
        },
        {
            "code": "1608",
            "localite": "Chapelle (Glâne)"
        },
        {
            "code": "1608",
            "localite": "Chesalles-sur-Oron"
        },
        {
            "code": "1608",
            "localite": "Oron-le-Châtel"
        },
        {
            "code": "1609",
            "localite": "Besencens"
        },
        {
            "code": "1609",
            "localite": "Fiaugères"
        },
        {
            "code": "1609",
            "localite": "St-Martin FR"
        },
        {
            "code": "1610",
            "localite": "Châtillens"
        },
        {
            "code": "1610",
            "localite": "Oron-la-Ville"
        },
        {
            "code": "1610",
            "localite": "Vuibroye"
        },
        {
            "code": "1611",
            "localite": "Le Crêt-près-Semsales"
        },
        {
            "code": "1612",
            "localite": "Ecoteaux"
        },
        {
            "code": "1613",
            "localite": "Maracon"
        },
        {
            "code": "1614",
            "localite": "Granges (Veveyse)"
        },
        {
            "code": "1615",
            "localite": "Bossonnens"
        },
        {
            "code": "1616",
            "localite": "Attalens"
        },
        {
            "code": "1617",
            "localite": "Remaufens"
        },
        {
            "code": "1617",
            "localite": "Tatroz"
        },
        {
            "code": "1618",
            "localite": "Châtel-St-Denis"
        },
        {
            "code": "1619",
            "localite": "Les Paccots"
        },
        {
            "code": "1623",
            "localite": "Semsales"
        },
        {
            "code": "1624",
            "localite": "Grattavache"
        },
        {
            "code": "1624",
            "localite": "La Verrerie"
        },
        {
            "code": "1624",
            "localite": "Progens"
        },
        {
            "code": "1625",
            "localite": "Maules"
        },
        {
            "code": "1625",
            "localite": "Sâles (Gruyère)"
        },
        {
            "code": "1626",
            "localite": "Romanens"
        },
        {
            "code": "1626",
            "localite": "Rueyres-Treyfayes"
        },
        {
            "code": "1627",
            "localite": "Vaulruz"
        },
        {
            "code": "1628",
            "localite": "Vuadens"
        },
        {
            "code": "1630",
            "localite": "Bulle"
        },
        {
            "code": "1632",
            "localite": "Riaz"
        },
        {
            "code": "1633",
            "localite": "Marsens"
        },
        {
            "code": "1633",
            "localite": "Vuippens"
        },
        {
            "code": "1634",
            "localite": "La Roche FR"
        },
        {
            "code": "1635",
            "localite": "La Tour-de-Trême"
        },
        {
            "code": "1636",
            "localite": "Broc"
        },
        {
            "code": "1637",
            "localite": "Charmey (Gruyère)"
        },
        {
            "code": "1638",
            "localite": "Morlon"
        },
        {
            "code": "1642",
            "localite": "Sorens"
        },
        {
            "code": "1643",
            "localite": "Gumefens"
        },
        {
            "code": "1644",
            "localite": "Avry-devant-Pont"
        },
        {
            "code": "1645",
            "localite": "Le Bry"
        },
        {
            "code": "1646",
            "localite": "Echarlens"
        },
        {
            "code": "1647",
            "localite": "Corbières"
        },
        {
            "code": "1648",
            "localite": "Hauteville"
        },
        {
            "code": "1649",
            "localite": "Pont-la-Ville"
        },
        {
            "code": "1651",
            "localite": "Villarvolard"
        },
        {
            "code": "1652",
            "localite": "Botterens"
        },
        {
            "code": "1652",
            "localite": "Villarbeney"
        },
        {
            "code": "1653",
            "localite": "Châtel-sur-Montsalvens"
        },
        {
            "code": "1653",
            "localite": "Crésuz"
        },
        {
            "code": "1654",
            "localite": "Cerniat FR"
        },
        {
            "code": "1656",
            "localite": "Im Fang"
        },
        {
            "code": "1656",
            "localite": "Jaun"
        },
        {
            "code": "1657",
            "localite": "Abländschen"
        },
        {
            "code": "1658",
            "localite": "La Tine"
        },
        {
            "code": "1658",
            "localite": "Rossinière"
        },
        {
            "code": "1659",
            "localite": "Flendruz"
        },
        {
            "code": "1659",
            "localite": "Rougemont"
        },
        {
            "code": "1660",
            "localite": "Château-d'Oex"
        },
        {
            "code": "1660",
            "localite": "L'Etivaz"
        },
        {
            "code": "1660",
            "localite": "La Lécherette"
        },
        {
            "code": "1660",
            "localite": "Les Moulins"
        },
        {
            "code": "1661",
            "localite": "Le Pâquier-Montbarry"
        },
        {
            "code": "1663",
            "localite": "Epagny"
        },
        {
            "code": "1663",
            "localite": "Gruyères"
        },
        {
            "code": "1663",
            "localite": "Moléson-sur-Gruyères"
        },
        {
            "code": "1663",
            "localite": "Pringy"
        },
        {
            "code": "1665",
            "localite": "Estavannens"
        },
        {
            "code": "1666",
            "localite": "Grandvillard"
        },
        {
            "code": "1666",
            "localite": "Villars-sous-Mont"
        },
        {
            "code": "1667",
            "localite": "Enney"
        },
        {
            "code": "1669",
            "localite": "Albeuve"
        },
        {
            "code": "1669",
            "localite": "Les Sciernes-d'Albeuve"
        },
        {
            "code": "1669",
            "localite": "Lessoc"
        },
        {
            "code": "1669",
            "localite": "Montbovon"
        },
        {
            "code": "1669",
            "localite": "Neirivue"
        },
        {
            "code": "1670",
            "localite": "Bionnens"
        },
        {
            "code": "1670",
            "localite": "Esmonts"
        },
        {
            "code": "1670",
            "localite": "Ursy"
        },
        {
            "code": "1673",
            "localite": "Auboranges"
        },
        {
            "code": "1673",
            "localite": "Ecublens FR"
        },
        {
            "code": "1673",
            "localite": "Gillarens"
        },
        {
            "code": "1673",
            "localite": "Promasens"
        },
        {
            "code": "1673",
            "localite": "Rue"
        },
        {
            "code": "1674",
            "localite": "Montet (Glâne)"
        },
        {
            "code": "1674",
            "localite": "Morlens"
        },
        {
            "code": "1674",
            "localite": "Vuarmarens"
        },
        {
            "code": "1675",
            "localite": "Blessens"
        },
        {
            "code": "1675",
            "localite": "Mossel"
        },
        {
            "code": "1675",
            "localite": "Vauderens"
        },
        {
            "code": "1676",
            "localite": "Chavannes-les-Forts"
        },
        {
            "code": "1677",
            "localite": "Prez-vers-Siviriez"
        },
        {
            "code": "1678",
            "localite": "Siviriez"
        },
        {
            "code": "1679",
            "localite": "Villaraboud"
        },
        {
            "code": "1680",
            "localite": "Berlens"
        },
        {
            "code": "1680",
            "localite": "Romont FR"
        },
        {
            "code": "1681",
            "localite": "Billens"
        },
        {
            "code": "1681",
            "localite": "Hennens"
        },
        {
            "code": "1682",
            "localite": "Cerniaz VD"
        },
        {
            "code": "1682",
            "localite": "Dompierre VD"
        },
        {
            "code": "1682",
            "localite": "Lovatens"
        },
        {
            "code": "1682",
            "localite": "Prévonloup"
        },
        {
            "code": "1682",
            "localite": "Villars-Bramard"
        },
        {
            "code": "1683",
            "localite": "Brenles"
        },
        {
            "code": "1683",
            "localite": "Chesalles-sur-Moudon"
        },
        {
            "code": "1683",
            "localite": "Sarzens"
        },
        {
            "code": "1684",
            "localite": "Mézières FR"
        },
        {
            "code": "1685",
            "localite": "Villariaz"
        },
        {
            "code": "1686",
            "localite": "Grangettes-près-Romont"
        },
        {
            "code": "1686",
            "localite": "La Neirigue"
        },
        {
            "code": "1687",
            "localite": "Estévenens"
        },
        {
            "code": "1687",
            "localite": "La Magne"
        },
        {
            "code": "1687",
            "localite": "Vuisternens-devant-Romont"
        },
        {
            "code": "1688",
            "localite": "Lieffrens"
        },
        {
            "code": "1688",
            "localite": "Sommentier"
        },
        {
            "code": "1689",
            "localite": "Le Châtelard-près-Romont"
        },
        {
            "code": "1690",
            "localite": "Lussy FR"
        },
        {
            "code": "1690",
            "localite": "Villaz-St-Pierre"
        },
        {
            "code": "1691",
            "localite": "Villarimboud"
        },
        {
            "code": "1692",
            "localite": "Massonnens"
        },
        {
            "code": "1694",
            "localite": "Chavannes-sous-Orsonnens"
        },
        {
            "code": "1694",
            "localite": "Orsonnens"
        },
        {
            "code": "1694",
            "localite": "Villargiroud"
        },
        {
            "code": "1694",
            "localite": "Villarsiviriaux"
        },
        {
            "code": "1695",
            "localite": "Estavayer-le-Gibloux"
        },
        {
            "code": "1695",
            "localite": "Rueyres-St-Laurent"
        },
        {
            "code": "1695",
            "localite": "Villarlod"
        },
        {
            "code": "1695",
            "localite": "Villarsel-le-Gibloux"
        },
        {
            "code": "1696",
            "localite": "Vuisternens-en-Ogoz"
        },
        {
            "code": "1697",
            "localite": "La Joux FR"
        },
        {
            "code": "1697",
            "localite": "Les Ecasseys"
        },
        {
            "code": "1699",
            "localite": "Bouloz"
        },
        {
            "code": "1699",
            "localite": "Pont (Veveyse)"
        },
        {
            "code": "1699",
            "localite": "Porsel"
        },
        {
            "code": "1700",
            "localite": "Fribourg"
        },
        {
            "code": "1712",
            "localite": "Tafers"
        },
        {
            "code": "1713",
            "localite": "St. Antoni"
        },
        {
            "code": "1714",
            "localite": "Heitenried"
        },
        {
            "code": "1715",
            "localite": "Alterswil FR"
        },
        {
            "code": "1716",
            "localite": "Oberschrot"
        },
        {
            "code": "1716",
            "localite": "Plaffeien"
        },
        {
            "code": "1716",
            "localite": "Schwarzsee"
        },
        {
            "code": "1717",
            "localite": "St. Ursen"
        },
        {
            "code": "1718",
            "localite": "Rechthalten"
        },
        {
            "code": "1719",
            "localite": "Brünisried"
        },
        {
            "code": "1719",
            "localite": "Zumholz"
        },
        {
            "code": "1720",
            "localite": "Chésopelloz"
        },
        {
            "code": "1720",
            "localite": "Corminboeuf"
        },
        {
            "code": "1721",
            "localite": "Cormérod"
        },
        {
            "code": "1721",
            "localite": "Cournillens"
        },
        {
            "code": "1721",
            "localite": "Courtion"
        },
        {
            "code": "1721",
            "localite": "Misery"
        },
        {
            "code": "1722",
            "localite": "Bourguillon"
        },
        {
            "code": "1723",
            "localite": "Marly"
        },
        {
            "code": "1723",
            "localite": "Pierrafortscha"
        },
        {
            "code": "1723",
            "localite": "Villarsel-sur-Marly"
        },
        {
            "code": "1724",
            "localite": "Bonnefontaine"
        },
        {
            "code": "1724",
            "localite": "Essert FR"
        },
        {
            "code": "1724",
            "localite": "Ferpicloz"
        },
        {
            "code": "1724",
            "localite": "Le Mouret"
        },
        {
            "code": "1724",
            "localite": "Montévraz"
        },
        {
            "code": "1724",
            "localite": "Oberried FR"
        },
        {
            "code": "1724",
            "localite": "Senèdes"
        },
        {
            "code": "1724",
            "localite": "Zénauva"
        },
        {
            "code": "1725",
            "localite": "Posieux"
        },
        {
            "code": "1726",
            "localite": "Farvagny-le-Grand"
        },
        {
            "code": "1726",
            "localite": "Farvagny-le-Petit"
        },
        {
            "code": "1726",
            "localite": "Grenilles"
        },
        {
            "code": "1726",
            "localite": "Posat"
        },
        {
            "code": "1727",
            "localite": "Corpataux"
        },
        {
            "code": "1727",
            "localite": "Magnedens"
        },
        {
            "code": "1728",
            "localite": "Rossens FR"
        },
        {
            "code": "1730",
            "localite": "Ecuvillens"
        },
        {
            "code": "1731",
            "localite": "Ependes FR"
        },
        {
            "code": "1732",
            "localite": "Arconciel"
        },
        {
            "code": "1733",
            "localite": "Treyvaux"
        },
        {
            "code": "1734",
            "localite": "Tentlingen"
        },
        {
            "code": "1735",
            "localite": "Giffers"
        },
        {
            "code": "1736",
            "localite": "St. Silvester"
        },
        {
            "code": "1737",
            "localite": "Plasselb"
        },
        {
            "code": "1738",
            "localite": "Sangernboden"
        },
        {
            "code": "1740",
            "localite": "Neyruz FR"
        },
        {
            "code": "1741",
            "localite": "Cottens FR"
        },
        {
            "code": "1742",
            "localite": "Autigny"
        },
        {
            "code": "1744",
            "localite": "Chénens"
        },
        {
            "code": "1745",
            "localite": "Lentigny"
        },
        {
            "code": "1746",
            "localite": "Prez-vers-Noréaz"
        },
        {
            "code": "1747",
            "localite": "Corserey"
        },
        {
            "code": "1748",
            "localite": "Torny-le-Grand"
        },
        {
            "code": "1749",
            "localite": "Middes"
        },
        {
            "code": "1752",
            "localite": "Villars-sur-Glâne"
        },
        {
            "code": "1753",
            "localite": "Matran"
        },
        {
            "code": "1754",
            "localite": "Avry-sur-Matran"
        },
        {
            "code": "1754",
            "localite": "Corjolens"
        },
        {
            "code": "1756",
            "localite": "Lovens"
        },
        {
            "code": "1756",
            "localite": "Onnens FR"
        },
        {
            "code": "1757",
            "localite": "Noréaz"
        },
        {
            "code": "1762",
            "localite": "Givisiez"
        },
        {
            "code": "1763",
            "localite": "Granges-Paccot"
        },
        {
            "code": "1772",
            "localite": "Grolley"
        },
        {
            "code": "1772",
            "localite": "Nierlet-les-Bois"
        },
        {
            "code": "1772",
            "localite": "Ponthaux"
        },
        {
            "code": "1773",
            "localite": "Chandon"
        },
        {
            "code": "1773",
            "localite": "Léchelles"
        },
        {
            "code": "1773",
            "localite": "Russy"
        },
        {
            "code": "1774",
            "localite": "Cousset"
        },
        {
            "code": "1774",
            "localite": "Montagny-les-Monts"
        },
        {
            "code": "1775",
            "localite": "Grandsivaz"
        },
        {
            "code": "1775",
            "localite": "Mannens"
        },
        {
            "code": "1776",
            "localite": "Montagny-la-Ville"
        },
        {
            "code": "1782",
            "localite": "Autafond"
        },
        {
            "code": "1782",
            "localite": "Belfaux"
        },
        {
            "code": "1782",
            "localite": "Cormagens"
        },
        {
            "code": "1782",
            "localite": "Formangueires"
        },
        {
            "code": "1782",
            "localite": "La Corbaz"
        },
        {
            "code": "1782",
            "localite": "Lossy"
        },
        {
            "code": "1783",
            "localite": "Barberêche"
        },
        {
            "code": "1783",
            "localite": "Pensier"
        },
        {
            "code": "1784",
            "localite": "Courtepin"
        },
        {
            "code": "1784",
            "localite": "Wallenried"
        },
        {
            "code": "1785",
            "localite": "Cressier FR"
        },
        {
            "code": "1786",
            "localite": "Sugiez"
        },
        {
            "code": "1787",
            "localite": "Mur (Vully) FR"
        },
        {
            "code": "1787",
            "localite": "Mur (Vully) VD"
        },
        {
            "code": "1787",
            "localite": "Môtier (Vully)"
        },
        {
            "code": "1788",
            "localite": "Praz (Vully)"
        },
        {
            "code": "1789",
            "localite": "Lugnorre"
        },
        {
            "code": "1791",
            "localite": "Courtaman"
        },
        {
            "code": "1792",
            "localite": "Cordast"
        },
        {
            "code": "1792",
            "localite": "Guschelmuth"
        },
        {
            "code": "1793",
            "localite": "Jeuss"
        },
        {
            "code": "1794",
            "localite": "Salvenach"
        },
        {
            "code": "1795",
            "localite": "Courlevon"
        },
        {
            "code": "1796",
            "localite": "Courgevaux"
        },
        {
            "code": "1797",
            "localite": "Münchenwiler"
        },
        {
            "code": "1800",
            "localite": "Vevey"
        },
        {
            "code": "1801",
            "localite": "Le Mont-Pèlerin"
        },
        {
            "code": "1802",
            "localite": "Corseaux"
        },
        {
            "code": "1803",
            "localite": "Chardonne"
        },
        {
            "code": "1804",
            "localite": "Corsier-sur-Vevey"
        },
        {
            "code": "1805",
            "localite": "Jongny"
        },
        {
            "code": "1806",
            "localite": "St-Légier-La Chiésaz"
        },
        {
            "code": "1807",
            "localite": "Blonay"
        },
        {
            "code": "1808",
            "localite": "Les Monts-de-Corsier"
        },
        {
            "code": "1809",
            "localite": "Fenil-sur-Corsier"
        },
        {
            "code": "1814",
            "localite": "La Tour-de-Peilz"
        },
        {
            "code": "1815",
            "localite": "Clarens"
        },
        {
            "code": "1816",
            "localite": "Chailly-Montreux"
        },
        {
            "code": "1817",
            "localite": "Brent"
        },
        {
            "code": "1820",
            "localite": "Montreux"
        },
        {
            "code": "1820",
            "localite": "Territet"
        },
        {
            "code": "1820",
            "localite": "Veytaux"
        },
        {
            "code": "1822",
            "localite": "Chernex"
        },
        {
            "code": "1823",
            "localite": "Glion"
        },
        {
            "code": "1824",
            "localite": "Caux"
        },
        {
            "code": "1832",
            "localite": "Chamby"
        },
        {
            "code": "1832",
            "localite": "Villard-sur-Chamby"
        },
        {
            "code": "1833",
            "localite": "Les Avants"
        },
        {
            "code": "1844",
            "localite": "Villeneuve VD"
        },
        {
            "code": "1845",
            "localite": "Noville"
        },
        {
            "code": "1846",
            "localite": "Chessel"
        },
        {
            "code": "1847",
            "localite": "Rennaz"
        },
        {
            "code": "1852",
            "localite": "Roche VD"
        },
        {
            "code": "1853",
            "localite": "Yvorne"
        },
        {
            "code": "1854",
            "localite": "Leysin"
        },
        {
            "code": "1856",
            "localite": "Corbeyrier"
        },
        {
            "code": "1860",
            "localite": "Aigle"
        },
        {
            "code": "1862",
            "localite": "La Comballaz"
        },
        {
            "code": "1862",
            "localite": "Les Mosses"
        },
        {
            "code": "1863",
            "localite": "Le Sépey"
        },
        {
            "code": "1864",
            "localite": "Vers-l'Eglise"
        },
        {
            "code": "1865",
            "localite": "Les Diablerets"
        },
        {
            "code": "1866",
            "localite": "La Forclaz VD"
        },
        {
            "code": "1867",
            "localite": "Ollon VD"
        },
        {
            "code": "1867",
            "localite": "Panex"
        },
        {
            "code": "1867",
            "localite": "St-Triphon"
        },
        {
            "code": "1868",
            "localite": "Collombey"
        },
        {
            "code": "1869",
            "localite": "Massongex"
        },
        {
            "code": "1870",
            "localite": "Monthey"
        },
        {
            "code": "1871",
            "localite": "Choëx"
        },
        {
            "code": "1871",
            "localite": "Les Giettes"
        },
        {
            "code": "1872",
            "localite": "Troistorrents"
        },
        {
            "code": "1873",
            "localite": "Champoussin"
        },
        {
            "code": "1873",
            "localite": "Les Crosets"
        },
        {
            "code": "1873",
            "localite": "Val-d'Illiez"
        },
        {
            "code": "1874",
            "localite": "Champéry"
        },
        {
            "code": "1875",
            "localite": "Morgins"
        },
        {
            "code": "1880",
            "localite": "Bex"
        },
        {
            "code": "1880",
            "localite": "Fenalet-sur-Bex"
        },
        {
            "code": "1880",
            "localite": "Frenières-sur-Bex"
        },
        {
            "code": "1880",
            "localite": "Les Plans-sur-Bex"
        },
        {
            "code": "1880",
            "localite": "Les Posses-sur-Bex"
        },
        {
            "code": "1882",
            "localite": "Gryon"
        },
        {
            "code": "1884",
            "localite": "Arveyes"
        },
        {
            "code": "1884",
            "localite": "Huémoz"
        },
        {
            "code": "1884",
            "localite": "Villars-sur-Ollon"
        },
        {
            "code": "1885",
            "localite": "Chesières"
        },
        {
            "code": "1890",
            "localite": "Mex VS"
        },
        {
            "code": "1890",
            "localite": "St-Maurice"
        },
        {
            "code": "1891",
            "localite": "Vérossaz"
        },
        {
            "code": "1892",
            "localite": "Lavey-Village"
        },
        {
            "code": "1892",
            "localite": "Lavey-les-Bains"
        },
        {
            "code": "1892",
            "localite": "Morcles"
        },
        {
            "code": "1893",
            "localite": "Muraz (Collombey)"
        },
        {
            "code": "1895",
            "localite": "Vionnaz"
        },
        {
            "code": "1896",
            "localite": "Miex"
        },
        {
            "code": "1896",
            "localite": "Vouvry"
        },
        {
            "code": "1897",
            "localite": "Bouveret"
        },
        {
            "code": "1897",
            "localite": "Les Evouettes"
        },
        {
            "code": "1898",
            "localite": "St-Gingolph"
        },
        {
            "code": "1899",
            "localite": "Torgon"
        },
        {
            "code": "1902",
            "localite": "Evionnaz"
        },
        {
            "code": "1903",
            "localite": "Collonges"
        },
        {
            "code": "1904",
            "localite": "Vernayaz"
        },
        {
            "code": "1905",
            "localite": "Dorénaz"
        },
        {
            "code": "1906",
            "localite": "Charrat"
        },
        {
            "code": "1907",
            "localite": "Saxon"
        },
        {
            "code": "1908",
            "localite": "Riddes"
        },
        {
            "code": "1911",
            "localite": "Ovronnaz"
        },
        {
            "code": "1912",
            "localite": "Dugny (Leytron)"
        },
        {
            "code": "1912",
            "localite": "Leytron"
        },
        {
            "code": "1912",
            "localite": "Montagnon (Leytron)"
        },
        {
            "code": "1912",
            "localite": "Produit (Leytron)"
        },
        {
            "code": "1913",
            "localite": "Saillon"
        },
        {
            "code": "1914",
            "localite": "Auddes-sur-Riddes"
        },
        {
            "code": "1914",
            "localite": "Isérables"
        },
        {
            "code": "1918",
            "localite": "La Tzoumaz"
        },
        {
            "code": "1920",
            "localite": "Martigny"
        },
        {
            "code": "1921",
            "localite": "Martigny-Croix"
        },
        {
            "code": "1922",
            "localite": "Les Granges (Salvan)"
        },
        {
            "code": "1922",
            "localite": "Salvan"
        },
        {
            "code": "1923",
            "localite": "Le Trétien"
        },
        {
            "code": "1923",
            "localite": "Les Marécottes"
        },
        {
            "code": "1925",
            "localite": "Finhaut"
        },
        {
            "code": "1925",
            "localite": "Le Châtelard VS"
        },
        {
            "code": "1926",
            "localite": "Fully"
        },
        {
            "code": "1927",
            "localite": "Chemin"
        },
        {
            "code": "1928",
            "localite": "Ravoire"
        },
        {
            "code": "1929",
            "localite": "Trient"
        },
        {
            "code": "1932",
            "localite": "Bovernier"
        },
        {
            "code": "1932",
            "localite": "Les Valettes (Bovernier)"
        },
        {
            "code": "1933",
            "localite": "Chamoille (Sembrancher)"
        },
        {
            "code": "1933",
            "localite": "La Garde (Sembrancher)"
        },
        {
            "code": "1933",
            "localite": "Sembrancher"
        },
        {
            "code": "1933",
            "localite": "Vens (Sembrancher)"
        },
        {
            "code": "1934",
            "localite": "Bruson"
        },
        {
            "code": "1934",
            "localite": "Le Châble VS"
        },
        {
            "code": "1936",
            "localite": "Verbier"
        },
        {
            "code": "1937",
            "localite": "Orsières"
        },
        {
            "code": "1938",
            "localite": "Champex-Lac"
        },
        {
            "code": "1941",
            "localite": "Cries (Vollèges)"
        },
        {
            "code": "1941",
            "localite": "Vollèges"
        },
        {
            "code": "1942",
            "localite": "Levron"
        },
        {
            "code": "1943",
            "localite": "Praz-de-Fort"
        },
        {
            "code": "1944",
            "localite": "La Fouly VS"
        },
        {
            "code": "1945",
            "localite": "Chandonne (Liddes)"
        },
        {
            "code": "1945",
            "localite": "Chez Petit (Liddes)"
        },
        {
            "code": "1945",
            "localite": "Dranse (Liddes)"
        },
        {
            "code": "1945",
            "localite": "Fontaine Dessous (Liddes)"
        },
        {
            "code": "1945",
            "localite": "Fontaine Dessus (Liddes)"
        },
        {
            "code": "1945",
            "localite": "Fornex (Liddes)"
        },
        {
            "code": "1945",
            "localite": "Les Moulins VS (Liddes)"
        },
        {
            "code": "1945",
            "localite": "Liddes"
        },
        {
            "code": "1945",
            "localite": "Palasuit (Liddes)"
        },
        {
            "code": "1945",
            "localite": "Petit Vichères (Liddes)"
        },
        {
            "code": "1945",
            "localite": "Rive Haute (Liddes)"
        },
        {
            "code": "1945",
            "localite": "Vichères (Liddes)"
        },
        {
            "code": "1946",
            "localite": "Bourg-St-Pierre"
        },
        {
            "code": "1947",
            "localite": "Champsec"
        },
        {
            "code": "1947",
            "localite": "Versegères"
        },
        {
            "code": "1948",
            "localite": "Fionnay"
        },
        {
            "code": "1948",
            "localite": "Lourtier"
        },
        {
            "code": "1948",
            "localite": "Sarreyer"
        },
        {
            "code": "1950",
            "localite": "Sion"
        },
        {
            "code": "1955",
            "localite": "Chamoson"
        },
        {
            "code": "1955",
            "localite": "Grugnay (Chamoson)"
        },
        {
            "code": "1955",
            "localite": "Les Vérines (Chamoson)"
        },
        {
            "code": "1955",
            "localite": "Mayens-de-Chamoson"
        },
        {
            "code": "1955",
            "localite": "Némiaz (Chamoson)"
        },
        {
            "code": "1955",
            "localite": "St-Pierre-de-Clages"
        },
        {
            "code": "1957",
            "localite": "Ardon"
        },
        {
            "code": "1958",
            "localite": "St-Léonard"
        },
        {
            "code": "1958",
            "localite": "Uvrier"
        },
        {
            "code": "1961",
            "localite": "Vernamiège"
        },
        {
            "code": "1962",
            "localite": "Pont-de-la-Morge (Sion)"
        },
        {
            "code": "1963",
            "localite": "Vétroz"
        },
        {
            "code": "1964",
            "localite": "Conthey"
        },
        {
            "code": "1965",
            "localite": "Savièse"
        },
        {
            "code": "1966",
            "localite": "Argnou (Ayent)"
        },
        {
            "code": "1966",
            "localite": "Blignou (Ayent)"
        },
        {
            "code": "1966",
            "localite": "Botyre (Ayent)"
        },
        {
            "code": "1966",
            "localite": "Fortunau (Ayent)"
        },
        {
            "code": "1966",
            "localite": "La Place (Ayent)"
        },
        {
            "code": "1966",
            "localite": "Luc (Ayent)"
        },
        {
            "code": "1966",
            "localite": "Saxonne (Ayent)"
        },
        {
            "code": "1966",
            "localite": "Signèse (Ayent)"
        },
        {
            "code": "1966",
            "localite": "St-Romain (Ayent)"
        },
        {
            "code": "1966",
            "localite": "Villa (Ayent)"
        },
        {
            "code": "1967",
            "localite": "Bramois"
        },
        {
            "code": "1968",
            "localite": "Mase"
        },
        {
            "code": "1969",
            "localite": "Eison (St-Martin)"
        },
        {
            "code": "1969",
            "localite": "Liez (St-Martin)"
        },
        {
            "code": "1969",
            "localite": "St-Martin VS"
        },
        {
            "code": "1969",
            "localite": "Suen (St-Martin)"
        },
        {
            "code": "1969",
            "localite": "Trogne (St-Martin)"
        },
        {
            "code": "1971",
            "localite": "Champlan (Grimisuat)"
        },
        {
            "code": "1971",
            "localite": "Grimisuat"
        },
        {
            "code": "1972",
            "localite": "Anzère"
        },
        {
            "code": "1973",
            "localite": "Nax"
        },
        {
            "code": "1974",
            "localite": "Arbaz"
        },
        {
            "code": "1975",
            "localite": "St-Séverin"
        },
        {
            "code": "1976",
            "localite": "Aven"
        },
        {
            "code": "1976",
            "localite": "Daillon"
        },
        {
            "code": "1976",
            "localite": "Erde"
        },
        {
            "code": "1977",
            "localite": "Icogne"
        },
        {
            "code": "1978",
            "localite": "Lens"
        },
        {
            "code": "1981",
            "localite": "Vex"
        },
        {
            "code": "1982",
            "localite": "Euseigne"
        },
        {
            "code": "1983",
            "localite": "Evolène"
        },
        {
            "code": "1983",
            "localite": "Lanna"
        },
        {
            "code": "1984",
            "localite": "La Tour VS"
        },
        {
            "code": "1984",
            "localite": "Les Haudères"
        },
        {
            "code": "1985",
            "localite": "La Forclaz VS"
        },
        {
            "code": "1985",
            "localite": "La Sage"
        },
        {
            "code": "1985",
            "localite": "Villa (Evolène)"
        },
        {
            "code": "1986",
            "localite": "Arolla"
        },
        {
            "code": "1987",
            "localite": "Hérémence"
        },
        {
            "code": "1988",
            "localite": "Les Collons"
        },
        {
            "code": "1988",
            "localite": "Thyon"
        },
        {
            "code": "1991",
            "localite": "Arvillard (Salins)"
        },
        {
            "code": "1991",
            "localite": "Misériez (Salins)"
        },
        {
            "code": "1991",
            "localite": "Pravidondaz (Salins)"
        },
        {
            "code": "1991",
            "localite": "Salins"
        },
        {
            "code": "1991",
            "localite": "Turin (Salins)"
        },
        {
            "code": "1992",
            "localite": "Crête-à-l'Oeil (Les Agettes)"
        },
        {
            "code": "1992",
            "localite": "La Vernaz (Les Agettes)"
        },
        {
            "code": "1992",
            "localite": "Les Agettes"
        },
        {
            "code": "1992",
            "localite": "Les Mayens-de-Sion"
        },
        {
            "code": "1993",
            "localite": "Clèbes (Nendaz)"
        },
        {
            "code": "1993",
            "localite": "Veysonnaz"
        },
        {
            "code": "1994",
            "localite": "Aproz (Nendaz)"
        },
        {
            "code": "1996",
            "localite": "Baar (Nendaz)"
        },
        {
            "code": "1996",
            "localite": "Basse-Nendaz"
        },
        {
            "code": "1996",
            "localite": "Beuson (Nendaz)"
        },
        {
            "code": "1996",
            "localite": "Bieudron (Nendaz)"
        },
        {
            "code": "1996",
            "localite": "Brignon (Nendaz)"
        },
        {
            "code": "1996",
            "localite": "Condémines (Nendaz)"
        },
        {
            "code": "1996",
            "localite": "Fey (Nendaz)"
        },
        {
            "code": "1996",
            "localite": "Saclentse"
        },
        {
            "code": "1997",
            "localite": "Haute-Nendaz"
        },
        {
            "code": "1997",
            "localite": "Siviez (Nendaz)"
        },
        {
            "code": "1997",
            "localite": "Sornard (Nendaz)"
        },
        {
            "code": "2000",
            "localite": "Neuchâtel"
        },
        {
            "code": "2012",
            "localite": "Auvernier"
        },
        {
            "code": "2013",
            "localite": "Colombier NE"
        },
        {
            "code": "2014",
            "localite": "Bôle"
        },
        {
            "code": "2015",
            "localite": "Areuse"
        },
        {
            "code": "2016",
            "localite": "Cortaillod"
        },
        {
            "code": "2017",
            "localite": "Boudry"
        },
        {
            "code": "2019",
            "localite": "Chambrelien"
        },
        {
            "code": "2019",
            "localite": "Rochefort"
        },
        {
            "code": "2022",
            "localite": "Bevaix"
        },
        {
            "code": "2023",
            "localite": "Gorgier"
        },
        {
            "code": "2024",
            "localite": "St-Aubin-Sauges"
        },
        {
            "code": "2025",
            "localite": "Chez-le-Bart"
        },
        {
            "code": "2027",
            "localite": "Fresens"
        },
        {
            "code": "2027",
            "localite": "Montalchez"
        },
        {
            "code": "2028",
            "localite": "Vaumarcus"
        },
        {
            "code": "2034",
            "localite": "Peseux"
        },
        {
            "code": "2035",
            "localite": "Corcelles NE"
        },
        {
            "code": "2036",
            "localite": "Cormondrèche"
        },
        {
            "code": "2037",
            "localite": "Montezillon"
        },
        {
            "code": "2037",
            "localite": "Montmollin"
        },
        {
            "code": "2042",
            "localite": "Valangin"
        },
        {
            "code": "2043",
            "localite": "Boudevilliers"
        },
        {
            "code": "2046",
            "localite": "Fontaines NE"
        },
        {
            "code": "2052",
            "localite": "Fontainemelon"
        },
        {
            "code": "2052",
            "localite": "La Vue-des-Alpes"
        },
        {
            "code": "2053",
            "localite": "Cernier"
        },
        {
            "code": "2054",
            "localite": "Chézard-St-Martin"
        },
        {
            "code": "2054",
            "localite": "Les Vieux-Prés"
        },
        {
            "code": "2056",
            "localite": "Dombresson"
        },
        {
            "code": "2057",
            "localite": "Villiers"
        },
        {
            "code": "2058",
            "localite": "Le Pâquier NE"
        },
        {
            "code": "2063",
            "localite": "Engollon"
        },
        {
            "code": "2063",
            "localite": "Fenin"
        },
        {
            "code": "2063",
            "localite": "Saules"
        },
        {
            "code": "2063",
            "localite": "Vilars NE"
        },
        {
            "code": "2065",
            "localite": "Savagnier"
        },
        {
            "code": "2067",
            "localite": "Chaumont"
        },
        {
            "code": "2068",
            "localite": "Hauterive NE"
        },
        {
            "code": "2072",
            "localite": "St-Blaise"
        },
        {
            "code": "2073",
            "localite": "Enges"
        },
        {
            "code": "2074",
            "localite": "Marin-Epagnier"
        },
        {
            "code": "2075",
            "localite": "Thielle"
        },
        {
            "code": "2075",
            "localite": "Wavre"
        },
        {
            "code": "2087",
            "localite": "Cornaux NE"
        },
        {
            "code": "2088",
            "localite": "Cressier NE"
        },
        {
            "code": "2103",
            "localite": "Noiraigue"
        },
        {
            "code": "2105",
            "localite": "Travers"
        },
        {
            "code": "2108",
            "localite": "Couvet"
        },
        {
            "code": "2112",
            "localite": "Môtiers NE"
        },
        {
            "code": "2113",
            "localite": "Boveresse"
        },
        {
            "code": "2114",
            "localite": "Fleurier"
        },
        {
            "code": "2115",
            "localite": "Buttes"
        },
        {
            "code": "2116",
            "localite": "Mont-de-Buttes"
        },
        {
            "code": "2117",
            "localite": "La Côte-aux-Fées"
        },
        {
            "code": "2123",
            "localite": "St-Sulpice NE"
        },
        {
            "code": "2124",
            "localite": "Les Sagnettes"
        },
        {
            "code": "2126",
            "localite": "Les Verrières"
        },
        {
            "code": "2127",
            "localite": "Les Bayards"
        },
        {
            "code": "2149",
            "localite": "Brot-Dessous"
        },
        {
            "code": "2149",
            "localite": "Champ-du-Moulin"
        },
        {
            "code": "2149",
            "localite": "Fretereules"
        },
        {
            "code": "2206",
            "localite": "Les Geneveys-sur-Coffrane"
        },
        {
            "code": "2207",
            "localite": "Coffrane"
        },
        {
            "code": "2208",
            "localite": "Les Hauts-Geneveys"
        },
        {
            "code": "2300",
            "localite": "La Chaux-de-Fonds"
        },
        {
            "code": "2300",
            "localite": "La Cibourg"
        },
        {
            "code": "2314",
            "localite": "La Sagne NE"
        },
        {
            "code": "2316",
            "localite": "Les Ponts-de-Martel"
        },
        {
            "code": "2316",
            "localite": "Petit-Martel"
        },
        {
            "code": "2318",
            "localite": "Brot-Plamboz"
        },
        {
            "code": "2322",
            "localite": "Le Crêt-du-Locle"
        },
        {
            "code": "2325",
            "localite": "Les Planchettes"
        },
        {
            "code": "2333",
            "localite": "La Cibourg"
        },
        {
            "code": "2333",
            "localite": "La Ferrière"
        },
        {
            "code": "2336",
            "localite": "Les Bois"
        },
        {
            "code": "2338",
            "localite": "Les Emibois"
        },
        {
            "code": "2338",
            "localite": "Muriaux"
        },
        {
            "code": "2340",
            "localite": "Le Noirmont"
        },
        {
            "code": "2345",
            "localite": "La Chaux-des-Breuleux"
        },
        {
            "code": "2345",
            "localite": "Le Cerneux-Veusil"
        },
        {
            "code": "2345",
            "localite": "Le Peuchapatte"
        },
        {
            "code": "2345",
            "localite": "Les Breuleux"
        },
        {
            "code": "2350",
            "localite": "Saignelégier"
        },
        {
            "code": "2353",
            "localite": "Les Pommerats"
        },
        {
            "code": "2354",
            "localite": "Goumois"
        },
        {
            "code": "2360",
            "localite": "Le Bémont JU"
        },
        {
            "code": "2362",
            "localite": "Montfaucon"
        },
        {
            "code": "2362",
            "localite": "Montfavergier"
        },
        {
            "code": "2363",
            "localite": "Les Enfers"
        },
        {
            "code": "2364",
            "localite": "St-Brais"
        },
        {
            "code": "2400",
            "localite": "Le Locle"
        },
        {
            "code": "2400",
            "localite": "Le Prévoux"
        },
        {
            "code": "2405",
            "localite": "La Chaux-du-Milieu"
        },
        {
            "code": "2406",
            "localite": "La Brévine"
        },
        {
            "code": "2406",
            "localite": "La Châtagne"
        },
        {
            "code": "2406",
            "localite": "Le Brouillet"
        },
        {
            "code": "2406",
            "localite": "Les Taillères"
        },
        {
            "code": "2414",
            "localite": "Le Cerneux-Péquignot"
        },
        {
            "code": "2416",
            "localite": "Les Brenets"
        },
        {
            "code": "2502",
            "localite": "Biel/Bienne"
        },
        {
            "code": "2503",
            "localite": "Biel/Bienne"
        },
        {
            "code": "2504",
            "localite": "Biel/Bienne"
        },
        {
            "code": "2505",
            "localite": "Biel/Bienne"
        },
        {
            "code": "2512",
            "localite": "Tüscherz-Alfermée"
        },
        {
            "code": "2513",
            "localite": "Twann"
        },
        {
            "code": "2514",
            "localite": "Ligerz"
        },
        {
            "code": "2515",
            "localite": "Prêles"
        },
        {
            "code": "2516",
            "localite": "Lamboing"
        },
        {
            "code": "2517",
            "localite": "Diesse"
        },
        {
            "code": "2518",
            "localite": "Nods"
        },
        {
            "code": "2520",
            "localite": "La Neuveville"
        },
        {
            "code": "2523",
            "localite": "Lignières"
        },
        {
            "code": "2525",
            "localite": "Le Landeron"
        },
        {
            "code": "2532",
            "localite": "Magglingen/Macolin"
        },
        {
            "code": "2533",
            "localite": "Evilard"
        },
        {
            "code": "2534",
            "localite": "Les Prés-d'Orvin"
        },
        {
            "code": "2534",
            "localite": "Orvin"
        },
        {
            "code": "2535",
            "localite": "Frinvillier"
        },
        {
            "code": "2536",
            "localite": "Plagne"
        },
        {
            "code": "2537",
            "localite": "Vauffelin"
        },
        {
            "code": "2538",
            "localite": "Romont BE"
        },
        {
            "code": "2540",
            "localite": "Grenchen"
        },
        {
            "code": "2542",
            "localite": "Pieterlen"
        },
        {
            "code": "2543",
            "localite": "Lengnau BE"
        },
        {
            "code": "2544",
            "localite": "Bettlach"
        },
        {
            "code": "2545",
            "localite": "Selzach"
        },
        {
            "code": "2552",
            "localite": "Orpund"
        },
        {
            "code": "2553",
            "localite": "Safnern"
        },
        {
            "code": "2554",
            "localite": "Meinisberg"
        },
        {
            "code": "2555",
            "localite": "Brügg BE"
        },
        {
            "code": "2556",
            "localite": "Scheuren"
        },
        {
            "code": "2556",
            "localite": "Schwadernau"
        },
        {
            "code": "2557",
            "localite": "Studen BE"
        },
        {
            "code": "2558",
            "localite": "Aegerten"
        },
        {
            "code": "2560",
            "localite": "Nidau"
        },
        {
            "code": "2562",
            "localite": "Port"
        },
        {
            "code": "2563",
            "localite": "Ipsach"
        },
        {
            "code": "2564",
            "localite": "Bellmund"
        },
        {
            "code": "2565",
            "localite": "Jens"
        },
        {
            "code": "2572",
            "localite": "Mörigen"
        },
        {
            "code": "2572",
            "localite": "Sutz"
        },
        {
            "code": "2575",
            "localite": "Gerolfingen"
        },
        {
            "code": "2575",
            "localite": "Hagneck"
        },
        {
            "code": "2575",
            "localite": "Täuffelen"
        },
        {
            "code": "2576",
            "localite": "Lüscherz"
        },
        {
            "code": "2577",
            "localite": "Finsterhennen"
        },
        {
            "code": "2577",
            "localite": "Siselen BE"
        },
        {
            "code": "2603",
            "localite": "Péry"
        },
        {
            "code": "2604",
            "localite": "La Heutte"
        },
        {
            "code": "2605",
            "localite": "Sonceboz-Sombeval"
        },
        {
            "code": "2606",
            "localite": "Corgémont"
        },
        {
            "code": "2607",
            "localite": "Cortébert"
        },
        {
            "code": "2608",
            "localite": "Courtelary"
        },
        {
            "code": "2608",
            "localite": "Montagne-de-Courtelary"
        },
        {
            "code": "2610",
            "localite": "Les Pontins"
        },
        {
            "code": "2610",
            "localite": "Mont-Crosin"
        },
        {
            "code": "2610",
            "localite": "Mont-Soleil"
        },
        {
            "code": "2610",
            "localite": "St-Imier"
        },
        {
            "code": "2612",
            "localite": "Cormoret"
        },
        {
            "code": "2613",
            "localite": "Villeret"
        },
        {
            "code": "2615",
            "localite": "Montagne-de-Sonvilier"
        },
        {
            "code": "2615",
            "localite": "Sonvilier"
        },
        {
            "code": "2616",
            "localite": "La Cibourg"
        },
        {
            "code": "2616",
            "localite": "Renan BE"
        },
        {
            "code": "2710",
            "localite": "Tavannes"
        },
        {
            "code": "2712",
            "localite": "Le Fuet"
        },
        {
            "code": "2713",
            "localite": "Bellelay"
        },
        {
            "code": "2714",
            "localite": "Le Prédame"
        },
        {
            "code": "2714",
            "localite": "Les Genevez JU"
        },
        {
            "code": "2715",
            "localite": "Châtelat"
        },
        {
            "code": "2715",
            "localite": "Monible"
        },
        {
            "code": "2716",
            "localite": "Sornetan"
        },
        {
            "code": "2717",
            "localite": "Fornet-Dessous"
        },
        {
            "code": "2717",
            "localite": "Rebévelier"
        },
        {
            "code": "2718",
            "localite": "Fornet-Dessus"
        },
        {
            "code": "2718",
            "localite": "Lajoux JU"
        },
        {
            "code": "2720",
            "localite": "La Tanne"
        },
        {
            "code": "2720",
            "localite": "Tramelan"
        },
        {
            "code": "2722",
            "localite": "Les Reussilles"
        },
        {
            "code": "2723",
            "localite": "Mont-Tramelan"
        },
        {
            "code": "2732",
            "localite": "Loveresse"
        },
        {
            "code": "2732",
            "localite": "Reconvilier"
        },
        {
            "code": "2732",
            "localite": "Saicourt"
        },
        {
            "code": "2732",
            "localite": "Saules BE"
        },
        {
            "code": "2733",
            "localite": "Pontenet"
        },
        {
            "code": "2735",
            "localite": "Bévilard"
        },
        {
            "code": "2735",
            "localite": "Champoz"
        },
        {
            "code": "2735",
            "localite": "Malleray"
        },
        {
            "code": "2736",
            "localite": "Sorvilier"
        },
        {
            "code": "2738",
            "localite": "Court"
        },
        {
            "code": "2740",
            "localite": "Moutier"
        },
        {
            "code": "2742",
            "localite": "Perrefitte"
        },
        {
            "code": "2743",
            "localite": "Eschert"
        },
        {
            "code": "2744",
            "localite": "Belprahon"
        },
        {
            "code": "2745",
            "localite": "Grandval"
        },
        {
            "code": "2746",
            "localite": "Crémines"
        },
        {
            "code": "2747",
            "localite": "Corcelles BE"
        },
        {
            "code": "2747",
            "localite": "Seehof"
        },
        {
            "code": "2748",
            "localite": "Les Ecorcheresses"
        },
        {
            "code": "2748",
            "localite": "Souboz"
        },
        {
            "code": "2762",
            "localite": "Roches BE"
        },
        {
            "code": "2800",
            "localite": "Delémont"
        },
        {
            "code": "2802",
            "localite": "Develier"
        },
        {
            "code": "2803",
            "localite": "Bourrignon"
        },
        {
            "code": "2805",
            "localite": "Soyhières"
        },
        {
            "code": "2806",
            "localite": "Mettembert"
        },
        {
            "code": "2807",
            "localite": "Lucelle"
        },
        {
            "code": "2807",
            "localite": "Pleigne"
        },
        {
            "code": "2812",
            "localite": "Movelier"
        },
        {
            "code": "2813",
            "localite": "Ederswiler"
        },
        {
            "code": "2814",
            "localite": "Roggenburg"
        },
        {
            "code": "2822",
            "localite": "Courroux"
        },
        {
            "code": "2823",
            "localite": "Courcelon"
        },
        {
            "code": "2824",
            "localite": "Vicques"
        },
        {
            "code": "2825",
            "localite": "Courchapoix"
        },
        {
            "code": "2826",
            "localite": "Corban"
        },
        {
            "code": "2827",
            "localite": "Mervelier"
        },
        {
            "code": "2827",
            "localite": "Schelten"
        },
        {
            "code": "2828",
            "localite": "Montsevelier"
        },
        {
            "code": "2829",
            "localite": "Vermes"
        },
        {
            "code": "2830",
            "localite": "Courrendlin"
        },
        {
            "code": "2830",
            "localite": "Vellerat"
        },
        {
            "code": "2832",
            "localite": "Rebeuvelier"
        },
        {
            "code": "2842",
            "localite": "Rossemaison"
        },
        {
            "code": "2843",
            "localite": "Châtillon JU"
        },
        {
            "code": "2852",
            "localite": "Courtételle"
        },
        {
            "code": "2853",
            "localite": "Courfaivre"
        },
        {
            "code": "2854",
            "localite": "Bassecourt"
        },
        {
            "code": "2855",
            "localite": "Glovelier"
        },
        {
            "code": "2856",
            "localite": "Boécourt"
        },
        {
            "code": "2857",
            "localite": "Montavon"
        },
        {
            "code": "2863",
            "localite": "Undervelier"
        },
        {
            "code": "2864",
            "localite": "Soulce"
        },
        {
            "code": "2873",
            "localite": "Saulcy"
        },
        {
            "code": "2882",
            "localite": "St-Ursanne"
        },
        {
            "code": "2883",
            "localite": "Montmelon"
        },
        {
            "code": "2884",
            "localite": "Montenol"
        },
        {
            "code": "2885",
            "localite": "Epauvillers"
        },
        {
            "code": "2886",
            "localite": "Epiquerez"
        },
        {
            "code": "2887",
            "localite": "Soubey"
        },
        {
            "code": "2888",
            "localite": "Seleute"
        },
        {
            "code": "2889",
            "localite": "Ocourt"
        },
        {
            "code": "2900",
            "localite": "Porrentruy"
        },
        {
            "code": "2902",
            "localite": "Fontenais"
        },
        {
            "code": "2903",
            "localite": "Villars-sur-Fontenais"
        },
        {
            "code": "2904",
            "localite": "Bressaucourt"
        },
        {
            "code": "2905",
            "localite": "Courtedoux"
        },
        {
            "code": "2906",
            "localite": "Chevenez"
        },
        {
            "code": "2907",
            "localite": "Rocourt"
        },
        {
            "code": "2908",
            "localite": "Grandfontaine"
        },
        {
            "code": "2912",
            "localite": "Roche-d'Or"
        },
        {
            "code": "2912",
            "localite": "Réclère"
        },
        {
            "code": "2914",
            "localite": "Damvant"
        },
        {
            "code": "2915",
            "localite": "Bure"
        },
        {
            "code": "2916",
            "localite": "Fahy"
        },
        {
            "code": "2922",
            "localite": "Courchavon"
        },
        {
            "code": "2923",
            "localite": "Courtemaîche"
        },
        {
            "code": "2924",
            "localite": "Montignez"
        },
        {
            "code": "2925",
            "localite": "Buix"
        },
        {
            "code": "2926",
            "localite": "Boncourt"
        },
        {
            "code": "2932",
            "localite": "Coeuve"
        },
        {
            "code": "2933",
            "localite": "Damphreux"
        },
        {
            "code": "2933",
            "localite": "Lugnez"
        },
        {
            "code": "2935",
            "localite": "Beurnevésin"
        },
        {
            "code": "2942",
            "localite": "Alle"
        },
        {
            "code": "2943",
            "localite": "Vendlincourt"
        },
        {
            "code": "2944",
            "localite": "Bonfol"
        },
        {
            "code": "2946",
            "localite": "Miécourt"
        },
        {
            "code": "2947",
            "localite": "Charmoille"
        },
        {
            "code": "2950",
            "localite": "Courgenay"
        },
        {
            "code": "2950",
            "localite": "Courtemautruy"
        },
        {
            "code": "2952",
            "localite": "Cornol"
        },
        {
            "code": "2953",
            "localite": "Fregiécourt"
        },
        {
            "code": "2953",
            "localite": "Pleujouse"
        },
        {
            "code": "2954",
            "localite": "Asuel"
        },
        {
            "code": "3004",
            "localite": "Bern"
        },
        {
            "code": "3005",
            "localite": "Bern"
        },
        {
            "code": "3006",
            "localite": "Bern"
        },
        {
            "code": "3007",
            "localite": "Bern"
        },
        {
            "code": "3008",
            "localite": "Bern"
        },
        {
            "code": "3010",
            "localite": "Bern"
        },
        {
            "code": "3011",
            "localite": "Bern"
        },
        {
            "code": "3012",
            "localite": "Bern"
        },
        {
            "code": "3013",
            "localite": "Bern"
        },
        {
            "code": "3014",
            "localite": "Bern"
        },
        {
            "code": "3015",
            "localite": "Bern"
        },
        {
            "code": "3018",
            "localite": "Bern"
        },
        {
            "code": "3019",
            "localite": "Bern"
        },
        {
            "code": "3020",
            "localite": "Bern"
        },
        {
            "code": "3027",
            "localite": "Bern"
        },
        {
            "code": "3032",
            "localite": "Hinterkappelen"
        },
        {
            "code": "3033",
            "localite": "Wohlen b. Bern"
        },
        {
            "code": "3034",
            "localite": "Murzelen"
        },
        {
            "code": "3035",
            "localite": "Frieswil"
        },
        {
            "code": "3036",
            "localite": "Detligen"
        },
        {
            "code": "3037",
            "localite": "Herrenschwanden"
        },
        {
            "code": "3038",
            "localite": "Kirchlindach"
        },
        {
            "code": "3042",
            "localite": "Ortschwaben"
        },
        {
            "code": "3043",
            "localite": "Uettligen"
        },
        {
            "code": "3044",
            "localite": "Innerberg"
        },
        {
            "code": "3045",
            "localite": "Meikirch"
        },
        {
            "code": "3046",
            "localite": "Wahlendorf"
        },
        {
            "code": "3047",
            "localite": "Bremgarten b. Bern"
        },
        {
            "code": "3048",
            "localite": "Worblaufen"
        },
        {
            "code": "3049",
            "localite": "Säriswil"
        },
        {
            "code": "3052",
            "localite": "Zollikofen"
        },
        {
            "code": "3053",
            "localite": "Deisswil b. Münchenbuchsee"
        },
        {
            "code": "3053",
            "localite": "Diemerswil"
        },
        {
            "code": "3053",
            "localite": "Lätti"
        },
        {
            "code": "3053",
            "localite": "Münchenbuchsee"
        },
        {
            "code": "3053",
            "localite": "Wiggiswil"
        },
        {
            "code": "3054",
            "localite": "Schüpfen"
        },
        {
            "code": "3063",
            "localite": "Ittigen"
        },
        {
            "code": "3065",
            "localite": "Bolligen"
        },
        {
            "code": "3066",
            "localite": "Stettlen"
        },
        {
            "code": "3067",
            "localite": "Boll"
        },
        {
            "code": "3068",
            "localite": "Utzigen"
        },
        {
            "code": "3072",
            "localite": "Ostermundigen"
        },
        {
            "code": "3073",
            "localite": "Gümligen"
        },
        {
            "code": "3074",
            "localite": "Muri b. Bern"
        },
        {
            "code": "3075",
            "localite": "Rüfenacht BE"
        },
        {
            "code": "3075",
            "localite": "Vielbringen b. Worb"
        },
        {
            "code": "3076",
            "localite": "Worb"
        },
        {
            "code": "3077",
            "localite": "Enggistein"
        },
        {
            "code": "3078",
            "localite": "Richigen"
        },
        {
            "code": "3082",
            "localite": "Schlosswil"
        },
        {
            "code": "3083",
            "localite": "Trimstein"
        },
        {
            "code": "3084",
            "localite": "Wabern"
        },
        {
            "code": "3086",
            "localite": "Englisberg"
        },
        {
            "code": "3086",
            "localite": "Zimmerwald"
        },
        {
            "code": "3087",
            "localite": "Niedermuhlern"
        },
        {
            "code": "3088",
            "localite": "Oberbütschel"
        },
        {
            "code": "3088",
            "localite": "Rüeggisberg"
        },
        {
            "code": "3089",
            "localite": "Hinterfultigen"
        },
        {
            "code": "3095",
            "localite": "Spiegel b. Bern"
        },
        {
            "code": "3096",
            "localite": "Oberbalm"
        },
        {
            "code": "3097",
            "localite": "Liebefeld"
        },
        {
            "code": "3098",
            "localite": "Köniz"
        },
        {
            "code": "3098",
            "localite": "Schliern b. Köniz"
        },
        {
            "code": "3099",
            "localite": "Rüti b. Riggisberg"
        },
        {
            "code": "3110",
            "localite": "Münsingen"
        },
        {
            "code": "3111",
            "localite": "Tägertschi"
        },
        {
            "code": "3112",
            "localite": "Allmendingen b. Bern"
        },
        {
            "code": "3113",
            "localite": "Rubigen"
        },
        {
            "code": "3114",
            "localite": "Wichtrach"
        },
        {
            "code": "3115",
            "localite": "Gerzensee"
        },
        {
            "code": "3116",
            "localite": "Kirchdorf BE"
        },
        {
            "code": "3116",
            "localite": "Mühledorf BE"
        },
        {
            "code": "3116",
            "localite": "Noflen BE"
        },
        {
            "code": "3122",
            "localite": "Kehrsatz"
        },
        {
            "code": "3123",
            "localite": "Belp"
        },
        {
            "code": "3124",
            "localite": "Belpberg"
        },
        {
            "code": "3125",
            "localite": "Toffen"
        },
        {
            "code": "3126",
            "localite": "Gelterfingen"
        },
        {
            "code": "3126",
            "localite": "Kaufdorf"
        },
        {
            "code": "3127",
            "localite": "Lohnstorf"
        },
        {
            "code": "3127",
            "localite": "Mühlethurnen"
        },
        {
            "code": "3128",
            "localite": "Kirchenthurnen"
        },
        {
            "code": "3128",
            "localite": "Rümligen"
        },
        {
            "code": "3132",
            "localite": "Riggisberg"
        },
        {
            "code": "3144",
            "localite": "Gasel"
        },
        {
            "code": "3145",
            "localite": "Niederscherli"
        },
        {
            "code": "3147",
            "localite": "Mittelhäusern"
        },
        {
            "code": "3148",
            "localite": "Lanzenhäusern"
        },
        {
            "code": "3150",
            "localite": "Schwarzenburg"
        },
        {
            "code": "3152",
            "localite": "Mamishaus"
        },
        {
            "code": "3153",
            "localite": "Rüschegg Gambach"
        },
        {
            "code": "3154",
            "localite": "Rüschegg Heubach"
        },
        {
            "code": "3155",
            "localite": "Helgisried-Rohrbach"
        },
        {
            "code": "3156",
            "localite": "Riffenmatt"
        },
        {
            "code": "3157",
            "localite": "Milken"
        },
        {
            "code": "3158",
            "localite": "Guggisberg"
        },
        {
            "code": "3159",
            "localite": "Riedstätt"
        },
        {
            "code": "3172",
            "localite": "Niederwangen b. Bern"
        },
        {
            "code": "3173",
            "localite": "Oberwangen b. Bern"
        },
        {
            "code": "3174",
            "localite": "Thörishaus"
        },
        {
            "code": "3175",
            "localite": "Flamatt"
        },
        {
            "code": "3176",
            "localite": "Neuenegg"
        },
        {
            "code": "3177",
            "localite": "Laupen BE"
        },
        {
            "code": "3178",
            "localite": "Bösingen"
        },
        {
            "code": "3179",
            "localite": "Kriechenwil"
        },
        {
            "code": "3182",
            "localite": "Ueberstorf"
        },
        {
            "code": "3183",
            "localite": "Albligen"
        },
        {
            "code": "3184",
            "localite": "Wünnewil"
        },
        {
            "code": "3185",
            "localite": "Schmitten FR"
        },
        {
            "code": "3186",
            "localite": "Düdingen"
        },
        {
            "code": "3202",
            "localite": "Frauenkappelen"
        },
        {
            "code": "3203",
            "localite": "Mühleberg"
        },
        {
            "code": "3204",
            "localite": "Rosshäusern"
        },
        {
            "code": "3205",
            "localite": "Gümmenen"
        },
        {
            "code": "3206",
            "localite": "Biberen"
        },
        {
            "code": "3206",
            "localite": "Ferenbalm"
        },
        {
            "code": "3206",
            "localite": "Gammen"
        },
        {
            "code": "3206",
            "localite": "Rizenbach"
        },
        {
            "code": "3206",
            "localite": "Wallenbuch"
        },
        {
            "code": "3207",
            "localite": "Golaten"
        },
        {
            "code": "3207",
            "localite": "Wileroltigen"
        },
        {
            "code": "3208",
            "localite": "Gurbrü"
        },
        {
            "code": "3210",
            "localite": "Kerzers"
        },
        {
            "code": "3212",
            "localite": "Gurmels"
        },
        {
            "code": "3212",
            "localite": "Kleingurmels"
        },
        {
            "code": "3213",
            "localite": "Kleinbösingen"
        },
        {
            "code": "3213",
            "localite": "Liebistorf"
        },
        {
            "code": "3214",
            "localite": "Ulmiz"
        },
        {
            "code": "3215",
            "localite": "Büchslen"
        },
        {
            "code": "3215",
            "localite": "Gempenach"
        },
        {
            "code": "3215",
            "localite": "Lurtigen"
        },
        {
            "code": "3216",
            "localite": "Agriswil"
        },
        {
            "code": "3216",
            "localite": "Ried b. Kerzers"
        },
        {
            "code": "3225",
            "localite": "Müntschemier"
        },
        {
            "code": "3226",
            "localite": "Treiten"
        },
        {
            "code": "3232",
            "localite": "Ins"
        },
        {
            "code": "3233",
            "localite": "Tschugg"
        },
        {
            "code": "3234",
            "localite": "Vinelz"
        },
        {
            "code": "3235",
            "localite": "Erlach"
        },
        {
            "code": "3236",
            "localite": "Gampelen"
        },
        {
            "code": "3237",
            "localite": "Brüttelen"
        },
        {
            "code": "3238",
            "localite": "Gals"
        },
        {
            "code": "3250",
            "localite": "Lyss"
        },
        {
            "code": "3251",
            "localite": "Ruppoldsried"
        },
        {
            "code": "3251",
            "localite": "Wengi b. Büren"
        },
        {
            "code": "3252",
            "localite": "Worben"
        },
        {
            "code": "3253",
            "localite": "Schnottwil"
        },
        {
            "code": "3254",
            "localite": "Balm b. Messen"
        },
        {
            "code": "3254",
            "localite": "Messen"
        },
        {
            "code": "3255",
            "localite": "Rapperswil BE"
        },
        {
            "code": "3256",
            "localite": "Bangerten b. Dieterswil"
        },
        {
            "code": "3256",
            "localite": "Dieterswil"
        },
        {
            "code": "3256",
            "localite": "Seewil"
        },
        {
            "code": "3257",
            "localite": "Ammerzwil BE"
        },
        {
            "code": "3257",
            "localite": "Grossaffoltern"
        },
        {
            "code": "3262",
            "localite": "Suberg"
        },
        {
            "code": "3263",
            "localite": "Büetigen"
        },
        {
            "code": "3264",
            "localite": "Diessbach b. Büren"
        },
        {
            "code": "3266",
            "localite": "Wiler b. Seedorf"
        },
        {
            "code": "3267",
            "localite": "Seedorf BE"
        },
        {
            "code": "3268",
            "localite": "Lobsigen"
        },
        {
            "code": "3270",
            "localite": "Aarberg"
        },
        {
            "code": "3271",
            "localite": "Radelfingen b. Aarberg"
        },
        {
            "code": "3272",
            "localite": "Epsach"
        },
        {
            "code": "3272",
            "localite": "Walperswil"
        },
        {
            "code": "3273",
            "localite": "Kappelen"
        },
        {
            "code": "3274",
            "localite": "Bühl b. Aarberg"
        },
        {
            "code": "3274",
            "localite": "Hermrigen"
        },
        {
            "code": "3274",
            "localite": "Merzligen"
        },
        {
            "code": "3280",
            "localite": "Greng"
        },
        {
            "code": "3280",
            "localite": "Meyriez"
        },
        {
            "code": "3280",
            "localite": "Murten"
        },
        {
            "code": "3282",
            "localite": "Bargen BE"
        },
        {
            "code": "3283",
            "localite": "Kallnach"
        },
        {
            "code": "3283",
            "localite": "Niederried b. Kallnach"
        },
        {
            "code": "3284",
            "localite": "Fräschels"
        },
        {
            "code": "3285",
            "localite": "Galmiz"
        },
        {
            "code": "3286",
            "localite": "Muntelier"
        },
        {
            "code": "3292",
            "localite": "Busswil BE"
        },
        {
            "code": "3293",
            "localite": "Dotzigen"
        },
        {
            "code": "3294",
            "localite": "Büren an der Aare"
        },
        {
            "code": "3294",
            "localite": "Meienried"
        },
        {
            "code": "3295",
            "localite": "Rüti b. Büren"
        },
        {
            "code": "3296",
            "localite": "Arch"
        },
        {
            "code": "3297",
            "localite": "Leuzigen"
        },
        {
            "code": "3298",
            "localite": "Oberwil b. Büren"
        },
        {
            "code": "3302",
            "localite": "Moosseedorf"
        },
        {
            "code": "3303",
            "localite": "Ballmoos"
        },
        {
            "code": "3303",
            "localite": "Jegenstorf"
        },
        {
            "code": "3303",
            "localite": "Münchringen"
        },
        {
            "code": "3303",
            "localite": "Zuzwil BE"
        },
        {
            "code": "3305",
            "localite": "Iffwil"
        },
        {
            "code": "3305",
            "localite": "Scheunen"
        },
        {
            "code": "3306",
            "localite": "Etzelkofen"
        },
        {
            "code": "3307",
            "localite": "Brunnenthal"
        },
        {
            "code": "3308",
            "localite": "Grafenried"
        },
        {
            "code": "3309",
            "localite": "Kernenried"
        },
        {
            "code": "3309",
            "localite": "Zauggenried"
        },
        {
            "code": "3312",
            "localite": "Fraubrunnen"
        },
        {
            "code": "3313",
            "localite": "Büren zum Hof"
        },
        {
            "code": "3314",
            "localite": "Schalunen"
        },
        {
            "code": "3315",
            "localite": "Bätterkinden"
        },
        {
            "code": "3315",
            "localite": "Kräiligen"
        },
        {
            "code": "3317",
            "localite": "Limpach"
        },
        {
            "code": "3317",
            "localite": "Mülchi"
        },
        {
            "code": "3322",
            "localite": "Mattstetten"
        },
        {
            "code": "3322",
            "localite": "Urtenen-Schönbühl"
        },
        {
            "code": "3323",
            "localite": "Bäriswil BE"
        },
        {
            "code": "3324",
            "localite": "Hindelbank"
        },
        {
            "code": "3324",
            "localite": "Mötschwil"
        },
        {
            "code": "3325",
            "localite": "Hettiswil b. Hindelbank"
        },
        {
            "code": "3326",
            "localite": "Krauchthal"
        },
        {
            "code": "3360",
            "localite": "Herzogenbuchsee"
        },
        {
            "code": "3362",
            "localite": "Niederönz"
        },
        {
            "code": "3363",
            "localite": "Oberönz"
        },
        {
            "code": "3365",
            "localite": "Grasswil"
        },
        {
            "code": "3365",
            "localite": "Seeberg"
        },
        {
            "code": "3366",
            "localite": "Bettenhausen"
        },
        {
            "code": "3366",
            "localite": "Bollodingen"
        },
        {
            "code": "3367",
            "localite": "Ochlenberg"
        },
        {
            "code": "3367",
            "localite": "Thörigen"
        },
        {
            "code": "3368",
            "localite": "Bleienbach"
        },
        {
            "code": "3372",
            "localite": "Wanzwil"
        },
        {
            "code": "3373",
            "localite": "Heimenhausen"
        },
        {
            "code": "3373",
            "localite": "Röthenbach Herzogenbuchsee"
        },
        {
            "code": "3374",
            "localite": "Wangenried"
        },
        {
            "code": "3375",
            "localite": "Inkwil"
        },
        {
            "code": "3376",
            "localite": "Berken"
        },
        {
            "code": "3376",
            "localite": "Graben"
        },
        {
            "code": "3377",
            "localite": "Walliswil b. Wangen"
        },
        {
            "code": "3380",
            "localite": "Walliswil b. Niederbipp"
        },
        {
            "code": "3380",
            "localite": "Wangen an der Aare"
        },
        {
            "code": "3400",
            "localite": "Burgdorf"
        },
        {
            "code": "3412",
            "localite": "Heimiswil"
        },
        {
            "code": "3413",
            "localite": "Kaltacker"
        },
        {
            "code": "3414",
            "localite": "Oberburg"
        },
        {
            "code": "3415",
            "localite": "Hasle b. Burgdorf"
        },
        {
            "code": "3415",
            "localite": "Rüegsauschachen"
        },
        {
            "code": "3415",
            "localite": "Schafhausen im Emmental"
        },
        {
            "code": "3416",
            "localite": "Affoltern im Emmental"
        },
        {
            "code": "3417",
            "localite": "Rüegsau"
        },
        {
            "code": "3418",
            "localite": "Rüegsbach"
        },
        {
            "code": "3419",
            "localite": "Biembach im Emmental"
        },
        {
            "code": "3421",
            "localite": "Lyssach"
        },
        {
            "code": "3421",
            "localite": "Rüti b. Lyssach"
        },
        {
            "code": "3422",
            "localite": "Alchenflüh"
        },
        {
            "code": "3422",
            "localite": "Kirchberg BE"
        },
        {
            "code": "3422",
            "localite": "Rüdtligen"
        },
        {
            "code": "3423",
            "localite": "Ersigen"
        },
        {
            "code": "3424",
            "localite": "Niederösch"
        },
        {
            "code": "3424",
            "localite": "Oberösch"
        },
        {
            "code": "3425",
            "localite": "Koppigen"
        },
        {
            "code": "3425",
            "localite": "Willadingen"
        },
        {
            "code": "3426",
            "localite": "Aefligen"
        },
        {
            "code": "3427",
            "localite": "Utzenstorf"
        },
        {
            "code": "3428",
            "localite": "Wiler b. Utzenstorf"
        },
        {
            "code": "3429",
            "localite": "Hellsau"
        },
        {
            "code": "3429",
            "localite": "Höchstetten"
        },
        {
            "code": "3432",
            "localite": "Lützelflüh-Goldbach"
        },
        {
            "code": "3433",
            "localite": "Schwanden im Emmental"
        },
        {
            "code": "3434",
            "localite": "Landiswil"
        },
        {
            "code": "3434",
            "localite": "Obergoldbach"
        },
        {
            "code": "3435",
            "localite": "Ramsei"
        },
        {
            "code": "3436",
            "localite": "Zollbrück"
        },
        {
            "code": "3437",
            "localite": "Rüderswil"
        },
        {
            "code": "3438",
            "localite": "Lauperswil"
        },
        {
            "code": "3439",
            "localite": "Ranflüh"
        },
        {
            "code": "3452",
            "localite": "Grünenmatt"
        },
        {
            "code": "3453",
            "localite": "Heimisbach"
        },
        {
            "code": "3454",
            "localite": "Sumiswald"
        },
        {
            "code": "3455",
            "localite": "Grünen"
        },
        {
            "code": "3456",
            "localite": "Trachselwald"
        },
        {
            "code": "3457",
            "localite": "Wasen im Emmental"
        },
        {
            "code": "3462",
            "localite": "Weier im Emmental"
        },
        {
            "code": "3463",
            "localite": "Häusernmoos im Emmental"
        },
        {
            "code": "3464",
            "localite": "Schmidigen-Mühleweg"
        },
        {
            "code": "3465",
            "localite": "Dürrenroth"
        },
        {
            "code": "3472",
            "localite": "Rumendingen"
        },
        {
            "code": "3472",
            "localite": "Wynigen"
        },
        {
            "code": "3473",
            "localite": "Alchenstorf"
        },
        {
            "code": "3474",
            "localite": "Rüedisbach"
        },
        {
            "code": "3475",
            "localite": "Hermiswil"
        },
        {
            "code": "3475",
            "localite": "Riedtwil"
        },
        {
            "code": "3476",
            "localite": "Oschwand"
        },
        {
            "code": "3503",
            "localite": "Gysenstein"
        },
        {
            "code": "3504",
            "localite": "Niederhünigen"
        },
        {
            "code": "3504",
            "localite": "Oberhünigen"
        },
        {
            "code": "3506",
            "localite": "Grosshöchstetten"
        },
        {
            "code": "3507",
            "localite": "Biglen"
        },
        {
            "code": "3508",
            "localite": "Arni BE"
        },
        {
            "code": "3510",
            "localite": "Freimettigen"
        },
        {
            "code": "3510",
            "localite": "Häutligen"
        },
        {
            "code": "3510",
            "localite": "Konolfingen"
        },
        {
            "code": "3512",
            "localite": "Walkringen"
        },
        {
            "code": "3513",
            "localite": "Bigenthal"
        },
        {
            "code": "3531",
            "localite": "Oberthal"
        },
        {
            "code": "3532",
            "localite": "Mirchel"
        },
        {
            "code": "3532",
            "localite": "Zäziwil"
        },
        {
            "code": "3533",
            "localite": "Bowil"
        },
        {
            "code": "3534",
            "localite": "Signau"
        },
        {
            "code": "3535",
            "localite": "Schüpbach"
        },
        {
            "code": "3536",
            "localite": "Aeschau"
        },
        {
            "code": "3537",
            "localite": "Eggiwil"
        },
        {
            "code": "3538",
            "localite": "Röthenbach im Emmental"
        },
        {
            "code": "3543",
            "localite": "Emmenmatt"
        },
        {
            "code": "3550",
            "localite": "Langnau im Emmental"
        },
        {
            "code": "3551",
            "localite": "Oberfrittenbach"
        },
        {
            "code": "3552",
            "localite": "Bärau"
        },
        {
            "code": "3553",
            "localite": "Gohl"
        },
        {
            "code": "3555",
            "localite": "Trubschachen"
        },
        {
            "code": "3556",
            "localite": "Trub"
        },
        {
            "code": "3557",
            "localite": "Fankhaus (Trub)"
        },
        {
            "code": "3600",
            "localite": "Thun"
        },
        {
            "code": "3603",
            "localite": "Thun"
        },
        {
            "code": "3604",
            "localite": "Thun"
        },
        {
            "code": "3608",
            "localite": "Thun"
        },
        {
            "code": "3612",
            "localite": "Steffisburg"
        },
        {
            "code": "3613",
            "localite": "Steffisburg"
        },
        {
            "code": "3614",
            "localite": "Unterlangenegg"
        },
        {
            "code": "3615",
            "localite": "Heimenschwand"
        },
        {
            "code": "3616",
            "localite": "Schwarzenegg"
        },
        {
            "code": "3617",
            "localite": "Fahrni b. Thun"
        },
        {
            "code": "3618",
            "localite": "Süderen"
        },
        {
            "code": "3619",
            "localite": "Eriz"
        },
        {
            "code": "3622",
            "localite": "Homberg b. Thun"
        },
        {
            "code": "3623",
            "localite": "Buchen BE"
        },
        {
            "code": "3623",
            "localite": "Horrenbach"
        },
        {
            "code": "3623",
            "localite": "Teuffenthal b. Thun"
        },
        {
            "code": "3624",
            "localite": "Goldiwil (Thun)"
        },
        {
            "code": "3624",
            "localite": "Schwendibach"
        },
        {
            "code": "3625",
            "localite": "Heiligenschwendi"
        },
        {
            "code": "3626",
            "localite": "Hünibach"
        },
        {
            "code": "3627",
            "localite": "Heimberg"
        },
        {
            "code": "3628",
            "localite": "Uttigen"
        },
        {
            "code": "3629",
            "localite": "Jaberg"
        },
        {
            "code": "3629",
            "localite": "Kiesen"
        },
        {
            "code": "3629",
            "localite": "Oppligen"
        },
        {
            "code": "3631",
            "localite": "Höfen b. Thun"
        },
        {
            "code": "3632",
            "localite": "Niederstocken"
        },
        {
            "code": "3632",
            "localite": "Oberstocken"
        },
        {
            "code": "3633",
            "localite": "Amsoldingen"
        },
        {
            "code": "3634",
            "localite": "Thierachern"
        },
        {
            "code": "3635",
            "localite": "Uebeschi"
        },
        {
            "code": "3636",
            "localite": "Forst b. Längenbühl"
        },
        {
            "code": "3636",
            "localite": "Längenbühl"
        },
        {
            "code": "3638",
            "localite": "Blumenstein"
        },
        {
            "code": "3638",
            "localite": "Pohlern"
        },
        {
            "code": "3645",
            "localite": "Gwatt (Thun)"
        },
        {
            "code": "3645",
            "localite": "Zwieselberg"
        },
        {
            "code": "3646",
            "localite": "Einigen"
        },
        {
            "code": "3647",
            "localite": "Reutigen"
        },
        {
            "code": "3652",
            "localite": "Hilterfingen"
        },
        {
            "code": "3653",
            "localite": "Oberhofen am Thunersee"
        },
        {
            "code": "3654",
            "localite": "Gunten"
        },
        {
            "code": "3655",
            "localite": "Sigriswil"
        },
        {
            "code": "3656",
            "localite": "Aeschlen ob Gunten"
        },
        {
            "code": "3656",
            "localite": "Ringoldswil"
        },
        {
            "code": "3656",
            "localite": "Tschingel ob Gunten"
        },
        {
            "code": "3657",
            "localite": "Schwanden (Sigriswil)"
        },
        {
            "code": "3658",
            "localite": "Merligen"
        },
        {
            "code": "3661",
            "localite": "Uetendorf"
        },
        {
            "code": "3662",
            "localite": "Seftigen"
        },
        {
            "code": "3663",
            "localite": "Gurzelen"
        },
        {
            "code": "3664",
            "localite": "Burgistein"
        },
        {
            "code": "3665",
            "localite": "Wattenwil"
        },
        {
            "code": "3671",
            "localite": "Brenzikofen"
        },
        {
            "code": "3671",
            "localite": "Herbligen"
        },
        {
            "code": "3672",
            "localite": "Aeschlen b. Oberdiessbach"
        },
        {
            "code": "3672",
            "localite": "Oberdiessbach"
        },
        {
            "code": "3673",
            "localite": "Linden"
        },
        {
            "code": "3674",
            "localite": "Bleiken b. Oberdiessbach"
        },
        {
            "code": "3700",
            "localite": "Spiez"
        },
        {
            "code": "3702",
            "localite": "Hondrich"
        },
        {
            "code": "3703",
            "localite": "Aeschi b. Spiez"
        },
        {
            "code": "3703",
            "localite": "Aeschiried"
        },
        {
            "code": "3704",
            "localite": "Krattigen"
        },
        {
            "code": "3705",
            "localite": "Faulensee"
        },
        {
            "code": "3706",
            "localite": "Leissigen"
        },
        {
            "code": "3707",
            "localite": "Därligen"
        },
        {
            "code": "3711",
            "localite": "Emdthal"
        },
        {
            "code": "3711",
            "localite": "Mülenen"
        },
        {
            "code": "3713",
            "localite": "Reichenbach im Kandertal"
        },
        {
            "code": "3714",
            "localite": "Frutigen"
        },
        {
            "code": "3714",
            "localite": "Wengi b. Frutigen"
        },
        {
            "code": "3715",
            "localite": "Adelboden"
        },
        {
            "code": "3716",
            "localite": "Kandergrund"
        },
        {
            "code": "3717",
            "localite": "Blausee-Mitholz"
        },
        {
            "code": "3718",
            "localite": "Kandersteg"
        },
        {
            "code": "3722",
            "localite": "Scharnachtal"
        },
        {
            "code": "3723",
            "localite": "Kiental"
        },
        {
            "code": "3724",
            "localite": "Ried (Frutigen)"
        },
        {
            "code": "3725",
            "localite": "Achseten"
        },
        {
            "code": "3752",
            "localite": "Wimmis"
        },
        {
            "code": "3753",
            "localite": "Oey"
        },
        {
            "code": "3754",
            "localite": "Diemtigen"
        },
        {
            "code": "3755",
            "localite": "Horboden"
        },
        {
            "code": "3756",
            "localite": "Zwischenflüh"
        },
        {
            "code": "3757",
            "localite": "Schwenden im Diemtigtal"
        },
        {
            "code": "3758",
            "localite": "Latterbach"
        },
        {
            "code": "3762",
            "localite": "Erlenbach im Simmental"
        },
        {
            "code": "3763",
            "localite": "Därstetten"
        },
        {
            "code": "3764",
            "localite": "Weissenburg"
        },
        {
            "code": "3765",
            "localite": "Oberwil im Simmental"
        },
        {
            "code": "3766",
            "localite": "Boltigen"
        },
        {
            "code": "3770",
            "localite": "Zweisimmen"
        },
        {
            "code": "3771",
            "localite": "Blankenburg"
        },
        {
            "code": "3772",
            "localite": "St. Stephan"
        },
        {
            "code": "3773",
            "localite": "Matten (St. Stephan)"
        },
        {
            "code": "3775",
            "localite": "Lenk im Simmental"
        },
        {
            "code": "3776",
            "localite": "Oeschseite"
        },
        {
            "code": "3777",
            "localite": "Saanenmöser"
        },
        {
            "code": "3778",
            "localite": "Schönried"
        },
        {
            "code": "3780",
            "localite": "Gstaad"
        },
        {
            "code": "3781",
            "localite": "Turbach"
        },
        {
            "code": "3782",
            "localite": "Lauenen b. Gstaad"
        },
        {
            "code": "3783",
            "localite": "Grund b. Gstaad"
        },
        {
            "code": "3784",
            "localite": "Feutersoey"
        },
        {
            "code": "3785",
            "localite": "Gsteig b. Gstaad"
        },
        {
            "code": "3792",
            "localite": "Saanen"
        },
        {
            "code": "3800",
            "localite": "Interlaken"
        },
        {
            "code": "3800",
            "localite": "Matten b. Interlaken"
        },
        {
            "code": "3800",
            "localite": "Sundlauenen"
        },
        {
            "code": "3800",
            "localite": "Unterseen"
        },
        {
            "code": "3801",
            "localite": "Jungfraujoch"
        },
        {
            "code": "3803",
            "localite": "Beatenberg"
        },
        {
            "code": "3804",
            "localite": "Habkern"
        },
        {
            "code": "3805",
            "localite": "Goldswil b. Interlaken"
        },
        {
            "code": "3806",
            "localite": "Bönigen b. Interlaken"
        },
        {
            "code": "3807",
            "localite": "Iseltwald"
        },
        {
            "code": "3812",
            "localite": "Wilderswil"
        },
        {
            "code": "3813",
            "localite": "Saxeten"
        },
        {
            "code": "3814",
            "localite": "Gsteigwiler"
        },
        {
            "code": "3815",
            "localite": "Gündlischwand"
        },
        {
            "code": "3815",
            "localite": "Zweilütschinen"
        },
        {
            "code": "3816",
            "localite": "Burglauenen"
        },
        {
            "code": "3816",
            "localite": "Lütschental"
        },
        {
            "code": "3818",
            "localite": "Grindelwald"
        },
        {
            "code": "3822",
            "localite": "Isenfluh"
        },
        {
            "code": "3822",
            "localite": "Lauterbrunnen"
        },
        {
            "code": "3823",
            "localite": "Eigergletscher"
        },
        {
            "code": "3823",
            "localite": "Kleine Scheidegg"
        },
        {
            "code": "3823",
            "localite": "Wengen"
        },
        {
            "code": "3824",
            "localite": "Stechelberg"
        },
        {
            "code": "3825",
            "localite": "Mürren"
        },
        {
            "code": "3826",
            "localite": "Gimmelwald"
        },
        {
            "code": "3852",
            "localite": "Ringgenberg BE"
        },
        {
            "code": "3853",
            "localite": "Niederried b. Interlaken"
        },
        {
            "code": "3854",
            "localite": "Oberried am Brienzersee"
        },
        {
            "code": "3855",
            "localite": "Axalp"
        },
        {
            "code": "3855",
            "localite": "Brienz BE"
        },
        {
            "code": "3855",
            "localite": "Schwanden b. Brienz"
        },
        {
            "code": "3856",
            "localite": "Brienzwiler"
        },
        {
            "code": "3857",
            "localite": "Unterbach BE"
        },
        {
            "code": "3858",
            "localite": "Hofstetten b. Brienz"
        },
        {
            "code": "3860",
            "localite": "Brünig"
        },
        {
            "code": "3860",
            "localite": "Meiringen"
        },
        {
            "code": "3860",
            "localite": "Rosenlaui"
        },
        {
            "code": "3860",
            "localite": "Schattenhalb"
        },
        {
            "code": "3862",
            "localite": "Innertkirchen"
        },
        {
            "code": "3863",
            "localite": "Gadmen"
        },
        {
            "code": "3864",
            "localite": "Guttannen"
        },
        {
            "code": "3900",
            "localite": "Brig"
        },
        {
            "code": "3900",
            "localite": "Brigerbad"
        },
        {
            "code": "3900",
            "localite": "Gamsen"
        },
        {
            "code": "3901",
            "localite": "Rothwald"
        },
        {
            "code": "3902",
            "localite": "Glis"
        },
        {
            "code": "3903",
            "localite": "Birgisch"
        },
        {
            "code": "3903",
            "localite": "Mund"
        },
        {
            "code": "3904",
            "localite": "Naters"
        },
        {
            "code": "3905",
            "localite": "Saas-Almagell"
        },
        {
            "code": "3906",
            "localite": "Saas-Fee"
        },
        {
            "code": "3907",
            "localite": "Gabi (Simplon)"
        },
        {
            "code": "3907",
            "localite": "Gondo"
        },
        {
            "code": "3907",
            "localite": "Simplon Dorf"
        },
        {
            "code": "3907",
            "localite": "Simplon Hospiz"
        },
        {
            "code": "3908",
            "localite": "Saas-Balen"
        },
        {
            "code": "3910",
            "localite": "Saas-Grund"
        },
        {
            "code": "3911",
            "localite": "Ried-Brig"
        },
        {
            "code": "3912",
            "localite": "Termen"
        },
        {
            "code": "3913",
            "localite": "Rosswald"
        },
        {
            "code": "3914",
            "localite": "Belalp"
        },
        {
            "code": "3914",
            "localite": "Blatten b. Naters"
        },
        {
            "code": "3916",
            "localite": "Ferden"
        },
        {
            "code": "3917",
            "localite": "Goppenstein"
        },
        {
            "code": "3917",
            "localite": "Kippel"
        },
        {
            "code": "3918",
            "localite": "Wiler (Lötschen)"
        },
        {
            "code": "3919",
            "localite": "Blatten (Lötschen)"
        },
        {
            "code": "3920",
            "localite": "Zermatt"
        },
        {
            "code": "3922",
            "localite": "Eisten"
        },
        {
            "code": "3922",
            "localite": "Kalpetran"
        },
        {
            "code": "3922",
            "localite": "Stalden VS"
        },
        {
            "code": "3923",
            "localite": "Törbel"
        },
        {
            "code": "3924",
            "localite": "St. Niklaus VS"
        },
        {
            "code": "3925",
            "localite": "Grächen"
        },
        {
            "code": "3926",
            "localite": "Embd"
        },
        {
            "code": "3927",
            "localite": "Herbriggen"
        },
        {
            "code": "3928",
            "localite": "Randa"
        },
        {
            "code": "3929",
            "localite": "Täsch"
        },
        {
            "code": "3930",
            "localite": "Eyholz"
        },
        {
            "code": "3930",
            "localite": "Visp"
        },
        {
            "code": "3931",
            "localite": "Lalden"
        },
        {
            "code": "3932",
            "localite": "Visperterminen"
        },
        {
            "code": "3933",
            "localite": "Staldenried"
        },
        {
            "code": "3934",
            "localite": "Zeneggen"
        },
        {
            "code": "3935",
            "localite": "Bürchen"
        },
        {
            "code": "3937",
            "localite": "Baltschieder"
        },
        {
            "code": "3938",
            "localite": "Ausserberg"
        },
        {
            "code": "3939",
            "localite": "Eggerberg"
        },
        {
            "code": "3940",
            "localite": "Steg VS"
        },
        {
            "code": "3942",
            "localite": "Niedergesteln"
        },
        {
            "code": "3942",
            "localite": "Raron"
        },
        {
            "code": "3942",
            "localite": "St. German"
        },
        {
            "code": "3943",
            "localite": "Eischoll"
        },
        {
            "code": "3944",
            "localite": "Unterbäch VS"
        },
        {
            "code": "3945",
            "localite": "Gampel"
        },
        {
            "code": "3945",
            "localite": "Niedergampel"
        },
        {
            "code": "3946",
            "localite": "Gruben"
        },
        {
            "code": "3946",
            "localite": "Turtmann"
        },
        {
            "code": "3947",
            "localite": "Ergisch"
        },
        {
            "code": "3948",
            "localite": "Oberems"
        },
        {
            "code": "3948",
            "localite": "Unterems"
        },
        {
            "code": "3949",
            "localite": "Hohtenn"
        },
        {
            "code": "3951",
            "localite": "Agarn"
        },
        {
            "code": "3952",
            "localite": "Susten"
        },
        {
            "code": "3953",
            "localite": "Inden"
        },
        {
            "code": "3953",
            "localite": "Leuk Stadt"
        },
        {
            "code": "3953",
            "localite": "Varen"
        },
        {
            "code": "3954",
            "localite": "Leukerbad"
        },
        {
            "code": "3955",
            "localite": "Albinen"
        },
        {
            "code": "3956",
            "localite": "Guttet-Feschel"
        },
        {
            "code": "3957",
            "localite": "Bratsch"
        },
        {
            "code": "3957",
            "localite": "Erschmatt"
        },
        {
            "code": "3960",
            "localite": "Corin-de-la-Crête"
        },
        {
            "code": "3960",
            "localite": "Loc"
        },
        {
            "code": "3960",
            "localite": "Muraz (Sierre)"
        },
        {
            "code": "3960",
            "localite": "Niouc"
        },
        {
            "code": "3960",
            "localite": "Sierre"
        },
        {
            "code": "3961",
            "localite": "Ayer"
        },
        {
            "code": "3961",
            "localite": "Chandolin"
        },
        {
            "code": "3961",
            "localite": "Grimentz"
        },
        {
            "code": "3961",
            "localite": "Mission"
        },
        {
            "code": "3961",
            "localite": "St-Jean VS"
        },
        {
            "code": "3961",
            "localite": "St-Luc"
        },
        {
            "code": "3961",
            "localite": "Vissoie"
        },
        {
            "code": "3961",
            "localite": "Zinal"
        },
        {
            "code": "3963",
            "localite": "Aminona"
        },
        {
            "code": "3963",
            "localite": "Crans VS"
        },
        {
            "code": "3963",
            "localite": "Crans-Montana"
        },
        {
            "code": "3963",
            "localite": "Montana"
        },
        {
            "code": "3965",
            "localite": "Chippis"
        },
        {
            "code": "3966",
            "localite": "Chalais"
        },
        {
            "code": "3966",
            "localite": "Réchy"
        },
        {
            "code": "3967",
            "localite": "Vercorin"
        },
        {
            "code": "3968",
            "localite": "Veyras"
        },
        {
            "code": "3970",
            "localite": "Salgesch"
        },
        {
            "code": "3971",
            "localite": "Chermignon"
        },
        {
            "code": "3971",
            "localite": "Chermignon-d'en-Bas"
        },
        {
            "code": "3971",
            "localite": "Ollon VS"
        },
        {
            "code": "3972",
            "localite": "Miège"
        },
        {
            "code": "3973",
            "localite": "Venthône"
        },
        {
            "code": "3974",
            "localite": "Mollens VS"
        },
        {
            "code": "3975",
            "localite": "Randogne"
        },
        {
            "code": "3976",
            "localite": "Champzabé"
        },
        {
            "code": "3976",
            "localite": "Noës"
        },
        {
            "code": "3977",
            "localite": "Granges VS"
        },
        {
            "code": "3978",
            "localite": "Flanthey"
        },
        {
            "code": "3979",
            "localite": "Grône"
        },
        {
            "code": "3982",
            "localite": "Bitsch"
        },
        {
            "code": "3983",
            "localite": "Bister"
        },
        {
            "code": "3983",
            "localite": "Filet"
        },
        {
            "code": "3983",
            "localite": "Goppisberg"
        },
        {
            "code": "3983",
            "localite": "Greich"
        },
        {
            "code": "3983",
            "localite": "Mörel"
        },
        {
            "code": "3984",
            "localite": "Fiesch"
        },
        {
            "code": "3984",
            "localite": "Fieschertal"
        },
        {
            "code": "3985",
            "localite": "Geschinen"
        },
        {
            "code": "3985",
            "localite": "Münster VS"
        },
        {
            "code": "3986",
            "localite": "Ried-Mörel"
        },
        {
            "code": "3987",
            "localite": "Riederalp"
        },
        {
            "code": "3988",
            "localite": "Obergesteln"
        },
        {
            "code": "3988",
            "localite": "Ulrichen"
        },
        {
            "code": "3989",
            "localite": "Biel VS"
        },
        {
            "code": "3989",
            "localite": "Blitzingen"
        },
        {
            "code": "3989",
            "localite": "Niederwald"
        },
        {
            "code": "3989",
            "localite": "Ritzingen"
        },
        {
            "code": "3989",
            "localite": "Selkingen"
        },
        {
            "code": "3991",
            "localite": "Betten"
        },
        {
            "code": "3992",
            "localite": "Bettmeralp"
        },
        {
            "code": "3993",
            "localite": "Grengiols"
        },
        {
            "code": "3994",
            "localite": "Lax"
        },
        {
            "code": "3994",
            "localite": "Martisberg"
        },
        {
            "code": "3995",
            "localite": "Ausserbinn"
        },
        {
            "code": "3995",
            "localite": "Ernen"
        },
        {
            "code": "3995",
            "localite": "Mühlebach (Goms)"
        },
        {
            "code": "3995",
            "localite": "Steinhaus"
        },
        {
            "code": "3996",
            "localite": "Binn"
        },
        {
            "code": "3997",
            "localite": "Bellwald"
        },
        {
            "code": "3998",
            "localite": "Gluringen"
        },
        {
            "code": "3998",
            "localite": "Reckingen VS"
        },
        {
            "code": "3999",
            "localite": "Oberwald"
        },
        {
            "code": "4001",
            "localite": "Basel"
        },
        {
            "code": "4031",
            "localite": "Basel"
        },
        {
            "code": "4051",
            "localite": "Basel"
        },
        {
            "code": "4052",
            "localite": "Basel"
        },
        {
            "code": "4053",
            "localite": "Basel"
        },
        {
            "code": "4054",
            "localite": "Basel"
        },
        {
            "code": "4055",
            "localite": "Basel"
        },
        {
            "code": "4056",
            "localite": "Basel"
        },
        {
            "code": "4057",
            "localite": "Basel"
        },
        {
            "code": "4058",
            "localite": "Basel"
        },
        {
            "code": "4059",
            "localite": "Basel"
        },
        {
            "code": "4101",
            "localite": "Bruderholz"
        },
        {
            "code": "4102",
            "localite": "Binningen"
        },
        {
            "code": "4103",
            "localite": "Bottmingen"
        },
        {
            "code": "4104",
            "localite": "Oberwil BL"
        },
        {
            "code": "4105",
            "localite": "Biel-Benken BL"
        },
        {
            "code": "4106",
            "localite": "Therwil"
        },
        {
            "code": "4107",
            "localite": "Ettingen"
        },
        {
            "code": "4108",
            "localite": "Witterswil"
        },
        {
            "code": "4112",
            "localite": "Bättwil"
        },
        {
            "code": "4112",
            "localite": "Flüh"
        },
        {
            "code": "4114",
            "localite": "Hofstetten SO"
        },
        {
            "code": "4115",
            "localite": "Mariastein"
        },
        {
            "code": "4116",
            "localite": "Metzerlen"
        },
        {
            "code": "4117",
            "localite": "Burg im Leimental"
        },
        {
            "code": "4118",
            "localite": "Rodersdorf"
        },
        {
            "code": "4123",
            "localite": "Allschwil"
        },
        {
            "code": "4124",
            "localite": "Schönenbuch"
        },
        {
            "code": "4125",
            "localite": "Riehen"
        },
        {
            "code": "4126",
            "localite": "Bettingen"
        },
        {
            "code": "4127",
            "localite": "Birsfelden"
        },
        {
            "code": "4132",
            "localite": "Muttenz"
        },
        {
            "code": "4133",
            "localite": "Pratteln"
        },
        {
            "code": "4142",
            "localite": "Münchenstein"
        },
        {
            "code": "4143",
            "localite": "Dornach"
        },
        {
            "code": "4144",
            "localite": "Arlesheim"
        },
        {
            "code": "4145",
            "localite": "Gempen"
        },
        {
            "code": "4146",
            "localite": "Hochwald"
        },
        {
            "code": "4147",
            "localite": "Aesch BL"
        },
        {
            "code": "4148",
            "localite": "Pfeffingen"
        },
        {
            "code": "4153",
            "localite": "Reinach BL"
        },
        {
            "code": "4202",
            "localite": "Duggingen"
        },
        {
            "code": "4203",
            "localite": "Grellingen"
        },
        {
            "code": "4204",
            "localite": "Himmelried"
        },
        {
            "code": "4206",
            "localite": "Seewen SO"
        },
        {
            "code": "4207",
            "localite": "Bretzwil"
        },
        {
            "code": "4208",
            "localite": "Nunningen"
        },
        {
            "code": "4222",
            "localite": "Zwingen"
        },
        {
            "code": "4223",
            "localite": "Blauen"
        },
        {
            "code": "4224",
            "localite": "Nenzlingen"
        },
        {
            "code": "4225",
            "localite": "Brislach"
        },
        {
            "code": "4226",
            "localite": "Breitenbach"
        },
        {
            "code": "4227",
            "localite": "Büsserach"
        },
        {
            "code": "4228",
            "localite": "Erschwil"
        },
        {
            "code": "4229",
            "localite": "Beinwil SO"
        },
        {
            "code": "4232",
            "localite": "Fehren"
        },
        {
            "code": "4233",
            "localite": "Meltingen"
        },
        {
            "code": "4234",
            "localite": "Zullwil"
        },
        {
            "code": "4242",
            "localite": "Laufen"
        },
        {
            "code": "4243",
            "localite": "Dittingen"
        },
        {
            "code": "4244",
            "localite": "Röschenz"
        },
        {
            "code": "4245",
            "localite": "Kleinlützel"
        },
        {
            "code": "4246",
            "localite": "Wahlen b. Laufen"
        },
        {
            "code": "4247",
            "localite": "Grindel"
        },
        {
            "code": "4252",
            "localite": "Bärschwil"
        },
        {
            "code": "4253",
            "localite": "Liesberg"
        },
        {
            "code": "4254",
            "localite": "Liesberg Dorf"
        },
        {
            "code": "4302",
            "localite": "Augst BL"
        },
        {
            "code": "4303",
            "localite": "Kaiseraugst"
        },
        {
            "code": "4304",
            "localite": "Giebenach"
        },
        {
            "code": "4305",
            "localite": "Olsberg"
        },
        {
            "code": "4310",
            "localite": "Rheinfelden"
        },
        {
            "code": "4312",
            "localite": "Magden"
        },
        {
            "code": "4313",
            "localite": "Möhlin"
        },
        {
            "code": "4314",
            "localite": "Zeiningen"
        },
        {
            "code": "4315",
            "localite": "Zuzgen"
        },
        {
            "code": "4316",
            "localite": "Hellikon"
        },
        {
            "code": "4317",
            "localite": "Wegenstetten"
        },
        {
            "code": "4322",
            "localite": "Mumpf"
        },
        {
            "code": "4323",
            "localite": "Wallbach"
        },
        {
            "code": "4324",
            "localite": "Obermumpf"
        },
        {
            "code": "4325",
            "localite": "Schupfart"
        },
        {
            "code": "4332",
            "localite": "Stein AG"
        },
        {
            "code": "4333",
            "localite": "Münchwilen AG"
        },
        {
            "code": "4334",
            "localite": "Sisseln AG"
        },
        {
            "code": "4402",
            "localite": "Frenkendorf"
        },
        {
            "code": "4410",
            "localite": "Liestal"
        },
        {
            "code": "4411",
            "localite": "Seltisberg"
        },
        {
            "code": "4412",
            "localite": "Nuglar"
        },
        {
            "code": "4413",
            "localite": "Büren SO"
        },
        {
            "code": "4414",
            "localite": "Füllinsdorf"
        },
        {
            "code": "4415",
            "localite": "Lausen"
        },
        {
            "code": "4416",
            "localite": "Bubendorf"
        },
        {
            "code": "4417",
            "localite": "Ziefen"
        },
        {
            "code": "4418",
            "localite": "Reigoldswil"
        },
        {
            "code": "4419",
            "localite": "Lupsingen"
        },
        {
            "code": "4421",
            "localite": "St. Pantaleon"
        },
        {
            "code": "4422",
            "localite": "Arisdorf"
        },
        {
            "code": "4423",
            "localite": "Hersberg"
        },
        {
            "code": "4424",
            "localite": "Arboldswil"
        },
        {
            "code": "4425",
            "localite": "Titterten"
        },
        {
            "code": "4426",
            "localite": "Lauwil"
        },
        {
            "code": "4431",
            "localite": "Bennwil"
        },
        {
            "code": "4432",
            "localite": "Lampenberg"
        },
        {
            "code": "4433",
            "localite": "Ramlinsburg"
        },
        {
            "code": "4434",
            "localite": "Hölstein"
        },
        {
            "code": "4435",
            "localite": "Niederdorf"
        },
        {
            "code": "4436",
            "localite": "Liedertswil"
        },
        {
            "code": "4436",
            "localite": "Oberdorf BL"
        },
        {
            "code": "4437",
            "localite": "Waldenburg"
        },
        {
            "code": "4438",
            "localite": "Langenbruck"
        },
        {
            "code": "4441",
            "localite": "Thürnen"
        },
        {
            "code": "4442",
            "localite": "Diepflingen"
        },
        {
            "code": "4443",
            "localite": "Wittinsburg"
        },
        {
            "code": "4444",
            "localite": "Rümlingen"
        },
        {
            "code": "4445",
            "localite": "Häfelfingen"
        },
        {
            "code": "4446",
            "localite": "Buckten"
        },
        {
            "code": "4447",
            "localite": "Känerkinden"
        },
        {
            "code": "4448",
            "localite": "Läufelfingen"
        },
        {
            "code": "4450",
            "localite": "Sissach"
        },
        {
            "code": "4451",
            "localite": "Wintersingen"
        },
        {
            "code": "4452",
            "localite": "Itingen"
        },
        {
            "code": "4453",
            "localite": "Nusshof"
        },
        {
            "code": "4455",
            "localite": "Zunzgen"
        },
        {
            "code": "4456",
            "localite": "Tenniken"
        },
        {
            "code": "4457",
            "localite": "Diegten"
        },
        {
            "code": "4458",
            "localite": "Eptingen"
        },
        {
            "code": "4460",
            "localite": "Gelterkinden"
        },
        {
            "code": "4461",
            "localite": "Böckten"
        },
        {
            "code": "4462",
            "localite": "Rickenbach BL"
        },
        {
            "code": "4463",
            "localite": "Buus"
        },
        {
            "code": "4464",
            "localite": "Maisprach"
        },
        {
            "code": "4465",
            "localite": "Hemmiken"
        },
        {
            "code": "4466",
            "localite": "Ormalingen"
        },
        {
            "code": "4467",
            "localite": "Rothenfluh"
        },
        {
            "code": "4468",
            "localite": "Kienberg"
        },
        {
            "code": "4469",
            "localite": "Anwil"
        },
        {
            "code": "4492",
            "localite": "Tecknau"
        },
        {
            "code": "4493",
            "localite": "Wenslingen"
        },
        {
            "code": "4494",
            "localite": "Oltingen"
        },
        {
            "code": "4495",
            "localite": "Zeglingen"
        },
        {
            "code": "4496",
            "localite": "Kilchberg BL"
        },
        {
            "code": "4497",
            "localite": "Rünenberg"
        },
        {
            "code": "4500",
            "localite": "Solothurn"
        },
        {
            "code": "4512",
            "localite": "Bellach"
        },
        {
            "code": "4513",
            "localite": "Langendorf"
        },
        {
            "code": "4514",
            "localite": "Lommiswil"
        },
        {
            "code": "4515",
            "localite": "Oberdorf SO"
        },
        {
            "code": "4515",
            "localite": "Weissenstein b. Solothurn"
        },
        {
            "code": "4522",
            "localite": "Rüttenen"
        },
        {
            "code": "4523",
            "localite": "Niederwil SO"
        },
        {
            "code": "4524",
            "localite": "Balmberg"
        },
        {
            "code": "4524",
            "localite": "Günsberg"
        },
        {
            "code": "4524",
            "localite": "Oberbalmberg"
        },
        {
            "code": "4525",
            "localite": "Balm b. Günsberg"
        },
        {
            "code": "4528",
            "localite": "Zuchwil"
        },
        {
            "code": "4532",
            "localite": "Feldbrunnen"
        },
        {
            "code": "4533",
            "localite": "Riedholz"
        },
        {
            "code": "4534",
            "localite": "Flumenthal"
        },
        {
            "code": "4535",
            "localite": "Hubersdorf"
        },
        {
            "code": "4535",
            "localite": "Kammersrohr"
        },
        {
            "code": "4536",
            "localite": "Attiswil"
        },
        {
            "code": "4537",
            "localite": "Wiedlisbach"
        },
        {
            "code": "4538",
            "localite": "Oberbipp"
        },
        {
            "code": "4539",
            "localite": "Farnern"
        },
        {
            "code": "4539",
            "localite": "Rumisberg"
        },
        {
            "code": "4542",
            "localite": "Luterbach"
        },
        {
            "code": "4543",
            "localite": "Deitingen"
        },
        {
            "code": "4552",
            "localite": "Derendingen"
        },
        {
            "code": "4553",
            "localite": "Subingen"
        },
        {
            "code": "4554",
            "localite": "Etziken"
        },
        {
            "code": "4554",
            "localite": "Hüniken"
        },
        {
            "code": "4556",
            "localite": "Aeschi SO"
        },
        {
            "code": "4556",
            "localite": "Bolken"
        },
        {
            "code": "4556",
            "localite": "Burgäschi"
        },
        {
            "code": "4556",
            "localite": "Steinhof SO"
        },
        {
            "code": "4557",
            "localite": "Horriwil"
        },
        {
            "code": "4558",
            "localite": "Heinrichswil"
        },
        {
            "code": "4558",
            "localite": "Hersiwil"
        },
        {
            "code": "4558",
            "localite": "Winistorf"
        },
        {
            "code": "4562",
            "localite": "Biberist"
        },
        {
            "code": "4563",
            "localite": "Gerlafingen"
        },
        {
            "code": "4564",
            "localite": "Obergerlafingen"
        },
        {
            "code": "4564",
            "localite": "Zielebach"
        },
        {
            "code": "4565",
            "localite": "Recherswil"
        },
        {
            "code": "4566",
            "localite": "Halten"
        },
        {
            "code": "4566",
            "localite": "Kriegstetten"
        },
        {
            "code": "4566",
            "localite": "Oekingen"
        },
        {
            "code": "4571",
            "localite": "Ichertswil"
        },
        {
            "code": "4571",
            "localite": "Lüterkofen"
        },
        {
            "code": "4573",
            "localite": "Lohn-Ammannsegg"
        },
        {
            "code": "4574",
            "localite": "Lüsslingen"
        },
        {
            "code": "4574",
            "localite": "Nennigkofen"
        },
        {
            "code": "4576",
            "localite": "Tscheppach"
        },
        {
            "code": "4577",
            "localite": "Hessigkofen"
        },
        {
            "code": "4578",
            "localite": "Bibern SO"
        },
        {
            "code": "4579",
            "localite": "Gossliwil"
        },
        {
            "code": "4581",
            "localite": "Küttigkofen"
        },
        {
            "code": "4582",
            "localite": "Brügglen"
        },
        {
            "code": "4583",
            "localite": "Aetigkofen"
        },
        {
            "code": "4583",
            "localite": "Mühledorf SO"
        },
        {
            "code": "4584",
            "localite": "Gächliwil"
        },
        {
            "code": "4584",
            "localite": "Lüterswil"
        },
        {
            "code": "4585",
            "localite": "Biezwil"
        },
        {
            "code": "4586",
            "localite": "Kyburg-Buchegg"
        },
        {
            "code": "4587",
            "localite": "Aetingen"
        },
        {
            "code": "4588",
            "localite": "Brittern"
        },
        {
            "code": "4588",
            "localite": "Oberramsern"
        },
        {
            "code": "4588",
            "localite": "Unterramsern"
        },
        {
            "code": "4600",
            "localite": "Olten"
        },
        {
            "code": "4612",
            "localite": "Wangen b. Olten"
        },
        {
            "code": "4613",
            "localite": "Rickenbach SO"
        },
        {
            "code": "4614",
            "localite": "Hägendorf"
        },
        {
            "code": "4615",
            "localite": "Allerheiligenberg"
        },
        {
            "code": "4616",
            "localite": "Kappel SO"
        },
        {
            "code": "4617",
            "localite": "Gunzgen"
        },
        {
            "code": "4618",
            "localite": "Boningen"
        },
        {
            "code": "4622",
            "localite": "Egerkingen"
        },
        {
            "code": "4623",
            "localite": "Neuendorf"
        },
        {
            "code": "4624",
            "localite": "Härkingen"
        },
        {
            "code": "4625",
            "localite": "Oberbuchsiten"
        },
        {
            "code": "4626",
            "localite": "Niederbuchsiten"
        },
        {
            "code": "4628",
            "localite": "Wolfwil"
        },
        {
            "code": "4629",
            "localite": "Fulenbach"
        },
        {
            "code": "4632",
            "localite": "Trimbach"
        },
        {
            "code": "4633",
            "localite": "Hauenstein"
        },
        {
            "code": "4634",
            "localite": "Wisen SO"
        },
        {
            "code": "4652",
            "localite": "Winznau"
        },
        {
            "code": "4653",
            "localite": "Obergösgen"
        },
        {
            "code": "4654",
            "localite": "Lostorf"
        },
        {
            "code": "4655",
            "localite": "Rohr b. Olten"
        },
        {
            "code": "4655",
            "localite": "Stüsslingen"
        },
        {
            "code": "4656",
            "localite": "Starrkirch-Wil"
        },
        {
            "code": "4657",
            "localite": "Dulliken"
        },
        {
            "code": "4658",
            "localite": "Däniken SO"
        },
        {
            "code": "4663",
            "localite": "Aarburg"
        },
        {
            "code": "4665",
            "localite": "Oftringen"
        },
        {
            "code": "4702",
            "localite": "Oensingen"
        },
        {
            "code": "4703",
            "localite": "Kestenholz"
        },
        {
            "code": "4704",
            "localite": "Niederbipp"
        },
        {
            "code": "4704",
            "localite": "Wolfisberg"
        },
        {
            "code": "4710",
            "localite": "Balsthal"
        },
        {
            "code": "4712",
            "localite": "Laupersdorf"
        },
        {
            "code": "4713",
            "localite": "Matzendorf"
        },
        {
            "code": "4714",
            "localite": "Aedermannsdorf"
        },
        {
            "code": "4715",
            "localite": "Herbetswil"
        },
        {
            "code": "4716",
            "localite": "Gänsbrunnen"
        },
        {
            "code": "4716",
            "localite": "Welschenrohr"
        },
        {
            "code": "4717",
            "localite": "Mümliswil"
        },
        {
            "code": "4718",
            "localite": "Holderbank SO"
        },
        {
            "code": "4719",
            "localite": "Ramiswil"
        },
        {
            "code": "4800",
            "localite": "Zofingen"
        },
        {
            "code": "4802",
            "localite": "Strengelbach"
        },
        {
            "code": "4803",
            "localite": "Vordemwald"
        },
        {
            "code": "4805",
            "localite": "Brittnau"
        },
        {
            "code": "4806",
            "localite": "Wikon"
        },
        {
            "code": "4812",
            "localite": "Mühlethal"
        },
        {
            "code": "4813",
            "localite": "Uerkheim"
        },
        {
            "code": "4814",
            "localite": "Bottenwil"
        },
        {
            "code": "4852",
            "localite": "Rothrist"
        },
        {
            "code": "4853",
            "localite": "Murgenthal"
        },
        {
            "code": "4853",
            "localite": "Riken AG"
        },
        {
            "code": "4856",
            "localite": "Glashütten"
        },
        {
            "code": "4900",
            "localite": "Langenthal"
        },
        {
            "code": "4911",
            "localite": "Schwarzhäusern"
        },
        {
            "code": "4912",
            "localite": "Aarwangen"
        },
        {
            "code": "4913",
            "localite": "Bannwil"
        },
        {
            "code": "4914",
            "localite": "Roggwil BE"
        },
        {
            "code": "4915",
            "localite": "St. Urban"
        },
        {
            "code": "4916",
            "localite": "Untersteckholz"
        },
        {
            "code": "4917",
            "localite": "Busswil b. Melchnau"
        },
        {
            "code": "4917",
            "localite": "Melchnau"
        },
        {
            "code": "4919",
            "localite": "Reisiswil"
        },
        {
            "code": "4922",
            "localite": "Bützberg"
        },
        {
            "code": "4922",
            "localite": "Thunstetten"
        },
        {
            "code": "4923",
            "localite": "Wynau"
        },
        {
            "code": "4924",
            "localite": "Obersteckholz"
        },
        {
            "code": "4932",
            "localite": "Gutenburg"
        },
        {
            "code": "4932",
            "localite": "Lotzwil"
        },
        {
            "code": "4933",
            "localite": "Rütschelen"
        },
        {
            "code": "4934",
            "localite": "Madiswil"
        },
        {
            "code": "4935",
            "localite": "Leimiswil"
        },
        {
            "code": "4936",
            "localite": "Kleindietwil"
        },
        {
            "code": "4937",
            "localite": "Ursenbach"
        },
        {
            "code": "4938",
            "localite": "Rohrbach"
        },
        {
            "code": "4938",
            "localite": "Rohrbachgraben"
        },
        {
            "code": "4942",
            "localite": "Walterswil BE"
        },
        {
            "code": "4943",
            "localite": "Oeschenbach"
        },
        {
            "code": "4944",
            "localite": "Auswil"
        },
        {
            "code": "4950",
            "localite": "Huttwil"
        },
        {
            "code": "4952",
            "localite": "Eriswil"
        },
        {
            "code": "4953",
            "localite": "Schwarzenbach (Huttwil)"
        },
        {
            "code": "4954",
            "localite": "Wyssachen"
        },
        {
            "code": "4955",
            "localite": "Gondiswil"
        },
        {
            "code": "5000",
            "localite": "Aarau"
        },
        {
            "code": "5004",
            "localite": "Aarau"
        },
        {
            "code": "5012",
            "localite": "Eppenberg"
        },
        {
            "code": "5012",
            "localite": "Schönenwerd"
        },
        {
            "code": "5012",
            "localite": "Wöschnau"
        },
        {
            "code": "5013",
            "localite": "Niedergösgen"
        },
        {
            "code": "5014",
            "localite": "Gretzenbach"
        },
        {
            "code": "5015",
            "localite": "Erlinsbach SO"
        },
        {
            "code": "5017",
            "localite": "Barmelweid"
        },
        {
            "code": "5018",
            "localite": "Erlinsbach"
        },
        {
            "code": "5022",
            "localite": "Rombach"
        },
        {
            "code": "5023",
            "localite": "Biberstein"
        },
        {
            "code": "5024",
            "localite": "Küttigen"
        },
        {
            "code": "5025",
            "localite": "Asp"
        },
        {
            "code": "5026",
            "localite": "Densbüren"
        },
        {
            "code": "5027",
            "localite": "Herznach"
        },
        {
            "code": "5028",
            "localite": "Ueken"
        },
        {
            "code": "5032",
            "localite": "Aarau Rohr"
        },
        {
            "code": "5033",
            "localite": "Buchs AG"
        },
        {
            "code": "5034",
            "localite": "Suhr"
        },
        {
            "code": "5035",
            "localite": "Unterentfelden"
        },
        {
            "code": "5036",
            "localite": "Oberentfelden"
        },
        {
            "code": "5037",
            "localite": "Muhen"
        },
        {
            "code": "5040",
            "localite": "Schöftland"
        },
        {
            "code": "5042",
            "localite": "Hirschthal"
        },
        {
            "code": "5043",
            "localite": "Holziken"
        },
        {
            "code": "5044",
            "localite": "Schlossrued"
        },
        {
            "code": "5046",
            "localite": "Schmiedrued"
        },
        {
            "code": "5046",
            "localite": "Walde AG"
        },
        {
            "code": "5053",
            "localite": "Staffelbach"
        },
        {
            "code": "5053",
            "localite": "Wittwil"
        },
        {
            "code": "5054",
            "localite": "Kirchleerau"
        },
        {
            "code": "5054",
            "localite": "Moosleerau"
        },
        {
            "code": "5056",
            "localite": "Attelwil"
        },
        {
            "code": "5057",
            "localite": "Reitnau"
        },
        {
            "code": "5058",
            "localite": "Wiliberg"
        },
        {
            "code": "5062",
            "localite": "Oberhof"
        },
        {
            "code": "5063",
            "localite": "Wölflinswil"
        },
        {
            "code": "5064",
            "localite": "Wittnau"
        },
        {
            "code": "5070",
            "localite": "Frick"
        },
        {
            "code": "5072",
            "localite": "Oeschgen"
        },
        {
            "code": "5073",
            "localite": "Gipf-Oberfrick"
        },
        {
            "code": "5074",
            "localite": "Eiken"
        },
        {
            "code": "5075",
            "localite": "Hornussen"
        },
        {
            "code": "5076",
            "localite": "Bözen"
        },
        {
            "code": "5077",
            "localite": "Elfingen"
        },
        {
            "code": "5078",
            "localite": "Effingen"
        },
        {
            "code": "5079",
            "localite": "Zeihen"
        },
        {
            "code": "5080",
            "localite": "Laufenburg"
        },
        {
            "code": "5082",
            "localite": "Kaisten"
        },
        {
            "code": "5083",
            "localite": "Ittenthal"
        },
        {
            "code": "5084",
            "localite": "Rheinsulz"
        },
        {
            "code": "5085",
            "localite": "Sulz AG"
        },
        {
            "code": "5102",
            "localite": "Rupperswil"
        },
        {
            "code": "5103",
            "localite": "Möriken AG"
        },
        {
            "code": "5103",
            "localite": "Wildegg"
        },
        {
            "code": "5105",
            "localite": "Auenstein"
        },
        {
            "code": "5106",
            "localite": "Veltheim AG"
        },
        {
            "code": "5107",
            "localite": "Schinznach Dorf"
        },
        {
            "code": "5108",
            "localite": "Oberflachs"
        },
        {
            "code": "5112",
            "localite": "Thalheim AG"
        },
        {
            "code": "5113",
            "localite": "Holderbank AG"
        },
        {
            "code": "5116",
            "localite": "Schinznach Bad"
        },
        {
            "code": "5200",
            "localite": "Brugg AG"
        },
        {
            "code": "5210",
            "localite": "Windisch"
        },
        {
            "code": "5212",
            "localite": "Hausen AG"
        },
        {
            "code": "5213",
            "localite": "Villnachern"
        },
        {
            "code": "5222",
            "localite": "Umiken"
        },
        {
            "code": "5223",
            "localite": "Riniken"
        },
        {
            "code": "5225",
            "localite": "Bözberg"
        },
        {
            "code": "5233",
            "localite": "Stilli"
        },
        {
            "code": "5234",
            "localite": "Villigen"
        },
        {
            "code": "5235",
            "localite": "Rüfenach AG"
        },
        {
            "code": "5236",
            "localite": "Remigen"
        },
        {
            "code": "5237",
            "localite": "Mönthal"
        },
        {
            "code": "5242",
            "localite": "Birr"
        },
        {
            "code": "5242",
            "localite": "Lupfig"
        },
        {
            "code": "5243",
            "localite": "Mülligen"
        },
        {
            "code": "5244",
            "localite": "Birrhard"
        },
        {
            "code": "5245",
            "localite": "Habsburg"
        },
        {
            "code": "5246",
            "localite": "Scherz"
        },
        {
            "code": "5272",
            "localite": "Gansingen"
        },
        {
            "code": "5273",
            "localite": "Oberhofen AG"
        },
        {
            "code": "5274",
            "localite": "Mettau"
        },
        {
            "code": "5275",
            "localite": "Etzgen"
        },
        {
            "code": "5276",
            "localite": "Wil AG"
        },
        {
            "code": "5277",
            "localite": "Hottwil"
        },
        {
            "code": "5300",
            "localite": "Turgi"
        },
        {
            "code": "5301",
            "localite": "Siggenthal Station"
        },
        {
            "code": "5303",
            "localite": "Würenlingen"
        },
        {
            "code": "5304",
            "localite": "Endingen"
        },
        {
            "code": "5305",
            "localite": "Unterendingen"
        },
        {
            "code": "5306",
            "localite": "Tegerfelden"
        },
        {
            "code": "5312",
            "localite": "Döttingen"
        },
        {
            "code": "5313",
            "localite": "Klingnau"
        },
        {
            "code": "5314",
            "localite": "Kleindöttingen"
        },
        {
            "code": "5315",
            "localite": "Böttstein"
        },
        {
            "code": "5316",
            "localite": "Leuggern"
        },
        {
            "code": "5317",
            "localite": "Hettenschwil"
        },
        {
            "code": "5318",
            "localite": "Mandach"
        },
        {
            "code": "5322",
            "localite": "Koblenz"
        },
        {
            "code": "5323",
            "localite": "Rietheim"
        },
        {
            "code": "5324",
            "localite": "Full-Reuenthal"
        },
        {
            "code": "5325",
            "localite": "Leibstadt"
        },
        {
            "code": "5326",
            "localite": "Schwaderloch"
        },
        {
            "code": "5330",
            "localite": "Bad Zurzach"
        },
        {
            "code": "5332",
            "localite": "Rekingen AG"
        },
        {
            "code": "5333",
            "localite": "Baldingen"
        },
        {
            "code": "5334",
            "localite": "Böbikon"
        },
        {
            "code": "5400",
            "localite": "Baden"
        },
        {
            "code": "5404",
            "localite": "Baden"
        },
        {
            "code": "5405",
            "localite": "Dättwil AG"
        },
        {
            "code": "5406",
            "localite": "Rütihof"
        },
        {
            "code": "5408",
            "localite": "Ennetbaden"
        },
        {
            "code": "5412",
            "localite": "Gebenstorf"
        },
        {
            "code": "5412",
            "localite": "Vogelsang AG"
        },
        {
            "code": "5413",
            "localite": "Birmenstorf AG"
        },
        {
            "code": "5415",
            "localite": "Hertenstein AG"
        },
        {
            "code": "5415",
            "localite": "Nussbaumen AG"
        },
        {
            "code": "5415",
            "localite": "Rieden AG"
        },
        {
            "code": "5416",
            "localite": "Kirchdorf AG"
        },
        {
            "code": "5417",
            "localite": "Untersiggenthal"
        },
        {
            "code": "5420",
            "localite": "Ehrendingen"
        },
        {
            "code": "5423",
            "localite": "Freienwil"
        },
        {
            "code": "5425",
            "localite": "Schneisingen"
        },
        {
            "code": "5426",
            "localite": "Lengnau AG"
        },
        {
            "code": "5430",
            "localite": "Wettingen"
        },
        {
            "code": "5432",
            "localite": "Neuenhof"
        },
        {
            "code": "5436",
            "localite": "Würenlos"
        },
        {
            "code": "5442",
            "localite": "Fislisbach"
        },
        {
            "code": "5443",
            "localite": "Niederrohrdorf"
        },
        {
            "code": "5444",
            "localite": "Künten"
        },
        {
            "code": "5445",
            "localite": "Eggenwil"
        },
        {
            "code": "5452",
            "localite": "Oberrohrdorf"
        },
        {
            "code": "5453",
            "localite": "Remetschwil"
        },
        {
            "code": "5454",
            "localite": "Bellikon"
        },
        {
            "code": "5462",
            "localite": "Siglistorf"
        },
        {
            "code": "5463",
            "localite": "Wislikofen"
        },
        {
            "code": "5464",
            "localite": "Rümikon AG"
        },
        {
            "code": "5465",
            "localite": "Mellikon"
        },
        {
            "code": "5466",
            "localite": "Kaiserstuhl AG"
        },
        {
            "code": "5467",
            "localite": "Fisibach"
        },
        {
            "code": "5502",
            "localite": "Hunzenschwil"
        },
        {
            "code": "5503",
            "localite": "Schafisheim"
        },
        {
            "code": "5504",
            "localite": "Othmarsingen"
        },
        {
            "code": "5505",
            "localite": "Brunegg"
        },
        {
            "code": "5506",
            "localite": "Mägenwil"
        },
        {
            "code": "5507",
            "localite": "Mellingen"
        },
        {
            "code": "5512",
            "localite": "Wohlenschwil"
        },
        {
            "code": "5522",
            "localite": "Tägerig"
        },
        {
            "code": "5524",
            "localite": "Nesselnbach"
        },
        {
            "code": "5524",
            "localite": "Niederwil AG"
        },
        {
            "code": "5525",
            "localite": "Fischbach-Göslikon"
        },
        {
            "code": "5600",
            "localite": "Ammerswil AG"
        },
        {
            "code": "5600",
            "localite": "Lenzburg"
        },
        {
            "code": "5603",
            "localite": "Staufen"
        },
        {
            "code": "5604",
            "localite": "Hendschiken"
        },
        {
            "code": "5605",
            "localite": "Dottikon"
        },
        {
            "code": "5606",
            "localite": "Dintikon"
        },
        {
            "code": "5607",
            "localite": "Hägglingen"
        },
        {
            "code": "5608",
            "localite": "Stetten AG"
        },
        {
            "code": "5610",
            "localite": "Wohlen AG"
        },
        {
            "code": "5611",
            "localite": "Anglikon"
        },
        {
            "code": "5612",
            "localite": "Villmergen"
        },
        {
            "code": "5613",
            "localite": "Hilfikon"
        },
        {
            "code": "5614",
            "localite": "Sarmenstorf"
        },
        {
            "code": "5615",
            "localite": "Fahrwangen"
        },
        {
            "code": "5616",
            "localite": "Meisterschwanden"
        },
        {
            "code": "5617",
            "localite": "Tennwil"
        },
        {
            "code": "5618",
            "localite": "Bettwil"
        },
        {
            "code": "5619",
            "localite": "Büttikon AG"
        },
        {
            "code": "5619",
            "localite": "Uezwil"
        },
        {
            "code": "5620",
            "localite": "Bremgarten AG"
        },
        {
            "code": "5621",
            "localite": "Zufikon"
        },
        {
            "code": "5622",
            "localite": "Waltenschwil"
        },
        {
            "code": "5623",
            "localite": "Boswil"
        },
        {
            "code": "5624",
            "localite": "Bünzen"
        },
        {
            "code": "5624",
            "localite": "Waldhäusern AG"
        },
        {
            "code": "5625",
            "localite": "Kallern"
        },
        {
            "code": "5626",
            "localite": "Hermetschwil-Staffeln"
        },
        {
            "code": "5627",
            "localite": "Besenbüren"
        },
        {
            "code": "5628",
            "localite": "Aristau"
        },
        {
            "code": "5630",
            "localite": "Muri AG"
        },
        {
            "code": "5632",
            "localite": "Buttwil"
        },
        {
            "code": "5634",
            "localite": "Merenschwand"
        },
        {
            "code": "5636",
            "localite": "Benzenschwil"
        },
        {
            "code": "5637",
            "localite": "Beinwil (Freiamt)"
        },
        {
            "code": "5637",
            "localite": "Geltwil"
        },
        {
            "code": "5642",
            "localite": "Mühlau"
        },
        {
            "code": "5643",
            "localite": "Alikon"
        },
        {
            "code": "5643",
            "localite": "Meienberg"
        },
        {
            "code": "5643",
            "localite": "Sins"
        },
        {
            "code": "5644",
            "localite": "Auw"
        },
        {
            "code": "5645",
            "localite": "Aettenschwil"
        },
        {
            "code": "5645",
            "localite": "Fenkrieden"
        },
        {
            "code": "5646",
            "localite": "Abtwil AG"
        },
        {
            "code": "5647",
            "localite": "Oberrüti"
        },
        {
            "code": "5702",
            "localite": "Niederlenz"
        },
        {
            "code": "5703",
            "localite": "Seon"
        },
        {
            "code": "5704",
            "localite": "Egliswil"
        },
        {
            "code": "5705",
            "localite": "Hallwil"
        },
        {
            "code": "5706",
            "localite": "Boniswil"
        },
        {
            "code": "5707",
            "localite": "Seengen"
        },
        {
            "code": "5708",
            "localite": "Birrwil"
        },
        {
            "code": "5712",
            "localite": "Beinwil am See"
        },
        {
            "code": "5722",
            "localite": "Gränichen"
        },
        {
            "code": "5723",
            "localite": "Teufenthal AG"
        },
        {
            "code": "5724",
            "localite": "Dürrenäsch"
        },
        {
            "code": "5725",
            "localite": "Leutwil"
        },
        {
            "code": "5726",
            "localite": "Unterkulm"
        },
        {
            "code": "5727",
            "localite": "Oberkulm"
        },
        {
            "code": "5728",
            "localite": "Gontenschwil"
        },
        {
            "code": "5732",
            "localite": "Zetzwil"
        },
        {
            "code": "5733",
            "localite": "Leimbach AG"
        },
        {
            "code": "5734",
            "localite": "Reinach AG"
        },
        {
            "code": "5735",
            "localite": "Pfeffikon LU"
        },
        {
            "code": "5736",
            "localite": "Burg AG"
        },
        {
            "code": "5737",
            "localite": "Menziken"
        },
        {
            "code": "5742",
            "localite": "Kölliken"
        },
        {
            "code": "5745",
            "localite": "Safenwil"
        },
        {
            "code": "5746",
            "localite": "Walterswil SO"
        },
        {
            "code": "6003",
            "localite": "Luzern"
        },
        {
            "code": "6004",
            "localite": "Luzern"
        },
        {
            "code": "6005",
            "localite": "Luzern"
        },
        {
            "code": "6005",
            "localite": "St. Niklausen LU"
        },
        {
            "code": "6006",
            "localite": "Luzern"
        },
        {
            "code": "6010",
            "localite": "Kriens"
        },
        {
            "code": "6010",
            "localite": "Pilatus Kulm"
        },
        {
            "code": "6012",
            "localite": "Obernau"
        },
        {
            "code": "6013",
            "localite": "Eigenthal"
        },
        {
            "code": "6014",
            "localite": "Luzern"
        },
        {
            "code": "6015",
            "localite": "Luzern"
        },
        {
            "code": "6016",
            "localite": "Hellbühl"
        },
        {
            "code": "6017",
            "localite": "Ruswil"
        },
        {
            "code": "6018",
            "localite": "Buttisholz"
        },
        {
            "code": "6019",
            "localite": "Sigigen"
        },
        {
            "code": "6020",
            "localite": "Emmenbrücke"
        },
        {
            "code": "6022",
            "localite": "Grosswangen"
        },
        {
            "code": "6023",
            "localite": "Rothenburg"
        },
        {
            "code": "6024",
            "localite": "Hildisrieden"
        },
        {
            "code": "6025",
            "localite": "Neudorf"
        },
        {
            "code": "6026",
            "localite": "Rain"
        },
        {
            "code": "6027",
            "localite": "Römerswil LU"
        },
        {
            "code": "6028",
            "localite": "Herlisberg"
        },
        {
            "code": "6030",
            "localite": "Ebikon"
        },
        {
            "code": "6032",
            "localite": "Emmen"
        },
        {
            "code": "6033",
            "localite": "Buchrain"
        },
        {
            "code": "6034",
            "localite": "Inwil"
        },
        {
            "code": "6035",
            "localite": "Perlen"
        },
        {
            "code": "6036",
            "localite": "Dierikon"
        },
        {
            "code": "6037",
            "localite": "Root"
        },
        {
            "code": "6038",
            "localite": "Gisikon"
        },
        {
            "code": "6038",
            "localite": "Honau"
        },
        {
            "code": "6039",
            "localite": "Root D4"
        },
        {
            "code": "6042",
            "localite": "Dietwil"
        },
        {
            "code": "6043",
            "localite": "Adligenswil"
        },
        {
            "code": "6044",
            "localite": "Udligenswil"
        },
        {
            "code": "6045",
            "localite": "Meggen"
        },
        {
            "code": "6047",
            "localite": "Kastanienbaum"
        },
        {
            "code": "6048",
            "localite": "Horw"
        },
        {
            "code": "6052",
            "localite": "Hergiswil NW"
        },
        {
            "code": "6053",
            "localite": "Alpnachstad"
        },
        {
            "code": "6055",
            "localite": "Alpnach Dorf"
        },
        {
            "code": "6056",
            "localite": "Kägiswil"
        },
        {
            "code": "6060",
            "localite": "Ramersberg"
        },
        {
            "code": "6060",
            "localite": "Sarnen"
        },
        {
            "code": "6062",
            "localite": "Wilen (Sarnen)"
        },
        {
            "code": "6063",
            "localite": "Stalden (Sarnen)"
        },
        {
            "code": "6064",
            "localite": "Kerns"
        },
        {
            "code": "6066",
            "localite": "St. Niklausen OW"
        },
        {
            "code": "6067",
            "localite": "Melchtal"
        },
        {
            "code": "6068",
            "localite": "Melchsee-Frutt"
        },
        {
            "code": "6072",
            "localite": "Sachseln"
        },
        {
            "code": "6073",
            "localite": "Flüeli-Ranft"
        },
        {
            "code": "6074",
            "localite": "Giswil"
        },
        {
            "code": "6078",
            "localite": "Bürglen OW"
        },
        {
            "code": "6078",
            "localite": "Lungern"
        },
        {
            "code": "6083",
            "localite": "Hasliberg Hohfluh"
        },
        {
            "code": "6084",
            "localite": "Hasliberg Wasserwendi"
        },
        {
            "code": "6085",
            "localite": "Hasliberg Goldern"
        },
        {
            "code": "6086",
            "localite": "Hasliberg Reuti"
        },
        {
            "code": "6102",
            "localite": "Malters"
        },
        {
            "code": "6103",
            "localite": "Schwarzenberg LU"
        },
        {
            "code": "6105",
            "localite": "Schachen LU"
        },
        {
            "code": "6106",
            "localite": "Werthenstein"
        },
        {
            "code": "6110",
            "localite": "Fontannen b. Wolhusen"
        },
        {
            "code": "6110",
            "localite": "Wolhusen"
        },
        {
            "code": "6112",
            "localite": "Doppleschwand"
        },
        {
            "code": "6113",
            "localite": "Romoos"
        },
        {
            "code": "6114",
            "localite": "Steinhuserberg"
        },
        {
            "code": "6122",
            "localite": "Menznau"
        },
        {
            "code": "6123",
            "localite": "Geiss"
        },
        {
            "code": "6125",
            "localite": "Menzberg"
        },
        {
            "code": "6126",
            "localite": "Daiwil"
        },
        {
            "code": "6130",
            "localite": "Willisau"
        },
        {
            "code": "6132",
            "localite": "Rohrmatt"
        },
        {
            "code": "6133",
            "localite": "Hergiswil b. Willisau"
        },
        {
            "code": "6142",
            "localite": "Gettnau"
        },
        {
            "code": "6143",
            "localite": "Ohmstal"
        },
        {
            "code": "6144",
            "localite": "Zell LU"
        },
        {
            "code": "6145",
            "localite": "Fischbach LU"
        },
        {
            "code": "6146",
            "localite": "Grossdietwil"
        },
        {
            "code": "6147",
            "localite": "Altbüron"
        },
        {
            "code": "6152",
            "localite": "Hüswil"
        },
        {
            "code": "6153",
            "localite": "Ufhusen"
        },
        {
            "code": "6154",
            "localite": "Hofstatt"
        },
        {
            "code": "6156",
            "localite": "Luthern"
        },
        {
            "code": "6156",
            "localite": "Luthern Bad"
        },
        {
            "code": "6162",
            "localite": "Entlebuch"
        },
        {
            "code": "6162",
            "localite": "Finsterwald b. Entlebuch"
        },
        {
            "code": "6162",
            "localite": "Rengg"
        },
        {
            "code": "6163",
            "localite": "Ebnet"
        },
        {
            "code": "6166",
            "localite": "Hasle LU"
        },
        {
            "code": "6167",
            "localite": "Bramboden"
        },
        {
            "code": "6170",
            "localite": "Schüpfheim"
        },
        {
            "code": "6173",
            "localite": "Flühli LU"
        },
        {
            "code": "6174",
            "localite": "Sörenberg"
        },
        {
            "code": "6182",
            "localite": "Escholzmatt"
        },
        {
            "code": "6192",
            "localite": "Wiggen"
        },
        {
            "code": "6196",
            "localite": "Marbach LU"
        },
        {
            "code": "6197",
            "localite": "Schangnau"
        },
        {
            "code": "6203",
            "localite": "Sempach Station"
        },
        {
            "code": "6204",
            "localite": "Sempach"
        },
        {
            "code": "6205",
            "localite": "Eich"
        },
        {
            "code": "6206",
            "localite": "Neuenkirch"
        },
        {
            "code": "6207",
            "localite": "Nottwil"
        },
        {
            "code": "6208",
            "localite": "Oberkirch LU"
        },
        {
            "code": "6210",
            "localite": "Sursee"
        },
        {
            "code": "6211",
            "localite": "Buchs LU"
        },
        {
            "code": "6212",
            "localite": "Kaltbach"
        },
        {
            "code": "6212",
            "localite": "St. Erhard"
        },
        {
            "code": "6213",
            "localite": "Knutwil"
        },
        {
            "code": "6214",
            "localite": "Schenkon"
        },
        {
            "code": "6215",
            "localite": "Beromünster"
        },
        {
            "code": "6215",
            "localite": "Schwarzenbach LU"
        },
        {
            "code": "6216",
            "localite": "Mauensee"
        },
        {
            "code": "6217",
            "localite": "Kottwil"
        },
        {
            "code": "6218",
            "localite": "Ettiswil"
        },
        {
            "code": "6221",
            "localite": "Rickenbach LU"
        },
        {
            "code": "6222",
            "localite": "Gunzwil"
        },
        {
            "code": "6231",
            "localite": "Schlierbach"
        },
        {
            "code": "6232",
            "localite": "Geuensee"
        },
        {
            "code": "6233",
            "localite": "Büron"
        },
        {
            "code": "6234",
            "localite": "Kulmerau"
        },
        {
            "code": "6234",
            "localite": "Triengen"
        },
        {
            "code": "6235",
            "localite": "Winikon"
        },
        {
            "code": "6236",
            "localite": "Wilihof"
        },
        {
            "code": "6242",
            "localite": "Wauwil"
        },
        {
            "code": "6243",
            "localite": "Egolzwil"
        },
        {
            "code": "6244",
            "localite": "Nebikon"
        },
        {
            "code": "6245",
            "localite": "Ebersecken"
        },
        {
            "code": "6246",
            "localite": "Altishofen"
        },
        {
            "code": "6247",
            "localite": "Schötz"
        },
        {
            "code": "6248",
            "localite": "Alberswil"
        },
        {
            "code": "6252",
            "localite": "Dagmersellen"
        },
        {
            "code": "6253",
            "localite": "Uffikon"
        },
        {
            "code": "6260",
            "localite": "Hintermoos"
        },
        {
            "code": "6260",
            "localite": "Mehlsecken"
        },
        {
            "code": "6260",
            "localite": "Reiden"
        },
        {
            "code": "6260",
            "localite": "Reidermoos"
        },
        {
            "code": "6262",
            "localite": "Langnau b. Reiden"
        },
        {
            "code": "6263",
            "localite": "Richenthal"
        },
        {
            "code": "6264",
            "localite": "Pfaffnau"
        },
        {
            "code": "6265",
            "localite": "Roggliswil"
        },
        {
            "code": "6274",
            "localite": "Eschenbach LU"
        },
        {
            "code": "6275",
            "localite": "Ballwil"
        },
        {
            "code": "6276",
            "localite": "Hohenrain"
        },
        {
            "code": "6277",
            "localite": "Kleinwangen"
        },
        {
            "code": "6277",
            "localite": "Lieli LU"
        },
        {
            "code": "6280",
            "localite": "Hochdorf"
        },
        {
            "code": "6280",
            "localite": "Urswil"
        },
        {
            "code": "6283",
            "localite": "Baldegg"
        },
        {
            "code": "6284",
            "localite": "Gelfingen"
        },
        {
            "code": "6284",
            "localite": "Sulz LU"
        },
        {
            "code": "6285",
            "localite": "Hitzkirch"
        },
        {
            "code": "6285",
            "localite": "Retschwil"
        },
        {
            "code": "6286",
            "localite": "Altwis"
        },
        {
            "code": "6287",
            "localite": "Aesch LU"
        },
        {
            "code": "6288",
            "localite": "Schongau"
        },
        {
            "code": "6289",
            "localite": "Hämikon"
        },
        {
            "code": "6289",
            "localite": "Müswangen"
        },
        {
            "code": "6294",
            "localite": "Ermensee"
        },
        {
            "code": "6295",
            "localite": "Mosen"
        },
        {
            "code": "6300",
            "localite": "Zug"
        },
        {
            "code": "6300",
            "localite": "Zugerberg"
        },
        {
            "code": "6312",
            "localite": "Steinhausen"
        },
        {
            "code": "6313",
            "localite": "Edlibach"
        },
        {
            "code": "6313",
            "localite": "Finstersee"
        },
        {
            "code": "6313",
            "localite": "Menzingen"
        },
        {
            "code": "6314",
            "localite": "Neuägeri"
        },
        {
            "code": "6314",
            "localite": "Unterägeri"
        },
        {
            "code": "6315",
            "localite": "Alosen"
        },
        {
            "code": "6315",
            "localite": "Morgarten"
        },
        {
            "code": "6315",
            "localite": "Oberägeri"
        },
        {
            "code": "6317",
            "localite": "Oberwil b. Zug"
        },
        {
            "code": "6318",
            "localite": "Walchwil"
        },
        {
            "code": "6319",
            "localite": "Allenwinden"
        },
        {
            "code": "6330",
            "localite": "Cham"
        },
        {
            "code": "6331",
            "localite": "Hünenberg"
        },
        {
            "code": "6332",
            "localite": "Hagendorn"
        },
        {
            "code": "6333",
            "localite": "Hünenberg See"
        },
        {
            "code": "6340",
            "localite": "Baar"
        },
        {
            "code": "6340",
            "localite": "Sihlbrugg"
        },
        {
            "code": "6343",
            "localite": "Buonas"
        },
        {
            "code": "6343",
            "localite": "Holzhäusern ZG"
        },
        {
            "code": "6343",
            "localite": "Risch"
        },
        {
            "code": "6343",
            "localite": "Rotkreuz"
        },
        {
            "code": "6344",
            "localite": "Meierskappel"
        },
        {
            "code": "6345",
            "localite": "Neuheim"
        },
        {
            "code": "6353",
            "localite": "Weggis"
        },
        {
            "code": "6354",
            "localite": "Vitznau"
        },
        {
            "code": "6356",
            "localite": "Rigi Kaltbad"
        },
        {
            "code": "6362",
            "localite": "Stansstad"
        },
        {
            "code": "6363",
            "localite": "Bürgenstock"
        },
        {
            "code": "6363",
            "localite": "Fürigen"
        },
        {
            "code": "6363",
            "localite": "Obbürgen"
        },
        {
            "code": "6365",
            "localite": "Kehrsiten"
        },
        {
            "code": "6370",
            "localite": "Oberdorf NW"
        },
        {
            "code": "6370",
            "localite": "Stans"
        },
        {
            "code": "6372",
            "localite": "Ennetmoos"
        },
        {
            "code": "6373",
            "localite": "Ennetbürgen"
        },
        {
            "code": "6374",
            "localite": "Buochs"
        },
        {
            "code": "6375",
            "localite": "Beckenried"
        },
        {
            "code": "6376",
            "localite": "Emmetten"
        },
        {
            "code": "6377",
            "localite": "Seelisberg"
        },
        {
            "code": "6382",
            "localite": "Büren NW"
        },
        {
            "code": "6383",
            "localite": "Dallenwil"
        },
        {
            "code": "6383",
            "localite": "Niederrickenbach"
        },
        {
            "code": "6383",
            "localite": "Wiesenberg"
        },
        {
            "code": "6383",
            "localite": "Wirzweli"
        },
        {
            "code": "6386",
            "localite": "Wolfenschiessen"
        },
        {
            "code": "6387",
            "localite": "Oberrickenbach"
        },
        {
            "code": "6388",
            "localite": "Grafenort"
        },
        {
            "code": "6390",
            "localite": "Engelberg"
        },
        {
            "code": "6402",
            "localite": "Merlischachen"
        },
        {
            "code": "6403",
            "localite": "Küssnacht am Rigi"
        },
        {
            "code": "6404",
            "localite": "Greppen"
        },
        {
            "code": "6405",
            "localite": "Immensee"
        },
        {
            "code": "6410",
            "localite": "Goldau"
        },
        {
            "code": "6410",
            "localite": "Rigi Klösterli"
        },
        {
            "code": "6410",
            "localite": "Rigi Kulm"
        },
        {
            "code": "6410",
            "localite": "Rigi Scheidegg"
        },
        {
            "code": "6410",
            "localite": "Rigi Staffel"
        },
        {
            "code": "6414",
            "localite": "Oberarth"
        },
        {
            "code": "6415",
            "localite": "Arth"
        },
        {
            "code": "6416",
            "localite": "Steinerberg"
        },
        {
            "code": "6417",
            "localite": "Sattel"
        },
        {
            "code": "6418",
            "localite": "Rothenthurm"
        },
        {
            "code": "6422",
            "localite": "Steinen"
        },
        {
            "code": "6423",
            "localite": "Seewen SZ"
        },
        {
            "code": "6424",
            "localite": "Lauerz"
        },
        {
            "code": "6430",
            "localite": "Schwyz"
        },
        {
            "code": "6432",
            "localite": "Rickenbach b. Schwyz"
        },
        {
            "code": "6433",
            "localite": "Stoos SZ"
        },
        {
            "code": "6434",
            "localite": "Illgau"
        },
        {
            "code": "6436",
            "localite": "Bisisthal"
        },
        {
            "code": "6436",
            "localite": "Muotathal"
        },
        {
            "code": "6436",
            "localite": "Ried (Muotathal)"
        },
        {
            "code": "6438",
            "localite": "Ibach"
        },
        {
            "code": "6440",
            "localite": "Brunnen"
        },
        {
            "code": "6441",
            "localite": "Rütli"
        },
        {
            "code": "6442",
            "localite": "Gersau"
        },
        {
            "code": "6443",
            "localite": "Morschach"
        },
        {
            "code": "6452",
            "localite": "Riemenstalden"
        },
        {
            "code": "6452",
            "localite": "Sisikon"
        },
        {
            "code": "6454",
            "localite": "Flüelen"
        },
        {
            "code": "6460",
            "localite": "Altdorf UR"
        },
        {
            "code": "6461",
            "localite": "Isenthal"
        },
        {
            "code": "6462",
            "localite": "Seedorf UR"
        },
        {
            "code": "6463",
            "localite": "Bürglen UR"
        },
        {
            "code": "6464",
            "localite": "Spiringen"
        },
        {
            "code": "6465",
            "localite": "Unterschächen"
        },
        {
            "code": "6466",
            "localite": "Bauen"
        },
        {
            "code": "6467",
            "localite": "Schattdorf"
        },
        {
            "code": "6468",
            "localite": "Attinghausen"
        },
        {
            "code": "6469",
            "localite": "Haldi b. Schattdorf"
        },
        {
            "code": "6472",
            "localite": "Erstfeld"
        },
        {
            "code": "6473",
            "localite": "Silenen"
        },
        {
            "code": "6474",
            "localite": "Amsteg"
        },
        {
            "code": "6475",
            "localite": "Bristen"
        },
        {
            "code": "6476",
            "localite": "Intschi"
        },
        {
            "code": "6482",
            "localite": "Gurtnellen"
        },
        {
            "code": "6484",
            "localite": "Wassen UR"
        },
        {
            "code": "6485",
            "localite": "Meien"
        },
        {
            "code": "6487",
            "localite": "Göschenen"
        },
        {
            "code": "6490",
            "localite": "Andermatt"
        },
        {
            "code": "6491",
            "localite": "Realp"
        },
        {
            "code": "6493",
            "localite": "Hospental"
        },
        {
            "code": "6500",
            "localite": "Bellinzona"
        },
        {
            "code": "6503",
            "localite": "Bellinzona"
        },
        {
            "code": "6512",
            "localite": "Giubiasco"
        },
        {
            "code": "6513",
            "localite": "Monte Carasso"
        },
        {
            "code": "6514",
            "localite": "Sementina"
        },
        {
            "code": "6515",
            "localite": "Gudo"
        },
        {
            "code": "6516",
            "localite": "Cugnasco"
        },
        {
            "code": "6517",
            "localite": "Arbedo"
        },
        {
            "code": "6518",
            "localite": "Gorduno"
        },
        {
            "code": "6523",
            "localite": "Preonzo"
        },
        {
            "code": "6524",
            "localite": "Moleno"
        },
        {
            "code": "6525",
            "localite": "Gnosca"
        },
        {
            "code": "6526",
            "localite": "Prosito"
        },
        {
            "code": "6527",
            "localite": "Lodrino"
        },
        {
            "code": "6528",
            "localite": "Camorino"
        },
        {
            "code": "6532",
            "localite": "Castione"
        },
        {
            "code": "6533",
            "localite": "Lumino"
        },
        {
            "code": "6534",
            "localite": "S. Vittore"
        },
        {
            "code": "6535",
            "localite": "Roveredo GR"
        },
        {
            "code": "6537",
            "localite": "Grono"
        },
        {
            "code": "6538",
            "localite": "Verdabbio"
        },
        {
            "code": "6540",
            "localite": "Castaneda"
        },
        {
            "code": "6541",
            "localite": "Sta. Maria in Calanca"
        },
        {
            "code": "6542",
            "localite": "Buseno"
        },
        {
            "code": "6543",
            "localite": "Arvigo"
        },
        {
            "code": "6544",
            "localite": "Braggio"
        },
        {
            "code": "6545",
            "localite": "Selma"
        },
        {
            "code": "6546",
            "localite": "Cauco"
        },
        {
            "code": "6548",
            "localite": "Augio"
        },
        {
            "code": "6548",
            "localite": "Rossa"
        },
        {
            "code": "6548",
            "localite": "Sta. Domenica"
        },
        {
            "code": "6549",
            "localite": "Laura"
        },
        {
            "code": "6556",
            "localite": "Leggia"
        },
        {
            "code": "6557",
            "localite": "Cama"
        },
        {
            "code": "6558",
            "localite": "Lostallo"
        },
        {
            "code": "6562",
            "localite": "Soazza"
        },
        {
            "code": "6563",
            "localite": "Mesocco"
        },
        {
            "code": "6565",
            "localite": "S. Bernardino"
        },
        {
            "code": "6571",
            "localite": "Indemini"
        },
        {
            "code": "6572",
            "localite": "Quartino"
        },
        {
            "code": "6573",
            "localite": "Magadino"
        },
        {
            "code": "6574",
            "localite": "Vira (Gambarogno)"
        },
        {
            "code": "6575",
            "localite": "S. Nazzaro"
        },
        {
            "code": "6575",
            "localite": "Vairano"
        },
        {
            "code": "6576",
            "localite": "Gerra (Gambarogno)"
        },
        {
            "code": "6577",
            "localite": "Ranzo"
        },
        {
            "code": "6578",
            "localite": "Caviano"
        },
        {
            "code": "6579",
            "localite": "Piazzogna"
        },
        {
            "code": "6582",
            "localite": "Pianezzo"
        },
        {
            "code": "6583",
            "localite": "S. Antonio (Val Morobbia)"
        },
        {
            "code": "6584",
            "localite": "Carena"
        },
        {
            "code": "6592",
            "localite": "S. Antonino"
        },
        {
            "code": "6593",
            "localite": "Cadenazzo"
        },
        {
            "code": "6594",
            "localite": "Contone"
        },
        {
            "code": "6595",
            "localite": "Riazzino"
        },
        {
            "code": "6596",
            "localite": "Gordola"
        },
        {
            "code": "6597",
            "localite": "Agarone"
        },
        {
            "code": "6598",
            "localite": "Tenero"
        },
        {
            "code": "6599",
            "localite": "Robasacco"
        },
        {
            "code": "6600",
            "localite": "Locarno"
        },
        {
            "code": "6600",
            "localite": "Muralto"
        },
        {
            "code": "6600",
            "localite": "Solduno"
        },
        {
            "code": "6605",
            "localite": "Locarno"
        },
        {
            "code": "6612",
            "localite": "Ascona"
        },
        {
            "code": "6613",
            "localite": "Porto Ronco"
        },
        {
            "code": "6614",
            "localite": "Brissago"
        },
        {
            "code": "6614",
            "localite": "Isole di Brissago"
        },
        {
            "code": "6616",
            "localite": "Losone"
        },
        {
            "code": "6618",
            "localite": "Arcegno"
        },
        {
            "code": "6622",
            "localite": "Ronco sopra Ascona"
        },
        {
            "code": "6631",
            "localite": "Corippo"
        },
        {
            "code": "6632",
            "localite": "Vogorno"
        },
        {
            "code": "6633",
            "localite": "Lavertezzo"
        },
        {
            "code": "6634",
            "localite": "Brione (Verzasca)"
        },
        {
            "code": "6635",
            "localite": "Gerra (Verzasca)"
        },
        {
            "code": "6636",
            "localite": "Frasco"
        },
        {
            "code": "6637",
            "localite": "Sonogno"
        },
        {
            "code": "6644",
            "localite": "Orselina"
        },
        {
            "code": "6645",
            "localite": "Brione sopra Minusio"
        },
        {
            "code": "6646",
            "localite": "Contra"
        },
        {
            "code": "6647",
            "localite": "Mergoscia"
        },
        {
            "code": "6648",
            "localite": "Minusio"
        },
        {
            "code": "6652",
            "localite": "Tegna"
        },
        {
            "code": "6653",
            "localite": "Verscio"
        },
        {
            "code": "6654",
            "localite": "Cavigliano"
        },
        {
            "code": "6655",
            "localite": "Intragna"
        },
        {
            "code": "6655",
            "localite": "Rasa"
        },
        {
            "code": "6655",
            "localite": "Verdasio"
        },
        {
            "code": "6656",
            "localite": "Golino"
        },
        {
            "code": "6657",
            "localite": "Palagnedra"
        },
        {
            "code": "6658",
            "localite": "Borgnone"
        },
        {
            "code": "6659",
            "localite": "Camedo"
        },
        {
            "code": "6659",
            "localite": "Moneto"
        },
        {
            "code": "6661",
            "localite": "Auressio"
        },
        {
            "code": "6661",
            "localite": "Berzona"
        },
        {
            "code": "6661",
            "localite": "Comologno"
        },
        {
            "code": "6661",
            "localite": "Crana"
        },
        {
            "code": "6661",
            "localite": "Gresso"
        },
        {
            "code": "6661",
            "localite": "Loco"
        },
        {
            "code": "6661",
            "localite": "Mosogno"
        },
        {
            "code": "6661",
            "localite": "Russo"
        },
        {
            "code": "6661",
            "localite": "Spruga"
        },
        {
            "code": "6661",
            "localite": "Vergeletto"
        },
        {
            "code": "6670",
            "localite": "Avegno"
        },
        {
            "code": "6672",
            "localite": "Gordevio"
        },
        {
            "code": "6673",
            "localite": "Maggia"
        },
        {
            "code": "6674",
            "localite": "Riveo"
        },
        {
            "code": "6674",
            "localite": "Someo"
        },
        {
            "code": "6675",
            "localite": "Cevio"
        },
        {
            "code": "6676",
            "localite": "Bignasco"
        },
        {
            "code": "6677",
            "localite": "Aurigeno"
        },
        {
            "code": "6677",
            "localite": "Moghegno"
        },
        {
            "code": "6678",
            "localite": "Coglio"
        },
        {
            "code": "6678",
            "localite": "Giumaglio"
        },
        {
            "code": "6678",
            "localite": "Lodano"
        },
        {
            "code": "6682",
            "localite": "Linescio"
        },
        {
            "code": "6683",
            "localite": "Cerentino"
        },
        {
            "code": "6683",
            "localite": "Niva (Vallemaggia)"
        },
        {
            "code": "6684",
            "localite": "Campo (Vallemaggia)"
        },
        {
            "code": "6684",
            "localite": "Cimalmotto"
        },
        {
            "code": "6685",
            "localite": "Bosco/Gurin"
        },
        {
            "code": "6690",
            "localite": "Cavergno"
        },
        {
            "code": "6690",
            "localite": "S. Carlo (Val Bavona)"
        },
        {
            "code": "6692",
            "localite": "Brontallo"
        },
        {
            "code": "6692",
            "localite": "Menzonio"
        },
        {
            "code": "6693",
            "localite": "Broglio"
        },
        {
            "code": "6694",
            "localite": "Prato-Sornico"
        },
        {
            "code": "6695",
            "localite": "Peccia"
        },
        {
            "code": "6695",
            "localite": "Piano di Peccia"
        },
        {
            "code": "6696",
            "localite": "Fusio"
        },
        {
            "code": "6702",
            "localite": "Claro"
        },
        {
            "code": "6703",
            "localite": "Osogna"
        },
        {
            "code": "6705",
            "localite": "Cresciano"
        },
        {
            "code": "6707",
            "localite": "Iragna"
        },
        {
            "code": "6710",
            "localite": "Biasca"
        },
        {
            "code": "6713",
            "localite": "Malvaglia"
        },
        {
            "code": "6714",
            "localite": "Semione"
        },
        {
            "code": "6715",
            "localite": "Dongio"
        },
        {
            "code": "6716",
            "localite": "Acquarossa"
        },
        {
            "code": "6716",
            "localite": "Leontica"
        },
        {
            "code": "6716",
            "localite": "Lottigna"
        },
        {
            "code": "6717",
            "localite": "Dangio"
        },
        {
            "code": "6717",
            "localite": "Torre"
        },
        {
            "code": "6718",
            "localite": "Camperio"
        },
        {
            "code": "6718",
            "localite": "Olivone"
        },
        {
            "code": "6719",
            "localite": "Aquila"
        },
        {
            "code": "6720",
            "localite": "Campo (Blenio)"
        },
        {
            "code": "6720",
            "localite": "Ghirone"
        },
        {
            "code": "6721",
            "localite": "Ludiano"
        },
        {
            "code": "6721",
            "localite": "Motto (Blenio)"
        },
        {
            "code": "6722",
            "localite": "Corzoneso"
        },
        {
            "code": "6723",
            "localite": "Castro"
        },
        {
            "code": "6723",
            "localite": "Marolta"
        },
        {
            "code": "6723",
            "localite": "Prugiasco"
        },
        {
            "code": "6724",
            "localite": "Largario"
        },
        {
            "code": "6724",
            "localite": "Ponto Valentino"
        },
        {
            "code": "6742",
            "localite": "Pollegio"
        },
        {
            "code": "6743",
            "localite": "Bodio TI"
        },
        {
            "code": "6744",
            "localite": "Personico"
        },
        {
            "code": "6745",
            "localite": "Giornico"
        },
        {
            "code": "6746",
            "localite": "Calonico"
        },
        {
            "code": "6746",
            "localite": "Lavorgo"
        },
        {
            "code": "6746",
            "localite": "Nivo"
        },
        {
            "code": "6747",
            "localite": "Chironico"
        },
        {
            "code": "6748",
            "localite": "Anzonico"
        },
        {
            "code": "6749",
            "localite": "Cavagnago"
        },
        {
            "code": "6749",
            "localite": "Sobrio"
        },
        {
            "code": "6760",
            "localite": "Calpiogna"
        },
        {
            "code": "6760",
            "localite": "Campello"
        },
        {
            "code": "6760",
            "localite": "Carì"
        },
        {
            "code": "6760",
            "localite": "Faido"
        },
        {
            "code": "6760",
            "localite": "Molare"
        },
        {
            "code": "6760",
            "localite": "Rossura"
        },
        {
            "code": "6763",
            "localite": "Mairengo"
        },
        {
            "code": "6763",
            "localite": "Osco"
        },
        {
            "code": "6764",
            "localite": "Chiggiogna"
        },
        {
            "code": "6772",
            "localite": "Rodi-Fiesso"
        },
        {
            "code": "6773",
            "localite": "Prato (Leventina)"
        },
        {
            "code": "6774",
            "localite": "Dalpe"
        },
        {
            "code": "6775",
            "localite": "Ambrì"
        },
        {
            "code": "6776",
            "localite": "Piotta"
        },
        {
            "code": "6777",
            "localite": "Quinto"
        },
        {
            "code": "6780",
            "localite": "Airolo"
        },
        {
            "code": "6781",
            "localite": "Bedretto"
        },
        {
            "code": "6781",
            "localite": "Villa Bedretto"
        },
        {
            "code": "6802",
            "localite": "Rivera"
        },
        {
            "code": "6803",
            "localite": "Camignolo"
        },
        {
            "code": "6804",
            "localite": "Bironico"
        },
        {
            "code": "6805",
            "localite": "Mezzovico"
        },
        {
            "code": "6806",
            "localite": "Sigirino"
        },
        {
            "code": "6807",
            "localite": "Taverne"
        },
        {
            "code": "6808",
            "localite": "Torricella"
        },
        {
            "code": "6809",
            "localite": "Medeglia"
        },
        {
            "code": "6810",
            "localite": "Isone"
        },
        {
            "code": "6814",
            "localite": "Cadempino"
        },
        {
            "code": "6814",
            "localite": "Lamone"
        },
        {
            "code": "6815",
            "localite": "Melide"
        },
        {
            "code": "6816",
            "localite": "Bissone"
        },
        {
            "code": "6817",
            "localite": "Maroggia"
        },
        {
            "code": "6818",
            "localite": "Melano"
        },
        {
            "code": "6821",
            "localite": "Rovio"
        },
        {
            "code": "6822",
            "localite": "Arogno"
        },
        {
            "code": "6823",
            "localite": "Pugerna"
        },
        {
            "code": "6825",
            "localite": "Capolago"
        },
        {
            "code": "6826",
            "localite": "Riva San Vitale"
        },
        {
            "code": "6827",
            "localite": "Brusino Arsizio"
        },
        {
            "code": "6828",
            "localite": "Balerna"
        },
        {
            "code": "6830",
            "localite": "Chiasso"
        },
        {
            "code": "6832",
            "localite": "Pedrinate"
        },
        {
            "code": "6832",
            "localite": "Seseglio"
        },
        {
            "code": "6833",
            "localite": "Vacallo"
        },
        {
            "code": "6834",
            "localite": "Morbio Inferiore"
        },
        {
            "code": "6835",
            "localite": "Morbio Superiore"
        },
        {
            "code": "6837",
            "localite": "Bruzella"
        },
        {
            "code": "6837",
            "localite": "Caneggio"
        },
        {
            "code": "6838",
            "localite": "Cabbio"
        },
        {
            "code": "6838",
            "localite": "Muggio"
        },
        {
            "code": "6839",
            "localite": "Sagno"
        },
        {
            "code": "6850",
            "localite": "Mendrisio"
        },
        {
            "code": "6852",
            "localite": "Genestrerio"
        },
        {
            "code": "6853",
            "localite": "Ligornetto"
        },
        {
            "code": "6854",
            "localite": "S. Pietro"
        },
        {
            "code": "6855",
            "localite": "Stabio"
        },
        {
            "code": "6862",
            "localite": "Rancate"
        },
        {
            "code": "6863",
            "localite": "Besazio"
        },
        {
            "code": "6864",
            "localite": "Arzo"
        },
        {
            "code": "6865",
            "localite": "Tremona"
        },
        {
            "code": "6866",
            "localite": "Meride"
        },
        {
            "code": "6867",
            "localite": "Serpiano"
        },
        {
            "code": "6872",
            "localite": "Salorino"
        },
        {
            "code": "6873",
            "localite": "Corteglia"
        },
        {
            "code": "6874",
            "localite": "Castel San Pietro"
        },
        {
            "code": "6875",
            "localite": "Campora"
        },
        {
            "code": "6875",
            "localite": "Casima"
        },
        {
            "code": "6875",
            "localite": "Monte"
        },
        {
            "code": "6877",
            "localite": "Coldrerio"
        },
        {
            "code": "6883",
            "localite": "Novazzano"
        },
        {
            "code": "6900",
            "localite": "Lugano"
        },
        {
            "code": "6900",
            "localite": "Massagno"
        },
        {
            "code": "6900",
            "localite": "Paradiso"
        },
        {
            "code": "6912",
            "localite": "Pazzallo"
        },
        {
            "code": "6913",
            "localite": "Carabbia"
        },
        {
            "code": "6914",
            "localite": "Carona"
        },
        {
            "code": "6915",
            "localite": "Pambio-Noranco"
        },
        {
            "code": "6916",
            "localite": "Grancia"
        },
        {
            "code": "6917",
            "localite": "Barbengo"
        },
        {
            "code": "6918",
            "localite": "Figino"
        },
        {
            "code": "6919",
            "localite": "Carabietta"
        },
        {
            "code": "6921",
            "localite": "Vico Morcote"
        },
        {
            "code": "6922",
            "localite": "Morcote"
        },
        {
            "code": "6924",
            "localite": "Sorengo"
        },
        {
            "code": "6925",
            "localite": "Gentilino"
        },
        {
            "code": "6926",
            "localite": "Montagnola"
        },
        {
            "code": "6927",
            "localite": "Agra"
        },
        {
            "code": "6928",
            "localite": "Manno"
        },
        {
            "code": "6929",
            "localite": "Gravesano"
        },
        {
            "code": "6930",
            "localite": "Bedano"
        },
        {
            "code": "6932",
            "localite": "Breganzona"
        },
        {
            "code": "6933",
            "localite": "Muzzano"
        },
        {
            "code": "6934",
            "localite": "Bioggio"
        },
        {
            "code": "6935",
            "localite": "Bosco Luganese"
        },
        {
            "code": "6936",
            "localite": "Cademario"
        },
        {
            "code": "6937",
            "localite": "Breno"
        },
        {
            "code": "6938",
            "localite": "Fescoggia"
        },
        {
            "code": "6938",
            "localite": "Vezio"
        },
        {
            "code": "6939",
            "localite": "Arosio"
        },
        {
            "code": "6939",
            "localite": "Mugena"
        },
        {
            "code": "6942",
            "localite": "Savosa"
        },
        {
            "code": "6943",
            "localite": "Vezia"
        },
        {
            "code": "6944",
            "localite": "Cureglia"
        },
        {
            "code": "6945",
            "localite": "Origlio"
        },
        {
            "code": "6946",
            "localite": "Ponte Capriasca"
        },
        {
            "code": "6947",
            "localite": "Vaglio"
        },
        {
            "code": "6948",
            "localite": "Porza"
        },
        {
            "code": "6949",
            "localite": "Comano"
        },
        {
            "code": "6950",
            "localite": "Tesserete"
        },
        {
            "code": "6951",
            "localite": "Bogno"
        },
        {
            "code": "6951",
            "localite": "Colla"
        },
        {
            "code": "6951",
            "localite": "Cozzo"
        },
        {
            "code": "6951",
            "localite": "Insone"
        },
        {
            "code": "6951",
            "localite": "Scareglia"
        },
        {
            "code": "6951",
            "localite": "Signôra"
        },
        {
            "code": "6952",
            "localite": "Canobbio"
        },
        {
            "code": "6953",
            "localite": "Lugaggia"
        },
        {
            "code": "6954",
            "localite": "Bigorio"
        },
        {
            "code": "6954",
            "localite": "Sala Capriasca"
        },
        {
            "code": "6955",
            "localite": "Cagiallo"
        },
        {
            "code": "6955",
            "localite": "Oggio"
        },
        {
            "code": "6956",
            "localite": "Lopagno"
        },
        {
            "code": "6957",
            "localite": "Roveredo TI"
        },
        {
            "code": "6958",
            "localite": "Bidogno"
        },
        {
            "code": "6958",
            "localite": "Corticiasca"
        },
        {
            "code": "6959",
            "localite": "Certara"
        },
        {
            "code": "6959",
            "localite": "Cimadera"
        },
        {
            "code": "6959",
            "localite": "Curtina"
        },
        {
            "code": "6959",
            "localite": "Maglio di Colla"
        },
        {
            "code": "6959",
            "localite": "Piandera Paese"
        },
        {
            "code": "6960",
            "localite": "Odogno"
        },
        {
            "code": "6962",
            "localite": "Viganello"
        },
        {
            "code": "6963",
            "localite": "Cureggia"
        },
        {
            "code": "6963",
            "localite": "Pregassona"
        },
        {
            "code": "6964",
            "localite": "Davesco-Soragno"
        },
        {
            "code": "6965",
            "localite": "Cadro"
        },
        {
            "code": "6966",
            "localite": "Villa Luganese"
        },
        {
            "code": "6967",
            "localite": "Dino"
        },
        {
            "code": "6968",
            "localite": "Sonvico"
        },
        {
            "code": "6974",
            "localite": "Aldesago"
        },
        {
            "code": "6976",
            "localite": "Castagnola"
        },
        {
            "code": "6977",
            "localite": "Ruvigliana"
        },
        {
            "code": "6978",
            "localite": "Gandria"
        },
        {
            "code": "6979",
            "localite": "Brè sopra Lugano"
        },
        {
            "code": "6980",
            "localite": "Castelrotto"
        },
        {
            "code": "6981",
            "localite": "Banco"
        },
        {
            "code": "6981",
            "localite": "Bedigliora"
        },
        {
            "code": "6981",
            "localite": "Beride di Bedigliora"
        },
        {
            "code": "6981",
            "localite": "Bombinasco"
        },
        {
            "code": "6982",
            "localite": "Agno"
        },
        {
            "code": "6983",
            "localite": "Magliaso"
        },
        {
            "code": "6984",
            "localite": "Pura"
        },
        {
            "code": "6986",
            "localite": "Curio"
        },
        {
            "code": "6986",
            "localite": "Miglieglia"
        },
        {
            "code": "6986",
            "localite": "Novaggio"
        },
        {
            "code": "6987",
            "localite": "Caslano"
        },
        {
            "code": "6988",
            "localite": "Ponte Tresa"
        },
        {
            "code": "6989",
            "localite": "Purasca"
        },
        {
            "code": "6990",
            "localite": "Cassina d'Agno"
        },
        {
            "code": "6991",
            "localite": "Neggio"
        },
        {
            "code": "6992",
            "localite": "Cimo"
        },
        {
            "code": "6992",
            "localite": "Vernate"
        },
        {
            "code": "6993",
            "localite": "Iseo"
        },
        {
            "code": "6994",
            "localite": "Aranno"
        },
        {
            "code": "6995",
            "localite": "Madonna del Piano"
        },
        {
            "code": "6997",
            "localite": "Sessa"
        },
        {
            "code": "6998",
            "localite": "Monteggio"
        },
        {
            "code": "6999",
            "localite": "Astano"
        },
        {
            "code": "7000",
            "localite": "Chur"
        },
        {
            "code": "7012",
            "localite": "Felsberg"
        },
        {
            "code": "7013",
            "localite": "Domat/Ems"
        },
        {
            "code": "7014",
            "localite": "Trin"
        },
        {
            "code": "7015",
            "localite": "Tamins"
        },
        {
            "code": "7016",
            "localite": "Trin Mulin"
        },
        {
            "code": "7017",
            "localite": "Flims Dorf"
        },
        {
            "code": "7018",
            "localite": "Flims Waldhaus"
        },
        {
            "code": "7019",
            "localite": "Fidaz"
        },
        {
            "code": "7023",
            "localite": "Haldenstein"
        },
        {
            "code": "7026",
            "localite": "Maladers"
        },
        {
            "code": "7027",
            "localite": "Calfreisen"
        },
        {
            "code": "7027",
            "localite": "Castiel"
        },
        {
            "code": "7027",
            "localite": "Lüen"
        },
        {
            "code": "7028",
            "localite": "Pagig"
        },
        {
            "code": "7028",
            "localite": "St. Peter"
        },
        {
            "code": "7029",
            "localite": "Peist"
        },
        {
            "code": "7031",
            "localite": "Laax GR"
        },
        {
            "code": "7032",
            "localite": "Laax GR 2"
        },
        {
            "code": "7050",
            "localite": "Arosa"
        },
        {
            "code": "7056",
            "localite": "Molinis"
        },
        {
            "code": "7057",
            "localite": "Langwies"
        },
        {
            "code": "7058",
            "localite": "Litzirüti"
        },
        {
            "code": "7062",
            "localite": "Passugg"
        },
        {
            "code": "7063",
            "localite": "Praden"
        },
        {
            "code": "7064",
            "localite": "Tschiertschen"
        },
        {
            "code": "7074",
            "localite": "Malix"
        },
        {
            "code": "7075",
            "localite": "Churwalden"
        },
        {
            "code": "7076",
            "localite": "Parpan"
        },
        {
            "code": "7077",
            "localite": "Valbella"
        },
        {
            "code": "7078",
            "localite": "Lenzerheide/Lai"
        },
        {
            "code": "7082",
            "localite": "Vaz/Obervaz"
        },
        {
            "code": "7083",
            "localite": "Lantsch/Lenz"
        },
        {
            "code": "7084",
            "localite": "Brienz/Brinzauls GR"
        },
        {
            "code": "7104",
            "localite": "Versam"
        },
        {
            "code": "7106",
            "localite": "Tenna"
        },
        {
            "code": "7107",
            "localite": "Safien Platz"
        },
        {
            "code": "7109",
            "localite": "Thalkirch"
        },
        {
            "code": "7110",
            "localite": "Peiden"
        },
        {
            "code": "7111",
            "localite": "Pitasch"
        },
        {
            "code": "7112",
            "localite": "Duvin"
        },
        {
            "code": "7113",
            "localite": "Camuns"
        },
        {
            "code": "7114",
            "localite": "Uors (Lumnezia)"
        },
        {
            "code": "7115",
            "localite": "Surcasti"
        },
        {
            "code": "7116",
            "localite": "St. Martin (Lugnez)"
        },
        {
            "code": "7116",
            "localite": "Tersnaus"
        },
        {
            "code": "7122",
            "localite": "Valendas"
        },
        {
            "code": "7126",
            "localite": "Castrisch"
        },
        {
            "code": "7127",
            "localite": "Sevgein"
        },
        {
            "code": "7128",
            "localite": "Riein"
        },
        {
            "code": "7130",
            "localite": "Ilanz"
        },
        {
            "code": "7130",
            "localite": "Schnaus"
        },
        {
            "code": "7132",
            "localite": "Vals"
        },
        {
            "code": "7134",
            "localite": "Obersaxen"
        },
        {
            "code": "7137",
            "localite": "Flond"
        },
        {
            "code": "7138",
            "localite": "Surcuolm"
        },
        {
            "code": "7141",
            "localite": "Luven"
        },
        {
            "code": "7142",
            "localite": "Cumbel"
        },
        {
            "code": "7143",
            "localite": "Morissen"
        },
        {
            "code": "7144",
            "localite": "Vella"
        },
        {
            "code": "7145",
            "localite": "Degen"
        },
        {
            "code": "7146",
            "localite": "Vattiz"
        },
        {
            "code": "7147",
            "localite": "Vignogn"
        },
        {
            "code": "7148",
            "localite": "Lumbrein"
        },
        {
            "code": "7149",
            "localite": "Vrin"
        },
        {
            "code": "7151",
            "localite": "Schluein"
        },
        {
            "code": "7152",
            "localite": "Sagogn"
        },
        {
            "code": "7153",
            "localite": "Falera"
        },
        {
            "code": "7154",
            "localite": "Ruschein"
        },
        {
            "code": "7155",
            "localite": "Ladir"
        },
        {
            "code": "7156",
            "localite": "Pigniu"
        },
        {
            "code": "7156",
            "localite": "Rueun"
        },
        {
            "code": "7157",
            "localite": "Siat"
        },
        {
            "code": "7158",
            "localite": "Waltensburg/Vuorz"
        },
        {
            "code": "7159",
            "localite": "Andiast"
        },
        {
            "code": "7162",
            "localite": "Tavanasa"
        },
        {
            "code": "7163",
            "localite": "Danis"
        },
        {
            "code": "7164",
            "localite": "Dardin"
        },
        {
            "code": "7165",
            "localite": "Breil/Brigels"
        },
        {
            "code": "7166",
            "localite": "Trun"
        },
        {
            "code": "7167",
            "localite": "Zignau"
        },
        {
            "code": "7168",
            "localite": "Schlans"
        },
        {
            "code": "7172",
            "localite": "Rabius"
        },
        {
            "code": "7173",
            "localite": "Surrein"
        },
        {
            "code": "7174",
            "localite": "S. Benedetg"
        },
        {
            "code": "7175",
            "localite": "Sumvitg"
        },
        {
            "code": "7176",
            "localite": "Cumpadials"
        },
        {
            "code": "7180",
            "localite": "Disentis/Mustér"
        },
        {
            "code": "7182",
            "localite": "Cavardiras"
        },
        {
            "code": "7183",
            "localite": "Mumpé Medel"
        },
        {
            "code": "7184",
            "localite": "Curaglia"
        },
        {
            "code": "7185",
            "localite": "Platta"
        },
        {
            "code": "7186",
            "localite": "Segnas"
        },
        {
            "code": "7187",
            "localite": "Camischolas"
        },
        {
            "code": "7188",
            "localite": "Sedrun"
        },
        {
            "code": "7189",
            "localite": "Rueras"
        },
        {
            "code": "7202",
            "localite": "Says"
        },
        {
            "code": "7203",
            "localite": "Trimmis"
        },
        {
            "code": "7204",
            "localite": "Untervaz"
        },
        {
            "code": "7205",
            "localite": "Zizers"
        },
        {
            "code": "7206",
            "localite": "Igis"
        },
        {
            "code": "7208",
            "localite": "Malans GR"
        },
        {
            "code": "7212",
            "localite": "Seewis Dorf"
        },
        {
            "code": "7212",
            "localite": "Seewis-Pardisla"
        },
        {
            "code": "7212",
            "localite": "Seewis-Schmitten"
        },
        {
            "code": "7213",
            "localite": "Valzeina"
        },
        {
            "code": "7214",
            "localite": "Grüsch"
        },
        {
            "code": "7215",
            "localite": "Fanas"
        },
        {
            "code": "7220",
            "localite": "Schiers"
        },
        {
            "code": "7222",
            "localite": "Lunden"
        },
        {
            "code": "7223",
            "localite": "Buchen im Prättigau"
        },
        {
            "code": "7224",
            "localite": "Putz"
        },
        {
            "code": "7226",
            "localite": "Fajauna"
        },
        {
            "code": "7226",
            "localite": "Stels"
        },
        {
            "code": "7228",
            "localite": "Pusserein"
        },
        {
            "code": "7228",
            "localite": "Schuders"
        },
        {
            "code": "7231",
            "localite": "Pragg-Jenaz"
        },
        {
            "code": "7232",
            "localite": "Furna"
        },
        {
            "code": "7233",
            "localite": "Jenaz"
        },
        {
            "code": "7235",
            "localite": "Fideris"
        },
        {
            "code": "7240",
            "localite": "Küblis"
        },
        {
            "code": "7241",
            "localite": "Conters im Prättigau"
        },
        {
            "code": "7242",
            "localite": "Luzein"
        },
        {
            "code": "7243",
            "localite": "Pany"
        },
        {
            "code": "7244",
            "localite": "Gadenstätt"
        },
        {
            "code": "7245",
            "localite": "Ascharina"
        },
        {
            "code": "7246",
            "localite": "St. Antönien"
        },
        {
            "code": "7247",
            "localite": "Saas im Prättigau"
        },
        {
            "code": "7249",
            "localite": "Serneus"
        },
        {
            "code": "7250",
            "localite": "Klosters"
        },
        {
            "code": "7252",
            "localite": "Klosters Dorf"
        },
        {
            "code": "7260",
            "localite": "Davos Dorf"
        },
        {
            "code": "7265",
            "localite": "Davos Wolfgang"
        },
        {
            "code": "7270",
            "localite": "Davos Platz"
        },
        {
            "code": "7272",
            "localite": "Davos Clavadel"
        },
        {
            "code": "7276",
            "localite": "Davos Frauenkirch"
        },
        {
            "code": "7277",
            "localite": "Davos Glaris"
        },
        {
            "code": "7278",
            "localite": "Davos Monstein"
        },
        {
            "code": "7302",
            "localite": "Landquart"
        },
        {
            "code": "7303",
            "localite": "Mastrils"
        },
        {
            "code": "7304",
            "localite": "Maienfeld"
        },
        {
            "code": "7306",
            "localite": "Fläsch"
        },
        {
            "code": "7307",
            "localite": "Jenins"
        },
        {
            "code": "7310",
            "localite": "Bad Ragaz"
        },
        {
            "code": "7312",
            "localite": "Pfäfers"
        },
        {
            "code": "7313",
            "localite": "St. Margrethenberg"
        },
        {
            "code": "7314",
            "localite": "Vadura"
        },
        {
            "code": "7315",
            "localite": "Vättis"
        },
        {
            "code": "7317",
            "localite": "Valens"
        },
        {
            "code": "7317",
            "localite": "Vasön"
        },
        {
            "code": "7320",
            "localite": "Sargans"
        },
        {
            "code": "7323",
            "localite": "Wangs"
        },
        {
            "code": "7324",
            "localite": "Vilters"
        },
        {
            "code": "7325",
            "localite": "Schwendi im Weisstannental"
        },
        {
            "code": "7326",
            "localite": "Weisstannen"
        },
        {
            "code": "7402",
            "localite": "Bonaduz"
        },
        {
            "code": "7403",
            "localite": "Rhäzüns"
        },
        {
            "code": "7404",
            "localite": "Feldis/Veulden"
        },
        {
            "code": "7405",
            "localite": "Rothenbrunnen"
        },
        {
            "code": "7407",
            "localite": "Trans"
        },
        {
            "code": "7408",
            "localite": "Cazis"
        },
        {
            "code": "7411",
            "localite": "Sils im Domleschg"
        },
        {
            "code": "7412",
            "localite": "Scharans"
        },
        {
            "code": "7413",
            "localite": "Fürstenaubruck"
        },
        {
            "code": "7414",
            "localite": "Fürstenau"
        },
        {
            "code": "7415",
            "localite": "Pratval"
        },
        {
            "code": "7415",
            "localite": "Rodels"
        },
        {
            "code": "7416",
            "localite": "Almens"
        },
        {
            "code": "7417",
            "localite": "Paspels"
        },
        {
            "code": "7418",
            "localite": "Tumegl/Tomils"
        },
        {
            "code": "7419",
            "localite": "Scheid"
        },
        {
            "code": "7421",
            "localite": "Summaprada"
        },
        {
            "code": "7422",
            "localite": "Tartar"
        },
        {
            "code": "7423",
            "localite": "Portein"
        },
        {
            "code": "7423",
            "localite": "Sarn"
        },
        {
            "code": "7424",
            "localite": "Dalin"
        },
        {
            "code": "7424",
            "localite": "Präz"
        },
        {
            "code": "7425",
            "localite": "Masein"
        },
        {
            "code": "7426",
            "localite": "Flerden"
        },
        {
            "code": "7427",
            "localite": "Urmein"
        },
        {
            "code": "7428",
            "localite": "Tschappina"
        },
        {
            "code": "7430",
            "localite": "Rongellen"
        },
        {
            "code": "7430",
            "localite": "Thusis"
        },
        {
            "code": "7431",
            "localite": "Mutten"
        },
        {
            "code": "7431",
            "localite": "Obermutten"
        },
        {
            "code": "7432",
            "localite": "Zillis"
        },
        {
            "code": "7433",
            "localite": "Donat"
        },
        {
            "code": "7433",
            "localite": "Lohn GR"
        },
        {
            "code": "7433",
            "localite": "Mathon"
        },
        {
            "code": "7433",
            "localite": "Wergenstein"
        },
        {
            "code": "7434",
            "localite": "Sufers"
        },
        {
            "code": "7435",
            "localite": "Splügen"
        },
        {
            "code": "7436",
            "localite": "Medels im Rheinwald"
        },
        {
            "code": "7437",
            "localite": "Nufenen"
        },
        {
            "code": "7438",
            "localite": "Hinterrhein"
        },
        {
            "code": "7440",
            "localite": "Andeer"
        },
        {
            "code": "7442",
            "localite": "Clugin"
        },
        {
            "code": "7443",
            "localite": "Pignia"
        },
        {
            "code": "7444",
            "localite": "Ausserferrera"
        },
        {
            "code": "7445",
            "localite": "Innerferrera"
        },
        {
            "code": "7447",
            "localite": "Avers"
        },
        {
            "code": "7448",
            "localite": "Juf"
        },
        {
            "code": "7450",
            "localite": "Tiefencastel"
        },
        {
            "code": "7451",
            "localite": "Alvaschein"
        },
        {
            "code": "7452",
            "localite": "Cunter"
        },
        {
            "code": "7453",
            "localite": "Tinizong"
        },
        {
            "code": "7454",
            "localite": "Rona"
        },
        {
            "code": "7455",
            "localite": "Mulegns"
        },
        {
            "code": "7456",
            "localite": "Marmorera"
        },
        {
            "code": "7456",
            "localite": "Sur"
        },
        {
            "code": "7457",
            "localite": "Bivio"
        },
        {
            "code": "7458",
            "localite": "Mon"
        },
        {
            "code": "7459",
            "localite": "Stierva"
        },
        {
            "code": "7460",
            "localite": "Savognin"
        },
        {
            "code": "7462",
            "localite": "Salouf"
        },
        {
            "code": "7463",
            "localite": "Riom"
        },
        {
            "code": "7464",
            "localite": "Parsonz"
        },
        {
            "code": "7472",
            "localite": "Surava"
        },
        {
            "code": "7473",
            "localite": "Alvaneu Bad"
        },
        {
            "code": "7477",
            "localite": "Filisur"
        },
        {
            "code": "7482",
            "localite": "Bergün/Bravuogn"
        },
        {
            "code": "7482",
            "localite": "Preda"
        },
        {
            "code": "7482",
            "localite": "Stugl/Stuls"
        },
        {
            "code": "7484",
            "localite": "Latsch"
        },
        {
            "code": "7492",
            "localite": "Alvaneu Dorf"
        },
        {
            "code": "7493",
            "localite": "Schmitten (Albula)"
        },
        {
            "code": "7494",
            "localite": "Davos Wiesen"
        },
        {
            "code": "7500",
            "localite": "St. Moritz"
        },
        {
            "code": "7502",
            "localite": "Bever"
        },
        {
            "code": "7503",
            "localite": "Samedan"
        },
        {
            "code": "7504",
            "localite": "Pontresina"
        },
        {
            "code": "7505",
            "localite": "Celerina/Schlarigna"
        },
        {
            "code": "7512",
            "localite": "Champfèr"
        },
        {
            "code": "7513",
            "localite": "Silvaplana"
        },
        {
            "code": "7513",
            "localite": "Silvaplana-Surlej"
        },
        {
            "code": "7514",
            "localite": "Fex"
        },
        {
            "code": "7514",
            "localite": "Sils/Segl Maria"
        },
        {
            "code": "7515",
            "localite": "Sils/Segl Baselgia"
        },
        {
            "code": "7516",
            "localite": "Maloja"
        },
        {
            "code": "7517",
            "localite": "Plaun da Lej"
        },
        {
            "code": "7522",
            "localite": "La Punt Chamues-ch"
        },
        {
            "code": "7523",
            "localite": "Madulain"
        },
        {
            "code": "7524",
            "localite": "Zuoz"
        },
        {
            "code": "7525",
            "localite": "S-chanf"
        },
        {
            "code": "7526",
            "localite": "Chapella"
        },
        {
            "code": "7526",
            "localite": "Cinuos-chel"
        },
        {
            "code": "7527",
            "localite": "Brail"
        },
        {
            "code": "7530",
            "localite": "Zernez"
        },
        {
            "code": "7532",
            "localite": "Tschierv"
        },
        {
            "code": "7533",
            "localite": "Fuldera"
        },
        {
            "code": "7534",
            "localite": "Lü"
        },
        {
            "code": "7535",
            "localite": "Valchava"
        },
        {
            "code": "7536",
            "localite": "Sta. Maria Val Müstair"
        },
        {
            "code": "7537",
            "localite": "Müstair"
        },
        {
            "code": "7542",
            "localite": "Susch"
        },
        {
            "code": "7543",
            "localite": "Lavin"
        },
        {
            "code": "7545",
            "localite": "Guarda"
        },
        {
            "code": "7546",
            "localite": "Ardez"
        },
        {
            "code": "7550",
            "localite": "Scuol"
        },
        {
            "code": "7551",
            "localite": "Ftan"
        },
        {
            "code": "7552",
            "localite": "Vulpera"
        },
        {
            "code": "7553",
            "localite": "Tarasp"
        },
        {
            "code": "7554",
            "localite": "Sent"
        },
        {
            "code": "7556",
            "localite": "Ramosch"
        },
        {
            "code": "7557",
            "localite": "Vnà"
        },
        {
            "code": "7558",
            "localite": "Strada"
        },
        {
            "code": "7559",
            "localite": "Tschlin"
        },
        {
            "code": "7560",
            "localite": "Martina"
        },
        {
            "code": "7562",
            "localite": "Samnaun-Compatsch"
        },
        {
            "code": "7563",
            "localite": "Samnaun Dorf"
        },
        {
            "code": "7602",
            "localite": "Casaccia"
        },
        {
            "code": "7603",
            "localite": "Vicosoprano"
        },
        {
            "code": "7604",
            "localite": "Borgonovo"
        },
        {
            "code": "7605",
            "localite": "Stampa"
        },
        {
            "code": "7606",
            "localite": "Bondo"
        },
        {
            "code": "7606",
            "localite": "Promontogno"
        },
        {
            "code": "7608",
            "localite": "Castasegna"
        },
        {
            "code": "7610",
            "localite": "Soglio"
        },
        {
            "code": "7710",
            "localite": "Alp Grüm"
        },
        {
            "code": "7710",
            "localite": "Ospizio Bernina"
        },
        {
            "code": "7741",
            "localite": "S. Carlo (Poschiavo)"
        },
        {
            "code": "7742",
            "localite": "La Rösa"
        },
        {
            "code": "7742",
            "localite": "Poschiavo"
        },
        {
            "code": "7742",
            "localite": "Sfazù"
        },
        {
            "code": "7743",
            "localite": "Brusio"
        },
        {
            "code": "7743",
            "localite": "Miralago"
        },
        {
            "code": "7744",
            "localite": "Campocologno"
        },
        {
            "code": "7745",
            "localite": "Li Curt"
        },
        {
            "code": "7746",
            "localite": "Le Prese"
        },
        {
            "code": "7747",
            "localite": "Viano"
        },
        {
            "code": "7748",
            "localite": "Campascio"
        },
        {
            "code": "8001",
            "localite": "Zürich"
        },
        {
            "code": "8002",
            "localite": "Zürich"
        },
        {
            "code": "8003",
            "localite": "Zürich"
        },
        {
            "code": "8004",
            "localite": "Zürich"
        },
        {
            "code": "8005",
            "localite": "Zürich"
        },
        {
            "code": "8006",
            "localite": "Zürich"
        },
        {
            "code": "8008",
            "localite": "Zürich"
        },
        {
            "code": "8032",
            "localite": "Zürich"
        },
        {
            "code": "8037",
            "localite": "Zürich"
        },
        {
            "code": "8038",
            "localite": "Zürich"
        },
        {
            "code": "8041",
            "localite": "Zürich"
        },
        {
            "code": "8044",
            "localite": "Gockhausen"
        },
        {
            "code": "8044",
            "localite": "Zürich"
        },
        {
            "code": "8045",
            "localite": "Zürich"
        },
        {
            "code": "8046",
            "localite": "Zürich"
        },
        {
            "code": "8047",
            "localite": "Zürich"
        },
        {
            "code": "8048",
            "localite": "Zürich"
        },
        {
            "code": "8049",
            "localite": "Zürich"
        },
        {
            "code": "8050",
            "localite": "Zürich"
        },
        {
            "code": "8051",
            "localite": "Zürich"
        },
        {
            "code": "8052",
            "localite": "Zürich"
        },
        {
            "code": "8053",
            "localite": "Zürich"
        },
        {
            "code": "8055",
            "localite": "Zürich"
        },
        {
            "code": "8057",
            "localite": "Zürich"
        },
        {
            "code": "8064",
            "localite": "Zürich"
        },
        {
            "code": "8102",
            "localite": "Oberengstringen"
        },
        {
            "code": "8103",
            "localite": "Unterengstringen"
        },
        {
            "code": "8104",
            "localite": "Weiningen ZH"
        },
        {
            "code": "8105",
            "localite": "Regensdorf"
        },
        {
            "code": "8105",
            "localite": "Watt"
        },
        {
            "code": "8106",
            "localite": "Adlikon b. Regensdorf"
        },
        {
            "code": "8107",
            "localite": "Buchs ZH"
        },
        {
            "code": "8108",
            "localite": "Dällikon"
        },
        {
            "code": "8109",
            "localite": "Kloster Fahr"
        },
        {
            "code": "8112",
            "localite": "Otelfingen"
        },
        {
            "code": "8113",
            "localite": "Boppelsen"
        },
        {
            "code": "8114",
            "localite": "Dänikon ZH"
        },
        {
            "code": "8115",
            "localite": "Hüttikon"
        },
        {
            "code": "8117",
            "localite": "Fällanden"
        },
        {
            "code": "8118",
            "localite": "Pfaffhausen"
        },
        {
            "code": "8121",
            "localite": "Benglen"
        },
        {
            "code": "8122",
            "localite": "Binz"
        },
        {
            "code": "8123",
            "localite": "Ebmatingen"
        },
        {
            "code": "8124",
            "localite": "Maur"
        },
        {
            "code": "8125",
            "localite": "Zollikerberg"
        },
        {
            "code": "8126",
            "localite": "Zumikon"
        },
        {
            "code": "8127",
            "localite": "Forch"
        },
        {
            "code": "8132",
            "localite": "Egg b. Zürich"
        },
        {
            "code": "8132",
            "localite": "Hinteregg"
        },
        {
            "code": "8133",
            "localite": "Esslingen"
        },
        {
            "code": "8134",
            "localite": "Adliswil"
        },
        {
            "code": "8135",
            "localite": "Langnau am Albis"
        },
        {
            "code": "8135",
            "localite": "Sihlbrugg Station"
        },
        {
            "code": "8135",
            "localite": "Sihlwald"
        },
        {
            "code": "8136",
            "localite": "Gattikon"
        },
        {
            "code": "8142",
            "localite": "Uitikon Waldegg"
        },
        {
            "code": "8143",
            "localite": "Stallikon"
        },
        {
            "code": "8143",
            "localite": "Uetliberg"
        },
        {
            "code": "8152",
            "localite": "Glattbrugg"
        },
        {
            "code": "8152",
            "localite": "Glattpark (Opfikon)"
        },
        {
            "code": "8152",
            "localite": "Opfikon"
        },
        {
            "code": "8153",
            "localite": "Rümlang"
        },
        {
            "code": "8154",
            "localite": "Oberglatt ZH"
        },
        {
            "code": "8155",
            "localite": "Nassenwil"
        },
        {
            "code": "8155",
            "localite": "Niederhasli"
        },
        {
            "code": "8156",
            "localite": "Oberhasli"
        },
        {
            "code": "8157",
            "localite": "Dielsdorf"
        },
        {
            "code": "8158",
            "localite": "Regensberg"
        },
        {
            "code": "8162",
            "localite": "Steinmaur"
        },
        {
            "code": "8162",
            "localite": "Sünikon"
        },
        {
            "code": "8164",
            "localite": "Bachs"
        },
        {
            "code": "8165",
            "localite": "Oberweningen"
        },
        {
            "code": "8165",
            "localite": "Schleinikon"
        },
        {
            "code": "8165",
            "localite": "Schöfflisdorf"
        },
        {
            "code": "8166",
            "localite": "Niederweningen"
        },
        {
            "code": "8172",
            "localite": "Niederglatt ZH"
        },
        {
            "code": "8173",
            "localite": "Neerach"
        },
        {
            "code": "8174",
            "localite": "Stadel b. Niederglatt"
        },
        {
            "code": "8175",
            "localite": "Windlach"
        },
        {
            "code": "8180",
            "localite": "Bülach"
        },
        {
            "code": "8181",
            "localite": "Höri"
        },
        {
            "code": "8182",
            "localite": "Hochfelden"
        },
        {
            "code": "8184",
            "localite": "Bachenbülach"
        },
        {
            "code": "8185",
            "localite": "Winkel"
        },
        {
            "code": "8187",
            "localite": "Weiach"
        },
        {
            "code": "8192",
            "localite": "Glattfelden"
        },
        {
            "code": "8192",
            "localite": "Zweidlen"
        },
        {
            "code": "8193",
            "localite": "Eglisau"
        },
        {
            "code": "8194",
            "localite": "Hüntwangen"
        },
        {
            "code": "8195",
            "localite": "Wasterkingen"
        },
        {
            "code": "8196",
            "localite": "Wil ZH"
        },
        {
            "code": "8197",
            "localite": "Rafz"
        },
        {
            "code": "8200",
            "localite": "Schaffhausen"
        },
        {
            "code": "8203",
            "localite": "Schaffhausen"
        },
        {
            "code": "8207",
            "localite": "Schaffhausen"
        },
        {
            "code": "8208",
            "localite": "Schaffhausen"
        },
        {
            "code": "8212",
            "localite": "Neuhausen am Rheinfall"
        },
        {
            "code": "8212",
            "localite": "Nohl"
        },
        {
            "code": "8213",
            "localite": "Neunkirch"
        },
        {
            "code": "8214",
            "localite": "Gächlingen"
        },
        {
            "code": "8215",
            "localite": "Hallau"
        },
        {
            "code": "8216",
            "localite": "Oberhallau"
        },
        {
            "code": "8217",
            "localite": "Wilchingen"
        },
        {
            "code": "8218",
            "localite": "Osterfingen"
        },
        {
            "code": "8219",
            "localite": "Trasadingen"
        },
        {
            "code": "8222",
            "localite": "Beringen"
        },
        {
            "code": "8223",
            "localite": "Guntmadingen"
        },
        {
            "code": "8224",
            "localite": "Löhningen"
        },
        {
            "code": "8225",
            "localite": "Siblingen"
        },
        {
            "code": "8226",
            "localite": "Schleitheim"
        },
        {
            "code": "8228",
            "localite": "Beggingen"
        },
        {
            "code": "8231",
            "localite": "Hemmental"
        },
        {
            "code": "8232",
            "localite": "Merishausen"
        },
        {
            "code": "8233",
            "localite": "Bargen SH"
        },
        {
            "code": "8234",
            "localite": "Stetten SH"
        },
        {
            "code": "8235",
            "localite": "Lohn SH"
        },
        {
            "code": "8236",
            "localite": "Büttenhardt"
        },
        {
            "code": "8236",
            "localite": "Opfertshofen SH"
        },
        {
            "code": "8239",
            "localite": "Dörflingen"
        },
        {
            "code": "8240",
            "localite": "Thayngen"
        },
        {
            "code": "8241",
            "localite": "Barzheim"
        },
        {
            "code": "8242",
            "localite": "Bibern SH"
        },
        {
            "code": "8242",
            "localite": "Hofen SH"
        },
        {
            "code": "8243",
            "localite": "Altdorf SH"
        },
        {
            "code": "8245",
            "localite": "Feuerthalen"
        },
        {
            "code": "8246",
            "localite": "Langwiesen"
        },
        {
            "code": "8247",
            "localite": "Flurlingen"
        },
        {
            "code": "8248",
            "localite": "Uhwiesen"
        },
        {
            "code": "8252",
            "localite": "Schlatt TG"
        },
        {
            "code": "8253",
            "localite": "Diessenhofen"
        },
        {
            "code": "8253",
            "localite": "Willisdorf"
        },
        {
            "code": "8254",
            "localite": "Basadingen"
        },
        {
            "code": "8255",
            "localite": "Schlattingen"
        },
        {
            "code": "8259",
            "localite": "Etzwilen"
        },
        {
            "code": "8259",
            "localite": "Kaltenbach"
        },
        {
            "code": "8259",
            "localite": "Rheinklingen"
        },
        {
            "code": "8259",
            "localite": "Wagenhausen"
        },
        {
            "code": "8260",
            "localite": "Stein am Rhein"
        },
        {
            "code": "8261",
            "localite": "Hemishofen"
        },
        {
            "code": "8262",
            "localite": "Ramsen"
        },
        {
            "code": "8263",
            "localite": "Buch SH"
        },
        {
            "code": "8264",
            "localite": "Eschenz"
        },
        {
            "code": "8265",
            "localite": "Mammern"
        },
        {
            "code": "8266",
            "localite": "Steckborn"
        },
        {
            "code": "8267",
            "localite": "Berlingen"
        },
        {
            "code": "8268",
            "localite": "Mannenbach-Salenstein"
        },
        {
            "code": "8268",
            "localite": "Salenstein"
        },
        {
            "code": "8269",
            "localite": "Fruthwilen"
        },
        {
            "code": "8272",
            "localite": "Ermatingen"
        },
        {
            "code": "8273",
            "localite": "Triboltingen"
        },
        {
            "code": "8274",
            "localite": "Gottlieben"
        },
        {
            "code": "8274",
            "localite": "Tägerwilen"
        },
        {
            "code": "8280",
            "localite": "Kreuzlingen"
        },
        {
            "code": "8302",
            "localite": "Kloten"
        },
        {
            "code": "8303",
            "localite": "Bassersdorf"
        },
        {
            "code": "8304",
            "localite": "Wallisellen"
        },
        {
            "code": "8305",
            "localite": "Dietlikon"
        },
        {
            "code": "8306",
            "localite": "Brüttisellen"
        },
        {
            "code": "8307",
            "localite": "Effretikon"
        },
        {
            "code": "8307",
            "localite": "Ottikon b. Kemptthal"
        },
        {
            "code": "8308",
            "localite": "Agasul"
        },
        {
            "code": "8308",
            "localite": "Illnau"
        },
        {
            "code": "8309",
            "localite": "Nürensdorf"
        },
        {
            "code": "8310",
            "localite": "Grafstal"
        },
        {
            "code": "8310",
            "localite": "Kemptthal"
        },
        {
            "code": "8311",
            "localite": "Brütten"
        },
        {
            "code": "8312",
            "localite": "Winterberg ZH"
        },
        {
            "code": "8314",
            "localite": "Kyburg"
        },
        {
            "code": "8315",
            "localite": "Lindau"
        },
        {
            "code": "8317",
            "localite": "Tagelswangen"
        },
        {
            "code": "8320",
            "localite": "Fehraltorf"
        },
        {
            "code": "8322",
            "localite": "Gündisau"
        },
        {
            "code": "8322",
            "localite": "Madetswil"
        },
        {
            "code": "8330",
            "localite": "Pfäffikon ZH"
        },
        {
            "code": "8331",
            "localite": "Auslikon"
        },
        {
            "code": "8332",
            "localite": "Rumlikon"
        },
        {
            "code": "8332",
            "localite": "Russikon"
        },
        {
            "code": "8335",
            "localite": "Hittnau"
        },
        {
            "code": "8340",
            "localite": "Hinwil"
        },
        {
            "code": "8342",
            "localite": "Wernetshausen"
        },
        {
            "code": "8344",
            "localite": "Bäretswil"
        },
        {
            "code": "8345",
            "localite": "Adetswil"
        },
        {
            "code": "8352",
            "localite": "Elsau"
        },
        {
            "code": "8352",
            "localite": "Ricketwil (Winterthur)"
        },
        {
            "code": "8353",
            "localite": "Elgg"
        },
        {
            "code": "8354",
            "localite": "Dickbuch"
        },
        {
            "code": "8354",
            "localite": "Hofstetten ZH"
        },
        {
            "code": "8355",
            "localite": "Aadorf"
        },
        {
            "code": "8356",
            "localite": "Ettenhausen TG"
        },
        {
            "code": "8357",
            "localite": "Guntershausen b. Aadorf"
        },
        {
            "code": "8360",
            "localite": "Eschlikon TG"
        },
        {
            "code": "8360",
            "localite": "Wallenwil"
        },
        {
            "code": "8362",
            "localite": "Balterswil"
        },
        {
            "code": "8363",
            "localite": "Bichelsee"
        },
        {
            "code": "8370",
            "localite": "Sirnach"
        },
        {
            "code": "8371",
            "localite": "Busswil TG"
        },
        {
            "code": "8372",
            "localite": "Wiezikon b. Sirnach"
        },
        {
            "code": "8374",
            "localite": "Dussnang"
        },
        {
            "code": "8374",
            "localite": "Oberwangen TG"
        },
        {
            "code": "8376",
            "localite": "Au TG"
        },
        {
            "code": "8376",
            "localite": "Fischingen"
        },
        {
            "code": "8400",
            "localite": "Winterthur"
        },
        {
            "code": "8404",
            "localite": "Reutlingen (Winterthur)"
        },
        {
            "code": "8404",
            "localite": "Stadel (Winterthur)"
        },
        {
            "code": "8404",
            "localite": "Winterthur"
        },
        {
            "code": "8405",
            "localite": "Winterthur"
        },
        {
            "code": "8406",
            "localite": "Winterthur"
        },
        {
            "code": "8408",
            "localite": "Winterthur"
        },
        {
            "code": "8409",
            "localite": "Winterthur"
        },
        {
            "code": "8412",
            "localite": "Aesch (Neftenbach)"
        },
        {
            "code": "8412",
            "localite": "Hünikon (Neftenbach)"
        },
        {
            "code": "8412",
            "localite": "Riet (Neftenbach)"
        },
        {
            "code": "8413",
            "localite": "Neftenbach"
        },
        {
            "code": "8414",
            "localite": "Buch am Irchel"
        },
        {
            "code": "8415",
            "localite": "Berg am Irchel"
        },
        {
            "code": "8415",
            "localite": "Gräslikon"
        },
        {
            "code": "8416",
            "localite": "Flaach"
        },
        {
            "code": "8418",
            "localite": "Schlatt ZH"
        },
        {
            "code": "8421",
            "localite": "Dättlikon"
        },
        {
            "code": "8422",
            "localite": "Pfungen"
        },
        {
            "code": "8424",
            "localite": "Embrach"
        },
        {
            "code": "8425",
            "localite": "Oberembrach"
        },
        {
            "code": "8426",
            "localite": "Lufingen"
        },
        {
            "code": "8427",
            "localite": "Freienstein"
        },
        {
            "code": "8427",
            "localite": "Rorbas"
        },
        {
            "code": "8428",
            "localite": "Teufen ZH"
        },
        {
            "code": "8442",
            "localite": "Hettlingen"
        },
        {
            "code": "8444",
            "localite": "Henggart"
        },
        {
            "code": "8447",
            "localite": "Dachsen"
        },
        {
            "code": "8450",
            "localite": "Andelfingen"
        },
        {
            "code": "8451",
            "localite": "Kleinandelfingen"
        },
        {
            "code": "8452",
            "localite": "Adlikon b. Andelfingen"
        },
        {
            "code": "8453",
            "localite": "Alten"
        },
        {
            "code": "8454",
            "localite": "Buchberg"
        },
        {
            "code": "8455",
            "localite": "Rüdlingen"
        },
        {
            "code": "8457",
            "localite": "Humlikon"
        },
        {
            "code": "8458",
            "localite": "Dorf"
        },
        {
            "code": "8459",
            "localite": "Volken"
        },
        {
            "code": "8460",
            "localite": "Marthalen"
        },
        {
            "code": "8461",
            "localite": "Oerlingen"
        },
        {
            "code": "8462",
            "localite": "Rheinau"
        },
        {
            "code": "8463",
            "localite": "Benken ZH"
        },
        {
            "code": "8464",
            "localite": "Ellikon am Rhein"
        },
        {
            "code": "8465",
            "localite": "Rudolfingen"
        },
        {
            "code": "8465",
            "localite": "Wildensbuch"
        },
        {
            "code": "8466",
            "localite": "Trüllikon"
        },
        {
            "code": "8467",
            "localite": "Truttikon"
        },
        {
            "code": "8468",
            "localite": "Guntalingen"
        },
        {
            "code": "8468",
            "localite": "Waltalingen"
        },
        {
            "code": "8471",
            "localite": "Berg (Dägerlen)"
        },
        {
            "code": "8471",
            "localite": "Bänk (Dägerlen)"
        },
        {
            "code": "8471",
            "localite": "Dägerlen"
        },
        {
            "code": "8471",
            "localite": "Oberwil (Dägerlen)"
        },
        {
            "code": "8471",
            "localite": "Rutschwil (Dägerlen)"
        },
        {
            "code": "8472",
            "localite": "Oberohringen"
        },
        {
            "code": "8472",
            "localite": "Seuzach"
        },
        {
            "code": "8472",
            "localite": "Unterohringen"
        },
        {
            "code": "8474",
            "localite": "Dinhard"
        },
        {
            "code": "8475",
            "localite": "Ossingen"
        },
        {
            "code": "8476",
            "localite": "Unterstammheim"
        },
        {
            "code": "8477",
            "localite": "Oberstammheim"
        },
        {
            "code": "8478",
            "localite": "Thalheim an der Thur"
        },
        {
            "code": "8479",
            "localite": "Altikon"
        },
        {
            "code": "8482",
            "localite": "Sennhof (Winterthur)"
        },
        {
            "code": "8483",
            "localite": "Kollbrunn"
        },
        {
            "code": "8484",
            "localite": "Neschwil"
        },
        {
            "code": "8484",
            "localite": "Theilingen"
        },
        {
            "code": "8484",
            "localite": "Weisslingen"
        },
        {
            "code": "8486",
            "localite": "Rikon im Tösstal"
        },
        {
            "code": "8487",
            "localite": "Rämismühle"
        },
        {
            "code": "8487",
            "localite": "Zell ZH"
        },
        {
            "code": "8488",
            "localite": "Turbenthal"
        },
        {
            "code": "8489",
            "localite": "Ehrikon"
        },
        {
            "code": "8489",
            "localite": "Schalchen"
        },
        {
            "code": "8489",
            "localite": "Wildberg"
        },
        {
            "code": "8492",
            "localite": "Wila"
        },
        {
            "code": "8493",
            "localite": "Saland"
        },
        {
            "code": "8494",
            "localite": "Bauma"
        },
        {
            "code": "8495",
            "localite": "Schmidrüti"
        },
        {
            "code": "8496",
            "localite": "Steg im Tösstal"
        },
        {
            "code": "8497",
            "localite": "Fischenthal"
        },
        {
            "code": "8498",
            "localite": "Gibswil"
        },
        {
            "code": "8499",
            "localite": "Sternenberg"
        },
        {
            "code": "8500",
            "localite": "Frauenfeld"
        },
        {
            "code": "8500",
            "localite": "Gerlikon"
        },
        {
            "code": "8505",
            "localite": "Dettighofen"
        },
        {
            "code": "8505",
            "localite": "Pfyn"
        },
        {
            "code": "8506",
            "localite": "Lanzenneunforn"
        },
        {
            "code": "8507",
            "localite": "Hörhausen"
        },
        {
            "code": "8508",
            "localite": "Homburg"
        },
        {
            "code": "8512",
            "localite": "Lustdorf"
        },
        {
            "code": "8512",
            "localite": "Thundorf"
        },
        {
            "code": "8512",
            "localite": "Wetzikon TG"
        },
        {
            "code": "8514",
            "localite": "Amlikon-Bissegg"
        },
        {
            "code": "8522",
            "localite": "Aawangen"
        },
        {
            "code": "8522",
            "localite": "Häuslenen"
        },
        {
            "code": "8523",
            "localite": "Hagenbuch ZH"
        },
        {
            "code": "8524",
            "localite": "Buch b. Frauenfeld"
        },
        {
            "code": "8524",
            "localite": "Uesslingen"
        },
        {
            "code": "8525",
            "localite": "Niederneunforn"
        },
        {
            "code": "8525",
            "localite": "Wilen b. Neunforn"
        },
        {
            "code": "8526",
            "localite": "Oberneunforn"
        },
        {
            "code": "8532",
            "localite": "Warth"
        },
        {
            "code": "8532",
            "localite": "Weiningen TG"
        },
        {
            "code": "8535",
            "localite": "Herdern"
        },
        {
            "code": "8536",
            "localite": "Hüttwilen"
        },
        {
            "code": "8537",
            "localite": "Nussbaumen TG"
        },
        {
            "code": "8537",
            "localite": "Uerschhausen"
        },
        {
            "code": "8542",
            "localite": "Wiesendangen"
        },
        {
            "code": "8543",
            "localite": "Bertschikon"
        },
        {
            "code": "8543",
            "localite": "Gundetswil"
        },
        {
            "code": "8543",
            "localite": "Kefikon ZH"
        },
        {
            "code": "8544",
            "localite": "Attikon"
        },
        {
            "code": "8545",
            "localite": "Rickenbach Sulz"
        },
        {
            "code": "8545",
            "localite": "Rickenbach ZH"
        },
        {
            "code": "8546",
            "localite": "Islikon"
        },
        {
            "code": "8546",
            "localite": "Kefikon TG"
        },
        {
            "code": "8546",
            "localite": "Menzengrüt"
        },
        {
            "code": "8547",
            "localite": "Gachnang"
        },
        {
            "code": "8548",
            "localite": "Ellikon an der Thur"
        },
        {
            "code": "8552",
            "localite": "Felben-Wellhausen"
        },
        {
            "code": "8553",
            "localite": "Eschikofen"
        },
        {
            "code": "8553",
            "localite": "Harenwilen"
        },
        {
            "code": "8553",
            "localite": "Hüttlingen"
        },
        {
            "code": "8553",
            "localite": "Mettendorf TG"
        },
        {
            "code": "8554",
            "localite": "Bonau"
        },
        {
            "code": "8554",
            "localite": "Müllheim-Wigoltingen"
        },
        {
            "code": "8555",
            "localite": "Müllheim Dorf"
        },
        {
            "code": "8556",
            "localite": "Engwang"
        },
        {
            "code": "8556",
            "localite": "Illhart"
        },
        {
            "code": "8556",
            "localite": "Lamperswil TG"
        },
        {
            "code": "8556",
            "localite": "Wigoltingen"
        },
        {
            "code": "8558",
            "localite": "Raperswilen"
        },
        {
            "code": "8560",
            "localite": "Märstetten"
        },
        {
            "code": "8561",
            "localite": "Ottoberg"
        },
        {
            "code": "8564",
            "localite": "Engwilen"
        },
        {
            "code": "8564",
            "localite": "Gunterswilen"
        },
        {
            "code": "8564",
            "localite": "Hattenhausen"
        },
        {
            "code": "8564",
            "localite": "Hefenhausen"
        },
        {
            "code": "8564",
            "localite": "Lipperswil"
        },
        {
            "code": "8564",
            "localite": "Sonterswil"
        },
        {
            "code": "8564",
            "localite": "Wagerswil"
        },
        {
            "code": "8564",
            "localite": "Wäldi"
        },
        {
            "code": "8565",
            "localite": "Hugelshofen"
        },
        {
            "code": "8566",
            "localite": "Dotnacht"
        },
        {
            "code": "8566",
            "localite": "Ellighausen"
        },
        {
            "code": "8566",
            "localite": "Lippoldswilen"
        },
        {
            "code": "8566",
            "localite": "Neuwilen"
        },
        {
            "code": "8570",
            "localite": "Weinfelden"
        },
        {
            "code": "8572",
            "localite": "Andhausen"
        },
        {
            "code": "8572",
            "localite": "Berg TG"
        },
        {
            "code": "8572",
            "localite": "Graltshausen"
        },
        {
            "code": "8572",
            "localite": "Guntershausen b. Berg"
        },
        {
            "code": "8573",
            "localite": "Alterswilen"
        },
        {
            "code": "8573",
            "localite": "Altishausen"
        },
        {
            "code": "8573",
            "localite": "Siegershausen"
        },
        {
            "code": "8574",
            "localite": "Dettighofen (Lengwil)"
        },
        {
            "code": "8574",
            "localite": "Illighausen"
        },
        {
            "code": "8574",
            "localite": "Lengwil"
        },
        {
            "code": "8574",
            "localite": "Oberhofen TG"
        },
        {
            "code": "8575",
            "localite": "Bürglen TG"
        },
        {
            "code": "8575",
            "localite": "Istighofen"
        },
        {
            "code": "8576",
            "localite": "Mauren TG"
        },
        {
            "code": "8577",
            "localite": "Schönholzerswilen"
        },
        {
            "code": "8580",
            "localite": "Amriswil"
        },
        {
            "code": "8580",
            "localite": "Biessenhofen"
        },
        {
            "code": "8580",
            "localite": "Hagenwil b. Amriswil"
        },
        {
            "code": "8580",
            "localite": "Hefenhofen"
        },
        {
            "code": "8580",
            "localite": "Sommeri"
        },
        {
            "code": "8581",
            "localite": "Schocherswil"
        },
        {
            "code": "8582",
            "localite": "Dozwil"
        },
        {
            "code": "8583",
            "localite": "Donzhausen"
        },
        {
            "code": "8583",
            "localite": "Götighofen"
        },
        {
            "code": "8583",
            "localite": "Sulgen"
        },
        {
            "code": "8584",
            "localite": "Leimbach TG"
        },
        {
            "code": "8584",
            "localite": "Opfershofen TG"
        },
        {
            "code": "8585",
            "localite": "Birwinken"
        },
        {
            "code": "8585",
            "localite": "Happerswil"
        },
        {
            "code": "8585",
            "localite": "Herrenhof"
        },
        {
            "code": "8585",
            "localite": "Klarsreuti"
        },
        {
            "code": "8585",
            "localite": "Langrickenbach"
        },
        {
            "code": "8585",
            "localite": "Mattwil"
        },
        {
            "code": "8585",
            "localite": "Schönenbaumgarten"
        },
        {
            "code": "8585",
            "localite": "Zuben"
        },
        {
            "code": "8586",
            "localite": "Andwil TG"
        },
        {
            "code": "8586",
            "localite": "Buch b. Kümmertshausen"
        },
        {
            "code": "8586",
            "localite": "Buchackern"
        },
        {
            "code": "8586",
            "localite": "Engishofen"
        },
        {
            "code": "8586",
            "localite": "Ennetaach"
        },
        {
            "code": "8586",
            "localite": "Erlen"
        },
        {
            "code": "8586",
            "localite": "Kümmertshausen"
        },
        {
            "code": "8586",
            "localite": "Riedt b. Erlen"
        },
        {
            "code": "8587",
            "localite": "Oberaach"
        },
        {
            "code": "8588",
            "localite": "Zihlschlacht"
        },
        {
            "code": "8589",
            "localite": "Sitterdorf"
        },
        {
            "code": "8590",
            "localite": "Romanshorn"
        },
        {
            "code": "8592",
            "localite": "Uttwil"
        },
        {
            "code": "8593",
            "localite": "Kesswil"
        },
        {
            "code": "8594",
            "localite": "Güttingen"
        },
        {
            "code": "8595",
            "localite": "Altnau"
        },
        {
            "code": "8596",
            "localite": "Münsterlingen"
        },
        {
            "code": "8596",
            "localite": "Scherzingen"
        },
        {
            "code": "8597",
            "localite": "Landschlacht"
        },
        {
            "code": "8598",
            "localite": "Bottighofen"
        },
        {
            "code": "8599",
            "localite": "Salmsach"
        },
        {
            "code": "8600",
            "localite": "Dübendorf"
        },
        {
            "code": "8602",
            "localite": "Wangen b. Dübendorf"
        },
        {
            "code": "8603",
            "localite": "Schwerzenbach"
        },
        {
            "code": "8604",
            "localite": "Volketswil"
        },
        {
            "code": "8605",
            "localite": "Gutenswil"
        },
        {
            "code": "8606",
            "localite": "Greifensee"
        },
        {
            "code": "8606",
            "localite": "Nänikon"
        },
        {
            "code": "8607",
            "localite": "Aathal-Seegräben"
        },
        {
            "code": "8608",
            "localite": "Bubikon"
        },
        {
            "code": "8610",
            "localite": "Uster"
        },
        {
            "code": "8614",
            "localite": "Bertschikon (Gossau ZH)"
        },
        {
            "code": "8614",
            "localite": "Sulzbach"
        },
        {
            "code": "8615",
            "localite": "Freudwil"
        },
        {
            "code": "8615",
            "localite": "Wermatswil"
        },
        {
            "code": "8616",
            "localite": "Riedikon"
        },
        {
            "code": "8617",
            "localite": "Mönchaltorf"
        },
        {
            "code": "8618",
            "localite": "Oetwil am See"
        },
        {
            "code": "8620",
            "localite": "Wetzikon ZH"
        },
        {
            "code": "8623",
            "localite": "Wetzikon ZH"
        },
        {
            "code": "8624",
            "localite": "Grüt (Gossau ZH)"
        },
        {
            "code": "8625",
            "localite": "Gossau ZH"
        },
        {
            "code": "8626",
            "localite": "Ottikon (Gossau ZH)"
        },
        {
            "code": "8627",
            "localite": "Grüningen"
        },
        {
            "code": "8630",
            "localite": "Rüti ZH"
        },
        {
            "code": "8632",
            "localite": "Tann"
        },
        {
            "code": "8633",
            "localite": "Wolfhausen"
        },
        {
            "code": "8634",
            "localite": "Hombrechtikon"
        },
        {
            "code": "8635",
            "localite": "Dürnten"
        },
        {
            "code": "8636",
            "localite": "Wald ZH"
        },
        {
            "code": "8637",
            "localite": "Laupen ZH"
        },
        {
            "code": "8638",
            "localite": "Goldingen"
        },
        {
            "code": "8640",
            "localite": "Hurden"
        },
        {
            "code": "8640",
            "localite": "Rapperswil SG"
        },
        {
            "code": "8645",
            "localite": "Jona"
        },
        {
            "code": "8646",
            "localite": "Wagen"
        },
        {
            "code": "8700",
            "localite": "Küsnacht ZH"
        },
        {
            "code": "8702",
            "localite": "Zollikon"
        },
        {
            "code": "8703",
            "localite": "Erlenbach ZH"
        },
        {
            "code": "8704",
            "localite": "Herrliberg"
        },
        {
            "code": "8706",
            "localite": "Meilen"
        },
        {
            "code": "8707",
            "localite": "Uetikon am See"
        },
        {
            "code": "8708",
            "localite": "Männedorf"
        },
        {
            "code": "8712",
            "localite": "Stäfa"
        },
        {
            "code": "8713",
            "localite": "Uerikon"
        },
        {
            "code": "8714",
            "localite": "Feldbach"
        },
        {
            "code": "8715",
            "localite": "Bollingen"
        },
        {
            "code": "8716",
            "localite": "Schmerikon"
        },
        {
            "code": "8717",
            "localite": "Benken SG"
        },
        {
            "code": "8718",
            "localite": "Schänis"
        },
        {
            "code": "8722",
            "localite": "Kaltbrunn"
        },
        {
            "code": "8723",
            "localite": "Maseltrangen"
        },
        {
            "code": "8723",
            "localite": "Rufi"
        },
        {
            "code": "8725",
            "localite": "Ernetschwil"
        },
        {
            "code": "8725",
            "localite": "Gebertingen"
        },
        {
            "code": "8726",
            "localite": "Ricken SG"
        },
        {
            "code": "8727",
            "localite": "Walde SG"
        },
        {
            "code": "8730",
            "localite": "Uznach"
        },
        {
            "code": "8732",
            "localite": "Neuhaus SG"
        },
        {
            "code": "8733",
            "localite": "Eschenbach SG"
        },
        {
            "code": "8734",
            "localite": "Ermenswil"
        },
        {
            "code": "8735",
            "localite": "Rüeterswil"
        },
        {
            "code": "8735",
            "localite": "St. Gallenkappel"
        },
        {
            "code": "8737",
            "localite": "Gommiswald"
        },
        {
            "code": "8738",
            "localite": "Uetliburg SG"
        },
        {
            "code": "8739",
            "localite": "Rieden SG"
        },
        {
            "code": "8750",
            "localite": "Glarus"
        },
        {
            "code": "8750",
            "localite": "Klöntal"
        },
        {
            "code": "8750",
            "localite": "Riedern"
        },
        {
            "code": "8751",
            "localite": "Urnerboden"
        },
        {
            "code": "8752",
            "localite": "Näfels"
        },
        {
            "code": "8753",
            "localite": "Mollis"
        },
        {
            "code": "8754",
            "localite": "Netstal"
        },
        {
            "code": "8755",
            "localite": "Ennenda"
        },
        {
            "code": "8756",
            "localite": "Mitlödi"
        },
        {
            "code": "8757",
            "localite": "Filzbach"
        },
        {
            "code": "8758",
            "localite": "Obstalden"
        },
        {
            "code": "8762",
            "localite": "Schwanden GL"
        },
        {
            "code": "8762",
            "localite": "Schwändi b. Schwanden"
        },
        {
            "code": "8762",
            "localite": "Sool"
        },
        {
            "code": "8765",
            "localite": "Engi"
        },
        {
            "code": "8766",
            "localite": "Matt"
        },
        {
            "code": "8767",
            "localite": "Elm"
        },
        {
            "code": "8772",
            "localite": "Nidfurn"
        },
        {
            "code": "8773",
            "localite": "Haslen GL"
        },
        {
            "code": "8774",
            "localite": "Leuggelbach"
        },
        {
            "code": "8775",
            "localite": "Hätzingen"
        },
        {
            "code": "8775",
            "localite": "Luchsingen"
        },
        {
            "code": "8777",
            "localite": "Betschwanden"
        },
        {
            "code": "8777",
            "localite": "Diesbach GL"
        },
        {
            "code": "8782",
            "localite": "Rüti GL"
        },
        {
            "code": "8783",
            "localite": "Linthal"
        },
        {
            "code": "8784",
            "localite": "Braunwald"
        },
        {
            "code": "8800",
            "localite": "Thalwil"
        },
        {
            "code": "8802",
            "localite": "Kilchberg ZH"
        },
        {
            "code": "8803",
            "localite": "Rüschlikon"
        },
        {
            "code": "8804",
            "localite": "Au ZH"
        },
        {
            "code": "8805",
            "localite": "Richterswil"
        },
        {
            "code": "8806",
            "localite": "Bäch SZ"
        },
        {
            "code": "8807",
            "localite": "Freienbach"
        },
        {
            "code": "8808",
            "localite": "Pfäffikon SZ"
        },
        {
            "code": "8810",
            "localite": "Horgen"
        },
        {
            "code": "8815",
            "localite": "Horgenberg"
        },
        {
            "code": "8816",
            "localite": "Hirzel"
        },
        {
            "code": "8820",
            "localite": "Wädenswil"
        },
        {
            "code": "8824",
            "localite": "Schönenberg ZH"
        },
        {
            "code": "8825",
            "localite": "Hütten"
        },
        {
            "code": "8832",
            "localite": "Wilen b. Wollerau"
        },
        {
            "code": "8832",
            "localite": "Wollerau"
        },
        {
            "code": "8833",
            "localite": "Samstagern"
        },
        {
            "code": "8834",
            "localite": "Schindellegi"
        },
        {
            "code": "8835",
            "localite": "Feusisberg"
        },
        {
            "code": "8836",
            "localite": "Bennau"
        },
        {
            "code": "8840",
            "localite": "Einsiedeln"
        },
        {
            "code": "8840",
            "localite": "Trachslau"
        },
        {
            "code": "8841",
            "localite": "Gross"
        },
        {
            "code": "8842",
            "localite": "Unteriberg"
        },
        {
            "code": "8843",
            "localite": "Oberiberg"
        },
        {
            "code": "8844",
            "localite": "Euthal"
        },
        {
            "code": "8845",
            "localite": "Studen SZ"
        },
        {
            "code": "8846",
            "localite": "Willerzell"
        },
        {
            "code": "8847",
            "localite": "Egg SZ"
        },
        {
            "code": "8849",
            "localite": "Alpthal"
        },
        {
            "code": "8852",
            "localite": "Altendorf"
        },
        {
            "code": "8853",
            "localite": "Lachen SZ"
        },
        {
            "code": "8854",
            "localite": "Galgenen"
        },
        {
            "code": "8854",
            "localite": "Siebnen"
        },
        {
            "code": "8855",
            "localite": "Wangen SZ"
        },
        {
            "code": "8856",
            "localite": "Tuggen"
        },
        {
            "code": "8857",
            "localite": "Vorderthal"
        },
        {
            "code": "8858",
            "localite": "Innerthal"
        },
        {
            "code": "8862",
            "localite": "Schübelbach"
        },
        {
            "code": "8863",
            "localite": "Buttikon SZ"
        },
        {
            "code": "8864",
            "localite": "Reichenburg"
        },
        {
            "code": "8865",
            "localite": "Bilten"
        },
        {
            "code": "8866",
            "localite": "Ziegelbrücke"
        },
        {
            "code": "8867",
            "localite": "Niederurnen"
        },
        {
            "code": "8868",
            "localite": "Oberurnen"
        },
        {
            "code": "8872",
            "localite": "Weesen"
        },
        {
            "code": "8873",
            "localite": "Amden"
        },
        {
            "code": "8874",
            "localite": "Mühlehorn"
        },
        {
            "code": "8877",
            "localite": "Murg"
        },
        {
            "code": "8878",
            "localite": "Quinten"
        },
        {
            "code": "8880",
            "localite": "Walenstadt"
        },
        {
            "code": "8881",
            "localite": "Tscherlach"
        },
        {
            "code": "8881",
            "localite": "Walenstadtberg"
        },
        {
            "code": "8882",
            "localite": "Unterterzen"
        },
        {
            "code": "8883",
            "localite": "Quarten"
        },
        {
            "code": "8884",
            "localite": "Oberterzen"
        },
        {
            "code": "8885",
            "localite": "Mols"
        },
        {
            "code": "8886",
            "localite": "Mädris-Vermol"
        },
        {
            "code": "8887",
            "localite": "Mels"
        },
        {
            "code": "8888",
            "localite": "Heiligkreuz (Mels)"
        },
        {
            "code": "8889",
            "localite": "Plons"
        },
        {
            "code": "8890",
            "localite": "Flums"
        },
        {
            "code": "8892",
            "localite": "Berschis"
        },
        {
            "code": "8893",
            "localite": "Flums Hochwiese"
        },
        {
            "code": "8894",
            "localite": "Flumserberg Saxli"
        },
        {
            "code": "8895",
            "localite": "Flumserberg Portels"
        },
        {
            "code": "8896",
            "localite": "Flumserberg Bergheim"
        },
        {
            "code": "8897",
            "localite": "Flumserberg Tannenheim"
        },
        {
            "code": "8898",
            "localite": "Flumserberg Tannenbodenalp"
        },
        {
            "code": "8902",
            "localite": "Urdorf"
        },
        {
            "code": "8903",
            "localite": "Birmensdorf ZH"
        },
        {
            "code": "8904",
            "localite": "Aesch ZH"
        },
        {
            "code": "8905",
            "localite": "Arni AG"
        },
        {
            "code": "8905",
            "localite": "Islisberg"
        },
        {
            "code": "8906",
            "localite": "Bonstetten"
        },
        {
            "code": "8907",
            "localite": "Wettswil"
        },
        {
            "code": "8908",
            "localite": "Hedingen"
        },
        {
            "code": "8909",
            "localite": "Zwillikon"
        },
        {
            "code": "8910",
            "localite": "Affoltern am Albis"
        },
        {
            "code": "8911",
            "localite": "Rifferswil"
        },
        {
            "code": "8912",
            "localite": "Obfelden"
        },
        {
            "code": "8913",
            "localite": "Ottenbach"
        },
        {
            "code": "8914",
            "localite": "Aeugst am Albis"
        },
        {
            "code": "8914",
            "localite": "Aeugstertal"
        },
        {
            "code": "8915",
            "localite": "Hausen am Albis"
        },
        {
            "code": "8916",
            "localite": "Jonen"
        },
        {
            "code": "8917",
            "localite": "Oberlunkhofen"
        },
        {
            "code": "8918",
            "localite": "Unterlunkhofen"
        },
        {
            "code": "8919",
            "localite": "Rottenschwil"
        },
        {
            "code": "8925",
            "localite": "Ebertswil"
        },
        {
            "code": "8926",
            "localite": "Hauptikon"
        },
        {
            "code": "8926",
            "localite": "Kappel am Albis"
        },
        {
            "code": "8926",
            "localite": "Uerzlikon"
        },
        {
            "code": "8932",
            "localite": "Mettmenstetten"
        },
        {
            "code": "8933",
            "localite": "Maschwanden"
        },
        {
            "code": "8934",
            "localite": "Knonau"
        },
        {
            "code": "8942",
            "localite": "Oberrieden"
        },
        {
            "code": "8951",
            "localite": "Fahrweid"
        },
        {
            "code": "8952",
            "localite": "Schlieren"
        },
        {
            "code": "8953",
            "localite": "Dietikon"
        },
        {
            "code": "8954",
            "localite": "Geroldswil"
        },
        {
            "code": "8955",
            "localite": "Oetwil an der Limmat"
        },
        {
            "code": "8956",
            "localite": "Killwangen"
        },
        {
            "code": "8957",
            "localite": "Spreitenbach"
        },
        {
            "code": "8962",
            "localite": "Bergdietikon"
        },
        {
            "code": "8964",
            "localite": "Rudolfstetten"
        },
        {
            "code": "8965",
            "localite": "Berikon"
        },
        {
            "code": "8966",
            "localite": "Oberwil-Lieli"
        },
        {
            "code": "8967",
            "localite": "Widen"
        },
        {
            "code": "9000",
            "localite": "St. Gallen"
        },
        {
            "code": "9008",
            "localite": "St. Gallen"
        },
        {
            "code": "9010",
            "localite": "St. Gallen"
        },
        {
            "code": "9011",
            "localite": "St. Gallen"
        },
        {
            "code": "9012",
            "localite": "St. Gallen"
        },
        {
            "code": "9014",
            "localite": "St. Gallen"
        },
        {
            "code": "9015",
            "localite": "St. Gallen"
        },
        {
            "code": "9016",
            "localite": "St. Gallen"
        },
        {
            "code": "9030",
            "localite": "Abtwil SG"
        },
        {
            "code": "9030",
            "localite": "St. Josefen"
        },
        {
            "code": "9032",
            "localite": "Engelburg"
        },
        {
            "code": "9033",
            "localite": "Untereggen"
        },
        {
            "code": "9034",
            "localite": "Eggersriet"
        },
        {
            "code": "9035",
            "localite": "Grub AR"
        },
        {
            "code": "9036",
            "localite": "Grub SG"
        },
        {
            "code": "9037",
            "localite": "Speicherschwendi"
        },
        {
            "code": "9038",
            "localite": "Rehetobel"
        },
        {
            "code": "9042",
            "localite": "Speicher"
        },
        {
            "code": "9043",
            "localite": "Trogen"
        },
        {
            "code": "9044",
            "localite": "Wald AR"
        },
        {
            "code": "9050",
            "localite": "Appenzell"
        },
        {
            "code": "9050",
            "localite": "Appenzell Eggerstanden"
        },
        {
            "code": "9050",
            "localite": "Appenzell Enggenhütten"
        },
        {
            "code": "9050",
            "localite": "Appenzell Meistersrüte"
        },
        {
            "code": "9050",
            "localite": "Appenzell Schlatt"
        },
        {
            "code": "9050",
            "localite": "Appenzell Steinegg"
        },
        {
            "code": "9052",
            "localite": "Niederteufen"
        },
        {
            "code": "9053",
            "localite": "Teufen AR"
        },
        {
            "code": "9054",
            "localite": "Haslen AI"
        },
        {
            "code": "9055",
            "localite": "Bühler"
        },
        {
            "code": "9056",
            "localite": "Gais"
        },
        {
            "code": "9057",
            "localite": "Schwende"
        },
        {
            "code": "9057",
            "localite": "Wasserauen"
        },
        {
            "code": "9057",
            "localite": "Weissbad"
        },
        {
            "code": "9058",
            "localite": "Brülisau"
        },
        {
            "code": "9062",
            "localite": "Lustmühle"
        },
        {
            "code": "9063",
            "localite": "Stein AR"
        },
        {
            "code": "9064",
            "localite": "Hundwil"
        },
        {
            "code": "9100",
            "localite": "Herisau"
        },
        {
            "code": "9103",
            "localite": "Schwellbrunn"
        },
        {
            "code": "9104",
            "localite": "Waldstatt"
        },
        {
            "code": "9105",
            "localite": "Schönengrund"
        },
        {
            "code": "9107",
            "localite": "Urnäsch"
        },
        {
            "code": "9108",
            "localite": "Gonten"
        },
        {
            "code": "9108",
            "localite": "Gontenbad"
        },
        {
            "code": "9108",
            "localite": "Jakobsbad"
        },
        {
            "code": "9112",
            "localite": "Schachen b. Herisau"
        },
        {
            "code": "9113",
            "localite": "Degersheim"
        },
        {
            "code": "9114",
            "localite": "Hoffeld"
        },
        {
            "code": "9115",
            "localite": "Dicken"
        },
        {
            "code": "9116",
            "localite": "Wolfertswil"
        },
        {
            "code": "9122",
            "localite": "Ebersol"
        },
        {
            "code": "9122",
            "localite": "Mogelsberg"
        },
        {
            "code": "9123",
            "localite": "Nassen"
        },
        {
            "code": "9125",
            "localite": "Brunnadern"
        },
        {
            "code": "9126",
            "localite": "Necker"
        },
        {
            "code": "9127",
            "localite": "St. Peterzell"
        },
        {
            "code": "9200",
            "localite": "Gossau SG"
        },
        {
            "code": "9203",
            "localite": "Niederwil SG"
        },
        {
            "code": "9204",
            "localite": "Andwil SG"
        },
        {
            "code": "9205",
            "localite": "Waldkirch"
        },
        {
            "code": "9212",
            "localite": "Arnegg"
        },
        {
            "code": "9213",
            "localite": "Hauptwil"
        },
        {
            "code": "9214",
            "localite": "Kradolf"
        },
        {
            "code": "9215",
            "localite": "Buhwil"
        },
        {
            "code": "9215",
            "localite": "Schönenberg an der Thur"
        },
        {
            "code": "9216",
            "localite": "Heldswil"
        },
        {
            "code": "9216",
            "localite": "Hohentannen"
        },
        {
            "code": "9217",
            "localite": "Neukirch an der Thur"
        },
        {
            "code": "9220",
            "localite": "Bischofszell"
        },
        {
            "code": "9223",
            "localite": "Halden"
        },
        {
            "code": "9223",
            "localite": "Schweizersholz"
        },
        {
            "code": "9225",
            "localite": "St. Pelagiberg"
        },
        {
            "code": "9225",
            "localite": "Wilen (Gottshaus)"
        },
        {
            "code": "9230",
            "localite": "Flawil"
        },
        {
            "code": "9231",
            "localite": "Egg (Flawil)"
        },
        {
            "code": "9240",
            "localite": "Niederglatt SG"
        },
        {
            "code": "9240",
            "localite": "Uzwil"
        },
        {
            "code": "9242",
            "localite": "Oberuzwil"
        },
        {
            "code": "9243",
            "localite": "Jonschwil"
        },
        {
            "code": "9244",
            "localite": "Niederuzwil"
        },
        {
            "code": "9245",
            "localite": "Oberbüren"
        },
        {
            "code": "9245",
            "localite": "Sonnental"
        },
        {
            "code": "9246",
            "localite": "Niederbüren"
        },
        {
            "code": "9247",
            "localite": "Henau"
        },
        {
            "code": "9248",
            "localite": "Bichwil"
        },
        {
            "code": "9249",
            "localite": "Algetshausen"
        },
        {
            "code": "9249",
            "localite": "Niederstetten"
        },
        {
            "code": "9249",
            "localite": "Oberstetten"
        },
        {
            "code": "9300",
            "localite": "Wittenbach"
        },
        {
            "code": "9304",
            "localite": "Bernhardzell"
        },
        {
            "code": "9305",
            "localite": "Berg SG"
        },
        {
            "code": "9306",
            "localite": "Freidorf TG"
        },
        {
            "code": "9308",
            "localite": "Lömmenschwil"
        },
        {
            "code": "9312",
            "localite": "Häggenschwil"
        },
        {
            "code": "9313",
            "localite": "Muolen"
        },
        {
            "code": "9314",
            "localite": "Steinebrunn"
        },
        {
            "code": "9315",
            "localite": "Neukirch (Egnach)"
        },
        {
            "code": "9315",
            "localite": "Winden"
        },
        {
            "code": "9320",
            "localite": "Arbon"
        },
        {
            "code": "9320",
            "localite": "Frasnacht"
        },
        {
            "code": "9320",
            "localite": "Stachen"
        },
        {
            "code": "9322",
            "localite": "Egnach"
        },
        {
            "code": "9323",
            "localite": "Steinach"
        },
        {
            "code": "9325",
            "localite": "Roggwil TG"
        },
        {
            "code": "9326",
            "localite": "Horn"
        },
        {
            "code": "9327",
            "localite": "Tübach"
        },
        {
            "code": "9400",
            "localite": "Rorschach"
        },
        {
            "code": "9402",
            "localite": "Mörschwil"
        },
        {
            "code": "9403",
            "localite": "Goldach"
        },
        {
            "code": "9404",
            "localite": "Rorschacherberg"
        },
        {
            "code": "9405",
            "localite": "Wienacht-Tobel"
        },
        {
            "code": "9410",
            "localite": "Heiden"
        },
        {
            "code": "9411",
            "localite": "Reute AR"
        },
        {
            "code": "9411",
            "localite": "Schachen b. Reute"
        },
        {
            "code": "9413",
            "localite": "Oberegg"
        },
        {
            "code": "9422",
            "localite": "Staad SG"
        },
        {
            "code": "9423",
            "localite": "Altenrhein"
        },
        {
            "code": "9424",
            "localite": "Rheineck"
        },
        {
            "code": "9425",
            "localite": "Thal"
        },
        {
            "code": "9426",
            "localite": "Lutzenberg"
        },
        {
            "code": "9427",
            "localite": "Wolfhalden"
        },
        {
            "code": "9428",
            "localite": "Walzenhausen"
        },
        {
            "code": "9430",
            "localite": "St. Margrethen SG"
        },
        {
            "code": "9434",
            "localite": "Au SG"
        },
        {
            "code": "9435",
            "localite": "Heerbrugg"
        },
        {
            "code": "9436",
            "localite": "Balgach"
        },
        {
            "code": "9437",
            "localite": "Marbach SG"
        },
        {
            "code": "9442",
            "localite": "Berneck"
        },
        {
            "code": "9442",
            "localite": "Büriswilen"
        },
        {
            "code": "9443",
            "localite": "Widnau"
        },
        {
            "code": "9444",
            "localite": "Diepoldsau"
        },
        {
            "code": "9445",
            "localite": "Rebstein"
        },
        {
            "code": "9450",
            "localite": "Altstätten SG"
        },
        {
            "code": "9450",
            "localite": "Lüchingen"
        },
        {
            "code": "9451",
            "localite": "Kriessern"
        },
        {
            "code": "9452",
            "localite": "Hinterforst"
        },
        {
            "code": "9453",
            "localite": "Eichberg"
        },
        {
            "code": "9462",
            "localite": "Montlingen"
        },
        {
            "code": "9463",
            "localite": "Oberriet SG"
        },
        {
            "code": "9464",
            "localite": "Lienz"
        },
        {
            "code": "9464",
            "localite": "Rüthi (Rheintal)"
        },
        {
            "code": "9465",
            "localite": "Salez"
        },
        {
            "code": "9466",
            "localite": "Sennwald"
        },
        {
            "code": "9467",
            "localite": "Frümsen"
        },
        {
            "code": "9468",
            "localite": "Sax"
        },
        {
            "code": "9469",
            "localite": "Haag (Rheintal)"
        },
        {
            "code": "9470",
            "localite": "Buchs SG"
        },
        {
            "code": "9470",
            "localite": "Werdenberg"
        },
        {
            "code": "9472",
            "localite": "Grabs"
        },
        {
            "code": "9472",
            "localite": "Grabserberg"
        },
        {
            "code": "9473",
            "localite": "Gams"
        },
        {
            "code": "9475",
            "localite": "Sevelen"
        },
        {
            "code": "9476",
            "localite": "Fontnas"
        },
        {
            "code": "9476",
            "localite": "Weite"
        },
        {
            "code": "9477",
            "localite": "Trübbach"
        },
        {
            "code": "9478",
            "localite": "Azmoos"
        },
        {
            "code": "9479",
            "localite": "Gretschins"
        },
        {
            "code": "9479",
            "localite": "Malans SG"
        },
        {
            "code": "9479",
            "localite": "Oberschan"
        },
        {
            "code": "9485",
            "localite": "Nendeln"
        },
        {
            "code": "9486",
            "localite": "Schaanwald"
        },
        {
            "code": "9487",
            "localite": "Gamprin-Bendern"
        },
        {
            "code": "9488",
            "localite": "Schellenberg"
        },
        {
            "code": "9490",
            "localite": "Vaduz"
        },
        {
            "code": "9491",
            "localite": "Ruggell"
        },
        {
            "code": "9492",
            "localite": "Eschen"
        },
        {
            "code": "9493",
            "localite": "Mauren FL"
        },
        {
            "code": "9494",
            "localite": "Schaan"
        },
        {
            "code": "9495",
            "localite": "Triesen"
        },
        {
            "code": "9496",
            "localite": "Balzers"
        },
        {
            "code": "9497",
            "localite": "Triesenberg"
        },
        {
            "code": "9498",
            "localite": "Planken"
        },
        {
            "code": "9500",
            "localite": "Wil SG"
        },
        {
            "code": "9502",
            "localite": "Braunau"
        },
        {
            "code": "9503",
            "localite": "Lanterswil"
        },
        {
            "code": "9503",
            "localite": "Stehrenberg"
        },
        {
            "code": "9504",
            "localite": "Friltschen"
        },
        {
            "code": "9506",
            "localite": "Lommis"
        },
        {
            "code": "9507",
            "localite": "Stettfurt"
        },
        {
            "code": "9508",
            "localite": "Weingarten-Kalthäusern"
        },
        {
            "code": "9512",
            "localite": "Rossrüti"
        },
        {
            "code": "9514",
            "localite": "Wuppenau"
        },
        {
            "code": "9515",
            "localite": "Hosenruck"
        },
        {
            "code": "9517",
            "localite": "Mettlen"
        },
        {
            "code": "9523",
            "localite": "Züberwangen"
        },
        {
            "code": "9524",
            "localite": "Zuzwil SG"
        },
        {
            "code": "9525",
            "localite": "Lenggenwil"
        },
        {
            "code": "9526",
            "localite": "Zuckenriet"
        },
        {
            "code": "9527",
            "localite": "Niederhelfenschwil"
        },
        {
            "code": "9532",
            "localite": "Rickenbach b. Wil"
        },
        {
            "code": "9533",
            "localite": "Dietschwil"
        },
        {
            "code": "9533",
            "localite": "Kirchberg SG"
        },
        {
            "code": "9534",
            "localite": "Gähwil"
        },
        {
            "code": "9535",
            "localite": "Wilen b. Wil"
        },
        {
            "code": "9536",
            "localite": "Schwarzenbach SG"
        },
        {
            "code": "9542",
            "localite": "Münchwilen TG"
        },
        {
            "code": "9543",
            "localite": "St. Margarethen TG"
        },
        {
            "code": "9545",
            "localite": "Wängi"
        },
        {
            "code": "9546",
            "localite": "Tuttwil"
        },
        {
            "code": "9547",
            "localite": "Wittenwil"
        },
        {
            "code": "9548",
            "localite": "Matzingen"
        },
        {
            "code": "9552",
            "localite": "Bronschhofen"
        },
        {
            "code": "9553",
            "localite": "Bettwiesen"
        },
        {
            "code": "9554",
            "localite": "Tägerschen"
        },
        {
            "code": "9555",
            "localite": "Tobel"
        },
        {
            "code": "9556",
            "localite": "Affeltrangen"
        },
        {
            "code": "9556",
            "localite": "Zezikon"
        },
        {
            "code": "9562",
            "localite": "Buch b. Märwil"
        },
        {
            "code": "9562",
            "localite": "Märwil"
        },
        {
            "code": "9565",
            "localite": "Bussnang"
        },
        {
            "code": "9565",
            "localite": "Oberbussnang"
        },
        {
            "code": "9565",
            "localite": "Oppikon"
        },
        {
            "code": "9565",
            "localite": "Rothenhausen"
        },
        {
            "code": "9565",
            "localite": "Schmidshof"
        },
        {
            "code": "9573",
            "localite": "Littenheid"
        },
        {
            "code": "9601",
            "localite": "Lütisburg Station"
        },
        {
            "code": "9602",
            "localite": "Bazenheid"
        },
        {
            "code": "9602",
            "localite": "Müselbach"
        },
        {
            "code": "9604",
            "localite": "Lütisburg"
        },
        {
            "code": "9604",
            "localite": "Oberrindal"
        },
        {
            "code": "9604",
            "localite": "Unterrindal"
        },
        {
            "code": "9606",
            "localite": "Bütschwil"
        },
        {
            "code": "9607",
            "localite": "Mosnang"
        },
        {
            "code": "9608",
            "localite": "Ganterschwil"
        },
        {
            "code": "9612",
            "localite": "Dreien"
        },
        {
            "code": "9613",
            "localite": "Mühlrüti"
        },
        {
            "code": "9614",
            "localite": "Libingen"
        },
        {
            "code": "9615",
            "localite": "Dietfurt"
        },
        {
            "code": "9620",
            "localite": "Lichtensteig"
        },
        {
            "code": "9621",
            "localite": "Oberhelfenschwil"
        },
        {
            "code": "9622",
            "localite": "Krinau"
        },
        {
            "code": "9630",
            "localite": "Wattwil"
        },
        {
            "code": "9631",
            "localite": "Ulisbach"
        },
        {
            "code": "9633",
            "localite": "Bächli (Hemberg)"
        },
        {
            "code": "9633",
            "localite": "Hemberg"
        },
        {
            "code": "9642",
            "localite": "Ebnat-Kappel"
        },
        {
            "code": "9643",
            "localite": "Krummenau"
        },
        {
            "code": "9650",
            "localite": "Nesslau"
        },
        {
            "code": "9651",
            "localite": "Ennetbühl"
        },
        {
            "code": "9652",
            "localite": "Neu St. Johann"
        },
        {
            "code": "9655",
            "localite": "Stein SG"
        },
        {
            "code": "9656",
            "localite": "Alt St. Johann"
        },
        {
            "code": "9657",
            "localite": "Unterwasser"
        },
        {
            "code": "9658",
            "localite": "Wildhaus"
        }
    ],
    "fr": [
        {
            "code": "1000",
            "localite": "Lausanne 25"
        },
        {
            "code": "1000",
            "localite": "Lausanne 26"
        },
        {
            "code": "1000",
            "localite": "Lausanne 27"
        },
        {
            "code": "1003",
            "localite": "Lausanne"
        },
        {
            "code": "1004",
            "localite": "Lausanne"
        },
        {
            "code": "1005",
            "localite": "Lausanne"
        },
        {
            "code": "1006",
            "localite": "Lausanne"
        },
        {
            "code": "1007",
            "localite": "Lausanne"
        },
        {
            "code": "1008",
            "localite": "Jouxtens-Mézery"
        },
        {
            "code": "1008",
            "localite": "Prilly"
        },
        {
            "code": "1009",
            "localite": "Pully"
        },
        {
            "code": "1010",
            "localite": "Lausanne"
        },
        {
            "code": "1011",
            "localite": "Lausanne"
        },
        {
            "code": "1012",
            "localite": "Lausanne"
        },
        {
            "code": "1015",
            "localite": "Lausanne"
        },
        {
            "code": "1018",
            "localite": "Lausanne"
        },
        {
            "code": "1020",
            "localite": "Renens VD"
        },
        {
            "code": "1022",
            "localite": "Chavannes-près-Renens"
        },
        {
            "code": "1023",
            "localite": "Crissier"
        },
        {
            "code": "1024",
            "localite": "Ecublens VD"
        },
        {
            "code": "1025",
            "localite": "St-Sulpice VD"
        },
        {
            "code": "1026",
            "localite": "Denges"
        },
        {
            "code": "1026",
            "localite": "Echandens"
        },
        {
            "code": "1027",
            "localite": "Lonay"
        },
        {
            "code": "1028",
            "localite": "Préverenges"
        },
        {
            "code": "1029",
            "localite": "Villars-Ste-Croix"
        },
        {
            "code": "1030",
            "localite": "Bussigny"
        },
        {
            "code": "1031",
            "localite": "Mex VD"
        },
        {
            "code": "1032",
            "localite": "Romanel-sur-Lausanne"
        },
        {
            "code": "1033",
            "localite": "Cheseaux-sur-Lausanne"
        },
        {
            "code": "1034",
            "localite": "Boussens"
        },
        {
            "code": "1035",
            "localite": "Bournens"
        },
        {
            "code": "1036",
            "localite": "Sullens"
        },
        {
            "code": "1037",
            "localite": "Etagnières"
        },
        {
            "code": "1038",
            "localite": "Bercher"
        },
        {
            "code": "1040",
            "localite": "Echallens"
        },
        {
            "code": "1040",
            "localite": "St-Barthélemy VD"
        },
        {
            "code": "1040",
            "localite": "Villars-le-Terroir"
        },
        {
            "code": "1041",
            "localite": "Bottens"
        },
        {
            "code": "1041",
            "localite": "Dommartin"
        },
        {
            "code": "1041",
            "localite": "Montaubion-Chardonney"
        },
        {
            "code": "1041",
            "localite": "Naz"
        },
        {
            "code": "1041",
            "localite": "Poliez-Pittet"
        },
        {
            "code": "1041",
            "localite": "Poliez-le-Grand"
        },
        {
            "code": "1042",
            "localite": "Assens"
        },
        {
            "code": "1042",
            "localite": "Bettens"
        },
        {
            "code": "1042",
            "localite": "Bioley-Orjulaz"
        },
        {
            "code": "1043",
            "localite": "Sugnens"
        },
        {
            "code": "1044",
            "localite": "Fey"
        },
        {
            "code": "1045",
            "localite": "Ogens"
        },
        {
            "code": "1046",
            "localite": "Rueyres"
        },
        {
            "code": "1047",
            "localite": "Oppens"
        },
        {
            "code": "1052",
            "localite": "Le Mont-sur-Lausanne"
        },
        {
            "code": "1053",
            "localite": "Bretigny-sur-Morrens"
        },
        {
            "code": "1053",
            "localite": "Cugy VD"
        },
        {
            "code": "1054",
            "localite": "Morrens VD"
        },
        {
            "code": "1055",
            "localite": "Froideville"
        },
        {
            "code": "1058",
            "localite": "Villars-Tiercelin"
        },
        {
            "code": "1059",
            "localite": "Peney-le-Jorat"
        },
        {
            "code": "1061",
            "localite": "Villars-Mendraz"
        },
        {
            "code": "1062",
            "localite": "Sottens"
        },
        {
            "code": "1063",
            "localite": "Boulens"
        },
        {
            "code": "1063",
            "localite": "Chapelle-sur-Moudon"
        },
        {
            "code": "1063",
            "localite": "Martherenges"
        },
        {
            "code": "1063",
            "localite": "Peyres-Possens"
        },
        {
            "code": "1066",
            "localite": "Epalinges"
        },
        {
            "code": "1068",
            "localite": "Les Monts-de-Pully"
        },
        {
            "code": "1070",
            "localite": "Puidoux"
        },
        {
            "code": "1071",
            "localite": "Chexbres"
        },
        {
            "code": "1071",
            "localite": "Rivaz"
        },
        {
            "code": "1071",
            "localite": "St-Saphorin (Lavaux)"
        },
        {
            "code": "1072",
            "localite": "Forel (Lavaux)"
        },
        {
            "code": "1073",
            "localite": "Mollie-Margot"
        },
        {
            "code": "1073",
            "localite": "Savigny"
        },
        {
            "code": "1076",
            "localite": "Ferlens VD"
        },
        {
            "code": "1077",
            "localite": "Servion"
        },
        {
            "code": "1078",
            "localite": "Essertes"
        },
        {
            "code": "1080",
            "localite": "Les Cullayes"
        },
        {
            "code": "1081",
            "localite": "Montpreveyres"
        },
        {
            "code": "1082",
            "localite": "Corcelles-le-Jorat"
        },
        {
            "code": "1083",
            "localite": "Mézières VD"
        },
        {
            "code": "1084",
            "localite": "Carrouge VD"
        },
        {
            "code": "1085",
            "localite": "Vulliens"
        },
        {
            "code": "1088",
            "localite": "Ropraz"
        },
        {
            "code": "1090",
            "localite": "La Croix (Lutry)"
        },
        {
            "code": "1091",
            "localite": "Aran"
        },
        {
            "code": "1091",
            "localite": "Chenaux"
        },
        {
            "code": "1091",
            "localite": "Grandvaux"
        },
        {
            "code": "1092",
            "localite": "Belmont-sur-Lausanne"
        },
        {
            "code": "1093",
            "localite": "La Conversion"
        },
        {
            "code": "1094",
            "localite": "Paudex"
        },
        {
            "code": "1095",
            "localite": "Lutry"
        },
        {
            "code": "1096",
            "localite": "Cully"
        },
        {
            "code": "1096",
            "localite": "Villette (Lavaux)"
        },
        {
            "code": "1097",
            "localite": "Riex"
        },
        {
            "code": "1098",
            "localite": "Epesses"
        },
        {
            "code": "1110",
            "localite": "Morges"
        },
        {
            "code": "1112",
            "localite": "Echichens"
        },
        {
            "code": "1113",
            "localite": "St-Saphorin-sur-Morges"
        },
        {
            "code": "1114",
            "localite": "Colombier VD"
        },
        {
            "code": "1115",
            "localite": "Vullierens"
        },
        {
            "code": "1116",
            "localite": "Cottens VD"
        },
        {
            "code": "1117",
            "localite": "Grancy"
        },
        {
            "code": "1121",
            "localite": "Bremblens"
        },
        {
            "code": "1122",
            "localite": "Romanel-sur-Morges"
        },
        {
            "code": "1123",
            "localite": "Aclens"
        },
        {
            "code": "1124",
            "localite": "Gollion"
        },
        {
            "code": "1125",
            "localite": "Monnaz"
        },
        {
            "code": "1126",
            "localite": "Vaux-sur-Morges"
        },
        {
            "code": "1127",
            "localite": "Clarmont"
        },
        {
            "code": "1128",
            "localite": "Reverolle"
        },
        {
            "code": "1131",
            "localite": "Tolochenaz"
        },
        {
            "code": "1132",
            "localite": "Lully VD"
        },
        {
            "code": "1134",
            "localite": "Chigny"
        },
        {
            "code": "1134",
            "localite": "Vufflens-le-Château"
        },
        {
            "code": "1135",
            "localite": "Denens"
        },
        {
            "code": "1136",
            "localite": "Bussy-Chardonney"
        },
        {
            "code": "1141",
            "localite": "Sévery"
        },
        {
            "code": "1142",
            "localite": "Pampigny"
        },
        {
            "code": "1143",
            "localite": "Apples"
        },
        {
            "code": "1144",
            "localite": "Ballens"
        },
        {
            "code": "1145",
            "localite": "Bière"
        },
        {
            "code": "1146",
            "localite": "Mollens VD"
        },
        {
            "code": "1147",
            "localite": "Montricher"
        },
        {
            "code": "1148",
            "localite": "Chavannes-le-Veyron"
        },
        {
            "code": "1148",
            "localite": "Cuarnens"
        },
        {
            "code": "1148",
            "localite": "L'Isle"
        },
        {
            "code": "1148",
            "localite": "La Coudre"
        },
        {
            "code": "1148",
            "localite": "La Praz"
        },
        {
            "code": "1148",
            "localite": "Mauraz"
        },
        {
            "code": "1148",
            "localite": "Moiry VD"
        },
        {
            "code": "1148",
            "localite": "Mont-la-Ville"
        },
        {
            "code": "1148",
            "localite": "Villars-Bozon"
        },
        {
            "code": "1149",
            "localite": "Berolle"
        },
        {
            "code": "1162",
            "localite": "St-Prex"
        },
        {
            "code": "1163",
            "localite": "Etoy"
        },
        {
            "code": "1164",
            "localite": "Buchillon"
        },
        {
            "code": "1165",
            "localite": "Allaman"
        },
        {
            "code": "1166",
            "localite": "Perroy"
        },
        {
            "code": "1167",
            "localite": "Lussy-sur-Morges"
        },
        {
            "code": "1168",
            "localite": "Villars-sous-Yens"
        },
        {
            "code": "1169",
            "localite": "Yens"
        },
        {
            "code": "1170",
            "localite": "Aubonne"
        },
        {
            "code": "1172",
            "localite": "Bougy-Villars"
        },
        {
            "code": "1173",
            "localite": "Féchy"
        },
        {
            "code": "1174",
            "localite": "Montherod"
        },
        {
            "code": "1174",
            "localite": "Pizy"
        },
        {
            "code": "1175",
            "localite": "Lavigny"
        },
        {
            "code": "1176",
            "localite": "St-Livres"
        },
        {
            "code": "1180",
            "localite": "Rolle"
        },
        {
            "code": "1180",
            "localite": "Tartegnin"
        },
        {
            "code": "1182",
            "localite": "Gilly"
        },
        {
            "code": "1183",
            "localite": "Bursins"
        },
        {
            "code": "1184",
            "localite": "Luins"
        },
        {
            "code": "1184",
            "localite": "Vinzel"
        },
        {
            "code": "1185",
            "localite": "Mont-sur-Rolle"
        },
        {
            "code": "1186",
            "localite": "Essertines-sur-Rolle"
        },
        {
            "code": "1187",
            "localite": "St-Oyens"
        },
        {
            "code": "1188",
            "localite": "Gimel"
        },
        {
            "code": "1188",
            "localite": "St-George"
        },
        {
            "code": "1189",
            "localite": "Saubraz"
        },
        {
            "code": "1195",
            "localite": "Bursinel"
        },
        {
            "code": "1195",
            "localite": "Dully"
        },
        {
            "code": "1196",
            "localite": "Gland"
        },
        {
            "code": "1197",
            "localite": "Prangins"
        },
        {
            "code": "1201",
            "localite": "Genève"
        },
        {
            "code": "1202",
            "localite": "Genève"
        },
        {
            "code": "1203",
            "localite": "Genève"
        },
        {
            "code": "1204",
            "localite": "Genève"
        },
        {
            "code": "1205",
            "localite": "Genève"
        },
        {
            "code": "1206",
            "localite": "Genève"
        },
        {
            "code": "1207",
            "localite": "Genève"
        },
        {
            "code": "1208",
            "localite": "Genève"
        },
        {
            "code": "1209",
            "localite": "Genève"
        },
        {
            "code": "1212",
            "localite": "Grand-Lancy"
        },
        {
            "code": "1213",
            "localite": "Onex"
        },
        {
            "code": "1213",
            "localite": "Petit-Lancy"
        },
        {
            "code": "1214",
            "localite": "Vernier"
        },
        {
            "code": "1215",
            "localite": "Genève"
        },
        {
            "code": "1216",
            "localite": "Cointrin"
        },
        {
            "code": "1217",
            "localite": "Meyrin"
        },
        {
            "code": "1218",
            "localite": "Le Grand-Saconnex"
        },
        {
            "code": "1219",
            "localite": "Aïre"
        },
        {
            "code": "1219",
            "localite": "Châtelaine"
        },
        {
            "code": "1219",
            "localite": "Le Lignon"
        },
        {
            "code": "1220",
            "localite": "Les Avanchets"
        },
        {
            "code": "1222",
            "localite": "Vésenaz"
        },
        {
            "code": "1223",
            "localite": "Cologny"
        },
        {
            "code": "1224",
            "localite": "Chêne-Bougeries"
        },
        {
            "code": "1225",
            "localite": "Chêne-Bourg"
        },
        {
            "code": "1226",
            "localite": "Thônex"
        },
        {
            "code": "1227",
            "localite": "Carouge GE"
        },
        {
            "code": "1227",
            "localite": "Les Acacias"
        },
        {
            "code": "1228",
            "localite": "Plan-les-Ouates"
        },
        {
            "code": "1231",
            "localite": "Conches"
        },
        {
            "code": "1232",
            "localite": "Confignon"
        },
        {
            "code": "1233",
            "localite": "Bernex"
        },
        {
            "code": "1234",
            "localite": "Vessy"
        },
        {
            "code": "1236",
            "localite": "Cartigny"
        },
        {
            "code": "1237",
            "localite": "Avully"
        },
        {
            "code": "1239",
            "localite": "Collex"
        },
        {
            "code": "1241",
            "localite": "Puplinge"
        },
        {
            "code": "1242",
            "localite": "Satigny"
        },
        {
            "code": "1243",
            "localite": "Presinge"
        },
        {
            "code": "1244",
            "localite": "Choulex"
        },
        {
            "code": "1245",
            "localite": "Collonge-Bellerive"
        },
        {
            "code": "1246",
            "localite": "Corsier GE"
        },
        {
            "code": "1247",
            "localite": "Anières"
        },
        {
            "code": "1248",
            "localite": "Hermance"
        },
        {
            "code": "1251",
            "localite": "Gy"
        },
        {
            "code": "1252",
            "localite": "Meinier"
        },
        {
            "code": "1253",
            "localite": "Vandoeuvres"
        },
        {
            "code": "1254",
            "localite": "Jussy"
        },
        {
            "code": "1255",
            "localite": "Veyrier"
        },
        {
            "code": "1256",
            "localite": "Troinex"
        },
        {
            "code": "1257",
            "localite": "La Croix-de-Rozon"
        },
        {
            "code": "1258",
            "localite": "Perly"
        },
        {
            "code": "1260",
            "localite": "Nyon"
        },
        {
            "code": "1261",
            "localite": "Le Vaud"
        },
        {
            "code": "1261",
            "localite": "Longirod"
        },
        {
            "code": "1261",
            "localite": "Marchissy"
        },
        {
            "code": "1262",
            "localite": "Eysins"
        },
        {
            "code": "1263",
            "localite": "Crassier"
        },
        {
            "code": "1264",
            "localite": "St-Cergue"
        },
        {
            "code": "1265",
            "localite": "La Cure"
        },
        {
            "code": "1266",
            "localite": "Duillier"
        },
        {
            "code": "1267",
            "localite": "Coinsins"
        },
        {
            "code": "1267",
            "localite": "Vich"
        },
        {
            "code": "1268",
            "localite": "Begnins"
        },
        {
            "code": "1268",
            "localite": "Burtigny"
        },
        {
            "code": "1269",
            "localite": "Bassins"
        },
        {
            "code": "1270",
            "localite": "Trélex"
        },
        {
            "code": "1271",
            "localite": "Givrins"
        },
        {
            "code": "1272",
            "localite": "Genolier"
        },
        {
            "code": "1273",
            "localite": "Arzier-Le Muids"
        },
        {
            "code": "1274",
            "localite": "Grens"
        },
        {
            "code": "1274",
            "localite": "Signy"
        },
        {
            "code": "1275",
            "localite": "Chéserex"
        },
        {
            "code": "1276",
            "localite": "Gingins"
        },
        {
            "code": "1277",
            "localite": "Arnex-sur-Nyon"
        },
        {
            "code": "1277",
            "localite": "Borex"
        },
        {
            "code": "1278",
            "localite": "La Rippe"
        },
        {
            "code": "1279",
            "localite": "Bogis-Bossey"
        },
        {
            "code": "1279",
            "localite": "Chavannes-de-Bogis"
        },
        {
            "code": "1281",
            "localite": "Russin"
        },
        {
            "code": "1283",
            "localite": "Dardagny"
        },
        {
            "code": "1283",
            "localite": "La Plaine"
        },
        {
            "code": "1284",
            "localite": "Chancy"
        },
        {
            "code": "1285",
            "localite": "Athenaz (Avusy)"
        },
        {
            "code": "1286",
            "localite": "Soral"
        },
        {
            "code": "1287",
            "localite": "Laconnex"
        },
        {
            "code": "1288",
            "localite": "Aire-la-Ville"
        },
        {
            "code": "1290",
            "localite": "Chavannes-des-Bois"
        },
        {
            "code": "1290",
            "localite": "Versoix"
        },
        {
            "code": "1291",
            "localite": "Commugny"
        },
        {
            "code": "1292",
            "localite": "Chambésy"
        },
        {
            "code": "1293",
            "localite": "Bellevue"
        },
        {
            "code": "1294",
            "localite": "Genthod"
        },
        {
            "code": "1295",
            "localite": "Mies"
        },
        {
            "code": "1295",
            "localite": "Tannay"
        },
        {
            "code": "1296",
            "localite": "Coppet"
        },
        {
            "code": "1297",
            "localite": "Founex"
        },
        {
            "code": "1298",
            "localite": "Céligny"
        },
        {
            "code": "1299",
            "localite": "Crans VD"
        },
        {
            "code": "1302",
            "localite": "Vufflens-la-Ville"
        },
        {
            "code": "1303",
            "localite": "Penthaz"
        },
        {
            "code": "1304",
            "localite": "Allens"
        },
        {
            "code": "1304",
            "localite": "Cossonay-Ville"
        },
        {
            "code": "1304",
            "localite": "Dizy"
        },
        {
            "code": "1304",
            "localite": "Senarclens"
        },
        {
            "code": "1305",
            "localite": "Penthalaz"
        },
        {
            "code": "1306",
            "localite": "Daillens"
        },
        {
            "code": "1307",
            "localite": "Lussery-Villars"
        },
        {
            "code": "1308",
            "localite": "La Chaux (Cossonay)"
        },
        {
            "code": "1312",
            "localite": "Eclépens"
        },
        {
            "code": "1313",
            "localite": "Ferreyres"
        },
        {
            "code": "1315",
            "localite": "La Sarraz"
        },
        {
            "code": "1316",
            "localite": "Chevilly"
        },
        {
            "code": "1317",
            "localite": "Orny"
        },
        {
            "code": "1318",
            "localite": "Pompaples"
        },
        {
            "code": "1321",
            "localite": "Arnex-sur-Orbe"
        },
        {
            "code": "1322",
            "localite": "Croy"
        },
        {
            "code": "1323",
            "localite": "Romainmôtier"
        },
        {
            "code": "1324",
            "localite": "Premier"
        },
        {
            "code": "1325",
            "localite": "Vaulion"
        },
        {
            "code": "1326",
            "localite": "Juriens"
        },
        {
            "code": "1329",
            "localite": "Bretonnières"
        },
        {
            "code": "1337",
            "localite": "Vallorbe"
        },
        {
            "code": "1338",
            "localite": "Ballaigues"
        },
        {
            "code": "1341",
            "localite": "L'Orient"
        },
        {
            "code": "1342",
            "localite": "Le Pont"
        },
        {
            "code": "1343",
            "localite": "Les Charbonnières"
        },
        {
            "code": "1344",
            "localite": "L'Abbaye"
        },
        {
            "code": "1345",
            "localite": "Le Lieu"
        },
        {
            "code": "1345",
            "localite": "Le Séchey"
        },
        {
            "code": "1346",
            "localite": "Les Bioux"
        },
        {
            "code": "1347",
            "localite": "Le Sentier"
        },
        {
            "code": "1347",
            "localite": "Le Solliat"
        },
        {
            "code": "1348",
            "localite": "Le Brassus"
        },
        {
            "code": "1350",
            "localite": "Orbe"
        },
        {
            "code": "1352",
            "localite": "Agiez"
        },
        {
            "code": "1353",
            "localite": "Bofflens"
        },
        {
            "code": "1354",
            "localite": "Montcherand"
        },
        {
            "code": "1355",
            "localite": "L'Abergement"
        },
        {
            "code": "1355",
            "localite": "Sergey"
        },
        {
            "code": "1356",
            "localite": "La Russille"
        },
        {
            "code": "1356",
            "localite": "Les Clées"
        },
        {
            "code": "1357",
            "localite": "Lignerolle"
        },
        {
            "code": "1358",
            "localite": "Valeyres-sous-Rances"
        },
        {
            "code": "1372",
            "localite": "Bavois"
        },
        {
            "code": "1373",
            "localite": "Chavornay"
        },
        {
            "code": "1374",
            "localite": "Corcelles-sur-Chavornay"
        },
        {
            "code": "1375",
            "localite": "Penthéréaz"
        },
        {
            "code": "1376",
            "localite": "Eclagnens"
        },
        {
            "code": "1376",
            "localite": "Goumoens-la-Ville"
        },
        {
            "code": "1376",
            "localite": "Goumoens-le-Jux"
        },
        {
            "code": "1377",
            "localite": "Oulens-sous-Echallens"
        },
        {
            "code": "1400",
            "localite": "Cheseaux-Noréaz"
        },
        {
            "code": "1400",
            "localite": "Yverdon-les-Bains"
        },
        {
            "code": "1404",
            "localite": "Cuarny"
        },
        {
            "code": "1404",
            "localite": "Villars-Epeney"
        },
        {
            "code": "1405",
            "localite": "Pomy"
        },
        {
            "code": "1406",
            "localite": "Cronay"
        },
        {
            "code": "1407",
            "localite": "Bioley-Magnoux"
        },
        {
            "code": "1407",
            "localite": "Donneloye"
        },
        {
            "code": "1407",
            "localite": "Gossens"
        },
        {
            "code": "1407",
            "localite": "Mézery-près-Donneloye"
        },
        {
            "code": "1408",
            "localite": "Prahins"
        },
        {
            "code": "1409",
            "localite": "Chanéaz"
        },
        {
            "code": "1410",
            "localite": "Correvon"
        },
        {
            "code": "1410",
            "localite": "Denezy"
        },
        {
            "code": "1410",
            "localite": "Prévondavaux"
        },
        {
            "code": "1410",
            "localite": "St-Cierges"
        },
        {
            "code": "1410",
            "localite": "Thierrens"
        },
        {
            "code": "1412",
            "localite": "Ursins"
        },
        {
            "code": "1412",
            "localite": "Valeyres-sous-Ursins"
        },
        {
            "code": "1413",
            "localite": "Orzens"
        },
        {
            "code": "1415",
            "localite": "Démoret"
        },
        {
            "code": "1415",
            "localite": "Molondin"
        },
        {
            "code": "1416",
            "localite": "Pailly"
        },
        {
            "code": "1417",
            "localite": "Epautheyres"
        },
        {
            "code": "1417",
            "localite": "Essertines-sur-Yverdon"
        },
        {
            "code": "1418",
            "localite": "Vuarrens"
        },
        {
            "code": "1420",
            "localite": "Fiez"
        },
        {
            "code": "1421",
            "localite": "Fontaines-sur-Grandson"
        },
        {
            "code": "1421",
            "localite": "Grandevent"
        },
        {
            "code": "1422",
            "localite": "Grandson"
        },
        {
            "code": "1423",
            "localite": "Fontanezier"
        },
        {
            "code": "1423",
            "localite": "Romairon"
        },
        {
            "code": "1423",
            "localite": "Vaugondry"
        },
        {
            "code": "1423",
            "localite": "Villars-Burquin"
        },
        {
            "code": "1424",
            "localite": "Champagne"
        },
        {
            "code": "1425",
            "localite": "Onnens VD"
        },
        {
            "code": "1426",
            "localite": "Concise"
        },
        {
            "code": "1426",
            "localite": "Corcelles-près-Concise"
        },
        {
            "code": "1427",
            "localite": "Bonvillars"
        },
        {
            "code": "1428",
            "localite": "Mutrux"
        },
        {
            "code": "1428",
            "localite": "Provence"
        },
        {
            "code": "1429",
            "localite": "Giez"
        },
        {
            "code": "1430",
            "localite": "Orges"
        },
        {
            "code": "1431",
            "localite": "Novalles"
        },
        {
            "code": "1431",
            "localite": "Vugelles-La Mothe"
        },
        {
            "code": "1432",
            "localite": "Belmont-sur-Yverdon"
        },
        {
            "code": "1432",
            "localite": "Gressy"
        },
        {
            "code": "1433",
            "localite": "Suchy"
        },
        {
            "code": "1434",
            "localite": "Ependes VD"
        },
        {
            "code": "1435",
            "localite": "Essert-Pittet"
        },
        {
            "code": "1436",
            "localite": "Chamblon"
        },
        {
            "code": "1436",
            "localite": "Treycovagnes"
        },
        {
            "code": "1437",
            "localite": "Suscévaz"
        },
        {
            "code": "1438",
            "localite": "Mathod"
        },
        {
            "code": "1439",
            "localite": "Rances"
        },
        {
            "code": "1441",
            "localite": "Valeyres-sous-Montagny"
        },
        {
            "code": "1442",
            "localite": "Montagny-près-Yverdon"
        },
        {
            "code": "1443",
            "localite": "Champvent"
        },
        {
            "code": "1443",
            "localite": "Essert-sous-Champvent"
        },
        {
            "code": "1443",
            "localite": "Villars-sous-Champvent"
        },
        {
            "code": "1445",
            "localite": "Vuiteboeuf"
        },
        {
            "code": "1446",
            "localite": "Baulmes"
        },
        {
            "code": "1450",
            "localite": "La Sagne (Ste-Croix)"
        },
        {
            "code": "1450",
            "localite": "Le Château-de-Ste-Croix"
        },
        {
            "code": "1450",
            "localite": "Ste-Croix"
        },
        {
            "code": "1452",
            "localite": "Les Rasses"
        },
        {
            "code": "1453",
            "localite": "Bullet"
        },
        {
            "code": "1453",
            "localite": "Mauborget"
        },
        {
            "code": "1454",
            "localite": "L'Auberson"
        },
        {
            "code": "1454",
            "localite": "La Vraconnaz"
        },
        {
            "code": "1462",
            "localite": "Yvonand"
        },
        {
            "code": "1463",
            "localite": "Rovray"
        },
        {
            "code": "1464",
            "localite": "Chavannes-le-Chêne"
        },
        {
            "code": "1464",
            "localite": "Chêne-Pâquier"
        },
        {
            "code": "1468",
            "localite": "Cheyres"
        },
        {
            "code": "1470",
            "localite": "Bollion"
        },
        {
            "code": "1470",
            "localite": "Estavayer-le-Lac"
        },
        {
            "code": "1470",
            "localite": "Lully FR"
        },
        {
            "code": "1470",
            "localite": "Seiry"
        },
        {
            "code": "1473",
            "localite": "Châtillon FR"
        },
        {
            "code": "1473",
            "localite": "Font"
        },
        {
            "code": "1474",
            "localite": "Châbles FR"
        },
        {
            "code": "1475",
            "localite": "Autavaux"
        },
        {
            "code": "1475",
            "localite": "Forel FR"
        },
        {
            "code": "1475",
            "localite": "Montbrelloz"
        },
        {
            "code": "1482",
            "localite": "Cugy FR"
        },
        {
            "code": "1483",
            "localite": "Frasses"
        },
        {
            "code": "1483",
            "localite": "Montet (Broye)"
        },
        {
            "code": "1483",
            "localite": "Vesin"
        },
        {
            "code": "1484",
            "localite": "Aumont"
        },
        {
            "code": "1484",
            "localite": "Granges-de-Vesin"
        },
        {
            "code": "1485",
            "localite": "Nuvilly"
        },
        {
            "code": "1486",
            "localite": "Vuissens"
        },
        {
            "code": "1489",
            "localite": "Murist"
        },
        {
            "code": "1509",
            "localite": "Vucherens"
        },
        {
            "code": "1510",
            "localite": "Moudon"
        },
        {
            "code": "1510",
            "localite": "Syens"
        },
        {
            "code": "1512",
            "localite": "Chavannes-sur-Moudon"
        },
        {
            "code": "1513",
            "localite": "Hermenches"
        },
        {
            "code": "1513",
            "localite": "Rossenges"
        },
        {
            "code": "1514",
            "localite": "Bussy-sur-Moudon"
        },
        {
            "code": "1515",
            "localite": "Neyruz-sur-Moudon"
        },
        {
            "code": "1515",
            "localite": "Villars-le-Comte"
        },
        {
            "code": "1521",
            "localite": "Curtilles"
        },
        {
            "code": "1522",
            "localite": "Lucens"
        },
        {
            "code": "1522",
            "localite": "Oulens-sur-Lucens"
        },
        {
            "code": "1523",
            "localite": "Granges-près-Marnand"
        },
        {
            "code": "1524",
            "localite": "Marnand"
        },
        {
            "code": "1525",
            "localite": "Henniez"
        },
        {
            "code": "1525",
            "localite": "Seigneux"
        },
        {
            "code": "1526",
            "localite": "Cremin"
        },
        {
            "code": "1526",
            "localite": "Forel-sur-Lucens"
        },
        {
            "code": "1527",
            "localite": "Villeneuve FR"
        },
        {
            "code": "1528",
            "localite": "Praratoud"
        },
        {
            "code": "1528",
            "localite": "Surpierre"
        },
        {
            "code": "1529",
            "localite": "Cheiry"
        },
        {
            "code": "1530",
            "localite": "Payerne"
        },
        {
            "code": "1532",
            "localite": "Fétigny"
        },
        {
            "code": "1533",
            "localite": "Ménières"
        },
        {
            "code": "1534",
            "localite": "Chapelle (Broye)"
        },
        {
            "code": "1534",
            "localite": "Sassel"
        },
        {
            "code": "1535",
            "localite": "Combremont-le-Grand"
        },
        {
            "code": "1536",
            "localite": "Combremont-le-Petit"
        },
        {
            "code": "1537",
            "localite": "Champtauroz"
        },
        {
            "code": "1538",
            "localite": "Treytorrens (Payerne)"
        },
        {
            "code": "1541",
            "localite": "Bussy FR"
        },
        {
            "code": "1541",
            "localite": "Morens FR"
        },
        {
            "code": "1541",
            "localite": "Sévaz"
        },
        {
            "code": "1542",
            "localite": "Rueyres-les-Prés"
        },
        {
            "code": "1543",
            "localite": "Grandcour"
        },
        {
            "code": "1544",
            "localite": "Gletterens"
        },
        {
            "code": "1545",
            "localite": "Chevroux"
        },
        {
            "code": "1551",
            "localite": "Vers-chez-Perrin"
        },
        {
            "code": "1552",
            "localite": "Trey"
        },
        {
            "code": "1553",
            "localite": "Châtonnaye"
        },
        {
            "code": "1554",
            "localite": "Rossens VD"
        },
        {
            "code": "1554",
            "localite": "Sédeilles"
        },
        {
            "code": "1555",
            "localite": "Villarzel"
        },
        {
            "code": "1562",
            "localite": "Corcelles-près-Payerne"
        },
        {
            "code": "1563",
            "localite": "Dompierre FR"
        },
        {
            "code": "1564",
            "localite": "Domdidier"
        },
        {
            "code": "1565",
            "localite": "Missy"
        },
        {
            "code": "1565",
            "localite": "Vallon"
        },
        {
            "code": "1566",
            "localite": "Les Friques"
        },
        {
            "code": "1566",
            "localite": "St-Aubin FR"
        },
        {
            "code": "1567",
            "localite": "Delley"
        },
        {
            "code": "1568",
            "localite": "Portalban"
        },
        {
            "code": "1580",
            "localite": "Avenches"
        },
        {
            "code": "1580",
            "localite": "Donatyre"
        },
        {
            "code": "1580",
            "localite": "Oleyres"
        },
        {
            "code": "1583",
            "localite": "Villarepos"
        },
        {
            "code": "1584",
            "localite": "Villars-le-Grand"
        },
        {
            "code": "1585",
            "localite": "Bellerive VD"
        },
        {
            "code": "1585",
            "localite": "Cotterd"
        },
        {
            "code": "1585",
            "localite": "Salavaux"
        },
        {
            "code": "1586",
            "localite": "Vallamand"
        },
        {
            "code": "1587",
            "localite": "Constantine"
        },
        {
            "code": "1587",
            "localite": "Montmagny"
        },
        {
            "code": "1588",
            "localite": "Cudrefin"
        },
        {
            "code": "1589",
            "localite": "Chabrey"
        },
        {
            "code": "1595",
            "localite": "Clavaleyres"
        },
        {
            "code": "1595",
            "localite": "Faoug"
        },
        {
            "code": "1607",
            "localite": "Les Tavernes"
        },
        {
            "code": "1607",
            "localite": "Les Thioleyres"
        },
        {
            "code": "1607",
            "localite": "Palézieux"
        },
        {
            "code": "1607",
            "localite": "Palézieux-Village"
        },
        {
            "code": "1608",
            "localite": "Bussigny-sur-Oron"
        },
        {
            "code": "1608",
            "localite": "Chapelle (Glâne)"
        },
        {
            "code": "1608",
            "localite": "Chesalles-sur-Oron"
        },
        {
            "code": "1608",
            "localite": "Oron-le-Châtel"
        },
        {
            "code": "1609",
            "localite": "Besencens"
        },
        {
            "code": "1609",
            "localite": "Fiaugères"
        },
        {
            "code": "1609",
            "localite": "St-Martin FR"
        },
        {
            "code": "1610",
            "localite": "Châtillens"
        },
        {
            "code": "1610",
            "localite": "Oron-la-Ville"
        },
        {
            "code": "1610",
            "localite": "Vuibroye"
        },
        {
            "code": "1611",
            "localite": "Le Crêt-près-Semsales"
        },
        {
            "code": "1612",
            "localite": "Ecoteaux"
        },
        {
            "code": "1613",
            "localite": "Maracon"
        },
        {
            "code": "1614",
            "localite": "Granges (Veveyse)"
        },
        {
            "code": "1615",
            "localite": "Bossonnens"
        },
        {
            "code": "1616",
            "localite": "Attalens"
        },
        {
            "code": "1617",
            "localite": "Remaufens"
        },
        {
            "code": "1617",
            "localite": "Tatroz"
        },
        {
            "code": "1618",
            "localite": "Châtel-St-Denis"
        },
        {
            "code": "1619",
            "localite": "Les Paccots"
        },
        {
            "code": "1623",
            "localite": "Semsales"
        },
        {
            "code": "1624",
            "localite": "Grattavache"
        },
        {
            "code": "1624",
            "localite": "La Verrerie"
        },
        {
            "code": "1624",
            "localite": "Progens"
        },
        {
            "code": "1625",
            "localite": "Maules"
        },
        {
            "code": "1625",
            "localite": "Sâles (Gruyère)"
        },
        {
            "code": "1626",
            "localite": "Romanens"
        },
        {
            "code": "1626",
            "localite": "Rueyres-Treyfayes"
        },
        {
            "code": "1627",
            "localite": "Vaulruz"
        },
        {
            "code": "1628",
            "localite": "Vuadens"
        },
        {
            "code": "1630",
            "localite": "Bulle"
        },
        {
            "code": "1632",
            "localite": "Riaz"
        },
        {
            "code": "1633",
            "localite": "Marsens"
        },
        {
            "code": "1633",
            "localite": "Vuippens"
        },
        {
            "code": "1634",
            "localite": "La Roche FR"
        },
        {
            "code": "1635",
            "localite": "La Tour-de-Trême"
        },
        {
            "code": "1636",
            "localite": "Broc"
        },
        {
            "code": "1637",
            "localite": "Charmey (Gruyère)"
        },
        {
            "code": "1638",
            "localite": "Morlon"
        },
        {
            "code": "1642",
            "localite": "Sorens"
        },
        {
            "code": "1643",
            "localite": "Gumefens"
        },
        {
            "code": "1644",
            "localite": "Avry-devant-Pont"
        },
        {
            "code": "1645",
            "localite": "Le Bry"
        },
        {
            "code": "1646",
            "localite": "Echarlens"
        },
        {
            "code": "1647",
            "localite": "Corbières"
        },
        {
            "code": "1648",
            "localite": "Hauteville"
        },
        {
            "code": "1649",
            "localite": "Pont-la-Ville"
        },
        {
            "code": "1651",
            "localite": "Villarvolard"
        },
        {
            "code": "1652",
            "localite": "Botterens"
        },
        {
            "code": "1652",
            "localite": "Villarbeney"
        },
        {
            "code": "1653",
            "localite": "Châtel-sur-Montsalvens"
        },
        {
            "code": "1653",
            "localite": "Crésuz"
        },
        {
            "code": "1654",
            "localite": "Cerniat FR"
        },
        {
            "code": "1656",
            "localite": "Im Fang"
        },
        {
            "code": "1656",
            "localite": "Jaun"
        },
        {
            "code": "1657",
            "localite": "Abländschen"
        },
        {
            "code": "1658",
            "localite": "La Tine"
        },
        {
            "code": "1658",
            "localite": "Rossinière"
        },
        {
            "code": "1659",
            "localite": "Flendruz"
        },
        {
            "code": "1659",
            "localite": "Rougemont"
        },
        {
            "code": "1660",
            "localite": "Château-d'Oex"
        },
        {
            "code": "1660",
            "localite": "L'Etivaz"
        },
        {
            "code": "1660",
            "localite": "La Lécherette"
        },
        {
            "code": "1660",
            "localite": "Les Moulins"
        },
        {
            "code": "1661",
            "localite": "Le Pâquier-Montbarry"
        },
        {
            "code": "1663",
            "localite": "Epagny"
        },
        {
            "code": "1663",
            "localite": "Gruyères"
        },
        {
            "code": "1663",
            "localite": "Moléson-sur-Gruyères"
        },
        {
            "code": "1663",
            "localite": "Pringy"
        },
        {
            "code": "1665",
            "localite": "Estavannens"
        },
        {
            "code": "1666",
            "localite": "Grandvillard"
        },
        {
            "code": "1666",
            "localite": "Villars-sous-Mont"
        },
        {
            "code": "1667",
            "localite": "Enney"
        },
        {
            "code": "1669",
            "localite": "Albeuve"
        },
        {
            "code": "1669",
            "localite": "Les Sciernes-d'Albeuve"
        },
        {
            "code": "1669",
            "localite": "Lessoc"
        },
        {
            "code": "1669",
            "localite": "Montbovon"
        },
        {
            "code": "1669",
            "localite": "Neirivue"
        },
        {
            "code": "1670",
            "localite": "Bionnens"
        },
        {
            "code": "1670",
            "localite": "Esmonts"
        },
        {
            "code": "1670",
            "localite": "Ursy"
        },
        {
            "code": "1673",
            "localite": "Auboranges"
        },
        {
            "code": "1673",
            "localite": "Ecublens FR"
        },
        {
            "code": "1673",
            "localite": "Gillarens"
        },
        {
            "code": "1673",
            "localite": "Promasens"
        },
        {
            "code": "1673",
            "localite": "Rue"
        },
        {
            "code": "1674",
            "localite": "Montet (Glâne)"
        },
        {
            "code": "1674",
            "localite": "Morlens"
        },
        {
            "code": "1674",
            "localite": "Vuarmarens"
        },
        {
            "code": "1675",
            "localite": "Blessens"
        },
        {
            "code": "1675",
            "localite": "Mossel"
        },
        {
            "code": "1675",
            "localite": "Vauderens"
        },
        {
            "code": "1676",
            "localite": "Chavannes-les-Forts"
        },
        {
            "code": "1677",
            "localite": "Prez-vers-Siviriez"
        },
        {
            "code": "1678",
            "localite": "Siviriez"
        },
        {
            "code": "1679",
            "localite": "Villaraboud"
        },
        {
            "code": "1680",
            "localite": "Berlens"
        },
        {
            "code": "1680",
            "localite": "Romont FR"
        },
        {
            "code": "1681",
            "localite": "Billens"
        },
        {
            "code": "1681",
            "localite": "Hennens"
        },
        {
            "code": "1682",
            "localite": "Cerniaz VD"
        },
        {
            "code": "1682",
            "localite": "Dompierre VD"
        },
        {
            "code": "1682",
            "localite": "Lovatens"
        },
        {
            "code": "1682",
            "localite": "Prévonloup"
        },
        {
            "code": "1682",
            "localite": "Villars-Bramard"
        },
        {
            "code": "1683",
            "localite": "Brenles"
        },
        {
            "code": "1683",
            "localite": "Chesalles-sur-Moudon"
        },
        {
            "code": "1683",
            "localite": "Sarzens"
        },
        {
            "code": "1684",
            "localite": "Mézières FR"
        },
        {
            "code": "1685",
            "localite": "Villariaz"
        },
        {
            "code": "1686",
            "localite": "Grangettes-près-Romont"
        },
        {
            "code": "1686",
            "localite": "La Neirigue"
        },
        {
            "code": "1687",
            "localite": "Estévenens"
        },
        {
            "code": "1687",
            "localite": "La Magne"
        },
        {
            "code": "1687",
            "localite": "Vuisternens-devant-Romont"
        },
        {
            "code": "1688",
            "localite": "Lieffrens"
        },
        {
            "code": "1688",
            "localite": "Sommentier"
        },
        {
            "code": "1689",
            "localite": "Le Châtelard-près-Romont"
        },
        {
            "code": "1690",
            "localite": "Lussy FR"
        },
        {
            "code": "1690",
            "localite": "Villaz-St-Pierre"
        },
        {
            "code": "1691",
            "localite": "Villarimboud"
        },
        {
            "code": "1692",
            "localite": "Massonnens"
        },
        {
            "code": "1694",
            "localite": "Chavannes-sous-Orsonnens"
        },
        {
            "code": "1694",
            "localite": "Orsonnens"
        },
        {
            "code": "1694",
            "localite": "Villargiroud"
        },
        {
            "code": "1694",
            "localite": "Villarsiviriaux"
        },
        {
            "code": "1695",
            "localite": "Estavayer-le-Gibloux"
        },
        {
            "code": "1695",
            "localite": "Rueyres-St-Laurent"
        },
        {
            "code": "1695",
            "localite": "Villarlod"
        },
        {
            "code": "1695",
            "localite": "Villarsel-le-Gibloux"
        },
        {
            "code": "1696",
            "localite": "Vuisternens-en-Ogoz"
        },
        {
            "code": "1697",
            "localite": "La Joux FR"
        },
        {
            "code": "1697",
            "localite": "Les Ecasseys"
        },
        {
            "code": "1699",
            "localite": "Bouloz"
        },
        {
            "code": "1699",
            "localite": "Pont (Veveyse)"
        },
        {
            "code": "1699",
            "localite": "Porsel"
        },
        {
            "code": "1700",
            "localite": "Fribourg"
        },
        {
            "code": "1712",
            "localite": "Tafers"
        },
        {
            "code": "1713",
            "localite": "St. Antoni"
        },
        {
            "code": "1714",
            "localite": "Heitenried"
        },
        {
            "code": "1715",
            "localite": "Alterswil FR"
        },
        {
            "code": "1716",
            "localite": "Oberschrot"
        },
        {
            "code": "1716",
            "localite": "Plaffeien"
        },
        {
            "code": "1716",
            "localite": "Schwarzsee"
        },
        {
            "code": "1717",
            "localite": "St. Ursen"
        },
        {
            "code": "1718",
            "localite": "Rechthalten"
        },
        {
            "code": "1719",
            "localite": "Brünisried"
        },
        {
            "code": "1719",
            "localite": "Zumholz"
        },
        {
            "code": "1720",
            "localite": "Chésopelloz"
        },
        {
            "code": "1720",
            "localite": "Corminboeuf"
        },
        {
            "code": "1721",
            "localite": "Cormérod"
        },
        {
            "code": "1721",
            "localite": "Cournillens"
        },
        {
            "code": "1721",
            "localite": "Courtion"
        },
        {
            "code": "1721",
            "localite": "Misery"
        },
        {
            "code": "1722",
            "localite": "Bourguillon"
        },
        {
            "code": "1723",
            "localite": "Marly"
        },
        {
            "code": "1723",
            "localite": "Pierrafortscha"
        },
        {
            "code": "1723",
            "localite": "Villarsel-sur-Marly"
        },
        {
            "code": "1724",
            "localite": "Bonnefontaine"
        },
        {
            "code": "1724",
            "localite": "Essert FR"
        },
        {
            "code": "1724",
            "localite": "Ferpicloz"
        },
        {
            "code": "1724",
            "localite": "Le Mouret"
        },
        {
            "code": "1724",
            "localite": "Montévraz"
        },
        {
            "code": "1724",
            "localite": "Oberried FR"
        },
        {
            "code": "1724",
            "localite": "Senèdes"
        },
        {
            "code": "1724",
            "localite": "Zénauva"
        },
        {
            "code": "1725",
            "localite": "Posieux"
        },
        {
            "code": "1726",
            "localite": "Farvagny-le-Grand"
        },
        {
            "code": "1726",
            "localite": "Farvagny-le-Petit"
        },
        {
            "code": "1726",
            "localite": "Grenilles"
        },
        {
            "code": "1726",
            "localite": "Posat"
        },
        {
            "code": "1727",
            "localite": "Corpataux"
        },
        {
            "code": "1727",
            "localite": "Magnedens"
        },
        {
            "code": "1728",
            "localite": "Rossens FR"
        },
        {
            "code": "1730",
            "localite": "Ecuvillens"
        },
        {
            "code": "1731",
            "localite": "Ependes FR"
        },
        {
            "code": "1732",
            "localite": "Arconciel"
        },
        {
            "code": "1733",
            "localite": "Treyvaux"
        },
        {
            "code": "1734",
            "localite": "Tentlingen"
        },
        {
            "code": "1735",
            "localite": "Giffers"
        },
        {
            "code": "1736",
            "localite": "St. Silvester"
        },
        {
            "code": "1737",
            "localite": "Plasselb"
        },
        {
            "code": "1738",
            "localite": "Sangernboden"
        },
        {
            "code": "1740",
            "localite": "Neyruz FR"
        },
        {
            "code": "1741",
            "localite": "Cottens FR"
        },
        {
            "code": "1742",
            "localite": "Autigny"
        },
        {
            "code": "1744",
            "localite": "Chénens"
        },
        {
            "code": "1745",
            "localite": "Lentigny"
        },
        {
            "code": "1746",
            "localite": "Prez-vers-Noréaz"
        },
        {
            "code": "1747",
            "localite": "Corserey"
        },
        {
            "code": "1748",
            "localite": "Torny-le-Grand"
        },
        {
            "code": "1749",
            "localite": "Middes"
        },
        {
            "code": "1752",
            "localite": "Villars-sur-Glâne"
        },
        {
            "code": "1753",
            "localite": "Matran"
        },
        {
            "code": "1754",
            "localite": "Avry-sur-Matran"
        },
        {
            "code": "1754",
            "localite": "Corjolens"
        },
        {
            "code": "1756",
            "localite": "Lovens"
        },
        {
            "code": "1756",
            "localite": "Onnens FR"
        },
        {
            "code": "1757",
            "localite": "Noréaz"
        },
        {
            "code": "1762",
            "localite": "Givisiez"
        },
        {
            "code": "1763",
            "localite": "Granges-Paccot"
        },
        {
            "code": "1772",
            "localite": "Grolley"
        },
        {
            "code": "1772",
            "localite": "Nierlet-les-Bois"
        },
        {
            "code": "1772",
            "localite": "Ponthaux"
        },
        {
            "code": "1773",
            "localite": "Chandon"
        },
        {
            "code": "1773",
            "localite": "Léchelles"
        },
        {
            "code": "1773",
            "localite": "Russy"
        },
        {
            "code": "1774",
            "localite": "Cousset"
        },
        {
            "code": "1774",
            "localite": "Montagny-les-Monts"
        },
        {
            "code": "1775",
            "localite": "Grandsivaz"
        },
        {
            "code": "1775",
            "localite": "Mannens"
        },
        {
            "code": "1776",
            "localite": "Montagny-la-Ville"
        },
        {
            "code": "1782",
            "localite": "Autafond"
        },
        {
            "code": "1782",
            "localite": "Belfaux"
        },
        {
            "code": "1782",
            "localite": "Cormagens"
        },
        {
            "code": "1782",
            "localite": "Formangueires"
        },
        {
            "code": "1782",
            "localite": "La Corbaz"
        },
        {
            "code": "1782",
            "localite": "Lossy"
        },
        {
            "code": "1783",
            "localite": "Barberêche"
        },
        {
            "code": "1783",
            "localite": "Pensier"
        },
        {
            "code": "1784",
            "localite": "Courtepin"
        },
        {
            "code": "1784",
            "localite": "Wallenried"
        },
        {
            "code": "1785",
            "localite": "Cressier FR"
        },
        {
            "code": "1786",
            "localite": "Sugiez"
        },
        {
            "code": "1787",
            "localite": "Mur (Vully) FR"
        },
        {
            "code": "1787",
            "localite": "Mur (Vully) VD"
        },
        {
            "code": "1787",
            "localite": "Môtier (Vully)"
        },
        {
            "code": "1788",
            "localite": "Praz (Vully)"
        },
        {
            "code": "1789",
            "localite": "Lugnorre"
        },
        {
            "code": "1791",
            "localite": "Courtaman"
        },
        {
            "code": "1792",
            "localite": "Cordast"
        },
        {
            "code": "1792",
            "localite": "Guschelmuth"
        },
        {
            "code": "1793",
            "localite": "Jeuss"
        },
        {
            "code": "1794",
            "localite": "Salvenach"
        },
        {
            "code": "1795",
            "localite": "Courlevon"
        },
        {
            "code": "1796",
            "localite": "Courgevaux"
        },
        {
            "code": "1797",
            "localite": "Münchenwiler"
        },
        {
            "code": "1800",
            "localite": "Vevey"
        },
        {
            "code": "1801",
            "localite": "Le Mont-Pèlerin"
        },
        {
            "code": "1802",
            "localite": "Corseaux"
        },
        {
            "code": "1803",
            "localite": "Chardonne"
        },
        {
            "code": "1804",
            "localite": "Corsier-sur-Vevey"
        },
        {
            "code": "1805",
            "localite": "Jongny"
        },
        {
            "code": "1806",
            "localite": "St-Légier-La Chiésaz"
        },
        {
            "code": "1807",
            "localite": "Blonay"
        },
        {
            "code": "1808",
            "localite": "Les Monts-de-Corsier"
        },
        {
            "code": "1809",
            "localite": "Fenil-sur-Corsier"
        },
        {
            "code": "1814",
            "localite": "La Tour-de-Peilz"
        },
        {
            "code": "1815",
            "localite": "Clarens"
        },
        {
            "code": "1816",
            "localite": "Chailly-Montreux"
        },
        {
            "code": "1817",
            "localite": "Brent"
        },
        {
            "code": "1820",
            "localite": "Montreux"
        },
        {
            "code": "1820",
            "localite": "Territet"
        },
        {
            "code": "1820",
            "localite": "Veytaux"
        },
        {
            "code": "1822",
            "localite": "Chernex"
        },
        {
            "code": "1823",
            "localite": "Glion"
        },
        {
            "code": "1824",
            "localite": "Caux"
        },
        {
            "code": "1832",
            "localite": "Chamby"
        },
        {
            "code": "1832",
            "localite": "Villard-sur-Chamby"
        },
        {
            "code": "1833",
            "localite": "Les Avants"
        },
        {
            "code": "1844",
            "localite": "Villeneuve VD"
        },
        {
            "code": "1845",
            "localite": "Noville"
        },
        {
            "code": "1846",
            "localite": "Chessel"
        },
        {
            "code": "1847",
            "localite": "Rennaz"
        },
        {
            "code": "1852",
            "localite": "Roche VD"
        },
        {
            "code": "1853",
            "localite": "Yvorne"
        },
        {
            "code": "1854",
            "localite": "Leysin"
        },
        {
            "code": "1856",
            "localite": "Corbeyrier"
        },
        {
            "code": "1860",
            "localite": "Aigle"
        },
        {
            "code": "1862",
            "localite": "La Comballaz"
        },
        {
            "code": "1862",
            "localite": "Les Mosses"
        },
        {
            "code": "1863",
            "localite": "Le Sépey"
        },
        {
            "code": "1864",
            "localite": "Vers-l'Eglise"
        },
        {
            "code": "1865",
            "localite": "Les Diablerets"
        },
        {
            "code": "1866",
            "localite": "La Forclaz VD"
        },
        {
            "code": "1867",
            "localite": "Ollon VD"
        },
        {
            "code": "1867",
            "localite": "Panex"
        },
        {
            "code": "1867",
            "localite": "St-Triphon"
        },
        {
            "code": "1868",
            "localite": "Collombey"
        },
        {
            "code": "1869",
            "localite": "Massongex"
        },
        {
            "code": "1870",
            "localite": "Monthey"
        },
        {
            "code": "1871",
            "localite": "Choëx"
        },
        {
            "code": "1871",
            "localite": "Les Giettes"
        },
        {
            "code": "1872",
            "localite": "Troistorrents"
        },
        {
            "code": "1873",
            "localite": "Champoussin"
        },
        {
            "code": "1873",
            "localite": "Les Crosets"
        },
        {
            "code": "1873",
            "localite": "Val-d'Illiez"
        },
        {
            "code": "1874",
            "localite": "Champéry"
        },
        {
            "code": "1875",
            "localite": "Morgins"
        },
        {
            "code": "1880",
            "localite": "Bex"
        },
        {
            "code": "1880",
            "localite": "Fenalet-sur-Bex"
        },
        {
            "code": "1880",
            "localite": "Frenières-sur-Bex"
        },
        {
            "code": "1880",
            "localite": "Les Plans-sur-Bex"
        },
        {
            "code": "1880",
            "localite": "Les Posses-sur-Bex"
        },
        {
            "code": "1882",
            "localite": "Gryon"
        },
        {
            "code": "1884",
            "localite": "Arveyes"
        },
        {
            "code": "1884",
            "localite": "Huémoz"
        },
        {
            "code": "1884",
            "localite": "Villars-sur-Ollon"
        },
        {
            "code": "1885",
            "localite": "Chesières"
        },
        {
            "code": "1890",
            "localite": "Mex VS"
        },
        {
            "code": "1890",
            "localite": "St-Maurice"
        },
        {
            "code": "1891",
            "localite": "Vérossaz"
        },
        {
            "code": "1892",
            "localite": "Lavey-Village"
        },
        {
            "code": "1892",
            "localite": "Lavey-les-Bains"
        },
        {
            "code": "1892",
            "localite": "Morcles"
        },
        {
            "code": "1893",
            "localite": "Muraz (Collombey)"
        },
        {
            "code": "1895",
            "localite": "Vionnaz"
        },
        {
            "code": "1896",
            "localite": "Miex"
        },
        {
            "code": "1896",
            "localite": "Vouvry"
        },
        {
            "code": "1897",
            "localite": "Bouveret"
        },
        {
            "code": "1897",
            "localite": "Les Evouettes"
        },
        {
            "code": "1898",
            "localite": "St-Gingolph"
        },
        {
            "code": "1899",
            "localite": "Torgon"
        },
        {
            "code": "1902",
            "localite": "Evionnaz"
        },
        {
            "code": "1903",
            "localite": "Collonges"
        },
        {
            "code": "1904",
            "localite": "Vernayaz"
        },
        {
            "code": "1905",
            "localite": "Dorénaz"
        },
        {
            "code": "1906",
            "localite": "Charrat"
        },
        {
            "code": "1907",
            "localite": "Saxon"
        },
        {
            "code": "1908",
            "localite": "Riddes"
        },
        {
            "code": "1911",
            "localite": "Ovronnaz"
        },
        {
            "code": "1912",
            "localite": "Dugny (Leytron)"
        },
        {
            "code": "1912",
            "localite": "Leytron"
        },
        {
            "code": "1912",
            "localite": "Montagnon (Leytron)"
        },
        {
            "code": "1912",
            "localite": "Produit (Leytron)"
        },
        {
            "code": "1913",
            "localite": "Saillon"
        },
        {
            "code": "1914",
            "localite": "Auddes-sur-Riddes"
        },
        {
            "code": "1914",
            "localite": "Isérables"
        },
        {
            "code": "1918",
            "localite": "La Tzoumaz"
        },
        {
            "code": "1920",
            "localite": "Martigny"
        },
        {
            "code": "1921",
            "localite": "Martigny-Croix"
        },
        {
            "code": "1922",
            "localite": "Les Granges (Salvan)"
        },
        {
            "code": "1922",
            "localite": "Salvan"
        },
        {
            "code": "1923",
            "localite": "Le Trétien"
        },
        {
            "code": "1923",
            "localite": "Les Marécottes"
        },
        {
            "code": "1925",
            "localite": "Finhaut"
        },
        {
            "code": "1925",
            "localite": "Le Châtelard VS"
        },
        {
            "code": "1926",
            "localite": "Fully"
        },
        {
            "code": "1927",
            "localite": "Chemin"
        },
        {
            "code": "1928",
            "localite": "Ravoire"
        },
        {
            "code": "1929",
            "localite": "Trient"
        },
        {
            "code": "1932",
            "localite": "Bovernier"
        },
        {
            "code": "1932",
            "localite": "Les Valettes (Bovernier)"
        },
        {
            "code": "1933",
            "localite": "Chamoille (Sembrancher)"
        },
        {
            "code": "1933",
            "localite": "La Garde (Sembrancher)"
        },
        {
            "code": "1933",
            "localite": "Sembrancher"
        },
        {
            "code": "1933",
            "localite": "Vens (Sembrancher)"
        },
        {
            "code": "1934",
            "localite": "Bruson"
        },
        {
            "code": "1934",
            "localite": "Le Châble VS"
        },
        {
            "code": "1936",
            "localite": "Verbier"
        },
        {
            "code": "1937",
            "localite": "Orsières"
        },
        {
            "code": "1938",
            "localite": "Champex-Lac"
        },
        {
            "code": "1941",
            "localite": "Cries (Vollèges)"
        },
        {
            "code": "1941",
            "localite": "Vollèges"
        },
        {
            "code": "1942",
            "localite": "Levron"
        },
        {
            "code": "1943",
            "localite": "Praz-de-Fort"
        },
        {
            "code": "1944",
            "localite": "La Fouly VS"
        },
        {
            "code": "1945",
            "localite": "Chandonne (Liddes)"
        },
        {
            "code": "1945",
            "localite": "Chez Petit (Liddes)"
        },
        {
            "code": "1945",
            "localite": "Dranse (Liddes)"
        },
        {
            "code": "1945",
            "localite": "Fontaine Dessous (Liddes)"
        },
        {
            "code": "1945",
            "localite": "Fontaine Dessus (Liddes)"
        },
        {
            "code": "1945",
            "localite": "Fornex (Liddes)"
        },
        {
            "code": "1945",
            "localite": "Les Moulins VS (Liddes)"
        },
        {
            "code": "1945",
            "localite": "Liddes"
        },
        {
            "code": "1945",
            "localite": "Palasuit (Liddes)"
        },
        {
            "code": "1945",
            "localite": "Petit Vichères (Liddes)"
        },
        {
            "code": "1945",
            "localite": "Rive Haute (Liddes)"
        },
        {
            "code": "1945",
            "localite": "Vichères (Liddes)"
        },
        {
            "code": "1946",
            "localite": "Bourg-St-Pierre"
        },
        {
            "code": "1947",
            "localite": "Champsec"
        },
        {
            "code": "1947",
            "localite": "Versegères"
        },
        {
            "code": "1948",
            "localite": "Fionnay"
        },
        {
            "code": "1948",
            "localite": "Lourtier"
        },
        {
            "code": "1948",
            "localite": "Sarreyer"
        },
        {
            "code": "1950",
            "localite": "Sion"
        },
        {
            "code": "1955",
            "localite": "Chamoson"
        },
        {
            "code": "1955",
            "localite": "Grugnay (Chamoson)"
        },
        {
            "code": "1955",
            "localite": "Les Vérines (Chamoson)"
        },
        {
            "code": "1955",
            "localite": "Mayens-de-Chamoson"
        },
        {
            "code": "1955",
            "localite": "Némiaz (Chamoson)"
        },
        {
            "code": "1955",
            "localite": "St-Pierre-de-Clages"
        },
        {
            "code": "1957",
            "localite": "Ardon"
        },
        {
            "code": "1958",
            "localite": "St-Léonard"
        },
        {
            "code": "1958",
            "localite": "Uvrier"
        },
        {
            "code": "1961",
            "localite": "Vernamiège"
        },
        {
            "code": "1962",
            "localite": "Pont-de-la-Morge (Sion)"
        },
        {
            "code": "1963",
            "localite": "Vétroz"
        },
        {
            "code": "1964",
            "localite": "Conthey"
        },
        {
            "code": "1965",
            "localite": "Savièse"
        },
        {
            "code": "1966",
            "localite": "Argnou (Ayent)"
        },
        {
            "code": "1966",
            "localite": "Blignou (Ayent)"
        },
        {
            "code": "1966",
            "localite": "Botyre (Ayent)"
        },
        {
            "code": "1966",
            "localite": "Fortunau (Ayent)"
        },
        {
            "code": "1966",
            "localite": "La Place (Ayent)"
        },
        {
            "code": "1966",
            "localite": "Luc (Ayent)"
        },
        {
            "code": "1966",
            "localite": "Saxonne (Ayent)"
        },
        {
            "code": "1966",
            "localite": "Signèse (Ayent)"
        },
        {
            "code": "1966",
            "localite": "St-Romain (Ayent)"
        },
        {
            "code": "1966",
            "localite": "Villa (Ayent)"
        },
        {
            "code": "1967",
            "localite": "Bramois"
        },
        {
            "code": "1968",
            "localite": "Mase"
        },
        {
            "code": "1969",
            "localite": "Eison (St-Martin)"
        },
        {
            "code": "1969",
            "localite": "Liez (St-Martin)"
        },
        {
            "code": "1969",
            "localite": "St-Martin VS"
        },
        {
            "code": "1969",
            "localite": "Suen (St-Martin)"
        },
        {
            "code": "1969",
            "localite": "Trogne (St-Martin)"
        },
        {
            "code": "1971",
            "localite": "Champlan (Grimisuat)"
        },
        {
            "code": "1971",
            "localite": "Grimisuat"
        },
        {
            "code": "1972",
            "localite": "Anzère"
        },
        {
            "code": "1973",
            "localite": "Nax"
        },
        {
            "code": "1974",
            "localite": "Arbaz"
        },
        {
            "code": "1975",
            "localite": "St-Séverin"
        },
        {
            "code": "1976",
            "localite": "Aven"
        },
        {
            "code": "1976",
            "localite": "Daillon"
        },
        {
            "code": "1976",
            "localite": "Erde"
        },
        {
            "code": "1977",
            "localite": "Icogne"
        },
        {
            "code": "1978",
            "localite": "Lens"
        },
        {
            "code": "1981",
            "localite": "Vex"
        },
        {
            "code": "1982",
            "localite": "Euseigne"
        },
        {
            "code": "1983",
            "localite": "Evolène"
        },
        {
            "code": "1983",
            "localite": "Lanna"
        },
        {
            "code": "1984",
            "localite": "La Tour VS"
        },
        {
            "code": "1984",
            "localite": "Les Haudères"
        },
        {
            "code": "1985",
            "localite": "La Forclaz VS"
        },
        {
            "code": "1985",
            "localite": "La Sage"
        },
        {
            "code": "1985",
            "localite": "Villa (Evolène)"
        },
        {
            "code": "1986",
            "localite": "Arolla"
        },
        {
            "code": "1987",
            "localite": "Hérémence"
        },
        {
            "code": "1988",
            "localite": "Les Collons"
        },
        {
            "code": "1988",
            "localite": "Thyon"
        },
        {
            "code": "1991",
            "localite": "Arvillard (Salins)"
        },
        {
            "code": "1991",
            "localite": "Misériez (Salins)"
        },
        {
            "code": "1991",
            "localite": "Pravidondaz (Salins)"
        },
        {
            "code": "1991",
            "localite": "Salins"
        },
        {
            "code": "1991",
            "localite": "Turin (Salins)"
        },
        {
            "code": "1992",
            "localite": "Crête-à-l'Oeil (Les Agettes)"
        },
        {
            "code": "1992",
            "localite": "La Vernaz (Les Agettes)"
        },
        {
            "code": "1992",
            "localite": "Les Agettes"
        },
        {
            "code": "1992",
            "localite": "Les Mayens-de-Sion"
        },
        {
            "code": "1993",
            "localite": "Clèbes (Nendaz)"
        },
        {
            "code": "1993",
            "localite": "Veysonnaz"
        },
        {
            "code": "1994",
            "localite": "Aproz (Nendaz)"
        },
        {
            "code": "1996",
            "localite": "Baar (Nendaz)"
        },
        {
            "code": "1996",
            "localite": "Basse-Nendaz"
        },
        {
            "code": "1996",
            "localite": "Beuson (Nendaz)"
        },
        {
            "code": "1996",
            "localite": "Bieudron (Nendaz)"
        },
        {
            "code": "1996",
            "localite": "Brignon (Nendaz)"
        },
        {
            "code": "1996",
            "localite": "Condémines (Nendaz)"
        },
        {
            "code": "1996",
            "localite": "Fey (Nendaz)"
        },
        {
            "code": "1996",
            "localite": "Saclentse"
        },
        {
            "code": "1997",
            "localite": "Haute-Nendaz"
        },
        {
            "code": "1997",
            "localite": "Siviez (Nendaz)"
        },
        {
            "code": "1997",
            "localite": "Sornard (Nendaz)"
        },
        {
            "code": "2000",
            "localite": "Neuchâtel"
        },
        {
            "code": "2012",
            "localite": "Auvernier"
        },
        {
            "code": "2013",
            "localite": "Colombier NE"
        },
        {
            "code": "2014",
            "localite": "Bôle"
        },
        {
            "code": "2015",
            "localite": "Areuse"
        },
        {
            "code": "2016",
            "localite": "Cortaillod"
        },
        {
            "code": "2017",
            "localite": "Boudry"
        },
        {
            "code": "2019",
            "localite": "Chambrelien"
        },
        {
            "code": "2019",
            "localite": "Rochefort"
        },
        {
            "code": "2022",
            "localite": "Bevaix"
        },
        {
            "code": "2023",
            "localite": "Gorgier"
        },
        {
            "code": "2024",
            "localite": "St-Aubin-Sauges"
        },
        {
            "code": "2025",
            "localite": "Chez-le-Bart"
        },
        {
            "code": "2027",
            "localite": "Fresens"
        },
        {
            "code": "2027",
            "localite": "Montalchez"
        },
        {
            "code": "2028",
            "localite": "Vaumarcus"
        },
        {
            "code": "2034",
            "localite": "Peseux"
        },
        {
            "code": "2035",
            "localite": "Corcelles NE"
        },
        {
            "code": "2036",
            "localite": "Cormondrèche"
        },
        {
            "code": "2037",
            "localite": "Montezillon"
        },
        {
            "code": "2037",
            "localite": "Montmollin"
        },
        {
            "code": "2042",
            "localite": "Valangin"
        },
        {
            "code": "2043",
            "localite": "Boudevilliers"
        },
        {
            "code": "2046",
            "localite": "Fontaines NE"
        },
        {
            "code": "2052",
            "localite": "Fontainemelon"
        },
        {
            "code": "2052",
            "localite": "La Vue-des-Alpes"
        },
        {
            "code": "2053",
            "localite": "Cernier"
        },
        {
            "code": "2054",
            "localite": "Chézard-St-Martin"
        },
        {
            "code": "2054",
            "localite": "Les Vieux-Prés"
        },
        {
            "code": "2056",
            "localite": "Dombresson"
        },
        {
            "code": "2057",
            "localite": "Villiers"
        },
        {
            "code": "2058",
            "localite": "Le Pâquier NE"
        },
        {
            "code": "2063",
            "localite": "Engollon"
        },
        {
            "code": "2063",
            "localite": "Fenin"
        },
        {
            "code": "2063",
            "localite": "Saules"
        },
        {
            "code": "2063",
            "localite": "Vilars NE"
        },
        {
            "code": "2065",
            "localite": "Savagnier"
        },
        {
            "code": "2067",
            "localite": "Chaumont"
        },
        {
            "code": "2068",
            "localite": "Hauterive NE"
        },
        {
            "code": "2072",
            "localite": "St-Blaise"
        },
        {
            "code": "2073",
            "localite": "Enges"
        },
        {
            "code": "2074",
            "localite": "Marin-Epagnier"
        },
        {
            "code": "2075",
            "localite": "Thielle"
        },
        {
            "code": "2075",
            "localite": "Wavre"
        },
        {
            "code": "2087",
            "localite": "Cornaux NE"
        },
        {
            "code": "2088",
            "localite": "Cressier NE"
        },
        {
            "code": "2103",
            "localite": "Noiraigue"
        },
        {
            "code": "2105",
            "localite": "Travers"
        },
        {
            "code": "2108",
            "localite": "Couvet"
        },
        {
            "code": "2112",
            "localite": "Môtiers NE"
        },
        {
            "code": "2113",
            "localite": "Boveresse"
        },
        {
            "code": "2114",
            "localite": "Fleurier"
        },
        {
            "code": "2115",
            "localite": "Buttes"
        },
        {
            "code": "2116",
            "localite": "Mont-de-Buttes"
        },
        {
            "code": "2117",
            "localite": "La Côte-aux-Fées"
        },
        {
            "code": "2123",
            "localite": "St-Sulpice NE"
        },
        {
            "code": "2124",
            "localite": "Les Sagnettes"
        },
        {
            "code": "2126",
            "localite": "Les Verrières"
        },
        {
            "code": "2127",
            "localite": "Les Bayards"
        },
        {
            "code": "2149",
            "localite": "Brot-Dessous"
        },
        {
            "code": "2149",
            "localite": "Champ-du-Moulin"
        },
        {
            "code": "2149",
            "localite": "Fretereules"
        },
        {
            "code": "2206",
            "localite": "Les Geneveys-sur-Coffrane"
        },
        {
            "code": "2207",
            "localite": "Coffrane"
        },
        {
            "code": "2208",
            "localite": "Les Hauts-Geneveys"
        },
        {
            "code": "2300",
            "localite": "La Chaux-de-Fonds"
        },
        {
            "code": "2300",
            "localite": "La Cibourg"
        },
        {
            "code": "2314",
            "localite": "La Sagne NE"
        },
        {
            "code": "2316",
            "localite": "Les Ponts-de-Martel"
        },
        {
            "code": "2316",
            "localite": "Petit-Martel"
        },
        {
            "code": "2318",
            "localite": "Brot-Plamboz"
        },
        {
            "code": "2322",
            "localite": "Le Crêt-du-Locle"
        },
        {
            "code": "2325",
            "localite": "Les Planchettes"
        },
        {
            "code": "2333",
            "localite": "La Cibourg"
        },
        {
            "code": "2333",
            "localite": "La Ferrière"
        },
        {
            "code": "2336",
            "localite": "Les Bois"
        },
        {
            "code": "2338",
            "localite": "Les Emibois"
        },
        {
            "code": "2338",
            "localite": "Muriaux"
        },
        {
            "code": "2340",
            "localite": "Le Noirmont"
        },
        {
            "code": "2345",
            "localite": "La Chaux-des-Breuleux"
        },
        {
            "code": "2345",
            "localite": "Le Cerneux-Veusil"
        },
        {
            "code": "2345",
            "localite": "Le Peuchapatte"
        },
        {
            "code": "2345",
            "localite": "Les Breuleux"
        },
        {
            "code": "2350",
            "localite": "Saignelégier"
        },
        {
            "code": "2353",
            "localite": "Les Pommerats"
        },
        {
            "code": "2354",
            "localite": "Goumois"
        },
        {
            "code": "2360",
            "localite": "Le Bémont JU"
        },
        {
            "code": "2362",
            "localite": "Montfaucon"
        },
        {
            "code": "2362",
            "localite": "Montfavergier"
        },
        {
            "code": "2363",
            "localite": "Les Enfers"
        },
        {
            "code": "2364",
            "localite": "St-Brais"
        },
        {
            "code": "2400",
            "localite": "Le Locle"
        },
        {
            "code": "2400",
            "localite": "Le Prévoux"
        },
        {
            "code": "2405",
            "localite": "La Chaux-du-Milieu"
        },
        {
            "code": "2406",
            "localite": "La Brévine"
        },
        {
            "code": "2406",
            "localite": "La Châtagne"
        },
        {
            "code": "2406",
            "localite": "Le Brouillet"
        },
        {
            "code": "2406",
            "localite": "Les Taillères"
        },
        {
            "code": "2414",
            "localite": "Le Cerneux-Péquignot"
        },
        {
            "code": "2416",
            "localite": "Les Brenets"
        },
        {
            "code": "2502",
            "localite": "Biel/Bienne"
        },
        {
            "code": "2503",
            "localite": "Biel/Bienne"
        },
        {
            "code": "2504",
            "localite": "Biel/Bienne"
        },
        {
            "code": "2505",
            "localite": "Biel/Bienne"
        },
        {
            "code": "2512",
            "localite": "Tüscherz-Alfermée"
        },
        {
            "code": "2513",
            "localite": "Twann"
        },
        {
            "code": "2514",
            "localite": "Ligerz"
        },
        {
            "code": "2515",
            "localite": "Prêles"
        },
        {
            "code": "2516",
            "localite": "Lamboing"
        },
        {
            "code": "2517",
            "localite": "Diesse"
        },
        {
            "code": "2518",
            "localite": "Nods"
        },
        {
            "code": "2520",
            "localite": "La Neuveville"
        },
        {
            "code": "2523",
            "localite": "Lignières"
        },
        {
            "code": "2525",
            "localite": "Le Landeron"
        },
        {
            "code": "2532",
            "localite": "Magglingen/Macolin"
        },
        {
            "code": "2533",
            "localite": "Evilard"
        },
        {
            "code": "2534",
            "localite": "Les Prés-d'Orvin"
        },
        {
            "code": "2534",
            "localite": "Orvin"
        },
        {
            "code": "2535",
            "localite": "Frinvillier"
        },
        {
            "code": "2536",
            "localite": "Plagne"
        },
        {
            "code": "2537",
            "localite": "Vauffelin"
        },
        {
            "code": "2538",
            "localite": "Romont BE"
        },
        {
            "code": "2540",
            "localite": "Grenchen"
        },
        {
            "code": "2542",
            "localite": "Pieterlen"
        },
        {
            "code": "2543",
            "localite": "Lengnau BE"
        },
        {
            "code": "2544",
            "localite": "Bettlach"
        },
        {
            "code": "2545",
            "localite": "Selzach"
        },
        {
            "code": "2552",
            "localite": "Orpund"
        },
        {
            "code": "2553",
            "localite": "Safnern"
        },
        {
            "code": "2554",
            "localite": "Meinisberg"
        },
        {
            "code": "2555",
            "localite": "Brügg BE"
        },
        {
            "code": "2556",
            "localite": "Scheuren"
        },
        {
            "code": "2556",
            "localite": "Schwadernau"
        },
        {
            "code": "2557",
            "localite": "Studen BE"
        },
        {
            "code": "2558",
            "localite": "Aegerten"
        },
        {
            "code": "2560",
            "localite": "Nidau"
        },
        {
            "code": "2562",
            "localite": "Port"
        },
        {
            "code": "2563",
            "localite": "Ipsach"
        },
        {
            "code": "2564",
            "localite": "Bellmund"
        },
        {
            "code": "2565",
            "localite": "Jens"
        },
        {
            "code": "2572",
            "localite": "Mörigen"
        },
        {
            "code": "2572",
            "localite": "Sutz"
        },
        {
            "code": "2575",
            "localite": "Gerolfingen"
        },
        {
            "code": "2575",
            "localite": "Hagneck"
        },
        {
            "code": "2575",
            "localite": "Täuffelen"
        },
        {
            "code": "2576",
            "localite": "Lüscherz"
        },
        {
            "code": "2577",
            "localite": "Finsterhennen"
        },
        {
            "code": "2577",
            "localite": "Siselen BE"
        },
        {
            "code": "2603",
            "localite": "Péry"
        },
        {
            "code": "2604",
            "localite": "La Heutte"
        },
        {
            "code": "2605",
            "localite": "Sonceboz-Sombeval"
        },
        {
            "code": "2606",
            "localite": "Corgémont"
        },
        {
            "code": "2607",
            "localite": "Cortébert"
        },
        {
            "code": "2608",
            "localite": "Courtelary"
        },
        {
            "code": "2608",
            "localite": "Montagne-de-Courtelary"
        },
        {
            "code": "2610",
            "localite": "Les Pontins"
        },
        {
            "code": "2610",
            "localite": "Mont-Crosin"
        },
        {
            "code": "2610",
            "localite": "Mont-Soleil"
        },
        {
            "code": "2610",
            "localite": "St-Imier"
        },
        {
            "code": "2612",
            "localite": "Cormoret"
        },
        {
            "code": "2613",
            "localite": "Villeret"
        },
        {
            "code": "2615",
            "localite": "Montagne-de-Sonvilier"
        },
        {
            "code": "2615",
            "localite": "Sonvilier"
        },
        {
            "code": "2616",
            "localite": "La Cibourg"
        },
        {
            "code": "2616",
            "localite": "Renan BE"
        },
        {
            "code": "2710",
            "localite": "Tavannes"
        },
        {
            "code": "2712",
            "localite": "Le Fuet"
        },
        {
            "code": "2713",
            "localite": "Bellelay"
        },
        {
            "code": "2714",
            "localite": "Le Prédame"
        },
        {
            "code": "2714",
            "localite": "Les Genevez JU"
        },
        {
            "code": "2715",
            "localite": "Châtelat"
        },
        {
            "code": "2715",
            "localite": "Monible"
        },
        {
            "code": "2716",
            "localite": "Sornetan"
        },
        {
            "code": "2717",
            "localite": "Fornet-Dessous"
        },
        {
            "code": "2717",
            "localite": "Rebévelier"
        },
        {
            "code": "2718",
            "localite": "Fornet-Dessus"
        },
        {
            "code": "2718",
            "localite": "Lajoux JU"
        },
        {
            "code": "2720",
            "localite": "La Tanne"
        },
        {
            "code": "2720",
            "localite": "Tramelan"
        },
        {
            "code": "2722",
            "localite": "Les Reussilles"
        },
        {
            "code": "2723",
            "localite": "Mont-Tramelan"
        },
        {
            "code": "2732",
            "localite": "Loveresse"
        },
        {
            "code": "2732",
            "localite": "Reconvilier"
        },
        {
            "code": "2732",
            "localite": "Saicourt"
        },
        {
            "code": "2732",
            "localite": "Saules BE"
        },
        {
            "code": "2733",
            "localite": "Pontenet"
        },
        {
            "code": "2735",
            "localite": "Bévilard"
        },
        {
            "code": "2735",
            "localite": "Champoz"
        },
        {
            "code": "2735",
            "localite": "Malleray"
        },
        {
            "code": "2736",
            "localite": "Sorvilier"
        },
        {
            "code": "2738",
            "localite": "Court"
        },
        {
            "code": "2740",
            "localite": "Moutier"
        },
        {
            "code": "2742",
            "localite": "Perrefitte"
        },
        {
            "code": "2743",
            "localite": "Eschert"
        },
        {
            "code": "2744",
            "localite": "Belprahon"
        },
        {
            "code": "2745",
            "localite": "Grandval"
        },
        {
            "code": "2746",
            "localite": "Crémines"
        },
        {
            "code": "2747",
            "localite": "Corcelles BE"
        },
        {
            "code": "2747",
            "localite": "Seehof"
        },
        {
            "code": "2748",
            "localite": "Les Ecorcheresses"
        },
        {
            "code": "2748",
            "localite": "Souboz"
        },
        {
            "code": "2762",
            "localite": "Roches BE"
        },
        {
            "code": "2800",
            "localite": "Delémont"
        },
        {
            "code": "2802",
            "localite": "Develier"
        },
        {
            "code": "2803",
            "localite": "Bourrignon"
        },
        {
            "code": "2805",
            "localite": "Soyhières"
        },
        {
            "code": "2806",
            "localite": "Mettembert"
        },
        {
            "code": "2807",
            "localite": "Lucelle"
        },
        {
            "code": "2807",
            "localite": "Pleigne"
        },
        {
            "code": "2812",
            "localite": "Movelier"
        },
        {
            "code": "2813",
            "localite": "Ederswiler"
        },
        {
            "code": "2814",
            "localite": "Roggenburg"
        },
        {
            "code": "2822",
            "localite": "Courroux"
        },
        {
            "code": "2823",
            "localite": "Courcelon"
        },
        {
            "code": "2824",
            "localite": "Vicques"
        },
        {
            "code": "2825",
            "localite": "Courchapoix"
        },
        {
            "code": "2826",
            "localite": "Corban"
        },
        {
            "code": "2827",
            "localite": "Mervelier"
        },
        {
            "code": "2827",
            "localite": "Schelten"
        },
        {
            "code": "2828",
            "localite": "Montsevelier"
        },
        {
            "code": "2829",
            "localite": "Vermes"
        },
        {
            "code": "2830",
            "localite": "Courrendlin"
        },
        {
            "code": "2830",
            "localite": "Vellerat"
        },
        {
            "code": "2832",
            "localite": "Rebeuvelier"
        },
        {
            "code": "2842",
            "localite": "Rossemaison"
        },
        {
            "code": "2843",
            "localite": "Châtillon JU"
        },
        {
            "code": "2852",
            "localite": "Courtételle"
        },
        {
            "code": "2853",
            "localite": "Courfaivre"
        },
        {
            "code": "2854",
            "localite": "Bassecourt"
        },
        {
            "code": "2855",
            "localite": "Glovelier"
        },
        {
            "code": "2856",
            "localite": "Boécourt"
        },
        {
            "code": "2857",
            "localite": "Montavon"
        },
        {
            "code": "2863",
            "localite": "Undervelier"
        },
        {
            "code": "2864",
            "localite": "Soulce"
        },
        {
            "code": "2873",
            "localite": "Saulcy"
        },
        {
            "code": "2882",
            "localite": "St-Ursanne"
        },
        {
            "code": "2883",
            "localite": "Montmelon"
        },
        {
            "code": "2884",
            "localite": "Montenol"
        },
        {
            "code": "2885",
            "localite": "Epauvillers"
        },
        {
            "code": "2886",
            "localite": "Epiquerez"
        },
        {
            "code": "2887",
            "localite": "Soubey"
        },
        {
            "code": "2888",
            "localite": "Seleute"
        },
        {
            "code": "2889",
            "localite": "Ocourt"
        },
        {
            "code": "2900",
            "localite": "Porrentruy"
        },
        {
            "code": "2902",
            "localite": "Fontenais"
        },
        {
            "code": "2903",
            "localite": "Villars-sur-Fontenais"
        },
        {
            "code": "2904",
            "localite": "Bressaucourt"
        },
        {
            "code": "2905",
            "localite": "Courtedoux"
        },
        {
            "code": "2906",
            "localite": "Chevenez"
        },
        {
            "code": "2907",
            "localite": "Rocourt"
        },
        {
            "code": "2908",
            "localite": "Grandfontaine"
        },
        {
            "code": "2912",
            "localite": "Roche-d'Or"
        },
        {
            "code": "2912",
            "localite": "Réclère"
        },
        {
            "code": "2914",
            "localite": "Damvant"
        },
        {
            "code": "2915",
            "localite": "Bure"
        },
        {
            "code": "2916",
            "localite": "Fahy"
        },
        {
            "code": "2922",
            "localite": "Courchavon"
        },
        {
            "code": "2923",
            "localite": "Courtemaîche"
        },
        {
            "code": "2924",
            "localite": "Montignez"
        },
        {
            "code": "2925",
            "localite": "Buix"
        },
        {
            "code": "2926",
            "localite": "Boncourt"
        },
        {
            "code": "2932",
            "localite": "Coeuve"
        },
        {
            "code": "2933",
            "localite": "Damphreux"
        },
        {
            "code": "2933",
            "localite": "Lugnez"
        },
        {
            "code": "2935",
            "localite": "Beurnevésin"
        },
        {
            "code": "2942",
            "localite": "Alle"
        },
        {
            "code": "2943",
            "localite": "Vendlincourt"
        },
        {
            "code": "2944",
            "localite": "Bonfol"
        },
        {
            "code": "2946",
            "localite": "Miécourt"
        },
        {
            "code": "2947",
            "localite": "Charmoille"
        },
        {
            "code": "2950",
            "localite": "Courgenay"
        },
        {
            "code": "2950",
            "localite": "Courtemautruy"
        },
        {
            "code": "2952",
            "localite": "Cornol"
        },
        {
            "code": "2953",
            "localite": "Fregiécourt"
        },
        {
            "code": "2953",
            "localite": "Pleujouse"
        },
        {
            "code": "2954",
            "localite": "Asuel"
        },
        {
            "code": "3004",
            "localite": "Bern"
        },
        {
            "code": "3005",
            "localite": "Bern"
        },
        {
            "code": "3006",
            "localite": "Bern"
        },
        {
            "code": "3007",
            "localite": "Bern"
        },
        {
            "code": "3008",
            "localite": "Bern"
        },
        {
            "code": "3010",
            "localite": "Bern"
        },
        {
            "code": "3011",
            "localite": "Bern"
        },
        {
            "code": "3012",
            "localite": "Bern"
        },
        {
            "code": "3013",
            "localite": "Bern"
        },
        {
            "code": "3014",
            "localite": "Bern"
        },
        {
            "code": "3015",
            "localite": "Bern"
        },
        {
            "code": "3018",
            "localite": "Bern"
        },
        {
            "code": "3019",
            "localite": "Bern"
        },
        {
            "code": "3020",
            "localite": "Bern"
        },
        {
            "code": "3027",
            "localite": "Bern"
        },
        {
            "code": "3032",
            "localite": "Hinterkappelen"
        },
        {
            "code": "3033",
            "localite": "Wohlen b. Bern"
        },
        {
            "code": "3034",
            "localite": "Murzelen"
        },
        {
            "code": "3035",
            "localite": "Frieswil"
        },
        {
            "code": "3036",
            "localite": "Detligen"
        },
        {
            "code": "3037",
            "localite": "Herrenschwanden"
        },
        {
            "code": "3038",
            "localite": "Kirchlindach"
        },
        {
            "code": "3042",
            "localite": "Ortschwaben"
        },
        {
            "code": "3043",
            "localite": "Uettligen"
        },
        {
            "code": "3044",
            "localite": "Innerberg"
        },
        {
            "code": "3045",
            "localite": "Meikirch"
        },
        {
            "code": "3046",
            "localite": "Wahlendorf"
        },
        {
            "code": "3047",
            "localite": "Bremgarten b. Bern"
        },
        {
            "code": "3048",
            "localite": "Worblaufen"
        },
        {
            "code": "3049",
            "localite": "Säriswil"
        },
        {
            "code": "3052",
            "localite": "Zollikofen"
        },
        {
            "code": "3053",
            "localite": "Deisswil b. Münchenbuchsee"
        },
        {
            "code": "3053",
            "localite": "Diemerswil"
        },
        {
            "code": "3053",
            "localite": "Lätti"
        },
        {
            "code": "3053",
            "localite": "Münchenbuchsee"
        },
        {
            "code": "3053",
            "localite": "Wiggiswil"
        },
        {
            "code": "3054",
            "localite": "Schüpfen"
        },
        {
            "code": "3063",
            "localite": "Ittigen"
        },
        {
            "code": "3065",
            "localite": "Bolligen"
        },
        {
            "code": "3066",
            "localite": "Stettlen"
        },
        {
            "code": "3067",
            "localite": "Boll"
        },
        {
            "code": "3068",
            "localite": "Utzigen"
        },
        {
            "code": "3072",
            "localite": "Ostermundigen"
        },
        {
            "code": "3073",
            "localite": "Gümligen"
        },
        {
            "code": "3074",
            "localite": "Muri b. Bern"
        },
        {
            "code": "3075",
            "localite": "Rüfenacht BE"
        },
        {
            "code": "3075",
            "localite": "Vielbringen b. Worb"
        },
        {
            "code": "3076",
            "localite": "Worb"
        },
        {
            "code": "3077",
            "localite": "Enggistein"
        },
        {
            "code": "3078",
            "localite": "Richigen"
        },
        {
            "code": "3082",
            "localite": "Schlosswil"
        },
        {
            "code": "3083",
            "localite": "Trimstein"
        },
        {
            "code": "3084",
            "localite": "Wabern"
        },
        {
            "code": "3086",
            "localite": "Englisberg"
        },
        {
            "code": "3086",
            "localite": "Zimmerwald"
        },
        {
            "code": "3087",
            "localite": "Niedermuhlern"
        },
        {
            "code": "3088",
            "localite": "Oberbütschel"
        },
        {
            "code": "3088",
            "localite": "Rüeggisberg"
        },
        {
            "code": "3089",
            "localite": "Hinterfultigen"
        },
        {
            "code": "3095",
            "localite": "Spiegel b. Bern"
        },
        {
            "code": "3096",
            "localite": "Oberbalm"
        },
        {
            "code": "3097",
            "localite": "Liebefeld"
        },
        {
            "code": "3098",
            "localite": "Köniz"
        },
        {
            "code": "3098",
            "localite": "Schliern b. Köniz"
        },
        {
            "code": "3099",
            "localite": "Rüti b. Riggisberg"
        },
        {
            "code": "3110",
            "localite": "Münsingen"
        },
        {
            "code": "3111",
            "localite": "Tägertschi"
        },
        {
            "code": "3112",
            "localite": "Allmendingen b. Bern"
        },
        {
            "code": "3113",
            "localite": "Rubigen"
        },
        {
            "code": "3114",
            "localite": "Wichtrach"
        },
        {
            "code": "3115",
            "localite": "Gerzensee"
        },
        {
            "code": "3116",
            "localite": "Kirchdorf BE"
        },
        {
            "code": "3116",
            "localite": "Mühledorf BE"
        },
        {
            "code": "3116",
            "localite": "Noflen BE"
        },
        {
            "code": "3122",
            "localite": "Kehrsatz"
        },
        {
            "code": "3123",
            "localite": "Belp"
        },
        {
            "code": "3124",
            "localite": "Belpberg"
        },
        {
            "code": "3125",
            "localite": "Toffen"
        },
        {
            "code": "3126",
            "localite": "Gelterfingen"
        },
        {
            "code": "3126",
            "localite": "Kaufdorf"
        },
        {
            "code": "3127",
            "localite": "Lohnstorf"
        },
        {
            "code": "3127",
            "localite": "Mühlethurnen"
        },
        {
            "code": "3128",
            "localite": "Kirchenthurnen"
        },
        {
            "code": "3128",
            "localite": "Rümligen"
        },
        {
            "code": "3132",
            "localite": "Riggisberg"
        },
        {
            "code": "3144",
            "localite": "Gasel"
        },
        {
            "code": "3145",
            "localite": "Niederscherli"
        },
        {
            "code": "3147",
            "localite": "Mittelhäusern"
        },
        {
            "code": "3148",
            "localite": "Lanzenhäusern"
        },
        {
            "code": "3150",
            "localite": "Schwarzenburg"
        },
        {
            "code": "3152",
            "localite": "Mamishaus"
        },
        {
            "code": "3153",
            "localite": "Rüschegg Gambach"
        },
        {
            "code": "3154",
            "localite": "Rüschegg Heubach"
        },
        {
            "code": "3155",
            "localite": "Helgisried-Rohrbach"
        },
        {
            "code": "3156",
            "localite": "Riffenmatt"
        },
        {
            "code": "3157",
            "localite": "Milken"
        },
        {
            "code": "3158",
            "localite": "Guggisberg"
        },
        {
            "code": "3159",
            "localite": "Riedstätt"
        },
        {
            "code": "3172",
            "localite": "Niederwangen b. Bern"
        },
        {
            "code": "3173",
            "localite": "Oberwangen b. Bern"
        },
        {
            "code": "3174",
            "localite": "Thörishaus"
        },
        {
            "code": "3175",
            "localite": "Flamatt"
        },
        {
            "code": "3176",
            "localite": "Neuenegg"
        },
        {
            "code": "3177",
            "localite": "Laupen BE"
        },
        {
            "code": "3178",
            "localite": "Bösingen"
        },
        {
            "code": "3179",
            "localite": "Kriechenwil"
        },
        {
            "code": "3182",
            "localite": "Ueberstorf"
        },
        {
            "code": "3183",
            "localite": "Albligen"
        },
        {
            "code": "3184",
            "localite": "Wünnewil"
        },
        {
            "code": "3185",
            "localite": "Schmitten FR"
        },
        {
            "code": "3186",
            "localite": "Düdingen"
        },
        {
            "code": "3202",
            "localite": "Frauenkappelen"
        },
        {
            "code": "3203",
            "localite": "Mühleberg"
        },
        {
            "code": "3204",
            "localite": "Rosshäusern"
        },
        {
            "code": "3205",
            "localite": "Gümmenen"
        },
        {
            "code": "3206",
            "localite": "Biberen"
        },
        {
            "code": "3206",
            "localite": "Ferenbalm"
        },
        {
            "code": "3206",
            "localite": "Gammen"
        },
        {
            "code": "3206",
            "localite": "Rizenbach"
        },
        {
            "code": "3206",
            "localite": "Wallenbuch"
        },
        {
            "code": "3207",
            "localite": "Golaten"
        },
        {
            "code": "3207",
            "localite": "Wileroltigen"
        },
        {
            "code": "3208",
            "localite": "Gurbrü"
        },
        {
            "code": "3210",
            "localite": "Kerzers"
        },
        {
            "code": "3212",
            "localite": "Gurmels"
        },
        {
            "code": "3212",
            "localite": "Kleingurmels"
        },
        {
            "code": "3213",
            "localite": "Kleinbösingen"
        },
        {
            "code": "3213",
            "localite": "Liebistorf"
        },
        {
            "code": "3214",
            "localite": "Ulmiz"
        },
        {
            "code": "3215",
            "localite": "Büchslen"
        },
        {
            "code": "3215",
            "localite": "Gempenach"
        },
        {
            "code": "3215",
            "localite": "Lurtigen"
        },
        {
            "code": "3216",
            "localite": "Agriswil"
        },
        {
            "code": "3216",
            "localite": "Ried b. Kerzers"
        },
        {
            "code": "3225",
            "localite": "Müntschemier"
        },
        {
            "code": "3226",
            "localite": "Treiten"
        },
        {
            "code": "3232",
            "localite": "Ins"
        },
        {
            "code": "3233",
            "localite": "Tschugg"
        },
        {
            "code": "3234",
            "localite": "Vinelz"
        },
        {
            "code": "3235",
            "localite": "Erlach"
        },
        {
            "code": "3236",
            "localite": "Gampelen"
        },
        {
            "code": "3237",
            "localite": "Brüttelen"
        },
        {
            "code": "3238",
            "localite": "Gals"
        },
        {
            "code": "3250",
            "localite": "Lyss"
        },
        {
            "code": "3251",
            "localite": "Ruppoldsried"
        },
        {
            "code": "3251",
            "localite": "Wengi b. Büren"
        },
        {
            "code": "3252",
            "localite": "Worben"
        },
        {
            "code": "3253",
            "localite": "Schnottwil"
        },
        {
            "code": "3254",
            "localite": "Balm b. Messen"
        },
        {
            "code": "3254",
            "localite": "Messen"
        },
        {
            "code": "3255",
            "localite": "Rapperswil BE"
        },
        {
            "code": "3256",
            "localite": "Bangerten b. Dieterswil"
        },
        {
            "code": "3256",
            "localite": "Dieterswil"
        },
        {
            "code": "3256",
            "localite": "Seewil"
        },
        {
            "code": "3257",
            "localite": "Ammerzwil BE"
        },
        {
            "code": "3257",
            "localite": "Grossaffoltern"
        },
        {
            "code": "3262",
            "localite": "Suberg"
        },
        {
            "code": "3263",
            "localite": "Büetigen"
        },
        {
            "code": "3264",
            "localite": "Diessbach b. Büren"
        },
        {
            "code": "3266",
            "localite": "Wiler b. Seedorf"
        },
        {
            "code": "3267",
            "localite": "Seedorf BE"
        },
        {
            "code": "3268",
            "localite": "Lobsigen"
        },
        {
            "code": "3270",
            "localite": "Aarberg"
        },
        {
            "code": "3271",
            "localite": "Radelfingen b. Aarberg"
        },
        {
            "code": "3272",
            "localite": "Epsach"
        },
        {
            "code": "3272",
            "localite": "Walperswil"
        },
        {
            "code": "3273",
            "localite": "Kappelen"
        },
        {
            "code": "3274",
            "localite": "Bühl b. Aarberg"
        },
        {
            "code": "3274",
            "localite": "Hermrigen"
        },
        {
            "code": "3274",
            "localite": "Merzligen"
        },
        {
            "code": "3280",
            "localite": "Greng"
        },
        {
            "code": "3280",
            "localite": "Meyriez"
        },
        {
            "code": "3280",
            "localite": "Murten"
        },
        {
            "code": "3282",
            "localite": "Bargen BE"
        },
        {
            "code": "3283",
            "localite": "Kallnach"
        },
        {
            "code": "3283",
            "localite": "Niederried b. Kallnach"
        },
        {
            "code": "3284",
            "localite": "Fräschels"
        },
        {
            "code": "3285",
            "localite": "Galmiz"
        },
        {
            "code": "3286",
            "localite": "Muntelier"
        },
        {
            "code": "3292",
            "localite": "Busswil BE"
        },
        {
            "code": "3293",
            "localite": "Dotzigen"
        },
        {
            "code": "3294",
            "localite": "Büren an der Aare"
        },
        {
            "code": "3294",
            "localite": "Meienried"
        },
        {
            "code": "3295",
            "localite": "Rüti b. Büren"
        },
        {
            "code": "3296",
            "localite": "Arch"
        },
        {
            "code": "3297",
            "localite": "Leuzigen"
        },
        {
            "code": "3298",
            "localite": "Oberwil b. Büren"
        },
        {
            "code": "3302",
            "localite": "Moosseedorf"
        },
        {
            "code": "3303",
            "localite": "Ballmoos"
        },
        {
            "code": "3303",
            "localite": "Jegenstorf"
        },
        {
            "code": "3303",
            "localite": "Münchringen"
        },
        {
            "code": "3303",
            "localite": "Zuzwil BE"
        },
        {
            "code": "3305",
            "localite": "Iffwil"
        },
        {
            "code": "3305",
            "localite": "Scheunen"
        },
        {
            "code": "3306",
            "localite": "Etzelkofen"
        },
        {
            "code": "3307",
            "localite": "Brunnenthal"
        },
        {
            "code": "3308",
            "localite": "Grafenried"
        },
        {
            "code": "3309",
            "localite": "Kernenried"
        },
        {
            "code": "3309",
            "localite": "Zauggenried"
        },
        {
            "code": "3312",
            "localite": "Fraubrunnen"
        },
        {
            "code": "3313",
            "localite": "Büren zum Hof"
        },
        {
            "code": "3314",
            "localite": "Schalunen"
        },
        {
            "code": "3315",
            "localite": "Bätterkinden"
        },
        {
            "code": "3315",
            "localite": "Kräiligen"
        },
        {
            "code": "3317",
            "localite": "Limpach"
        },
        {
            "code": "3317",
            "localite": "Mülchi"
        },
        {
            "code": "3322",
            "localite": "Mattstetten"
        },
        {
            "code": "3322",
            "localite": "Urtenen-Schönbühl"
        },
        {
            "code": "3323",
            "localite": "Bäriswil BE"
        },
        {
            "code": "3324",
            "localite": "Hindelbank"
        },
        {
            "code": "3324",
            "localite": "Mötschwil"
        },
        {
            "code": "3325",
            "localite": "Hettiswil b. Hindelbank"
        },
        {
            "code": "3326",
            "localite": "Krauchthal"
        },
        {
            "code": "3360",
            "localite": "Herzogenbuchsee"
        },
        {
            "code": "3362",
            "localite": "Niederönz"
        },
        {
            "code": "3363",
            "localite": "Oberönz"
        },
        {
            "code": "3365",
            "localite": "Grasswil"
        },
        {
            "code": "3365",
            "localite": "Seeberg"
        },
        {
            "code": "3366",
            "localite": "Bettenhausen"
        },
        {
            "code": "3366",
            "localite": "Bollodingen"
        },
        {
            "code": "3367",
            "localite": "Ochlenberg"
        },
        {
            "code": "3367",
            "localite": "Thörigen"
        },
        {
            "code": "3368",
            "localite": "Bleienbach"
        },
        {
            "code": "3372",
            "localite": "Wanzwil"
        },
        {
            "code": "3373",
            "localite": "Heimenhausen"
        },
        {
            "code": "3373",
            "localite": "Röthenbach Herzogenbuchsee"
        },
        {
            "code": "3374",
            "localite": "Wangenried"
        },
        {
            "code": "3375",
            "localite": "Inkwil"
        },
        {
            "code": "3376",
            "localite": "Berken"
        },
        {
            "code": "3376",
            "localite": "Graben"
        },
        {
            "code": "3377",
            "localite": "Walliswil b. Wangen"
        },
        {
            "code": "3380",
            "localite": "Walliswil b. Niederbipp"
        },
        {
            "code": "3380",
            "localite": "Wangen an der Aare"
        },
        {
            "code": "3400",
            "localite": "Burgdorf"
        },
        {
            "code": "3412",
            "localite": "Heimiswil"
        },
        {
            "code": "3413",
            "localite": "Kaltacker"
        },
        {
            "code": "3414",
            "localite": "Oberburg"
        },
        {
            "code": "3415",
            "localite": "Hasle b. Burgdorf"
        },
        {
            "code": "3415",
            "localite": "Rüegsauschachen"
        },
        {
            "code": "3415",
            "localite": "Schafhausen im Emmental"
        },
        {
            "code": "3416",
            "localite": "Affoltern im Emmental"
        },
        {
            "code": "3417",
            "localite": "Rüegsau"
        },
        {
            "code": "3418",
            "localite": "Rüegsbach"
        },
        {
            "code": "3419",
            "localite": "Biembach im Emmental"
        },
        {
            "code": "3421",
            "localite": "Lyssach"
        },
        {
            "code": "3421",
            "localite": "Rüti b. Lyssach"
        },
        {
            "code": "3422",
            "localite": "Alchenflüh"
        },
        {
            "code": "3422",
            "localite": "Kirchberg BE"
        },
        {
            "code": "3422",
            "localite": "Rüdtligen"
        },
        {
            "code": "3423",
            "localite": "Ersigen"
        },
        {
            "code": "3424",
            "localite": "Niederösch"
        },
        {
            "code": "3424",
            "localite": "Oberösch"
        },
        {
            "code": "3425",
            "localite": "Koppigen"
        },
        {
            "code": "3425",
            "localite": "Willadingen"
        },
        {
            "code": "3426",
            "localite": "Aefligen"
        },
        {
            "code": "3427",
            "localite": "Utzenstorf"
        },
        {
            "code": "3428",
            "localite": "Wiler b. Utzenstorf"
        },
        {
            "code": "3429",
            "localite": "Hellsau"
        },
        {
            "code": "3429",
            "localite": "Höchstetten"
        },
        {
            "code": "3432",
            "localite": "Lützelflüh-Goldbach"
        },
        {
            "code": "3433",
            "localite": "Schwanden im Emmental"
        },
        {
            "code": "3434",
            "localite": "Landiswil"
        },
        {
            "code": "3434",
            "localite": "Obergoldbach"
        },
        {
            "code": "3435",
            "localite": "Ramsei"
        },
        {
            "code": "3436",
            "localite": "Zollbrück"
        },
        {
            "code": "3437",
            "localite": "Rüderswil"
        },
        {
            "code": "3438",
            "localite": "Lauperswil"
        },
        {
            "code": "3439",
            "localite": "Ranflüh"
        },
        {
            "code": "3452",
            "localite": "Grünenmatt"
        },
        {
            "code": "3453",
            "localite": "Heimisbach"
        },
        {
            "code": "3454",
            "localite": "Sumiswald"
        },
        {
            "code": "3455",
            "localite": "Grünen"
        },
        {
            "code": "3456",
            "localite": "Trachselwald"
        },
        {
            "code": "3457",
            "localite": "Wasen im Emmental"
        },
        {
            "code": "3462",
            "localite": "Weier im Emmental"
        },
        {
            "code": "3463",
            "localite": "Häusernmoos im Emmental"
        },
        {
            "code": "3464",
            "localite": "Schmidigen-Mühleweg"
        },
        {
            "code": "3465",
            "localite": "Dürrenroth"
        },
        {
            "code": "3472",
            "localite": "Rumendingen"
        },
        {
            "code": "3472",
            "localite": "Wynigen"
        },
        {
            "code": "3473",
            "localite": "Alchenstorf"
        },
        {
            "code": "3474",
            "localite": "Rüedisbach"
        },
        {
            "code": "3475",
            "localite": "Hermiswil"
        },
        {
            "code": "3475",
            "localite": "Riedtwil"
        },
        {
            "code": "3476",
            "localite": "Oschwand"
        },
        {
            "code": "3503",
            "localite": "Gysenstein"
        },
        {
            "code": "3504",
            "localite": "Niederhünigen"
        },
        {
            "code": "3504",
            "localite": "Oberhünigen"
        },
        {
            "code": "3506",
            "localite": "Grosshöchstetten"
        },
        {
            "code": "3507",
            "localite": "Biglen"
        },
        {
            "code": "3508",
            "localite": "Arni BE"
        },
        {
            "code": "3510",
            "localite": "Freimettigen"
        },
        {
            "code": "3510",
            "localite": "Häutligen"
        },
        {
            "code": "3510",
            "localite": "Konolfingen"
        },
        {
            "code": "3512",
            "localite": "Walkringen"
        },
        {
            "code": "3513",
            "localite": "Bigenthal"
        },
        {
            "code": "3531",
            "localite": "Oberthal"
        },
        {
            "code": "3532",
            "localite": "Mirchel"
        },
        {
            "code": "3532",
            "localite": "Zäziwil"
        },
        {
            "code": "3533",
            "localite": "Bowil"
        },
        {
            "code": "3534",
            "localite": "Signau"
        },
        {
            "code": "3535",
            "localite": "Schüpbach"
        },
        {
            "code": "3536",
            "localite": "Aeschau"
        },
        {
            "code": "3537",
            "localite": "Eggiwil"
        },
        {
            "code": "3538",
            "localite": "Röthenbach im Emmental"
        },
        {
            "code": "3543",
            "localite": "Emmenmatt"
        },
        {
            "code": "3550",
            "localite": "Langnau im Emmental"
        },
        {
            "code": "3551",
            "localite": "Oberfrittenbach"
        },
        {
            "code": "3552",
            "localite": "Bärau"
        },
        {
            "code": "3553",
            "localite": "Gohl"
        },
        {
            "code": "3555",
            "localite": "Trubschachen"
        },
        {
            "code": "3556",
            "localite": "Trub"
        },
        {
            "code": "3557",
            "localite": "Fankhaus (Trub)"
        },
        {
            "code": "3600",
            "localite": "Thun"
        },
        {
            "code": "3603",
            "localite": "Thun"
        },
        {
            "code": "3604",
            "localite": "Thun"
        },
        {
            "code": "3608",
            "localite": "Thun"
        },
        {
            "code": "3612",
            "localite": "Steffisburg"
        },
        {
            "code": "3613",
            "localite": "Steffisburg"
        },
        {
            "code": "3614",
            "localite": "Unterlangenegg"
        },
        {
            "code": "3615",
            "localite": "Heimenschwand"
        },
        {
            "code": "3616",
            "localite": "Schwarzenegg"
        },
        {
            "code": "3617",
            "localite": "Fahrni b. Thun"
        },
        {
            "code": "3618",
            "localite": "Süderen"
        },
        {
            "code": "3619",
            "localite": "Eriz"
        },
        {
            "code": "3622",
            "localite": "Homberg b. Thun"
        },
        {
            "code": "3623",
            "localite": "Buchen BE"
        },
        {
            "code": "3623",
            "localite": "Horrenbach"
        },
        {
            "code": "3623",
            "localite": "Teuffenthal b. Thun"
        },
        {
            "code": "3624",
            "localite": "Goldiwil (Thun)"
        },
        {
            "code": "3624",
            "localite": "Schwendibach"
        },
        {
            "code": "3625",
            "localite": "Heiligenschwendi"
        },
        {
            "code": "3626",
            "localite": "Hünibach"
        },
        {
            "code": "3627",
            "localite": "Heimberg"
        },
        {
            "code": "3628",
            "localite": "Uttigen"
        },
        {
            "code": "3629",
            "localite": "Jaberg"
        },
        {
            "code": "3629",
            "localite": "Kiesen"
        },
        {
            "code": "3629",
            "localite": "Oppligen"
        },
        {
            "code": "3631",
            "localite": "Höfen b. Thun"
        },
        {
            "code": "3632",
            "localite": "Niederstocken"
        },
        {
            "code": "3632",
            "localite": "Oberstocken"
        },
        {
            "code": "3633",
            "localite": "Amsoldingen"
        },
        {
            "code": "3634",
            "localite": "Thierachern"
        },
        {
            "code": "3635",
            "localite": "Uebeschi"
        },
        {
            "code": "3636",
            "localite": "Forst b. Längenbühl"
        },
        {
            "code": "3636",
            "localite": "Längenbühl"
        },
        {
            "code": "3638",
            "localite": "Blumenstein"
        },
        {
            "code": "3638",
            "localite": "Pohlern"
        },
        {
            "code": "3645",
            "localite": "Gwatt (Thun)"
        },
        {
            "code": "3645",
            "localite": "Zwieselberg"
        },
        {
            "code": "3646",
            "localite": "Einigen"
        },
        {
            "code": "3647",
            "localite": "Reutigen"
        },
        {
            "code": "3652",
            "localite": "Hilterfingen"
        },
        {
            "code": "3653",
            "localite": "Oberhofen am Thunersee"
        },
        {
            "code": "3654",
            "localite": "Gunten"
        },
        {
            "code": "3655",
            "localite": "Sigriswil"
        },
        {
            "code": "3656",
            "localite": "Aeschlen ob Gunten"
        },
        {
            "code": "3656",
            "localite": "Ringoldswil"
        },
        {
            "code": "3656",
            "localite": "Tschingel ob Gunten"
        },
        {
            "code": "3657",
            "localite": "Schwanden (Sigriswil)"
        },
        {
            "code": "3658",
            "localite": "Merligen"
        },
        {
            "code": "3661",
            "localite": "Uetendorf"
        },
        {
            "code": "3662",
            "localite": "Seftigen"
        },
        {
            "code": "3663",
            "localite": "Gurzelen"
        },
        {
            "code": "3664",
            "localite": "Burgistein"
        },
        {
            "code": "3665",
            "localite": "Wattenwil"
        },
        {
            "code": "3671",
            "localite": "Brenzikofen"
        },
        {
            "code": "3671",
            "localite": "Herbligen"
        },
        {
            "code": "3672",
            "localite": "Aeschlen b. Oberdiessbach"
        },
        {
            "code": "3672",
            "localite": "Oberdiessbach"
        },
        {
            "code": "3673",
            "localite": "Linden"
        },
        {
            "code": "3674",
            "localite": "Bleiken b. Oberdiessbach"
        },
        {
            "code": "3700",
            "localite": "Spiez"
        },
        {
            "code": "3702",
            "localite": "Hondrich"
        },
        {
            "code": "3703",
            "localite": "Aeschi b. Spiez"
        },
        {
            "code": "3703",
            "localite": "Aeschiried"
        },
        {
            "code": "3704",
            "localite": "Krattigen"
        },
        {
            "code": "3705",
            "localite": "Faulensee"
        },
        {
            "code": "3706",
            "localite": "Leissigen"
        },
        {
            "code": "3707",
            "localite": "Därligen"
        },
        {
            "code": "3711",
            "localite": "Emdthal"
        },
        {
            "code": "3711",
            "localite": "Mülenen"
        },
        {
            "code": "3713",
            "localite": "Reichenbach im Kandertal"
        },
        {
            "code": "3714",
            "localite": "Frutigen"
        },
        {
            "code": "3714",
            "localite": "Wengi b. Frutigen"
        },
        {
            "code": "3715",
            "localite": "Adelboden"
        },
        {
            "code": "3716",
            "localite": "Kandergrund"
        },
        {
            "code": "3717",
            "localite": "Blausee-Mitholz"
        },
        {
            "code": "3718",
            "localite": "Kandersteg"
        },
        {
            "code": "3722",
            "localite": "Scharnachtal"
        },
        {
            "code": "3723",
            "localite": "Kiental"
        },
        {
            "code": "3724",
            "localite": "Ried (Frutigen)"
        },
        {
            "code": "3725",
            "localite": "Achseten"
        },
        {
            "code": "3752",
            "localite": "Wimmis"
        },
        {
            "code": "3753",
            "localite": "Oey"
        },
        {
            "code": "3754",
            "localite": "Diemtigen"
        },
        {
            "code": "3755",
            "localite": "Horboden"
        },
        {
            "code": "3756",
            "localite": "Zwischenflüh"
        },
        {
            "code": "3757",
            "localite": "Schwenden im Diemtigtal"
        },
        {
            "code": "3758",
            "localite": "Latterbach"
        },
        {
            "code": "3762",
            "localite": "Erlenbach im Simmental"
        },
        {
            "code": "3763",
            "localite": "Därstetten"
        },
        {
            "code": "3764",
            "localite": "Weissenburg"
        },
        {
            "code": "3765",
            "localite": "Oberwil im Simmental"
        },
        {
            "code": "3766",
            "localite": "Boltigen"
        },
        {
            "code": "3770",
            "localite": "Zweisimmen"
        },
        {
            "code": "3771",
            "localite": "Blankenburg"
        },
        {
            "code": "3772",
            "localite": "St. Stephan"
        },
        {
            "code": "3773",
            "localite": "Matten (St. Stephan)"
        },
        {
            "code": "3775",
            "localite": "Lenk im Simmental"
        },
        {
            "code": "3776",
            "localite": "Oeschseite"
        },
        {
            "code": "3777",
            "localite": "Saanenmöser"
        },
        {
            "code": "3778",
            "localite": "Schönried"
        },
        {
            "code": "3780",
            "localite": "Gstaad"
        },
        {
            "code": "3781",
            "localite": "Turbach"
        },
        {
            "code": "3782",
            "localite": "Lauenen b. Gstaad"
        },
        {
            "code": "3783",
            "localite": "Grund b. Gstaad"
        },
        {
            "code": "3784",
            "localite": "Feutersoey"
        },
        {
            "code": "3785",
            "localite": "Gsteig b. Gstaad"
        },
        {
            "code": "3792",
            "localite": "Saanen"
        },
        {
            "code": "3800",
            "localite": "Interlaken"
        },
        {
            "code": "3800",
            "localite": "Matten b. Interlaken"
        },
        {
            "code": "3800",
            "localite": "Sundlauenen"
        },
        {
            "code": "3800",
            "localite": "Unterseen"
        },
        {
            "code": "3801",
            "localite": "Jungfraujoch"
        },
        {
            "code": "3803",
            "localite": "Beatenberg"
        },
        {
            "code": "3804",
            "localite": "Habkern"
        },
        {
            "code": "3805",
            "localite": "Goldswil b. Interlaken"
        },
        {
            "code": "3806",
            "localite": "Bönigen b. Interlaken"
        },
        {
            "code": "3807",
            "localite": "Iseltwald"
        },
        {
            "code": "3812",
            "localite": "Wilderswil"
        },
        {
            "code": "3813",
            "localite": "Saxeten"
        },
        {
            "code": "3814",
            "localite": "Gsteigwiler"
        },
        {
            "code": "3815",
            "localite": "Gündlischwand"
        },
        {
            "code": "3815",
            "localite": "Zweilütschinen"
        },
        {
            "code": "3816",
            "localite": "Burglauenen"
        },
        {
            "code": "3816",
            "localite": "Lütschental"
        },
        {
            "code": "3818",
            "localite": "Grindelwald"
        },
        {
            "code": "3822",
            "localite": "Isenfluh"
        },
        {
            "code": "3822",
            "localite": "Lauterbrunnen"
        },
        {
            "code": "3823",
            "localite": "Eigergletscher"
        },
        {
            "code": "3823",
            "localite": "Kleine Scheidegg"
        },
        {
            "code": "3823",
            "localite": "Wengen"
        },
        {
            "code": "3824",
            "localite": "Stechelberg"
        },
        {
            "code": "3825",
            "localite": "Mürren"
        },
        {
            "code": "3826",
            "localite": "Gimmelwald"
        },
        {
            "code": "3852",
            "localite": "Ringgenberg BE"
        },
        {
            "code": "3853",
            "localite": "Niederried b. Interlaken"
        },
        {
            "code": "3854",
            "localite": "Oberried am Brienzersee"
        },
        {
            "code": "3855",
            "localite": "Axalp"
        },
        {
            "code": "3855",
            "localite": "Brienz BE"
        },
        {
            "code": "3855",
            "localite": "Schwanden b. Brienz"
        },
        {
            "code": "3856",
            "localite": "Brienzwiler"
        },
        {
            "code": "3857",
            "localite": "Unterbach BE"
        },
        {
            "code": "3858",
            "localite": "Hofstetten b. Brienz"
        },
        {
            "code": "3860",
            "localite": "Brünig"
        },
        {
            "code": "3860",
            "localite": "Meiringen"
        },
        {
            "code": "3860",
            "localite": "Rosenlaui"
        },
        {
            "code": "3860",
            "localite": "Schattenhalb"
        },
        {
            "code": "3862",
            "localite": "Innertkirchen"
        },
        {
            "code": "3863",
            "localite": "Gadmen"
        },
        {
            "code": "3864",
            "localite": "Guttannen"
        },
        {
            "code": "3900",
            "localite": "Brig"
        },
        {
            "code": "3900",
            "localite": "Brigerbad"
        },
        {
            "code": "3900",
            "localite": "Gamsen"
        },
        {
            "code": "3901",
            "localite": "Rothwald"
        },
        {
            "code": "3902",
            "localite": "Glis"
        },
        {
            "code": "3903",
            "localite": "Birgisch"
        },
        {
            "code": "3903",
            "localite": "Mund"
        },
        {
            "code": "3904",
            "localite": "Naters"
        },
        {
            "code": "3905",
            "localite": "Saas-Almagell"
        },
        {
            "code": "3906",
            "localite": "Saas-Fee"
        },
        {
            "code": "3907",
            "localite": "Gabi (Simplon)"
        },
        {
            "code": "3907",
            "localite": "Gondo"
        },
        {
            "code": "3907",
            "localite": "Simplon Dorf"
        },
        {
            "code": "3907",
            "localite": "Simplon Hospiz"
        },
        {
            "code": "3908",
            "localite": "Saas-Balen"
        },
        {
            "code": "3910",
            "localite": "Saas-Grund"
        },
        {
            "code": "3911",
            "localite": "Ried-Brig"
        },
        {
            "code": "3912",
            "localite": "Termen"
        },
        {
            "code": "3913",
            "localite": "Rosswald"
        },
        {
            "code": "3914",
            "localite": "Belalp"
        },
        {
            "code": "3914",
            "localite": "Blatten b. Naters"
        },
        {
            "code": "3916",
            "localite": "Ferden"
        },
        {
            "code": "3917",
            "localite": "Goppenstein"
        },
        {
            "code": "3917",
            "localite": "Kippel"
        },
        {
            "code": "3918",
            "localite": "Wiler (Lötschen)"
        },
        {
            "code": "3919",
            "localite": "Blatten (Lötschen)"
        },
        {
            "code": "3920",
            "localite": "Zermatt"
        },
        {
            "code": "3922",
            "localite": "Eisten"
        },
        {
            "code": "3922",
            "localite": "Kalpetran"
        },
        {
            "code": "3922",
            "localite": "Stalden VS"
        },
        {
            "code": "3923",
            "localite": "Törbel"
        },
        {
            "code": "3924",
            "localite": "St. Niklaus VS"
        },
        {
            "code": "3925",
            "localite": "Grächen"
        },
        {
            "code": "3926",
            "localite": "Embd"
        },
        {
            "code": "3927",
            "localite": "Herbriggen"
        },
        {
            "code": "3928",
            "localite": "Randa"
        },
        {
            "code": "3929",
            "localite": "Täsch"
        },
        {
            "code": "3930",
            "localite": "Eyholz"
        },
        {
            "code": "3930",
            "localite": "Visp"
        },
        {
            "code": "3931",
            "localite": "Lalden"
        },
        {
            "code": "3932",
            "localite": "Visperterminen"
        },
        {
            "code": "3933",
            "localite": "Staldenried"
        },
        {
            "code": "3934",
            "localite": "Zeneggen"
        },
        {
            "code": "3935",
            "localite": "Bürchen"
        },
        {
            "code": "3937",
            "localite": "Baltschieder"
        },
        {
            "code": "3938",
            "localite": "Ausserberg"
        },
        {
            "code": "3939",
            "localite": "Eggerberg"
        },
        {
            "code": "3940",
            "localite": "Steg VS"
        },
        {
            "code": "3942",
            "localite": "Niedergesteln"
        },
        {
            "code": "3942",
            "localite": "Raron"
        },
        {
            "code": "3942",
            "localite": "St. German"
        },
        {
            "code": "3943",
            "localite": "Eischoll"
        },
        {
            "code": "3944",
            "localite": "Unterbäch VS"
        },
        {
            "code": "3945",
            "localite": "Gampel"
        },
        {
            "code": "3945",
            "localite": "Niedergampel"
        },
        {
            "code": "3946",
            "localite": "Gruben"
        },
        {
            "code": "3946",
            "localite": "Turtmann"
        },
        {
            "code": "3947",
            "localite": "Ergisch"
        },
        {
            "code": "3948",
            "localite": "Oberems"
        },
        {
            "code": "3948",
            "localite": "Unterems"
        },
        {
            "code": "3949",
            "localite": "Hohtenn"
        },
        {
            "code": "3951",
            "localite": "Agarn"
        },
        {
            "code": "3952",
            "localite": "Susten"
        },
        {
            "code": "3953",
            "localite": "Inden"
        },
        {
            "code": "3953",
            "localite": "Leuk Stadt"
        },
        {
            "code": "3953",
            "localite": "Varen"
        },
        {
            "code": "3954",
            "localite": "Leukerbad"
        },
        {
            "code": "3955",
            "localite": "Albinen"
        },
        {
            "code": "3956",
            "localite": "Guttet-Feschel"
        },
        {
            "code": "3957",
            "localite": "Bratsch"
        },
        {
            "code": "3957",
            "localite": "Erschmatt"
        },
        {
            "code": "3960",
            "localite": "Corin-de-la-Crête"
        },
        {
            "code": "3960",
            "localite": "Loc"
        },
        {
            "code": "3960",
            "localite": "Muraz (Sierre)"
        },
        {
            "code": "3960",
            "localite": "Niouc"
        },
        {
            "code": "3960",
            "localite": "Sierre"
        },
        {
            "code": "3961",
            "localite": "Ayer"
        },
        {
            "code": "3961",
            "localite": "Chandolin"
        },
        {
            "code": "3961",
            "localite": "Grimentz"
        },
        {
            "code": "3961",
            "localite": "Mission"
        },
        {
            "code": "3961",
            "localite": "St-Jean VS"
        },
        {
            "code": "3961",
            "localite": "St-Luc"
        },
        {
            "code": "3961",
            "localite": "Vissoie"
        },
        {
            "code": "3961",
            "localite": "Zinal"
        },
        {
            "code": "3963",
            "localite": "Aminona"
        },
        {
            "code": "3963",
            "localite": "Crans VS"
        },
        {
            "code": "3963",
            "localite": "Crans-Montana"
        },
        {
            "code": "3963",
            "localite": "Montana"
        },
        {
            "code": "3965",
            "localite": "Chippis"
        },
        {
            "code": "3966",
            "localite": "Chalais"
        },
        {
            "code": "3966",
            "localite": "Réchy"
        },
        {
            "code": "3967",
            "localite": "Vercorin"
        },
        {
            "code": "3968",
            "localite": "Veyras"
        },
        {
            "code": "3970",
            "localite": "Salgesch"
        },
        {
            "code": "3971",
            "localite": "Chermignon"
        },
        {
            "code": "3971",
            "localite": "Chermignon-d'en-Bas"
        },
        {
            "code": "3971",
            "localite": "Ollon VS"
        },
        {
            "code": "3972",
            "localite": "Miège"
        },
        {
            "code": "3973",
            "localite": "Venthône"
        },
        {
            "code": "3974",
            "localite": "Mollens VS"
        },
        {
            "code": "3975",
            "localite": "Randogne"
        },
        {
            "code": "3976",
            "localite": "Champzabé"
        },
        {
            "code": "3976",
            "localite": "Noës"
        },
        {
            "code": "3977",
            "localite": "Granges VS"
        },
        {
            "code": "3978",
            "localite": "Flanthey"
        },
        {
            "code": "3979",
            "localite": "Grône"
        },
        {
            "code": "3982",
            "localite": "Bitsch"
        },
        {
            "code": "3983",
            "localite": "Bister"
        },
        {
            "code": "3983",
            "localite": "Filet"
        },
        {
            "code": "3983",
            "localite": "Goppisberg"
        },
        {
            "code": "3983",
            "localite": "Greich"
        },
        {
            "code": "3983",
            "localite": "Mörel"
        },
        {
            "code": "3984",
            "localite": "Fiesch"
        },
        {
            "code": "3984",
            "localite": "Fieschertal"
        },
        {
            "code": "3985",
            "localite": "Geschinen"
        },
        {
            "code": "3985",
            "localite": "Münster VS"
        },
        {
            "code": "3986",
            "localite": "Ried-Mörel"
        },
        {
            "code": "3987",
            "localite": "Riederalp"
        },
        {
            "code": "3988",
            "localite": "Obergesteln"
        },
        {
            "code": "3988",
            "localite": "Ulrichen"
        },
        {
            "code": "3989",
            "localite": "Biel VS"
        },
        {
            "code": "3989",
            "localite": "Blitzingen"
        },
        {
            "code": "3989",
            "localite": "Niederwald"
        },
        {
            "code": "3989",
            "localite": "Ritzingen"
        },
        {
            "code": "3989",
            "localite": "Selkingen"
        },
        {
            "code": "3991",
            "localite": "Betten"
        },
        {
            "code": "3992",
            "localite": "Bettmeralp"
        },
        {
            "code": "3993",
            "localite": "Grengiols"
        },
        {
            "code": "3994",
            "localite": "Lax"
        },
        {
            "code": "3994",
            "localite": "Martisberg"
        },
        {
            "code": "3995",
            "localite": "Ausserbinn"
        },
        {
            "code": "3995",
            "localite": "Ernen"
        },
        {
            "code": "3995",
            "localite": "Mühlebach (Goms)"
        },
        {
            "code": "3995",
            "localite": "Steinhaus"
        },
        {
            "code": "3996",
            "localite": "Binn"
        },
        {
            "code": "3997",
            "localite": "Bellwald"
        },
        {
            "code": "3998",
            "localite": "Gluringen"
        },
        {
            "code": "3998",
            "localite": "Reckingen VS"
        },
        {
            "code": "3999",
            "localite": "Oberwald"
        },
        {
            "code": "4001",
            "localite": "Basel"
        },
        {
            "code": "4031",
            "localite": "Basel"
        },
        {
            "code": "4051",
            "localite": "Basel"
        },
        {
            "code": "4052",
            "localite": "Basel"
        },
        {
            "code": "4053",
            "localite": "Basel"
        },
        {
            "code": "4054",
            "localite": "Basel"
        },
        {
            "code": "4055",
            "localite": "Basel"
        },
        {
            "code": "4056",
            "localite": "Basel"
        },
        {
            "code": "4057",
            "localite": "Basel"
        },
        {
            "code": "4058",
            "localite": "Basel"
        },
        {
            "code": "4059",
            "localite": "Basel"
        },
        {
            "code": "4101",
            "localite": "Bruderholz"
        },
        {
            "code": "4102",
            "localite": "Binningen"
        },
        {
            "code": "4103",
            "localite": "Bottmingen"
        },
        {
            "code": "4104",
            "localite": "Oberwil BL"
        },
        {
            "code": "4105",
            "localite": "Biel-Benken BL"
        },
        {
            "code": "4106",
            "localite": "Therwil"
        },
        {
            "code": "4107",
            "localite": "Ettingen"
        },
        {
            "code": "4108",
            "localite": "Witterswil"
        },
        {
            "code": "4112",
            "localite": "Bättwil"
        },
        {
            "code": "4112",
            "localite": "Flüh"
        },
        {
            "code": "4114",
            "localite": "Hofstetten SO"
        },
        {
            "code": "4115",
            "localite": "Mariastein"
        },
        {
            "code": "4116",
            "localite": "Metzerlen"
        },
        {
            "code": "4117",
            "localite": "Burg im Leimental"
        },
        {
            "code": "4118",
            "localite": "Rodersdorf"
        },
        {
            "code": "4123",
            "localite": "Allschwil"
        },
        {
            "code": "4124",
            "localite": "Schönenbuch"
        },
        {
            "code": "4125",
            "localite": "Riehen"
        },
        {
            "code": "4126",
            "localite": "Bettingen"
        },
        {
            "code": "4127",
            "localite": "Birsfelden"
        },
        {
            "code": "4132",
            "localite": "Muttenz"
        },
        {
            "code": "4133",
            "localite": "Pratteln"
        },
        {
            "code": "4142",
            "localite": "Münchenstein"
        },
        {
            "code": "4143",
            "localite": "Dornach"
        },
        {
            "code": "4144",
            "localite": "Arlesheim"
        },
        {
            "code": "4145",
            "localite": "Gempen"
        },
        {
            "code": "4146",
            "localite": "Hochwald"
        },
        {
            "code": "4147",
            "localite": "Aesch BL"
        },
        {
            "code": "4148",
            "localite": "Pfeffingen"
        },
        {
            "code": "4153",
            "localite": "Reinach BL"
        },
        {
            "code": "4202",
            "localite": "Duggingen"
        },
        {
            "code": "4203",
            "localite": "Grellingen"
        },
        {
            "code": "4204",
            "localite": "Himmelried"
        },
        {
            "code": "4206",
            "localite": "Seewen SO"
        },
        {
            "code": "4207",
            "localite": "Bretzwil"
        },
        {
            "code": "4208",
            "localite": "Nunningen"
        },
        {
            "code": "4222",
            "localite": "Zwingen"
        },
        {
            "code": "4223",
            "localite": "Blauen"
        },
        {
            "code": "4224",
            "localite": "Nenzlingen"
        },
        {
            "code": "4225",
            "localite": "Brislach"
        },
        {
            "code": "4226",
            "localite": "Breitenbach"
        },
        {
            "code": "4227",
            "localite": "Büsserach"
        },
        {
            "code": "4228",
            "localite": "Erschwil"
        },
        {
            "code": "4229",
            "localite": "Beinwil SO"
        },
        {
            "code": "4232",
            "localite": "Fehren"
        },
        {
            "code": "4233",
            "localite": "Meltingen"
        },
        {
            "code": "4234",
            "localite": "Zullwil"
        },
        {
            "code": "4242",
            "localite": "Laufen"
        },
        {
            "code": "4243",
            "localite": "Dittingen"
        },
        {
            "code": "4244",
            "localite": "Röschenz"
        },
        {
            "code": "4245",
            "localite": "Kleinlützel"
        },
        {
            "code": "4246",
            "localite": "Wahlen b. Laufen"
        },
        {
            "code": "4247",
            "localite": "Grindel"
        },
        {
            "code": "4252",
            "localite": "Bärschwil"
        },
        {
            "code": "4253",
            "localite": "Liesberg"
        },
        {
            "code": "4254",
            "localite": "Liesberg Dorf"
        },
        {
            "code": "4302",
            "localite": "Augst BL"
        },
        {
            "code": "4303",
            "localite": "Kaiseraugst"
        },
        {
            "code": "4304",
            "localite": "Giebenach"
        },
        {
            "code": "4305",
            "localite": "Olsberg"
        },
        {
            "code": "4310",
            "localite": "Rheinfelden"
        },
        {
            "code": "4312",
            "localite": "Magden"
        },
        {
            "code": "4313",
            "localite": "Möhlin"
        },
        {
            "code": "4314",
            "localite": "Zeiningen"
        },
        {
            "code": "4315",
            "localite": "Zuzgen"
        },
        {
            "code": "4316",
            "localite": "Hellikon"
        },
        {
            "code": "4317",
            "localite": "Wegenstetten"
        },
        {
            "code": "4322",
            "localite": "Mumpf"
        },
        {
            "code": "4323",
            "localite": "Wallbach"
        },
        {
            "code": "4324",
            "localite": "Obermumpf"
        },
        {
            "code": "4325",
            "localite": "Schupfart"
        },
        {
            "code": "4332",
            "localite": "Stein AG"
        },
        {
            "code": "4333",
            "localite": "Münchwilen AG"
        },
        {
            "code": "4334",
            "localite": "Sisseln AG"
        },
        {
            "code": "4402",
            "localite": "Frenkendorf"
        },
        {
            "code": "4410",
            "localite": "Liestal"
        },
        {
            "code": "4411",
            "localite": "Seltisberg"
        },
        {
            "code": "4412",
            "localite": "Nuglar"
        },
        {
            "code": "4413",
            "localite": "Büren SO"
        },
        {
            "code": "4414",
            "localite": "Füllinsdorf"
        },
        {
            "code": "4415",
            "localite": "Lausen"
        },
        {
            "code": "4416",
            "localite": "Bubendorf"
        },
        {
            "code": "4417",
            "localite": "Ziefen"
        },
        {
            "code": "4418",
            "localite": "Reigoldswil"
        },
        {
            "code": "4419",
            "localite": "Lupsingen"
        },
        {
            "code": "4421",
            "localite": "St. Pantaleon"
        },
        {
            "code": "4422",
            "localite": "Arisdorf"
        },
        {
            "code": "4423",
            "localite": "Hersberg"
        },
        {
            "code": "4424",
            "localite": "Arboldswil"
        },
        {
            "code": "4425",
            "localite": "Titterten"
        },
        {
            "code": "4426",
            "localite": "Lauwil"
        },
        {
            "code": "4431",
            "localite": "Bennwil"
        },
        {
            "code": "4432",
            "localite": "Lampenberg"
        },
        {
            "code": "4433",
            "localite": "Ramlinsburg"
        },
        {
            "code": "4434",
            "localite": "Hölstein"
        },
        {
            "code": "4435",
            "localite": "Niederdorf"
        },
        {
            "code": "4436",
            "localite": "Liedertswil"
        },
        {
            "code": "4436",
            "localite": "Oberdorf BL"
        },
        {
            "code": "4437",
            "localite": "Waldenburg"
        },
        {
            "code": "4438",
            "localite": "Langenbruck"
        },
        {
            "code": "4441",
            "localite": "Thürnen"
        },
        {
            "code": "4442",
            "localite": "Diepflingen"
        },
        {
            "code": "4443",
            "localite": "Wittinsburg"
        },
        {
            "code": "4444",
            "localite": "Rümlingen"
        },
        {
            "code": "4445",
            "localite": "Häfelfingen"
        },
        {
            "code": "4446",
            "localite": "Buckten"
        },
        {
            "code": "4447",
            "localite": "Känerkinden"
        },
        {
            "code": "4448",
            "localite": "Läufelfingen"
        },
        {
            "code": "4450",
            "localite": "Sissach"
        },
        {
            "code": "4451",
            "localite": "Wintersingen"
        },
        {
            "code": "4452",
            "localite": "Itingen"
        },
        {
            "code": "4453",
            "localite": "Nusshof"
        },
        {
            "code": "4455",
            "localite": "Zunzgen"
        },
        {
            "code": "4456",
            "localite": "Tenniken"
        },
        {
            "code": "4457",
            "localite": "Diegten"
        },
        {
            "code": "4458",
            "localite": "Eptingen"
        },
        {
            "code": "4460",
            "localite": "Gelterkinden"
        },
        {
            "code": "4461",
            "localite": "Böckten"
        },
        {
            "code": "4462",
            "localite": "Rickenbach BL"
        },
        {
            "code": "4463",
            "localite": "Buus"
        },
        {
            "code": "4464",
            "localite": "Maisprach"
        },
        {
            "code": "4465",
            "localite": "Hemmiken"
        },
        {
            "code": "4466",
            "localite": "Ormalingen"
        },
        {
            "code": "4467",
            "localite": "Rothenfluh"
        },
        {
            "code": "4468",
            "localite": "Kienberg"
        },
        {
            "code": "4469",
            "localite": "Anwil"
        },
        {
            "code": "4492",
            "localite": "Tecknau"
        },
        {
            "code": "4493",
            "localite": "Wenslingen"
        },
        {
            "code": "4494",
            "localite": "Oltingen"
        },
        {
            "code": "4495",
            "localite": "Zeglingen"
        },
        {
            "code": "4496",
            "localite": "Kilchberg BL"
        },
        {
            "code": "4497",
            "localite": "Rünenberg"
        },
        {
            "code": "4500",
            "localite": "Solothurn"
        },
        {
            "code": "4512",
            "localite": "Bellach"
        },
        {
            "code": "4513",
            "localite": "Langendorf"
        },
        {
            "code": "4514",
            "localite": "Lommiswil"
        },
        {
            "code": "4515",
            "localite": "Oberdorf SO"
        },
        {
            "code": "4515",
            "localite": "Weissenstein b. Solothurn"
        },
        {
            "code": "4522",
            "localite": "Rüttenen"
        },
        {
            "code": "4523",
            "localite": "Niederwil SO"
        },
        {
            "code": "4524",
            "localite": "Balmberg"
        },
        {
            "code": "4524",
            "localite": "Günsberg"
        },
        {
            "code": "4524",
            "localite": "Oberbalmberg"
        },
        {
            "code": "4525",
            "localite": "Balm b. Günsberg"
        },
        {
            "code": "4528",
            "localite": "Zuchwil"
        },
        {
            "code": "4532",
            "localite": "Feldbrunnen"
        },
        {
            "code": "4533",
            "localite": "Riedholz"
        },
        {
            "code": "4534",
            "localite": "Flumenthal"
        },
        {
            "code": "4535",
            "localite": "Hubersdorf"
        },
        {
            "code": "4535",
            "localite": "Kammersrohr"
        },
        {
            "code": "4536",
            "localite": "Attiswil"
        },
        {
            "code": "4537",
            "localite": "Wiedlisbach"
        },
        {
            "code": "4538",
            "localite": "Oberbipp"
        },
        {
            "code": "4539",
            "localite": "Farnern"
        },
        {
            "code": "4539",
            "localite": "Rumisberg"
        },
        {
            "code": "4542",
            "localite": "Luterbach"
        },
        {
            "code": "4543",
            "localite": "Deitingen"
        },
        {
            "code": "4552",
            "localite": "Derendingen"
        },
        {
            "code": "4553",
            "localite": "Subingen"
        },
        {
            "code": "4554",
            "localite": "Etziken"
        },
        {
            "code": "4554",
            "localite": "Hüniken"
        },
        {
            "code": "4556",
            "localite": "Aeschi SO"
        },
        {
            "code": "4556",
            "localite": "Bolken"
        },
        {
            "code": "4556",
            "localite": "Burgäschi"
        },
        {
            "code": "4556",
            "localite": "Steinhof SO"
        },
        {
            "code": "4557",
            "localite": "Horriwil"
        },
        {
            "code": "4558",
            "localite": "Heinrichswil"
        },
        {
            "code": "4558",
            "localite": "Hersiwil"
        },
        {
            "code": "4558",
            "localite": "Winistorf"
        },
        {
            "code": "4562",
            "localite": "Biberist"
        },
        {
            "code": "4563",
            "localite": "Gerlafingen"
        },
        {
            "code": "4564",
            "localite": "Obergerlafingen"
        },
        {
            "code": "4564",
            "localite": "Zielebach"
        },
        {
            "code": "4565",
            "localite": "Recherswil"
        },
        {
            "code": "4566",
            "localite": "Halten"
        },
        {
            "code": "4566",
            "localite": "Kriegstetten"
        },
        {
            "code": "4566",
            "localite": "Oekingen"
        },
        {
            "code": "4571",
            "localite": "Ichertswil"
        },
        {
            "code": "4571",
            "localite": "Lüterkofen"
        },
        {
            "code": "4573",
            "localite": "Lohn-Ammannsegg"
        },
        {
            "code": "4574",
            "localite": "Lüsslingen"
        },
        {
            "code": "4574",
            "localite": "Nennigkofen"
        },
        {
            "code": "4576",
            "localite": "Tscheppach"
        },
        {
            "code": "4577",
            "localite": "Hessigkofen"
        },
        {
            "code": "4578",
            "localite": "Bibern SO"
        },
        {
            "code": "4579",
            "localite": "Gossliwil"
        },
        {
            "code": "4581",
            "localite": "Küttigkofen"
        },
        {
            "code": "4582",
            "localite": "Brügglen"
        },
        {
            "code": "4583",
            "localite": "Aetigkofen"
        },
        {
            "code": "4583",
            "localite": "Mühledorf SO"
        },
        {
            "code": "4584",
            "localite": "Gächliwil"
        },
        {
            "code": "4584",
            "localite": "Lüterswil"
        },
        {
            "code": "4585",
            "localite": "Biezwil"
        },
        {
            "code": "4586",
            "localite": "Kyburg-Buchegg"
        },
        {
            "code": "4587",
            "localite": "Aetingen"
        },
        {
            "code": "4588",
            "localite": "Brittern"
        },
        {
            "code": "4588",
            "localite": "Oberramsern"
        },
        {
            "code": "4588",
            "localite": "Unterramsern"
        },
        {
            "code": "4600",
            "localite": "Olten"
        },
        {
            "code": "4612",
            "localite": "Wangen b. Olten"
        },
        {
            "code": "4613",
            "localite": "Rickenbach SO"
        },
        {
            "code": "4614",
            "localite": "Hägendorf"
        },
        {
            "code": "4615",
            "localite": "Allerheiligenberg"
        },
        {
            "code": "4616",
            "localite": "Kappel SO"
        },
        {
            "code": "4617",
            "localite": "Gunzgen"
        },
        {
            "code": "4618",
            "localite": "Boningen"
        },
        {
            "code": "4622",
            "localite": "Egerkingen"
        },
        {
            "code": "4623",
            "localite": "Neuendorf"
        },
        {
            "code": "4624",
            "localite": "Härkingen"
        },
        {
            "code": "4625",
            "localite": "Oberbuchsiten"
        },
        {
            "code": "4626",
            "localite": "Niederbuchsiten"
        },
        {
            "code": "4628",
            "localite": "Wolfwil"
        },
        {
            "code": "4629",
            "localite": "Fulenbach"
        },
        {
            "code": "4632",
            "localite": "Trimbach"
        },
        {
            "code": "4633",
            "localite": "Hauenstein"
        },
        {
            "code": "4634",
            "localite": "Wisen SO"
        },
        {
            "code": "4652",
            "localite": "Winznau"
        },
        {
            "code": "4653",
            "localite": "Obergösgen"
        },
        {
            "code": "4654",
            "localite": "Lostorf"
        },
        {
            "code": "4655",
            "localite": "Rohr b. Olten"
        },
        {
            "code": "4655",
            "localite": "Stüsslingen"
        },
        {
            "code": "4656",
            "localite": "Starrkirch-Wil"
        },
        {
            "code": "4657",
            "localite": "Dulliken"
        },
        {
            "code": "4658",
            "localite": "Däniken SO"
        },
        {
            "code": "4663",
            "localite": "Aarburg"
        },
        {
            "code": "4665",
            "localite": "Oftringen"
        },
        {
            "code": "4702",
            "localite": "Oensingen"
        },
        {
            "code": "4703",
            "localite": "Kestenholz"
        },
        {
            "code": "4704",
            "localite": "Niederbipp"
        },
        {
            "code": "4704",
            "localite": "Wolfisberg"
        },
        {
            "code": "4710",
            "localite": "Balsthal"
        },
        {
            "code": "4712",
            "localite": "Laupersdorf"
        },
        {
            "code": "4713",
            "localite": "Matzendorf"
        },
        {
            "code": "4714",
            "localite": "Aedermannsdorf"
        },
        {
            "code": "4715",
            "localite": "Herbetswil"
        },
        {
            "code": "4716",
            "localite": "Gänsbrunnen"
        },
        {
            "code": "4716",
            "localite": "Welschenrohr"
        },
        {
            "code": "4717",
            "localite": "Mümliswil"
        },
        {
            "code": "4718",
            "localite": "Holderbank SO"
        },
        {
            "code": "4719",
            "localite": "Ramiswil"
        },
        {
            "code": "4800",
            "localite": "Zofingen"
        },
        {
            "code": "4802",
            "localite": "Strengelbach"
        },
        {
            "code": "4803",
            "localite": "Vordemwald"
        },
        {
            "code": "4805",
            "localite": "Brittnau"
        },
        {
            "code": "4806",
            "localite": "Wikon"
        },
        {
            "code": "4812",
            "localite": "Mühlethal"
        },
        {
            "code": "4813",
            "localite": "Uerkheim"
        },
        {
            "code": "4814",
            "localite": "Bottenwil"
        },
        {
            "code": "4852",
            "localite": "Rothrist"
        },
        {
            "code": "4853",
            "localite": "Murgenthal"
        },
        {
            "code": "4853",
            "localite": "Riken AG"
        },
        {
            "code": "4856",
            "localite": "Glashütten"
        },
        {
            "code": "4900",
            "localite": "Langenthal"
        },
        {
            "code": "4911",
            "localite": "Schwarzhäusern"
        },
        {
            "code": "4912",
            "localite": "Aarwangen"
        },
        {
            "code": "4913",
            "localite": "Bannwil"
        },
        {
            "code": "4914",
            "localite": "Roggwil BE"
        },
        {
            "code": "4915",
            "localite": "St. Urban"
        },
        {
            "code": "4916",
            "localite": "Untersteckholz"
        },
        {
            "code": "4917",
            "localite": "Busswil b. Melchnau"
        },
        {
            "code": "4917",
            "localite": "Melchnau"
        },
        {
            "code": "4919",
            "localite": "Reisiswil"
        },
        {
            "code": "4922",
            "localite": "Bützberg"
        },
        {
            "code": "4922",
            "localite": "Thunstetten"
        },
        {
            "code": "4923",
            "localite": "Wynau"
        },
        {
            "code": "4924",
            "localite": "Obersteckholz"
        },
        {
            "code": "4932",
            "localite": "Gutenburg"
        },
        {
            "code": "4932",
            "localite": "Lotzwil"
        },
        {
            "code": "4933",
            "localite": "Rütschelen"
        },
        {
            "code": "4934",
            "localite": "Madiswil"
        },
        {
            "code": "4935",
            "localite": "Leimiswil"
        },
        {
            "code": "4936",
            "localite": "Kleindietwil"
        },
        {
            "code": "4937",
            "localite": "Ursenbach"
        },
        {
            "code": "4938",
            "localite": "Rohrbach"
        },
        {
            "code": "4938",
            "localite": "Rohrbachgraben"
        },
        {
            "code": "4942",
            "localite": "Walterswil BE"
        },
        {
            "code": "4943",
            "localite": "Oeschenbach"
        },
        {
            "code": "4944",
            "localite": "Auswil"
        },
        {
            "code": "4950",
            "localite": "Huttwil"
        },
        {
            "code": "4952",
            "localite": "Eriswil"
        },
        {
            "code": "4953",
            "localite": "Schwarzenbach (Huttwil)"
        },
        {
            "code": "4954",
            "localite": "Wyssachen"
        },
        {
            "code": "4955",
            "localite": "Gondiswil"
        },
        {
            "code": "5000",
            "localite": "Aarau"
        },
        {
            "code": "5004",
            "localite": "Aarau"
        },
        {
            "code": "5012",
            "localite": "Eppenberg"
        },
        {
            "code": "5012",
            "localite": "Schönenwerd"
        },
        {
            "code": "5012",
            "localite": "Wöschnau"
        },
        {
            "code": "5013",
            "localite": "Niedergösgen"
        },
        {
            "code": "5014",
            "localite": "Gretzenbach"
        },
        {
            "code": "5015",
            "localite": "Erlinsbach SO"
        },
        {
            "code": "5017",
            "localite": "Barmelweid"
        },
        {
            "code": "5018",
            "localite": "Erlinsbach"
        },
        {
            "code": "5022",
            "localite": "Rombach"
        },
        {
            "code": "5023",
            "localite": "Biberstein"
        },
        {
            "code": "5024",
            "localite": "Küttigen"
        },
        {
            "code": "5025",
            "localite": "Asp"
        },
        {
            "code": "5026",
            "localite": "Densbüren"
        },
        {
            "code": "5027",
            "localite": "Herznach"
        },
        {
            "code": "5028",
            "localite": "Ueken"
        },
        {
            "code": "5032",
            "localite": "Aarau Rohr"
        },
        {
            "code": "5033",
            "localite": "Buchs AG"
        },
        {
            "code": "5034",
            "localite": "Suhr"
        },
        {
            "code": "5035",
            "localite": "Unterentfelden"
        },
        {
            "code": "5036",
            "localite": "Oberentfelden"
        },
        {
            "code": "5037",
            "localite": "Muhen"
        },
        {
            "code": "5040",
            "localite": "Schöftland"
        },
        {
            "code": "5042",
            "localite": "Hirschthal"
        },
        {
            "code": "5043",
            "localite": "Holziken"
        },
        {
            "code": "5044",
            "localite": "Schlossrued"
        },
        {
            "code": "5046",
            "localite": "Schmiedrued"
        },
        {
            "code": "5046",
            "localite": "Walde AG"
        },
        {
            "code": "5053",
            "localite": "Staffelbach"
        },
        {
            "code": "5053",
            "localite": "Wittwil"
        },
        {
            "code": "5054",
            "localite": "Kirchleerau"
        },
        {
            "code": "5054",
            "localite": "Moosleerau"
        },
        {
            "code": "5056",
            "localite": "Attelwil"
        },
        {
            "code": "5057",
            "localite": "Reitnau"
        },
        {
            "code": "5058",
            "localite": "Wiliberg"
        },
        {
            "code": "5062",
            "localite": "Oberhof"
        },
        {
            "code": "5063",
            "localite": "Wölflinswil"
        },
        {
            "code": "5064",
            "localite": "Wittnau"
        },
        {
            "code": "5070",
            "localite": "Frick"
        },
        {
            "code": "5072",
            "localite": "Oeschgen"
        },
        {
            "code": "5073",
            "localite": "Gipf-Oberfrick"
        },
        {
            "code": "5074",
            "localite": "Eiken"
        },
        {
            "code": "5075",
            "localite": "Hornussen"
        },
        {
            "code": "5076",
            "localite": "Bözen"
        },
        {
            "code": "5077",
            "localite": "Elfingen"
        },
        {
            "code": "5078",
            "localite": "Effingen"
        },
        {
            "code": "5079",
            "localite": "Zeihen"
        },
        {
            "code": "5080",
            "localite": "Laufenburg"
        },
        {
            "code": "5082",
            "localite": "Kaisten"
        },
        {
            "code": "5083",
            "localite": "Ittenthal"
        },
        {
            "code": "5084",
            "localite": "Rheinsulz"
        },
        {
            "code": "5085",
            "localite": "Sulz AG"
        },
        {
            "code": "5102",
            "localite": "Rupperswil"
        },
        {
            "code": "5103",
            "localite": "Möriken AG"
        },
        {
            "code": "5103",
            "localite": "Wildegg"
        },
        {
            "code": "5105",
            "localite": "Auenstein"
        },
        {
            "code": "5106",
            "localite": "Veltheim AG"
        },
        {
            "code": "5107",
            "localite": "Schinznach Dorf"
        },
        {
            "code": "5108",
            "localite": "Oberflachs"
        },
        {
            "code": "5112",
            "localite": "Thalheim AG"
        },
        {
            "code": "5113",
            "localite": "Holderbank AG"
        },
        {
            "code": "5116",
            "localite": "Schinznach Bad"
        },
        {
            "code": "5200",
            "localite": "Brugg AG"
        },
        {
            "code": "5210",
            "localite": "Windisch"
        },
        {
            "code": "5212",
            "localite": "Hausen AG"
        },
        {
            "code": "5213",
            "localite": "Villnachern"
        },
        {
            "code": "5222",
            "localite": "Umiken"
        },
        {
            "code": "5223",
            "localite": "Riniken"
        },
        {
            "code": "5225",
            "localite": "Bözberg"
        },
        {
            "code": "5233",
            "localite": "Stilli"
        },
        {
            "code": "5234",
            "localite": "Villigen"
        },
        {
            "code": "5235",
            "localite": "Rüfenach AG"
        },
        {
            "code": "5236",
            "localite": "Remigen"
        },
        {
            "code": "5237",
            "localite": "Mönthal"
        },
        {
            "code": "5242",
            "localite": "Birr"
        },
        {
            "code": "5242",
            "localite": "Lupfig"
        },
        {
            "code": "5243",
            "localite": "Mülligen"
        },
        {
            "code": "5244",
            "localite": "Birrhard"
        },
        {
            "code": "5245",
            "localite": "Habsburg"
        },
        {
            "code": "5246",
            "localite": "Scherz"
        },
        {
            "code": "5272",
            "localite": "Gansingen"
        },
        {
            "code": "5273",
            "localite": "Oberhofen AG"
        },
        {
            "code": "5274",
            "localite": "Mettau"
        },
        {
            "code": "5275",
            "localite": "Etzgen"
        },
        {
            "code": "5276",
            "localite": "Wil AG"
        },
        {
            "code": "5277",
            "localite": "Hottwil"
        },
        {
            "code": "5300",
            "localite": "Turgi"
        },
        {
            "code": "5301",
            "localite": "Siggenthal Station"
        },
        {
            "code": "5303",
            "localite": "Würenlingen"
        },
        {
            "code": "5304",
            "localite": "Endingen"
        },
        {
            "code": "5305",
            "localite": "Unterendingen"
        },
        {
            "code": "5306",
            "localite": "Tegerfelden"
        },
        {
            "code": "5312",
            "localite": "Döttingen"
        },
        {
            "code": "5313",
            "localite": "Klingnau"
        },
        {
            "code": "5314",
            "localite": "Kleindöttingen"
        },
        {
            "code": "5315",
            "localite": "Böttstein"
        },
        {
            "code": "5316",
            "localite": "Leuggern"
        },
        {
            "code": "5317",
            "localite": "Hettenschwil"
        },
        {
            "code": "5318",
            "localite": "Mandach"
        },
        {
            "code": "5322",
            "localite": "Koblenz"
        },
        {
            "code": "5323",
            "localite": "Rietheim"
        },
        {
            "code": "5324",
            "localite": "Full-Reuenthal"
        },
        {
            "code": "5325",
            "localite": "Leibstadt"
        },
        {
            "code": "5326",
            "localite": "Schwaderloch"
        },
        {
            "code": "5330",
            "localite": "Bad Zurzach"
        },
        {
            "code": "5332",
            "localite": "Rekingen AG"
        },
        {
            "code": "5333",
            "localite": "Baldingen"
        },
        {
            "code": "5334",
            "localite": "Böbikon"
        },
        {
            "code": "5400",
            "localite": "Baden"
        },
        {
            "code": "5404",
            "localite": "Baden"
        },
        {
            "code": "5405",
            "localite": "Dättwil AG"
        },
        {
            "code": "5406",
            "localite": "Rütihof"
        },
        {
            "code": "5408",
            "localite": "Ennetbaden"
        },
        {
            "code": "5412",
            "localite": "Gebenstorf"
        },
        {
            "code": "5412",
            "localite": "Vogelsang AG"
        },
        {
            "code": "5413",
            "localite": "Birmenstorf AG"
        },
        {
            "code": "5415",
            "localite": "Hertenstein AG"
        },
        {
            "code": "5415",
            "localite": "Nussbaumen AG"
        },
        {
            "code": "5415",
            "localite": "Rieden AG"
        },
        {
            "code": "5416",
            "localite": "Kirchdorf AG"
        },
        {
            "code": "5417",
            "localite": "Untersiggenthal"
        },
        {
            "code": "5420",
            "localite": "Ehrendingen"
        },
        {
            "code": "5423",
            "localite": "Freienwil"
        },
        {
            "code": "5425",
            "localite": "Schneisingen"
        },
        {
            "code": "5426",
            "localite": "Lengnau AG"
        },
        {
            "code": "5430",
            "localite": "Wettingen"
        },
        {
            "code": "5432",
            "localite": "Neuenhof"
        },
        {
            "code": "5436",
            "localite": "Würenlos"
        },
        {
            "code": "5442",
            "localite": "Fislisbach"
        },
        {
            "code": "5443",
            "localite": "Niederrohrdorf"
        },
        {
            "code": "5444",
            "localite": "Künten"
        },
        {
            "code": "5445",
            "localite": "Eggenwil"
        },
        {
            "code": "5452",
            "localite": "Oberrohrdorf"
        },
        {
            "code": "5453",
            "localite": "Remetschwil"
        },
        {
            "code": "5454",
            "localite": "Bellikon"
        },
        {
            "code": "5462",
            "localite": "Siglistorf"
        },
        {
            "code": "5463",
            "localite": "Wislikofen"
        },
        {
            "code": "5464",
            "localite": "Rümikon AG"
        },
        {
            "code": "5465",
            "localite": "Mellikon"
        },
        {
            "code": "5466",
            "localite": "Kaiserstuhl AG"
        },
        {
            "code": "5467",
            "localite": "Fisibach"
        },
        {
            "code": "5502",
            "localite": "Hunzenschwil"
        },
        {
            "code": "5503",
            "localite": "Schafisheim"
        },
        {
            "code": "5504",
            "localite": "Othmarsingen"
        },
        {
            "code": "5505",
            "localite": "Brunegg"
        },
        {
            "code": "5506",
            "localite": "Mägenwil"
        },
        {
            "code": "5507",
            "localite": "Mellingen"
        },
        {
            "code": "5512",
            "localite": "Wohlenschwil"
        },
        {
            "code": "5522",
            "localite": "Tägerig"
        },
        {
            "code": "5524",
            "localite": "Nesselnbach"
        },
        {
            "code": "5524",
            "localite": "Niederwil AG"
        },
        {
            "code": "5525",
            "localite": "Fischbach-Göslikon"
        },
        {
            "code": "5600",
            "localite": "Ammerswil AG"
        },
        {
            "code": "5600",
            "localite": "Lenzburg"
        },
        {
            "code": "5603",
            "localite": "Staufen"
        },
        {
            "code": "5604",
            "localite": "Hendschiken"
        },
        {
            "code": "5605",
            "localite": "Dottikon"
        },
        {
            "code": "5606",
            "localite": "Dintikon"
        },
        {
            "code": "5607",
            "localite": "Hägglingen"
        },
        {
            "code": "5608",
            "localite": "Stetten AG"
        },
        {
            "code": "5610",
            "localite": "Wohlen AG"
        },
        {
            "code": "5611",
            "localite": "Anglikon"
        },
        {
            "code": "5612",
            "localite": "Villmergen"
        },
        {
            "code": "5613",
            "localite": "Hilfikon"
        },
        {
            "code": "5614",
            "localite": "Sarmenstorf"
        },
        {
            "code": "5615",
            "localite": "Fahrwangen"
        },
        {
            "code": "5616",
            "localite": "Meisterschwanden"
        },
        {
            "code": "5617",
            "localite": "Tennwil"
        },
        {
            "code": "5618",
            "localite": "Bettwil"
        },
        {
            "code": "5619",
            "localite": "Büttikon AG"
        },
        {
            "code": "5619",
            "localite": "Uezwil"
        },
        {
            "code": "5620",
            "localite": "Bremgarten AG"
        },
        {
            "code": "5621",
            "localite": "Zufikon"
        },
        {
            "code": "5622",
            "localite": "Waltenschwil"
        },
        {
            "code": "5623",
            "localite": "Boswil"
        },
        {
            "code": "5624",
            "localite": "Bünzen"
        },
        {
            "code": "5624",
            "localite": "Waldhäusern AG"
        },
        {
            "code": "5625",
            "localite": "Kallern"
        },
        {
            "code": "5626",
            "localite": "Hermetschwil-Staffeln"
        },
        {
            "code": "5627",
            "localite": "Besenbüren"
        },
        {
            "code": "5628",
            "localite": "Aristau"
        },
        {
            "code": "5630",
            "localite": "Muri AG"
        },
        {
            "code": "5632",
            "localite": "Buttwil"
        },
        {
            "code": "5634",
            "localite": "Merenschwand"
        },
        {
            "code": "5636",
            "localite": "Benzenschwil"
        },
        {
            "code": "5637",
            "localite": "Beinwil (Freiamt)"
        },
        {
            "code": "5637",
            "localite": "Geltwil"
        },
        {
            "code": "5642",
            "localite": "Mühlau"
        },
        {
            "code": "5643",
            "localite": "Alikon"
        },
        {
            "code": "5643",
            "localite": "Meienberg"
        },
        {
            "code": "5643",
            "localite": "Sins"
        },
        {
            "code": "5644",
            "localite": "Auw"
        },
        {
            "code": "5645",
            "localite": "Aettenschwil"
        },
        {
            "code": "5645",
            "localite": "Fenkrieden"
        },
        {
            "code": "5646",
            "localite": "Abtwil AG"
        },
        {
            "code": "5647",
            "localite": "Oberrüti"
        },
        {
            "code": "5702",
            "localite": "Niederlenz"
        },
        {
            "code": "5703",
            "localite": "Seon"
        },
        {
            "code": "5704",
            "localite": "Egliswil"
        },
        {
            "code": "5705",
            "localite": "Hallwil"
        },
        {
            "code": "5706",
            "localite": "Boniswil"
        },
        {
            "code": "5707",
            "localite": "Seengen"
        },
        {
            "code": "5708",
            "localite": "Birrwil"
        },
        {
            "code": "5712",
            "localite": "Beinwil am See"
        },
        {
            "code": "5722",
            "localite": "Gränichen"
        },
        {
            "code": "5723",
            "localite": "Teufenthal AG"
        },
        {
            "code": "5724",
            "localite": "Dürrenäsch"
        },
        {
            "code": "5725",
            "localite": "Leutwil"
        },
        {
            "code": "5726",
            "localite": "Unterkulm"
        },
        {
            "code": "5727",
            "localite": "Oberkulm"
        },
        {
            "code": "5728",
            "localite": "Gontenschwil"
        },
        {
            "code": "5732",
            "localite": "Zetzwil"
        },
        {
            "code": "5733",
            "localite": "Leimbach AG"
        },
        {
            "code": "5734",
            "localite": "Reinach AG"
        },
        {
            "code": "5735",
            "localite": "Pfeffikon LU"
        },
        {
            "code": "5736",
            "localite": "Burg AG"
        },
        {
            "code": "5737",
            "localite": "Menziken"
        },
        {
            "code": "5742",
            "localite": "Kölliken"
        },
        {
            "code": "5745",
            "localite": "Safenwil"
        },
        {
            "code": "5746",
            "localite": "Walterswil SO"
        },
        {
            "code": "6003",
            "localite": "Luzern"
        },
        {
            "code": "6004",
            "localite": "Luzern"
        },
        {
            "code": "6005",
            "localite": "Luzern"
        },
        {
            "code": "6005",
            "localite": "St. Niklausen LU"
        },
        {
            "code": "6006",
            "localite": "Luzern"
        },
        {
            "code": "6010",
            "localite": "Kriens"
        },
        {
            "code": "6010",
            "localite": "Pilatus Kulm"
        },
        {
            "code": "6012",
            "localite": "Obernau"
        },
        {
            "code": "6013",
            "localite": "Eigenthal"
        },
        {
            "code": "6014",
            "localite": "Luzern"
        },
        {
            "code": "6015",
            "localite": "Luzern"
        },
        {
            "code": "6016",
            "localite": "Hellbühl"
        },
        {
            "code": "6017",
            "localite": "Ruswil"
        },
        {
            "code": "6018",
            "localite": "Buttisholz"
        },
        {
            "code": "6019",
            "localite": "Sigigen"
        },
        {
            "code": "6020",
            "localite": "Emmenbrücke"
        },
        {
            "code": "6022",
            "localite": "Grosswangen"
        },
        {
            "code": "6023",
            "localite": "Rothenburg"
        },
        {
            "code": "6024",
            "localite": "Hildisrieden"
        },
        {
            "code": "6025",
            "localite": "Neudorf"
        },
        {
            "code": "6026",
            "localite": "Rain"
        },
        {
            "code": "6027",
            "localite": "Römerswil LU"
        },
        {
            "code": "6028",
            "localite": "Herlisberg"
        },
        {
            "code": "6030",
            "localite": "Ebikon"
        },
        {
            "code": "6032",
            "localite": "Emmen"
        },
        {
            "code": "6033",
            "localite": "Buchrain"
        },
        {
            "code": "6034",
            "localite": "Inwil"
        },
        {
            "code": "6035",
            "localite": "Perlen"
        },
        {
            "code": "6036",
            "localite": "Dierikon"
        },
        {
            "code": "6037",
            "localite": "Root"
        },
        {
            "code": "6038",
            "localite": "Gisikon"
        },
        {
            "code": "6038",
            "localite": "Honau"
        },
        {
            "code": "6039",
            "localite": "Root D4"
        },
        {
            "code": "6042",
            "localite": "Dietwil"
        },
        {
            "code": "6043",
            "localite": "Adligenswil"
        },
        {
            "code": "6044",
            "localite": "Udligenswil"
        },
        {
            "code": "6045",
            "localite": "Meggen"
        },
        {
            "code": "6047",
            "localite": "Kastanienbaum"
        },
        {
            "code": "6048",
            "localite": "Horw"
        },
        {
            "code": "6052",
            "localite": "Hergiswil NW"
        },
        {
            "code": "6053",
            "localite": "Alpnachstad"
        },
        {
            "code": "6055",
            "localite": "Alpnach Dorf"
        },
        {
            "code": "6056",
            "localite": "Kägiswil"
        },
        {
            "code": "6060",
            "localite": "Ramersberg"
        },
        {
            "code": "6060",
            "localite": "Sarnen"
        },
        {
            "code": "6062",
            "localite": "Wilen (Sarnen)"
        },
        {
            "code": "6063",
            "localite": "Stalden (Sarnen)"
        },
        {
            "code": "6064",
            "localite": "Kerns"
        },
        {
            "code": "6066",
            "localite": "St. Niklausen OW"
        },
        {
            "code": "6067",
            "localite": "Melchtal"
        },
        {
            "code": "6068",
            "localite": "Melchsee-Frutt"
        },
        {
            "code": "6072",
            "localite": "Sachseln"
        },
        {
            "code": "6073",
            "localite": "Flüeli-Ranft"
        },
        {
            "code": "6074",
            "localite": "Giswil"
        },
        {
            "code": "6078",
            "localite": "Bürglen OW"
        },
        {
            "code": "6078",
            "localite": "Lungern"
        },
        {
            "code": "6083",
            "localite": "Hasliberg Hohfluh"
        },
        {
            "code": "6084",
            "localite": "Hasliberg Wasserwendi"
        },
        {
            "code": "6085",
            "localite": "Hasliberg Goldern"
        },
        {
            "code": "6086",
            "localite": "Hasliberg Reuti"
        },
        {
            "code": "6102",
            "localite": "Malters"
        },
        {
            "code": "6103",
            "localite": "Schwarzenberg LU"
        },
        {
            "code": "6105",
            "localite": "Schachen LU"
        },
        {
            "code": "6106",
            "localite": "Werthenstein"
        },
        {
            "code": "6110",
            "localite": "Fontannen b. Wolhusen"
        },
        {
            "code": "6110",
            "localite": "Wolhusen"
        },
        {
            "code": "6112",
            "localite": "Doppleschwand"
        },
        {
            "code": "6113",
            "localite": "Romoos"
        },
        {
            "code": "6114",
            "localite": "Steinhuserberg"
        },
        {
            "code": "6122",
            "localite": "Menznau"
        },
        {
            "code": "6123",
            "localite": "Geiss"
        },
        {
            "code": "6125",
            "localite": "Menzberg"
        },
        {
            "code": "6126",
            "localite": "Daiwil"
        },
        {
            "code": "6130",
            "localite": "Willisau"
        },
        {
            "code": "6132",
            "localite": "Rohrmatt"
        },
        {
            "code": "6133",
            "localite": "Hergiswil b. Willisau"
        },
        {
            "code": "6142",
            "localite": "Gettnau"
        },
        {
            "code": "6143",
            "localite": "Ohmstal"
        },
        {
            "code": "6144",
            "localite": "Zell LU"
        },
        {
            "code": "6145",
            "localite": "Fischbach LU"
        },
        {
            "code": "6146",
            "localite": "Grossdietwil"
        },
        {
            "code": "6147",
            "localite": "Altbüron"
        },
        {
            "code": "6152",
            "localite": "Hüswil"
        },
        {
            "code": "6153",
            "localite": "Ufhusen"
        },
        {
            "code": "6154",
            "localite": "Hofstatt"
        },
        {
            "code": "6156",
            "localite": "Luthern"
        },
        {
            "code": "6156",
            "localite": "Luthern Bad"
        },
        {
            "code": "6162",
            "localite": "Entlebuch"
        },
        {
            "code": "6162",
            "localite": "Finsterwald b. Entlebuch"
        },
        {
            "code": "6162",
            "localite": "Rengg"
        },
        {
            "code": "6163",
            "localite": "Ebnet"
        },
        {
            "code": "6166",
            "localite": "Hasle LU"
        },
        {
            "code": "6167",
            "localite": "Bramboden"
        },
        {
            "code": "6170",
            "localite": "Schüpfheim"
        },
        {
            "code": "6173",
            "localite": "Flühli LU"
        },
        {
            "code": "6174",
            "localite": "Sörenberg"
        },
        {
            "code": "6182",
            "localite": "Escholzmatt"
        },
        {
            "code": "6192",
            "localite": "Wiggen"
        },
        {
            "code": "6196",
            "localite": "Marbach LU"
        },
        {
            "code": "6197",
            "localite": "Schangnau"
        },
        {
            "code": "6203",
            "localite": "Sempach Station"
        },
        {
            "code": "6204",
            "localite": "Sempach"
        },
        {
            "code": "6205",
            "localite": "Eich"
        },
        {
            "code": "6206",
            "localite": "Neuenkirch"
        },
        {
            "code": "6207",
            "localite": "Nottwil"
        },
        {
            "code": "6208",
            "localite": "Oberkirch LU"
        },
        {
            "code": "6210",
            "localite": "Sursee"
        },
        {
            "code": "6211",
            "localite": "Buchs LU"
        },
        {
            "code": "6212",
            "localite": "Kaltbach"
        },
        {
            "code": "6212",
            "localite": "St. Erhard"
        },
        {
            "code": "6213",
            "localite": "Knutwil"
        },
        {
            "code": "6214",
            "localite": "Schenkon"
        },
        {
            "code": "6215",
            "localite": "Beromünster"
        },
        {
            "code": "6215",
            "localite": "Schwarzenbach LU"
        },
        {
            "code": "6216",
            "localite": "Mauensee"
        },
        {
            "code": "6217",
            "localite": "Kottwil"
        },
        {
            "code": "6218",
            "localite": "Ettiswil"
        },
        {
            "code": "6221",
            "localite": "Rickenbach LU"
        },
        {
            "code": "6222",
            "localite": "Gunzwil"
        },
        {
            "code": "6231",
            "localite": "Schlierbach"
        },
        {
            "code": "6232",
            "localite": "Geuensee"
        },
        {
            "code": "6233",
            "localite": "Büron"
        },
        {
            "code": "6234",
            "localite": "Kulmerau"
        },
        {
            "code": "6234",
            "localite": "Triengen"
        },
        {
            "code": "6235",
            "localite": "Winikon"
        },
        {
            "code": "6236",
            "localite": "Wilihof"
        },
        {
            "code": "6242",
            "localite": "Wauwil"
        },
        {
            "code": "6243",
            "localite": "Egolzwil"
        },
        {
            "code": "6244",
            "localite": "Nebikon"
        },
        {
            "code": "6245",
            "localite": "Ebersecken"
        },
        {
            "code": "6246",
            "localite": "Altishofen"
        },
        {
            "code": "6247",
            "localite": "Schötz"
        },
        {
            "code": "6248",
            "localite": "Alberswil"
        },
        {
            "code": "6252",
            "localite": "Dagmersellen"
        },
        {
            "code": "6253",
            "localite": "Uffikon"
        },
        {
            "code": "6260",
            "localite": "Hintermoos"
        },
        {
            "code": "6260",
            "localite": "Mehlsecken"
        },
        {
            "code": "6260",
            "localite": "Reiden"
        },
        {
            "code": "6260",
            "localite": "Reidermoos"
        },
        {
            "code": "6262",
            "localite": "Langnau b. Reiden"
        },
        {
            "code": "6263",
            "localite": "Richenthal"
        },
        {
            "code": "6264",
            "localite": "Pfaffnau"
        },
        {
            "code": "6265",
            "localite": "Roggliswil"
        },
        {
            "code": "6274",
            "localite": "Eschenbach LU"
        },
        {
            "code": "6275",
            "localite": "Ballwil"
        },
        {
            "code": "6276",
            "localite": "Hohenrain"
        },
        {
            "code": "6277",
            "localite": "Kleinwangen"
        },
        {
            "code": "6277",
            "localite": "Lieli LU"
        },
        {
            "code": "6280",
            "localite": "Hochdorf"
        },
        {
            "code": "6280",
            "localite": "Urswil"
        },
        {
            "code": "6283",
            "localite": "Baldegg"
        },
        {
            "code": "6284",
            "localite": "Gelfingen"
        },
        {
            "code": "6284",
            "localite": "Sulz LU"
        },
        {
            "code": "6285",
            "localite": "Hitzkirch"
        },
        {
            "code": "6285",
            "localite": "Retschwil"
        },
        {
            "code": "6286",
            "localite": "Altwis"
        },
        {
            "code": "6287",
            "localite": "Aesch LU"
        },
        {
            "code": "6288",
            "localite": "Schongau"
        },
        {
            "code": "6289",
            "localite": "Hämikon"
        },
        {
            "code": "6289",
            "localite": "Müswangen"
        },
        {
            "code": "6294",
            "localite": "Ermensee"
        },
        {
            "code": "6295",
            "localite": "Mosen"
        },
        {
            "code": "6300",
            "localite": "Zug"
        },
        {
            "code": "6300",
            "localite": "Zugerberg"
        },
        {
            "code": "6312",
            "localite": "Steinhausen"
        },
        {
            "code": "6313",
            "localite": "Edlibach"
        },
        {
            "code": "6313",
            "localite": "Finstersee"
        },
        {
            "code": "6313",
            "localite": "Menzingen"
        },
        {
            "code": "6314",
            "localite": "Neuägeri"
        },
        {
            "code": "6314",
            "localite": "Unterägeri"
        },
        {
            "code": "6315",
            "localite": "Alosen"
        },
        {
            "code": "6315",
            "localite": "Morgarten"
        },
        {
            "code": "6315",
            "localite": "Oberägeri"
        },
        {
            "code": "6317",
            "localite": "Oberwil b. Zug"
        },
        {
            "code": "6318",
            "localite": "Walchwil"
        },
        {
            "code": "6319",
            "localite": "Allenwinden"
        },
        {
            "code": "6330",
            "localite": "Cham"
        },
        {
            "code": "6331",
            "localite": "Hünenberg"
        },
        {
            "code": "6332",
            "localite": "Hagendorn"
        },
        {
            "code": "6333",
            "localite": "Hünenberg See"
        },
        {
            "code": "6340",
            "localite": "Baar"
        },
        {
            "code": "6340",
            "localite": "Sihlbrugg"
        },
        {
            "code": "6343",
            "localite": "Buonas"
        },
        {
            "code": "6343",
            "localite": "Holzhäusern ZG"
        },
        {
            "code": "6343",
            "localite": "Risch"
        },
        {
            "code": "6343",
            "localite": "Rotkreuz"
        },
        {
            "code": "6344",
            "localite": "Meierskappel"
        },
        {
            "code": "6345",
            "localite": "Neuheim"
        },
        {
            "code": "6353",
            "localite": "Weggis"
        },
        {
            "code": "6354",
            "localite": "Vitznau"
        },
        {
            "code": "6356",
            "localite": "Rigi Kaltbad"
        },
        {
            "code": "6362",
            "localite": "Stansstad"
        },
        {
            "code": "6363",
            "localite": "Bürgenstock"
        },
        {
            "code": "6363",
            "localite": "Fürigen"
        },
        {
            "code": "6363",
            "localite": "Obbürgen"
        },
        {
            "code": "6365",
            "localite": "Kehrsiten"
        },
        {
            "code": "6370",
            "localite": "Oberdorf NW"
        },
        {
            "code": "6370",
            "localite": "Stans"
        },
        {
            "code": "6372",
            "localite": "Ennetmoos"
        },
        {
            "code": "6373",
            "localite": "Ennetbürgen"
        },
        {
            "code": "6374",
            "localite": "Buochs"
        },
        {
            "code": "6375",
            "localite": "Beckenried"
        },
        {
            "code": "6376",
            "localite": "Emmetten"
        },
        {
            "code": "6377",
            "localite": "Seelisberg"
        },
        {
            "code": "6382",
            "localite": "Büren NW"
        },
        {
            "code": "6383",
            "localite": "Dallenwil"
        },
        {
            "code": "6383",
            "localite": "Niederrickenbach"
        },
        {
            "code": "6383",
            "localite": "Wiesenberg"
        },
        {
            "code": "6383",
            "localite": "Wirzweli"
        },
        {
            "code": "6386",
            "localite": "Wolfenschiessen"
        },
        {
            "code": "6387",
            "localite": "Oberrickenbach"
        },
        {
            "code": "6388",
            "localite": "Grafenort"
        },
        {
            "code": "6390",
            "localite": "Engelberg"
        },
        {
            "code": "6402",
            "localite": "Merlischachen"
        },
        {
            "code": "6403",
            "localite": "Küssnacht am Rigi"
        },
        {
            "code": "6404",
            "localite": "Greppen"
        },
        {
            "code": "6405",
            "localite": "Immensee"
        },
        {
            "code": "6410",
            "localite": "Goldau"
        },
        {
            "code": "6410",
            "localite": "Rigi Klösterli"
        },
        {
            "code": "6410",
            "localite": "Rigi Kulm"
        },
        {
            "code": "6410",
            "localite": "Rigi Scheidegg"
        },
        {
            "code": "6410",
            "localite": "Rigi Staffel"
        },
        {
            "code": "6414",
            "localite": "Oberarth"
        },
        {
            "code": "6415",
            "localite": "Arth"
        },
        {
            "code": "6416",
            "localite": "Steinerberg"
        },
        {
            "code": "6417",
            "localite": "Sattel"
        },
        {
            "code": "6418",
            "localite": "Rothenthurm"
        },
        {
            "code": "6422",
            "localite": "Steinen"
        },
        {
            "code": "6423",
            "localite": "Seewen SZ"
        },
        {
            "code": "6424",
            "localite": "Lauerz"
        },
        {
            "code": "6430",
            "localite": "Schwyz"
        },
        {
            "code": "6432",
            "localite": "Rickenbach b. Schwyz"
        },
        {
            "code": "6433",
            "localite": "Stoos SZ"
        },
        {
            "code": "6434",
            "localite": "Illgau"
        },
        {
            "code": "6436",
            "localite": "Bisisthal"
        },
        {
            "code": "6436",
            "localite": "Muotathal"
        },
        {
            "code": "6436",
            "localite": "Ried (Muotathal)"
        },
        {
            "code": "6438",
            "localite": "Ibach"
        },
        {
            "code": "6440",
            "localite": "Brunnen"
        },
        {
            "code": "6441",
            "localite": "Rütli"
        },
        {
            "code": "6442",
            "localite": "Gersau"
        },
        {
            "code": "6443",
            "localite": "Morschach"
        },
        {
            "code": "6452",
            "localite": "Riemenstalden"
        },
        {
            "code": "6452",
            "localite": "Sisikon"
        },
        {
            "code": "6454",
            "localite": "Flüelen"
        },
        {
            "code": "6460",
            "localite": "Altdorf UR"
        },
        {
            "code": "6461",
            "localite": "Isenthal"
        },
        {
            "code": "6462",
            "localite": "Seedorf UR"
        },
        {
            "code": "6463",
            "localite": "Bürglen UR"
        },
        {
            "code": "6464",
            "localite": "Spiringen"
        },
        {
            "code": "6465",
            "localite": "Unterschächen"
        },
        {
            "code": "6466",
            "localite": "Bauen"
        },
        {
            "code": "6467",
            "localite": "Schattdorf"
        },
        {
            "code": "6468",
            "localite": "Attinghausen"
        },
        {
            "code": "6469",
            "localite": "Haldi b. Schattdorf"
        },
        {
            "code": "6472",
            "localite": "Erstfeld"
        },
        {
            "code": "6473",
            "localite": "Silenen"
        },
        {
            "code": "6474",
            "localite": "Amsteg"
        },
        {
            "code": "6475",
            "localite": "Bristen"
        },
        {
            "code": "6476",
            "localite": "Intschi"
        },
        {
            "code": "6482",
            "localite": "Gurtnellen"
        },
        {
            "code": "6484",
            "localite": "Wassen UR"
        },
        {
            "code": "6485",
            "localite": "Meien"
        },
        {
            "code": "6487",
            "localite": "Göschenen"
        },
        {
            "code": "6490",
            "localite": "Andermatt"
        },
        {
            "code": "6491",
            "localite": "Realp"
        },
        {
            "code": "6493",
            "localite": "Hospental"
        },
        {
            "code": "6500",
            "localite": "Bellinzona"
        },
        {
            "code": "6503",
            "localite": "Bellinzona"
        },
        {
            "code": "6512",
            "localite": "Giubiasco"
        },
        {
            "code": "6513",
            "localite": "Monte Carasso"
        },
        {
            "code": "6514",
            "localite": "Sementina"
        },
        {
            "code": "6515",
            "localite": "Gudo"
        },
        {
            "code": "6516",
            "localite": "Cugnasco"
        },
        {
            "code": "6517",
            "localite": "Arbedo"
        },
        {
            "code": "6518",
            "localite": "Gorduno"
        },
        {
            "code": "6523",
            "localite": "Preonzo"
        },
        {
            "code": "6524",
            "localite": "Moleno"
        },
        {
            "code": "6525",
            "localite": "Gnosca"
        },
        {
            "code": "6526",
            "localite": "Prosito"
        },
        {
            "code": "6527",
            "localite": "Lodrino"
        },
        {
            "code": "6528",
            "localite": "Camorino"
        },
        {
            "code": "6532",
            "localite": "Castione"
        },
        {
            "code": "6533",
            "localite": "Lumino"
        },
        {
            "code": "6534",
            "localite": "S. Vittore"
        },
        {
            "code": "6535",
            "localite": "Roveredo GR"
        },
        {
            "code": "6537",
            "localite": "Grono"
        },
        {
            "code": "6538",
            "localite": "Verdabbio"
        },
        {
            "code": "6540",
            "localite": "Castaneda"
        },
        {
            "code": "6541",
            "localite": "Sta. Maria in Calanca"
        },
        {
            "code": "6542",
            "localite": "Buseno"
        },
        {
            "code": "6543",
            "localite": "Arvigo"
        },
        {
            "code": "6544",
            "localite": "Braggio"
        },
        {
            "code": "6545",
            "localite": "Selma"
        },
        {
            "code": "6546",
            "localite": "Cauco"
        },
        {
            "code": "6548",
            "localite": "Augio"
        },
        {
            "code": "6548",
            "localite": "Rossa"
        },
        {
            "code": "6548",
            "localite": "Sta. Domenica"
        },
        {
            "code": "6549",
            "localite": "Laura"
        },
        {
            "code": "6556",
            "localite": "Leggia"
        },
        {
            "code": "6557",
            "localite": "Cama"
        },
        {
            "code": "6558",
            "localite": "Lostallo"
        },
        {
            "code": "6562",
            "localite": "Soazza"
        },
        {
            "code": "6563",
            "localite": "Mesocco"
        },
        {
            "code": "6565",
            "localite": "S. Bernardino"
        },
        {
            "code": "6571",
            "localite": "Indemini"
        },
        {
            "code": "6572",
            "localite": "Quartino"
        },
        {
            "code": "6573",
            "localite": "Magadino"
        },
        {
            "code": "6574",
            "localite": "Vira (Gambarogno)"
        },
        {
            "code": "6575",
            "localite": "S. Nazzaro"
        },
        {
            "code": "6575",
            "localite": "Vairano"
        },
        {
            "code": "6576",
            "localite": "Gerra (Gambarogno)"
        },
        {
            "code": "6577",
            "localite": "Ranzo"
        },
        {
            "code": "6578",
            "localite": "Caviano"
        },
        {
            "code": "6579",
            "localite": "Piazzogna"
        },
        {
            "code": "6582",
            "localite": "Pianezzo"
        },
        {
            "code": "6583",
            "localite": "S. Antonio (Val Morobbia)"
        },
        {
            "code": "6584",
            "localite": "Carena"
        },
        {
            "code": "6592",
            "localite": "S. Antonino"
        },
        {
            "code": "6593",
            "localite": "Cadenazzo"
        },
        {
            "code": "6594",
            "localite": "Contone"
        },
        {
            "code": "6595",
            "localite": "Riazzino"
        },
        {
            "code": "6596",
            "localite": "Gordola"
        },
        {
            "code": "6597",
            "localite": "Agarone"
        },
        {
            "code": "6598",
            "localite": "Tenero"
        },
        {
            "code": "6599",
            "localite": "Robasacco"
        },
        {
            "code": "6600",
            "localite": "Locarno"
        },
        {
            "code": "6600",
            "localite": "Muralto"
        },
        {
            "code": "6600",
            "localite": "Solduno"
        },
        {
            "code": "6605",
            "localite": "Locarno"
        },
        {
            "code": "6612",
            "localite": "Ascona"
        },
        {
            "code": "6613",
            "localite": "Porto Ronco"
        },
        {
            "code": "6614",
            "localite": "Brissago"
        },
        {
            "code": "6614",
            "localite": "Isole di Brissago"
        },
        {
            "code": "6616",
            "localite": "Losone"
        },
        {
            "code": "6618",
            "localite": "Arcegno"
        },
        {
            "code": "6622",
            "localite": "Ronco sopra Ascona"
        },
        {
            "code": "6631",
            "localite": "Corippo"
        },
        {
            "code": "6632",
            "localite": "Vogorno"
        },
        {
            "code": "6633",
            "localite": "Lavertezzo"
        },
        {
            "code": "6634",
            "localite": "Brione (Verzasca)"
        },
        {
            "code": "6635",
            "localite": "Gerra (Verzasca)"
        },
        {
            "code": "6636",
            "localite": "Frasco"
        },
        {
            "code": "6637",
            "localite": "Sonogno"
        },
        {
            "code": "6644",
            "localite": "Orselina"
        },
        {
            "code": "6645",
            "localite": "Brione sopra Minusio"
        },
        {
            "code": "6646",
            "localite": "Contra"
        },
        {
            "code": "6647",
            "localite": "Mergoscia"
        },
        {
            "code": "6648",
            "localite": "Minusio"
        },
        {
            "code": "6652",
            "localite": "Tegna"
        },
        {
            "code": "6653",
            "localite": "Verscio"
        },
        {
            "code": "6654",
            "localite": "Cavigliano"
        },
        {
            "code": "6655",
            "localite": "Intragna"
        },
        {
            "code": "6655",
            "localite": "Rasa"
        },
        {
            "code": "6655",
            "localite": "Verdasio"
        },
        {
            "code": "6656",
            "localite": "Golino"
        },
        {
            "code": "6657",
            "localite": "Palagnedra"
        },
        {
            "code": "6658",
            "localite": "Borgnone"
        },
        {
            "code": "6659",
            "localite": "Camedo"
        },
        {
            "code": "6659",
            "localite": "Moneto"
        },
        {
            "code": "6661",
            "localite": "Auressio"
        },
        {
            "code": "6661",
            "localite": "Berzona"
        },
        {
            "code": "6661",
            "localite": "Comologno"
        },
        {
            "code": "6661",
            "localite": "Crana"
        },
        {
            "code": "6661",
            "localite": "Gresso"
        },
        {
            "code": "6661",
            "localite": "Loco"
        },
        {
            "code": "6661",
            "localite": "Mosogno"
        },
        {
            "code": "6661",
            "localite": "Russo"
        },
        {
            "code": "6661",
            "localite": "Spruga"
        },
        {
            "code": "6661",
            "localite": "Vergeletto"
        },
        {
            "code": "6670",
            "localite": "Avegno"
        },
        {
            "code": "6672",
            "localite": "Gordevio"
        },
        {
            "code": "6673",
            "localite": "Maggia"
        },
        {
            "code": "6674",
            "localite": "Riveo"
        },
        {
            "code": "6674",
            "localite": "Someo"
        },
        {
            "code": "6675",
            "localite": "Cevio"
        },
        {
            "code": "6676",
            "localite": "Bignasco"
        },
        {
            "code": "6677",
            "localite": "Aurigeno"
        },
        {
            "code": "6677",
            "localite": "Moghegno"
        },
        {
            "code": "6678",
            "localite": "Coglio"
        },
        {
            "code": "6678",
            "localite": "Giumaglio"
        },
        {
            "code": "6678",
            "localite": "Lodano"
        },
        {
            "code": "6682",
            "localite": "Linescio"
        },
        {
            "code": "6683",
            "localite": "Cerentino"
        },
        {
            "code": "6683",
            "localite": "Niva (Vallemaggia)"
        },
        {
            "code": "6684",
            "localite": "Campo (Vallemaggia)"
        },
        {
            "code": "6684",
            "localite": "Cimalmotto"
        },
        {
            "code": "6685",
            "localite": "Bosco/Gurin"
        },
        {
            "code": "6690",
            "localite": "Cavergno"
        },
        {
            "code": "6690",
            "localite": "S. Carlo (Val Bavona)"
        },
        {
            "code": "6692",
            "localite": "Brontallo"
        },
        {
            "code": "6692",
            "localite": "Menzonio"
        },
        {
            "code": "6693",
            "localite": "Broglio"
        },
        {
            "code": "6694",
            "localite": "Prato-Sornico"
        },
        {
            "code": "6695",
            "localite": "Peccia"
        },
        {
            "code": "6695",
            "localite": "Piano di Peccia"
        },
        {
            "code": "6696",
            "localite": "Fusio"
        },
        {
            "code": "6702",
            "localite": "Claro"
        },
        {
            "code": "6703",
            "localite": "Osogna"
        },
        {
            "code": "6705",
            "localite": "Cresciano"
        },
        {
            "code": "6707",
            "localite": "Iragna"
        },
        {
            "code": "6710",
            "localite": "Biasca"
        },
        {
            "code": "6713",
            "localite": "Malvaglia"
        },
        {
            "code": "6714",
            "localite": "Semione"
        },
        {
            "code": "6715",
            "localite": "Dongio"
        },
        {
            "code": "6716",
            "localite": "Acquarossa"
        },
        {
            "code": "6716",
            "localite": "Leontica"
        },
        {
            "code": "6716",
            "localite": "Lottigna"
        },
        {
            "code": "6717",
            "localite": "Dangio"
        },
        {
            "code": "6717",
            "localite": "Torre"
        },
        {
            "code": "6718",
            "localite": "Camperio"
        },
        {
            "code": "6718",
            "localite": "Olivone"
        },
        {
            "code": "6719",
            "localite": "Aquila"
        },
        {
            "code": "6720",
            "localite": "Campo (Blenio)"
        },
        {
            "code": "6720",
            "localite": "Ghirone"
        },
        {
            "code": "6721",
            "localite": "Ludiano"
        },
        {
            "code": "6721",
            "localite": "Motto (Blenio)"
        },
        {
            "code": "6722",
            "localite": "Corzoneso"
        },
        {
            "code": "6723",
            "localite": "Castro"
        },
        {
            "code": "6723",
            "localite": "Marolta"
        },
        {
            "code": "6723",
            "localite": "Prugiasco"
        },
        {
            "code": "6724",
            "localite": "Largario"
        },
        {
            "code": "6724",
            "localite": "Ponto Valentino"
        },
        {
            "code": "6742",
            "localite": "Pollegio"
        },
        {
            "code": "6743",
            "localite": "Bodio TI"
        },
        {
            "code": "6744",
            "localite": "Personico"
        },
        {
            "code": "6745",
            "localite": "Giornico"
        },
        {
            "code": "6746",
            "localite": "Calonico"
        },
        {
            "code": "6746",
            "localite": "Lavorgo"
        },
        {
            "code": "6746",
            "localite": "Nivo"
        },
        {
            "code": "6747",
            "localite": "Chironico"
        },
        {
            "code": "6748",
            "localite": "Anzonico"
        },
        {
            "code": "6749",
            "localite": "Cavagnago"
        },
        {
            "code": "6749",
            "localite": "Sobrio"
        },
        {
            "code": "6760",
            "localite": "Calpiogna"
        },
        {
            "code": "6760",
            "localite": "Campello"
        },
        {
            "code": "6760",
            "localite": "Carì"
        },
        {
            "code": "6760",
            "localite": "Faido"
        },
        {
            "code": "6760",
            "localite": "Molare"
        },
        {
            "code": "6760",
            "localite": "Rossura"
        },
        {
            "code": "6763",
            "localite": "Mairengo"
        },
        {
            "code": "6763",
            "localite": "Osco"
        },
        {
            "code": "6764",
            "localite": "Chiggiogna"
        },
        {
            "code": "6772",
            "localite": "Rodi-Fiesso"
        },
        {
            "code": "6773",
            "localite": "Prato (Leventina)"
        },
        {
            "code": "6774",
            "localite": "Dalpe"
        },
        {
            "code": "6775",
            "localite": "Ambrì"
        },
        {
            "code": "6776",
            "localite": "Piotta"
        },
        {
            "code": "6777",
            "localite": "Quinto"
        },
        {
            "code": "6780",
            "localite": "Airolo"
        },
        {
            "code": "6781",
            "localite": "Bedretto"
        },
        {
            "code": "6781",
            "localite": "Villa Bedretto"
        },
        {
            "code": "6802",
            "localite": "Rivera"
        },
        {
            "code": "6803",
            "localite": "Camignolo"
        },
        {
            "code": "6804",
            "localite": "Bironico"
        },
        {
            "code": "6805",
            "localite": "Mezzovico"
        },
        {
            "code": "6806",
            "localite": "Sigirino"
        },
        {
            "code": "6807",
            "localite": "Taverne"
        },
        {
            "code": "6808",
            "localite": "Torricella"
        },
        {
            "code": "6809",
            "localite": "Medeglia"
        },
        {
            "code": "6810",
            "localite": "Isone"
        },
        {
            "code": "6814",
            "localite": "Cadempino"
        },
        {
            "code": "6814",
            "localite": "Lamone"
        },
        {
            "code": "6815",
            "localite": "Melide"
        },
        {
            "code": "6816",
            "localite": "Bissone"
        },
        {
            "code": "6817",
            "localite": "Maroggia"
        },
        {
            "code": "6818",
            "localite": "Melano"
        },
        {
            "code": "6821",
            "localite": "Rovio"
        },
        {
            "code": "6822",
            "localite": "Arogno"
        },
        {
            "code": "6823",
            "localite": "Pugerna"
        },
        {
            "code": "6825",
            "localite": "Capolago"
        },
        {
            "code": "6826",
            "localite": "Riva San Vitale"
        },
        {
            "code": "6827",
            "localite": "Brusino Arsizio"
        },
        {
            "code": "6828",
            "localite": "Balerna"
        },
        {
            "code": "6830",
            "localite": "Chiasso"
        },
        {
            "code": "6832",
            "localite": "Pedrinate"
        },
        {
            "code": "6832",
            "localite": "Seseglio"
        },
        {
            "code": "6833",
            "localite": "Vacallo"
        },
        {
            "code": "6834",
            "localite": "Morbio Inferiore"
        },
        {
            "code": "6835",
            "localite": "Morbio Superiore"
        },
        {
            "code": "6837",
            "localite": "Bruzella"
        },
        {
            "code": "6837",
            "localite": "Caneggio"
        },
        {
            "code": "6838",
            "localite": "Cabbio"
        },
        {
            "code": "6838",
            "localite": "Muggio"
        },
        {
            "code": "6839",
            "localite": "Sagno"
        },
        {
            "code": "6850",
            "localite": "Mendrisio"
        },
        {
            "code": "6852",
            "localite": "Genestrerio"
        },
        {
            "code": "6853",
            "localite": "Ligornetto"
        },
        {
            "code": "6854",
            "localite": "S. Pietro"
        },
        {
            "code": "6855",
            "localite": "Stabio"
        },
        {
            "code": "6862",
            "localite": "Rancate"
        },
        {
            "code": "6863",
            "localite": "Besazio"
        },
        {
            "code": "6864",
            "localite": "Arzo"
        },
        {
            "code": "6865",
            "localite": "Tremona"
        },
        {
            "code": "6866",
            "localite": "Meride"
        },
        {
            "code": "6867",
            "localite": "Serpiano"
        },
        {
            "code": "6872",
            "localite": "Salorino"
        },
        {
            "code": "6873",
            "localite": "Corteglia"
        },
        {
            "code": "6874",
            "localite": "Castel San Pietro"
        },
        {
            "code": "6875",
            "localite": "Campora"
        },
        {
            "code": "6875",
            "localite": "Casima"
        },
        {
            "code": "6875",
            "localite": "Monte"
        },
        {
            "code": "6877",
            "localite": "Coldrerio"
        },
        {
            "code": "6883",
            "localite": "Novazzano"
        },
        {
            "code": "6900",
            "localite": "Lugano"
        },
        {
            "code": "6900",
            "localite": "Massagno"
        },
        {
            "code": "6900",
            "localite": "Paradiso"
        },
        {
            "code": "6912",
            "localite": "Pazzallo"
        },
        {
            "code": "6913",
            "localite": "Carabbia"
        },
        {
            "code": "6914",
            "localite": "Carona"
        },
        {
            "code": "6915",
            "localite": "Pambio-Noranco"
        },
        {
            "code": "6916",
            "localite": "Grancia"
        },
        {
            "code": "6917",
            "localite": "Barbengo"
        },
        {
            "code": "6918",
            "localite": "Figino"
        },
        {
            "code": "6919",
            "localite": "Carabietta"
        },
        {
            "code": "6921",
            "localite": "Vico Morcote"
        },
        {
            "code": "6922",
            "localite": "Morcote"
        },
        {
            "code": "6924",
            "localite": "Sorengo"
        },
        {
            "code": "6925",
            "localite": "Gentilino"
        },
        {
            "code": "6926",
            "localite": "Montagnola"
        },
        {
            "code": "6927",
            "localite": "Agra"
        },
        {
            "code": "6928",
            "localite": "Manno"
        },
        {
            "code": "6929",
            "localite": "Gravesano"
        },
        {
            "code": "6930",
            "localite": "Bedano"
        },
        {
            "code": "6932",
            "localite": "Breganzona"
        },
        {
            "code": "6933",
            "localite": "Muzzano"
        },
        {
            "code": "6934",
            "localite": "Bioggio"
        },
        {
            "code": "6935",
            "localite": "Bosco Luganese"
        },
        {
            "code": "6936",
            "localite": "Cademario"
        },
        {
            "code": "6937",
            "localite": "Breno"
        },
        {
            "code": "6938",
            "localite": "Fescoggia"
        },
        {
            "code": "6938",
            "localite": "Vezio"
        },
        {
            "code": "6939",
            "localite": "Arosio"
        },
        {
            "code": "6939",
            "localite": "Mugena"
        },
        {
            "code": "6942",
            "localite": "Savosa"
        },
        {
            "code": "6943",
            "localite": "Vezia"
        },
        {
            "code": "6944",
            "localite": "Cureglia"
        },
        {
            "code": "6945",
            "localite": "Origlio"
        },
        {
            "code": "6946",
            "localite": "Ponte Capriasca"
        },
        {
            "code": "6947",
            "localite": "Vaglio"
        },
        {
            "code": "6948",
            "localite": "Porza"
        },
        {
            "code": "6949",
            "localite": "Comano"
        },
        {
            "code": "6950",
            "localite": "Tesserete"
        },
        {
            "code": "6951",
            "localite": "Bogno"
        },
        {
            "code": "6951",
            "localite": "Colla"
        },
        {
            "code": "6951",
            "localite": "Cozzo"
        },
        {
            "code": "6951",
            "localite": "Insone"
        },
        {
            "code": "6951",
            "localite": "Scareglia"
        },
        {
            "code": "6951",
            "localite": "Signôra"
        },
        {
            "code": "6952",
            "localite": "Canobbio"
        },
        {
            "code": "6953",
            "localite": "Lugaggia"
        },
        {
            "code": "6954",
            "localite": "Bigorio"
        },
        {
            "code": "6954",
            "localite": "Sala Capriasca"
        },
        {
            "code": "6955",
            "localite": "Cagiallo"
        },
        {
            "code": "6955",
            "localite": "Oggio"
        },
        {
            "code": "6956",
            "localite": "Lopagno"
        },
        {
            "code": "6957",
            "localite": "Roveredo TI"
        },
        {
            "code": "6958",
            "localite": "Bidogno"
        },
        {
            "code": "6958",
            "localite": "Corticiasca"
        },
        {
            "code": "6959",
            "localite": "Certara"
        },
        {
            "code": "6959",
            "localite": "Cimadera"
        },
        {
            "code": "6959",
            "localite": "Curtina"
        },
        {
            "code": "6959",
            "localite": "Maglio di Colla"
        },
        {
            "code": "6959",
            "localite": "Piandera Paese"
        },
        {
            "code": "6960",
            "localite": "Odogno"
        },
        {
            "code": "6962",
            "localite": "Viganello"
        },
        {
            "code": "6963",
            "localite": "Cureggia"
        },
        {
            "code": "6963",
            "localite": "Pregassona"
        },
        {
            "code": "6964",
            "localite": "Davesco-Soragno"
        },
        {
            "code": "6965",
            "localite": "Cadro"
        },
        {
            "code": "6966",
            "localite": "Villa Luganese"
        },
        {
            "code": "6967",
            "localite": "Dino"
        },
        {
            "code": "6968",
            "localite": "Sonvico"
        },
        {
            "code": "6974",
            "localite": "Aldesago"
        },
        {
            "code": "6976",
            "localite": "Castagnola"
        },
        {
            "code": "6977",
            "localite": "Ruvigliana"
        },
        {
            "code": "6978",
            "localite": "Gandria"
        },
        {
            "code": "6979",
            "localite": "Brè sopra Lugano"
        },
        {
            "code": "6980",
            "localite": "Castelrotto"
        },
        {
            "code": "6981",
            "localite": "Banco"
        },
        {
            "code": "6981",
            "localite": "Bedigliora"
        },
        {
            "code": "6981",
            "localite": "Beride di Bedigliora"
        },
        {
            "code": "6981",
            "localite": "Bombinasco"
        },
        {
            "code": "6982",
            "localite": "Agno"
        },
        {
            "code": "6983",
            "localite": "Magliaso"
        },
        {
            "code": "6984",
            "localite": "Pura"
        },
        {
            "code": "6986",
            "localite": "Curio"
        },
        {
            "code": "6986",
            "localite": "Miglieglia"
        },
        {
            "code": "6986",
            "localite": "Novaggio"
        },
        {
            "code": "6987",
            "localite": "Caslano"
        },
        {
            "code": "6988",
            "localite": "Ponte Tresa"
        },
        {
            "code": "6989",
            "localite": "Purasca"
        },
        {
            "code": "6990",
            "localite": "Cassina d'Agno"
        },
        {
            "code": "6991",
            "localite": "Neggio"
        },
        {
            "code": "6992",
            "localite": "Cimo"
        },
        {
            "code": "6992",
            "localite": "Vernate"
        },
        {
            "code": "6993",
            "localite": "Iseo"
        },
        {
            "code": "6994",
            "localite": "Aranno"
        },
        {
            "code": "6995",
            "localite": "Madonna del Piano"
        },
        {
            "code": "6997",
            "localite": "Sessa"
        },
        {
            "code": "6998",
            "localite": "Monteggio"
        },
        {
            "code": "6999",
            "localite": "Astano"
        },
        {
            "code": "7000",
            "localite": "Chur"
        },
        {
            "code": "7012",
            "localite": "Felsberg"
        },
        {
            "code": "7013",
            "localite": "Domat/Ems"
        },
        {
            "code": "7014",
            "localite": "Trin"
        },
        {
            "code": "7015",
            "localite": "Tamins"
        },
        {
            "code": "7016",
            "localite": "Trin Mulin"
        },
        {
            "code": "7017",
            "localite": "Flims Dorf"
        },
        {
            "code": "7018",
            "localite": "Flims Waldhaus"
        },
        {
            "code": "7019",
            "localite": "Fidaz"
        },
        {
            "code": "7023",
            "localite": "Haldenstein"
        },
        {
            "code": "7026",
            "localite": "Maladers"
        },
        {
            "code": "7027",
            "localite": "Calfreisen"
        },
        {
            "code": "7027",
            "localite": "Castiel"
        },
        {
            "code": "7027",
            "localite": "Lüen"
        },
        {
            "code": "7028",
            "localite": "Pagig"
        },
        {
            "code": "7028",
            "localite": "St. Peter"
        },
        {
            "code": "7029",
            "localite": "Peist"
        },
        {
            "code": "7031",
            "localite": "Laax GR"
        },
        {
            "code": "7032",
            "localite": "Laax GR 2"
        },
        {
            "code": "7050",
            "localite": "Arosa"
        },
        {
            "code": "7056",
            "localite": "Molinis"
        },
        {
            "code": "7057",
            "localite": "Langwies"
        },
        {
            "code": "7058",
            "localite": "Litzirüti"
        },
        {
            "code": "7062",
            "localite": "Passugg"
        },
        {
            "code": "7063",
            "localite": "Praden"
        },
        {
            "code": "7064",
            "localite": "Tschiertschen"
        },
        {
            "code": "7074",
            "localite": "Malix"
        },
        {
            "code": "7075",
            "localite": "Churwalden"
        },
        {
            "code": "7076",
            "localite": "Parpan"
        },
        {
            "code": "7077",
            "localite": "Valbella"
        },
        {
            "code": "7078",
            "localite": "Lenzerheide/Lai"
        },
        {
            "code": "7082",
            "localite": "Vaz/Obervaz"
        },
        {
            "code": "7083",
            "localite": "Lantsch/Lenz"
        },
        {
            "code": "7084",
            "localite": "Brienz/Brinzauls GR"
        },
        {
            "code": "7104",
            "localite": "Versam"
        },
        {
            "code": "7106",
            "localite": "Tenna"
        },
        {
            "code": "7107",
            "localite": "Safien Platz"
        },
        {
            "code": "7109",
            "localite": "Thalkirch"
        },
        {
            "code": "7110",
            "localite": "Peiden"
        },
        {
            "code": "7111",
            "localite": "Pitasch"
        },
        {
            "code": "7112",
            "localite": "Duvin"
        },
        {
            "code": "7113",
            "localite": "Camuns"
        },
        {
            "code": "7114",
            "localite": "Uors (Lumnezia)"
        },
        {
            "code": "7115",
            "localite": "Surcasti"
        },
        {
            "code": "7116",
            "localite": "St. Martin (Lugnez)"
        },
        {
            "code": "7116",
            "localite": "Tersnaus"
        },
        {
            "code": "7122",
            "localite": "Valendas"
        },
        {
            "code": "7126",
            "localite": "Castrisch"
        },
        {
            "code": "7127",
            "localite": "Sevgein"
        },
        {
            "code": "7128",
            "localite": "Riein"
        },
        {
            "code": "7130",
            "localite": "Ilanz"
        },
        {
            "code": "7130",
            "localite": "Schnaus"
        },
        {
            "code": "7132",
            "localite": "Vals"
        },
        {
            "code": "7134",
            "localite": "Obersaxen"
        },
        {
            "code": "7137",
            "localite": "Flond"
        },
        {
            "code": "7138",
            "localite": "Surcuolm"
        },
        {
            "code": "7141",
            "localite": "Luven"
        },
        {
            "code": "7142",
            "localite": "Cumbel"
        },
        {
            "code": "7143",
            "localite": "Morissen"
        },
        {
            "code": "7144",
            "localite": "Vella"
        },
        {
            "code": "7145",
            "localite": "Degen"
        },
        {
            "code": "7146",
            "localite": "Vattiz"
        },
        {
            "code": "7147",
            "localite": "Vignogn"
        },
        {
            "code": "7148",
            "localite": "Lumbrein"
        },
        {
            "code": "7149",
            "localite": "Vrin"
        },
        {
            "code": "7151",
            "localite": "Schluein"
        },
        {
            "code": "7152",
            "localite": "Sagogn"
        },
        {
            "code": "7153",
            "localite": "Falera"
        },
        {
            "code": "7154",
            "localite": "Ruschein"
        },
        {
            "code": "7155",
            "localite": "Ladir"
        },
        {
            "code": "7156",
            "localite": "Pigniu"
        },
        {
            "code": "7156",
            "localite": "Rueun"
        },
        {
            "code": "7157",
            "localite": "Siat"
        },
        {
            "code": "7158",
            "localite": "Waltensburg/Vuorz"
        },
        {
            "code": "7159",
            "localite": "Andiast"
        },
        {
            "code": "7162",
            "localite": "Tavanasa"
        },
        {
            "code": "7163",
            "localite": "Danis"
        },
        {
            "code": "7164",
            "localite": "Dardin"
        },
        {
            "code": "7165",
            "localite": "Breil/Brigels"
        },
        {
            "code": "7166",
            "localite": "Trun"
        },
        {
            "code": "7167",
            "localite": "Zignau"
        },
        {
            "code": "7168",
            "localite": "Schlans"
        },
        {
            "code": "7172",
            "localite": "Rabius"
        },
        {
            "code": "7173",
            "localite": "Surrein"
        },
        {
            "code": "7174",
            "localite": "S. Benedetg"
        },
        {
            "code": "7175",
            "localite": "Sumvitg"
        },
        {
            "code": "7176",
            "localite": "Cumpadials"
        },
        {
            "code": "7180",
            "localite": "Disentis/Mustér"
        },
        {
            "code": "7182",
            "localite": "Cavardiras"
        },
        {
            "code": "7183",
            "localite": "Mumpé Medel"
        },
        {
            "code": "7184",
            "localite": "Curaglia"
        },
        {
            "code": "7185",
            "localite": "Platta"
        },
        {
            "code": "7186",
            "localite": "Segnas"
        },
        {
            "code": "7187",
            "localite": "Camischolas"
        },
        {
            "code": "7188",
            "localite": "Sedrun"
        },
        {
            "code": "7189",
            "localite": "Rueras"
        },
        {
            "code": "7202",
            "localite": "Says"
        },
        {
            "code": "7203",
            "localite": "Trimmis"
        },
        {
            "code": "7204",
            "localite": "Untervaz"
        },
        {
            "code": "7205",
            "localite": "Zizers"
        },
        {
            "code": "7206",
            "localite": "Igis"
        },
        {
            "code": "7208",
            "localite": "Malans GR"
        },
        {
            "code": "7212",
            "localite": "Seewis Dorf"
        },
        {
            "code": "7212",
            "localite": "Seewis-Pardisla"
        },
        {
            "code": "7212",
            "localite": "Seewis-Schmitten"
        },
        {
            "code": "7213",
            "localite": "Valzeina"
        },
        {
            "code": "7214",
            "localite": "Grüsch"
        },
        {
            "code": "7215",
            "localite": "Fanas"
        },
        {
            "code": "7220",
            "localite": "Schiers"
        },
        {
            "code": "7222",
            "localite": "Lunden"
        },
        {
            "code": "7223",
            "localite": "Buchen im Prättigau"
        },
        {
            "code": "7224",
            "localite": "Putz"
        },
        {
            "code": "7226",
            "localite": "Fajauna"
        },
        {
            "code": "7226",
            "localite": "Stels"
        },
        {
            "code": "7228",
            "localite": "Pusserein"
        },
        {
            "code": "7228",
            "localite": "Schuders"
        },
        {
            "code": "7231",
            "localite": "Pragg-Jenaz"
        },
        {
            "code": "7232",
            "localite": "Furna"
        },
        {
            "code": "7233",
            "localite": "Jenaz"
        },
        {
            "code": "7235",
            "localite": "Fideris"
        },
        {
            "code": "7240",
            "localite": "Küblis"
        },
        {
            "code": "7241",
            "localite": "Conters im Prättigau"
        },
        {
            "code": "7242",
            "localite": "Luzein"
        },
        {
            "code": "7243",
            "localite": "Pany"
        },
        {
            "code": "7244",
            "localite": "Gadenstätt"
        },
        {
            "code": "7245",
            "localite": "Ascharina"
        },
        {
            "code": "7246",
            "localite": "St. Antönien"
        },
        {
            "code": "7247",
            "localite": "Saas im Prättigau"
        },
        {
            "code": "7249",
            "localite": "Serneus"
        },
        {
            "code": "7250",
            "localite": "Klosters"
        },
        {
            "code": "7252",
            "localite": "Klosters Dorf"
        },
        {
            "code": "7260",
            "localite": "Davos Dorf"
        },
        {
            "code": "7265",
            "localite": "Davos Wolfgang"
        },
        {
            "code": "7270",
            "localite": "Davos Platz"
        },
        {
            "code": "7272",
            "localite": "Davos Clavadel"
        },
        {
            "code": "7276",
            "localite": "Davos Frauenkirch"
        },
        {
            "code": "7277",
            "localite": "Davos Glaris"
        },
        {
            "code": "7278",
            "localite": "Davos Monstein"
        },
        {
            "code": "7302",
            "localite": "Landquart"
        },
        {
            "code": "7303",
            "localite": "Mastrils"
        },
        {
            "code": "7304",
            "localite": "Maienfeld"
        },
        {
            "code": "7306",
            "localite": "Fläsch"
        },
        {
            "code": "7307",
            "localite": "Jenins"
        },
        {
            "code": "7310",
            "localite": "Bad Ragaz"
        },
        {
            "code": "7312",
            "localite": "Pfäfers"
        },
        {
            "code": "7313",
            "localite": "St. Margrethenberg"
        },
        {
            "code": "7314",
            "localite": "Vadura"
        },
        {
            "code": "7315",
            "localite": "Vättis"
        },
        {
            "code": "7317",
            "localite": "Valens"
        },
        {
            "code": "7317",
            "localite": "Vasön"
        },
        {
            "code": "7320",
            "localite": "Sargans"
        },
        {
            "code": "7323",
            "localite": "Wangs"
        },
        {
            "code": "7324",
            "localite": "Vilters"
        },
        {
            "code": "7325",
            "localite": "Schwendi im Weisstannental"
        },
        {
            "code": "7326",
            "localite": "Weisstannen"
        },
        {
            "code": "7402",
            "localite": "Bonaduz"
        },
        {
            "code": "7403",
            "localite": "Rhäzüns"
        },
        {
            "code": "7404",
            "localite": "Feldis/Veulden"
        },
        {
            "code": "7405",
            "localite": "Rothenbrunnen"
        },
        {
            "code": "7407",
            "localite": "Trans"
        },
        {
            "code": "7408",
            "localite": "Cazis"
        },
        {
            "code": "7411",
            "localite": "Sils im Domleschg"
        },
        {
            "code": "7412",
            "localite": "Scharans"
        },
        {
            "code": "7413",
            "localite": "Fürstenaubruck"
        },
        {
            "code": "7414",
            "localite": "Fürstenau"
        },
        {
            "code": "7415",
            "localite": "Pratval"
        },
        {
            "code": "7415",
            "localite": "Rodels"
        },
        {
            "code": "7416",
            "localite": "Almens"
        },
        {
            "code": "7417",
            "localite": "Paspels"
        },
        {
            "code": "7418",
            "localite": "Tumegl/Tomils"
        },
        {
            "code": "7419",
            "localite": "Scheid"
        },
        {
            "code": "7421",
            "localite": "Summaprada"
        },
        {
            "code": "7422",
            "localite": "Tartar"
        },
        {
            "code": "7423",
            "localite": "Portein"
        },
        {
            "code": "7423",
            "localite": "Sarn"
        },
        {
            "code": "7424",
            "localite": "Dalin"
        },
        {
            "code": "7424",
            "localite": "Präz"
        },
        {
            "code": "7425",
            "localite": "Masein"
        },
        {
            "code": "7426",
            "localite": "Flerden"
        },
        {
            "code": "7427",
            "localite": "Urmein"
        },
        {
            "code": "7428",
            "localite": "Tschappina"
        },
        {
            "code": "7430",
            "localite": "Rongellen"
        },
        {
            "code": "7430",
            "localite": "Thusis"
        },
        {
            "code": "7431",
            "localite": "Mutten"
        },
        {
            "code": "7431",
            "localite": "Obermutten"
        },
        {
            "code": "7432",
            "localite": "Zillis"
        },
        {
            "code": "7433",
            "localite": "Donat"
        },
        {
            "code": "7433",
            "localite": "Lohn GR"
        },
        {
            "code": "7433",
            "localite": "Mathon"
        },
        {
            "code": "7433",
            "localite": "Wergenstein"
        },
        {
            "code": "7434",
            "localite": "Sufers"
        },
        {
            "code": "7435",
            "localite": "Splügen"
        },
        {
            "code": "7436",
            "localite": "Medels im Rheinwald"
        },
        {
            "code": "7437",
            "localite": "Nufenen"
        },
        {
            "code": "7438",
            "localite": "Hinterrhein"
        },
        {
            "code": "7440",
            "localite": "Andeer"
        },
        {
            "code": "7442",
            "localite": "Clugin"
        },
        {
            "code": "7443",
            "localite": "Pignia"
        },
        {
            "code": "7444",
            "localite": "Ausserferrera"
        },
        {
            "code": "7445",
            "localite": "Innerferrera"
        },
        {
            "code": "7447",
            "localite": "Avers"
        },
        {
            "code": "7448",
            "localite": "Juf"
        },
        {
            "code": "7450",
            "localite": "Tiefencastel"
        },
        {
            "code": "7451",
            "localite": "Alvaschein"
        },
        {
            "code": "7452",
            "localite": "Cunter"
        },
        {
            "code": "7453",
            "localite": "Tinizong"
        },
        {
            "code": "7454",
            "localite": "Rona"
        },
        {
            "code": "7455",
            "localite": "Mulegns"
        },
        {
            "code": "7456",
            "localite": "Marmorera"
        },
        {
            "code": "7456",
            "localite": "Sur"
        },
        {
            "code": "7457",
            "localite": "Bivio"
        },
        {
            "code": "7458",
            "localite": "Mon"
        },
        {
            "code": "7459",
            "localite": "Stierva"
        },
        {
            "code": "7460",
            "localite": "Savognin"
        },
        {
            "code": "7462",
            "localite": "Salouf"
        },
        {
            "code": "7463",
            "localite": "Riom"
        },
        {
            "code": "7464",
            "localite": "Parsonz"
        },
        {
            "code": "7472",
            "localite": "Surava"
        },
        {
            "code": "7473",
            "localite": "Alvaneu Bad"
        },
        {
            "code": "7477",
            "localite": "Filisur"
        },
        {
            "code": "7482",
            "localite": "Bergün/Bravuogn"
        },
        {
            "code": "7482",
            "localite": "Preda"
        },
        {
            "code": "7482",
            "localite": "Stugl/Stuls"
        },
        {
            "code": "7484",
            "localite": "Latsch"
        },
        {
            "code": "7492",
            "localite": "Alvaneu Dorf"
        },
        {
            "code": "7493",
            "localite": "Schmitten (Albula)"
        },
        {
            "code": "7494",
            "localite": "Davos Wiesen"
        },
        {
            "code": "7500",
            "localite": "St. Moritz"
        },
        {
            "code": "7502",
            "localite": "Bever"
        },
        {
            "code": "7503",
            "localite": "Samedan"
        },
        {
            "code": "7504",
            "localite": "Pontresina"
        },
        {
            "code": "7505",
            "localite": "Celerina/Schlarigna"
        },
        {
            "code": "7512",
            "localite": "Champfèr"
        },
        {
            "code": "7513",
            "localite": "Silvaplana"
        },
        {
            "code": "7513",
            "localite": "Silvaplana-Surlej"
        },
        {
            "code": "7514",
            "localite": "Fex"
        },
        {
            "code": "7514",
            "localite": "Sils/Segl Maria"
        },
        {
            "code": "7515",
            "localite": "Sils/Segl Baselgia"
        },
        {
            "code": "7516",
            "localite": "Maloja"
        },
        {
            "code": "7517",
            "localite": "Plaun da Lej"
        },
        {
            "code": "7522",
            "localite": "La Punt Chamues-ch"
        },
        {
            "code": "7523",
            "localite": "Madulain"
        },
        {
            "code": "7524",
            "localite": "Zuoz"
        },
        {
            "code": "7525",
            "localite": "S-chanf"
        },
        {
            "code": "7526",
            "localite": "Chapella"
        },
        {
            "code": "7526",
            "localite": "Cinuos-chel"
        },
        {
            "code": "7527",
            "localite": "Brail"
        },
        {
            "code": "7530",
            "localite": "Zernez"
        },
        {
            "code": "7532",
            "localite": "Tschierv"
        },
        {
            "code": "7533",
            "localite": "Fuldera"
        },
        {
            "code": "7534",
            "localite": "Lü"
        },
        {
            "code": "7535",
            "localite": "Valchava"
        },
        {
            "code": "7536",
            "localite": "Sta. Maria Val Müstair"
        },
        {
            "code": "7537",
            "localite": "Müstair"
        },
        {
            "code": "7542",
            "localite": "Susch"
        },
        {
            "code": "7543",
            "localite": "Lavin"
        },
        {
            "code": "7545",
            "localite": "Guarda"
        },
        {
            "code": "7546",
            "localite": "Ardez"
        },
        {
            "code": "7550",
            "localite": "Scuol"
        },
        {
            "code": "7551",
            "localite": "Ftan"
        },
        {
            "code": "7552",
            "localite": "Vulpera"
        },
        {
            "code": "7553",
            "localite": "Tarasp"
        },
        {
            "code": "7554",
            "localite": "Sent"
        },
        {
            "code": "7556",
            "localite": "Ramosch"
        },
        {
            "code": "7557",
            "localite": "Vnà"
        },
        {
            "code": "7558",
            "localite": "Strada"
        },
        {
            "code": "7559",
            "localite": "Tschlin"
        },
        {
            "code": "7560",
            "localite": "Martina"
        },
        {
            "code": "7562",
            "localite": "Samnaun-Compatsch"
        },
        {
            "code": "7563",
            "localite": "Samnaun Dorf"
        },
        {
            "code": "7602",
            "localite": "Casaccia"
        },
        {
            "code": "7603",
            "localite": "Vicosoprano"
        },
        {
            "code": "7604",
            "localite": "Borgonovo"
        },
        {
            "code": "7605",
            "localite": "Stampa"
        },
        {
            "code": "7606",
            "localite": "Bondo"
        },
        {
            "code": "7606",
            "localite": "Promontogno"
        },
        {
            "code": "7608",
            "localite": "Castasegna"
        },
        {
            "code": "7610",
            "localite": "Soglio"
        },
        {
            "code": "7710",
            "localite": "Alp Grüm"
        },
        {
            "code": "7710",
            "localite": "Ospizio Bernina"
        },
        {
            "code": "7741",
            "localite": "S. Carlo (Poschiavo)"
        },
        {
            "code": "7742",
            "localite": "La Rösa"
        },
        {
            "code": "7742",
            "localite": "Poschiavo"
        },
        {
            "code": "7742",
            "localite": "Sfazù"
        },
        {
            "code": "7743",
            "localite": "Brusio"
        },
        {
            "code": "7743",
            "localite": "Miralago"
        },
        {
            "code": "7744",
            "localite": "Campocologno"
        },
        {
            "code": "7745",
            "localite": "Li Curt"
        },
        {
            "code": "7746",
            "localite": "Le Prese"
        },
        {
            "code": "7747",
            "localite": "Viano"
        },
        {
            "code": "7748",
            "localite": "Campascio"
        },
        {
            "code": "8001",
            "localite": "Zürich"
        },
        {
            "code": "8002",
            "localite": "Zürich"
        },
        {
            "code": "8003",
            "localite": "Zürich"
        },
        {
            "code": "8004",
            "localite": "Zürich"
        },
        {
            "code": "8005",
            "localite": "Zürich"
        },
        {
            "code": "8006",
            "localite": "Zürich"
        },
        {
            "code": "8008",
            "localite": "Zürich"
        },
        {
            "code": "8032",
            "localite": "Zürich"
        },
        {
            "code": "8037",
            "localite": "Zürich"
        },
        {
            "code": "8038",
            "localite": "Zürich"
        },
        {
            "code": "8041",
            "localite": "Zürich"
        },
        {
            "code": "8044",
            "localite": "Gockhausen"
        },
        {
            "code": "8044",
            "localite": "Zürich"
        },
        {
            "code": "8045",
            "localite": "Zürich"
        },
        {
            "code": "8046",
            "localite": "Zürich"
        },
        {
            "code": "8047",
            "localite": "Zürich"
        },
        {
            "code": "8048",
            "localite": "Zürich"
        },
        {
            "code": "8049",
            "localite": "Zürich"
        },
        {
            "code": "8050",
            "localite": "Zürich"
        },
        {
            "code": "8051",
            "localite": "Zürich"
        },
        {
            "code": "8052",
            "localite": "Zürich"
        },
        {
            "code": "8053",
            "localite": "Zürich"
        },
        {
            "code": "8055",
            "localite": "Zürich"
        },
        {
            "code": "8057",
            "localite": "Zürich"
        },
        {
            "code": "8064",
            "localite": "Zürich"
        },
        {
            "code": "8102",
            "localite": "Oberengstringen"
        },
        {
            "code": "8103",
            "localite": "Unterengstringen"
        },
        {
            "code": "8104",
            "localite": "Weiningen ZH"
        },
        {
            "code": "8105",
            "localite": "Regensdorf"
        },
        {
            "code": "8105",
            "localite": "Watt"
        },
        {
            "code": "8106",
            "localite": "Adlikon b. Regensdorf"
        },
        {
            "code": "8107",
            "localite": "Buchs ZH"
        },
        {
            "code": "8108",
            "localite": "Dällikon"
        },
        {
            "code": "8109",
            "localite": "Kloster Fahr"
        },
        {
            "code": "8112",
            "localite": "Otelfingen"
        },
        {
            "code": "8113",
            "localite": "Boppelsen"
        },
        {
            "code": "8114",
            "localite": "Dänikon ZH"
        },
        {
            "code": "8115",
            "localite": "Hüttikon"
        },
        {
            "code": "8117",
            "localite": "Fällanden"
        },
        {
            "code": "8118",
            "localite": "Pfaffhausen"
        },
        {
            "code": "8121",
            "localite": "Benglen"
        },
        {
            "code": "8122",
            "localite": "Binz"
        },
        {
            "code": "8123",
            "localite": "Ebmatingen"
        },
        {
            "code": "8124",
            "localite": "Maur"
        },
        {
            "code": "8125",
            "localite": "Zollikerberg"
        },
        {
            "code": "8126",
            "localite": "Zumikon"
        },
        {
            "code": "8127",
            "localite": "Forch"
        },
        {
            "code": "8132",
            "localite": "Egg b. Zürich"
        },
        {
            "code": "8132",
            "localite": "Hinteregg"
        },
        {
            "code": "8133",
            "localite": "Esslingen"
        },
        {
            "code": "8134",
            "localite": "Adliswil"
        },
        {
            "code": "8135",
            "localite": "Langnau am Albis"
        },
        {
            "code": "8135",
            "localite": "Sihlbrugg Station"
        },
        {
            "code": "8135",
            "localite": "Sihlwald"
        },
        {
            "code": "8136",
            "localite": "Gattikon"
        },
        {
            "code": "8142",
            "localite": "Uitikon Waldegg"
        },
        {
            "code": "8143",
            "localite": "Stallikon"
        },
        {
            "code": "8143",
            "localite": "Uetliberg"
        },
        {
            "code": "8152",
            "localite": "Glattbrugg"
        },
        {
            "code": "8152",
            "localite": "Glattpark (Opfikon)"
        },
        {
            "code": "8152",
            "localite": "Opfikon"
        },
        {
            "code": "8153",
            "localite": "Rümlang"
        },
        {
            "code": "8154",
            "localite": "Oberglatt ZH"
        },
        {
            "code": "8155",
            "localite": "Nassenwil"
        },
        {
            "code": "8155",
            "localite": "Niederhasli"
        },
        {
            "code": "8156",
            "localite": "Oberhasli"
        },
        {
            "code": "8157",
            "localite": "Dielsdorf"
        },
        {
            "code": "8158",
            "localite": "Regensberg"
        },
        {
            "code": "8162",
            "localite": "Steinmaur"
        },
        {
            "code": "8162",
            "localite": "Sünikon"
        },
        {
            "code": "8164",
            "localite": "Bachs"
        },
        {
            "code": "8165",
            "localite": "Oberweningen"
        },
        {
            "code": "8165",
            "localite": "Schleinikon"
        },
        {
            "code": "8165",
            "localite": "Schöfflisdorf"
        },
        {
            "code": "8166",
            "localite": "Niederweningen"
        },
        {
            "code": "8172",
            "localite": "Niederglatt ZH"
        },
        {
            "code": "8173",
            "localite": "Neerach"
        },
        {
            "code": "8174",
            "localite": "Stadel b. Niederglatt"
        },
        {
            "code": "8175",
            "localite": "Windlach"
        },
        {
            "code": "8180",
            "localite": "Bülach"
        },
        {
            "code": "8181",
            "localite": "Höri"
        },
        {
            "code": "8182",
            "localite": "Hochfelden"
        },
        {
            "code": "8184",
            "localite": "Bachenbülach"
        },
        {
            "code": "8185",
            "localite": "Winkel"
        },
        {
            "code": "8187",
            "localite": "Weiach"
        },
        {
            "code": "8192",
            "localite": "Glattfelden"
        },
        {
            "code": "8192",
            "localite": "Zweidlen"
        },
        {
            "code": "8193",
            "localite": "Eglisau"
        },
        {
            "code": "8194",
            "localite": "Hüntwangen"
        },
        {
            "code": "8195",
            "localite": "Wasterkingen"
        },
        {
            "code": "8196",
            "localite": "Wil ZH"
        },
        {
            "code": "8197",
            "localite": "Rafz"
        },
        {
            "code": "8200",
            "localite": "Schaffhausen"
        },
        {
            "code": "8203",
            "localite": "Schaffhausen"
        },
        {
            "code": "8207",
            "localite": "Schaffhausen"
        },
        {
            "code": "8208",
            "localite": "Schaffhausen"
        },
        {
            "code": "8212",
            "localite": "Neuhausen am Rheinfall"
        },
        {
            "code": "8212",
            "localite": "Nohl"
        },
        {
            "code": "8213",
            "localite": "Neunkirch"
        },
        {
            "code": "8214",
            "localite": "Gächlingen"
        },
        {
            "code": "8215",
            "localite": "Hallau"
        },
        {
            "code": "8216",
            "localite": "Oberhallau"
        },
        {
            "code": "8217",
            "localite": "Wilchingen"
        },
        {
            "code": "8218",
            "localite": "Osterfingen"
        },
        {
            "code": "8219",
            "localite": "Trasadingen"
        },
        {
            "code": "8222",
            "localite": "Beringen"
        },
        {
            "code": "8223",
            "localite": "Guntmadingen"
        },
        {
            "code": "8224",
            "localite": "Löhningen"
        },
        {
            "code": "8225",
            "localite": "Siblingen"
        },
        {
            "code": "8226",
            "localite": "Schleitheim"
        },
        {
            "code": "8228",
            "localite": "Beggingen"
        },
        {
            "code": "8231",
            "localite": "Hemmental"
        },
        {
            "code": "8232",
            "localite": "Merishausen"
        },
        {
            "code": "8233",
            "localite": "Bargen SH"
        },
        {
            "code": "8234",
            "localite": "Stetten SH"
        },
        {
            "code": "8235",
            "localite": "Lohn SH"
        },
        {
            "code": "8236",
            "localite": "Büttenhardt"
        },
        {
            "code": "8236",
            "localite": "Opfertshofen SH"
        },
        {
            "code": "8239",
            "localite": "Dörflingen"
        },
        {
            "code": "8240",
            "localite": "Thayngen"
        },
        {
            "code": "8241",
            "localite": "Barzheim"
        },
        {
            "code": "8242",
            "localite": "Bibern SH"
        },
        {
            "code": "8242",
            "localite": "Hofen SH"
        },
        {
            "code": "8243",
            "localite": "Altdorf SH"
        },
        {
            "code": "8245",
            "localite": "Feuerthalen"
        },
        {
            "code": "8246",
            "localite": "Langwiesen"
        },
        {
            "code": "8247",
            "localite": "Flurlingen"
        },
        {
            "code": "8248",
            "localite": "Uhwiesen"
        },
        {
            "code": "8252",
            "localite": "Schlatt TG"
        },
        {
            "code": "8253",
            "localite": "Diessenhofen"
        },
        {
            "code": "8253",
            "localite": "Willisdorf"
        },
        {
            "code": "8254",
            "localite": "Basadingen"
        },
        {
            "code": "8255",
            "localite": "Schlattingen"
        },
        {
            "code": "8259",
            "localite": "Etzwilen"
        },
        {
            "code": "8259",
            "localite": "Kaltenbach"
        },
        {
            "code": "8259",
            "localite": "Rheinklingen"
        },
        {
            "code": "8259",
            "localite": "Wagenhausen"
        },
        {
            "code": "8260",
            "localite": "Stein am Rhein"
        },
        {
            "code": "8261",
            "localite": "Hemishofen"
        },
        {
            "code": "8262",
            "localite": "Ramsen"
        },
        {
            "code": "8263",
            "localite": "Buch SH"
        },
        {
            "code": "8264",
            "localite": "Eschenz"
        },
        {
            "code": "8265",
            "localite": "Mammern"
        },
        {
            "code": "8266",
            "localite": "Steckborn"
        },
        {
            "code": "8267",
            "localite": "Berlingen"
        },
        {
            "code": "8268",
            "localite": "Mannenbach-Salenstein"
        },
        {
            "code": "8268",
            "localite": "Salenstein"
        },
        {
            "code": "8269",
            "localite": "Fruthwilen"
        },
        {
            "code": "8272",
            "localite": "Ermatingen"
        },
        {
            "code": "8273",
            "localite": "Triboltingen"
        },
        {
            "code": "8274",
            "localite": "Gottlieben"
        },
        {
            "code": "8274",
            "localite": "Tägerwilen"
        },
        {
            "code": "8280",
            "localite": "Kreuzlingen"
        },
        {
            "code": "8302",
            "localite": "Kloten"
        },
        {
            "code": "8303",
            "localite": "Bassersdorf"
        },
        {
            "code": "8304",
            "localite": "Wallisellen"
        },
        {
            "code": "8305",
            "localite": "Dietlikon"
        },
        {
            "code": "8306",
            "localite": "Brüttisellen"
        },
        {
            "code": "8307",
            "localite": "Effretikon"
        },
        {
            "code": "8307",
            "localite": "Ottikon b. Kemptthal"
        },
        {
            "code": "8308",
            "localite": "Agasul"
        },
        {
            "code": "8308",
            "localite": "Illnau"
        },
        {
            "code": "8309",
            "localite": "Nürensdorf"
        },
        {
            "code": "8310",
            "localite": "Grafstal"
        },
        {
            "code": "8310",
            "localite": "Kemptthal"
        },
        {
            "code": "8311",
            "localite": "Brütten"
        },
        {
            "code": "8312",
            "localite": "Winterberg ZH"
        },
        {
            "code": "8314",
            "localite": "Kyburg"
        },
        {
            "code": "8315",
            "localite": "Lindau"
        },
        {
            "code": "8317",
            "localite": "Tagelswangen"
        },
        {
            "code": "8320",
            "localite": "Fehraltorf"
        },
        {
            "code": "8322",
            "localite": "Gündisau"
        },
        {
            "code": "8322",
            "localite": "Madetswil"
        },
        {
            "code": "8330",
            "localite": "Pfäffikon ZH"
        },
        {
            "code": "8331",
            "localite": "Auslikon"
        },
        {
            "code": "8332",
            "localite": "Rumlikon"
        },
        {
            "code": "8332",
            "localite": "Russikon"
        },
        {
            "code": "8335",
            "localite": "Hittnau"
        },
        {
            "code": "8340",
            "localite": "Hinwil"
        },
        {
            "code": "8342",
            "localite": "Wernetshausen"
        },
        {
            "code": "8344",
            "localite": "Bäretswil"
        },
        {
            "code": "8345",
            "localite": "Adetswil"
        },
        {
            "code": "8352",
            "localite": "Elsau"
        },
        {
            "code": "8352",
            "localite": "Ricketwil (Winterthur)"
        },
        {
            "code": "8353",
            "localite": "Elgg"
        },
        {
            "code": "8354",
            "localite": "Dickbuch"
        },
        {
            "code": "8354",
            "localite": "Hofstetten ZH"
        },
        {
            "code": "8355",
            "localite": "Aadorf"
        },
        {
            "code": "8356",
            "localite": "Ettenhausen TG"
        },
        {
            "code": "8357",
            "localite": "Guntershausen b. Aadorf"
        },
        {
            "code": "8360",
            "localite": "Eschlikon TG"
        },
        {
            "code": "8360",
            "localite": "Wallenwil"
        },
        {
            "code": "8362",
            "localite": "Balterswil"
        },
        {
            "code": "8363",
            "localite": "Bichelsee"
        },
        {
            "code": "8370",
            "localite": "Sirnach"
        },
        {
            "code": "8371",
            "localite": "Busswil TG"
        },
        {
            "code": "8372",
            "localite": "Wiezikon b. Sirnach"
        },
        {
            "code": "8374",
            "localite": "Dussnang"
        },
        {
            "code": "8374",
            "localite": "Oberwangen TG"
        },
        {
            "code": "8376",
            "localite": "Au TG"
        },
        {
            "code": "8376",
            "localite": "Fischingen"
        },
        {
            "code": "8400",
            "localite": "Winterthur"
        },
        {
            "code": "8404",
            "localite": "Reutlingen (Winterthur)"
        },
        {
            "code": "8404",
            "localite": "Stadel (Winterthur)"
        },
        {
            "code": "8404",
            "localite": "Winterthur"
        },
        {
            "code": "8405",
            "localite": "Winterthur"
        },
        {
            "code": "8406",
            "localite": "Winterthur"
        },
        {
            "code": "8408",
            "localite": "Winterthur"
        },
        {
            "code": "8409",
            "localite": "Winterthur"
        },
        {
            "code": "8412",
            "localite": "Aesch (Neftenbach)"
        },
        {
            "code": "8412",
            "localite": "Hünikon (Neftenbach)"
        },
        {
            "code": "8412",
            "localite": "Riet (Neftenbach)"
        },
        {
            "code": "8413",
            "localite": "Neftenbach"
        },
        {
            "code": "8414",
            "localite": "Buch am Irchel"
        },
        {
            "code": "8415",
            "localite": "Berg am Irchel"
        },
        {
            "code": "8415",
            "localite": "Gräslikon"
        },
        {
            "code": "8416",
            "localite": "Flaach"
        },
        {
            "code": "8418",
            "localite": "Schlatt ZH"
        },
        {
            "code": "8421",
            "localite": "Dättlikon"
        },
        {
            "code": "8422",
            "localite": "Pfungen"
        },
        {
            "code": "8424",
            "localite": "Embrach"
        },
        {
            "code": "8425",
            "localite": "Oberembrach"
        },
        {
            "code": "8426",
            "localite": "Lufingen"
        },
        {
            "code": "8427",
            "localite": "Freienstein"
        },
        {
            "code": "8427",
            "localite": "Rorbas"
        },
        {
            "code": "8428",
            "localite": "Teufen ZH"
        },
        {
            "code": "8442",
            "localite": "Hettlingen"
        },
        {
            "code": "8444",
            "localite": "Henggart"
        },
        {
            "code": "8447",
            "localite": "Dachsen"
        },
        {
            "code": "8450",
            "localite": "Andelfingen"
        },
        {
            "code": "8451",
            "localite": "Kleinandelfingen"
        },
        {
            "code": "8452",
            "localite": "Adlikon b. Andelfingen"
        },
        {
            "code": "8453",
            "localite": "Alten"
        },
        {
            "code": "8454",
            "localite": "Buchberg"
        },
        {
            "code": "8455",
            "localite": "Rüdlingen"
        },
        {
            "code": "8457",
            "localite": "Humlikon"
        },
        {
            "code": "8458",
            "localite": "Dorf"
        },
        {
            "code": "8459",
            "localite": "Volken"
        },
        {
            "code": "8460",
            "localite": "Marthalen"
        },
        {
            "code": "8461",
            "localite": "Oerlingen"
        },
        {
            "code": "8462",
            "localite": "Rheinau"
        },
        {
            "code": "8463",
            "localite": "Benken ZH"
        },
        {
            "code": "8464",
            "localite": "Ellikon am Rhein"
        },
        {
            "code": "8465",
            "localite": "Rudolfingen"
        },
        {
            "code": "8465",
            "localite": "Wildensbuch"
        },
        {
            "code": "8466",
            "localite": "Trüllikon"
        },
        {
            "code": "8467",
            "localite": "Truttikon"
        },
        {
            "code": "8468",
            "localite": "Guntalingen"
        },
        {
            "code": "8468",
            "localite": "Waltalingen"
        },
        {
            "code": "8471",
            "localite": "Berg (Dägerlen)"
        },
        {
            "code": "8471",
            "localite": "Bänk (Dägerlen)"
        },
        {
            "code": "8471",
            "localite": "Dägerlen"
        },
        {
            "code": "8471",
            "localite": "Oberwil (Dägerlen)"
        },
        {
            "code": "8471",
            "localite": "Rutschwil (Dägerlen)"
        },
        {
            "code": "8472",
            "localite": "Oberohringen"
        },
        {
            "code": "8472",
            "localite": "Seuzach"
        },
        {
            "code": "8472",
            "localite": "Unterohringen"
        },
        {
            "code": "8474",
            "localite": "Dinhard"
        },
        {
            "code": "8475",
            "localite": "Ossingen"
        },
        {
            "code": "8476",
            "localite": "Unterstammheim"
        },
        {
            "code": "8477",
            "localite": "Oberstammheim"
        },
        {
            "code": "8478",
            "localite": "Thalheim an der Thur"
        },
        {
            "code": "8479",
            "localite": "Altikon"
        },
        {
            "code": "8482",
            "localite": "Sennhof (Winterthur)"
        },
        {
            "code": "8483",
            "localite": "Kollbrunn"
        },
        {
            "code": "8484",
            "localite": "Neschwil"
        },
        {
            "code": "8484",
            "localite": "Theilingen"
        },
        {
            "code": "8484",
            "localite": "Weisslingen"
        },
        {
            "code": "8486",
            "localite": "Rikon im Tösstal"
        },
        {
            "code": "8487",
            "localite": "Rämismühle"
        },
        {
            "code": "8487",
            "localite": "Zell ZH"
        },
        {
            "code": "8488",
            "localite": "Turbenthal"
        },
        {
            "code": "8489",
            "localite": "Ehrikon"
        },
        {
            "code": "8489",
            "localite": "Schalchen"
        },
        {
            "code": "8489",
            "localite": "Wildberg"
        },
        {
            "code": "8492",
            "localite": "Wila"
        },
        {
            "code": "8493",
            "localite": "Saland"
        },
        {
            "code": "8494",
            "localite": "Bauma"
        },
        {
            "code": "8495",
            "localite": "Schmidrüti"
        },
        {
            "code": "8496",
            "localite": "Steg im Tösstal"
        },
        {
            "code": "8497",
            "localite": "Fischenthal"
        },
        {
            "code": "8498",
            "localite": "Gibswil"
        },
        {
            "code": "8499",
            "localite": "Sternenberg"
        },
        {
            "code": "8500",
            "localite": "Frauenfeld"
        },
        {
            "code": "8500",
            "localite": "Gerlikon"
        },
        {
            "code": "8505",
            "localite": "Dettighofen"
        },
        {
            "code": "8505",
            "localite": "Pfyn"
        },
        {
            "code": "8506",
            "localite": "Lanzenneunforn"
        },
        {
            "code": "8507",
            "localite": "Hörhausen"
        },
        {
            "code": "8508",
            "localite": "Homburg"
        },
        {
            "code": "8512",
            "localite": "Lustdorf"
        },
        {
            "code": "8512",
            "localite": "Thundorf"
        },
        {
            "code": "8512",
            "localite": "Wetzikon TG"
        },
        {
            "code": "8514",
            "localite": "Amlikon-Bissegg"
        },
        {
            "code": "8522",
            "localite": "Aawangen"
        },
        {
            "code": "8522",
            "localite": "Häuslenen"
        },
        {
            "code": "8523",
            "localite": "Hagenbuch ZH"
        },
        {
            "code": "8524",
            "localite": "Buch b. Frauenfeld"
        },
        {
            "code": "8524",
            "localite": "Uesslingen"
        },
        {
            "code": "8525",
            "localite": "Niederneunforn"
        },
        {
            "code": "8525",
            "localite": "Wilen b. Neunforn"
        },
        {
            "code": "8526",
            "localite": "Oberneunforn"
        },
        {
            "code": "8532",
            "localite": "Warth"
        },
        {
            "code": "8532",
            "localite": "Weiningen TG"
        },
        {
            "code": "8535",
            "localite": "Herdern"
        },
        {
            "code": "8536",
            "localite": "Hüttwilen"
        },
        {
            "code": "8537",
            "localite": "Nussbaumen TG"
        },
        {
            "code": "8537",
            "localite": "Uerschhausen"
        },
        {
            "code": "8542",
            "localite": "Wiesendangen"
        },
        {
            "code": "8543",
            "localite": "Bertschikon"
        },
        {
            "code": "8543",
            "localite": "Gundetswil"
        },
        {
            "code": "8543",
            "localite": "Kefikon ZH"
        },
        {
            "code": "8544",
            "localite": "Attikon"
        },
        {
            "code": "8545",
            "localite": "Rickenbach Sulz"
        },
        {
            "code": "8545",
            "localite": "Rickenbach ZH"
        },
        {
            "code": "8546",
            "localite": "Islikon"
        },
        {
            "code": "8546",
            "localite": "Kefikon TG"
        },
        {
            "code": "8546",
            "localite": "Menzengrüt"
        },
        {
            "code": "8547",
            "localite": "Gachnang"
        },
        {
            "code": "8548",
            "localite": "Ellikon an der Thur"
        },
        {
            "code": "8552",
            "localite": "Felben-Wellhausen"
        },
        {
            "code": "8553",
            "localite": "Eschikofen"
        },
        {
            "code": "8553",
            "localite": "Harenwilen"
        },
        {
            "code": "8553",
            "localite": "Hüttlingen"
        },
        {
            "code": "8553",
            "localite": "Mettendorf TG"
        },
        {
            "code": "8554",
            "localite": "Bonau"
        },
        {
            "code": "8554",
            "localite": "Müllheim-Wigoltingen"
        },
        {
            "code": "8555",
            "localite": "Müllheim Dorf"
        },
        {
            "code": "8556",
            "localite": "Engwang"
        },
        {
            "code": "8556",
            "localite": "Illhart"
        },
        {
            "code": "8556",
            "localite": "Lamperswil TG"
        },
        {
            "code": "8556",
            "localite": "Wigoltingen"
        },
        {
            "code": "8558",
            "localite": "Raperswilen"
        },
        {
            "code": "8560",
            "localite": "Märstetten"
        },
        {
            "code": "8561",
            "localite": "Ottoberg"
        },
        {
            "code": "8564",
            "localite": "Engwilen"
        },
        {
            "code": "8564",
            "localite": "Gunterswilen"
        },
        {
            "code": "8564",
            "localite": "Hattenhausen"
        },
        {
            "code": "8564",
            "localite": "Hefenhausen"
        },
        {
            "code": "8564",
            "localite": "Lipperswil"
        },
        {
            "code": "8564",
            "localite": "Sonterswil"
        },
        {
            "code": "8564",
            "localite": "Wagerswil"
        },
        {
            "code": "8564",
            "localite": "Wäldi"
        },
        {
            "code": "8565",
            "localite": "Hugelshofen"
        },
        {
            "code": "8566",
            "localite": "Dotnacht"
        },
        {
            "code": "8566",
            "localite": "Ellighausen"
        },
        {
            "code": "8566",
            "localite": "Lippoldswilen"
        },
        {
            "code": "8566",
            "localite": "Neuwilen"
        },
        {
            "code": "8570",
            "localite": "Weinfelden"
        },
        {
            "code": "8572",
            "localite": "Andhausen"
        },
        {
            "code": "8572",
            "localite": "Berg TG"
        },
        {
            "code": "8572",
            "localite": "Graltshausen"
        },
        {
            "code": "8572",
            "localite": "Guntershausen b. Berg"
        },
        {
            "code": "8573",
            "localite": "Alterswilen"
        },
        {
            "code": "8573",
            "localite": "Altishausen"
        },
        {
            "code": "8573",
            "localite": "Siegershausen"
        },
        {
            "code": "8574",
            "localite": "Dettighofen (Lengwil)"
        },
        {
            "code": "8574",
            "localite": "Illighausen"
        },
        {
            "code": "8574",
            "localite": "Lengwil"
        },
        {
            "code": "8574",
            "localite": "Oberhofen TG"
        },
        {
            "code": "8575",
            "localite": "Bürglen TG"
        },
        {
            "code": "8575",
            "localite": "Istighofen"
        },
        {
            "code": "8576",
            "localite": "Mauren TG"
        },
        {
            "code": "8577",
            "localite": "Schönholzerswilen"
        },
        {
            "code": "8580",
            "localite": "Amriswil"
        },
        {
            "code": "8580",
            "localite": "Biessenhofen"
        },
        {
            "code": "8580",
            "localite": "Hagenwil b. Amriswil"
        },
        {
            "code": "8580",
            "localite": "Hefenhofen"
        },
        {
            "code": "8580",
            "localite": "Sommeri"
        },
        {
            "code": "8581",
            "localite": "Schocherswil"
        },
        {
            "code": "8582",
            "localite": "Dozwil"
        },
        {
            "code": "8583",
            "localite": "Donzhausen"
        },
        {
            "code": "8583",
            "localite": "Götighofen"
        },
        {
            "code": "8583",
            "localite": "Sulgen"
        },
        {
            "code": "8584",
            "localite": "Leimbach TG"
        },
        {
            "code": "8584",
            "localite": "Opfershofen TG"
        },
        {
            "code": "8585",
            "localite": "Birwinken"
        },
        {
            "code": "8585",
            "localite": "Happerswil"
        },
        {
            "code": "8585",
            "localite": "Herrenhof"
        },
        {
            "code": "8585",
            "localite": "Klarsreuti"
        },
        {
            "code": "8585",
            "localite": "Langrickenbach"
        },
        {
            "code": "8585",
            "localite": "Mattwil"
        },
        {
            "code": "8585",
            "localite": "Schönenbaumgarten"
        },
        {
            "code": "8585",
            "localite": "Zuben"
        },
        {
            "code": "8586",
            "localite": "Andwil TG"
        },
        {
            "code": "8586",
            "localite": "Buch b. Kümmertshausen"
        },
        {
            "code": "8586",
            "localite": "Buchackern"
        },
        {
            "code": "8586",
            "localite": "Engishofen"
        },
        {
            "code": "8586",
            "localite": "Ennetaach"
        },
        {
            "code": "8586",
            "localite": "Erlen"
        },
        {
            "code": "8586",
            "localite": "Kümmertshausen"
        },
        {
            "code": "8586",
            "localite": "Riedt b. Erlen"
        },
        {
            "code": "8587",
            "localite": "Oberaach"
        },
        {
            "code": "8588",
            "localite": "Zihlschlacht"
        },
        {
            "code": "8589",
            "localite": "Sitterdorf"
        },
        {
            "code": "8590",
            "localite": "Romanshorn"
        },
        {
            "code": "8592",
            "localite": "Uttwil"
        },
        {
            "code": "8593",
            "localite": "Kesswil"
        },
        {
            "code": "8594",
            "localite": "Güttingen"
        },
        {
            "code": "8595",
            "localite": "Altnau"
        },
        {
            "code": "8596",
            "localite": "Münsterlingen"
        },
        {
            "code": "8596",
            "localite": "Scherzingen"
        },
        {
            "code": "8597",
            "localite": "Landschlacht"
        },
        {
            "code": "8598",
            "localite": "Bottighofen"
        },
        {
            "code": "8599",
            "localite": "Salmsach"
        },
        {
            "code": "8600",
            "localite": "Dübendorf"
        },
        {
            "code": "8602",
            "localite": "Wangen b. Dübendorf"
        },
        {
            "code": "8603",
            "localite": "Schwerzenbach"
        },
        {
            "code": "8604",
            "localite": "Volketswil"
        },
        {
            "code": "8605",
            "localite": "Gutenswil"
        },
        {
            "code": "8606",
            "localite": "Greifensee"
        },
        {
            "code": "8606",
            "localite": "Nänikon"
        },
        {
            "code": "8607",
            "localite": "Aathal-Seegräben"
        },
        {
            "code": "8608",
            "localite": "Bubikon"
        },
        {
            "code": "8610",
            "localite": "Uster"
        },
        {
            "code": "8614",
            "localite": "Bertschikon (Gossau ZH)"
        },
        {
            "code": "8614",
            "localite": "Sulzbach"
        },
        {
            "code": "8615",
            "localite": "Freudwil"
        },
        {
            "code": "8615",
            "localite": "Wermatswil"
        },
        {
            "code": "8616",
            "localite": "Riedikon"
        },
        {
            "code": "8617",
            "localite": "Mönchaltorf"
        },
        {
            "code": "8618",
            "localite": "Oetwil am See"
        },
        {
            "code": "8620",
            "localite": "Wetzikon ZH"
        },
        {
            "code": "8623",
            "localite": "Wetzikon ZH"
        },
        {
            "code": "8624",
            "localite": "Grüt (Gossau ZH)"
        },
        {
            "code": "8625",
            "localite": "Gossau ZH"
        },
        {
            "code": "8626",
            "localite": "Ottikon (Gossau ZH)"
        },
        {
            "code": "8627",
            "localite": "Grüningen"
        },
        {
            "code": "8630",
            "localite": "Rüti ZH"
        },
        {
            "code": "8632",
            "localite": "Tann"
        },
        {
            "code": "8633",
            "localite": "Wolfhausen"
        },
        {
            "code": "8634",
            "localite": "Hombrechtikon"
        },
        {
            "code": "8635",
            "localite": "Dürnten"
        },
        {
            "code": "8636",
            "localite": "Wald ZH"
        },
        {
            "code": "8637",
            "localite": "Laupen ZH"
        },
        {
            "code": "8638",
            "localite": "Goldingen"
        },
        {
            "code": "8640",
            "localite": "Hurden"
        },
        {
            "code": "8640",
            "localite": "Rapperswil SG"
        },
        {
            "code": "8645",
            "localite": "Jona"
        },
        {
            "code": "8646",
            "localite": "Wagen"
        },
        {
            "code": "8700",
            "localite": "Küsnacht ZH"
        },
        {
            "code": "8702",
            "localite": "Zollikon"
        },
        {
            "code": "8703",
            "localite": "Erlenbach ZH"
        },
        {
            "code": "8704",
            "localite": "Herrliberg"
        },
        {
            "code": "8706",
            "localite": "Meilen"
        },
        {
            "code": "8707",
            "localite": "Uetikon am See"
        },
        {
            "code": "8708",
            "localite": "Männedorf"
        },
        {
            "code": "8712",
            "localite": "Stäfa"
        },
        {
            "code": "8713",
            "localite": "Uerikon"
        },
        {
            "code": "8714",
            "localite": "Feldbach"
        },
        {
            "code": "8715",
            "localite": "Bollingen"
        },
        {
            "code": "8716",
            "localite": "Schmerikon"
        },
        {
            "code": "8717",
            "localite": "Benken SG"
        },
        {
            "code": "8718",
            "localite": "Schänis"
        },
        {
            "code": "8722",
            "localite": "Kaltbrunn"
        },
        {
            "code": "8723",
            "localite": "Maseltrangen"
        },
        {
            "code": "8723",
            "localite": "Rufi"
        },
        {
            "code": "8725",
            "localite": "Ernetschwil"
        },
        {
            "code": "8725",
            "localite": "Gebertingen"
        },
        {
            "code": "8726",
            "localite": "Ricken SG"
        },
        {
            "code": "8727",
            "localite": "Walde SG"
        },
        {
            "code": "8730",
            "localite": "Uznach"
        },
        {
            "code": "8732",
            "localite": "Neuhaus SG"
        },
        {
            "code": "8733",
            "localite": "Eschenbach SG"
        },
        {
            "code": "8734",
            "localite": "Ermenswil"
        },
        {
            "code": "8735",
            "localite": "Rüeterswil"
        },
        {
            "code": "8735",
            "localite": "St. Gallenkappel"
        },
        {
            "code": "8737",
            "localite": "Gommiswald"
        },
        {
            "code": "8738",
            "localite": "Uetliburg SG"
        },
        {
            "code": "8739",
            "localite": "Rieden SG"
        },
        {
            "code": "8750",
            "localite": "Glarus"
        },
        {
            "code": "8750",
            "localite": "Klöntal"
        },
        {
            "code": "8750",
            "localite": "Riedern"
        },
        {
            "code": "8751",
            "localite": "Urnerboden"
        },
        {
            "code": "8752",
            "localite": "Näfels"
        },
        {
            "code": "8753",
            "localite": "Mollis"
        },
        {
            "code": "8754",
            "localite": "Netstal"
        },
        {
            "code": "8755",
            "localite": "Ennenda"
        },
        {
            "code": "8756",
            "localite": "Mitlödi"
        },
        {
            "code": "8757",
            "localite": "Filzbach"
        },
        {
            "code": "8758",
            "localite": "Obstalden"
        },
        {
            "code": "8762",
            "localite": "Schwanden GL"
        },
        {
            "code": "8762",
            "localite": "Schwändi b. Schwanden"
        },
        {
            "code": "8762",
            "localite": "Sool"
        },
        {
            "code": "8765",
            "localite": "Engi"
        },
        {
            "code": "8766",
            "localite": "Matt"
        },
        {
            "code": "8767",
            "localite": "Elm"
        },
        {
            "code": "8772",
            "localite": "Nidfurn"
        },
        {
            "code": "8773",
            "localite": "Haslen GL"
        },
        {
            "code": "8774",
            "localite": "Leuggelbach"
        },
        {
            "code": "8775",
            "localite": "Hätzingen"
        },
        {
            "code": "8775",
            "localite": "Luchsingen"
        },
        {
            "code": "8777",
            "localite": "Betschwanden"
        },
        {
            "code": "8777",
            "localite": "Diesbach GL"
        },
        {
            "code": "8782",
            "localite": "Rüti GL"
        },
        {
            "code": "8783",
            "localite": "Linthal"
        },
        {
            "code": "8784",
            "localite": "Braunwald"
        },
        {
            "code": "8800",
            "localite": "Thalwil"
        },
        {
            "code": "8802",
            "localite": "Kilchberg ZH"
        },
        {
            "code": "8803",
            "localite": "Rüschlikon"
        },
        {
            "code": "8804",
            "localite": "Au ZH"
        },
        {
            "code": "8805",
            "localite": "Richterswil"
        },
        {
            "code": "8806",
            "localite": "Bäch SZ"
        },
        {
            "code": "8807",
            "localite": "Freienbach"
        },
        {
            "code": "8808",
            "localite": "Pfäffikon SZ"
        },
        {
            "code": "8810",
            "localite": "Horgen"
        },
        {
            "code": "8815",
            "localite": "Horgenberg"
        },
        {
            "code": "8816",
            "localite": "Hirzel"
        },
        {
            "code": "8820",
            "localite": "Wädenswil"
        },
        {
            "code": "8824",
            "localite": "Schönenberg ZH"
        },
        {
            "code": "8825",
            "localite": "Hütten"
        },
        {
            "code": "8832",
            "localite": "Wilen b. Wollerau"
        },
        {
            "code": "8832",
            "localite": "Wollerau"
        },
        {
            "code": "8833",
            "localite": "Samstagern"
        },
        {
            "code": "8834",
            "localite": "Schindellegi"
        },
        {
            "code": "8835",
            "localite": "Feusisberg"
        },
        {
            "code": "8836",
            "localite": "Bennau"
        },
        {
            "code": "8840",
            "localite": "Einsiedeln"
        },
        {
            "code": "8840",
            "localite": "Trachslau"
        },
        {
            "code": "8841",
            "localite": "Gross"
        },
        {
            "code": "8842",
            "localite": "Unteriberg"
        },
        {
            "code": "8843",
            "localite": "Oberiberg"
        },
        {
            "code": "8844",
            "localite": "Euthal"
        },
        {
            "code": "8845",
            "localite": "Studen SZ"
        },
        {
            "code": "8846",
            "localite": "Willerzell"
        },
        {
            "code": "8847",
            "localite": "Egg SZ"
        },
        {
            "code": "8849",
            "localite": "Alpthal"
        },
        {
            "code": "8852",
            "localite": "Altendorf"
        },
        {
            "code": "8853",
            "localite": "Lachen SZ"
        },
        {
            "code": "8854",
            "localite": "Galgenen"
        },
        {
            "code": "8854",
            "localite": "Siebnen"
        },
        {
            "code": "8855",
            "localite": "Wangen SZ"
        },
        {
            "code": "8856",
            "localite": "Tuggen"
        },
        {
            "code": "8857",
            "localite": "Vorderthal"
        },
        {
            "code": "8858",
            "localite": "Innerthal"
        },
        {
            "code": "8862",
            "localite": "Schübelbach"
        },
        {
            "code": "8863",
            "localite": "Buttikon SZ"
        },
        {
            "code": "8864",
            "localite": "Reichenburg"
        },
        {
            "code": "8865",
            "localite": "Bilten"
        },
        {
            "code": "8866",
            "localite": "Ziegelbrücke"
        },
        {
            "code": "8867",
            "localite": "Niederurnen"
        },
        {
            "code": "8868",
            "localite": "Oberurnen"
        },
        {
            "code": "8872",
            "localite": "Weesen"
        },
        {
            "code": "8873",
            "localite": "Amden"
        },
        {
            "code": "8874",
            "localite": "Mühlehorn"
        },
        {
            "code": "8877",
            "localite": "Murg"
        },
        {
            "code": "8878",
            "localite": "Quinten"
        },
        {
            "code": "8880",
            "localite": "Walenstadt"
        },
        {
            "code": "8881",
            "localite": "Tscherlach"
        },
        {
            "code": "8881",
            "localite": "Walenstadtberg"
        },
        {
            "code": "8882",
            "localite": "Unterterzen"
        },
        {
            "code": "8883",
            "localite": "Quarten"
        },
        {
            "code": "8884",
            "localite": "Oberterzen"
        },
        {
            "code": "8885",
            "localite": "Mols"
        },
        {
            "code": "8886",
            "localite": "Mädris-Vermol"
        },
        {
            "code": "8887",
            "localite": "Mels"
        },
        {
            "code": "8888",
            "localite": "Heiligkreuz (Mels)"
        },
        {
            "code": "8889",
            "localite": "Plons"
        },
        {
            "code": "8890",
            "localite": "Flums"
        },
        {
            "code": "8892",
            "localite": "Berschis"
        },
        {
            "code": "8893",
            "localite": "Flums Hochwiese"
        },
        {
            "code": "8894",
            "localite": "Flumserberg Saxli"
        },
        {
            "code": "8895",
            "localite": "Flumserberg Portels"
        },
        {
            "code": "8896",
            "localite": "Flumserberg Bergheim"
        },
        {
            "code": "8897",
            "localite": "Flumserberg Tannenheim"
        },
        {
            "code": "8898",
            "localite": "Flumserberg Tannenbodenalp"
        },
        {
            "code": "8902",
            "localite": "Urdorf"
        },
        {
            "code": "8903",
            "localite": "Birmensdorf ZH"
        },
        {
            "code": "8904",
            "localite": "Aesch ZH"
        },
        {
            "code": "8905",
            "localite": "Arni AG"
        },
        {
            "code": "8905",
            "localite": "Islisberg"
        },
        {
            "code": "8906",
            "localite": "Bonstetten"
        },
        {
            "code": "8907",
            "localite": "Wettswil"
        },
        {
            "code": "8908",
            "localite": "Hedingen"
        },
        {
            "code": "8909",
            "localite": "Zwillikon"
        },
        {
            "code": "8910",
            "localite": "Affoltern am Albis"
        },
        {
            "code": "8911",
            "localite": "Rifferswil"
        },
        {
            "code": "8912",
            "localite": "Obfelden"
        },
        {
            "code": "8913",
            "localite": "Ottenbach"
        },
        {
            "code": "8914",
            "localite": "Aeugst am Albis"
        },
        {
            "code": "8914",
            "localite": "Aeugstertal"
        },
        {
            "code": "8915",
            "localite": "Hausen am Albis"
        },
        {
            "code": "8916",
            "localite": "Jonen"
        },
        {
            "code": "8917",
            "localite": "Oberlunkhofen"
        },
        {
            "code": "8918",
            "localite": "Unterlunkhofen"
        },
        {
            "code": "8919",
            "localite": "Rottenschwil"
        },
        {
            "code": "8925",
            "localite": "Ebertswil"
        },
        {
            "code": "8926",
            "localite": "Hauptikon"
        },
        {
            "code": "8926",
            "localite": "Kappel am Albis"
        },
        {
            "code": "8926",
            "localite": "Uerzlikon"
        },
        {
            "code": "8932",
            "localite": "Mettmenstetten"
        },
        {
            "code": "8933",
            "localite": "Maschwanden"
        },
        {
            "code": "8934",
            "localite": "Knonau"
        },
        {
            "code": "8942",
            "localite": "Oberrieden"
        },
        {
            "code": "8951",
            "localite": "Fahrweid"
        },
        {
            "code": "8952",
            "localite": "Schlieren"
        },
        {
            "code": "8953",
            "localite": "Dietikon"
        },
        {
            "code": "8954",
            "localite": "Geroldswil"
        },
        {
            "code": "8955",
            "localite": "Oetwil an der Limmat"
        },
        {
            "code": "8956",
            "localite": "Killwangen"
        },
        {
            "code": "8957",
            "localite": "Spreitenbach"
        },
        {
            "code": "8962",
            "localite": "Bergdietikon"
        },
        {
            "code": "8964",
            "localite": "Rudolfstetten"
        },
        {
            "code": "8965",
            "localite": "Berikon"
        },
        {
            "code": "8966",
            "localite": "Oberwil-Lieli"
        },
        {
            "code": "8967",
            "localite": "Widen"
        },
        {
            "code": "9000",
            "localite": "St. Gallen"
        },
        {
            "code": "9008",
            "localite": "St. Gallen"
        },
        {
            "code": "9010",
            "localite": "St. Gallen"
        },
        {
            "code": "9011",
            "localite": "St. Gallen"
        },
        {
            "code": "9012",
            "localite": "St. Gallen"
        },
        {
            "code": "9014",
            "localite": "St. Gallen"
        },
        {
            "code": "9015",
            "localite": "St. Gallen"
        },
        {
            "code": "9016",
            "localite": "St. Gallen"
        },
        {
            "code": "9030",
            "localite": "Abtwil SG"
        },
        {
            "code": "9030",
            "localite": "St. Josefen"
        },
        {
            "code": "9032",
            "localite": "Engelburg"
        },
        {
            "code": "9033",
            "localite": "Untereggen"
        },
        {
            "code": "9034",
            "localite": "Eggersriet"
        },
        {
            "code": "9035",
            "localite": "Grub AR"
        },
        {
            "code": "9036",
            "localite": "Grub SG"
        },
        {
            "code": "9037",
            "localite": "Speicherschwendi"
        },
        {
            "code": "9038",
            "localite": "Rehetobel"
        },
        {
            "code": "9042",
            "localite": "Speicher"
        },
        {
            "code": "9043",
            "localite": "Trogen"
        },
        {
            "code": "9044",
            "localite": "Wald AR"
        },
        {
            "code": "9050",
            "localite": "Appenzell"
        },
        {
            "code": "9050",
            "localite": "Appenzell Eggerstanden"
        },
        {
            "code": "9050",
            "localite": "Appenzell Enggenhütten"
        },
        {
            "code": "9050",
            "localite": "Appenzell Meistersrüte"
        },
        {
            "code": "9050",
            "localite": "Appenzell Schlatt"
        },
        {
            "code": "9050",
            "localite": "Appenzell Steinegg"
        },
        {
            "code": "9052",
            "localite": "Niederteufen"
        },
        {
            "code": "9053",
            "localite": "Teufen AR"
        },
        {
            "code": "9054",
            "localite": "Haslen AI"
        },
        {
            "code": "9055",
            "localite": "Bühler"
        },
        {
            "code": "9056",
            "localite": "Gais"
        },
        {
            "code": "9057",
            "localite": "Schwende"
        },
        {
            "code": "9057",
            "localite": "Wasserauen"
        },
        {
            "code": "9057",
            "localite": "Weissbad"
        },
        {
            "code": "9058",
            "localite": "Brülisau"
        },
        {
            "code": "9062",
            "localite": "Lustmühle"
        },
        {
            "code": "9063",
            "localite": "Stein AR"
        },
        {
            "code": "9064",
            "localite": "Hundwil"
        },
        {
            "code": "9100",
            "localite": "Herisau"
        },
        {
            "code": "9103",
            "localite": "Schwellbrunn"
        },
        {
            "code": "9104",
            "localite": "Waldstatt"
        },
        {
            "code": "9105",
            "localite": "Schönengrund"
        },
        {
            "code": "9107",
            "localite": "Urnäsch"
        },
        {
            "code": "9108",
            "localite": "Gonten"
        },
        {
            "code": "9108",
            "localite": "Gontenbad"
        },
        {
            "code": "9108",
            "localite": "Jakobsbad"
        },
        {
            "code": "9112",
            "localite": "Schachen b. Herisau"
        },
        {
            "code": "9113",
            "localite": "Degersheim"
        },
        {
            "code": "9114",
            "localite": "Hoffeld"
        },
        {
            "code": "9115",
            "localite": "Dicken"
        },
        {
            "code": "9116",
            "localite": "Wolfertswil"
        },
        {
            "code": "9122",
            "localite": "Ebersol"
        },
        {
            "code": "9122",
            "localite": "Mogelsberg"
        },
        {
            "code": "9123",
            "localite": "Nassen"
        },
        {
            "code": "9125",
            "localite": "Brunnadern"
        },
        {
            "code": "9126",
            "localite": "Necker"
        },
        {
            "code": "9127",
            "localite": "St. Peterzell"
        },
        {
            "code": "9200",
            "localite": "Gossau SG"
        },
        {
            "code": "9203",
            "localite": "Niederwil SG"
        },
        {
            "code": "9204",
            "localite": "Andwil SG"
        },
        {
            "code": "9205",
            "localite": "Waldkirch"
        },
        {
            "code": "9212",
            "localite": "Arnegg"
        },
        {
            "code": "9213",
            "localite": "Hauptwil"
        },
        {
            "code": "9214",
            "localite": "Kradolf"
        },
        {
            "code": "9215",
            "localite": "Buhwil"
        },
        {
            "code": "9215",
            "localite": "Schönenberg an der Thur"
        },
        {
            "code": "9216",
            "localite": "Heldswil"
        },
        {
            "code": "9216",
            "localite": "Hohentannen"
        },
        {
            "code": "9217",
            "localite": "Neukirch an der Thur"
        },
        {
            "code": "9220",
            "localite": "Bischofszell"
        },
        {
            "code": "9223",
            "localite": "Halden"
        },
        {
            "code": "9223",
            "localite": "Schweizersholz"
        },
        {
            "code": "9225",
            "localite": "St. Pelagiberg"
        },
        {
            "code": "9225",
            "localite": "Wilen (Gottshaus)"
        },
        {
            "code": "9230",
            "localite": "Flawil"
        },
        {
            "code": "9231",
            "localite": "Egg (Flawil)"
        },
        {
            "code": "9240",
            "localite": "Niederglatt SG"
        },
        {
            "code": "9240",
            "localite": "Uzwil"
        },
        {
            "code": "9242",
            "localite": "Oberuzwil"
        },
        {
            "code": "9243",
            "localite": "Jonschwil"
        },
        {
            "code": "9244",
            "localite": "Niederuzwil"
        },
        {
            "code": "9245",
            "localite": "Oberbüren"
        },
        {
            "code": "9245",
            "localite": "Sonnental"
        },
        {
            "code": "9246",
            "localite": "Niederbüren"
        },
        {
            "code": "9247",
            "localite": "Henau"
        },
        {
            "code": "9248",
            "localite": "Bichwil"
        },
        {
            "code": "9249",
            "localite": "Algetshausen"
        },
        {
            "code": "9249",
            "localite": "Niederstetten"
        },
        {
            "code": "9249",
            "localite": "Oberstetten"
        },
        {
            "code": "9300",
            "localite": "Wittenbach"
        },
        {
            "code": "9304",
            "localite": "Bernhardzell"
        },
        {
            "code": "9305",
            "localite": "Berg SG"
        },
        {
            "code": "9306",
            "localite": "Freidorf TG"
        },
        {
            "code": "9308",
            "localite": "Lömmenschwil"
        },
        {
            "code": "9312",
            "localite": "Häggenschwil"
        },
        {
            "code": "9313",
            "localite": "Muolen"
        },
        {
            "code": "9314",
            "localite": "Steinebrunn"
        },
        {
            "code": "9315",
            "localite": "Neukirch (Egnach)"
        },
        {
            "code": "9315",
            "localite": "Winden"
        },
        {
            "code": "9320",
            "localite": "Arbon"
        },
        {
            "code": "9320",
            "localite": "Frasnacht"
        },
        {
            "code": "9320",
            "localite": "Stachen"
        },
        {
            "code": "9322",
            "localite": "Egnach"
        },
        {
            "code": "9323",
            "localite": "Steinach"
        },
        {
            "code": "9325",
            "localite": "Roggwil TG"
        },
        {
            "code": "9326",
            "localite": "Horn"
        },
        {
            "code": "9327",
            "localite": "Tübach"
        },
        {
            "code": "9400",
            "localite": "Rorschach"
        },
        {
            "code": "9402",
            "localite": "Mörschwil"
        },
        {
            "code": "9403",
            "localite": "Goldach"
        },
        {
            "code": "9404",
            "localite": "Rorschacherberg"
        },
        {
            "code": "9405",
            "localite": "Wienacht-Tobel"
        },
        {
            "code": "9410",
            "localite": "Heiden"
        },
        {
            "code": "9411",
            "localite": "Reute AR"
        },
        {
            "code": "9411",
            "localite": "Schachen b. Reute"
        },
        {
            "code": "9413",
            "localite": "Oberegg"
        },
        {
            "code": "9422",
            "localite": "Staad SG"
        },
        {
            "code": "9423",
            "localite": "Altenrhein"
        },
        {
            "code": "9424",
            "localite": "Rheineck"
        },
        {
            "code": "9425",
            "localite": "Thal"
        },
        {
            "code": "9426",
            "localite": "Lutzenberg"
        },
        {
            "code": "9427",
            "localite": "Wolfhalden"
        },
        {
            "code": "9428",
            "localite": "Walzenhausen"
        },
        {
            "code": "9430",
            "localite": "St. Margrethen SG"
        },
        {
            "code": "9434",
            "localite": "Au SG"
        },
        {
            "code": "9435",
            "localite": "Heerbrugg"
        },
        {
            "code": "9436",
            "localite": "Balgach"
        },
        {
            "code": "9437",
            "localite": "Marbach SG"
        },
        {
            "code": "9442",
            "localite": "Berneck"
        },
        {
            "code": "9442",
            "localite": "Büriswilen"
        },
        {
            "code": "9443",
            "localite": "Widnau"
        },
        {
            "code": "9444",
            "localite": "Diepoldsau"
        },
        {
            "code": "9445",
            "localite": "Rebstein"
        },
        {
            "code": "9450",
            "localite": "Altstätten SG"
        },
        {
            "code": "9450",
            "localite": "Lüchingen"
        },
        {
            "code": "9451",
            "localite": "Kriessern"
        },
        {
            "code": "9452",
            "localite": "Hinterforst"
        },
        {
            "code": "9453",
            "localite": "Eichberg"
        },
        {
            "code": "9462",
            "localite": "Montlingen"
        },
        {
            "code": "9463",
            "localite": "Oberriet SG"
        },
        {
            "code": "9464",
            "localite": "Lienz"
        },
        {
            "code": "9464",
            "localite": "Rüthi (Rheintal)"
        },
        {
            "code": "9465",
            "localite": "Salez"
        },
        {
            "code": "9466",
            "localite": "Sennwald"
        },
        {
            "code": "9467",
            "localite": "Frümsen"
        },
        {
            "code": "9468",
            "localite": "Sax"
        },
        {
            "code": "9469",
            "localite": "Haag (Rheintal)"
        },
        {
            "code": "9470",
            "localite": "Buchs SG"
        },
        {
            "code": "9470",
            "localite": "Werdenberg"
        },
        {
            "code": "9472",
            "localite": "Grabs"
        },
        {
            "code": "9472",
            "localite": "Grabserberg"
        },
        {
            "code": "9473",
            "localite": "Gams"
        },
        {
            "code": "9475",
            "localite": "Sevelen"
        },
        {
            "code": "9476",
            "localite": "Fontnas"
        },
        {
            "code": "9476",
            "localite": "Weite"
        },
        {
            "code": "9477",
            "localite": "Trübbach"
        },
        {
            "code": "9478",
            "localite": "Azmoos"
        },
        {
            "code": "9479",
            "localite": "Gretschins"
        },
        {
            "code": "9479",
            "localite": "Malans SG"
        },
        {
            "code": "9479",
            "localite": "Oberschan"
        },
        {
            "code": "9485",
            "localite": "Nendeln"
        },
        {
            "code": "9486",
            "localite": "Schaanwald"
        },
        {
            "code": "9487",
            "localite": "Gamprin-Bendern"
        },
        {
            "code": "9488",
            "localite": "Schellenberg"
        },
        {
            "code": "9490",
            "localite": "Vaduz"
        },
        {
            "code": "9491",
            "localite": "Ruggell"
        },
        {
            "code": "9492",
            "localite": "Eschen"
        },
        {
            "code": "9493",
            "localite": "Mauren FL"
        },
        {
            "code": "9494",
            "localite": "Schaan"
        },
        {
            "code": "9495",
            "localite": "Triesen"
        },
        {
            "code": "9496",
            "localite": "Balzers"
        },
        {
            "code": "9497",
            "localite": "Triesenberg"
        },
        {
            "code": "9498",
            "localite": "Planken"
        },
        {
            "code": "9500",
            "localite": "Wil SG"
        },
        {
            "code": "9502",
            "localite": "Braunau"
        },
        {
            "code": "9503",
            "localite": "Lanterswil"
        },
        {
            "code": "9503",
            "localite": "Stehrenberg"
        },
        {
            "code": "9504",
            "localite": "Friltschen"
        },
        {
            "code": "9506",
            "localite": "Lommis"
        },
        {
            "code": "9507",
            "localite": "Stettfurt"
        },
        {
            "code": "9508",
            "localite": "Weingarten-Kalthäusern"
        },
        {
            "code": "9512",
            "localite": "Rossrüti"
        },
        {
            "code": "9514",
            "localite": "Wuppenau"
        },
        {
            "code": "9515",
            "localite": "Hosenruck"
        },
        {
            "code": "9517",
            "localite": "Mettlen"
        },
        {
            "code": "9523",
            "localite": "Züberwangen"
        },
        {
            "code": "9524",
            "localite": "Zuzwil SG"
        },
        {
            "code": "9525",
            "localite": "Lenggenwil"
        },
        {
            "code": "9526",
            "localite": "Zuckenriet"
        },
        {
            "code": "9527",
            "localite": "Niederhelfenschwil"
        },
        {
            "code": "9532",
            "localite": "Rickenbach b. Wil"
        },
        {
            "code": "9533",
            "localite": "Dietschwil"
        },
        {
            "code": "9533",
            "localite": "Kirchberg SG"
        },
        {
            "code": "9534",
            "localite": "Gähwil"
        },
        {
            "code": "9535",
            "localite": "Wilen b. Wil"
        },
        {
            "code": "9536",
            "localite": "Schwarzenbach SG"
        },
        {
            "code": "9542",
            "localite": "Münchwilen TG"
        },
        {
            "code": "9543",
            "localite": "St. Margarethen TG"
        },
        {
            "code": "9545",
            "localite": "Wängi"
        },
        {
            "code": "9546",
            "localite": "Tuttwil"
        },
        {
            "code": "9547",
            "localite": "Wittenwil"
        },
        {
            "code": "9548",
            "localite": "Matzingen"
        },
        {
            "code": "9552",
            "localite": "Bronschhofen"
        },
        {
            "code": "9553",
            "localite": "Bettwiesen"
        },
        {
            "code": "9554",
            "localite": "Tägerschen"
        },
        {
            "code": "9555",
            "localite": "Tobel"
        },
        {
            "code": "9556",
            "localite": "Affeltrangen"
        },
        {
            "code": "9556",
            "localite": "Zezikon"
        },
        {
            "code": "9562",
            "localite": "Buch b. Märwil"
        },
        {
            "code": "9562",
            "localite": "Märwil"
        },
        {
            "code": "9565",
            "localite": "Bussnang"
        },
        {
            "code": "9565",
            "localite": "Oberbussnang"
        },
        {
            "code": "9565",
            "localite": "Oppikon"
        },
        {
            "code": "9565",
            "localite": "Rothenhausen"
        },
        {
            "code": "9565",
            "localite": "Schmidshof"
        },
        {
            "code": "9573",
            "localite": "Littenheid"
        },
        {
            "code": "9601",
            "localite": "Lütisburg Station"
        },
        {
            "code": "9602",
            "localite": "Bazenheid"
        },
        {
            "code": "9602",
            "localite": "Müselbach"
        },
        {
            "code": "9604",
            "localite": "Lütisburg"
        },
        {
            "code": "9604",
            "localite": "Oberrindal"
        },
        {
            "code": "9604",
            "localite": "Unterrindal"
        },
        {
            "code": "9606",
            "localite": "Bütschwil"
        },
        {
            "code": "9607",
            "localite": "Mosnang"
        },
        {
            "code": "9608",
            "localite": "Ganterschwil"
        },
        {
            "code": "9612",
            "localite": "Dreien"
        },
        {
            "code": "9613",
            "localite": "Mühlrüti"
        },
        {
            "code": "9614",
            "localite": "Libingen"
        },
        {
            "code": "9615",
            "localite": "Dietfurt"
        },
        {
            "code": "9620",
            "localite": "Lichtensteig"
        },
        {
            "code": "9621",
            "localite": "Oberhelfenschwil"
        },
        {
            "code": "9622",
            "localite": "Krinau"
        },
        {
            "code": "9630",
            "localite": "Wattwil"
        },
        {
            "code": "9631",
            "localite": "Ulisbach"
        },
        {
            "code": "9633",
            "localite": "Bächli (Hemberg)"
        },
        {
            "code": "9633",
            "localite": "Hemberg"
        },
        {
            "code": "9642",
            "localite": "Ebnat-Kappel"
        },
        {
            "code": "9643",
            "localite": "Krummenau"
        },
        {
            "code": "9650",
            "localite": "Nesslau"
        },
        {
            "code": "9651",
            "localite": "Ennetbühl"
        },
        {
            "code": "9652",
            "localite": "Neu St. Johann"
        },
        {
            "code": "9655",
            "localite": "Stein SG"
        },
        {
            "code": "9656",
            "localite": "Alt St. Johann"
        },
        {
            "code": "9657",
            "localite": "Unterwasser"
        },
        {
            "code": "9658",
            "localite": "Wildhaus"
        }
    ],
    "it": [
        {
            "code": "1000",
            "localite": "Lausanne 25"
        },
        {
            "code": "1000",
            "localite": "Lausanne 26"
        },
        {
            "code": "1000",
            "localite": "Lausanne 27"
        },
        {
            "code": "1003",
            "localite": "Lausanne"
        },
        {
            "code": "1004",
            "localite": "Lausanne"
        },
        {
            "code": "1005",
            "localite": "Lausanne"
        },
        {
            "code": "1006",
            "localite": "Lausanne"
        },
        {
            "code": "1007",
            "localite": "Lausanne"
        },
        {
            "code": "1008",
            "localite": "Jouxtens-Mézery"
        },
        {
            "code": "1008",
            "localite": "Prilly"
        },
        {
            "code": "1009",
            "localite": "Pully"
        },
        {
            "code": "1010",
            "localite": "Lausanne"
        },
        {
            "code": "1011",
            "localite": "Lausanne"
        },
        {
            "code": "1012",
            "localite": "Lausanne"
        },
        {
            "code": "1015",
            "localite": "Lausanne"
        },
        {
            "code": "1018",
            "localite": "Lausanne"
        },
        {
            "code": "1020",
            "localite": "Renens VD"
        },
        {
            "code": "1022",
            "localite": "Chavannes-près-Renens"
        },
        {
            "code": "1023",
            "localite": "Crissier"
        },
        {
            "code": "1024",
            "localite": "Ecublens VD"
        },
        {
            "code": "1025",
            "localite": "St-Sulpice VD"
        },
        {
            "code": "1026",
            "localite": "Denges"
        },
        {
            "code": "1026",
            "localite": "Echandens"
        },
        {
            "code": "1027",
            "localite": "Lonay"
        },
        {
            "code": "1028",
            "localite": "Préverenges"
        },
        {
            "code": "1029",
            "localite": "Villars-Ste-Croix"
        },
        {
            "code": "1030",
            "localite": "Bussigny"
        },
        {
            "code": "1031",
            "localite": "Mex VD"
        },
        {
            "code": "1032",
            "localite": "Romanel-sur-Lausanne"
        },
        {
            "code": "1033",
            "localite": "Cheseaux-sur-Lausanne"
        },
        {
            "code": "1034",
            "localite": "Boussens"
        },
        {
            "code": "1035",
            "localite": "Bournens"
        },
        {
            "code": "1036",
            "localite": "Sullens"
        },
        {
            "code": "1037",
            "localite": "Etagnières"
        },
        {
            "code": "1038",
            "localite": "Bercher"
        },
        {
            "code": "1040",
            "localite": "Echallens"
        },
        {
            "code": "1040",
            "localite": "St-Barthélemy VD"
        },
        {
            "code": "1040",
            "localite": "Villars-le-Terroir"
        },
        {
            "code": "1041",
            "localite": "Bottens"
        },
        {
            "code": "1041",
            "localite": "Dommartin"
        },
        {
            "code": "1041",
            "localite": "Montaubion-Chardonney"
        },
        {
            "code": "1041",
            "localite": "Naz"
        },
        {
            "code": "1041",
            "localite": "Poliez-Pittet"
        },
        {
            "code": "1041",
            "localite": "Poliez-le-Grand"
        },
        {
            "code": "1042",
            "localite": "Assens"
        },
        {
            "code": "1042",
            "localite": "Bettens"
        },
        {
            "code": "1042",
            "localite": "Bioley-Orjulaz"
        },
        {
            "code": "1043",
            "localite": "Sugnens"
        },
        {
            "code": "1044",
            "localite": "Fey"
        },
        {
            "code": "1045",
            "localite": "Ogens"
        },
        {
            "code": "1046",
            "localite": "Rueyres"
        },
        {
            "code": "1047",
            "localite": "Oppens"
        },
        {
            "code": "1052",
            "localite": "Le Mont-sur-Lausanne"
        },
        {
            "code": "1053",
            "localite": "Bretigny-sur-Morrens"
        },
        {
            "code": "1053",
            "localite": "Cugy VD"
        },
        {
            "code": "1054",
            "localite": "Morrens VD"
        },
        {
            "code": "1055",
            "localite": "Froideville"
        },
        {
            "code": "1058",
            "localite": "Villars-Tiercelin"
        },
        {
            "code": "1059",
            "localite": "Peney-le-Jorat"
        },
        {
            "code": "1061",
            "localite": "Villars-Mendraz"
        },
        {
            "code": "1062",
            "localite": "Sottens"
        },
        {
            "code": "1063",
            "localite": "Boulens"
        },
        {
            "code": "1063",
            "localite": "Chapelle-sur-Moudon"
        },
        {
            "code": "1063",
            "localite": "Martherenges"
        },
        {
            "code": "1063",
            "localite": "Peyres-Possens"
        },
        {
            "code": "1066",
            "localite": "Epalinges"
        },
        {
            "code": "1068",
            "localite": "Les Monts-de-Pully"
        },
        {
            "code": "1070",
            "localite": "Puidoux"
        },
        {
            "code": "1071",
            "localite": "Chexbres"
        },
        {
            "code": "1071",
            "localite": "Rivaz"
        },
        {
            "code": "1071",
            "localite": "St-Saphorin (Lavaux)"
        },
        {
            "code": "1072",
            "localite": "Forel (Lavaux)"
        },
        {
            "code": "1073",
            "localite": "Mollie-Margot"
        },
        {
            "code": "1073",
            "localite": "Savigny"
        },
        {
            "code": "1076",
            "localite": "Ferlens VD"
        },
        {
            "code": "1077",
            "localite": "Servion"
        },
        {
            "code": "1078",
            "localite": "Essertes"
        },
        {
            "code": "1080",
            "localite": "Les Cullayes"
        },
        {
            "code": "1081",
            "localite": "Montpreveyres"
        },
        {
            "code": "1082",
            "localite": "Corcelles-le-Jorat"
        },
        {
            "code": "1083",
            "localite": "Mézières VD"
        },
        {
            "code": "1084",
            "localite": "Carrouge VD"
        },
        {
            "code": "1085",
            "localite": "Vulliens"
        },
        {
            "code": "1088",
            "localite": "Ropraz"
        },
        {
            "code": "1090",
            "localite": "La Croix (Lutry)"
        },
        {
            "code": "1091",
            "localite": "Aran"
        },
        {
            "code": "1091",
            "localite": "Chenaux"
        },
        {
            "code": "1091",
            "localite": "Grandvaux"
        },
        {
            "code": "1092",
            "localite": "Belmont-sur-Lausanne"
        },
        {
            "code": "1093",
            "localite": "La Conversion"
        },
        {
            "code": "1094",
            "localite": "Paudex"
        },
        {
            "code": "1095",
            "localite": "Lutry"
        },
        {
            "code": "1096",
            "localite": "Cully"
        },
        {
            "code": "1096",
            "localite": "Villette (Lavaux)"
        },
        {
            "code": "1097",
            "localite": "Riex"
        },
        {
            "code": "1098",
            "localite": "Epesses"
        },
        {
            "code": "1110",
            "localite": "Morges"
        },
        {
            "code": "1112",
            "localite": "Echichens"
        },
        {
            "code": "1113",
            "localite": "St-Saphorin-sur-Morges"
        },
        {
            "code": "1114",
            "localite": "Colombier VD"
        },
        {
            "code": "1115",
            "localite": "Vullierens"
        },
        {
            "code": "1116",
            "localite": "Cottens VD"
        },
        {
            "code": "1117",
            "localite": "Grancy"
        },
        {
            "code": "1121",
            "localite": "Bremblens"
        },
        {
            "code": "1122",
            "localite": "Romanel-sur-Morges"
        },
        {
            "code": "1123",
            "localite": "Aclens"
        },
        {
            "code": "1124",
            "localite": "Gollion"
        },
        {
            "code": "1125",
            "localite": "Monnaz"
        },
        {
            "code": "1126",
            "localite": "Vaux-sur-Morges"
        },
        {
            "code": "1127",
            "localite": "Clarmont"
        },
        {
            "code": "1128",
            "localite": "Reverolle"
        },
        {
            "code": "1131",
            "localite": "Tolochenaz"
        },
        {
            "code": "1132",
            "localite": "Lully VD"
        },
        {
            "code": "1134",
            "localite": "Chigny"
        },
        {
            "code": "1134",
            "localite": "Vufflens-le-Château"
        },
        {
            "code": "1135",
            "localite": "Denens"
        },
        {
            "code": "1136",
            "localite": "Bussy-Chardonney"
        },
        {
            "code": "1141",
            "localite": "Sévery"
        },
        {
            "code": "1142",
            "localite": "Pampigny"
        },
        {
            "code": "1143",
            "localite": "Apples"
        },
        {
            "code": "1144",
            "localite": "Ballens"
        },
        {
            "code": "1145",
            "localite": "Bière"
        },
        {
            "code": "1146",
            "localite": "Mollens VD"
        },
        {
            "code": "1147",
            "localite": "Montricher"
        },
        {
            "code": "1148",
            "localite": "Chavannes-le-Veyron"
        },
        {
            "code": "1148",
            "localite": "Cuarnens"
        },
        {
            "code": "1148",
            "localite": "L'Isle"
        },
        {
            "code": "1148",
            "localite": "La Coudre"
        },
        {
            "code": "1148",
            "localite": "La Praz"
        },
        {
            "code": "1148",
            "localite": "Mauraz"
        },
        {
            "code": "1148",
            "localite": "Moiry VD"
        },
        {
            "code": "1148",
            "localite": "Mont-la-Ville"
        },
        {
            "code": "1148",
            "localite": "Villars-Bozon"
        },
        {
            "code": "1149",
            "localite": "Berolle"
        },
        {
            "code": "1162",
            "localite": "St-Prex"
        },
        {
            "code": "1163",
            "localite": "Etoy"
        },
        {
            "code": "1164",
            "localite": "Buchillon"
        },
        {
            "code": "1165",
            "localite": "Allaman"
        },
        {
            "code": "1166",
            "localite": "Perroy"
        },
        {
            "code": "1167",
            "localite": "Lussy-sur-Morges"
        },
        {
            "code": "1168",
            "localite": "Villars-sous-Yens"
        },
        {
            "code": "1169",
            "localite": "Yens"
        },
        {
            "code": "1170",
            "localite": "Aubonne"
        },
        {
            "code": "1172",
            "localite": "Bougy-Villars"
        },
        {
            "code": "1173",
            "localite": "Féchy"
        },
        {
            "code": "1174",
            "localite": "Montherod"
        },
        {
            "code": "1174",
            "localite": "Pizy"
        },
        {
            "code": "1175",
            "localite": "Lavigny"
        },
        {
            "code": "1176",
            "localite": "St-Livres"
        },
        {
            "code": "1180",
            "localite": "Rolle"
        },
        {
            "code": "1180",
            "localite": "Tartegnin"
        },
        {
            "code": "1182",
            "localite": "Gilly"
        },
        {
            "code": "1183",
            "localite": "Bursins"
        },
        {
            "code": "1184",
            "localite": "Luins"
        },
        {
            "code": "1184",
            "localite": "Vinzel"
        },
        {
            "code": "1185",
            "localite": "Mont-sur-Rolle"
        },
        {
            "code": "1186",
            "localite": "Essertines-sur-Rolle"
        },
        {
            "code": "1187",
            "localite": "St-Oyens"
        },
        {
            "code": "1188",
            "localite": "Gimel"
        },
        {
            "code": "1188",
            "localite": "St-George"
        },
        {
            "code": "1189",
            "localite": "Saubraz"
        },
        {
            "code": "1195",
            "localite": "Bursinel"
        },
        {
            "code": "1195",
            "localite": "Dully"
        },
        {
            "code": "1196",
            "localite": "Gland"
        },
        {
            "code": "1197",
            "localite": "Prangins"
        },
        {
            "code": "1201",
            "localite": "Genève"
        },
        {
            "code": "1202",
            "localite": "Genève"
        },
        {
            "code": "1203",
            "localite": "Genève"
        },
        {
            "code": "1204",
            "localite": "Genève"
        },
        {
            "code": "1205",
            "localite": "Genève"
        },
        {
            "code": "1206",
            "localite": "Genève"
        },
        {
            "code": "1207",
            "localite": "Genève"
        },
        {
            "code": "1208",
            "localite": "Genève"
        },
        {
            "code": "1209",
            "localite": "Genève"
        },
        {
            "code": "1212",
            "localite": "Grand-Lancy"
        },
        {
            "code": "1213",
            "localite": "Onex"
        },
        {
            "code": "1213",
            "localite": "Petit-Lancy"
        },
        {
            "code": "1214",
            "localite": "Vernier"
        },
        {
            "code": "1215",
            "localite": "Genève"
        },
        {
            "code": "1216",
            "localite": "Cointrin"
        },
        {
            "code": "1217",
            "localite": "Meyrin"
        },
        {
            "code": "1218",
            "localite": "Le Grand-Saconnex"
        },
        {
            "code": "1219",
            "localite": "Aïre"
        },
        {
            "code": "1219",
            "localite": "Châtelaine"
        },
        {
            "code": "1219",
            "localite": "Le Lignon"
        },
        {
            "code": "1220",
            "localite": "Les Avanchets"
        },
        {
            "code": "1222",
            "localite": "Vésenaz"
        },
        {
            "code": "1223",
            "localite": "Cologny"
        },
        {
            "code": "1224",
            "localite": "Chêne-Bougeries"
        },
        {
            "code": "1225",
            "localite": "Chêne-Bourg"
        },
        {
            "code": "1226",
            "localite": "Thônex"
        },
        {
            "code": "1227",
            "localite": "Carouge GE"
        },
        {
            "code": "1227",
            "localite": "Les Acacias"
        },
        {
            "code": "1228",
            "localite": "Plan-les-Ouates"
        },
        {
            "code": "1231",
            "localite": "Conches"
        },
        {
            "code": "1232",
            "localite": "Confignon"
        },
        {
            "code": "1233",
            "localite": "Bernex"
        },
        {
            "code": "1234",
            "localite": "Vessy"
        },
        {
            "code": "1236",
            "localite": "Cartigny"
        },
        {
            "code": "1237",
            "localite": "Avully"
        },
        {
            "code": "1239",
            "localite": "Collex"
        },
        {
            "code": "1241",
            "localite": "Puplinge"
        },
        {
            "code": "1242",
            "localite": "Satigny"
        },
        {
            "code": "1243",
            "localite": "Presinge"
        },
        {
            "code": "1244",
            "localite": "Choulex"
        },
        {
            "code": "1245",
            "localite": "Collonge-Bellerive"
        },
        {
            "code": "1246",
            "localite": "Corsier GE"
        },
        {
            "code": "1247",
            "localite": "Anières"
        },
        {
            "code": "1248",
            "localite": "Hermance"
        },
        {
            "code": "1251",
            "localite": "Gy"
        },
        {
            "code": "1252",
            "localite": "Meinier"
        },
        {
            "code": "1253",
            "localite": "Vandoeuvres"
        },
        {
            "code": "1254",
            "localite": "Jussy"
        },
        {
            "code": "1255",
            "localite": "Veyrier"
        },
        {
            "code": "1256",
            "localite": "Troinex"
        },
        {
            "code": "1257",
            "localite": "La Croix-de-Rozon"
        },
        {
            "code": "1258",
            "localite": "Perly"
        },
        {
            "code": "1260",
            "localite": "Nyon"
        },
        {
            "code": "1261",
            "localite": "Le Vaud"
        },
        {
            "code": "1261",
            "localite": "Longirod"
        },
        {
            "code": "1261",
            "localite": "Marchissy"
        },
        {
            "code": "1262",
            "localite": "Eysins"
        },
        {
            "code": "1263",
            "localite": "Crassier"
        },
        {
            "code": "1264",
            "localite": "St-Cergue"
        },
        {
            "code": "1265",
            "localite": "La Cure"
        },
        {
            "code": "1266",
            "localite": "Duillier"
        },
        {
            "code": "1267",
            "localite": "Coinsins"
        },
        {
            "code": "1267",
            "localite": "Vich"
        },
        {
            "code": "1268",
            "localite": "Begnins"
        },
        {
            "code": "1268",
            "localite": "Burtigny"
        },
        {
            "code": "1269",
            "localite": "Bassins"
        },
        {
            "code": "1270",
            "localite": "Trélex"
        },
        {
            "code": "1271",
            "localite": "Givrins"
        },
        {
            "code": "1272",
            "localite": "Genolier"
        },
        {
            "code": "1273",
            "localite": "Arzier-Le Muids"
        },
        {
            "code": "1274",
            "localite": "Grens"
        },
        {
            "code": "1274",
            "localite": "Signy"
        },
        {
            "code": "1275",
            "localite": "Chéserex"
        },
        {
            "code": "1276",
            "localite": "Gingins"
        },
        {
            "code": "1277",
            "localite": "Arnex-sur-Nyon"
        },
        {
            "code": "1277",
            "localite": "Borex"
        },
        {
            "code": "1278",
            "localite": "La Rippe"
        },
        {
            "code": "1279",
            "localite": "Bogis-Bossey"
        },
        {
            "code": "1279",
            "localite": "Chavannes-de-Bogis"
        },
        {
            "code": "1281",
            "localite": "Russin"
        },
        {
            "code": "1283",
            "localite": "Dardagny"
        },
        {
            "code": "1283",
            "localite": "La Plaine"
        },
        {
            "code": "1284",
            "localite": "Chancy"
        },
        {
            "code": "1285",
            "localite": "Athenaz (Avusy)"
        },
        {
            "code": "1286",
            "localite": "Soral"
        },
        {
            "code": "1287",
            "localite": "Laconnex"
        },
        {
            "code": "1288",
            "localite": "Aire-la-Ville"
        },
        {
            "code": "1290",
            "localite": "Chavannes-des-Bois"
        },
        {
            "code": "1290",
            "localite": "Versoix"
        },
        {
            "code": "1291",
            "localite": "Commugny"
        },
        {
            "code": "1292",
            "localite": "Chambésy"
        },
        {
            "code": "1293",
            "localite": "Bellevue"
        },
        {
            "code": "1294",
            "localite": "Genthod"
        },
        {
            "code": "1295",
            "localite": "Mies"
        },
        {
            "code": "1295",
            "localite": "Tannay"
        },
        {
            "code": "1296",
            "localite": "Coppet"
        },
        {
            "code": "1297",
            "localite": "Founex"
        },
        {
            "code": "1298",
            "localite": "Céligny"
        },
        {
            "code": "1299",
            "localite": "Crans VD"
        },
        {
            "code": "1302",
            "localite": "Vufflens-la-Ville"
        },
        {
            "code": "1303",
            "localite": "Penthaz"
        },
        {
            "code": "1304",
            "localite": "Allens"
        },
        {
            "code": "1304",
            "localite": "Cossonay-Ville"
        },
        {
            "code": "1304",
            "localite": "Dizy"
        },
        {
            "code": "1304",
            "localite": "Senarclens"
        },
        {
            "code": "1305",
            "localite": "Penthalaz"
        },
        {
            "code": "1306",
            "localite": "Daillens"
        },
        {
            "code": "1307",
            "localite": "Lussery-Villars"
        },
        {
            "code": "1308",
            "localite": "La Chaux (Cossonay)"
        },
        {
            "code": "1312",
            "localite": "Eclépens"
        },
        {
            "code": "1313",
            "localite": "Ferreyres"
        },
        {
            "code": "1315",
            "localite": "La Sarraz"
        },
        {
            "code": "1316",
            "localite": "Chevilly"
        },
        {
            "code": "1317",
            "localite": "Orny"
        },
        {
            "code": "1318",
            "localite": "Pompaples"
        },
        {
            "code": "1321",
            "localite": "Arnex-sur-Orbe"
        },
        {
            "code": "1322",
            "localite": "Croy"
        },
        {
            "code": "1323",
            "localite": "Romainmôtier"
        },
        {
            "code": "1324",
            "localite": "Premier"
        },
        {
            "code": "1325",
            "localite": "Vaulion"
        },
        {
            "code": "1326",
            "localite": "Juriens"
        },
        {
            "code": "1329",
            "localite": "Bretonnières"
        },
        {
            "code": "1337",
            "localite": "Vallorbe"
        },
        {
            "code": "1338",
            "localite": "Ballaigues"
        },
        {
            "code": "1341",
            "localite": "L'Orient"
        },
        {
            "code": "1342",
            "localite": "Le Pont"
        },
        {
            "code": "1343",
            "localite": "Les Charbonnières"
        },
        {
            "code": "1344",
            "localite": "L'Abbaye"
        },
        {
            "code": "1345",
            "localite": "Le Lieu"
        },
        {
            "code": "1345",
            "localite": "Le Séchey"
        },
        {
            "code": "1346",
            "localite": "Les Bioux"
        },
        {
            "code": "1347",
            "localite": "Le Sentier"
        },
        {
            "code": "1347",
            "localite": "Le Solliat"
        },
        {
            "code": "1348",
            "localite": "Le Brassus"
        },
        {
            "code": "1350",
            "localite": "Orbe"
        },
        {
            "code": "1352",
            "localite": "Agiez"
        },
        {
            "code": "1353",
            "localite": "Bofflens"
        },
        {
            "code": "1354",
            "localite": "Montcherand"
        },
        {
            "code": "1355",
            "localite": "L'Abergement"
        },
        {
            "code": "1355",
            "localite": "Sergey"
        },
        {
            "code": "1356",
            "localite": "La Russille"
        },
        {
            "code": "1356",
            "localite": "Les Clées"
        },
        {
            "code": "1357",
            "localite": "Lignerolle"
        },
        {
            "code": "1358",
            "localite": "Valeyres-sous-Rances"
        },
        {
            "code": "1372",
            "localite": "Bavois"
        },
        {
            "code": "1373",
            "localite": "Chavornay"
        },
        {
            "code": "1374",
            "localite": "Corcelles-sur-Chavornay"
        },
        {
            "code": "1375",
            "localite": "Penthéréaz"
        },
        {
            "code": "1376",
            "localite": "Eclagnens"
        },
        {
            "code": "1376",
            "localite": "Goumoens-la-Ville"
        },
        {
            "code": "1376",
            "localite": "Goumoens-le-Jux"
        },
        {
            "code": "1377",
            "localite": "Oulens-sous-Echallens"
        },
        {
            "code": "1400",
            "localite": "Cheseaux-Noréaz"
        },
        {
            "code": "1400",
            "localite": "Yverdon-les-Bains"
        },
        {
            "code": "1404",
            "localite": "Cuarny"
        },
        {
            "code": "1404",
            "localite": "Villars-Epeney"
        },
        {
            "code": "1405",
            "localite": "Pomy"
        },
        {
            "code": "1406",
            "localite": "Cronay"
        },
        {
            "code": "1407",
            "localite": "Bioley-Magnoux"
        },
        {
            "code": "1407",
            "localite": "Donneloye"
        },
        {
            "code": "1407",
            "localite": "Gossens"
        },
        {
            "code": "1407",
            "localite": "Mézery-près-Donneloye"
        },
        {
            "code": "1408",
            "localite": "Prahins"
        },
        {
            "code": "1409",
            "localite": "Chanéaz"
        },
        {
            "code": "1410",
            "localite": "Correvon"
        },
        {
            "code": "1410",
            "localite": "Denezy"
        },
        {
            "code": "1410",
            "localite": "Prévondavaux"
        },
        {
            "code": "1410",
            "localite": "St-Cierges"
        },
        {
            "code": "1410",
            "localite": "Thierrens"
        },
        {
            "code": "1412",
            "localite": "Ursins"
        },
        {
            "code": "1412",
            "localite": "Valeyres-sous-Ursins"
        },
        {
            "code": "1413",
            "localite": "Orzens"
        },
        {
            "code": "1415",
            "localite": "Démoret"
        },
        {
            "code": "1415",
            "localite": "Molondin"
        },
        {
            "code": "1416",
            "localite": "Pailly"
        },
        {
            "code": "1417",
            "localite": "Epautheyres"
        },
        {
            "code": "1417",
            "localite": "Essertines-sur-Yverdon"
        },
        {
            "code": "1418",
            "localite": "Vuarrens"
        },
        {
            "code": "1420",
            "localite": "Fiez"
        },
        {
            "code": "1421",
            "localite": "Fontaines-sur-Grandson"
        },
        {
            "code": "1421",
            "localite": "Grandevent"
        },
        {
            "code": "1422",
            "localite": "Grandson"
        },
        {
            "code": "1423",
            "localite": "Fontanezier"
        },
        {
            "code": "1423",
            "localite": "Romairon"
        },
        {
            "code": "1423",
            "localite": "Vaugondry"
        },
        {
            "code": "1423",
            "localite": "Villars-Burquin"
        },
        {
            "code": "1424",
            "localite": "Champagne"
        },
        {
            "code": "1425",
            "localite": "Onnens VD"
        },
        {
            "code": "1426",
            "localite": "Concise"
        },
        {
            "code": "1426",
            "localite": "Corcelles-près-Concise"
        },
        {
            "code": "1427",
            "localite": "Bonvillars"
        },
        {
            "code": "1428",
            "localite": "Mutrux"
        },
        {
            "code": "1428",
            "localite": "Provence"
        },
        {
            "code": "1429",
            "localite": "Giez"
        },
        {
            "code": "1430",
            "localite": "Orges"
        },
        {
            "code": "1431",
            "localite": "Novalles"
        },
        {
            "code": "1431",
            "localite": "Vugelles-La Mothe"
        },
        {
            "code": "1432",
            "localite": "Belmont-sur-Yverdon"
        },
        {
            "code": "1432",
            "localite": "Gressy"
        },
        {
            "code": "1433",
            "localite": "Suchy"
        },
        {
            "code": "1434",
            "localite": "Ependes VD"
        },
        {
            "code": "1435",
            "localite": "Essert-Pittet"
        },
        {
            "code": "1436",
            "localite": "Chamblon"
        },
        {
            "code": "1436",
            "localite": "Treycovagnes"
        },
        {
            "code": "1437",
            "localite": "Suscévaz"
        },
        {
            "code": "1438",
            "localite": "Mathod"
        },
        {
            "code": "1439",
            "localite": "Rances"
        },
        {
            "code": "1441",
            "localite": "Valeyres-sous-Montagny"
        },
        {
            "code": "1442",
            "localite": "Montagny-près-Yverdon"
        },
        {
            "code": "1443",
            "localite": "Champvent"
        },
        {
            "code": "1443",
            "localite": "Essert-sous-Champvent"
        },
        {
            "code": "1443",
            "localite": "Villars-sous-Champvent"
        },
        {
            "code": "1445",
            "localite": "Vuiteboeuf"
        },
        {
            "code": "1446",
            "localite": "Baulmes"
        },
        {
            "code": "1450",
            "localite": "La Sagne (Ste-Croix)"
        },
        {
            "code": "1450",
            "localite": "Le Château-de-Ste-Croix"
        },
        {
            "code": "1450",
            "localite": "Ste-Croix"
        },
        {
            "code": "1452",
            "localite": "Les Rasses"
        },
        {
            "code": "1453",
            "localite": "Bullet"
        },
        {
            "code": "1453",
            "localite": "Mauborget"
        },
        {
            "code": "1454",
            "localite": "L'Auberson"
        },
        {
            "code": "1454",
            "localite": "La Vraconnaz"
        },
        {
            "code": "1462",
            "localite": "Yvonand"
        },
        {
            "code": "1463",
            "localite": "Rovray"
        },
        {
            "code": "1464",
            "localite": "Chavannes-le-Chêne"
        },
        {
            "code": "1464",
            "localite": "Chêne-Pâquier"
        },
        {
            "code": "1468",
            "localite": "Cheyres"
        },
        {
            "code": "1470",
            "localite": "Bollion"
        },
        {
            "code": "1470",
            "localite": "Estavayer-le-Lac"
        },
        {
            "code": "1470",
            "localite": "Lully FR"
        },
        {
            "code": "1470",
            "localite": "Seiry"
        },
        {
            "code": "1473",
            "localite": "Châtillon FR"
        },
        {
            "code": "1473",
            "localite": "Font"
        },
        {
            "code": "1474",
            "localite": "Châbles FR"
        },
        {
            "code": "1475",
            "localite": "Autavaux"
        },
        {
            "code": "1475",
            "localite": "Forel FR"
        },
        {
            "code": "1475",
            "localite": "Montbrelloz"
        },
        {
            "code": "1482",
            "localite": "Cugy FR"
        },
        {
            "code": "1483",
            "localite": "Frasses"
        },
        {
            "code": "1483",
            "localite": "Montet (Broye)"
        },
        {
            "code": "1483",
            "localite": "Vesin"
        },
        {
            "code": "1484",
            "localite": "Aumont"
        },
        {
            "code": "1484",
            "localite": "Granges-de-Vesin"
        },
        {
            "code": "1485",
            "localite": "Nuvilly"
        },
        {
            "code": "1486",
            "localite": "Vuissens"
        },
        {
            "code": "1489",
            "localite": "Murist"
        },
        {
            "code": "1509",
            "localite": "Vucherens"
        },
        {
            "code": "1510",
            "localite": "Moudon"
        },
        {
            "code": "1510",
            "localite": "Syens"
        },
        {
            "code": "1512",
            "localite": "Chavannes-sur-Moudon"
        },
        {
            "code": "1513",
            "localite": "Hermenches"
        },
        {
            "code": "1513",
            "localite": "Rossenges"
        },
        {
            "code": "1514",
            "localite": "Bussy-sur-Moudon"
        },
        {
            "code": "1515",
            "localite": "Neyruz-sur-Moudon"
        },
        {
            "code": "1515",
            "localite": "Villars-le-Comte"
        },
        {
            "code": "1521",
            "localite": "Curtilles"
        },
        {
            "code": "1522",
            "localite": "Lucens"
        },
        {
            "code": "1522",
            "localite": "Oulens-sur-Lucens"
        },
        {
            "code": "1523",
            "localite": "Granges-près-Marnand"
        },
        {
            "code": "1524",
            "localite": "Marnand"
        },
        {
            "code": "1525",
            "localite": "Henniez"
        },
        {
            "code": "1525",
            "localite": "Seigneux"
        },
        {
            "code": "1526",
            "localite": "Cremin"
        },
        {
            "code": "1526",
            "localite": "Forel-sur-Lucens"
        },
        {
            "code": "1527",
            "localite": "Villeneuve FR"
        },
        {
            "code": "1528",
            "localite": "Praratoud"
        },
        {
            "code": "1528",
            "localite": "Surpierre"
        },
        {
            "code": "1529",
            "localite": "Cheiry"
        },
        {
            "code": "1530",
            "localite": "Payerne"
        },
        {
            "code": "1532",
            "localite": "Fétigny"
        },
        {
            "code": "1533",
            "localite": "Ménières"
        },
        {
            "code": "1534",
            "localite": "Chapelle (Broye)"
        },
        {
            "code": "1534",
            "localite": "Sassel"
        },
        {
            "code": "1535",
            "localite": "Combremont-le-Grand"
        },
        {
            "code": "1536",
            "localite": "Combremont-le-Petit"
        },
        {
            "code": "1537",
            "localite": "Champtauroz"
        },
        {
            "code": "1538",
            "localite": "Treytorrens (Payerne)"
        },
        {
            "code": "1541",
            "localite": "Bussy FR"
        },
        {
            "code": "1541",
            "localite": "Morens FR"
        },
        {
            "code": "1541",
            "localite": "Sévaz"
        },
        {
            "code": "1542",
            "localite": "Rueyres-les-Prés"
        },
        {
            "code": "1543",
            "localite": "Grandcour"
        },
        {
            "code": "1544",
            "localite": "Gletterens"
        },
        {
            "code": "1545",
            "localite": "Chevroux"
        },
        {
            "code": "1551",
            "localite": "Vers-chez-Perrin"
        },
        {
            "code": "1552",
            "localite": "Trey"
        },
        {
            "code": "1553",
            "localite": "Châtonnaye"
        },
        {
            "code": "1554",
            "localite": "Rossens VD"
        },
        {
            "code": "1554",
            "localite": "Sédeilles"
        },
        {
            "code": "1555",
            "localite": "Villarzel"
        },
        {
            "code": "1562",
            "localite": "Corcelles-près-Payerne"
        },
        {
            "code": "1563",
            "localite": "Dompierre FR"
        },
        {
            "code": "1564",
            "localite": "Domdidier"
        },
        {
            "code": "1565",
            "localite": "Missy"
        },
        {
            "code": "1565",
            "localite": "Vallon"
        },
        {
            "code": "1566",
            "localite": "Les Friques"
        },
        {
            "code": "1566",
            "localite": "St-Aubin FR"
        },
        {
            "code": "1567",
            "localite": "Delley"
        },
        {
            "code": "1568",
            "localite": "Portalban"
        },
        {
            "code": "1580",
            "localite": "Avenches"
        },
        {
            "code": "1580",
            "localite": "Donatyre"
        },
        {
            "code": "1580",
            "localite": "Oleyres"
        },
        {
            "code": "1583",
            "localite": "Villarepos"
        },
        {
            "code": "1584",
            "localite": "Villars-le-Grand"
        },
        {
            "code": "1585",
            "localite": "Bellerive VD"
        },
        {
            "code": "1585",
            "localite": "Cotterd"
        },
        {
            "code": "1585",
            "localite": "Salavaux"
        },
        {
            "code": "1586",
            "localite": "Vallamand"
        },
        {
            "code": "1587",
            "localite": "Constantine"
        },
        {
            "code": "1587",
            "localite": "Montmagny"
        },
        {
            "code": "1588",
            "localite": "Cudrefin"
        },
        {
            "code": "1589",
            "localite": "Chabrey"
        },
        {
            "code": "1595",
            "localite": "Clavaleyres"
        },
        {
            "code": "1595",
            "localite": "Faoug"
        },
        {
            "code": "1607",
            "localite": "Les Tavernes"
        },
        {
            "code": "1607",
            "localite": "Les Thioleyres"
        },
        {
            "code": "1607",
            "localite": "Palézieux"
        },
        {
            "code": "1607",
            "localite": "Palézieux-Village"
        },
        {
            "code": "1608",
            "localite": "Bussigny-sur-Oron"
        },
        {
            "code": "1608",
            "localite": "Chapelle (Glâne)"
        },
        {
            "code": "1608",
            "localite": "Chesalles-sur-Oron"
        },
        {
            "code": "1608",
            "localite": "Oron-le-Châtel"
        },
        {
            "code": "1609",
            "localite": "Besencens"
        },
        {
            "code": "1609",
            "localite": "Fiaugères"
        },
        {
            "code": "1609",
            "localite": "St-Martin FR"
        },
        {
            "code": "1610",
            "localite": "Châtillens"
        },
        {
            "code": "1610",
            "localite": "Oron-la-Ville"
        },
        {
            "code": "1610",
            "localite": "Vuibroye"
        },
        {
            "code": "1611",
            "localite": "Le Crêt-près-Semsales"
        },
        {
            "code": "1612",
            "localite": "Ecoteaux"
        },
        {
            "code": "1613",
            "localite": "Maracon"
        },
        {
            "code": "1614",
            "localite": "Granges (Veveyse)"
        },
        {
            "code": "1615",
            "localite": "Bossonnens"
        },
        {
            "code": "1616",
            "localite": "Attalens"
        },
        {
            "code": "1617",
            "localite": "Remaufens"
        },
        {
            "code": "1617",
            "localite": "Tatroz"
        },
        {
            "code": "1618",
            "localite": "Châtel-St-Denis"
        },
        {
            "code": "1619",
            "localite": "Les Paccots"
        },
        {
            "code": "1623",
            "localite": "Semsales"
        },
        {
            "code": "1624",
            "localite": "Grattavache"
        },
        {
            "code": "1624",
            "localite": "La Verrerie"
        },
        {
            "code": "1624",
            "localite": "Progens"
        },
        {
            "code": "1625",
            "localite": "Maules"
        },
        {
            "code": "1625",
            "localite": "Sâles (Gruyère)"
        },
        {
            "code": "1626",
            "localite": "Romanens"
        },
        {
            "code": "1626",
            "localite": "Rueyres-Treyfayes"
        },
        {
            "code": "1627",
            "localite": "Vaulruz"
        },
        {
            "code": "1628",
            "localite": "Vuadens"
        },
        {
            "code": "1630",
            "localite": "Bulle"
        },
        {
            "code": "1632",
            "localite": "Riaz"
        },
        {
            "code": "1633",
            "localite": "Marsens"
        },
        {
            "code": "1633",
            "localite": "Vuippens"
        },
        {
            "code": "1634",
            "localite": "La Roche FR"
        },
        {
            "code": "1635",
            "localite": "La Tour-de-Trême"
        },
        {
            "code": "1636",
            "localite": "Broc"
        },
        {
            "code": "1637",
            "localite": "Charmey (Gruyère)"
        },
        {
            "code": "1638",
            "localite": "Morlon"
        },
        {
            "code": "1642",
            "localite": "Sorens"
        },
        {
            "code": "1643",
            "localite": "Gumefens"
        },
        {
            "code": "1644",
            "localite": "Avry-devant-Pont"
        },
        {
            "code": "1645",
            "localite": "Le Bry"
        },
        {
            "code": "1646",
            "localite": "Echarlens"
        },
        {
            "code": "1647",
            "localite": "Corbières"
        },
        {
            "code": "1648",
            "localite": "Hauteville"
        },
        {
            "code": "1649",
            "localite": "Pont-la-Ville"
        },
        {
            "code": "1651",
            "localite": "Villarvolard"
        },
        {
            "code": "1652",
            "localite": "Botterens"
        },
        {
            "code": "1652",
            "localite": "Villarbeney"
        },
        {
            "code": "1653",
            "localite": "Châtel-sur-Montsalvens"
        },
        {
            "code": "1653",
            "localite": "Crésuz"
        },
        {
            "code": "1654",
            "localite": "Cerniat FR"
        },
        {
            "code": "1656",
            "localite": "Im Fang"
        },
        {
            "code": "1656",
            "localite": "Jaun"
        },
        {
            "code": "1657",
            "localite": "Abländschen"
        },
        {
            "code": "1658",
            "localite": "La Tine"
        },
        {
            "code": "1658",
            "localite": "Rossinière"
        },
        {
            "code": "1659",
            "localite": "Flendruz"
        },
        {
            "code": "1659",
            "localite": "Rougemont"
        },
        {
            "code": "1660",
            "localite": "Château-d'Oex"
        },
        {
            "code": "1660",
            "localite": "L'Etivaz"
        },
        {
            "code": "1660",
            "localite": "La Lécherette"
        },
        {
            "code": "1660",
            "localite": "Les Moulins"
        },
        {
            "code": "1661",
            "localite": "Le Pâquier-Montbarry"
        },
        {
            "code": "1663",
            "localite": "Epagny"
        },
        {
            "code": "1663",
            "localite": "Gruyères"
        },
        {
            "code": "1663",
            "localite": "Moléson-sur-Gruyères"
        },
        {
            "code": "1663",
            "localite": "Pringy"
        },
        {
            "code": "1665",
            "localite": "Estavannens"
        },
        {
            "code": "1666",
            "localite": "Grandvillard"
        },
        {
            "code": "1666",
            "localite": "Villars-sous-Mont"
        },
        {
            "code": "1667",
            "localite": "Enney"
        },
        {
            "code": "1669",
            "localite": "Albeuve"
        },
        {
            "code": "1669",
            "localite": "Les Sciernes-d'Albeuve"
        },
        {
            "code": "1669",
            "localite": "Lessoc"
        },
        {
            "code": "1669",
            "localite": "Montbovon"
        },
        {
            "code": "1669",
            "localite": "Neirivue"
        },
        {
            "code": "1670",
            "localite": "Bionnens"
        },
        {
            "code": "1670",
            "localite": "Esmonts"
        },
        {
            "code": "1670",
            "localite": "Ursy"
        },
        {
            "code": "1673",
            "localite": "Auboranges"
        },
        {
            "code": "1673",
            "localite": "Ecublens FR"
        },
        {
            "code": "1673",
            "localite": "Gillarens"
        },
        {
            "code": "1673",
            "localite": "Promasens"
        },
        {
            "code": "1673",
            "localite": "Rue"
        },
        {
            "code": "1674",
            "localite": "Montet (Glâne)"
        },
        {
            "code": "1674",
            "localite": "Morlens"
        },
        {
            "code": "1674",
            "localite": "Vuarmarens"
        },
        {
            "code": "1675",
            "localite": "Blessens"
        },
        {
            "code": "1675",
            "localite": "Mossel"
        },
        {
            "code": "1675",
            "localite": "Vauderens"
        },
        {
            "code": "1676",
            "localite": "Chavannes-les-Forts"
        },
        {
            "code": "1677",
            "localite": "Prez-vers-Siviriez"
        },
        {
            "code": "1678",
            "localite": "Siviriez"
        },
        {
            "code": "1679",
            "localite": "Villaraboud"
        },
        {
            "code": "1680",
            "localite": "Berlens"
        },
        {
            "code": "1680",
            "localite": "Romont FR"
        },
        {
            "code": "1681",
            "localite": "Billens"
        },
        {
            "code": "1681",
            "localite": "Hennens"
        },
        {
            "code": "1682",
            "localite": "Cerniaz VD"
        },
        {
            "code": "1682",
            "localite": "Dompierre VD"
        },
        {
            "code": "1682",
            "localite": "Lovatens"
        },
        {
            "code": "1682",
            "localite": "Prévonloup"
        },
        {
            "code": "1682",
            "localite": "Villars-Bramard"
        },
        {
            "code": "1683",
            "localite": "Brenles"
        },
        {
            "code": "1683",
            "localite": "Chesalles-sur-Moudon"
        },
        {
            "code": "1683",
            "localite": "Sarzens"
        },
        {
            "code": "1684",
            "localite": "Mézières FR"
        },
        {
            "code": "1685",
            "localite": "Villariaz"
        },
        {
            "code": "1686",
            "localite": "Grangettes-près-Romont"
        },
        {
            "code": "1686",
            "localite": "La Neirigue"
        },
        {
            "code": "1687",
            "localite": "Estévenens"
        },
        {
            "code": "1687",
            "localite": "La Magne"
        },
        {
            "code": "1687",
            "localite": "Vuisternens-devant-Romont"
        },
        {
            "code": "1688",
            "localite": "Lieffrens"
        },
        {
            "code": "1688",
            "localite": "Sommentier"
        },
        {
            "code": "1689",
            "localite": "Le Châtelard-près-Romont"
        },
        {
            "code": "1690",
            "localite": "Lussy FR"
        },
        {
            "code": "1690",
            "localite": "Villaz-St-Pierre"
        },
        {
            "code": "1691",
            "localite": "Villarimboud"
        },
        {
            "code": "1692",
            "localite": "Massonnens"
        },
        {
            "code": "1694",
            "localite": "Chavannes-sous-Orsonnens"
        },
        {
            "code": "1694",
            "localite": "Orsonnens"
        },
        {
            "code": "1694",
            "localite": "Villargiroud"
        },
        {
            "code": "1694",
            "localite": "Villarsiviriaux"
        },
        {
            "code": "1695",
            "localite": "Estavayer-le-Gibloux"
        },
        {
            "code": "1695",
            "localite": "Rueyres-St-Laurent"
        },
        {
            "code": "1695",
            "localite": "Villarlod"
        },
        {
            "code": "1695",
            "localite": "Villarsel-le-Gibloux"
        },
        {
            "code": "1696",
            "localite": "Vuisternens-en-Ogoz"
        },
        {
            "code": "1697",
            "localite": "La Joux FR"
        },
        {
            "code": "1697",
            "localite": "Les Ecasseys"
        },
        {
            "code": "1699",
            "localite": "Bouloz"
        },
        {
            "code": "1699",
            "localite": "Pont (Veveyse)"
        },
        {
            "code": "1699",
            "localite": "Porsel"
        },
        {
            "code": "1700",
            "localite": "Fribourg"
        },
        {
            "code": "1712",
            "localite": "Tafers"
        },
        {
            "code": "1713",
            "localite": "St. Antoni"
        },
        {
            "code": "1714",
            "localite": "Heitenried"
        },
        {
            "code": "1715",
            "localite": "Alterswil FR"
        },
        {
            "code": "1716",
            "localite": "Oberschrot"
        },
        {
            "code": "1716",
            "localite": "Plaffeien"
        },
        {
            "code": "1716",
            "localite": "Schwarzsee"
        },
        {
            "code": "1717",
            "localite": "St. Ursen"
        },
        {
            "code": "1718",
            "localite": "Rechthalten"
        },
        {
            "code": "1719",
            "localite": "Brünisried"
        },
        {
            "code": "1719",
            "localite": "Zumholz"
        },
        {
            "code": "1720",
            "localite": "Chésopelloz"
        },
        {
            "code": "1720",
            "localite": "Corminboeuf"
        },
        {
            "code": "1721",
            "localite": "Cormérod"
        },
        {
            "code": "1721",
            "localite": "Cournillens"
        },
        {
            "code": "1721",
            "localite": "Courtion"
        },
        {
            "code": "1721",
            "localite": "Misery"
        },
        {
            "code": "1722",
            "localite": "Bourguillon"
        },
        {
            "code": "1723",
            "localite": "Marly"
        },
        {
            "code": "1723",
            "localite": "Pierrafortscha"
        },
        {
            "code": "1723",
            "localite": "Villarsel-sur-Marly"
        },
        {
            "code": "1724",
            "localite": "Bonnefontaine"
        },
        {
            "code": "1724",
            "localite": "Essert FR"
        },
        {
            "code": "1724",
            "localite": "Ferpicloz"
        },
        {
            "code": "1724",
            "localite": "Le Mouret"
        },
        {
            "code": "1724",
            "localite": "Montévraz"
        },
        {
            "code": "1724",
            "localite": "Oberried FR"
        },
        {
            "code": "1724",
            "localite": "Senèdes"
        },
        {
            "code": "1724",
            "localite": "Zénauva"
        },
        {
            "code": "1725",
            "localite": "Posieux"
        },
        {
            "code": "1726",
            "localite": "Farvagny-le-Grand"
        },
        {
            "code": "1726",
            "localite": "Farvagny-le-Petit"
        },
        {
            "code": "1726",
            "localite": "Grenilles"
        },
        {
            "code": "1726",
            "localite": "Posat"
        },
        {
            "code": "1727",
            "localite": "Corpataux"
        },
        {
            "code": "1727",
            "localite": "Magnedens"
        },
        {
            "code": "1728",
            "localite": "Rossens FR"
        },
        {
            "code": "1730",
            "localite": "Ecuvillens"
        },
        {
            "code": "1731",
            "localite": "Ependes FR"
        },
        {
            "code": "1732",
            "localite": "Arconciel"
        },
        {
            "code": "1733",
            "localite": "Treyvaux"
        },
        {
            "code": "1734",
            "localite": "Tentlingen"
        },
        {
            "code": "1735",
            "localite": "Giffers"
        },
        {
            "code": "1736",
            "localite": "St. Silvester"
        },
        {
            "code": "1737",
            "localite": "Plasselb"
        },
        {
            "code": "1738",
            "localite": "Sangernboden"
        },
        {
            "code": "1740",
            "localite": "Neyruz FR"
        },
        {
            "code": "1741",
            "localite": "Cottens FR"
        },
        {
            "code": "1742",
            "localite": "Autigny"
        },
        {
            "code": "1744",
            "localite": "Chénens"
        },
        {
            "code": "1745",
            "localite": "Lentigny"
        },
        {
            "code": "1746",
            "localite": "Prez-vers-Noréaz"
        },
        {
            "code": "1747",
            "localite": "Corserey"
        },
        {
            "code": "1748",
            "localite": "Torny-le-Grand"
        },
        {
            "code": "1749",
            "localite": "Middes"
        },
        {
            "code": "1752",
            "localite": "Villars-sur-Glâne"
        },
        {
            "code": "1753",
            "localite": "Matran"
        },
        {
            "code": "1754",
            "localite": "Avry-sur-Matran"
        },
        {
            "code": "1754",
            "localite": "Corjolens"
        },
        {
            "code": "1756",
            "localite": "Lovens"
        },
        {
            "code": "1756",
            "localite": "Onnens FR"
        },
        {
            "code": "1757",
            "localite": "Noréaz"
        },
        {
            "code": "1762",
            "localite": "Givisiez"
        },
        {
            "code": "1763",
            "localite": "Granges-Paccot"
        },
        {
            "code": "1772",
            "localite": "Grolley"
        },
        {
            "code": "1772",
            "localite": "Nierlet-les-Bois"
        },
        {
            "code": "1772",
            "localite": "Ponthaux"
        },
        {
            "code": "1773",
            "localite": "Chandon"
        },
        {
            "code": "1773",
            "localite": "Léchelles"
        },
        {
            "code": "1773",
            "localite": "Russy"
        },
        {
            "code": "1774",
            "localite": "Cousset"
        },
        {
            "code": "1774",
            "localite": "Montagny-les-Monts"
        },
        {
            "code": "1775",
            "localite": "Grandsivaz"
        },
        {
            "code": "1775",
            "localite": "Mannens"
        },
        {
            "code": "1776",
            "localite": "Montagny-la-Ville"
        },
        {
            "code": "1782",
            "localite": "Autafond"
        },
        {
            "code": "1782",
            "localite": "Belfaux"
        },
        {
            "code": "1782",
            "localite": "Cormagens"
        },
        {
            "code": "1782",
            "localite": "Formangueires"
        },
        {
            "code": "1782",
            "localite": "La Corbaz"
        },
        {
            "code": "1782",
            "localite": "Lossy"
        },
        {
            "code": "1783",
            "localite": "Barberêche"
        },
        {
            "code": "1783",
            "localite": "Pensier"
        },
        {
            "code": "1784",
            "localite": "Courtepin"
        },
        {
            "code": "1784",
            "localite": "Wallenried"
        },
        {
            "code": "1785",
            "localite": "Cressier FR"
        },
        {
            "code": "1786",
            "localite": "Sugiez"
        },
        {
            "code": "1787",
            "localite": "Mur (Vully) FR"
        },
        {
            "code": "1787",
            "localite": "Mur (Vully) VD"
        },
        {
            "code": "1787",
            "localite": "Môtier (Vully)"
        },
        {
            "code": "1788",
            "localite": "Praz (Vully)"
        },
        {
            "code": "1789",
            "localite": "Lugnorre"
        },
        {
            "code": "1791",
            "localite": "Courtaman"
        },
        {
            "code": "1792",
            "localite": "Cordast"
        },
        {
            "code": "1792",
            "localite": "Guschelmuth"
        },
        {
            "code": "1793",
            "localite": "Jeuss"
        },
        {
            "code": "1794",
            "localite": "Salvenach"
        },
        {
            "code": "1795",
            "localite": "Courlevon"
        },
        {
            "code": "1796",
            "localite": "Courgevaux"
        },
        {
            "code": "1797",
            "localite": "Münchenwiler"
        },
        {
            "code": "1800",
            "localite": "Vevey"
        },
        {
            "code": "1801",
            "localite": "Le Mont-Pèlerin"
        },
        {
            "code": "1802",
            "localite": "Corseaux"
        },
        {
            "code": "1803",
            "localite": "Chardonne"
        },
        {
            "code": "1804",
            "localite": "Corsier-sur-Vevey"
        },
        {
            "code": "1805",
            "localite": "Jongny"
        },
        {
            "code": "1806",
            "localite": "St-Légier-La Chiésaz"
        },
        {
            "code": "1807",
            "localite": "Blonay"
        },
        {
            "code": "1808",
            "localite": "Les Monts-de-Corsier"
        },
        {
            "code": "1809",
            "localite": "Fenil-sur-Corsier"
        },
        {
            "code": "1814",
            "localite": "La Tour-de-Peilz"
        },
        {
            "code": "1815",
            "localite": "Clarens"
        },
        {
            "code": "1816",
            "localite": "Chailly-Montreux"
        },
        {
            "code": "1817",
            "localite": "Brent"
        },
        {
            "code": "1820",
            "localite": "Montreux"
        },
        {
            "code": "1820",
            "localite": "Territet"
        },
        {
            "code": "1820",
            "localite": "Veytaux"
        },
        {
            "code": "1822",
            "localite": "Chernex"
        },
        {
            "code": "1823",
            "localite": "Glion"
        },
        {
            "code": "1824",
            "localite": "Caux"
        },
        {
            "code": "1832",
            "localite": "Chamby"
        },
        {
            "code": "1832",
            "localite": "Villard-sur-Chamby"
        },
        {
            "code": "1833",
            "localite": "Les Avants"
        },
        {
            "code": "1844",
            "localite": "Villeneuve VD"
        },
        {
            "code": "1845",
            "localite": "Noville"
        },
        {
            "code": "1846",
            "localite": "Chessel"
        },
        {
            "code": "1847",
            "localite": "Rennaz"
        },
        {
            "code": "1852",
            "localite": "Roche VD"
        },
        {
            "code": "1853",
            "localite": "Yvorne"
        },
        {
            "code": "1854",
            "localite": "Leysin"
        },
        {
            "code": "1856",
            "localite": "Corbeyrier"
        },
        {
            "code": "1860",
            "localite": "Aigle"
        },
        {
            "code": "1862",
            "localite": "La Comballaz"
        },
        {
            "code": "1862",
            "localite": "Les Mosses"
        },
        {
            "code": "1863",
            "localite": "Le Sépey"
        },
        {
            "code": "1864",
            "localite": "Vers-l'Eglise"
        },
        {
            "code": "1865",
            "localite": "Les Diablerets"
        },
        {
            "code": "1866",
            "localite": "La Forclaz VD"
        },
        {
            "code": "1867",
            "localite": "Ollon VD"
        },
        {
            "code": "1867",
            "localite": "Panex"
        },
        {
            "code": "1867",
            "localite": "St-Triphon"
        },
        {
            "code": "1868",
            "localite": "Collombey"
        },
        {
            "code": "1869",
            "localite": "Massongex"
        },
        {
            "code": "1870",
            "localite": "Monthey"
        },
        {
            "code": "1871",
            "localite": "Choëx"
        },
        {
            "code": "1871",
            "localite": "Les Giettes"
        },
        {
            "code": "1872",
            "localite": "Troistorrents"
        },
        {
            "code": "1873",
            "localite": "Champoussin"
        },
        {
            "code": "1873",
            "localite": "Les Crosets"
        },
        {
            "code": "1873",
            "localite": "Val-d'Illiez"
        },
        {
            "code": "1874",
            "localite": "Champéry"
        },
        {
            "code": "1875",
            "localite": "Morgins"
        },
        {
            "code": "1880",
            "localite": "Bex"
        },
        {
            "code": "1880",
            "localite": "Fenalet-sur-Bex"
        },
        {
            "code": "1880",
            "localite": "Frenières-sur-Bex"
        },
        {
            "code": "1880",
            "localite": "Les Plans-sur-Bex"
        },
        {
            "code": "1880",
            "localite": "Les Posses-sur-Bex"
        },
        {
            "code": "1882",
            "localite": "Gryon"
        },
        {
            "code": "1884",
            "localite": "Arveyes"
        },
        {
            "code": "1884",
            "localite": "Huémoz"
        },
        {
            "code": "1884",
            "localite": "Villars-sur-Ollon"
        },
        {
            "code": "1885",
            "localite": "Chesières"
        },
        {
            "code": "1890",
            "localite": "Mex VS"
        },
        {
            "code": "1890",
            "localite": "St-Maurice"
        },
        {
            "code": "1891",
            "localite": "Vérossaz"
        },
        {
            "code": "1892",
            "localite": "Lavey-Village"
        },
        {
            "code": "1892",
            "localite": "Lavey-les-Bains"
        },
        {
            "code": "1892",
            "localite": "Morcles"
        },
        {
            "code": "1893",
            "localite": "Muraz (Collombey)"
        },
        {
            "code": "1895",
            "localite": "Vionnaz"
        },
        {
            "code": "1896",
            "localite": "Miex"
        },
        {
            "code": "1896",
            "localite": "Vouvry"
        },
        {
            "code": "1897",
            "localite": "Bouveret"
        },
        {
            "code": "1897",
            "localite": "Les Evouettes"
        },
        {
            "code": "1898",
            "localite": "St-Gingolph"
        },
        {
            "code": "1899",
            "localite": "Torgon"
        },
        {
            "code": "1902",
            "localite": "Evionnaz"
        },
        {
            "code": "1903",
            "localite": "Collonges"
        },
        {
            "code": "1904",
            "localite": "Vernayaz"
        },
        {
            "code": "1905",
            "localite": "Dorénaz"
        },
        {
            "code": "1906",
            "localite": "Charrat"
        },
        {
            "code": "1907",
            "localite": "Saxon"
        },
        {
            "code": "1908",
            "localite": "Riddes"
        },
        {
            "code": "1911",
            "localite": "Ovronnaz"
        },
        {
            "code": "1912",
            "localite": "Dugny (Leytron)"
        },
        {
            "code": "1912",
            "localite": "Leytron"
        },
        {
            "code": "1912",
            "localite": "Montagnon (Leytron)"
        },
        {
            "code": "1912",
            "localite": "Produit (Leytron)"
        },
        {
            "code": "1913",
            "localite": "Saillon"
        },
        {
            "code": "1914",
            "localite": "Auddes-sur-Riddes"
        },
        {
            "code": "1914",
            "localite": "Isérables"
        },
        {
            "code": "1918",
            "localite": "La Tzoumaz"
        },
        {
            "code": "1920",
            "localite": "Martigny"
        },
        {
            "code": "1921",
            "localite": "Martigny-Croix"
        },
        {
            "code": "1922",
            "localite": "Les Granges (Salvan)"
        },
        {
            "code": "1922",
            "localite": "Salvan"
        },
        {
            "code": "1923",
            "localite": "Le Trétien"
        },
        {
            "code": "1923",
            "localite": "Les Marécottes"
        },
        {
            "code": "1925",
            "localite": "Finhaut"
        },
        {
            "code": "1925",
            "localite": "Le Châtelard VS"
        },
        {
            "code": "1926",
            "localite": "Fully"
        },
        {
            "code": "1927",
            "localite": "Chemin"
        },
        {
            "code": "1928",
            "localite": "Ravoire"
        },
        {
            "code": "1929",
            "localite": "Trient"
        },
        {
            "code": "1932",
            "localite": "Bovernier"
        },
        {
            "code": "1932",
            "localite": "Les Valettes (Bovernier)"
        },
        {
            "code": "1933",
            "localite": "Chamoille (Sembrancher)"
        },
        {
            "code": "1933",
            "localite": "La Garde (Sembrancher)"
        },
        {
            "code": "1933",
            "localite": "Sembrancher"
        },
        {
            "code": "1933",
            "localite": "Vens (Sembrancher)"
        },
        {
            "code": "1934",
            "localite": "Bruson"
        },
        {
            "code": "1934",
            "localite": "Le Châble VS"
        },
        {
            "code": "1936",
            "localite": "Verbier"
        },
        {
            "code": "1937",
            "localite": "Orsières"
        },
        {
            "code": "1938",
            "localite": "Champex-Lac"
        },
        {
            "code": "1941",
            "localite": "Cries (Vollèges)"
        },
        {
            "code": "1941",
            "localite": "Vollèges"
        },
        {
            "code": "1942",
            "localite": "Levron"
        },
        {
            "code": "1943",
            "localite": "Praz-de-Fort"
        },
        {
            "code": "1944",
            "localite": "La Fouly VS"
        },
        {
            "code": "1945",
            "localite": "Chandonne (Liddes)"
        },
        {
            "code": "1945",
            "localite": "Chez Petit (Liddes)"
        },
        {
            "code": "1945",
            "localite": "Dranse (Liddes)"
        },
        {
            "code": "1945",
            "localite": "Fontaine Dessous (Liddes)"
        },
        {
            "code": "1945",
            "localite": "Fontaine Dessus (Liddes)"
        },
        {
            "code": "1945",
            "localite": "Fornex (Liddes)"
        },
        {
            "code": "1945",
            "localite": "Les Moulins VS (Liddes)"
        },
        {
            "code": "1945",
            "localite": "Liddes"
        },
        {
            "code": "1945",
            "localite": "Palasuit (Liddes)"
        },
        {
            "code": "1945",
            "localite": "Petit Vichères (Liddes)"
        },
        {
            "code": "1945",
            "localite": "Rive Haute (Liddes)"
        },
        {
            "code": "1945",
            "localite": "Vichères (Liddes)"
        },
        {
            "code": "1946",
            "localite": "Bourg-St-Pierre"
        },
        {
            "code": "1947",
            "localite": "Champsec"
        },
        {
            "code": "1947",
            "localite": "Versegères"
        },
        {
            "code": "1948",
            "localite": "Fionnay"
        },
        {
            "code": "1948",
            "localite": "Lourtier"
        },
        {
            "code": "1948",
            "localite": "Sarreyer"
        },
        {
            "code": "1950",
            "localite": "Sion"
        },
        {
            "code": "1955",
            "localite": "Chamoson"
        },
        {
            "code": "1955",
            "localite": "Grugnay (Chamoson)"
        },
        {
            "code": "1955",
            "localite": "Les Vérines (Chamoson)"
        },
        {
            "code": "1955",
            "localite": "Mayens-de-Chamoson"
        },
        {
            "code": "1955",
            "localite": "Némiaz (Chamoson)"
        },
        {
            "code": "1955",
            "localite": "St-Pierre-de-Clages"
        },
        {
            "code": "1957",
            "localite": "Ardon"
        },
        {
            "code": "1958",
            "localite": "St-Léonard"
        },
        {
            "code": "1958",
            "localite": "Uvrier"
        },
        {
            "code": "1961",
            "localite": "Vernamiège"
        },
        {
            "code": "1962",
            "localite": "Pont-de-la-Morge (Sion)"
        },
        {
            "code": "1963",
            "localite": "Vétroz"
        },
        {
            "code": "1964",
            "localite": "Conthey"
        },
        {
            "code": "1965",
            "localite": "Savièse"
        },
        {
            "code": "1966",
            "localite": "Argnou (Ayent)"
        },
        {
            "code": "1966",
            "localite": "Blignou (Ayent)"
        },
        {
            "code": "1966",
            "localite": "Botyre (Ayent)"
        },
        {
            "code": "1966",
            "localite": "Fortunau (Ayent)"
        },
        {
            "code": "1966",
            "localite": "La Place (Ayent)"
        },
        {
            "code": "1966",
            "localite": "Luc (Ayent)"
        },
        {
            "code": "1966",
            "localite": "Saxonne (Ayent)"
        },
        {
            "code": "1966",
            "localite": "Signèse (Ayent)"
        },
        {
            "code": "1966",
            "localite": "St-Romain (Ayent)"
        },
        {
            "code": "1966",
            "localite": "Villa (Ayent)"
        },
        {
            "code": "1967",
            "localite": "Bramois"
        },
        {
            "code": "1968",
            "localite": "Mase"
        },
        {
            "code": "1969",
            "localite": "Eison (St-Martin)"
        },
        {
            "code": "1969",
            "localite": "Liez (St-Martin)"
        },
        {
            "code": "1969",
            "localite": "St-Martin VS"
        },
        {
            "code": "1969",
            "localite": "Suen (St-Martin)"
        },
        {
            "code": "1969",
            "localite": "Trogne (St-Martin)"
        },
        {
            "code": "1971",
            "localite": "Champlan (Grimisuat)"
        },
        {
            "code": "1971",
            "localite": "Grimisuat"
        },
        {
            "code": "1972",
            "localite": "Anzère"
        },
        {
            "code": "1973",
            "localite": "Nax"
        },
        {
            "code": "1974",
            "localite": "Arbaz"
        },
        {
            "code": "1975",
            "localite": "St-Séverin"
        },
        {
            "code": "1976",
            "localite": "Aven"
        },
        {
            "code": "1976",
            "localite": "Daillon"
        },
        {
            "code": "1976",
            "localite": "Erde"
        },
        {
            "code": "1977",
            "localite": "Icogne"
        },
        {
            "code": "1978",
            "localite": "Lens"
        },
        {
            "code": "1981",
            "localite": "Vex"
        },
        {
            "code": "1982",
            "localite": "Euseigne"
        },
        {
            "code": "1983",
            "localite": "Evolène"
        },
        {
            "code": "1983",
            "localite": "Lanna"
        },
        {
            "code": "1984",
            "localite": "La Tour VS"
        },
        {
            "code": "1984",
            "localite": "Les Haudères"
        },
        {
            "code": "1985",
            "localite": "La Forclaz VS"
        },
        {
            "code": "1985",
            "localite": "La Sage"
        },
        {
            "code": "1985",
            "localite": "Villa (Evolène)"
        },
        {
            "code": "1986",
            "localite": "Arolla"
        },
        {
            "code": "1987",
            "localite": "Hérémence"
        },
        {
            "code": "1988",
            "localite": "Les Collons"
        },
        {
            "code": "1988",
            "localite": "Thyon"
        },
        {
            "code": "1991",
            "localite": "Arvillard (Salins)"
        },
        {
            "code": "1991",
            "localite": "Misériez (Salins)"
        },
        {
            "code": "1991",
            "localite": "Pravidondaz (Salins)"
        },
        {
            "code": "1991",
            "localite": "Salins"
        },
        {
            "code": "1991",
            "localite": "Turin (Salins)"
        },
        {
            "code": "1992",
            "localite": "Crête-à-l'Oeil (Les Agettes)"
        },
        {
            "code": "1992",
            "localite": "La Vernaz (Les Agettes)"
        },
        {
            "code": "1992",
            "localite": "Les Agettes"
        },
        {
            "code": "1992",
            "localite": "Les Mayens-de-Sion"
        },
        {
            "code": "1993",
            "localite": "Clèbes (Nendaz)"
        },
        {
            "code": "1993",
            "localite": "Veysonnaz"
        },
        {
            "code": "1994",
            "localite": "Aproz (Nendaz)"
        },
        {
            "code": "1996",
            "localite": "Baar (Nendaz)"
        },
        {
            "code": "1996",
            "localite": "Basse-Nendaz"
        },
        {
            "code": "1996",
            "localite": "Beuson (Nendaz)"
        },
        {
            "code": "1996",
            "localite": "Bieudron (Nendaz)"
        },
        {
            "code": "1996",
            "localite": "Brignon (Nendaz)"
        },
        {
            "code": "1996",
            "localite": "Condémines (Nendaz)"
        },
        {
            "code": "1996",
            "localite": "Fey (Nendaz)"
        },
        {
            "code": "1996",
            "localite": "Saclentse"
        },
        {
            "code": "1997",
            "localite": "Haute-Nendaz"
        },
        {
            "code": "1997",
            "localite": "Siviez (Nendaz)"
        },
        {
            "code": "1997",
            "localite": "Sornard (Nendaz)"
        },
        {
            "code": "2000",
            "localite": "Neuchâtel"
        },
        {
            "code": "2012",
            "localite": "Auvernier"
        },
        {
            "code": "2013",
            "localite": "Colombier NE"
        },
        {
            "code": "2014",
            "localite": "Bôle"
        },
        {
            "code": "2015",
            "localite": "Areuse"
        },
        {
            "code": "2016",
            "localite": "Cortaillod"
        },
        {
            "code": "2017",
            "localite": "Boudry"
        },
        {
            "code": "2019",
            "localite": "Chambrelien"
        },
        {
            "code": "2019",
            "localite": "Rochefort"
        },
        {
            "code": "2022",
            "localite": "Bevaix"
        },
        {
            "code": "2023",
            "localite": "Gorgier"
        },
        {
            "code": "2024",
            "localite": "St-Aubin-Sauges"
        },
        {
            "code": "2025",
            "localite": "Chez-le-Bart"
        },
        {
            "code": "2027",
            "localite": "Fresens"
        },
        {
            "code": "2027",
            "localite": "Montalchez"
        },
        {
            "code": "2028",
            "localite": "Vaumarcus"
        },
        {
            "code": "2034",
            "localite": "Peseux"
        },
        {
            "code": "2035",
            "localite": "Corcelles NE"
        },
        {
            "code": "2036",
            "localite": "Cormondrèche"
        },
        {
            "code": "2037",
            "localite": "Montezillon"
        },
        {
            "code": "2037",
            "localite": "Montmollin"
        },
        {
            "code": "2042",
            "localite": "Valangin"
        },
        {
            "code": "2043",
            "localite": "Boudevilliers"
        },
        {
            "code": "2046",
            "localite": "Fontaines NE"
        },
        {
            "code": "2052",
            "localite": "Fontainemelon"
        },
        {
            "code": "2052",
            "localite": "La Vue-des-Alpes"
        },
        {
            "code": "2053",
            "localite": "Cernier"
        },
        {
            "code": "2054",
            "localite": "Chézard-St-Martin"
        },
        {
            "code": "2054",
            "localite": "Les Vieux-Prés"
        },
        {
            "code": "2056",
            "localite": "Dombresson"
        },
        {
            "code": "2057",
            "localite": "Villiers"
        },
        {
            "code": "2058",
            "localite": "Le Pâquier NE"
        },
        {
            "code": "2063",
            "localite": "Engollon"
        },
        {
            "code": "2063",
            "localite": "Fenin"
        },
        {
            "code": "2063",
            "localite": "Saules"
        },
        {
            "code": "2063",
            "localite": "Vilars NE"
        },
        {
            "code": "2065",
            "localite": "Savagnier"
        },
        {
            "code": "2067",
            "localite": "Chaumont"
        },
        {
            "code": "2068",
            "localite": "Hauterive NE"
        },
        {
            "code": "2072",
            "localite": "St-Blaise"
        },
        {
            "code": "2073",
            "localite": "Enges"
        },
        {
            "code": "2074",
            "localite": "Marin-Epagnier"
        },
        {
            "code": "2075",
            "localite": "Thielle"
        },
        {
            "code": "2075",
            "localite": "Wavre"
        },
        {
            "code": "2087",
            "localite": "Cornaux NE"
        },
        {
            "code": "2088",
            "localite": "Cressier NE"
        },
        {
            "code": "2103",
            "localite": "Noiraigue"
        },
        {
            "code": "2105",
            "localite": "Travers"
        },
        {
            "code": "2108",
            "localite": "Couvet"
        },
        {
            "code": "2112",
            "localite": "Môtiers NE"
        },
        {
            "code": "2113",
            "localite": "Boveresse"
        },
        {
            "code": "2114",
            "localite": "Fleurier"
        },
        {
            "code": "2115",
            "localite": "Buttes"
        },
        {
            "code": "2116",
            "localite": "Mont-de-Buttes"
        },
        {
            "code": "2117",
            "localite": "La Côte-aux-Fées"
        },
        {
            "code": "2123",
            "localite": "St-Sulpice NE"
        },
        {
            "code": "2124",
            "localite": "Les Sagnettes"
        },
        {
            "code": "2126",
            "localite": "Les Verrières"
        },
        {
            "code": "2127",
            "localite": "Les Bayards"
        },
        {
            "code": "2149",
            "localite": "Brot-Dessous"
        },
        {
            "code": "2149",
            "localite": "Champ-du-Moulin"
        },
        {
            "code": "2149",
            "localite": "Fretereules"
        },
        {
            "code": "2206",
            "localite": "Les Geneveys-sur-Coffrane"
        },
        {
            "code": "2207",
            "localite": "Coffrane"
        },
        {
            "code": "2208",
            "localite": "Les Hauts-Geneveys"
        },
        {
            "code": "2300",
            "localite": "La Chaux-de-Fonds"
        },
        {
            "code": "2300",
            "localite": "La Cibourg"
        },
        {
            "code": "2314",
            "localite": "La Sagne NE"
        },
        {
            "code": "2316",
            "localite": "Les Ponts-de-Martel"
        },
        {
            "code": "2316",
            "localite": "Petit-Martel"
        },
        {
            "code": "2318",
            "localite": "Brot-Plamboz"
        },
        {
            "code": "2322",
            "localite": "Le Crêt-du-Locle"
        },
        {
            "code": "2325",
            "localite": "Les Planchettes"
        },
        {
            "code": "2333",
            "localite": "La Cibourg"
        },
        {
            "code": "2333",
            "localite": "La Ferrière"
        },
        {
            "code": "2336",
            "localite": "Les Bois"
        },
        {
            "code": "2338",
            "localite": "Les Emibois"
        },
        {
            "code": "2338",
            "localite": "Muriaux"
        },
        {
            "code": "2340",
            "localite": "Le Noirmont"
        },
        {
            "code": "2345",
            "localite": "La Chaux-des-Breuleux"
        },
        {
            "code": "2345",
            "localite": "Le Cerneux-Veusil"
        },
        {
            "code": "2345",
            "localite": "Le Peuchapatte"
        },
        {
            "code": "2345",
            "localite": "Les Breuleux"
        },
        {
            "code": "2350",
            "localite": "Saignelégier"
        },
        {
            "code": "2353",
            "localite": "Les Pommerats"
        },
        {
            "code": "2354",
            "localite": "Goumois"
        },
        {
            "code": "2360",
            "localite": "Le Bémont JU"
        },
        {
            "code": "2362",
            "localite": "Montfaucon"
        },
        {
            "code": "2362",
            "localite": "Montfavergier"
        },
        {
            "code": "2363",
            "localite": "Les Enfers"
        },
        {
            "code": "2364",
            "localite": "St-Brais"
        },
        {
            "code": "2400",
            "localite": "Le Locle"
        },
        {
            "code": "2400",
            "localite": "Le Prévoux"
        },
        {
            "code": "2405",
            "localite": "La Chaux-du-Milieu"
        },
        {
            "code": "2406",
            "localite": "La Brévine"
        },
        {
            "code": "2406",
            "localite": "La Châtagne"
        },
        {
            "code": "2406",
            "localite": "Le Brouillet"
        },
        {
            "code": "2406",
            "localite": "Les Taillères"
        },
        {
            "code": "2414",
            "localite": "Le Cerneux-Péquignot"
        },
        {
            "code": "2416",
            "localite": "Les Brenets"
        },
        {
            "code": "2502",
            "localite": "Biel/Bienne"
        },
        {
            "code": "2503",
            "localite": "Biel/Bienne"
        },
        {
            "code": "2504",
            "localite": "Biel/Bienne"
        },
        {
            "code": "2505",
            "localite": "Biel/Bienne"
        },
        {
            "code": "2512",
            "localite": "Tüscherz-Alfermée"
        },
        {
            "code": "2513",
            "localite": "Twann"
        },
        {
            "code": "2514",
            "localite": "Ligerz"
        },
        {
            "code": "2515",
            "localite": "Prêles"
        },
        {
            "code": "2516",
            "localite": "Lamboing"
        },
        {
            "code": "2517",
            "localite": "Diesse"
        },
        {
            "code": "2518",
            "localite": "Nods"
        },
        {
            "code": "2520",
            "localite": "La Neuveville"
        },
        {
            "code": "2523",
            "localite": "Lignières"
        },
        {
            "code": "2525",
            "localite": "Le Landeron"
        },
        {
            "code": "2532",
            "localite": "Magglingen/Macolin"
        },
        {
            "code": "2533",
            "localite": "Evilard"
        },
        {
            "code": "2534",
            "localite": "Les Prés-d'Orvin"
        },
        {
            "code": "2534",
            "localite": "Orvin"
        },
        {
            "code": "2535",
            "localite": "Frinvillier"
        },
        {
            "code": "2536",
            "localite": "Plagne"
        },
        {
            "code": "2537",
            "localite": "Vauffelin"
        },
        {
            "code": "2538",
            "localite": "Romont BE"
        },
        {
            "code": "2540",
            "localite": "Grenchen"
        },
        {
            "code": "2542",
            "localite": "Pieterlen"
        },
        {
            "code": "2543",
            "localite": "Lengnau BE"
        },
        {
            "code": "2544",
            "localite": "Bettlach"
        },
        {
            "code": "2545",
            "localite": "Selzach"
        },
        {
            "code": "2552",
            "localite": "Orpund"
        },
        {
            "code": "2553",
            "localite": "Safnern"
        },
        {
            "code": "2554",
            "localite": "Meinisberg"
        },
        {
            "code": "2555",
            "localite": "Brügg BE"
        },
        {
            "code": "2556",
            "localite": "Scheuren"
        },
        {
            "code": "2556",
            "localite": "Schwadernau"
        },
        {
            "code": "2557",
            "localite": "Studen BE"
        },
        {
            "code": "2558",
            "localite": "Aegerten"
        },
        {
            "code": "2560",
            "localite": "Nidau"
        },
        {
            "code": "2562",
            "localite": "Port"
        },
        {
            "code": "2563",
            "localite": "Ipsach"
        },
        {
            "code": "2564",
            "localite": "Bellmund"
        },
        {
            "code": "2565",
            "localite": "Jens"
        },
        {
            "code": "2572",
            "localite": "Mörigen"
        },
        {
            "code": "2572",
            "localite": "Sutz"
        },
        {
            "code": "2575",
            "localite": "Gerolfingen"
        },
        {
            "code": "2575",
            "localite": "Hagneck"
        },
        {
            "code": "2575",
            "localite": "Täuffelen"
        },
        {
            "code": "2576",
            "localite": "Lüscherz"
        },
        {
            "code": "2577",
            "localite": "Finsterhennen"
        },
        {
            "code": "2577",
            "localite": "Siselen BE"
        },
        {
            "code": "2603",
            "localite": "Péry"
        },
        {
            "code": "2604",
            "localite": "La Heutte"
        },
        {
            "code": "2605",
            "localite": "Sonceboz-Sombeval"
        },
        {
            "code": "2606",
            "localite": "Corgémont"
        },
        {
            "code": "2607",
            "localite": "Cortébert"
        },
        {
            "code": "2608",
            "localite": "Courtelary"
        },
        {
            "code": "2608",
            "localite": "Montagne-de-Courtelary"
        },
        {
            "code": "2610",
            "localite": "Les Pontins"
        },
        {
            "code": "2610",
            "localite": "Mont-Crosin"
        },
        {
            "code": "2610",
            "localite": "Mont-Soleil"
        },
        {
            "code": "2610",
            "localite": "St-Imier"
        },
        {
            "code": "2612",
            "localite": "Cormoret"
        },
        {
            "code": "2613",
            "localite": "Villeret"
        },
        {
            "code": "2615",
            "localite": "Montagne-de-Sonvilier"
        },
        {
            "code": "2615",
            "localite": "Sonvilier"
        },
        {
            "code": "2616",
            "localite": "La Cibourg"
        },
        {
            "code": "2616",
            "localite": "Renan BE"
        },
        {
            "code": "2710",
            "localite": "Tavannes"
        },
        {
            "code": "2712",
            "localite": "Le Fuet"
        },
        {
            "code": "2713",
            "localite": "Bellelay"
        },
        {
            "code": "2714",
            "localite": "Le Prédame"
        },
        {
            "code": "2714",
            "localite": "Les Genevez JU"
        },
        {
            "code": "2715",
            "localite": "Châtelat"
        },
        {
            "code": "2715",
            "localite": "Monible"
        },
        {
            "code": "2716",
            "localite": "Sornetan"
        },
        {
            "code": "2717",
            "localite": "Fornet-Dessous"
        },
        {
            "code": "2717",
            "localite": "Rebévelier"
        },
        {
            "code": "2718",
            "localite": "Fornet-Dessus"
        },
        {
            "code": "2718",
            "localite": "Lajoux JU"
        },
        {
            "code": "2720",
            "localite": "La Tanne"
        },
        {
            "code": "2720",
            "localite": "Tramelan"
        },
        {
            "code": "2722",
            "localite": "Les Reussilles"
        },
        {
            "code": "2723",
            "localite": "Mont-Tramelan"
        },
        {
            "code": "2732",
            "localite": "Loveresse"
        },
        {
            "code": "2732",
            "localite": "Reconvilier"
        },
        {
            "code": "2732",
            "localite": "Saicourt"
        },
        {
            "code": "2732",
            "localite": "Saules BE"
        },
        {
            "code": "2733",
            "localite": "Pontenet"
        },
        {
            "code": "2735",
            "localite": "Bévilard"
        },
        {
            "code": "2735",
            "localite": "Champoz"
        },
        {
            "code": "2735",
            "localite": "Malleray"
        },
        {
            "code": "2736",
            "localite": "Sorvilier"
        },
        {
            "code": "2738",
            "localite": "Court"
        },
        {
            "code": "2740",
            "localite": "Moutier"
        },
        {
            "code": "2742",
            "localite": "Perrefitte"
        },
        {
            "code": "2743",
            "localite": "Eschert"
        },
        {
            "code": "2744",
            "localite": "Belprahon"
        },
        {
            "code": "2745",
            "localite": "Grandval"
        },
        {
            "code": "2746",
            "localite": "Crémines"
        },
        {
            "code": "2747",
            "localite": "Corcelles BE"
        },
        {
            "code": "2747",
            "localite": "Seehof"
        },
        {
            "code": "2748",
            "localite": "Les Ecorcheresses"
        },
        {
            "code": "2748",
            "localite": "Souboz"
        },
        {
            "code": "2762",
            "localite": "Roches BE"
        },
        {
            "code": "2800",
            "localite": "Delémont"
        },
        {
            "code": "2802",
            "localite": "Develier"
        },
        {
            "code": "2803",
            "localite": "Bourrignon"
        },
        {
            "code": "2805",
            "localite": "Soyhières"
        },
        {
            "code": "2806",
            "localite": "Mettembert"
        },
        {
            "code": "2807",
            "localite": "Lucelle"
        },
        {
            "code": "2807",
            "localite": "Pleigne"
        },
        {
            "code": "2812",
            "localite": "Movelier"
        },
        {
            "code": "2813",
            "localite": "Ederswiler"
        },
        {
            "code": "2814",
            "localite": "Roggenburg"
        },
        {
            "code": "2822",
            "localite": "Courroux"
        },
        {
            "code": "2823",
            "localite": "Courcelon"
        },
        {
            "code": "2824",
            "localite": "Vicques"
        },
        {
            "code": "2825",
            "localite": "Courchapoix"
        },
        {
            "code": "2826",
            "localite": "Corban"
        },
        {
            "code": "2827",
            "localite": "Mervelier"
        },
        {
            "code": "2827",
            "localite": "Schelten"
        },
        {
            "code": "2828",
            "localite": "Montsevelier"
        },
        {
            "code": "2829",
            "localite": "Vermes"
        },
        {
            "code": "2830",
            "localite": "Courrendlin"
        },
        {
            "code": "2830",
            "localite": "Vellerat"
        },
        {
            "code": "2832",
            "localite": "Rebeuvelier"
        },
        {
            "code": "2842",
            "localite": "Rossemaison"
        },
        {
            "code": "2843",
            "localite": "Châtillon JU"
        },
        {
            "code": "2852",
            "localite": "Courtételle"
        },
        {
            "code": "2853",
            "localite": "Courfaivre"
        },
        {
            "code": "2854",
            "localite": "Bassecourt"
        },
        {
            "code": "2855",
            "localite": "Glovelier"
        },
        {
            "code": "2856",
            "localite": "Boécourt"
        },
        {
            "code": "2857",
            "localite": "Montavon"
        },
        {
            "code": "2863",
            "localite": "Undervelier"
        },
        {
            "code": "2864",
            "localite": "Soulce"
        },
        {
            "code": "2873",
            "localite": "Saulcy"
        },
        {
            "code": "2882",
            "localite": "St-Ursanne"
        },
        {
            "code": "2883",
            "localite": "Montmelon"
        },
        {
            "code": "2884",
            "localite": "Montenol"
        },
        {
            "code": "2885",
            "localite": "Epauvillers"
        },
        {
            "code": "2886",
            "localite": "Epiquerez"
        },
        {
            "code": "2887",
            "localite": "Soubey"
        },
        {
            "code": "2888",
            "localite": "Seleute"
        },
        {
            "code": "2889",
            "localite": "Ocourt"
        },
        {
            "code": "2900",
            "localite": "Porrentruy"
        },
        {
            "code": "2902",
            "localite": "Fontenais"
        },
        {
            "code": "2903",
            "localite": "Villars-sur-Fontenais"
        },
        {
            "code": "2904",
            "localite": "Bressaucourt"
        },
        {
            "code": "2905",
            "localite": "Courtedoux"
        },
        {
            "code": "2906",
            "localite": "Chevenez"
        },
        {
            "code": "2907",
            "localite": "Rocourt"
        },
        {
            "code": "2908",
            "localite": "Grandfontaine"
        },
        {
            "code": "2912",
            "localite": "Roche-d'Or"
        },
        {
            "code": "2912",
            "localite": "Réclère"
        },
        {
            "code": "2914",
            "localite": "Damvant"
        },
        {
            "code": "2915",
            "localite": "Bure"
        },
        {
            "code": "2916",
            "localite": "Fahy"
        },
        {
            "code": "2922",
            "localite": "Courchavon"
        },
        {
            "code": "2923",
            "localite": "Courtemaîche"
        },
        {
            "code": "2924",
            "localite": "Montignez"
        },
        {
            "code": "2925",
            "localite": "Buix"
        },
        {
            "code": "2926",
            "localite": "Boncourt"
        },
        {
            "code": "2932",
            "localite": "Coeuve"
        },
        {
            "code": "2933",
            "localite": "Damphreux"
        },
        {
            "code": "2933",
            "localite": "Lugnez"
        },
        {
            "code": "2935",
            "localite": "Beurnevésin"
        },
        {
            "code": "2942",
            "localite": "Alle"
        },
        {
            "code": "2943",
            "localite": "Vendlincourt"
        },
        {
            "code": "2944",
            "localite": "Bonfol"
        },
        {
            "code": "2946",
            "localite": "Miécourt"
        },
        {
            "code": "2947",
            "localite": "Charmoille"
        },
        {
            "code": "2950",
            "localite": "Courgenay"
        },
        {
            "code": "2950",
            "localite": "Courtemautruy"
        },
        {
            "code": "2952",
            "localite": "Cornol"
        },
        {
            "code": "2953",
            "localite": "Fregiécourt"
        },
        {
            "code": "2953",
            "localite": "Pleujouse"
        },
        {
            "code": "2954",
            "localite": "Asuel"
        },
        {
            "code": "3004",
            "localite": "Bern"
        },
        {
            "code": "3005",
            "localite": "Bern"
        },
        {
            "code": "3006",
            "localite": "Bern"
        },
        {
            "code": "3007",
            "localite": "Bern"
        },
        {
            "code": "3008",
            "localite": "Bern"
        },
        {
            "code": "3010",
            "localite": "Bern"
        },
        {
            "code": "3011",
            "localite": "Bern"
        },
        {
            "code": "3012",
            "localite": "Bern"
        },
        {
            "code": "3013",
            "localite": "Bern"
        },
        {
            "code": "3014",
            "localite": "Bern"
        },
        {
            "code": "3015",
            "localite": "Bern"
        },
        {
            "code": "3018",
            "localite": "Bern"
        },
        {
            "code": "3019",
            "localite": "Bern"
        },
        {
            "code": "3020",
            "localite": "Bern"
        },
        {
            "code": "3027",
            "localite": "Bern"
        },
        {
            "code": "3032",
            "localite": "Hinterkappelen"
        },
        {
            "code": "3033",
            "localite": "Wohlen b. Bern"
        },
        {
            "code": "3034",
            "localite": "Murzelen"
        },
        {
            "code": "3035",
            "localite": "Frieswil"
        },
        {
            "code": "3036",
            "localite": "Detligen"
        },
        {
            "code": "3037",
            "localite": "Herrenschwanden"
        },
        {
            "code": "3038",
            "localite": "Kirchlindach"
        },
        {
            "code": "3042",
            "localite": "Ortschwaben"
        },
        {
            "code": "3043",
            "localite": "Uettligen"
        },
        {
            "code": "3044",
            "localite": "Innerberg"
        },
        {
            "code": "3045",
            "localite": "Meikirch"
        },
        {
            "code": "3046",
            "localite": "Wahlendorf"
        },
        {
            "code": "3047",
            "localite": "Bremgarten b. Bern"
        },
        {
            "code": "3048",
            "localite": "Worblaufen"
        },
        {
            "code": "3049",
            "localite": "Säriswil"
        },
        {
            "code": "3052",
            "localite": "Zollikofen"
        },
        {
            "code": "3053",
            "localite": "Deisswil b. Münchenbuchsee"
        },
        {
            "code": "3053",
            "localite": "Diemerswil"
        },
        {
            "code": "3053",
            "localite": "Lätti"
        },
        {
            "code": "3053",
            "localite": "Münchenbuchsee"
        },
        {
            "code": "3053",
            "localite": "Wiggiswil"
        },
        {
            "code": "3054",
            "localite": "Schüpfen"
        },
        {
            "code": "3063",
            "localite": "Ittigen"
        },
        {
            "code": "3065",
            "localite": "Bolligen"
        },
        {
            "code": "3066",
            "localite": "Stettlen"
        },
        {
            "code": "3067",
            "localite": "Boll"
        },
        {
            "code": "3068",
            "localite": "Utzigen"
        },
        {
            "code": "3072",
            "localite": "Ostermundigen"
        },
        {
            "code": "3073",
            "localite": "Gümligen"
        },
        {
            "code": "3074",
            "localite": "Muri b. Bern"
        },
        {
            "code": "3075",
            "localite": "Rüfenacht BE"
        },
        {
            "code": "3075",
            "localite": "Vielbringen b. Worb"
        },
        {
            "code": "3076",
            "localite": "Worb"
        },
        {
            "code": "3077",
            "localite": "Enggistein"
        },
        {
            "code": "3078",
            "localite": "Richigen"
        },
        {
            "code": "3082",
            "localite": "Schlosswil"
        },
        {
            "code": "3083",
            "localite": "Trimstein"
        },
        {
            "code": "3084",
            "localite": "Wabern"
        },
        {
            "code": "3086",
            "localite": "Englisberg"
        },
        {
            "code": "3086",
            "localite": "Zimmerwald"
        },
        {
            "code": "3087",
            "localite": "Niedermuhlern"
        },
        {
            "code": "3088",
            "localite": "Oberbütschel"
        },
        {
            "code": "3088",
            "localite": "Rüeggisberg"
        },
        {
            "code": "3089",
            "localite": "Hinterfultigen"
        },
        {
            "code": "3095",
            "localite": "Spiegel b. Bern"
        },
        {
            "code": "3096",
            "localite": "Oberbalm"
        },
        {
            "code": "3097",
            "localite": "Liebefeld"
        },
        {
            "code": "3098",
            "localite": "Köniz"
        },
        {
            "code": "3098",
            "localite": "Schliern b. Köniz"
        },
        {
            "code": "3099",
            "localite": "Rüti b. Riggisberg"
        },
        {
            "code": "3110",
            "localite": "Münsingen"
        },
        {
            "code": "3111",
            "localite": "Tägertschi"
        },
        {
            "code": "3112",
            "localite": "Allmendingen b. Bern"
        },
        {
            "code": "3113",
            "localite": "Rubigen"
        },
        {
            "code": "3114",
            "localite": "Wichtrach"
        },
        {
            "code": "3115",
            "localite": "Gerzensee"
        },
        {
            "code": "3116",
            "localite": "Kirchdorf BE"
        },
        {
            "code": "3116",
            "localite": "Mühledorf BE"
        },
        {
            "code": "3116",
            "localite": "Noflen BE"
        },
        {
            "code": "3122",
            "localite": "Kehrsatz"
        },
        {
            "code": "3123",
            "localite": "Belp"
        },
        {
            "code": "3124",
            "localite": "Belpberg"
        },
        {
            "code": "3125",
            "localite": "Toffen"
        },
        {
            "code": "3126",
            "localite": "Gelterfingen"
        },
        {
            "code": "3126",
            "localite": "Kaufdorf"
        },
        {
            "code": "3127",
            "localite": "Lohnstorf"
        },
        {
            "code": "3127",
            "localite": "Mühlethurnen"
        },
        {
            "code": "3128",
            "localite": "Kirchenthurnen"
        },
        {
            "code": "3128",
            "localite": "Rümligen"
        },
        {
            "code": "3132",
            "localite": "Riggisberg"
        },
        {
            "code": "3144",
            "localite": "Gasel"
        },
        {
            "code": "3145",
            "localite": "Niederscherli"
        },
        {
            "code": "3147",
            "localite": "Mittelhäusern"
        },
        {
            "code": "3148",
            "localite": "Lanzenhäusern"
        },
        {
            "code": "3150",
            "localite": "Schwarzenburg"
        },
        {
            "code": "3152",
            "localite": "Mamishaus"
        },
        {
            "code": "3153",
            "localite": "Rüschegg Gambach"
        },
        {
            "code": "3154",
            "localite": "Rüschegg Heubach"
        },
        {
            "code": "3155",
            "localite": "Helgisried-Rohrbach"
        },
        {
            "code": "3156",
            "localite": "Riffenmatt"
        },
        {
            "code": "3157",
            "localite": "Milken"
        },
        {
            "code": "3158",
            "localite": "Guggisberg"
        },
        {
            "code": "3159",
            "localite": "Riedstätt"
        },
        {
            "code": "3172",
            "localite": "Niederwangen b. Bern"
        },
        {
            "code": "3173",
            "localite": "Oberwangen b. Bern"
        },
        {
            "code": "3174",
            "localite": "Thörishaus"
        },
        {
            "code": "3175",
            "localite": "Flamatt"
        },
        {
            "code": "3176",
            "localite": "Neuenegg"
        },
        {
            "code": "3177",
            "localite": "Laupen BE"
        },
        {
            "code": "3178",
            "localite": "Bösingen"
        },
        {
            "code": "3179",
            "localite": "Kriechenwil"
        },
        {
            "code": "3182",
            "localite": "Ueberstorf"
        },
        {
            "code": "3183",
            "localite": "Albligen"
        },
        {
            "code": "3184",
            "localite": "Wünnewil"
        },
        {
            "code": "3185",
            "localite": "Schmitten FR"
        },
        {
            "code": "3186",
            "localite": "Düdingen"
        },
        {
            "code": "3202",
            "localite": "Frauenkappelen"
        },
        {
            "code": "3203",
            "localite": "Mühleberg"
        },
        {
            "code": "3204",
            "localite": "Rosshäusern"
        },
        {
            "code": "3205",
            "localite": "Gümmenen"
        },
        {
            "code": "3206",
            "localite": "Biberen"
        },
        {
            "code": "3206",
            "localite": "Ferenbalm"
        },
        {
            "code": "3206",
            "localite": "Gammen"
        },
        {
            "code": "3206",
            "localite": "Rizenbach"
        },
        {
            "code": "3206",
            "localite": "Wallenbuch"
        },
        {
            "code": "3207",
            "localite": "Golaten"
        },
        {
            "code": "3207",
            "localite": "Wileroltigen"
        },
        {
            "code": "3208",
            "localite": "Gurbrü"
        },
        {
            "code": "3210",
            "localite": "Kerzers"
        },
        {
            "code": "3212",
            "localite": "Gurmels"
        },
        {
            "code": "3212",
            "localite": "Kleingurmels"
        },
        {
            "code": "3213",
            "localite": "Kleinbösingen"
        },
        {
            "code": "3213",
            "localite": "Liebistorf"
        },
        {
            "code": "3214",
            "localite": "Ulmiz"
        },
        {
            "code": "3215",
            "localite": "Büchslen"
        },
        {
            "code": "3215",
            "localite": "Gempenach"
        },
        {
            "code": "3215",
            "localite": "Lurtigen"
        },
        {
            "code": "3216",
            "localite": "Agriswil"
        },
        {
            "code": "3216",
            "localite": "Ried b. Kerzers"
        },
        {
            "code": "3225",
            "localite": "Müntschemier"
        },
        {
            "code": "3226",
            "localite": "Treiten"
        },
        {
            "code": "3232",
            "localite": "Ins"
        },
        {
            "code": "3233",
            "localite": "Tschugg"
        },
        {
            "code": "3234",
            "localite": "Vinelz"
        },
        {
            "code": "3235",
            "localite": "Erlach"
        },
        {
            "code": "3236",
            "localite": "Gampelen"
        },
        {
            "code": "3237",
            "localite": "Brüttelen"
        },
        {
            "code": "3238",
            "localite": "Gals"
        },
        {
            "code": "3250",
            "localite": "Lyss"
        },
        {
            "code": "3251",
            "localite": "Ruppoldsried"
        },
        {
            "code": "3251",
            "localite": "Wengi b. Büren"
        },
        {
            "code": "3252",
            "localite": "Worben"
        },
        {
            "code": "3253",
            "localite": "Schnottwil"
        },
        {
            "code": "3254",
            "localite": "Balm b. Messen"
        },
        {
            "code": "3254",
            "localite": "Messen"
        },
        {
            "code": "3255",
            "localite": "Rapperswil BE"
        },
        {
            "code": "3256",
            "localite": "Bangerten b. Dieterswil"
        },
        {
            "code": "3256",
            "localite": "Dieterswil"
        },
        {
            "code": "3256",
            "localite": "Seewil"
        },
        {
            "code": "3257",
            "localite": "Ammerzwil BE"
        },
        {
            "code": "3257",
            "localite": "Grossaffoltern"
        },
        {
            "code": "3262",
            "localite": "Suberg"
        },
        {
            "code": "3263",
            "localite": "Büetigen"
        },
        {
            "code": "3264",
            "localite": "Diessbach b. Büren"
        },
        {
            "code": "3266",
            "localite": "Wiler b. Seedorf"
        },
        {
            "code": "3267",
            "localite": "Seedorf BE"
        },
        {
            "code": "3268",
            "localite": "Lobsigen"
        },
        {
            "code": "3270",
            "localite": "Aarberg"
        },
        {
            "code": "3271",
            "localite": "Radelfingen b. Aarberg"
        },
        {
            "code": "3272",
            "localite": "Epsach"
        },
        {
            "code": "3272",
            "localite": "Walperswil"
        },
        {
            "code": "3273",
            "localite": "Kappelen"
        },
        {
            "code": "3274",
            "localite": "Bühl b. Aarberg"
        },
        {
            "code": "3274",
            "localite": "Hermrigen"
        },
        {
            "code": "3274",
            "localite": "Merzligen"
        },
        {
            "code": "3280",
            "localite": "Greng"
        },
        {
            "code": "3280",
            "localite": "Meyriez"
        },
        {
            "code": "3280",
            "localite": "Murten"
        },
        {
            "code": "3282",
            "localite": "Bargen BE"
        },
        {
            "code": "3283",
            "localite": "Kallnach"
        },
        {
            "code": "3283",
            "localite": "Niederried b. Kallnach"
        },
        {
            "code": "3284",
            "localite": "Fräschels"
        },
        {
            "code": "3285",
            "localite": "Galmiz"
        },
        {
            "code": "3286",
            "localite": "Muntelier"
        },
        {
            "code": "3292",
            "localite": "Busswil BE"
        },
        {
            "code": "3293",
            "localite": "Dotzigen"
        },
        {
            "code": "3294",
            "localite": "Büren an der Aare"
        },
        {
            "code": "3294",
            "localite": "Meienried"
        },
        {
            "code": "3295",
            "localite": "Rüti b. Büren"
        },
        {
            "code": "3296",
            "localite": "Arch"
        },
        {
            "code": "3297",
            "localite": "Leuzigen"
        },
        {
            "code": "3298",
            "localite": "Oberwil b. Büren"
        },
        {
            "code": "3302",
            "localite": "Moosseedorf"
        },
        {
            "code": "3303",
            "localite": "Ballmoos"
        },
        {
            "code": "3303",
            "localite": "Jegenstorf"
        },
        {
            "code": "3303",
            "localite": "Münchringen"
        },
        {
            "code": "3303",
            "localite": "Zuzwil BE"
        },
        {
            "code": "3305",
            "localite": "Iffwil"
        },
        {
            "code": "3305",
            "localite": "Scheunen"
        },
        {
            "code": "3306",
            "localite": "Etzelkofen"
        },
        {
            "code": "3307",
            "localite": "Brunnenthal"
        },
        {
            "code": "3308",
            "localite": "Grafenried"
        },
        {
            "code": "3309",
            "localite": "Kernenried"
        },
        {
            "code": "3309",
            "localite": "Zauggenried"
        },
        {
            "code": "3312",
            "localite": "Fraubrunnen"
        },
        {
            "code": "3313",
            "localite": "Büren zum Hof"
        },
        {
            "code": "3314",
            "localite": "Schalunen"
        },
        {
            "code": "3315",
            "localite": "Bätterkinden"
        },
        {
            "code": "3315",
            "localite": "Kräiligen"
        },
        {
            "code": "3317",
            "localite": "Limpach"
        },
        {
            "code": "3317",
            "localite": "Mülchi"
        },
        {
            "code": "3322",
            "localite": "Mattstetten"
        },
        {
            "code": "3322",
            "localite": "Urtenen-Schönbühl"
        },
        {
            "code": "3323",
            "localite": "Bäriswil BE"
        },
        {
            "code": "3324",
            "localite": "Hindelbank"
        },
        {
            "code": "3324",
            "localite": "Mötschwil"
        },
        {
            "code": "3325",
            "localite": "Hettiswil b. Hindelbank"
        },
        {
            "code": "3326",
            "localite": "Krauchthal"
        },
        {
            "code": "3360",
            "localite": "Herzogenbuchsee"
        },
        {
            "code": "3362",
            "localite": "Niederönz"
        },
        {
            "code": "3363",
            "localite": "Oberönz"
        },
        {
            "code": "3365",
            "localite": "Grasswil"
        },
        {
            "code": "3365",
            "localite": "Seeberg"
        },
        {
            "code": "3366",
            "localite": "Bettenhausen"
        },
        {
            "code": "3366",
            "localite": "Bollodingen"
        },
        {
            "code": "3367",
            "localite": "Ochlenberg"
        },
        {
            "code": "3367",
            "localite": "Thörigen"
        },
        {
            "code": "3368",
            "localite": "Bleienbach"
        },
        {
            "code": "3372",
            "localite": "Wanzwil"
        },
        {
            "code": "3373",
            "localite": "Heimenhausen"
        },
        {
            "code": "3373",
            "localite": "Röthenbach Herzogenbuchsee"
        },
        {
            "code": "3374",
            "localite": "Wangenried"
        },
        {
            "code": "3375",
            "localite": "Inkwil"
        },
        {
            "code": "3376",
            "localite": "Berken"
        },
        {
            "code": "3376",
            "localite": "Graben"
        },
        {
            "code": "3377",
            "localite": "Walliswil b. Wangen"
        },
        {
            "code": "3380",
            "localite": "Walliswil b. Niederbipp"
        },
        {
            "code": "3380",
            "localite": "Wangen an der Aare"
        },
        {
            "code": "3400",
            "localite": "Burgdorf"
        },
        {
            "code": "3412",
            "localite": "Heimiswil"
        },
        {
            "code": "3413",
            "localite": "Kaltacker"
        },
        {
            "code": "3414",
            "localite": "Oberburg"
        },
        {
            "code": "3415",
            "localite": "Hasle b. Burgdorf"
        },
        {
            "code": "3415",
            "localite": "Rüegsauschachen"
        },
        {
            "code": "3415",
            "localite": "Schafhausen im Emmental"
        },
        {
            "code": "3416",
            "localite": "Affoltern im Emmental"
        },
        {
            "code": "3417",
            "localite": "Rüegsau"
        },
        {
            "code": "3418",
            "localite": "Rüegsbach"
        },
        {
            "code": "3419",
            "localite": "Biembach im Emmental"
        },
        {
            "code": "3421",
            "localite": "Lyssach"
        },
        {
            "code": "3421",
            "localite": "Rüti b. Lyssach"
        },
        {
            "code": "3422",
            "localite": "Alchenflüh"
        },
        {
            "code": "3422",
            "localite": "Kirchberg BE"
        },
        {
            "code": "3422",
            "localite": "Rüdtligen"
        },
        {
            "code": "3423",
            "localite": "Ersigen"
        },
        {
            "code": "3424",
            "localite": "Niederösch"
        },
        {
            "code": "3424",
            "localite": "Oberösch"
        },
        {
            "code": "3425",
            "localite": "Koppigen"
        },
        {
            "code": "3425",
            "localite": "Willadingen"
        },
        {
            "code": "3426",
            "localite": "Aefligen"
        },
        {
            "code": "3427",
            "localite": "Utzenstorf"
        },
        {
            "code": "3428",
            "localite": "Wiler b. Utzenstorf"
        },
        {
            "code": "3429",
            "localite": "Hellsau"
        },
        {
            "code": "3429",
            "localite": "Höchstetten"
        },
        {
            "code": "3432",
            "localite": "Lützelflüh-Goldbach"
        },
        {
            "code": "3433",
            "localite": "Schwanden im Emmental"
        },
        {
            "code": "3434",
            "localite": "Landiswil"
        },
        {
            "code": "3434",
            "localite": "Obergoldbach"
        },
        {
            "code": "3435",
            "localite": "Ramsei"
        },
        {
            "code": "3436",
            "localite": "Zollbrück"
        },
        {
            "code": "3437",
            "localite": "Rüderswil"
        },
        {
            "code": "3438",
            "localite": "Lauperswil"
        },
        {
            "code": "3439",
            "localite": "Ranflüh"
        },
        {
            "code": "3452",
            "localite": "Grünenmatt"
        },
        {
            "code": "3453",
            "localite": "Heimisbach"
        },
        {
            "code": "3454",
            "localite": "Sumiswald"
        },
        {
            "code": "3455",
            "localite": "Grünen"
        },
        {
            "code": "3456",
            "localite": "Trachselwald"
        },
        {
            "code": "3457",
            "localite": "Wasen im Emmental"
        },
        {
            "code": "3462",
            "localite": "Weier im Emmental"
        },
        {
            "code": "3463",
            "localite": "Häusernmoos im Emmental"
        },
        {
            "code": "3464",
            "localite": "Schmidigen-Mühleweg"
        },
        {
            "code": "3465",
            "localite": "Dürrenroth"
        },
        {
            "code": "3472",
            "localite": "Rumendingen"
        },
        {
            "code": "3472",
            "localite": "Wynigen"
        },
        {
            "code": "3473",
            "localite": "Alchenstorf"
        },
        {
            "code": "3474",
            "localite": "Rüedisbach"
        },
        {
            "code": "3475",
            "localite": "Hermiswil"
        },
        {
            "code": "3475",
            "localite": "Riedtwil"
        },
        {
            "code": "3476",
            "localite": "Oschwand"
        },
        {
            "code": "3503",
            "localite": "Gysenstein"
        },
        {
            "code": "3504",
            "localite": "Niederhünigen"
        },
        {
            "code": "3504",
            "localite": "Oberhünigen"
        },
        {
            "code": "3506",
            "localite": "Grosshöchstetten"
        },
        {
            "code": "3507",
            "localite": "Biglen"
        },
        {
            "code": "3508",
            "localite": "Arni BE"
        },
        {
            "code": "3510",
            "localite": "Freimettigen"
        },
        {
            "code": "3510",
            "localite": "Häutligen"
        },
        {
            "code": "3510",
            "localite": "Konolfingen"
        },
        {
            "code": "3512",
            "localite": "Walkringen"
        },
        {
            "code": "3513",
            "localite": "Bigenthal"
        },
        {
            "code": "3531",
            "localite": "Oberthal"
        },
        {
            "code": "3532",
            "localite": "Mirchel"
        },
        {
            "code": "3532",
            "localite": "Zäziwil"
        },
        {
            "code": "3533",
            "localite": "Bowil"
        },
        {
            "code": "3534",
            "localite": "Signau"
        },
        {
            "code": "3535",
            "localite": "Schüpbach"
        },
        {
            "code": "3536",
            "localite": "Aeschau"
        },
        {
            "code": "3537",
            "localite": "Eggiwil"
        },
        {
            "code": "3538",
            "localite": "Röthenbach im Emmental"
        },
        {
            "code": "3543",
            "localite": "Emmenmatt"
        },
        {
            "code": "3550",
            "localite": "Langnau im Emmental"
        },
        {
            "code": "3551",
            "localite": "Oberfrittenbach"
        },
        {
            "code": "3552",
            "localite": "Bärau"
        },
        {
            "code": "3553",
            "localite": "Gohl"
        },
        {
            "code": "3555",
            "localite": "Trubschachen"
        },
        {
            "code": "3556",
            "localite": "Trub"
        },
        {
            "code": "3557",
            "localite": "Fankhaus (Trub)"
        },
        {
            "code": "3600",
            "localite": "Thun"
        },
        {
            "code": "3603",
            "localite": "Thun"
        },
        {
            "code": "3604",
            "localite": "Thun"
        },
        {
            "code": "3608",
            "localite": "Thun"
        },
        {
            "code": "3612",
            "localite": "Steffisburg"
        },
        {
            "code": "3613",
            "localite": "Steffisburg"
        },
        {
            "code": "3614",
            "localite": "Unterlangenegg"
        },
        {
            "code": "3615",
            "localite": "Heimenschwand"
        },
        {
            "code": "3616",
            "localite": "Schwarzenegg"
        },
        {
            "code": "3617",
            "localite": "Fahrni b. Thun"
        },
        {
            "code": "3618",
            "localite": "Süderen"
        },
        {
            "code": "3619",
            "localite": "Eriz"
        },
        {
            "code": "3622",
            "localite": "Homberg b. Thun"
        },
        {
            "code": "3623",
            "localite": "Buchen BE"
        },
        {
            "code": "3623",
            "localite": "Horrenbach"
        },
        {
            "code": "3623",
            "localite": "Teuffenthal b. Thun"
        },
        {
            "code": "3624",
            "localite": "Goldiwil (Thun)"
        },
        {
            "code": "3624",
            "localite": "Schwendibach"
        },
        {
            "code": "3625",
            "localite": "Heiligenschwendi"
        },
        {
            "code": "3626",
            "localite": "Hünibach"
        },
        {
            "code": "3627",
            "localite": "Heimberg"
        },
        {
            "code": "3628",
            "localite": "Uttigen"
        },
        {
            "code": "3629",
            "localite": "Jaberg"
        },
        {
            "code": "3629",
            "localite": "Kiesen"
        },
        {
            "code": "3629",
            "localite": "Oppligen"
        },
        {
            "code": "3631",
            "localite": "Höfen b. Thun"
        },
        {
            "code": "3632",
            "localite": "Niederstocken"
        },
        {
            "code": "3632",
            "localite": "Oberstocken"
        },
        {
            "code": "3633",
            "localite": "Amsoldingen"
        },
        {
            "code": "3634",
            "localite": "Thierachern"
        },
        {
            "code": "3635",
            "localite": "Uebeschi"
        },
        {
            "code": "3636",
            "localite": "Forst b. Längenbühl"
        },
        {
            "code": "3636",
            "localite": "Längenbühl"
        },
        {
            "code": "3638",
            "localite": "Blumenstein"
        },
        {
            "code": "3638",
            "localite": "Pohlern"
        },
        {
            "code": "3645",
            "localite": "Gwatt (Thun)"
        },
        {
            "code": "3645",
            "localite": "Zwieselberg"
        },
        {
            "code": "3646",
            "localite": "Einigen"
        },
        {
            "code": "3647",
            "localite": "Reutigen"
        },
        {
            "code": "3652",
            "localite": "Hilterfingen"
        },
        {
            "code": "3653",
            "localite": "Oberhofen am Thunersee"
        },
        {
            "code": "3654",
            "localite": "Gunten"
        },
        {
            "code": "3655",
            "localite": "Sigriswil"
        },
        {
            "code": "3656",
            "localite": "Aeschlen ob Gunten"
        },
        {
            "code": "3656",
            "localite": "Ringoldswil"
        },
        {
            "code": "3656",
            "localite": "Tschingel ob Gunten"
        },
        {
            "code": "3657",
            "localite": "Schwanden (Sigriswil)"
        },
        {
            "code": "3658",
            "localite": "Merligen"
        },
        {
            "code": "3661",
            "localite": "Uetendorf"
        },
        {
            "code": "3662",
            "localite": "Seftigen"
        },
        {
            "code": "3663",
            "localite": "Gurzelen"
        },
        {
            "code": "3664",
            "localite": "Burgistein"
        },
        {
            "code": "3665",
            "localite": "Wattenwil"
        },
        {
            "code": "3671",
            "localite": "Brenzikofen"
        },
        {
            "code": "3671",
            "localite": "Herbligen"
        },
        {
            "code": "3672",
            "localite": "Aeschlen b. Oberdiessbach"
        },
        {
            "code": "3672",
            "localite": "Oberdiessbach"
        },
        {
            "code": "3673",
            "localite": "Linden"
        },
        {
            "code": "3674",
            "localite": "Bleiken b. Oberdiessbach"
        },
        {
            "code": "3700",
            "localite": "Spiez"
        },
        {
            "code": "3702",
            "localite": "Hondrich"
        },
        {
            "code": "3703",
            "localite": "Aeschi b. Spiez"
        },
        {
            "code": "3703",
            "localite": "Aeschiried"
        },
        {
            "code": "3704",
            "localite": "Krattigen"
        },
        {
            "code": "3705",
            "localite": "Faulensee"
        },
        {
            "code": "3706",
            "localite": "Leissigen"
        },
        {
            "code": "3707",
            "localite": "Därligen"
        },
        {
            "code": "3711",
            "localite": "Emdthal"
        },
        {
            "code": "3711",
            "localite": "Mülenen"
        },
        {
            "code": "3713",
            "localite": "Reichenbach im Kandertal"
        },
        {
            "code": "3714",
            "localite": "Frutigen"
        },
        {
            "code": "3714",
            "localite": "Wengi b. Frutigen"
        },
        {
            "code": "3715",
            "localite": "Adelboden"
        },
        {
            "code": "3716",
            "localite": "Kandergrund"
        },
        {
            "code": "3717",
            "localite": "Blausee-Mitholz"
        },
        {
            "code": "3718",
            "localite": "Kandersteg"
        },
        {
            "code": "3722",
            "localite": "Scharnachtal"
        },
        {
            "code": "3723",
            "localite": "Kiental"
        },
        {
            "code": "3724",
            "localite": "Ried (Frutigen)"
        },
        {
            "code": "3725",
            "localite": "Achseten"
        },
        {
            "code": "3752",
            "localite": "Wimmis"
        },
        {
            "code": "3753",
            "localite": "Oey"
        },
        {
            "code": "3754",
            "localite": "Diemtigen"
        },
        {
            "code": "3755",
            "localite": "Horboden"
        },
        {
            "code": "3756",
            "localite": "Zwischenflüh"
        },
        {
            "code": "3757",
            "localite": "Schwenden im Diemtigtal"
        },
        {
            "code": "3758",
            "localite": "Latterbach"
        },
        {
            "code": "3762",
            "localite": "Erlenbach im Simmental"
        },
        {
            "code": "3763",
            "localite": "Därstetten"
        },
        {
            "code": "3764",
            "localite": "Weissenburg"
        },
        {
            "code": "3765",
            "localite": "Oberwil im Simmental"
        },
        {
            "code": "3766",
            "localite": "Boltigen"
        },
        {
            "code": "3770",
            "localite": "Zweisimmen"
        },
        {
            "code": "3771",
            "localite": "Blankenburg"
        },
        {
            "code": "3772",
            "localite": "St. Stephan"
        },
        {
            "code": "3773",
            "localite": "Matten (St. Stephan)"
        },
        {
            "code": "3775",
            "localite": "Lenk im Simmental"
        },
        {
            "code": "3776",
            "localite": "Oeschseite"
        },
        {
            "code": "3777",
            "localite": "Saanenmöser"
        },
        {
            "code": "3778",
            "localite": "Schönried"
        },
        {
            "code": "3780",
            "localite": "Gstaad"
        },
        {
            "code": "3781",
            "localite": "Turbach"
        },
        {
            "code": "3782",
            "localite": "Lauenen b. Gstaad"
        },
        {
            "code": "3783",
            "localite": "Grund b. Gstaad"
        },
        {
            "code": "3784",
            "localite": "Feutersoey"
        },
        {
            "code": "3785",
            "localite": "Gsteig b. Gstaad"
        },
        {
            "code": "3792",
            "localite": "Saanen"
        },
        {
            "code": "3800",
            "localite": "Interlaken"
        },
        {
            "code": "3800",
            "localite": "Matten b. Interlaken"
        },
        {
            "code": "3800",
            "localite": "Sundlauenen"
        },
        {
            "code": "3800",
            "localite": "Unterseen"
        },
        {
            "code": "3801",
            "localite": "Jungfraujoch"
        },
        {
            "code": "3803",
            "localite": "Beatenberg"
        },
        {
            "code": "3804",
            "localite": "Habkern"
        },
        {
            "code": "3805",
            "localite": "Goldswil b. Interlaken"
        },
        {
            "code": "3806",
            "localite": "Bönigen b. Interlaken"
        },
        {
            "code": "3807",
            "localite": "Iseltwald"
        },
        {
            "code": "3812",
            "localite": "Wilderswil"
        },
        {
            "code": "3813",
            "localite": "Saxeten"
        },
        {
            "code": "3814",
            "localite": "Gsteigwiler"
        },
        {
            "code": "3815",
            "localite": "Gündlischwand"
        },
        {
            "code": "3815",
            "localite": "Zweilütschinen"
        },
        {
            "code": "3816",
            "localite": "Burglauenen"
        },
        {
            "code": "3816",
            "localite": "Lütschental"
        },
        {
            "code": "3818",
            "localite": "Grindelwald"
        },
        {
            "code": "3822",
            "localite": "Isenfluh"
        },
        {
            "code": "3822",
            "localite": "Lauterbrunnen"
        },
        {
            "code": "3823",
            "localite": "Eigergletscher"
        },
        {
            "code": "3823",
            "localite": "Kleine Scheidegg"
        },
        {
            "code": "3823",
            "localite": "Wengen"
        },
        {
            "code": "3824",
            "localite": "Stechelberg"
        },
        {
            "code": "3825",
            "localite": "Mürren"
        },
        {
            "code": "3826",
            "localite": "Gimmelwald"
        },
        {
            "code": "3852",
            "localite": "Ringgenberg BE"
        },
        {
            "code": "3853",
            "localite": "Niederried b. Interlaken"
        },
        {
            "code": "3854",
            "localite": "Oberried am Brienzersee"
        },
        {
            "code": "3855",
            "localite": "Axalp"
        },
        {
            "code": "3855",
            "localite": "Brienz BE"
        },
        {
            "code": "3855",
            "localite": "Schwanden b. Brienz"
        },
        {
            "code": "3856",
            "localite": "Brienzwiler"
        },
        {
            "code": "3857",
            "localite": "Unterbach BE"
        },
        {
            "code": "3858",
            "localite": "Hofstetten b. Brienz"
        },
        {
            "code": "3860",
            "localite": "Brünig"
        },
        {
            "code": "3860",
            "localite": "Meiringen"
        },
        {
            "code": "3860",
            "localite": "Rosenlaui"
        },
        {
            "code": "3860",
            "localite": "Schattenhalb"
        },
        {
            "code": "3862",
            "localite": "Innertkirchen"
        },
        {
            "code": "3863",
            "localite": "Gadmen"
        },
        {
            "code": "3864",
            "localite": "Guttannen"
        },
        {
            "code": "3900",
            "localite": "Brig"
        },
        {
            "code": "3900",
            "localite": "Brigerbad"
        },
        {
            "code": "3900",
            "localite": "Gamsen"
        },
        {
            "code": "3901",
            "localite": "Rothwald"
        },
        {
            "code": "3902",
            "localite": "Glis"
        },
        {
            "code": "3903",
            "localite": "Birgisch"
        },
        {
            "code": "3903",
            "localite": "Mund"
        },
        {
            "code": "3904",
            "localite": "Naters"
        },
        {
            "code": "3905",
            "localite": "Saas-Almagell"
        },
        {
            "code": "3906",
            "localite": "Saas-Fee"
        },
        {
            "code": "3907",
            "localite": "Gabi (Simplon)"
        },
        {
            "code": "3907",
            "localite": "Gondo"
        },
        {
            "code": "3907",
            "localite": "Simplon Dorf"
        },
        {
            "code": "3907",
            "localite": "Simplon Hospiz"
        },
        {
            "code": "3908",
            "localite": "Saas-Balen"
        },
        {
            "code": "3910",
            "localite": "Saas-Grund"
        },
        {
            "code": "3911",
            "localite": "Ried-Brig"
        },
        {
            "code": "3912",
            "localite": "Termen"
        },
        {
            "code": "3913",
            "localite": "Rosswald"
        },
        {
            "code": "3914",
            "localite": "Belalp"
        },
        {
            "code": "3914",
            "localite": "Blatten b. Naters"
        },
        {
            "code": "3916",
            "localite": "Ferden"
        },
        {
            "code": "3917",
            "localite": "Goppenstein"
        },
        {
            "code": "3917",
            "localite": "Kippel"
        },
        {
            "code": "3918",
            "localite": "Wiler (Lötschen)"
        },
        {
            "code": "3919",
            "localite": "Blatten (Lötschen)"
        },
        {
            "code": "3920",
            "localite": "Zermatt"
        },
        {
            "code": "3922",
            "localite": "Eisten"
        },
        {
            "code": "3922",
            "localite": "Kalpetran"
        },
        {
            "code": "3922",
            "localite": "Stalden VS"
        },
        {
            "code": "3923",
            "localite": "Törbel"
        },
        {
            "code": "3924",
            "localite": "St. Niklaus VS"
        },
        {
            "code": "3925",
            "localite": "Grächen"
        },
        {
            "code": "3926",
            "localite": "Embd"
        },
        {
            "code": "3927",
            "localite": "Herbriggen"
        },
        {
            "code": "3928",
            "localite": "Randa"
        },
        {
            "code": "3929",
            "localite": "Täsch"
        },
        {
            "code": "3930",
            "localite": "Eyholz"
        },
        {
            "code": "3930",
            "localite": "Visp"
        },
        {
            "code": "3931",
            "localite": "Lalden"
        },
        {
            "code": "3932",
            "localite": "Visperterminen"
        },
        {
            "code": "3933",
            "localite": "Staldenried"
        },
        {
            "code": "3934",
            "localite": "Zeneggen"
        },
        {
            "code": "3935",
            "localite": "Bürchen"
        },
        {
            "code": "3937",
            "localite": "Baltschieder"
        },
        {
            "code": "3938",
            "localite": "Ausserberg"
        },
        {
            "code": "3939",
            "localite": "Eggerberg"
        },
        {
            "code": "3940",
            "localite": "Steg VS"
        },
        {
            "code": "3942",
            "localite": "Niedergesteln"
        },
        {
            "code": "3942",
            "localite": "Raron"
        },
        {
            "code": "3942",
            "localite": "St. German"
        },
        {
            "code": "3943",
            "localite": "Eischoll"
        },
        {
            "code": "3944",
            "localite": "Unterbäch VS"
        },
        {
            "code": "3945",
            "localite": "Gampel"
        },
        {
            "code": "3945",
            "localite": "Niedergampel"
        },
        {
            "code": "3946",
            "localite": "Gruben"
        },
        {
            "code": "3946",
            "localite": "Turtmann"
        },
        {
            "code": "3947",
            "localite": "Ergisch"
        },
        {
            "code": "3948",
            "localite": "Oberems"
        },
        {
            "code": "3948",
            "localite": "Unterems"
        },
        {
            "code": "3949",
            "localite": "Hohtenn"
        },
        {
            "code": "3951",
            "localite": "Agarn"
        },
        {
            "code": "3952",
            "localite": "Susten"
        },
        {
            "code": "3953",
            "localite": "Inden"
        },
        {
            "code": "3953",
            "localite": "Leuk Stadt"
        },
        {
            "code": "3953",
            "localite": "Varen"
        },
        {
            "code": "3954",
            "localite": "Leukerbad"
        },
        {
            "code": "3955",
            "localite": "Albinen"
        },
        {
            "code": "3956",
            "localite": "Guttet-Feschel"
        },
        {
            "code": "3957",
            "localite": "Bratsch"
        },
        {
            "code": "3957",
            "localite": "Erschmatt"
        },
        {
            "code": "3960",
            "localite": "Corin-de-la-Crête"
        },
        {
            "code": "3960",
            "localite": "Loc"
        },
        {
            "code": "3960",
            "localite": "Muraz (Sierre)"
        },
        {
            "code": "3960",
            "localite": "Niouc"
        },
        {
            "code": "3960",
            "localite": "Sierre"
        },
        {
            "code": "3961",
            "localite": "Ayer"
        },
        {
            "code": "3961",
            "localite": "Chandolin"
        },
        {
            "code": "3961",
            "localite": "Grimentz"
        },
        {
            "code": "3961",
            "localite": "Mission"
        },
        {
            "code": "3961",
            "localite": "St-Jean VS"
        },
        {
            "code": "3961",
            "localite": "St-Luc"
        },
        {
            "code": "3961",
            "localite": "Vissoie"
        },
        {
            "code": "3961",
            "localite": "Zinal"
        },
        {
            "code": "3963",
            "localite": "Aminona"
        },
        {
            "code": "3963",
            "localite": "Crans VS"
        },
        {
            "code": "3963",
            "localite": "Crans-Montana"
        },
        {
            "code": "3963",
            "localite": "Montana"
        },
        {
            "code": "3965",
            "localite": "Chippis"
        },
        {
            "code": "3966",
            "localite": "Chalais"
        },
        {
            "code": "3966",
            "localite": "Réchy"
        },
        {
            "code": "3967",
            "localite": "Vercorin"
        },
        {
            "code": "3968",
            "localite": "Veyras"
        },
        {
            "code": "3970",
            "localite": "Salgesch"
        },
        {
            "code": "3971",
            "localite": "Chermignon"
        },
        {
            "code": "3971",
            "localite": "Chermignon-d'en-Bas"
        },
        {
            "code": "3971",
            "localite": "Ollon VS"
        },
        {
            "code": "3972",
            "localite": "Miège"
        },
        {
            "code": "3973",
            "localite": "Venthône"
        },
        {
            "code": "3974",
            "localite": "Mollens VS"
        },
        {
            "code": "3975",
            "localite": "Randogne"
        },
        {
            "code": "3976",
            "localite": "Champzabé"
        },
        {
            "code": "3976",
            "localite": "Noës"
        },
        {
            "code": "3977",
            "localite": "Granges VS"
        },
        {
            "code": "3978",
            "localite": "Flanthey"
        },
        {
            "code": "3979",
            "localite": "Grône"
        },
        {
            "code": "3982",
            "localite": "Bitsch"
        },
        {
            "code": "3983",
            "localite": "Bister"
        },
        {
            "code": "3983",
            "localite": "Filet"
        },
        {
            "code": "3983",
            "localite": "Goppisberg"
        },
        {
            "code": "3983",
            "localite": "Greich"
        },
        {
            "code": "3983",
            "localite": "Mörel"
        },
        {
            "code": "3984",
            "localite": "Fiesch"
        },
        {
            "code": "3984",
            "localite": "Fieschertal"
        },
        {
            "code": "3985",
            "localite": "Geschinen"
        },
        {
            "code": "3985",
            "localite": "Münster VS"
        },
        {
            "code": "3986",
            "localite": "Ried-Mörel"
        },
        {
            "code": "3987",
            "localite": "Riederalp"
        },
        {
            "code": "3988",
            "localite": "Obergesteln"
        },
        {
            "code": "3988",
            "localite": "Ulrichen"
        },
        {
            "code": "3989",
            "localite": "Biel VS"
        },
        {
            "code": "3989",
            "localite": "Blitzingen"
        },
        {
            "code": "3989",
            "localite": "Niederwald"
        },
        {
            "code": "3989",
            "localite": "Ritzingen"
        },
        {
            "code": "3989",
            "localite": "Selkingen"
        },
        {
            "code": "3991",
            "localite": "Betten"
        },
        {
            "code": "3992",
            "localite": "Bettmeralp"
        },
        {
            "code": "3993",
            "localite": "Grengiols"
        },
        {
            "code": "3994",
            "localite": "Lax"
        },
        {
            "code": "3994",
            "localite": "Martisberg"
        },
        {
            "code": "3995",
            "localite": "Ausserbinn"
        },
        {
            "code": "3995",
            "localite": "Ernen"
        },
        {
            "code": "3995",
            "localite": "Mühlebach (Goms)"
        },
        {
            "code": "3995",
            "localite": "Steinhaus"
        },
        {
            "code": "3996",
            "localite": "Binn"
        },
        {
            "code": "3997",
            "localite": "Bellwald"
        },
        {
            "code": "3998",
            "localite": "Gluringen"
        },
        {
            "code": "3998",
            "localite": "Reckingen VS"
        },
        {
            "code": "3999",
            "localite": "Oberwald"
        },
        {
            "code": "4001",
            "localite": "Basel"
        },
        {
            "code": "4031",
            "localite": "Basel"
        },
        {
            "code": "4051",
            "localite": "Basel"
        },
        {
            "code": "4052",
            "localite": "Basel"
        },
        {
            "code": "4053",
            "localite": "Basel"
        },
        {
            "code": "4054",
            "localite": "Basel"
        },
        {
            "code": "4055",
            "localite": "Basel"
        },
        {
            "code": "4056",
            "localite": "Basel"
        },
        {
            "code": "4057",
            "localite": "Basel"
        },
        {
            "code": "4058",
            "localite": "Basel"
        },
        {
            "code": "4059",
            "localite": "Basel"
        },
        {
            "code": "4101",
            "localite": "Bruderholz"
        },
        {
            "code": "4102",
            "localite": "Binningen"
        },
        {
            "code": "4103",
            "localite": "Bottmingen"
        },
        {
            "code": "4104",
            "localite": "Oberwil BL"
        },
        {
            "code": "4105",
            "localite": "Biel-Benken BL"
        },
        {
            "code": "4106",
            "localite": "Therwil"
        },
        {
            "code": "4107",
            "localite": "Ettingen"
        },
        {
            "code": "4108",
            "localite": "Witterswil"
        },
        {
            "code": "4112",
            "localite": "Bättwil"
        },
        {
            "code": "4112",
            "localite": "Flüh"
        },
        {
            "code": "4114",
            "localite": "Hofstetten SO"
        },
        {
            "code": "4115",
            "localite": "Mariastein"
        },
        {
            "code": "4116",
            "localite": "Metzerlen"
        },
        {
            "code": "4117",
            "localite": "Burg im Leimental"
        },
        {
            "code": "4118",
            "localite": "Rodersdorf"
        },
        {
            "code": "4123",
            "localite": "Allschwil"
        },
        {
            "code": "4124",
            "localite": "Schönenbuch"
        },
        {
            "code": "4125",
            "localite": "Riehen"
        },
        {
            "code": "4126",
            "localite": "Bettingen"
        },
        {
            "code": "4127",
            "localite": "Birsfelden"
        },
        {
            "code": "4132",
            "localite": "Muttenz"
        },
        {
            "code": "4133",
            "localite": "Pratteln"
        },
        {
            "code": "4142",
            "localite": "Münchenstein"
        },
        {
            "code": "4143",
            "localite": "Dornach"
        },
        {
            "code": "4144",
            "localite": "Arlesheim"
        },
        {
            "code": "4145",
            "localite": "Gempen"
        },
        {
            "code": "4146",
            "localite": "Hochwald"
        },
        {
            "code": "4147",
            "localite": "Aesch BL"
        },
        {
            "code": "4148",
            "localite": "Pfeffingen"
        },
        {
            "code": "4153",
            "localite": "Reinach BL"
        },
        {
            "code": "4202",
            "localite": "Duggingen"
        },
        {
            "code": "4203",
            "localite": "Grellingen"
        },
        {
            "code": "4204",
            "localite": "Himmelried"
        },
        {
            "code": "4206",
            "localite": "Seewen SO"
        },
        {
            "code": "4207",
            "localite": "Bretzwil"
        },
        {
            "code": "4208",
            "localite": "Nunningen"
        },
        {
            "code": "4222",
            "localite": "Zwingen"
        },
        {
            "code": "4223",
            "localite": "Blauen"
        },
        {
            "code": "4224",
            "localite": "Nenzlingen"
        },
        {
            "code": "4225",
            "localite": "Brislach"
        },
        {
            "code": "4226",
            "localite": "Breitenbach"
        },
        {
            "code": "4227",
            "localite": "Büsserach"
        },
        {
            "code": "4228",
            "localite": "Erschwil"
        },
        {
            "code": "4229",
            "localite": "Beinwil SO"
        },
        {
            "code": "4232",
            "localite": "Fehren"
        },
        {
            "code": "4233",
            "localite": "Meltingen"
        },
        {
            "code": "4234",
            "localite": "Zullwil"
        },
        {
            "code": "4242",
            "localite": "Laufen"
        },
        {
            "code": "4243",
            "localite": "Dittingen"
        },
        {
            "code": "4244",
            "localite": "Röschenz"
        },
        {
            "code": "4245",
            "localite": "Kleinlützel"
        },
        {
            "code": "4246",
            "localite": "Wahlen b. Laufen"
        },
        {
            "code": "4247",
            "localite": "Grindel"
        },
        {
            "code": "4252",
            "localite": "Bärschwil"
        },
        {
            "code": "4253",
            "localite": "Liesberg"
        },
        {
            "code": "4254",
            "localite": "Liesberg Dorf"
        },
        {
            "code": "4302",
            "localite": "Augst BL"
        },
        {
            "code": "4303",
            "localite": "Kaiseraugst"
        },
        {
            "code": "4304",
            "localite": "Giebenach"
        },
        {
            "code": "4305",
            "localite": "Olsberg"
        },
        {
            "code": "4310",
            "localite": "Rheinfelden"
        },
        {
            "code": "4312",
            "localite": "Magden"
        },
        {
            "code": "4313",
            "localite": "Möhlin"
        },
        {
            "code": "4314",
            "localite": "Zeiningen"
        },
        {
            "code": "4315",
            "localite": "Zuzgen"
        },
        {
            "code": "4316",
            "localite": "Hellikon"
        },
        {
            "code": "4317",
            "localite": "Wegenstetten"
        },
        {
            "code": "4322",
            "localite": "Mumpf"
        },
        {
            "code": "4323",
            "localite": "Wallbach"
        },
        {
            "code": "4324",
            "localite": "Obermumpf"
        },
        {
            "code": "4325",
            "localite": "Schupfart"
        },
        {
            "code": "4332",
            "localite": "Stein AG"
        },
        {
            "code": "4333",
            "localite": "Münchwilen AG"
        },
        {
            "code": "4334",
            "localite": "Sisseln AG"
        },
        {
            "code": "4402",
            "localite": "Frenkendorf"
        },
        {
            "code": "4410",
            "localite": "Liestal"
        },
        {
            "code": "4411",
            "localite": "Seltisberg"
        },
        {
            "code": "4412",
            "localite": "Nuglar"
        },
        {
            "code": "4413",
            "localite": "Büren SO"
        },
        {
            "code": "4414",
            "localite": "Füllinsdorf"
        },
        {
            "code": "4415",
            "localite": "Lausen"
        },
        {
            "code": "4416",
            "localite": "Bubendorf"
        },
        {
            "code": "4417",
            "localite": "Ziefen"
        },
        {
            "code": "4418",
            "localite": "Reigoldswil"
        },
        {
            "code": "4419",
            "localite": "Lupsingen"
        },
        {
            "code": "4421",
            "localite": "St. Pantaleon"
        },
        {
            "code": "4422",
            "localite": "Arisdorf"
        },
        {
            "code": "4423",
            "localite": "Hersberg"
        },
        {
            "code": "4424",
            "localite": "Arboldswil"
        },
        {
            "code": "4425",
            "localite": "Titterten"
        },
        {
            "code": "4426",
            "localite": "Lauwil"
        },
        {
            "code": "4431",
            "localite": "Bennwil"
        },
        {
            "code": "4432",
            "localite": "Lampenberg"
        },
        {
            "code": "4433",
            "localite": "Ramlinsburg"
        },
        {
            "code": "4434",
            "localite": "Hölstein"
        },
        {
            "code": "4435",
            "localite": "Niederdorf"
        },
        {
            "code": "4436",
            "localite": "Liedertswil"
        },
        {
            "code": "4436",
            "localite": "Oberdorf BL"
        },
        {
            "code": "4437",
            "localite": "Waldenburg"
        },
        {
            "code": "4438",
            "localite": "Langenbruck"
        },
        {
            "code": "4441",
            "localite": "Thürnen"
        },
        {
            "code": "4442",
            "localite": "Diepflingen"
        },
        {
            "code": "4443",
            "localite": "Wittinsburg"
        },
        {
            "code": "4444",
            "localite": "Rümlingen"
        },
        {
            "code": "4445",
            "localite": "Häfelfingen"
        },
        {
            "code": "4446",
            "localite": "Buckten"
        },
        {
            "code": "4447",
            "localite": "Känerkinden"
        },
        {
            "code": "4448",
            "localite": "Läufelfingen"
        },
        {
            "code": "4450",
            "localite": "Sissach"
        },
        {
            "code": "4451",
            "localite": "Wintersingen"
        },
        {
            "code": "4452",
            "localite": "Itingen"
        },
        {
            "code": "4453",
            "localite": "Nusshof"
        },
        {
            "code": "4455",
            "localite": "Zunzgen"
        },
        {
            "code": "4456",
            "localite": "Tenniken"
        },
        {
            "code": "4457",
            "localite": "Diegten"
        },
        {
            "code": "4458",
            "localite": "Eptingen"
        },
        {
            "code": "4460",
            "localite": "Gelterkinden"
        },
        {
            "code": "4461",
            "localite": "Böckten"
        },
        {
            "code": "4462",
            "localite": "Rickenbach BL"
        },
        {
            "code": "4463",
            "localite": "Buus"
        },
        {
            "code": "4464",
            "localite": "Maisprach"
        },
        {
            "code": "4465",
            "localite": "Hemmiken"
        },
        {
            "code": "4466",
            "localite": "Ormalingen"
        },
        {
            "code": "4467",
            "localite": "Rothenfluh"
        },
        {
            "code": "4468",
            "localite": "Kienberg"
        },
        {
            "code": "4469",
            "localite": "Anwil"
        },
        {
            "code": "4492",
            "localite": "Tecknau"
        },
        {
            "code": "4493",
            "localite": "Wenslingen"
        },
        {
            "code": "4494",
            "localite": "Oltingen"
        },
        {
            "code": "4495",
            "localite": "Zeglingen"
        },
        {
            "code": "4496",
            "localite": "Kilchberg BL"
        },
        {
            "code": "4497",
            "localite": "Rünenberg"
        },
        {
            "code": "4500",
            "localite": "Solothurn"
        },
        {
            "code": "4512",
            "localite": "Bellach"
        },
        {
            "code": "4513",
            "localite": "Langendorf"
        },
        {
            "code": "4514",
            "localite": "Lommiswil"
        },
        {
            "code": "4515",
            "localite": "Oberdorf SO"
        },
        {
            "code": "4515",
            "localite": "Weissenstein b. Solothurn"
        },
        {
            "code": "4522",
            "localite": "Rüttenen"
        },
        {
            "code": "4523",
            "localite": "Niederwil SO"
        },
        {
            "code": "4524",
            "localite": "Balmberg"
        },
        {
            "code": "4524",
            "localite": "Günsberg"
        },
        {
            "code": "4524",
            "localite": "Oberbalmberg"
        },
        {
            "code": "4525",
            "localite": "Balm b. Günsberg"
        },
        {
            "code": "4528",
            "localite": "Zuchwil"
        },
        {
            "code": "4532",
            "localite": "Feldbrunnen"
        },
        {
            "code": "4533",
            "localite": "Riedholz"
        },
        {
            "code": "4534",
            "localite": "Flumenthal"
        },
        {
            "code": "4535",
            "localite": "Hubersdorf"
        },
        {
            "code": "4535",
            "localite": "Kammersrohr"
        },
        {
            "code": "4536",
            "localite": "Attiswil"
        },
        {
            "code": "4537",
            "localite": "Wiedlisbach"
        },
        {
            "code": "4538",
            "localite": "Oberbipp"
        },
        {
            "code": "4539",
            "localite": "Farnern"
        },
        {
            "code": "4539",
            "localite": "Rumisberg"
        },
        {
            "code": "4542",
            "localite": "Luterbach"
        },
        {
            "code": "4543",
            "localite": "Deitingen"
        },
        {
            "code": "4552",
            "localite": "Derendingen"
        },
        {
            "code": "4553",
            "localite": "Subingen"
        },
        {
            "code": "4554",
            "localite": "Etziken"
        },
        {
            "code": "4554",
            "localite": "Hüniken"
        },
        {
            "code": "4556",
            "localite": "Aeschi SO"
        },
        {
            "code": "4556",
            "localite": "Bolken"
        },
        {
            "code": "4556",
            "localite": "Burgäschi"
        },
        {
            "code": "4556",
            "localite": "Steinhof SO"
        },
        {
            "code": "4557",
            "localite": "Horriwil"
        },
        {
            "code": "4558",
            "localite": "Heinrichswil"
        },
        {
            "code": "4558",
            "localite": "Hersiwil"
        },
        {
            "code": "4558",
            "localite": "Winistorf"
        },
        {
            "code": "4562",
            "localite": "Biberist"
        },
        {
            "code": "4563",
            "localite": "Gerlafingen"
        },
        {
            "code": "4564",
            "localite": "Obergerlafingen"
        },
        {
            "code": "4564",
            "localite": "Zielebach"
        },
        {
            "code": "4565",
            "localite": "Recherswil"
        },
        {
            "code": "4566",
            "localite": "Halten"
        },
        {
            "code": "4566",
            "localite": "Kriegstetten"
        },
        {
            "code": "4566",
            "localite": "Oekingen"
        },
        {
            "code": "4571",
            "localite": "Ichertswil"
        },
        {
            "code": "4571",
            "localite": "Lüterkofen"
        },
        {
            "code": "4573",
            "localite": "Lohn-Ammannsegg"
        },
        {
            "code": "4574",
            "localite": "Lüsslingen"
        },
        {
            "code": "4574",
            "localite": "Nennigkofen"
        },
        {
            "code": "4576",
            "localite": "Tscheppach"
        },
        {
            "code": "4577",
            "localite": "Hessigkofen"
        },
        {
            "code": "4578",
            "localite": "Bibern SO"
        },
        {
            "code": "4579",
            "localite": "Gossliwil"
        },
        {
            "code": "4581",
            "localite": "Küttigkofen"
        },
        {
            "code": "4582",
            "localite": "Brügglen"
        },
        {
            "code": "4583",
            "localite": "Aetigkofen"
        },
        {
            "code": "4583",
            "localite": "Mühledorf SO"
        },
        {
            "code": "4584",
            "localite": "Gächliwil"
        },
        {
            "code": "4584",
            "localite": "Lüterswil"
        },
        {
            "code": "4585",
            "localite": "Biezwil"
        },
        {
            "code": "4586",
            "localite": "Kyburg-Buchegg"
        },
        {
            "code": "4587",
            "localite": "Aetingen"
        },
        {
            "code": "4588",
            "localite": "Brittern"
        },
        {
            "code": "4588",
            "localite": "Oberramsern"
        },
        {
            "code": "4588",
            "localite": "Unterramsern"
        },
        {
            "code": "4600",
            "localite": "Olten"
        },
        {
            "code": "4612",
            "localite": "Wangen b. Olten"
        },
        {
            "code": "4613",
            "localite": "Rickenbach SO"
        },
        {
            "code": "4614",
            "localite": "Hägendorf"
        },
        {
            "code": "4615",
            "localite": "Allerheiligenberg"
        },
        {
            "code": "4616",
            "localite": "Kappel SO"
        },
        {
            "code": "4617",
            "localite": "Gunzgen"
        },
        {
            "code": "4618",
            "localite": "Boningen"
        },
        {
            "code": "4622",
            "localite": "Egerkingen"
        },
        {
            "code": "4623",
            "localite": "Neuendorf"
        },
        {
            "code": "4624",
            "localite": "Härkingen"
        },
        {
            "code": "4625",
            "localite": "Oberbuchsiten"
        },
        {
            "code": "4626",
            "localite": "Niederbuchsiten"
        },
        {
            "code": "4628",
            "localite": "Wolfwil"
        },
        {
            "code": "4629",
            "localite": "Fulenbach"
        },
        {
            "code": "4632",
            "localite": "Trimbach"
        },
        {
            "code": "4633",
            "localite": "Hauenstein"
        },
        {
            "code": "4634",
            "localite": "Wisen SO"
        },
        {
            "code": "4652",
            "localite": "Winznau"
        },
        {
            "code": "4653",
            "localite": "Obergösgen"
        },
        {
            "code": "4654",
            "localite": "Lostorf"
        },
        {
            "code": "4655",
            "localite": "Rohr b. Olten"
        },
        {
            "code": "4655",
            "localite": "Stüsslingen"
        },
        {
            "code": "4656",
            "localite": "Starrkirch-Wil"
        },
        {
            "code": "4657",
            "localite": "Dulliken"
        },
        {
            "code": "4658",
            "localite": "Däniken SO"
        },
        {
            "code": "4663",
            "localite": "Aarburg"
        },
        {
            "code": "4665",
            "localite": "Oftringen"
        },
        {
            "code": "4702",
            "localite": "Oensingen"
        },
        {
            "code": "4703",
            "localite": "Kestenholz"
        },
        {
            "code": "4704",
            "localite": "Niederbipp"
        },
        {
            "code": "4704",
            "localite": "Wolfisberg"
        },
        {
            "code": "4710",
            "localite": "Balsthal"
        },
        {
            "code": "4712",
            "localite": "Laupersdorf"
        },
        {
            "code": "4713",
            "localite": "Matzendorf"
        },
        {
            "code": "4714",
            "localite": "Aedermannsdorf"
        },
        {
            "code": "4715",
            "localite": "Herbetswil"
        },
        {
            "code": "4716",
            "localite": "Gänsbrunnen"
        },
        {
            "code": "4716",
            "localite": "Welschenrohr"
        },
        {
            "code": "4717",
            "localite": "Mümliswil"
        },
        {
            "code": "4718",
            "localite": "Holderbank SO"
        },
        {
            "code": "4719",
            "localite": "Ramiswil"
        },
        {
            "code": "4800",
            "localite": "Zofingen"
        },
        {
            "code": "4802",
            "localite": "Strengelbach"
        },
        {
            "code": "4803",
            "localite": "Vordemwald"
        },
        {
            "code": "4805",
            "localite": "Brittnau"
        },
        {
            "code": "4806",
            "localite": "Wikon"
        },
        {
            "code": "4812",
            "localite": "Mühlethal"
        },
        {
            "code": "4813",
            "localite": "Uerkheim"
        },
        {
            "code": "4814",
            "localite": "Bottenwil"
        },
        {
            "code": "4852",
            "localite": "Rothrist"
        },
        {
            "code": "4853",
            "localite": "Murgenthal"
        },
        {
            "code": "4853",
            "localite": "Riken AG"
        },
        {
            "code": "4856",
            "localite": "Glashütten"
        },
        {
            "code": "4900",
            "localite": "Langenthal"
        },
        {
            "code": "4911",
            "localite": "Schwarzhäusern"
        },
        {
            "code": "4912",
            "localite": "Aarwangen"
        },
        {
            "code": "4913",
            "localite": "Bannwil"
        },
        {
            "code": "4914",
            "localite": "Roggwil BE"
        },
        {
            "code": "4915",
            "localite": "St. Urban"
        },
        {
            "code": "4916",
            "localite": "Untersteckholz"
        },
        {
            "code": "4917",
            "localite": "Busswil b. Melchnau"
        },
        {
            "code": "4917",
            "localite": "Melchnau"
        },
        {
            "code": "4919",
            "localite": "Reisiswil"
        },
        {
            "code": "4922",
            "localite": "Bützberg"
        },
        {
            "code": "4922",
            "localite": "Thunstetten"
        },
        {
            "code": "4923",
            "localite": "Wynau"
        },
        {
            "code": "4924",
            "localite": "Obersteckholz"
        },
        {
            "code": "4932",
            "localite": "Gutenburg"
        },
        {
            "code": "4932",
            "localite": "Lotzwil"
        },
        {
            "code": "4933",
            "localite": "Rütschelen"
        },
        {
            "code": "4934",
            "localite": "Madiswil"
        },
        {
            "code": "4935",
            "localite": "Leimiswil"
        },
        {
            "code": "4936",
            "localite": "Kleindietwil"
        },
        {
            "code": "4937",
            "localite": "Ursenbach"
        },
        {
            "code": "4938",
            "localite": "Rohrbach"
        },
        {
            "code": "4938",
            "localite": "Rohrbachgraben"
        },
        {
            "code": "4942",
            "localite": "Walterswil BE"
        },
        {
            "code": "4943",
            "localite": "Oeschenbach"
        },
        {
            "code": "4944",
            "localite": "Auswil"
        },
        {
            "code": "4950",
            "localite": "Huttwil"
        },
        {
            "code": "4952",
            "localite": "Eriswil"
        },
        {
            "code": "4953",
            "localite": "Schwarzenbach (Huttwil)"
        },
        {
            "code": "4954",
            "localite": "Wyssachen"
        },
        {
            "code": "4955",
            "localite": "Gondiswil"
        },
        {
            "code": "5000",
            "localite": "Aarau"
        },
        {
            "code": "5004",
            "localite": "Aarau"
        },
        {
            "code": "5012",
            "localite": "Eppenberg"
        },
        {
            "code": "5012",
            "localite": "Schönenwerd"
        },
        {
            "code": "5012",
            "localite": "Wöschnau"
        },
        {
            "code": "5013",
            "localite": "Niedergösgen"
        },
        {
            "code": "5014",
            "localite": "Gretzenbach"
        },
        {
            "code": "5015",
            "localite": "Erlinsbach SO"
        },
        {
            "code": "5017",
            "localite": "Barmelweid"
        },
        {
            "code": "5018",
            "localite": "Erlinsbach"
        },
        {
            "code": "5022",
            "localite": "Rombach"
        },
        {
            "code": "5023",
            "localite": "Biberstein"
        },
        {
            "code": "5024",
            "localite": "Küttigen"
        },
        {
            "code": "5025",
            "localite": "Asp"
        },
        {
            "code": "5026",
            "localite": "Densbüren"
        },
        {
            "code": "5027",
            "localite": "Herznach"
        },
        {
            "code": "5028",
            "localite": "Ueken"
        },
        {
            "code": "5032",
            "localite": "Aarau Rohr"
        },
        {
            "code": "5033",
            "localite": "Buchs AG"
        },
        {
            "code": "5034",
            "localite": "Suhr"
        },
        {
            "code": "5035",
            "localite": "Unterentfelden"
        },
        {
            "code": "5036",
            "localite": "Oberentfelden"
        },
        {
            "code": "5037",
            "localite": "Muhen"
        },
        {
            "code": "5040",
            "localite": "Schöftland"
        },
        {
            "code": "5042",
            "localite": "Hirschthal"
        },
        {
            "code": "5043",
            "localite": "Holziken"
        },
        {
            "code": "5044",
            "localite": "Schlossrued"
        },
        {
            "code": "5046",
            "localite": "Schmiedrued"
        },
        {
            "code": "5046",
            "localite": "Walde AG"
        },
        {
            "code": "5053",
            "localite": "Staffelbach"
        },
        {
            "code": "5053",
            "localite": "Wittwil"
        },
        {
            "code": "5054",
            "localite": "Kirchleerau"
        },
        {
            "code": "5054",
            "localite": "Moosleerau"
        },
        {
            "code": "5056",
            "localite": "Attelwil"
        },
        {
            "code": "5057",
            "localite": "Reitnau"
        },
        {
            "code": "5058",
            "localite": "Wiliberg"
        },
        {
            "code": "5062",
            "localite": "Oberhof"
        },
        {
            "code": "5063",
            "localite": "Wölflinswil"
        },
        {
            "code": "5064",
            "localite": "Wittnau"
        },
        {
            "code": "5070",
            "localite": "Frick"
        },
        {
            "code": "5072",
            "localite": "Oeschgen"
        },
        {
            "code": "5073",
            "localite": "Gipf-Oberfrick"
        },
        {
            "code": "5074",
            "localite": "Eiken"
        },
        {
            "code": "5075",
            "localite": "Hornussen"
        },
        {
            "code": "5076",
            "localite": "Bözen"
        },
        {
            "code": "5077",
            "localite": "Elfingen"
        },
        {
            "code": "5078",
            "localite": "Effingen"
        },
        {
            "code": "5079",
            "localite": "Zeihen"
        },
        {
            "code": "5080",
            "localite": "Laufenburg"
        },
        {
            "code": "5082",
            "localite": "Kaisten"
        },
        {
            "code": "5083",
            "localite": "Ittenthal"
        },
        {
            "code": "5084",
            "localite": "Rheinsulz"
        },
        {
            "code": "5085",
            "localite": "Sulz AG"
        },
        {
            "code": "5102",
            "localite": "Rupperswil"
        },
        {
            "code": "5103",
            "localite": "Möriken AG"
        },
        {
            "code": "5103",
            "localite": "Wildegg"
        },
        {
            "code": "5105",
            "localite": "Auenstein"
        },
        {
            "code": "5106",
            "localite": "Veltheim AG"
        },
        {
            "code": "5107",
            "localite": "Schinznach Dorf"
        },
        {
            "code": "5108",
            "localite": "Oberflachs"
        },
        {
            "code": "5112",
            "localite": "Thalheim AG"
        },
        {
            "code": "5113",
            "localite": "Holderbank AG"
        },
        {
            "code": "5116",
            "localite": "Schinznach Bad"
        },
        {
            "code": "5200",
            "localite": "Brugg AG"
        },
        {
            "code": "5210",
            "localite": "Windisch"
        },
        {
            "code": "5212",
            "localite": "Hausen AG"
        },
        {
            "code": "5213",
            "localite": "Villnachern"
        },
        {
            "code": "5222",
            "localite": "Umiken"
        },
        {
            "code": "5223",
            "localite": "Riniken"
        },
        {
            "code": "5225",
            "localite": "Bözberg"
        },
        {
            "code": "5233",
            "localite": "Stilli"
        },
        {
            "code": "5234",
            "localite": "Villigen"
        },
        {
            "code": "5235",
            "localite": "Rüfenach AG"
        },
        {
            "code": "5236",
            "localite": "Remigen"
        },
        {
            "code": "5237",
            "localite": "Mönthal"
        },
        {
            "code": "5242",
            "localite": "Birr"
        },
        {
            "code": "5242",
            "localite": "Lupfig"
        },
        {
            "code": "5243",
            "localite": "Mülligen"
        },
        {
            "code": "5244",
            "localite": "Birrhard"
        },
        {
            "code": "5245",
            "localite": "Habsburg"
        },
        {
            "code": "5246",
            "localite": "Scherz"
        },
        {
            "code": "5272",
            "localite": "Gansingen"
        },
        {
            "code": "5273",
            "localite": "Oberhofen AG"
        },
        {
            "code": "5274",
            "localite": "Mettau"
        },
        {
            "code": "5275",
            "localite": "Etzgen"
        },
        {
            "code": "5276",
            "localite": "Wil AG"
        },
        {
            "code": "5277",
            "localite": "Hottwil"
        },
        {
            "code": "5300",
            "localite": "Turgi"
        },
        {
            "code": "5301",
            "localite": "Siggenthal Station"
        },
        {
            "code": "5303",
            "localite": "Würenlingen"
        },
        {
            "code": "5304",
            "localite": "Endingen"
        },
        {
            "code": "5305",
            "localite": "Unterendingen"
        },
        {
            "code": "5306",
            "localite": "Tegerfelden"
        },
        {
            "code": "5312",
            "localite": "Döttingen"
        },
        {
            "code": "5313",
            "localite": "Klingnau"
        },
        {
            "code": "5314",
            "localite": "Kleindöttingen"
        },
        {
            "code": "5315",
            "localite": "Böttstein"
        },
        {
            "code": "5316",
            "localite": "Leuggern"
        },
        {
            "code": "5317",
            "localite": "Hettenschwil"
        },
        {
            "code": "5318",
            "localite": "Mandach"
        },
        {
            "code": "5322",
            "localite": "Koblenz"
        },
        {
            "code": "5323",
            "localite": "Rietheim"
        },
        {
            "code": "5324",
            "localite": "Full-Reuenthal"
        },
        {
            "code": "5325",
            "localite": "Leibstadt"
        },
        {
            "code": "5326",
            "localite": "Schwaderloch"
        },
        {
            "code": "5330",
            "localite": "Bad Zurzach"
        },
        {
            "code": "5332",
            "localite": "Rekingen AG"
        },
        {
            "code": "5333",
            "localite": "Baldingen"
        },
        {
            "code": "5334",
            "localite": "Böbikon"
        },
        {
            "code": "5400",
            "localite": "Baden"
        },
        {
            "code": "5404",
            "localite": "Baden"
        },
        {
            "code": "5405",
            "localite": "Dättwil AG"
        },
        {
            "code": "5406",
            "localite": "Rütihof"
        },
        {
            "code": "5408",
            "localite": "Ennetbaden"
        },
        {
            "code": "5412",
            "localite": "Gebenstorf"
        },
        {
            "code": "5412",
            "localite": "Vogelsang AG"
        },
        {
            "code": "5413",
            "localite": "Birmenstorf AG"
        },
        {
            "code": "5415",
            "localite": "Hertenstein AG"
        },
        {
            "code": "5415",
            "localite": "Nussbaumen AG"
        },
        {
            "code": "5415",
            "localite": "Rieden AG"
        },
        {
            "code": "5416",
            "localite": "Kirchdorf AG"
        },
        {
            "code": "5417",
            "localite": "Untersiggenthal"
        },
        {
            "code": "5420",
            "localite": "Ehrendingen"
        },
        {
            "code": "5423",
            "localite": "Freienwil"
        },
        {
            "code": "5425",
            "localite": "Schneisingen"
        },
        {
            "code": "5426",
            "localite": "Lengnau AG"
        },
        {
            "code": "5430",
            "localite": "Wettingen"
        },
        {
            "code": "5432",
            "localite": "Neuenhof"
        },
        {
            "code": "5436",
            "localite": "Würenlos"
        },
        {
            "code": "5442",
            "localite": "Fislisbach"
        },
        {
            "code": "5443",
            "localite": "Niederrohrdorf"
        },
        {
            "code": "5444",
            "localite": "Künten"
        },
        {
            "code": "5445",
            "localite": "Eggenwil"
        },
        {
            "code": "5452",
            "localite": "Oberrohrdorf"
        },
        {
            "code": "5453",
            "localite": "Remetschwil"
        },
        {
            "code": "5454",
            "localite": "Bellikon"
        },
        {
            "code": "5462",
            "localite": "Siglistorf"
        },
        {
            "code": "5463",
            "localite": "Wislikofen"
        },
        {
            "code": "5464",
            "localite": "Rümikon AG"
        },
        {
            "code": "5465",
            "localite": "Mellikon"
        },
        {
            "code": "5466",
            "localite": "Kaiserstuhl AG"
        },
        {
            "code": "5467",
            "localite": "Fisibach"
        },
        {
            "code": "5502",
            "localite": "Hunzenschwil"
        },
        {
            "code": "5503",
            "localite": "Schafisheim"
        },
        {
            "code": "5504",
            "localite": "Othmarsingen"
        },
        {
            "code": "5505",
            "localite": "Brunegg"
        },
        {
            "code": "5506",
            "localite": "Mägenwil"
        },
        {
            "code": "5507",
            "localite": "Mellingen"
        },
        {
            "code": "5512",
            "localite": "Wohlenschwil"
        },
        {
            "code": "5522",
            "localite": "Tägerig"
        },
        {
            "code": "5524",
            "localite": "Nesselnbach"
        },
        {
            "code": "5524",
            "localite": "Niederwil AG"
        },
        {
            "code": "5525",
            "localite": "Fischbach-Göslikon"
        },
        {
            "code": "5600",
            "localite": "Ammerswil AG"
        },
        {
            "code": "5600",
            "localite": "Lenzburg"
        },
        {
            "code": "5603",
            "localite": "Staufen"
        },
        {
            "code": "5604",
            "localite": "Hendschiken"
        },
        {
            "code": "5605",
            "localite": "Dottikon"
        },
        {
            "code": "5606",
            "localite": "Dintikon"
        },
        {
            "code": "5607",
            "localite": "Hägglingen"
        },
        {
            "code": "5608",
            "localite": "Stetten AG"
        },
        {
            "code": "5610",
            "localite": "Wohlen AG"
        },
        {
            "code": "5611",
            "localite": "Anglikon"
        },
        {
            "code": "5612",
            "localite": "Villmergen"
        },
        {
            "code": "5613",
            "localite": "Hilfikon"
        },
        {
            "code": "5614",
            "localite": "Sarmenstorf"
        },
        {
            "code": "5615",
            "localite": "Fahrwangen"
        },
        {
            "code": "5616",
            "localite": "Meisterschwanden"
        },
        {
            "code": "5617",
            "localite": "Tennwil"
        },
        {
            "code": "5618",
            "localite": "Bettwil"
        },
        {
            "code": "5619",
            "localite": "Büttikon AG"
        },
        {
            "code": "5619",
            "localite": "Uezwil"
        },
        {
            "code": "5620",
            "localite": "Bremgarten AG"
        },
        {
            "code": "5621",
            "localite": "Zufikon"
        },
        {
            "code": "5622",
            "localite": "Waltenschwil"
        },
        {
            "code": "5623",
            "localite": "Boswil"
        },
        {
            "code": "5624",
            "localite": "Bünzen"
        },
        {
            "code": "5624",
            "localite": "Waldhäusern AG"
        },
        {
            "code": "5625",
            "localite": "Kallern"
        },
        {
            "code": "5626",
            "localite": "Hermetschwil-Staffeln"
        },
        {
            "code": "5627",
            "localite": "Besenbüren"
        },
        {
            "code": "5628",
            "localite": "Aristau"
        },
        {
            "code": "5630",
            "localite": "Muri AG"
        },
        {
            "code": "5632",
            "localite": "Buttwil"
        },
        {
            "code": "5634",
            "localite": "Merenschwand"
        },
        {
            "code": "5636",
            "localite": "Benzenschwil"
        },
        {
            "code": "5637",
            "localite": "Beinwil (Freiamt)"
        },
        {
            "code": "5637",
            "localite": "Geltwil"
        },
        {
            "code": "5642",
            "localite": "Mühlau"
        },
        {
            "code": "5643",
            "localite": "Alikon"
        },
        {
            "code": "5643",
            "localite": "Meienberg"
        },
        {
            "code": "5643",
            "localite": "Sins"
        },
        {
            "code": "5644",
            "localite": "Auw"
        },
        {
            "code": "5645",
            "localite": "Aettenschwil"
        },
        {
            "code": "5645",
            "localite": "Fenkrieden"
        },
        {
            "code": "5646",
            "localite": "Abtwil AG"
        },
        {
            "code": "5647",
            "localite": "Oberrüti"
        },
        {
            "code": "5702",
            "localite": "Niederlenz"
        },
        {
            "code": "5703",
            "localite": "Seon"
        },
        {
            "code": "5704",
            "localite": "Egliswil"
        },
        {
            "code": "5705",
            "localite": "Hallwil"
        },
        {
            "code": "5706",
            "localite": "Boniswil"
        },
        {
            "code": "5707",
            "localite": "Seengen"
        },
        {
            "code": "5708",
            "localite": "Birrwil"
        },
        {
            "code": "5712",
            "localite": "Beinwil am See"
        },
        {
            "code": "5722",
            "localite": "Gränichen"
        },
        {
            "code": "5723",
            "localite": "Teufenthal AG"
        },
        {
            "code": "5724",
            "localite": "Dürrenäsch"
        },
        {
            "code": "5725",
            "localite": "Leutwil"
        },
        {
            "code": "5726",
            "localite": "Unterkulm"
        },
        {
            "code": "5727",
            "localite": "Oberkulm"
        },
        {
            "code": "5728",
            "localite": "Gontenschwil"
        },
        {
            "code": "5732",
            "localite": "Zetzwil"
        },
        {
            "code": "5733",
            "localite": "Leimbach AG"
        },
        {
            "code": "5734",
            "localite": "Reinach AG"
        },
        {
            "code": "5735",
            "localite": "Pfeffikon LU"
        },
        {
            "code": "5736",
            "localite": "Burg AG"
        },
        {
            "code": "5737",
            "localite": "Menziken"
        },
        {
            "code": "5742",
            "localite": "Kölliken"
        },
        {
            "code": "5745",
            "localite": "Safenwil"
        },
        {
            "code": "5746",
            "localite": "Walterswil SO"
        },
        {
            "code": "6003",
            "localite": "Luzern"
        },
        {
            "code": "6004",
            "localite": "Luzern"
        },
        {
            "code": "6005",
            "localite": "Luzern"
        },
        {
            "code": "6005",
            "localite": "St. Niklausen LU"
        },
        {
            "code": "6006",
            "localite": "Luzern"
        },
        {
            "code": "6010",
            "localite": "Kriens"
        },
        {
            "code": "6010",
            "localite": "Pilatus Kulm"
        },
        {
            "code": "6012",
            "localite": "Obernau"
        },
        {
            "code": "6013",
            "localite": "Eigenthal"
        },
        {
            "code": "6014",
            "localite": "Luzern"
        },
        {
            "code": "6015",
            "localite": "Luzern"
        },
        {
            "code": "6016",
            "localite": "Hellbühl"
        },
        {
            "code": "6017",
            "localite": "Ruswil"
        },
        {
            "code": "6018",
            "localite": "Buttisholz"
        },
        {
            "code": "6019",
            "localite": "Sigigen"
        },
        {
            "code": "6020",
            "localite": "Emmenbrücke"
        },
        {
            "code": "6022",
            "localite": "Grosswangen"
        },
        {
            "code": "6023",
            "localite": "Rothenburg"
        },
        {
            "code": "6024",
            "localite": "Hildisrieden"
        },
        {
            "code": "6025",
            "localite": "Neudorf"
        },
        {
            "code": "6026",
            "localite": "Rain"
        },
        {
            "code": "6027",
            "localite": "Römerswil LU"
        },
        {
            "code": "6028",
            "localite": "Herlisberg"
        },
        {
            "code": "6030",
            "localite": "Ebikon"
        },
        {
            "code": "6032",
            "localite": "Emmen"
        },
        {
            "code": "6033",
            "localite": "Buchrain"
        },
        {
            "code": "6034",
            "localite": "Inwil"
        },
        {
            "code": "6035",
            "localite": "Perlen"
        },
        {
            "code": "6036",
            "localite": "Dierikon"
        },
        {
            "code": "6037",
            "localite": "Root"
        },
        {
            "code": "6038",
            "localite": "Gisikon"
        },
        {
            "code": "6038",
            "localite": "Honau"
        },
        {
            "code": "6039",
            "localite": "Root D4"
        },
        {
            "code": "6042",
            "localite": "Dietwil"
        },
        {
            "code": "6043",
            "localite": "Adligenswil"
        },
        {
            "code": "6044",
            "localite": "Udligenswil"
        },
        {
            "code": "6045",
            "localite": "Meggen"
        },
        {
            "code": "6047",
            "localite": "Kastanienbaum"
        },
        {
            "code": "6048",
            "localite": "Horw"
        },
        {
            "code": "6052",
            "localite": "Hergiswil NW"
        },
        {
            "code": "6053",
            "localite": "Alpnachstad"
        },
        {
            "code": "6055",
            "localite": "Alpnach Dorf"
        },
        {
            "code": "6056",
            "localite": "Kägiswil"
        },
        {
            "code": "6060",
            "localite": "Ramersberg"
        },
        {
            "code": "6060",
            "localite": "Sarnen"
        },
        {
            "code": "6062",
            "localite": "Wilen (Sarnen)"
        },
        {
            "code": "6063",
            "localite": "Stalden (Sarnen)"
        },
        {
            "code": "6064",
            "localite": "Kerns"
        },
        {
            "code": "6066",
            "localite": "St. Niklausen OW"
        },
        {
            "code": "6067",
            "localite": "Melchtal"
        },
        {
            "code": "6068",
            "localite": "Melchsee-Frutt"
        },
        {
            "code": "6072",
            "localite": "Sachseln"
        },
        {
            "code": "6073",
            "localite": "Flüeli-Ranft"
        },
        {
            "code": "6074",
            "localite": "Giswil"
        },
        {
            "code": "6078",
            "localite": "Bürglen OW"
        },
        {
            "code": "6078",
            "localite": "Lungern"
        },
        {
            "code": "6083",
            "localite": "Hasliberg Hohfluh"
        },
        {
            "code": "6084",
            "localite": "Hasliberg Wasserwendi"
        },
        {
            "code": "6085",
            "localite": "Hasliberg Goldern"
        },
        {
            "code": "6086",
            "localite": "Hasliberg Reuti"
        },
        {
            "code": "6102",
            "localite": "Malters"
        },
        {
            "code": "6103",
            "localite": "Schwarzenberg LU"
        },
        {
            "code": "6105",
            "localite": "Schachen LU"
        },
        {
            "code": "6106",
            "localite": "Werthenstein"
        },
        {
            "code": "6110",
            "localite": "Fontannen b. Wolhusen"
        },
        {
            "code": "6110",
            "localite": "Wolhusen"
        },
        {
            "code": "6112",
            "localite": "Doppleschwand"
        },
        {
            "code": "6113",
            "localite": "Romoos"
        },
        {
            "code": "6114",
            "localite": "Steinhuserberg"
        },
        {
            "code": "6122",
            "localite": "Menznau"
        },
        {
            "code": "6123",
            "localite": "Geiss"
        },
        {
            "code": "6125",
            "localite": "Menzberg"
        },
        {
            "code": "6126",
            "localite": "Daiwil"
        },
        {
            "code": "6130",
            "localite": "Willisau"
        },
        {
            "code": "6132",
            "localite": "Rohrmatt"
        },
        {
            "code": "6133",
            "localite": "Hergiswil b. Willisau"
        },
        {
            "code": "6142",
            "localite": "Gettnau"
        },
        {
            "code": "6143",
            "localite": "Ohmstal"
        },
        {
            "code": "6144",
            "localite": "Zell LU"
        },
        {
            "code": "6145",
            "localite": "Fischbach LU"
        },
        {
            "code": "6146",
            "localite": "Grossdietwil"
        },
        {
            "code": "6147",
            "localite": "Altbüron"
        },
        {
            "code": "6152",
            "localite": "Hüswil"
        },
        {
            "code": "6153",
            "localite": "Ufhusen"
        },
        {
            "code": "6154",
            "localite": "Hofstatt"
        },
        {
            "code": "6156",
            "localite": "Luthern"
        },
        {
            "code": "6156",
            "localite": "Luthern Bad"
        },
        {
            "code": "6162",
            "localite": "Entlebuch"
        },
        {
            "code": "6162",
            "localite": "Finsterwald b. Entlebuch"
        },
        {
            "code": "6162",
            "localite": "Rengg"
        },
        {
            "code": "6163",
            "localite": "Ebnet"
        },
        {
            "code": "6166",
            "localite": "Hasle LU"
        },
        {
            "code": "6167",
            "localite": "Bramboden"
        },
        {
            "code": "6170",
            "localite": "Schüpfheim"
        },
        {
            "code": "6173",
            "localite": "Flühli LU"
        },
        {
            "code": "6174",
            "localite": "Sörenberg"
        },
        {
            "code": "6182",
            "localite": "Escholzmatt"
        },
        {
            "code": "6192",
            "localite": "Wiggen"
        },
        {
            "code": "6196",
            "localite": "Marbach LU"
        },
        {
            "code": "6197",
            "localite": "Schangnau"
        },
        {
            "code": "6203",
            "localite": "Sempach Station"
        },
        {
            "code": "6204",
            "localite": "Sempach"
        },
        {
            "code": "6205",
            "localite": "Eich"
        },
        {
            "code": "6206",
            "localite": "Neuenkirch"
        },
        {
            "code": "6207",
            "localite": "Nottwil"
        },
        {
            "code": "6208",
            "localite": "Oberkirch LU"
        },
        {
            "code": "6210",
            "localite": "Sursee"
        },
        {
            "code": "6211",
            "localite": "Buchs LU"
        },
        {
            "code": "6212",
            "localite": "Kaltbach"
        },
        {
            "code": "6212",
            "localite": "St. Erhard"
        },
        {
            "code": "6213",
            "localite": "Knutwil"
        },
        {
            "code": "6214",
            "localite": "Schenkon"
        },
        {
            "code": "6215",
            "localite": "Beromünster"
        },
        {
            "code": "6215",
            "localite": "Schwarzenbach LU"
        },
        {
            "code": "6216",
            "localite": "Mauensee"
        },
        {
            "code": "6217",
            "localite": "Kottwil"
        },
        {
            "code": "6218",
            "localite": "Ettiswil"
        },
        {
            "code": "6221",
            "localite": "Rickenbach LU"
        },
        {
            "code": "6222",
            "localite": "Gunzwil"
        },
        {
            "code": "6231",
            "localite": "Schlierbach"
        },
        {
            "code": "6232",
            "localite": "Geuensee"
        },
        {
            "code": "6233",
            "localite": "Büron"
        },
        {
            "code": "6234",
            "localite": "Kulmerau"
        },
        {
            "code": "6234",
            "localite": "Triengen"
        },
        {
            "code": "6235",
            "localite": "Winikon"
        },
        {
            "code": "6236",
            "localite": "Wilihof"
        },
        {
            "code": "6242",
            "localite": "Wauwil"
        },
        {
            "code": "6243",
            "localite": "Egolzwil"
        },
        {
            "code": "6244",
            "localite": "Nebikon"
        },
        {
            "code": "6245",
            "localite": "Ebersecken"
        },
        {
            "code": "6246",
            "localite": "Altishofen"
        },
        {
            "code": "6247",
            "localite": "Schötz"
        },
        {
            "code": "6248",
            "localite": "Alberswil"
        },
        {
            "code": "6252",
            "localite": "Dagmersellen"
        },
        {
            "code": "6253",
            "localite": "Uffikon"
        },
        {
            "code": "6260",
            "localite": "Hintermoos"
        },
        {
            "code": "6260",
            "localite": "Mehlsecken"
        },
        {
            "code": "6260",
            "localite": "Reiden"
        },
        {
            "code": "6260",
            "localite": "Reidermoos"
        },
        {
            "code": "6262",
            "localite": "Langnau b. Reiden"
        },
        {
            "code": "6263",
            "localite": "Richenthal"
        },
        {
            "code": "6264",
            "localite": "Pfaffnau"
        },
        {
            "code": "6265",
            "localite": "Roggliswil"
        },
        {
            "code": "6274",
            "localite": "Eschenbach LU"
        },
        {
            "code": "6275",
            "localite": "Ballwil"
        },
        {
            "code": "6276",
            "localite": "Hohenrain"
        },
        {
            "code": "6277",
            "localite": "Kleinwangen"
        },
        {
            "code": "6277",
            "localite": "Lieli LU"
        },
        {
            "code": "6280",
            "localite": "Hochdorf"
        },
        {
            "code": "6280",
            "localite": "Urswil"
        },
        {
            "code": "6283",
            "localite": "Baldegg"
        },
        {
            "code": "6284",
            "localite": "Gelfingen"
        },
        {
            "code": "6284",
            "localite": "Sulz LU"
        },
        {
            "code": "6285",
            "localite": "Hitzkirch"
        },
        {
            "code": "6285",
            "localite": "Retschwil"
        },
        {
            "code": "6286",
            "localite": "Altwis"
        },
        {
            "code": "6287",
            "localite": "Aesch LU"
        },
        {
            "code": "6288",
            "localite": "Schongau"
        },
        {
            "code": "6289",
            "localite": "Hämikon"
        },
        {
            "code": "6289",
            "localite": "Müswangen"
        },
        {
            "code": "6294",
            "localite": "Ermensee"
        },
        {
            "code": "6295",
            "localite": "Mosen"
        },
        {
            "code": "6300",
            "localite": "Zug"
        },
        {
            "code": "6300",
            "localite": "Zugerberg"
        },
        {
            "code": "6312",
            "localite": "Steinhausen"
        },
        {
            "code": "6313",
            "localite": "Edlibach"
        },
        {
            "code": "6313",
            "localite": "Finstersee"
        },
        {
            "code": "6313",
            "localite": "Menzingen"
        },
        {
            "code": "6314",
            "localite": "Neuägeri"
        },
        {
            "code": "6314",
            "localite": "Unterägeri"
        },
        {
            "code": "6315",
            "localite": "Alosen"
        },
        {
            "code": "6315",
            "localite": "Morgarten"
        },
        {
            "code": "6315",
            "localite": "Oberägeri"
        },
        {
            "code": "6317",
            "localite": "Oberwil b. Zug"
        },
        {
            "code": "6318",
            "localite": "Walchwil"
        },
        {
            "code": "6319",
            "localite": "Allenwinden"
        },
        {
            "code": "6330",
            "localite": "Cham"
        },
        {
            "code": "6331",
            "localite": "Hünenberg"
        },
        {
            "code": "6332",
            "localite": "Hagendorn"
        },
        {
            "code": "6333",
            "localite": "Hünenberg See"
        },
        {
            "code": "6340",
            "localite": "Baar"
        },
        {
            "code": "6340",
            "localite": "Sihlbrugg"
        },
        {
            "code": "6343",
            "localite": "Buonas"
        },
        {
            "code": "6343",
            "localite": "Holzhäusern ZG"
        },
        {
            "code": "6343",
            "localite": "Risch"
        },
        {
            "code": "6343",
            "localite": "Rotkreuz"
        },
        {
            "code": "6344",
            "localite": "Meierskappel"
        },
        {
            "code": "6345",
            "localite": "Neuheim"
        },
        {
            "code": "6353",
            "localite": "Weggis"
        },
        {
            "code": "6354",
            "localite": "Vitznau"
        },
        {
            "code": "6356",
            "localite": "Rigi Kaltbad"
        },
        {
            "code": "6362",
            "localite": "Stansstad"
        },
        {
            "code": "6363",
            "localite": "Bürgenstock"
        },
        {
            "code": "6363",
            "localite": "Fürigen"
        },
        {
            "code": "6363",
            "localite": "Obbürgen"
        },
        {
            "code": "6365",
            "localite": "Kehrsiten"
        },
        {
            "code": "6370",
            "localite": "Oberdorf NW"
        },
        {
            "code": "6370",
            "localite": "Stans"
        },
        {
            "code": "6372",
            "localite": "Ennetmoos"
        },
        {
            "code": "6373",
            "localite": "Ennetbürgen"
        },
        {
            "code": "6374",
            "localite": "Buochs"
        },
        {
            "code": "6375",
            "localite": "Beckenried"
        },
        {
            "code": "6376",
            "localite": "Emmetten"
        },
        {
            "code": "6377",
            "localite": "Seelisberg"
        },
        {
            "code": "6382",
            "localite": "Büren NW"
        },
        {
            "code": "6383",
            "localite": "Dallenwil"
        },
        {
            "code": "6383",
            "localite": "Niederrickenbach"
        },
        {
            "code": "6383",
            "localite": "Wiesenberg"
        },
        {
            "code": "6383",
            "localite": "Wirzweli"
        },
        {
            "code": "6386",
            "localite": "Wolfenschiessen"
        },
        {
            "code": "6387",
            "localite": "Oberrickenbach"
        },
        {
            "code": "6388",
            "localite": "Grafenort"
        },
        {
            "code": "6390",
            "localite": "Engelberg"
        },
        {
            "code": "6402",
            "localite": "Merlischachen"
        },
        {
            "code": "6403",
            "localite": "Küssnacht am Rigi"
        },
        {
            "code": "6404",
            "localite": "Greppen"
        },
        {
            "code": "6405",
            "localite": "Immensee"
        },
        {
            "code": "6410",
            "localite": "Goldau"
        },
        {
            "code": "6410",
            "localite": "Rigi Klösterli"
        },
        {
            "code": "6410",
            "localite": "Rigi Kulm"
        },
        {
            "code": "6410",
            "localite": "Rigi Scheidegg"
        },
        {
            "code": "6410",
            "localite": "Rigi Staffel"
        },
        {
            "code": "6414",
            "localite": "Oberarth"
        },
        {
            "code": "6415",
            "localite": "Arth"
        },
        {
            "code": "6416",
            "localite": "Steinerberg"
        },
        {
            "code": "6417",
            "localite": "Sattel"
        },
        {
            "code": "6418",
            "localite": "Rothenthurm"
        },
        {
            "code": "6422",
            "localite": "Steinen"
        },
        {
            "code": "6423",
            "localite": "Seewen SZ"
        },
        {
            "code": "6424",
            "localite": "Lauerz"
        },
        {
            "code": "6430",
            "localite": "Schwyz"
        },
        {
            "code": "6432",
            "localite": "Rickenbach b. Schwyz"
        },
        {
            "code": "6433",
            "localite": "Stoos SZ"
        },
        {
            "code": "6434",
            "localite": "Illgau"
        },
        {
            "code": "6436",
            "localite": "Bisisthal"
        },
        {
            "code": "6436",
            "localite": "Muotathal"
        },
        {
            "code": "6436",
            "localite": "Ried (Muotathal)"
        },
        {
            "code": "6438",
            "localite": "Ibach"
        },
        {
            "code": "6440",
            "localite": "Brunnen"
        },
        {
            "code": "6441",
            "localite": "Rütli"
        },
        {
            "code": "6442",
            "localite": "Gersau"
        },
        {
            "code": "6443",
            "localite": "Morschach"
        },
        {
            "code": "6452",
            "localite": "Riemenstalden"
        },
        {
            "code": "6452",
            "localite": "Sisikon"
        },
        {
            "code": "6454",
            "localite": "Flüelen"
        },
        {
            "code": "6460",
            "localite": "Altdorf UR"
        },
        {
            "code": "6461",
            "localite": "Isenthal"
        },
        {
            "code": "6462",
            "localite": "Seedorf UR"
        },
        {
            "code": "6463",
            "localite": "Bürglen UR"
        },
        {
            "code": "6464",
            "localite": "Spiringen"
        },
        {
            "code": "6465",
            "localite": "Unterschächen"
        },
        {
            "code": "6466",
            "localite": "Bauen"
        },
        {
            "code": "6467",
            "localite": "Schattdorf"
        },
        {
            "code": "6468",
            "localite": "Attinghausen"
        },
        {
            "code": "6469",
            "localite": "Haldi b. Schattdorf"
        },
        {
            "code": "6472",
            "localite": "Erstfeld"
        },
        {
            "code": "6473",
            "localite": "Silenen"
        },
        {
            "code": "6474",
            "localite": "Amsteg"
        },
        {
            "code": "6475",
            "localite": "Bristen"
        },
        {
            "code": "6476",
            "localite": "Intschi"
        },
        {
            "code": "6482",
            "localite": "Gurtnellen"
        },
        {
            "code": "6484",
            "localite": "Wassen UR"
        },
        {
            "code": "6485",
            "localite": "Meien"
        },
        {
            "code": "6487",
            "localite": "Göschenen"
        },
        {
            "code": "6490",
            "localite": "Andermatt"
        },
        {
            "code": "6491",
            "localite": "Realp"
        },
        {
            "code": "6493",
            "localite": "Hospental"
        },
        {
            "code": "6500",
            "localite": "Bellinzona"
        },
        {
            "code": "6503",
            "localite": "Bellinzona"
        },
        {
            "code": "6512",
            "localite": "Giubiasco"
        },
        {
            "code": "6513",
            "localite": "Monte Carasso"
        },
        {
            "code": "6514",
            "localite": "Sementina"
        },
        {
            "code": "6515",
            "localite": "Gudo"
        },
        {
            "code": "6516",
            "localite": "Cugnasco"
        },
        {
            "code": "6517",
            "localite": "Arbedo"
        },
        {
            "code": "6518",
            "localite": "Gorduno"
        },
        {
            "code": "6523",
            "localite": "Preonzo"
        },
        {
            "code": "6524",
            "localite": "Moleno"
        },
        {
            "code": "6525",
            "localite": "Gnosca"
        },
        {
            "code": "6526",
            "localite": "Prosito"
        },
        {
            "code": "6527",
            "localite": "Lodrino"
        },
        {
            "code": "6528",
            "localite": "Camorino"
        },
        {
            "code": "6532",
            "localite": "Castione"
        },
        {
            "code": "6533",
            "localite": "Lumino"
        },
        {
            "code": "6534",
            "localite": "S. Vittore"
        },
        {
            "code": "6535",
            "localite": "Roveredo GR"
        },
        {
            "code": "6537",
            "localite": "Grono"
        },
        {
            "code": "6538",
            "localite": "Verdabbio"
        },
        {
            "code": "6540",
            "localite": "Castaneda"
        },
        {
            "code": "6541",
            "localite": "Sta. Maria in Calanca"
        },
        {
            "code": "6542",
            "localite": "Buseno"
        },
        {
            "code": "6543",
            "localite": "Arvigo"
        },
        {
            "code": "6544",
            "localite": "Braggio"
        },
        {
            "code": "6545",
            "localite": "Selma"
        },
        {
            "code": "6546",
            "localite": "Cauco"
        },
        {
            "code": "6548",
            "localite": "Augio"
        },
        {
            "code": "6548",
            "localite": "Rossa"
        },
        {
            "code": "6548",
            "localite": "Sta. Domenica"
        },
        {
            "code": "6549",
            "localite": "Laura"
        },
        {
            "code": "6556",
            "localite": "Leggia"
        },
        {
            "code": "6557",
            "localite": "Cama"
        },
        {
            "code": "6558",
            "localite": "Lostallo"
        },
        {
            "code": "6562",
            "localite": "Soazza"
        },
        {
            "code": "6563",
            "localite": "Mesocco"
        },
        {
            "code": "6565",
            "localite": "S. Bernardino"
        },
        {
            "code": "6571",
            "localite": "Indemini"
        },
        {
            "code": "6572",
            "localite": "Quartino"
        },
        {
            "code": "6573",
            "localite": "Magadino"
        },
        {
            "code": "6574",
            "localite": "Vira (Gambarogno)"
        },
        {
            "code": "6575",
            "localite": "S. Nazzaro"
        },
        {
            "code": "6575",
            "localite": "Vairano"
        },
        {
            "code": "6576",
            "localite": "Gerra (Gambarogno)"
        },
        {
            "code": "6577",
            "localite": "Ranzo"
        },
        {
            "code": "6578",
            "localite": "Caviano"
        },
        {
            "code": "6579",
            "localite": "Piazzogna"
        },
        {
            "code": "6582",
            "localite": "Pianezzo"
        },
        {
            "code": "6583",
            "localite": "S. Antonio (Val Morobbia)"
        },
        {
            "code": "6584",
            "localite": "Carena"
        },
        {
            "code": "6592",
            "localite": "S. Antonino"
        },
        {
            "code": "6593",
            "localite": "Cadenazzo"
        },
        {
            "code": "6594",
            "localite": "Contone"
        },
        {
            "code": "6595",
            "localite": "Riazzino"
        },
        {
            "code": "6596",
            "localite": "Gordola"
        },
        {
            "code": "6597",
            "localite": "Agarone"
        },
        {
            "code": "6598",
            "localite": "Tenero"
        },
        {
            "code": "6599",
            "localite": "Robasacco"
        },
        {
            "code": "6600",
            "localite": "Locarno"
        },
        {
            "code": "6600",
            "localite": "Muralto"
        },
        {
            "code": "6600",
            "localite": "Solduno"
        },
        {
            "code": "6605",
            "localite": "Locarno"
        },
        {
            "code": "6612",
            "localite": "Ascona"
        },
        {
            "code": "6613",
            "localite": "Porto Ronco"
        },
        {
            "code": "6614",
            "localite": "Brissago"
        },
        {
            "code": "6614",
            "localite": "Isole di Brissago"
        },
        {
            "code": "6616",
            "localite": "Losone"
        },
        {
            "code": "6618",
            "localite": "Arcegno"
        },
        {
            "code": "6622",
            "localite": "Ronco sopra Ascona"
        },
        {
            "code": "6631",
            "localite": "Corippo"
        },
        {
            "code": "6632",
            "localite": "Vogorno"
        },
        {
            "code": "6633",
            "localite": "Lavertezzo"
        },
        {
            "code": "6634",
            "localite": "Brione (Verzasca)"
        },
        {
            "code": "6635",
            "localite": "Gerra (Verzasca)"
        },
        {
            "code": "6636",
            "localite": "Frasco"
        },
        {
            "code": "6637",
            "localite": "Sonogno"
        },
        {
            "code": "6644",
            "localite": "Orselina"
        },
        {
            "code": "6645",
            "localite": "Brione sopra Minusio"
        },
        {
            "code": "6646",
            "localite": "Contra"
        },
        {
            "code": "6647",
            "localite": "Mergoscia"
        },
        {
            "code": "6648",
            "localite": "Minusio"
        },
        {
            "code": "6652",
            "localite": "Tegna"
        },
        {
            "code": "6653",
            "localite": "Verscio"
        },
        {
            "code": "6654",
            "localite": "Cavigliano"
        },
        {
            "code": "6655",
            "localite": "Intragna"
        },
        {
            "code": "6655",
            "localite": "Rasa"
        },
        {
            "code": "6655",
            "localite": "Verdasio"
        },
        {
            "code": "6656",
            "localite": "Golino"
        },
        {
            "code": "6657",
            "localite": "Palagnedra"
        },
        {
            "code": "6658",
            "localite": "Borgnone"
        },
        {
            "code": "6659",
            "localite": "Camedo"
        },
        {
            "code": "6659",
            "localite": "Moneto"
        },
        {
            "code": "6661",
            "localite": "Auressio"
        },
        {
            "code": "6661",
            "localite": "Berzona"
        },
        {
            "code": "6661",
            "localite": "Comologno"
        },
        {
            "code": "6661",
            "localite": "Crana"
        },
        {
            "code": "6661",
            "localite": "Gresso"
        },
        {
            "code": "6661",
            "localite": "Loco"
        },
        {
            "code": "6661",
            "localite": "Mosogno"
        },
        {
            "code": "6661",
            "localite": "Russo"
        },
        {
            "code": "6661",
            "localite": "Spruga"
        },
        {
            "code": "6661",
            "localite": "Vergeletto"
        },
        {
            "code": "6670",
            "localite": "Avegno"
        },
        {
            "code": "6672",
            "localite": "Gordevio"
        },
        {
            "code": "6673",
            "localite": "Maggia"
        },
        {
            "code": "6674",
            "localite": "Riveo"
        },
        {
            "code": "6674",
            "localite": "Someo"
        },
        {
            "code": "6675",
            "localite": "Cevio"
        },
        {
            "code": "6676",
            "localite": "Bignasco"
        },
        {
            "code": "6677",
            "localite": "Aurigeno"
        },
        {
            "code": "6677",
            "localite": "Moghegno"
        },
        {
            "code": "6678",
            "localite": "Coglio"
        },
        {
            "code": "6678",
            "localite": "Giumaglio"
        },
        {
            "code": "6678",
            "localite": "Lodano"
        },
        {
            "code": "6682",
            "localite": "Linescio"
        },
        {
            "code": "6683",
            "localite": "Cerentino"
        },
        {
            "code": "6683",
            "localite": "Niva (Vallemaggia)"
        },
        {
            "code": "6684",
            "localite": "Campo (Vallemaggia)"
        },
        {
            "code": "6684",
            "localite": "Cimalmotto"
        },
        {
            "code": "6685",
            "localite": "Bosco/Gurin"
        },
        {
            "code": "6690",
            "localite": "Cavergno"
        },
        {
            "code": "6690",
            "localite": "S. Carlo (Val Bavona)"
        },
        {
            "code": "6692",
            "localite": "Brontallo"
        },
        {
            "code": "6692",
            "localite": "Menzonio"
        },
        {
            "code": "6693",
            "localite": "Broglio"
        },
        {
            "code": "6694",
            "localite": "Prato-Sornico"
        },
        {
            "code": "6695",
            "localite": "Peccia"
        },
        {
            "code": "6695",
            "localite": "Piano di Peccia"
        },
        {
            "code": "6696",
            "localite": "Fusio"
        },
        {
            "code": "6702",
            "localite": "Claro"
        },
        {
            "code": "6703",
            "localite": "Osogna"
        },
        {
            "code": "6705",
            "localite": "Cresciano"
        },
        {
            "code": "6707",
            "localite": "Iragna"
        },
        {
            "code": "6710",
            "localite": "Biasca"
        },
        {
            "code": "6713",
            "localite": "Malvaglia"
        },
        {
            "code": "6714",
            "localite": "Semione"
        },
        {
            "code": "6715",
            "localite": "Dongio"
        },
        {
            "code": "6716",
            "localite": "Acquarossa"
        },
        {
            "code": "6716",
            "localite": "Leontica"
        },
        {
            "code": "6716",
            "localite": "Lottigna"
        },
        {
            "code": "6717",
            "localite": "Dangio"
        },
        {
            "code": "6717",
            "localite": "Torre"
        },
        {
            "code": "6718",
            "localite": "Camperio"
        },
        {
            "code": "6718",
            "localite": "Olivone"
        },
        {
            "code": "6719",
            "localite": "Aquila"
        },
        {
            "code": "6720",
            "localite": "Campo (Blenio)"
        },
        {
            "code": "6720",
            "localite": "Ghirone"
        },
        {
            "code": "6721",
            "localite": "Ludiano"
        },
        {
            "code": "6721",
            "localite": "Motto (Blenio)"
        },
        {
            "code": "6722",
            "localite": "Corzoneso"
        },
        {
            "code": "6723",
            "localite": "Castro"
        },
        {
            "code": "6723",
            "localite": "Marolta"
        },
        {
            "code": "6723",
            "localite": "Prugiasco"
        },
        {
            "code": "6724",
            "localite": "Largario"
        },
        {
            "code": "6724",
            "localite": "Ponto Valentino"
        },
        {
            "code": "6742",
            "localite": "Pollegio"
        },
        {
            "code": "6743",
            "localite": "Bodio TI"
        },
        {
            "code": "6744",
            "localite": "Personico"
        },
        {
            "code": "6745",
            "localite": "Giornico"
        },
        {
            "code": "6746",
            "localite": "Calonico"
        },
        {
            "code": "6746",
            "localite": "Lavorgo"
        },
        {
            "code": "6746",
            "localite": "Nivo"
        },
        {
            "code": "6747",
            "localite": "Chironico"
        },
        {
            "code": "6748",
            "localite": "Anzonico"
        },
        {
            "code": "6749",
            "localite": "Cavagnago"
        },
        {
            "code": "6749",
            "localite": "Sobrio"
        },
        {
            "code": "6760",
            "localite": "Calpiogna"
        },
        {
            "code": "6760",
            "localite": "Campello"
        },
        {
            "code": "6760",
            "localite": "Carì"
        },
        {
            "code": "6760",
            "localite": "Faido"
        },
        {
            "code": "6760",
            "localite": "Molare"
        },
        {
            "code": "6760",
            "localite": "Rossura"
        },
        {
            "code": "6763",
            "localite": "Mairengo"
        },
        {
            "code": "6763",
            "localite": "Osco"
        },
        {
            "code": "6764",
            "localite": "Chiggiogna"
        },
        {
            "code": "6772",
            "localite": "Rodi-Fiesso"
        },
        {
            "code": "6773",
            "localite": "Prato (Leventina)"
        },
        {
            "code": "6774",
            "localite": "Dalpe"
        },
        {
            "code": "6775",
            "localite": "Ambrì"
        },
        {
            "code": "6776",
            "localite": "Piotta"
        },
        {
            "code": "6777",
            "localite": "Quinto"
        },
        {
            "code": "6780",
            "localite": "Airolo"
        },
        {
            "code": "6781",
            "localite": "Bedretto"
        },
        {
            "code": "6781",
            "localite": "Villa Bedretto"
        },
        {
            "code": "6802",
            "localite": "Rivera"
        },
        {
            "code": "6803",
            "localite": "Camignolo"
        },
        {
            "code": "6804",
            "localite": "Bironico"
        },
        {
            "code": "6805",
            "localite": "Mezzovico"
        },
        {
            "code": "6806",
            "localite": "Sigirino"
        },
        {
            "code": "6807",
            "localite": "Taverne"
        },
        {
            "code": "6808",
            "localite": "Torricella"
        },
        {
            "code": "6809",
            "localite": "Medeglia"
        },
        {
            "code": "6810",
            "localite": "Isone"
        },
        {
            "code": "6814",
            "localite": "Cadempino"
        },
        {
            "code": "6814",
            "localite": "Lamone"
        },
        {
            "code": "6815",
            "localite": "Melide"
        },
        {
            "code": "6816",
            "localite": "Bissone"
        },
        {
            "code": "6817",
            "localite": "Maroggia"
        },
        {
            "code": "6818",
            "localite": "Melano"
        },
        {
            "code": "6821",
            "localite": "Rovio"
        },
        {
            "code": "6822",
            "localite": "Arogno"
        },
        {
            "code": "6823",
            "localite": "Pugerna"
        },
        {
            "code": "6825",
            "localite": "Capolago"
        },
        {
            "code": "6826",
            "localite": "Riva San Vitale"
        },
        {
            "code": "6827",
            "localite": "Brusino Arsizio"
        },
        {
            "code": "6828",
            "localite": "Balerna"
        },
        {
            "code": "6830",
            "localite": "Chiasso"
        },
        {
            "code": "6832",
            "localite": "Pedrinate"
        },
        {
            "code": "6832",
            "localite": "Seseglio"
        },
        {
            "code": "6833",
            "localite": "Vacallo"
        },
        {
            "code": "6834",
            "localite": "Morbio Inferiore"
        },
        {
            "code": "6835",
            "localite": "Morbio Superiore"
        },
        {
            "code": "6837",
            "localite": "Bruzella"
        },
        {
            "code": "6837",
            "localite": "Caneggio"
        },
        {
            "code": "6838",
            "localite": "Cabbio"
        },
        {
            "code": "6838",
            "localite": "Muggio"
        },
        {
            "code": "6839",
            "localite": "Sagno"
        },
        {
            "code": "6850",
            "localite": "Mendrisio"
        },
        {
            "code": "6852",
            "localite": "Genestrerio"
        },
        {
            "code": "6853",
            "localite": "Ligornetto"
        },
        {
            "code": "6854",
            "localite": "S. Pietro"
        },
        {
            "code": "6855",
            "localite": "Stabio"
        },
        {
            "code": "6862",
            "localite": "Rancate"
        },
        {
            "code": "6863",
            "localite": "Besazio"
        },
        {
            "code": "6864",
            "localite": "Arzo"
        },
        {
            "code": "6865",
            "localite": "Tremona"
        },
        {
            "code": "6866",
            "localite": "Meride"
        },
        {
            "code": "6867",
            "localite": "Serpiano"
        },
        {
            "code": "6872",
            "localite": "Salorino"
        },
        {
            "code": "6873",
            "localite": "Corteglia"
        },
        {
            "code": "6874",
            "localite": "Castel San Pietro"
        },
        {
            "code": "6875",
            "localite": "Campora"
        },
        {
            "code": "6875",
            "localite": "Casima"
        },
        {
            "code": "6875",
            "localite": "Monte"
        },
        {
            "code": "6877",
            "localite": "Coldrerio"
        },
        {
            "code": "6883",
            "localite": "Novazzano"
        },
        {
            "code": "6900",
            "localite": "Lugano"
        },
        {
            "code": "6900",
            "localite": "Massagno"
        },
        {
            "code": "6900",
            "localite": "Paradiso"
        },
        {
            "code": "6912",
            "localite": "Pazzallo"
        },
        {
            "code": "6913",
            "localite": "Carabbia"
        },
        {
            "code": "6914",
            "localite": "Carona"
        },
        {
            "code": "6915",
            "localite": "Pambio-Noranco"
        },
        {
            "code": "6916",
            "localite": "Grancia"
        },
        {
            "code": "6917",
            "localite": "Barbengo"
        },
        {
            "code": "6918",
            "localite": "Figino"
        },
        {
            "code": "6919",
            "localite": "Carabietta"
        },
        {
            "code": "6921",
            "localite": "Vico Morcote"
        },
        {
            "code": "6922",
            "localite": "Morcote"
        },
        {
            "code": "6924",
            "localite": "Sorengo"
        },
        {
            "code": "6925",
            "localite": "Gentilino"
        },
        {
            "code": "6926",
            "localite": "Montagnola"
        },
        {
            "code": "6927",
            "localite": "Agra"
        },
        {
            "code": "6928",
            "localite": "Manno"
        },
        {
            "code": "6929",
            "localite": "Gravesano"
        },
        {
            "code": "6930",
            "localite": "Bedano"
        },
        {
            "code": "6932",
            "localite": "Breganzona"
        },
        {
            "code": "6933",
            "localite": "Muzzano"
        },
        {
            "code": "6934",
            "localite": "Bioggio"
        },
        {
            "code": "6935",
            "localite": "Bosco Luganese"
        },
        {
            "code": "6936",
            "localite": "Cademario"
        },
        {
            "code": "6937",
            "localite": "Breno"
        },
        {
            "code": "6938",
            "localite": "Fescoggia"
        },
        {
            "code": "6938",
            "localite": "Vezio"
        },
        {
            "code": "6939",
            "localite": "Arosio"
        },
        {
            "code": "6939",
            "localite": "Mugena"
        },
        {
            "code": "6942",
            "localite": "Savosa"
        },
        {
            "code": "6943",
            "localite": "Vezia"
        },
        {
            "code": "6944",
            "localite": "Cureglia"
        },
        {
            "code": "6945",
            "localite": "Origlio"
        },
        {
            "code": "6946",
            "localite": "Ponte Capriasca"
        },
        {
            "code": "6947",
            "localite": "Vaglio"
        },
        {
            "code": "6948",
            "localite": "Porza"
        },
        {
            "code": "6949",
            "localite": "Comano"
        },
        {
            "code": "6950",
            "localite": "Tesserete"
        },
        {
            "code": "6951",
            "localite": "Bogno"
        },
        {
            "code": "6951",
            "localite": "Colla"
        },
        {
            "code": "6951",
            "localite": "Cozzo"
        },
        {
            "code": "6951",
            "localite": "Insone"
        },
        {
            "code": "6951",
            "localite": "Scareglia"
        },
        {
            "code": "6951",
            "localite": "Signôra"
        },
        {
            "code": "6952",
            "localite": "Canobbio"
        },
        {
            "code": "6953",
            "localite": "Lugaggia"
        },
        {
            "code": "6954",
            "localite": "Bigorio"
        },
        {
            "code": "6954",
            "localite": "Sala Capriasca"
        },
        {
            "code": "6955",
            "localite": "Cagiallo"
        },
        {
            "code": "6955",
            "localite": "Oggio"
        },
        {
            "code": "6956",
            "localite": "Lopagno"
        },
        {
            "code": "6957",
            "localite": "Roveredo TI"
        },
        {
            "code": "6958",
            "localite": "Bidogno"
        },
        {
            "code": "6958",
            "localite": "Corticiasca"
        },
        {
            "code": "6959",
            "localite": "Certara"
        },
        {
            "code": "6959",
            "localite": "Cimadera"
        },
        {
            "code": "6959",
            "localite": "Curtina"
        },
        {
            "code": "6959",
            "localite": "Maglio di Colla"
        },
        {
            "code": "6959",
            "localite": "Piandera Paese"
        },
        {
            "code": "6960",
            "localite": "Odogno"
        },
        {
            "code": "6962",
            "localite": "Viganello"
        },
        {
            "code": "6963",
            "localite": "Cureggia"
        },
        {
            "code": "6963",
            "localite": "Pregassona"
        },
        {
            "code": "6964",
            "localite": "Davesco-Soragno"
        },
        {
            "code": "6965",
            "localite": "Cadro"
        },
        {
            "code": "6966",
            "localite": "Villa Luganese"
        },
        {
            "code": "6967",
            "localite": "Dino"
        },
        {
            "code": "6968",
            "localite": "Sonvico"
        },
        {
            "code": "6974",
            "localite": "Aldesago"
        },
        {
            "code": "6976",
            "localite": "Castagnola"
        },
        {
            "code": "6977",
            "localite": "Ruvigliana"
        },
        {
            "code": "6978",
            "localite": "Gandria"
        },
        {
            "code": "6979",
            "localite": "Brè sopra Lugano"
        },
        {
            "code": "6980",
            "localite": "Castelrotto"
        },
        {
            "code": "6981",
            "localite": "Banco"
        },
        {
            "code": "6981",
            "localite": "Bedigliora"
        },
        {
            "code": "6981",
            "localite": "Beride di Bedigliora"
        },
        {
            "code": "6981",
            "localite": "Bombinasco"
        },
        {
            "code": "6982",
            "localite": "Agno"
        },
        {
            "code": "6983",
            "localite": "Magliaso"
        },
        {
            "code": "6984",
            "localite": "Pura"
        },
        {
            "code": "6986",
            "localite": "Curio"
        },
        {
            "code": "6986",
            "localite": "Miglieglia"
        },
        {
            "code": "6986",
            "localite": "Novaggio"
        },
        {
            "code": "6987",
            "localite": "Caslano"
        },
        {
            "code": "6988",
            "localite": "Ponte Tresa"
        },
        {
            "code": "6989",
            "localite": "Purasca"
        },
        {
            "code": "6990",
            "localite": "Cassina d'Agno"
        },
        {
            "code": "6991",
            "localite": "Neggio"
        },
        {
            "code": "6992",
            "localite": "Cimo"
        },
        {
            "code": "6992",
            "localite": "Vernate"
        },
        {
            "code": "6993",
            "localite": "Iseo"
        },
        {
            "code": "6994",
            "localite": "Aranno"
        },
        {
            "code": "6995",
            "localite": "Madonna del Piano"
        },
        {
            "code": "6997",
            "localite": "Sessa"
        },
        {
            "code": "6998",
            "localite": "Monteggio"
        },
        {
            "code": "6999",
            "localite": "Astano"
        },
        {
            "code": "7000",
            "localite": "Chur"
        },
        {
            "code": "7012",
            "localite": "Felsberg"
        },
        {
            "code": "7013",
            "localite": "Domat/Ems"
        },
        {
            "code": "7014",
            "localite": "Trin"
        },
        {
            "code": "7015",
            "localite": "Tamins"
        },
        {
            "code": "7016",
            "localite": "Trin Mulin"
        },
        {
            "code": "7017",
            "localite": "Flims Dorf"
        },
        {
            "code": "7018",
            "localite": "Flims Waldhaus"
        },
        {
            "code": "7019",
            "localite": "Fidaz"
        },
        {
            "code": "7023",
            "localite": "Haldenstein"
        },
        {
            "code": "7026",
            "localite": "Maladers"
        },
        {
            "code": "7027",
            "localite": "Calfreisen"
        },
        {
            "code": "7027",
            "localite": "Castiel"
        },
        {
            "code": "7027",
            "localite": "Lüen"
        },
        {
            "code": "7028",
            "localite": "Pagig"
        },
        {
            "code": "7028",
            "localite": "St. Peter"
        },
        {
            "code": "7029",
            "localite": "Peist"
        },
        {
            "code": "7031",
            "localite": "Laax GR"
        },
        {
            "code": "7032",
            "localite": "Laax GR 2"
        },
        {
            "code": "7050",
            "localite": "Arosa"
        },
        {
            "code": "7056",
            "localite": "Molinis"
        },
        {
            "code": "7057",
            "localite": "Langwies"
        },
        {
            "code": "7058",
            "localite": "Litzirüti"
        },
        {
            "code": "7062",
            "localite": "Passugg"
        },
        {
            "code": "7063",
            "localite": "Praden"
        },
        {
            "code": "7064",
            "localite": "Tschiertschen"
        },
        {
            "code": "7074",
            "localite": "Malix"
        },
        {
            "code": "7075",
            "localite": "Churwalden"
        },
        {
            "code": "7076",
            "localite": "Parpan"
        },
        {
            "code": "7077",
            "localite": "Valbella"
        },
        {
            "code": "7078",
            "localite": "Lenzerheide/Lai"
        },
        {
            "code": "7082",
            "localite": "Vaz/Obervaz"
        },
        {
            "code": "7083",
            "localite": "Lantsch/Lenz"
        },
        {
            "code": "7084",
            "localite": "Brienz/Brinzauls GR"
        },
        {
            "code": "7104",
            "localite": "Versam"
        },
        {
            "code": "7106",
            "localite": "Tenna"
        },
        {
            "code": "7107",
            "localite": "Safien Platz"
        },
        {
            "code": "7109",
            "localite": "Thalkirch"
        },
        {
            "code": "7110",
            "localite": "Peiden"
        },
        {
            "code": "7111",
            "localite": "Pitasch"
        },
        {
            "code": "7112",
            "localite": "Duvin"
        },
        {
            "code": "7113",
            "localite": "Camuns"
        },
        {
            "code": "7114",
            "localite": "Uors (Lumnezia)"
        },
        {
            "code": "7115",
            "localite": "Surcasti"
        },
        {
            "code": "7116",
            "localite": "St. Martin (Lugnez)"
        },
        {
            "code": "7116",
            "localite": "Tersnaus"
        },
        {
            "code": "7122",
            "localite": "Valendas"
        },
        {
            "code": "7126",
            "localite": "Castrisch"
        },
        {
            "code": "7127",
            "localite": "Sevgein"
        },
        {
            "code": "7128",
            "localite": "Riein"
        },
        {
            "code": "7130",
            "localite": "Ilanz"
        },
        {
            "code": "7130",
            "localite": "Schnaus"
        },
        {
            "code": "7132",
            "localite": "Vals"
        },
        {
            "code": "7134",
            "localite": "Obersaxen"
        },
        {
            "code": "7137",
            "localite": "Flond"
        },
        {
            "code": "7138",
            "localite": "Surcuolm"
        },
        {
            "code": "7141",
            "localite": "Luven"
        },
        {
            "code": "7142",
            "localite": "Cumbel"
        },
        {
            "code": "7143",
            "localite": "Morissen"
        },
        {
            "code": "7144",
            "localite": "Vella"
        },
        {
            "code": "7145",
            "localite": "Degen"
        },
        {
            "code": "7146",
            "localite": "Vattiz"
        },
        {
            "code": "7147",
            "localite": "Vignogn"
        },
        {
            "code": "7148",
            "localite": "Lumbrein"
        },
        {
            "code": "7149",
            "localite": "Vrin"
        },
        {
            "code": "7151",
            "localite": "Schluein"
        },
        {
            "code": "7152",
            "localite": "Sagogn"
        },
        {
            "code": "7153",
            "localite": "Falera"
        },
        {
            "code": "7154",
            "localite": "Ruschein"
        },
        {
            "code": "7155",
            "localite": "Ladir"
        },
        {
            "code": "7156",
            "localite": "Pigniu"
        },
        {
            "code": "7156",
            "localite": "Rueun"
        },
        {
            "code": "7157",
            "localite": "Siat"
        },
        {
            "code": "7158",
            "localite": "Waltensburg/Vuorz"
        },
        {
            "code": "7159",
            "localite": "Andiast"
        },
        {
            "code": "7162",
            "localite": "Tavanasa"
        },
        {
            "code": "7163",
            "localite": "Danis"
        },
        {
            "code": "7164",
            "localite": "Dardin"
        },
        {
            "code": "7165",
            "localite": "Breil/Brigels"
        },
        {
            "code": "7166",
            "localite": "Trun"
        },
        {
            "code": "7167",
            "localite": "Zignau"
        },
        {
            "code": "7168",
            "localite": "Schlans"
        },
        {
            "code": "7172",
            "localite": "Rabius"
        },
        {
            "code": "7173",
            "localite": "Surrein"
        },
        {
            "code": "7174",
            "localite": "S. Benedetg"
        },
        {
            "code": "7175",
            "localite": "Sumvitg"
        },
        {
            "code": "7176",
            "localite": "Cumpadials"
        },
        {
            "code": "7180",
            "localite": "Disentis/Mustér"
        },
        {
            "code": "7182",
            "localite": "Cavardiras"
        },
        {
            "code": "7183",
            "localite": "Mumpé Medel"
        },
        {
            "code": "7184",
            "localite": "Curaglia"
        },
        {
            "code": "7185",
            "localite": "Platta"
        },
        {
            "code": "7186",
            "localite": "Segnas"
        },
        {
            "code": "7187",
            "localite": "Camischolas"
        },
        {
            "code": "7188",
            "localite": "Sedrun"
        },
        {
            "code": "7189",
            "localite": "Rueras"
        },
        {
            "code": "7202",
            "localite": "Says"
        },
        {
            "code": "7203",
            "localite": "Trimmis"
        },
        {
            "code": "7204",
            "localite": "Untervaz"
        },
        {
            "code": "7205",
            "localite": "Zizers"
        },
        {
            "code": "7206",
            "localite": "Igis"
        },
        {
            "code": "7208",
            "localite": "Malans GR"
        },
        {
            "code": "7212",
            "localite": "Seewis Dorf"
        },
        {
            "code": "7212",
            "localite": "Seewis-Pardisla"
        },
        {
            "code": "7212",
            "localite": "Seewis-Schmitten"
        },
        {
            "code": "7213",
            "localite": "Valzeina"
        },
        {
            "code": "7214",
            "localite": "Grüsch"
        },
        {
            "code": "7215",
            "localite": "Fanas"
        },
        {
            "code": "7220",
            "localite": "Schiers"
        },
        {
            "code": "7222",
            "localite": "Lunden"
        },
        {
            "code": "7223",
            "localite": "Buchen im Prättigau"
        },
        {
            "code": "7224",
            "localite": "Putz"
        },
        {
            "code": "7226",
            "localite": "Fajauna"
        },
        {
            "code": "7226",
            "localite": "Stels"
        },
        {
            "code": "7228",
            "localite": "Pusserein"
        },
        {
            "code": "7228",
            "localite": "Schuders"
        },
        {
            "code": "7231",
            "localite": "Pragg-Jenaz"
        },
        {
            "code": "7232",
            "localite": "Furna"
        },
        {
            "code": "7233",
            "localite": "Jenaz"
        },
        {
            "code": "7235",
            "localite": "Fideris"
        },
        {
            "code": "7240",
            "localite": "Küblis"
        },
        {
            "code": "7241",
            "localite": "Conters im Prättigau"
        },
        {
            "code": "7242",
            "localite": "Luzein"
        },
        {
            "code": "7243",
            "localite": "Pany"
        },
        {
            "code": "7244",
            "localite": "Gadenstätt"
        },
        {
            "code": "7245",
            "localite": "Ascharina"
        },
        {
            "code": "7246",
            "localite": "St. Antönien"
        },
        {
            "code": "7247",
            "localite": "Saas im Prättigau"
        },
        {
            "code": "7249",
            "localite": "Serneus"
        },
        {
            "code": "7250",
            "localite": "Klosters"
        },
        {
            "code": "7252",
            "localite": "Klosters Dorf"
        },
        {
            "code": "7260",
            "localite": "Davos Dorf"
        },
        {
            "code": "7265",
            "localite": "Davos Wolfgang"
        },
        {
            "code": "7270",
            "localite": "Davos Platz"
        },
        {
            "code": "7272",
            "localite": "Davos Clavadel"
        },
        {
            "code": "7276",
            "localite": "Davos Frauenkirch"
        },
        {
            "code": "7277",
            "localite": "Davos Glaris"
        },
        {
            "code": "7278",
            "localite": "Davos Monstein"
        },
        {
            "code": "7302",
            "localite": "Landquart"
        },
        {
            "code": "7303",
            "localite": "Mastrils"
        },
        {
            "code": "7304",
            "localite": "Maienfeld"
        },
        {
            "code": "7306",
            "localite": "Fläsch"
        },
        {
            "code": "7307",
            "localite": "Jenins"
        },
        {
            "code": "7310",
            "localite": "Bad Ragaz"
        },
        {
            "code": "7312",
            "localite": "Pfäfers"
        },
        {
            "code": "7313",
            "localite": "St. Margrethenberg"
        },
        {
            "code": "7314",
            "localite": "Vadura"
        },
        {
            "code": "7315",
            "localite": "Vättis"
        },
        {
            "code": "7317",
            "localite": "Valens"
        },
        {
            "code": "7317",
            "localite": "Vasön"
        },
        {
            "code": "7320",
            "localite": "Sargans"
        },
        {
            "code": "7323",
            "localite": "Wangs"
        },
        {
            "code": "7324",
            "localite": "Vilters"
        },
        {
            "code": "7325",
            "localite": "Schwendi im Weisstannental"
        },
        {
            "code": "7326",
            "localite": "Weisstannen"
        },
        {
            "code": "7402",
            "localite": "Bonaduz"
        },
        {
            "code": "7403",
            "localite": "Rhäzüns"
        },
        {
            "code": "7404",
            "localite": "Feldis/Veulden"
        },
        {
            "code": "7405",
            "localite": "Rothenbrunnen"
        },
        {
            "code": "7407",
            "localite": "Trans"
        },
        {
            "code": "7408",
            "localite": "Cazis"
        },
        {
            "code": "7411",
            "localite": "Sils im Domleschg"
        },
        {
            "code": "7412",
            "localite": "Scharans"
        },
        {
            "code": "7413",
            "localite": "Fürstenaubruck"
        },
        {
            "code": "7414",
            "localite": "Fürstenau"
        },
        {
            "code": "7415",
            "localite": "Pratval"
        },
        {
            "code": "7415",
            "localite": "Rodels"
        },
        {
            "code": "7416",
            "localite": "Almens"
        },
        {
            "code": "7417",
            "localite": "Paspels"
        },
        {
            "code": "7418",
            "localite": "Tumegl/Tomils"
        },
        {
            "code": "7419",
            "localite": "Scheid"
        },
        {
            "code": "7421",
            "localite": "Summaprada"
        },
        {
            "code": "7422",
            "localite": "Tartar"
        },
        {
            "code": "7423",
            "localite": "Portein"
        },
        {
            "code": "7423",
            "localite": "Sarn"
        },
        {
            "code": "7424",
            "localite": "Dalin"
        },
        {
            "code": "7424",
            "localite": "Präz"
        },
        {
            "code": "7425",
            "localite": "Masein"
        },
        {
            "code": "7426",
            "localite": "Flerden"
        },
        {
            "code": "7427",
            "localite": "Urmein"
        },
        {
            "code": "7428",
            "localite": "Tschappina"
        },
        {
            "code": "7430",
            "localite": "Rongellen"
        },
        {
            "code": "7430",
            "localite": "Thusis"
        },
        {
            "code": "7431",
            "localite": "Mutten"
        },
        {
            "code": "7431",
            "localite": "Obermutten"
        },
        {
            "code": "7432",
            "localite": "Zillis"
        },
        {
            "code": "7433",
            "localite": "Donat"
        },
        {
            "code": "7433",
            "localite": "Lohn GR"
        },
        {
            "code": "7433",
            "localite": "Mathon"
        },
        {
            "code": "7433",
            "localite": "Wergenstein"
        },
        {
            "code": "7434",
            "localite": "Sufers"
        },
        {
            "code": "7435",
            "localite": "Splügen"
        },
        {
            "code": "7436",
            "localite": "Medels im Rheinwald"
        },
        {
            "code": "7437",
            "localite": "Nufenen"
        },
        {
            "code": "7438",
            "localite": "Hinterrhein"
        },
        {
            "code": "7440",
            "localite": "Andeer"
        },
        {
            "code": "7442",
            "localite": "Clugin"
        },
        {
            "code": "7443",
            "localite": "Pignia"
        },
        {
            "code": "7444",
            "localite": "Ausserferrera"
        },
        {
            "code": "7445",
            "localite": "Innerferrera"
        },
        {
            "code": "7447",
            "localite": "Avers"
        },
        {
            "code": "7448",
            "localite": "Juf"
        },
        {
            "code": "7450",
            "localite": "Tiefencastel"
        },
        {
            "code": "7451",
            "localite": "Alvaschein"
        },
        {
            "code": "7452",
            "localite": "Cunter"
        },
        {
            "code": "7453",
            "localite": "Tinizong"
        },
        {
            "code": "7454",
            "localite": "Rona"
        },
        {
            "code": "7455",
            "localite": "Mulegns"
        },
        {
            "code": "7456",
            "localite": "Marmorera"
        },
        {
            "code": "7456",
            "localite": "Sur"
        },
        {
            "code": "7457",
            "localite": "Bivio"
        },
        {
            "code": "7458",
            "localite": "Mon"
        },
        {
            "code": "7459",
            "localite": "Stierva"
        },
        {
            "code": "7460",
            "localite": "Savognin"
        },
        {
            "code": "7462",
            "localite": "Salouf"
        },
        {
            "code": "7463",
            "localite": "Riom"
        },
        {
            "code": "7464",
            "localite": "Parsonz"
        },
        {
            "code": "7472",
            "localite": "Surava"
        },
        {
            "code": "7473",
            "localite": "Alvaneu Bad"
        },
        {
            "code": "7477",
            "localite": "Filisur"
        },
        {
            "code": "7482",
            "localite": "Bergün/Bravuogn"
        },
        {
            "code": "7482",
            "localite": "Preda"
        },
        {
            "code": "7482",
            "localite": "Stugl/Stuls"
        },
        {
            "code": "7484",
            "localite": "Latsch"
        },
        {
            "code": "7492",
            "localite": "Alvaneu Dorf"
        },
        {
            "code": "7493",
            "localite": "Schmitten (Albula)"
        },
        {
            "code": "7494",
            "localite": "Davos Wiesen"
        },
        {
            "code": "7500",
            "localite": "St. Moritz"
        },
        {
            "code": "7502",
            "localite": "Bever"
        },
        {
            "code": "7503",
            "localite": "Samedan"
        },
        {
            "code": "7504",
            "localite": "Pontresina"
        },
        {
            "code": "7505",
            "localite": "Celerina/Schlarigna"
        },
        {
            "code": "7512",
            "localite": "Champfèr"
        },
        {
            "code": "7513",
            "localite": "Silvaplana"
        },
        {
            "code": "7513",
            "localite": "Silvaplana-Surlej"
        },
        {
            "code": "7514",
            "localite": "Fex"
        },
        {
            "code": "7514",
            "localite": "Sils/Segl Maria"
        },
        {
            "code": "7515",
            "localite": "Sils/Segl Baselgia"
        },
        {
            "code": "7516",
            "localite": "Maloja"
        },
        {
            "code": "7517",
            "localite": "Plaun da Lej"
        },
        {
            "code": "7522",
            "localite": "La Punt Chamues-ch"
        },
        {
            "code": "7523",
            "localite": "Madulain"
        },
        {
            "code": "7524",
            "localite": "Zuoz"
        },
        {
            "code": "7525",
            "localite": "S-chanf"
        },
        {
            "code": "7526",
            "localite": "Chapella"
        },
        {
            "code": "7526",
            "localite": "Cinuos-chel"
        },
        {
            "code": "7527",
            "localite": "Brail"
        },
        {
            "code": "7530",
            "localite": "Zernez"
        },
        {
            "code": "7532",
            "localite": "Tschierv"
        },
        {
            "code": "7533",
            "localite": "Fuldera"
        },
        {
            "code": "7534",
            "localite": "Lü"
        },
        {
            "code": "7535",
            "localite": "Valchava"
        },
        {
            "code": "7536",
            "localite": "Sta. Maria Val Müstair"
        },
        {
            "code": "7537",
            "localite": "Müstair"
        },
        {
            "code": "7542",
            "localite": "Susch"
        },
        {
            "code": "7543",
            "localite": "Lavin"
        },
        {
            "code": "7545",
            "localite": "Guarda"
        },
        {
            "code": "7546",
            "localite": "Ardez"
        },
        {
            "code": "7550",
            "localite": "Scuol"
        },
        {
            "code": "7551",
            "localite": "Ftan"
        },
        {
            "code": "7552",
            "localite": "Vulpera"
        },
        {
            "code": "7553",
            "localite": "Tarasp"
        },
        {
            "code": "7554",
            "localite": "Sent"
        },
        {
            "code": "7556",
            "localite": "Ramosch"
        },
        {
            "code": "7557",
            "localite": "Vnà"
        },
        {
            "code": "7558",
            "localite": "Strada"
        },
        {
            "code": "7559",
            "localite": "Tschlin"
        },
        {
            "code": "7560",
            "localite": "Martina"
        },
        {
            "code": "7562",
            "localite": "Samnaun-Compatsch"
        },
        {
            "code": "7563",
            "localite": "Samnaun Dorf"
        },
        {
            "code": "7602",
            "localite": "Casaccia"
        },
        {
            "code": "7603",
            "localite": "Vicosoprano"
        },
        {
            "code": "7604",
            "localite": "Borgonovo"
        },
        {
            "code": "7605",
            "localite": "Stampa"
        },
        {
            "code": "7606",
            "localite": "Bondo"
        },
        {
            "code": "7606",
            "localite": "Promontogno"
        },
        {
            "code": "7608",
            "localite": "Castasegna"
        },
        {
            "code": "7610",
            "localite": "Soglio"
        },
        {
            "code": "7710",
            "localite": "Alp Grüm"
        },
        {
            "code": "7710",
            "localite": "Ospizio Bernina"
        },
        {
            "code": "7741",
            "localite": "S. Carlo (Poschiavo)"
        },
        {
            "code": "7742",
            "localite": "La Rösa"
        },
        {
            "code": "7742",
            "localite": "Poschiavo"
        },
        {
            "code": "7742",
            "localite": "Sfazù"
        },
        {
            "code": "7743",
            "localite": "Brusio"
        },
        {
            "code": "7743",
            "localite": "Miralago"
        },
        {
            "code": "7744",
            "localite": "Campocologno"
        },
        {
            "code": "7745",
            "localite": "Li Curt"
        },
        {
            "code": "7746",
            "localite": "Le Prese"
        },
        {
            "code": "7747",
            "localite": "Viano"
        },
        {
            "code": "7748",
            "localite": "Campascio"
        },
        {
            "code": "8001",
            "localite": "Zürich"
        },
        {
            "code": "8002",
            "localite": "Zürich"
        },
        {
            "code": "8003",
            "localite": "Zürich"
        },
        {
            "code": "8004",
            "localite": "Zürich"
        },
        {
            "code": "8005",
            "localite": "Zürich"
        },
        {
            "code": "8006",
            "localite": "Zürich"
        },
        {
            "code": "8008",
            "localite": "Zürich"
        },
        {
            "code": "8032",
            "localite": "Zürich"
        },
        {
            "code": "8037",
            "localite": "Zürich"
        },
        {
            "code": "8038",
            "localite": "Zürich"
        },
        {
            "code": "8041",
            "localite": "Zürich"
        },
        {
            "code": "8044",
            "localite": "Gockhausen"
        },
        {
            "code": "8044",
            "localite": "Zürich"
        },
        {
            "code": "8045",
            "localite": "Zürich"
        },
        {
            "code": "8046",
            "localite": "Zürich"
        },
        {
            "code": "8047",
            "localite": "Zürich"
        },
        {
            "code": "8048",
            "localite": "Zürich"
        },
        {
            "code": "8049",
            "localite": "Zürich"
        },
        {
            "code": "8050",
            "localite": "Zürich"
        },
        {
            "code": "8051",
            "localite": "Zürich"
        },
        {
            "code": "8052",
            "localite": "Zürich"
        },
        {
            "code": "8053",
            "localite": "Zürich"
        },
        {
            "code": "8055",
            "localite": "Zürich"
        },
        {
            "code": "8057",
            "localite": "Zürich"
        },
        {
            "code": "8064",
            "localite": "Zürich"
        },
        {
            "code": "8102",
            "localite": "Oberengstringen"
        },
        {
            "code": "8103",
            "localite": "Unterengstringen"
        },
        {
            "code": "8104",
            "localite": "Weiningen ZH"
        },
        {
            "code": "8105",
            "localite": "Regensdorf"
        },
        {
            "code": "8105",
            "localite": "Watt"
        },
        {
            "code": "8106",
            "localite": "Adlikon b. Regensdorf"
        },
        {
            "code": "8107",
            "localite": "Buchs ZH"
        },
        {
            "code": "8108",
            "localite": "Dällikon"
        },
        {
            "code": "8109",
            "localite": "Kloster Fahr"
        },
        {
            "code": "8112",
            "localite": "Otelfingen"
        },
        {
            "code": "8113",
            "localite": "Boppelsen"
        },
        {
            "code": "8114",
            "localite": "Dänikon ZH"
        },
        {
            "code": "8115",
            "localite": "Hüttikon"
        },
        {
            "code": "8117",
            "localite": "Fällanden"
        },
        {
            "code": "8118",
            "localite": "Pfaffhausen"
        },
        {
            "code": "8121",
            "localite": "Benglen"
        },
        {
            "code": "8122",
            "localite": "Binz"
        },
        {
            "code": "8123",
            "localite": "Ebmatingen"
        },
        {
            "code": "8124",
            "localite": "Maur"
        },
        {
            "code": "8125",
            "localite": "Zollikerberg"
        },
        {
            "code": "8126",
            "localite": "Zumikon"
        },
        {
            "code": "8127",
            "localite": "Forch"
        },
        {
            "code": "8132",
            "localite": "Egg b. Zürich"
        },
        {
            "code": "8132",
            "localite": "Hinteregg"
        },
        {
            "code": "8133",
            "localite": "Esslingen"
        },
        {
            "code": "8134",
            "localite": "Adliswil"
        },
        {
            "code": "8135",
            "localite": "Langnau am Albis"
        },
        {
            "code": "8135",
            "localite": "Sihlbrugg Station"
        },
        {
            "code": "8135",
            "localite": "Sihlwald"
        },
        {
            "code": "8136",
            "localite": "Gattikon"
        },
        {
            "code": "8142",
            "localite": "Uitikon Waldegg"
        },
        {
            "code": "8143",
            "localite": "Stallikon"
        },
        {
            "code": "8143",
            "localite": "Uetliberg"
        },
        {
            "code": "8152",
            "localite": "Glattbrugg"
        },
        {
            "code": "8152",
            "localite": "Glattpark (Opfikon)"
        },
        {
            "code": "8152",
            "localite": "Opfikon"
        },
        {
            "code": "8153",
            "localite": "Rümlang"
        },
        {
            "code": "8154",
            "localite": "Oberglatt ZH"
        },
        {
            "code": "8155",
            "localite": "Nassenwil"
        },
        {
            "code": "8155",
            "localite": "Niederhasli"
        },
        {
            "code": "8156",
            "localite": "Oberhasli"
        },
        {
            "code": "8157",
            "localite": "Dielsdorf"
        },
        {
            "code": "8158",
            "localite": "Regensberg"
        },
        {
            "code": "8162",
            "localite": "Steinmaur"
        },
        {
            "code": "8162",
            "localite": "Sünikon"
        },
        {
            "code": "8164",
            "localite": "Bachs"
        },
        {
            "code": "8165",
            "localite": "Oberweningen"
        },
        {
            "code": "8165",
            "localite": "Schleinikon"
        },
        {
            "code": "8165",
            "localite": "Schöfflisdorf"
        },
        {
            "code": "8166",
            "localite": "Niederweningen"
        },
        {
            "code": "8172",
            "localite": "Niederglatt ZH"
        },
        {
            "code": "8173",
            "localite": "Neerach"
        },
        {
            "code": "8174",
            "localite": "Stadel b. Niederglatt"
        },
        {
            "code": "8175",
            "localite": "Windlach"
        },
        {
            "code": "8180",
            "localite": "Bülach"
        },
        {
            "code": "8181",
            "localite": "Höri"
        },
        {
            "code": "8182",
            "localite": "Hochfelden"
        },
        {
            "code": "8184",
            "localite": "Bachenbülach"
        },
        {
            "code": "8185",
            "localite": "Winkel"
        },
        {
            "code": "8187",
            "localite": "Weiach"
        },
        {
            "code": "8192",
            "localite": "Glattfelden"
        },
        {
            "code": "8192",
            "localite": "Zweidlen"
        },
        {
            "code": "8193",
            "localite": "Eglisau"
        },
        {
            "code": "8194",
            "localite": "Hüntwangen"
        },
        {
            "code": "8195",
            "localite": "Wasterkingen"
        },
        {
            "code": "8196",
            "localite": "Wil ZH"
        },
        {
            "code": "8197",
            "localite": "Rafz"
        },
        {
            "code": "8200",
            "localite": "Schaffhausen"
        },
        {
            "code": "8203",
            "localite": "Schaffhausen"
        },
        {
            "code": "8207",
            "localite": "Schaffhausen"
        },
        {
            "code": "8208",
            "localite": "Schaffhausen"
        },
        {
            "code": "8212",
            "localite": "Neuhausen am Rheinfall"
        },
        {
            "code": "8212",
            "localite": "Nohl"
        },
        {
            "code": "8213",
            "localite": "Neunkirch"
        },
        {
            "code": "8214",
            "localite": "Gächlingen"
        },
        {
            "code": "8215",
            "localite": "Hallau"
        },
        {
            "code": "8216",
            "localite": "Oberhallau"
        },
        {
            "code": "8217",
            "localite": "Wilchingen"
        },
        {
            "code": "8218",
            "localite": "Osterfingen"
        },
        {
            "code": "8219",
            "localite": "Trasadingen"
        },
        {
            "code": "8222",
            "localite": "Beringen"
        },
        {
            "code": "8223",
            "localite": "Guntmadingen"
        },
        {
            "code": "8224",
            "localite": "Löhningen"
        },
        {
            "code": "8225",
            "localite": "Siblingen"
        },
        {
            "code": "8226",
            "localite": "Schleitheim"
        },
        {
            "code": "8228",
            "localite": "Beggingen"
        },
        {
            "code": "8231",
            "localite": "Hemmental"
        },
        {
            "code": "8232",
            "localite": "Merishausen"
        },
        {
            "code": "8233",
            "localite": "Bargen SH"
        },
        {
            "code": "8234",
            "localite": "Stetten SH"
        },
        {
            "code": "8235",
            "localite": "Lohn SH"
        },
        {
            "code": "8236",
            "localite": "Büttenhardt"
        },
        {
            "code": "8236",
            "localite": "Opfertshofen SH"
        },
        {
            "code": "8239",
            "localite": "Dörflingen"
        },
        {
            "code": "8240",
            "localite": "Thayngen"
        },
        {
            "code": "8241",
            "localite": "Barzheim"
        },
        {
            "code": "8242",
            "localite": "Bibern SH"
        },
        {
            "code": "8242",
            "localite": "Hofen SH"
        },
        {
            "code": "8243",
            "localite": "Altdorf SH"
        },
        {
            "code": "8245",
            "localite": "Feuerthalen"
        },
        {
            "code": "8246",
            "localite": "Langwiesen"
        },
        {
            "code": "8247",
            "localite": "Flurlingen"
        },
        {
            "code": "8248",
            "localite": "Uhwiesen"
        },
        {
            "code": "8252",
            "localite": "Schlatt TG"
        },
        {
            "code": "8253",
            "localite": "Diessenhofen"
        },
        {
            "code": "8253",
            "localite": "Willisdorf"
        },
        {
            "code": "8254",
            "localite": "Basadingen"
        },
        {
            "code": "8255",
            "localite": "Schlattingen"
        },
        {
            "code": "8259",
            "localite": "Etzwilen"
        },
        {
            "code": "8259",
            "localite": "Kaltenbach"
        },
        {
            "code": "8259",
            "localite": "Rheinklingen"
        },
        {
            "code": "8259",
            "localite": "Wagenhausen"
        },
        {
            "code": "8260",
            "localite": "Stein am Rhein"
        },
        {
            "code": "8261",
            "localite": "Hemishofen"
        },
        {
            "code": "8262",
            "localite": "Ramsen"
        },
        {
            "code": "8263",
            "localite": "Buch SH"
        },
        {
            "code": "8264",
            "localite": "Eschenz"
        },
        {
            "code": "8265",
            "localite": "Mammern"
        },
        {
            "code": "8266",
            "localite": "Steckborn"
        },
        {
            "code": "8267",
            "localite": "Berlingen"
        },
        {
            "code": "8268",
            "localite": "Mannenbach-Salenstein"
        },
        {
            "code": "8268",
            "localite": "Salenstein"
        },
        {
            "code": "8269",
            "localite": "Fruthwilen"
        },
        {
            "code": "8272",
            "localite": "Ermatingen"
        },
        {
            "code": "8273",
            "localite": "Triboltingen"
        },
        {
            "code": "8274",
            "localite": "Gottlieben"
        },
        {
            "code": "8274",
            "localite": "Tägerwilen"
        },
        {
            "code": "8280",
            "localite": "Kreuzlingen"
        },
        {
            "code": "8302",
            "localite": "Kloten"
        },
        {
            "code": "8303",
            "localite": "Bassersdorf"
        },
        {
            "code": "8304",
            "localite": "Wallisellen"
        },
        {
            "code": "8305",
            "localite": "Dietlikon"
        },
        {
            "code": "8306",
            "localite": "Brüttisellen"
        },
        {
            "code": "8307",
            "localite": "Effretikon"
        },
        {
            "code": "8307",
            "localite": "Ottikon b. Kemptthal"
        },
        {
            "code": "8308",
            "localite": "Agasul"
        },
        {
            "code": "8308",
            "localite": "Illnau"
        },
        {
            "code": "8309",
            "localite": "Nürensdorf"
        },
        {
            "code": "8310",
            "localite": "Grafstal"
        },
        {
            "code": "8310",
            "localite": "Kemptthal"
        },
        {
            "code": "8311",
            "localite": "Brütten"
        },
        {
            "code": "8312",
            "localite": "Winterberg ZH"
        },
        {
            "code": "8314",
            "localite": "Kyburg"
        },
        {
            "code": "8315",
            "localite": "Lindau"
        },
        {
            "code": "8317",
            "localite": "Tagelswangen"
        },
        {
            "code": "8320",
            "localite": "Fehraltorf"
        },
        {
            "code": "8322",
            "localite": "Gündisau"
        },
        {
            "code": "8322",
            "localite": "Madetswil"
        },
        {
            "code": "8330",
            "localite": "Pfäffikon ZH"
        },
        {
            "code": "8331",
            "localite": "Auslikon"
        },
        {
            "code": "8332",
            "localite": "Rumlikon"
        },
        {
            "code": "8332",
            "localite": "Russikon"
        },
        {
            "code": "8335",
            "localite": "Hittnau"
        },
        {
            "code": "8340",
            "localite": "Hinwil"
        },
        {
            "code": "8342",
            "localite": "Wernetshausen"
        },
        {
            "code": "8344",
            "localite": "Bäretswil"
        },
        {
            "code": "8345",
            "localite": "Adetswil"
        },
        {
            "code": "8352",
            "localite": "Elsau"
        },
        {
            "code": "8352",
            "localite": "Ricketwil (Winterthur)"
        },
        {
            "code": "8353",
            "localite": "Elgg"
        },
        {
            "code": "8354",
            "localite": "Dickbuch"
        },
        {
            "code": "8354",
            "localite": "Hofstetten ZH"
        },
        {
            "code": "8355",
            "localite": "Aadorf"
        },
        {
            "code": "8356",
            "localite": "Ettenhausen TG"
        },
        {
            "code": "8357",
            "localite": "Guntershausen b. Aadorf"
        },
        {
            "code": "8360",
            "localite": "Eschlikon TG"
        },
        {
            "code": "8360",
            "localite": "Wallenwil"
        },
        {
            "code": "8362",
            "localite": "Balterswil"
        },
        {
            "code": "8363",
            "localite": "Bichelsee"
        },
        {
            "code": "8370",
            "localite": "Sirnach"
        },
        {
            "code": "8371",
            "localite": "Busswil TG"
        },
        {
            "code": "8372",
            "localite": "Wiezikon b. Sirnach"
        },
        {
            "code": "8374",
            "localite": "Dussnang"
        },
        {
            "code": "8374",
            "localite": "Oberwangen TG"
        },
        {
            "code": "8376",
            "localite": "Au TG"
        },
        {
            "code": "8376",
            "localite": "Fischingen"
        },
        {
            "code": "8400",
            "localite": "Winterthur"
        },
        {
            "code": "8404",
            "localite": "Reutlingen (Winterthur)"
        },
        {
            "code": "8404",
            "localite": "Stadel (Winterthur)"
        },
        {
            "code": "8404",
            "localite": "Winterthur"
        },
        {
            "code": "8405",
            "localite": "Winterthur"
        },
        {
            "code": "8406",
            "localite": "Winterthur"
        },
        {
            "code": "8408",
            "localite": "Winterthur"
        },
        {
            "code": "8409",
            "localite": "Winterthur"
        },
        {
            "code": "8412",
            "localite": "Aesch (Neftenbach)"
        },
        {
            "code": "8412",
            "localite": "Hünikon (Neftenbach)"
        },
        {
            "code": "8412",
            "localite": "Riet (Neftenbach)"
        },
        {
            "code": "8413",
            "localite": "Neftenbach"
        },
        {
            "code": "8414",
            "localite": "Buch am Irchel"
        },
        {
            "code": "8415",
            "localite": "Berg am Irchel"
        },
        {
            "code": "8415",
            "localite": "Gräslikon"
        },
        {
            "code": "8416",
            "localite": "Flaach"
        },
        {
            "code": "8418",
            "localite": "Schlatt ZH"
        },
        {
            "code": "8421",
            "localite": "Dättlikon"
        },
        {
            "code": "8422",
            "localite": "Pfungen"
        },
        {
            "code": "8424",
            "localite": "Embrach"
        },
        {
            "code": "8425",
            "localite": "Oberembrach"
        },
        {
            "code": "8426",
            "localite": "Lufingen"
        },
        {
            "code": "8427",
            "localite": "Freienstein"
        },
        {
            "code": "8427",
            "localite": "Rorbas"
        },
        {
            "code": "8428",
            "localite": "Teufen ZH"
        },
        {
            "code": "8442",
            "localite": "Hettlingen"
        },
        {
            "code": "8444",
            "localite": "Henggart"
        },
        {
            "code": "8447",
            "localite": "Dachsen"
        },
        {
            "code": "8450",
            "localite": "Andelfingen"
        },
        {
            "code": "8451",
            "localite": "Kleinandelfingen"
        },
        {
            "code": "8452",
            "localite": "Adlikon b. Andelfingen"
        },
        {
            "code": "8453",
            "localite": "Alten"
        },
        {
            "code": "8454",
            "localite": "Buchberg"
        },
        {
            "code": "8455",
            "localite": "Rüdlingen"
        },
        {
            "code": "8457",
            "localite": "Humlikon"
        },
        {
            "code": "8458",
            "localite": "Dorf"
        },
        {
            "code": "8459",
            "localite": "Volken"
        },
        {
            "code": "8460",
            "localite": "Marthalen"
        },
        {
            "code": "8461",
            "localite": "Oerlingen"
        },
        {
            "code": "8462",
            "localite": "Rheinau"
        },
        {
            "code": "8463",
            "localite": "Benken ZH"
        },
        {
            "code": "8464",
            "localite": "Ellikon am Rhein"
        },
        {
            "code": "8465",
            "localite": "Rudolfingen"
        },
        {
            "code": "8465",
            "localite": "Wildensbuch"
        },
        {
            "code": "8466",
            "localite": "Trüllikon"
        },
        {
            "code": "8467",
            "localite": "Truttikon"
        },
        {
            "code": "8468",
            "localite": "Guntalingen"
        },
        {
            "code": "8468",
            "localite": "Waltalingen"
        },
        {
            "code": "8471",
            "localite": "Berg (Dägerlen)"
        },
        {
            "code": "8471",
            "localite": "Bänk (Dägerlen)"
        },
        {
            "code": "8471",
            "localite": "Dägerlen"
        },
        {
            "code": "8471",
            "localite": "Oberwil (Dägerlen)"
        },
        {
            "code": "8471",
            "localite": "Rutschwil (Dägerlen)"
        },
        {
            "code": "8472",
            "localite": "Oberohringen"
        },
        {
            "code": "8472",
            "localite": "Seuzach"
        },
        {
            "code": "8472",
            "localite": "Unterohringen"
        },
        {
            "code": "8474",
            "localite": "Dinhard"
        },
        {
            "code": "8475",
            "localite": "Ossingen"
        },
        {
            "code": "8476",
            "localite": "Unterstammheim"
        },
        {
            "code": "8477",
            "localite": "Oberstammheim"
        },
        {
            "code": "8478",
            "localite": "Thalheim an der Thur"
        },
        {
            "code": "8479",
            "localite": "Altikon"
        },
        {
            "code": "8482",
            "localite": "Sennhof (Winterthur)"
        },
        {
            "code": "8483",
            "localite": "Kollbrunn"
        },
        {
            "code": "8484",
            "localite": "Neschwil"
        },
        {
            "code": "8484",
            "localite": "Theilingen"
        },
        {
            "code": "8484",
            "localite": "Weisslingen"
        },
        {
            "code": "8486",
            "localite": "Rikon im Tösstal"
        },
        {
            "code": "8487",
            "localite": "Rämismühle"
        },
        {
            "code": "8487",
            "localite": "Zell ZH"
        },
        {
            "code": "8488",
            "localite": "Turbenthal"
        },
        {
            "code": "8489",
            "localite": "Ehrikon"
        },
        {
            "code": "8489",
            "localite": "Schalchen"
        },
        {
            "code": "8489",
            "localite": "Wildberg"
        },
        {
            "code": "8492",
            "localite": "Wila"
        },
        {
            "code": "8493",
            "localite": "Saland"
        },
        {
            "code": "8494",
            "localite": "Bauma"
        },
        {
            "code": "8495",
            "localite": "Schmidrüti"
        },
        {
            "code": "8496",
            "localite": "Steg im Tösstal"
        },
        {
            "code": "8497",
            "localite": "Fischenthal"
        },
        {
            "code": "8498",
            "localite": "Gibswil"
        },
        {
            "code": "8499",
            "localite": "Sternenberg"
        },
        {
            "code": "8500",
            "localite": "Frauenfeld"
        },
        {
            "code": "8500",
            "localite": "Gerlikon"
        },
        {
            "code": "8505",
            "localite": "Dettighofen"
        },
        {
            "code": "8505",
            "localite": "Pfyn"
        },
        {
            "code": "8506",
            "localite": "Lanzenneunforn"
        },
        {
            "code": "8507",
            "localite": "Hörhausen"
        },
        {
            "code": "8508",
            "localite": "Homburg"
        },
        {
            "code": "8512",
            "localite": "Lustdorf"
        },
        {
            "code": "8512",
            "localite": "Thundorf"
        },
        {
            "code": "8512",
            "localite": "Wetzikon TG"
        },
        {
            "code": "8514",
            "localite": "Amlikon-Bissegg"
        },
        {
            "code": "8522",
            "localite": "Aawangen"
        },
        {
            "code": "8522",
            "localite": "Häuslenen"
        },
        {
            "code": "8523",
            "localite": "Hagenbuch ZH"
        },
        {
            "code": "8524",
            "localite": "Buch b. Frauenfeld"
        },
        {
            "code": "8524",
            "localite": "Uesslingen"
        },
        {
            "code": "8525",
            "localite": "Niederneunforn"
        },
        {
            "code": "8525",
            "localite": "Wilen b. Neunforn"
        },
        {
            "code": "8526",
            "localite": "Oberneunforn"
        },
        {
            "code": "8532",
            "localite": "Warth"
        },
        {
            "code": "8532",
            "localite": "Weiningen TG"
        },
        {
            "code": "8535",
            "localite": "Herdern"
        },
        {
            "code": "8536",
            "localite": "Hüttwilen"
        },
        {
            "code": "8537",
            "localite": "Nussbaumen TG"
        },
        {
            "code": "8537",
            "localite": "Uerschhausen"
        },
        {
            "code": "8542",
            "localite": "Wiesendangen"
        },
        {
            "code": "8543",
            "localite": "Bertschikon"
        },
        {
            "code": "8543",
            "localite": "Gundetswil"
        },
        {
            "code": "8543",
            "localite": "Kefikon ZH"
        },
        {
            "code": "8544",
            "localite": "Attikon"
        },
        {
            "code": "8545",
            "localite": "Rickenbach Sulz"
        },
        {
            "code": "8545",
            "localite": "Rickenbach ZH"
        },
        {
            "code": "8546",
            "localite": "Islikon"
        },
        {
            "code": "8546",
            "localite": "Kefikon TG"
        },
        {
            "code": "8546",
            "localite": "Menzengrüt"
        },
        {
            "code": "8547",
            "localite": "Gachnang"
        },
        {
            "code": "8548",
            "localite": "Ellikon an der Thur"
        },
        {
            "code": "8552",
            "localite": "Felben-Wellhausen"
        },
        {
            "code": "8553",
            "localite": "Eschikofen"
        },
        {
            "code": "8553",
            "localite": "Harenwilen"
        },
        {
            "code": "8553",
            "localite": "Hüttlingen"
        },
        {
            "code": "8553",
            "localite": "Mettendorf TG"
        },
        {
            "code": "8554",
            "localite": "Bonau"
        },
        {
            "code": "8554",
            "localite": "Müllheim-Wigoltingen"
        },
        {
            "code": "8555",
            "localite": "Müllheim Dorf"
        },
        {
            "code": "8556",
            "localite": "Engwang"
        },
        {
            "code": "8556",
            "localite": "Illhart"
        },
        {
            "code": "8556",
            "localite": "Lamperswil TG"
        },
        {
            "code": "8556",
            "localite": "Wigoltingen"
        },
        {
            "code": "8558",
            "localite": "Raperswilen"
        },
        {
            "code": "8560",
            "localite": "Märstetten"
        },
        {
            "code": "8561",
            "localite": "Ottoberg"
        },
        {
            "code": "8564",
            "localite": "Engwilen"
        },
        {
            "code": "8564",
            "localite": "Gunterswilen"
        },
        {
            "code": "8564",
            "localite": "Hattenhausen"
        },
        {
            "code": "8564",
            "localite": "Hefenhausen"
        },
        {
            "code": "8564",
            "localite": "Lipperswil"
        },
        {
            "code": "8564",
            "localite": "Sonterswil"
        },
        {
            "code": "8564",
            "localite": "Wagerswil"
        },
        {
            "code": "8564",
            "localite": "Wäldi"
        },
        {
            "code": "8565",
            "localite": "Hugelshofen"
        },
        {
            "code": "8566",
            "localite": "Dotnacht"
        },
        {
            "code": "8566",
            "localite": "Ellighausen"
        },
        {
            "code": "8566",
            "localite": "Lippoldswilen"
        },
        {
            "code": "8566",
            "localite": "Neuwilen"
        },
        {
            "code": "8570",
            "localite": "Weinfelden"
        },
        {
            "code": "8572",
            "localite": "Andhausen"
        },
        {
            "code": "8572",
            "localite": "Berg TG"
        },
        {
            "code": "8572",
            "localite": "Graltshausen"
        },
        {
            "code": "8572",
            "localite": "Guntershausen b. Berg"
        },
        {
            "code": "8573",
            "localite": "Alterswilen"
        },
        {
            "code": "8573",
            "localite": "Altishausen"
        },
        {
            "code": "8573",
            "localite": "Siegershausen"
        },
        {
            "code": "8574",
            "localite": "Dettighofen (Lengwil)"
        },
        {
            "code": "8574",
            "localite": "Illighausen"
        },
        {
            "code": "8574",
            "localite": "Lengwil"
        },
        {
            "code": "8574",
            "localite": "Oberhofen TG"
        },
        {
            "code": "8575",
            "localite": "Bürglen TG"
        },
        {
            "code": "8575",
            "localite": "Istighofen"
        },
        {
            "code": "8576",
            "localite": "Mauren TG"
        },
        {
            "code": "8577",
            "localite": "Schönholzerswilen"
        },
        {
            "code": "8580",
            "localite": "Amriswil"
        },
        {
            "code": "8580",
            "localite": "Biessenhofen"
        },
        {
            "code": "8580",
            "localite": "Hagenwil b. Amriswil"
        },
        {
            "code": "8580",
            "localite": "Hefenhofen"
        },
        {
            "code": "8580",
            "localite": "Sommeri"
        },
        {
            "code": "8581",
            "localite": "Schocherswil"
        },
        {
            "code": "8582",
            "localite": "Dozwil"
        },
        {
            "code": "8583",
            "localite": "Donzhausen"
        },
        {
            "code": "8583",
            "localite": "Götighofen"
        },
        {
            "code": "8583",
            "localite": "Sulgen"
        },
        {
            "code": "8584",
            "localite": "Leimbach TG"
        },
        {
            "code": "8584",
            "localite": "Opfershofen TG"
        },
        {
            "code": "8585",
            "localite": "Birwinken"
        },
        {
            "code": "8585",
            "localite": "Happerswil"
        },
        {
            "code": "8585",
            "localite": "Herrenhof"
        },
        {
            "code": "8585",
            "localite": "Klarsreuti"
        },
        {
            "code": "8585",
            "localite": "Langrickenbach"
        },
        {
            "code": "8585",
            "localite": "Mattwil"
        },
        {
            "code": "8585",
            "localite": "Schönenbaumgarten"
        },
        {
            "code": "8585",
            "localite": "Zuben"
        },
        {
            "code": "8586",
            "localite": "Andwil TG"
        },
        {
            "code": "8586",
            "localite": "Buch b. Kümmertshausen"
        },
        {
            "code": "8586",
            "localite": "Buchackern"
        },
        {
            "code": "8586",
            "localite": "Engishofen"
        },
        {
            "code": "8586",
            "localite": "Ennetaach"
        },
        {
            "code": "8586",
            "localite": "Erlen"
        },
        {
            "code": "8586",
            "localite": "Kümmertshausen"
        },
        {
            "code": "8586",
            "localite": "Riedt b. Erlen"
        },
        {
            "code": "8587",
            "localite": "Oberaach"
        },
        {
            "code": "8588",
            "localite": "Zihlschlacht"
        },
        {
            "code": "8589",
            "localite": "Sitterdorf"
        },
        {
            "code": "8590",
            "localite": "Romanshorn"
        },
        {
            "code": "8592",
            "localite": "Uttwil"
        },
        {
            "code": "8593",
            "localite": "Kesswil"
        },
        {
            "code": "8594",
            "localite": "Güttingen"
        },
        {
            "code": "8595",
            "localite": "Altnau"
        },
        {
            "code": "8596",
            "localite": "Münsterlingen"
        },
        {
            "code": "8596",
            "localite": "Scherzingen"
        },
        {
            "code": "8597",
            "localite": "Landschlacht"
        },
        {
            "code": "8598",
            "localite": "Bottighofen"
        },
        {
            "code": "8599",
            "localite": "Salmsach"
        },
        {
            "code": "8600",
            "localite": "Dübendorf"
        },
        {
            "code": "8602",
            "localite": "Wangen b. Dübendorf"
        },
        {
            "code": "8603",
            "localite": "Schwerzenbach"
        },
        {
            "code": "8604",
            "localite": "Volketswil"
        },
        {
            "code": "8605",
            "localite": "Gutenswil"
        },
        {
            "code": "8606",
            "localite": "Greifensee"
        },
        {
            "code": "8606",
            "localite": "Nänikon"
        },
        {
            "code": "8607",
            "localite": "Aathal-Seegräben"
        },
        {
            "code": "8608",
            "localite": "Bubikon"
        },
        {
            "code": "8610",
            "localite": "Uster"
        },
        {
            "code": "8614",
            "localite": "Bertschikon (Gossau ZH)"
        },
        {
            "code": "8614",
            "localite": "Sulzbach"
        },
        {
            "code": "8615",
            "localite": "Freudwil"
        },
        {
            "code": "8615",
            "localite": "Wermatswil"
        },
        {
            "code": "8616",
            "localite": "Riedikon"
        },
        {
            "code": "8617",
            "localite": "Mönchaltorf"
        },
        {
            "code": "8618",
            "localite": "Oetwil am See"
        },
        {
            "code": "8620",
            "localite": "Wetzikon ZH"
        },
        {
            "code": "8623",
            "localite": "Wetzikon ZH"
        },
        {
            "code": "8624",
            "localite": "Grüt (Gossau ZH)"
        },
        {
            "code": "8625",
            "localite": "Gossau ZH"
        },
        {
            "code": "8626",
            "localite": "Ottikon (Gossau ZH)"
        },
        {
            "code": "8627",
            "localite": "Grüningen"
        },
        {
            "code": "8630",
            "localite": "Rüti ZH"
        },
        {
            "code": "8632",
            "localite": "Tann"
        },
        {
            "code": "8633",
            "localite": "Wolfhausen"
        },
        {
            "code": "8634",
            "localite": "Hombrechtikon"
        },
        {
            "code": "8635",
            "localite": "Dürnten"
        },
        {
            "code": "8636",
            "localite": "Wald ZH"
        },
        {
            "code": "8637",
            "localite": "Laupen ZH"
        },
        {
            "code": "8638",
            "localite": "Goldingen"
        },
        {
            "code": "8640",
            "localite": "Hurden"
        },
        {
            "code": "8640",
            "localite": "Rapperswil SG"
        },
        {
            "code": "8645",
            "localite": "Jona"
        },
        {
            "code": "8646",
            "localite": "Wagen"
        },
        {
            "code": "8700",
            "localite": "Küsnacht ZH"
        },
        {
            "code": "8702",
            "localite": "Zollikon"
        },
        {
            "code": "8703",
            "localite": "Erlenbach ZH"
        },
        {
            "code": "8704",
            "localite": "Herrliberg"
        },
        {
            "code": "8706",
            "localite": "Meilen"
        },
        {
            "code": "8707",
            "localite": "Uetikon am See"
        },
        {
            "code": "8708",
            "localite": "Männedorf"
        },
        {
            "code": "8712",
            "localite": "Stäfa"
        },
        {
            "code": "8713",
            "localite": "Uerikon"
        },
        {
            "code": "8714",
            "localite": "Feldbach"
        },
        {
            "code": "8715",
            "localite": "Bollingen"
        },
        {
            "code": "8716",
            "localite": "Schmerikon"
        },
        {
            "code": "8717",
            "localite": "Benken SG"
        },
        {
            "code": "8718",
            "localite": "Schänis"
        },
        {
            "code": "8722",
            "localite": "Kaltbrunn"
        },
        {
            "code": "8723",
            "localite": "Maseltrangen"
        },
        {
            "code": "8723",
            "localite": "Rufi"
        },
        {
            "code": "8725",
            "localite": "Ernetschwil"
        },
        {
            "code": "8725",
            "localite": "Gebertingen"
        },
        {
            "code": "8726",
            "localite": "Ricken SG"
        },
        {
            "code": "8727",
            "localite": "Walde SG"
        },
        {
            "code": "8730",
            "localite": "Uznach"
        },
        {
            "code": "8732",
            "localite": "Neuhaus SG"
        },
        {
            "code": "8733",
            "localite": "Eschenbach SG"
        },
        {
            "code": "8734",
            "localite": "Ermenswil"
        },
        {
            "code": "8735",
            "localite": "Rüeterswil"
        },
        {
            "code": "8735",
            "localite": "St. Gallenkappel"
        },
        {
            "code": "8737",
            "localite": "Gommiswald"
        },
        {
            "code": "8738",
            "localite": "Uetliburg SG"
        },
        {
            "code": "8739",
            "localite": "Rieden SG"
        },
        {
            "code": "8750",
            "localite": "Glarus"
        },
        {
            "code": "8750",
            "localite": "Klöntal"
        },
        {
            "code": "8750",
            "localite": "Riedern"
        },
        {
            "code": "8751",
            "localite": "Urnerboden"
        },
        {
            "code": "8752",
            "localite": "Näfels"
        },
        {
            "code": "8753",
            "localite": "Mollis"
        },
        {
            "code": "8754",
            "localite": "Netstal"
        },
        {
            "code": "8755",
            "localite": "Ennenda"
        },
        {
            "code": "8756",
            "localite": "Mitlödi"
        },
        {
            "code": "8757",
            "localite": "Filzbach"
        },
        {
            "code": "8758",
            "localite": "Obstalden"
        },
        {
            "code": "8762",
            "localite": "Schwanden GL"
        },
        {
            "code": "8762",
            "localite": "Schwändi b. Schwanden"
        },
        {
            "code": "8762",
            "localite": "Sool"
        },
        {
            "code": "8765",
            "localite": "Engi"
        },
        {
            "code": "8766",
            "localite": "Matt"
        },
        {
            "code": "8767",
            "localite": "Elm"
        },
        {
            "code": "8772",
            "localite": "Nidfurn"
        },
        {
            "code": "8773",
            "localite": "Haslen GL"
        },
        {
            "code": "8774",
            "localite": "Leuggelbach"
        },
        {
            "code": "8775",
            "localite": "Hätzingen"
        },
        {
            "code": "8775",
            "localite": "Luchsingen"
        },
        {
            "code": "8777",
            "localite": "Betschwanden"
        },
        {
            "code": "8777",
            "localite": "Diesbach GL"
        },
        {
            "code": "8782",
            "localite": "Rüti GL"
        },
        {
            "code": "8783",
            "localite": "Linthal"
        },
        {
            "code": "8784",
            "localite": "Braunwald"
        },
        {
            "code": "8800",
            "localite": "Thalwil"
        },
        {
            "code": "8802",
            "localite": "Kilchberg ZH"
        },
        {
            "code": "8803",
            "localite": "Rüschlikon"
        },
        {
            "code": "8804",
            "localite": "Au ZH"
        },
        {
            "code": "8805",
            "localite": "Richterswil"
        },
        {
            "code": "8806",
            "localite": "Bäch SZ"
        },
        {
            "code": "8807",
            "localite": "Freienbach"
        },
        {
            "code": "8808",
            "localite": "Pfäffikon SZ"
        },
        {
            "code": "8810",
            "localite": "Horgen"
        },
        {
            "code": "8815",
            "localite": "Horgenberg"
        },
        {
            "code": "8816",
            "localite": "Hirzel"
        },
        {
            "code": "8820",
            "localite": "Wädenswil"
        },
        {
            "code": "8824",
            "localite": "Schönenberg ZH"
        },
        {
            "code": "8825",
            "localite": "Hütten"
        },
        {
            "code": "8832",
            "localite": "Wilen b. Wollerau"
        },
        {
            "code": "8832",
            "localite": "Wollerau"
        },
        {
            "code": "8833",
            "localite": "Samstagern"
        },
        {
            "code": "8834",
            "localite": "Schindellegi"
        },
        {
            "code": "8835",
            "localite": "Feusisberg"
        },
        {
            "code": "8836",
            "localite": "Bennau"
        },
        {
            "code": "8840",
            "localite": "Einsiedeln"
        },
        {
            "code": "8840",
            "localite": "Trachslau"
        },
        {
            "code": "8841",
            "localite": "Gross"
        },
        {
            "code": "8842",
            "localite": "Unteriberg"
        },
        {
            "code": "8843",
            "localite": "Oberiberg"
        },
        {
            "code": "8844",
            "localite": "Euthal"
        },
        {
            "code": "8845",
            "localite": "Studen SZ"
        },
        {
            "code": "8846",
            "localite": "Willerzell"
        },
        {
            "code": "8847",
            "localite": "Egg SZ"
        },
        {
            "code": "8849",
            "localite": "Alpthal"
        },
        {
            "code": "8852",
            "localite": "Altendorf"
        },
        {
            "code": "8853",
            "localite": "Lachen SZ"
        },
        {
            "code": "8854",
            "localite": "Galgenen"
        },
        {
            "code": "8854",
            "localite": "Siebnen"
        },
        {
            "code": "8855",
            "localite": "Wangen SZ"
        },
        {
            "code": "8856",
            "localite": "Tuggen"
        },
        {
            "code": "8857",
            "localite": "Vorderthal"
        },
        {
            "code": "8858",
            "localite": "Innerthal"
        },
        {
            "code": "8862",
            "localite": "Schübelbach"
        },
        {
            "code": "8863",
            "localite": "Buttikon SZ"
        },
        {
            "code": "8864",
            "localite": "Reichenburg"
        },
        {
            "code": "8865",
            "localite": "Bilten"
        },
        {
            "code": "8866",
            "localite": "Ziegelbrücke"
        },
        {
            "code": "8867",
            "localite": "Niederurnen"
        },
        {
            "code": "8868",
            "localite": "Oberurnen"
        },
        {
            "code": "8872",
            "localite": "Weesen"
        },
        {
            "code": "8873",
            "localite": "Amden"
        },
        {
            "code": "8874",
            "localite": "Mühlehorn"
        },
        {
            "code": "8877",
            "localite": "Murg"
        },
        {
            "code": "8878",
            "localite": "Quinten"
        },
        {
            "code": "8880",
            "localite": "Walenstadt"
        },
        {
            "code": "8881",
            "localite": "Tscherlach"
        },
        {
            "code": "8881",
            "localite": "Walenstadtberg"
        },
        {
            "code": "8882",
            "localite": "Unterterzen"
        },
        {
            "code": "8883",
            "localite": "Quarten"
        },
        {
            "code": "8884",
            "localite": "Oberterzen"
        },
        {
            "code": "8885",
            "localite": "Mols"
        },
        {
            "code": "8886",
            "localite": "Mädris-Vermol"
        },
        {
            "code": "8887",
            "localite": "Mels"
        },
        {
            "code": "8888",
            "localite": "Heiligkreuz (Mels)"
        },
        {
            "code": "8889",
            "localite": "Plons"
        },
        {
            "code": "8890",
            "localite": "Flums"
        },
        {
            "code": "8892",
            "localite": "Berschis"
        },
        {
            "code": "8893",
            "localite": "Flums Hochwiese"
        },
        {
            "code": "8894",
            "localite": "Flumserberg Saxli"
        },
        {
            "code": "8895",
            "localite": "Flumserberg Portels"
        },
        {
            "code": "8896",
            "localite": "Flumserberg Bergheim"
        },
        {
            "code": "8897",
            "localite": "Flumserberg Tannenheim"
        },
        {
            "code": "8898",
            "localite": "Flumserberg Tannenbodenalp"
        },
        {
            "code": "8902",
            "localite": "Urdorf"
        },
        {
            "code": "8903",
            "localite": "Birmensdorf ZH"
        },
        {
            "code": "8904",
            "localite": "Aesch ZH"
        },
        {
            "code": "8905",
            "localite": "Arni AG"
        },
        {
            "code": "8905",
            "localite": "Islisberg"
        },
        {
            "code": "8906",
            "localite": "Bonstetten"
        },
        {
            "code": "8907",
            "localite": "Wettswil"
        },
        {
            "code": "8908",
            "localite": "Hedingen"
        },
        {
            "code": "8909",
            "localite": "Zwillikon"
        },
        {
            "code": "8910",
            "localite": "Affoltern am Albis"
        },
        {
            "code": "8911",
            "localite": "Rifferswil"
        },
        {
            "code": "8912",
            "localite": "Obfelden"
        },
        {
            "code": "8913",
            "localite": "Ottenbach"
        },
        {
            "code": "8914",
            "localite": "Aeugst am Albis"
        },
        {
            "code": "8914",
            "localite": "Aeugstertal"
        },
        {
            "code": "8915",
            "localite": "Hausen am Albis"
        },
        {
            "code": "8916",
            "localite": "Jonen"
        },
        {
            "code": "8917",
            "localite": "Oberlunkhofen"
        },
        {
            "code": "8918",
            "localite": "Unterlunkhofen"
        },
        {
            "code": "8919",
            "localite": "Rottenschwil"
        },
        {
            "code": "8925",
            "localite": "Ebertswil"
        },
        {
            "code": "8926",
            "localite": "Hauptikon"
        },
        {
            "code": "8926",
            "localite": "Kappel am Albis"
        },
        {
            "code": "8926",
            "localite": "Uerzlikon"
        },
        {
            "code": "8932",
            "localite": "Mettmenstetten"
        },
        {
            "code": "8933",
            "localite": "Maschwanden"
        },
        {
            "code": "8934",
            "localite": "Knonau"
        },
        {
            "code": "8942",
            "localite": "Oberrieden"
        },
        {
            "code": "8951",
            "localite": "Fahrweid"
        },
        {
            "code": "8952",
            "localite": "Schlieren"
        },
        {
            "code": "8953",
            "localite": "Dietikon"
        },
        {
            "code": "8954",
            "localite": "Geroldswil"
        },
        {
            "code": "8955",
            "localite": "Oetwil an der Limmat"
        },
        {
            "code": "8956",
            "localite": "Killwangen"
        },
        {
            "code": "8957",
            "localite": "Spreitenbach"
        },
        {
            "code": "8962",
            "localite": "Bergdietikon"
        },
        {
            "code": "8964",
            "localite": "Rudolfstetten"
        },
        {
            "code": "8965",
            "localite": "Berikon"
        },
        {
            "code": "8966",
            "localite": "Oberwil-Lieli"
        },
        {
            "code": "8967",
            "localite": "Widen"
        },
        {
            "code": "9000",
            "localite": "St. Gallen"
        },
        {
            "code": "9008",
            "localite": "St. Gallen"
        },
        {
            "code": "9010",
            "localite": "St. Gallen"
        },
        {
            "code": "9011",
            "localite": "St. Gallen"
        },
        {
            "code": "9012",
            "localite": "St. Gallen"
        },
        {
            "code": "9014",
            "localite": "St. Gallen"
        },
        {
            "code": "9015",
            "localite": "St. Gallen"
        },
        {
            "code": "9016",
            "localite": "St. Gallen"
        },
        {
            "code": "9030",
            "localite": "Abtwil SG"
        },
        {
            "code": "9030",
            "localite": "St. Josefen"
        },
        {
            "code": "9032",
            "localite": "Engelburg"
        },
        {
            "code": "9033",
            "localite": "Untereggen"
        },
        {
            "code": "9034",
            "localite": "Eggersriet"
        },
        {
            "code": "9035",
            "localite": "Grub AR"
        },
        {
            "code": "9036",
            "localite": "Grub SG"
        },
        {
            "code": "9037",
            "localite": "Speicherschwendi"
        },
        {
            "code": "9038",
            "localite": "Rehetobel"
        },
        {
            "code": "9042",
            "localite": "Speicher"
        },
        {
            "code": "9043",
            "localite": "Trogen"
        },
        {
            "code": "9044",
            "localite": "Wald AR"
        },
        {
            "code": "9050",
            "localite": "Appenzell"
        },
        {
            "code": "9050",
            "localite": "Appenzell Eggerstanden"
        },
        {
            "code": "9050",
            "localite": "Appenzell Enggenhütten"
        },
        {
            "code": "9050",
            "localite": "Appenzell Meistersrüte"
        },
        {
            "code": "9050",
            "localite": "Appenzell Schlatt"
        },
        {
            "code": "9050",
            "localite": "Appenzell Steinegg"
        },
        {
            "code": "9052",
            "localite": "Niederteufen"
        },
        {
            "code": "9053",
            "localite": "Teufen AR"
        },
        {
            "code": "9054",
            "localite": "Haslen AI"
        },
        {
            "code": "9055",
            "localite": "Bühler"
        },
        {
            "code": "9056",
            "localite": "Gais"
        },
        {
            "code": "9057",
            "localite": "Schwende"
        },
        {
            "code": "9057",
            "localite": "Wasserauen"
        },
        {
            "code": "9057",
            "localite": "Weissbad"
        },
        {
            "code": "9058",
            "localite": "Brülisau"
        },
        {
            "code": "9062",
            "localite": "Lustmühle"
        },
        {
            "code": "9063",
            "localite": "Stein AR"
        },
        {
            "code": "9064",
            "localite": "Hundwil"
        },
        {
            "code": "9100",
            "localite": "Herisau"
        },
        {
            "code": "9103",
            "localite": "Schwellbrunn"
        },
        {
            "code": "9104",
            "localite": "Waldstatt"
        },
        {
            "code": "9105",
            "localite": "Schönengrund"
        },
        {
            "code": "9107",
            "localite": "Urnäsch"
        },
        {
            "code": "9108",
            "localite": "Gonten"
        },
        {
            "code": "9108",
            "localite": "Gontenbad"
        },
        {
            "code": "9108",
            "localite": "Jakobsbad"
        },
        {
            "code": "9112",
            "localite": "Schachen b. Herisau"
        },
        {
            "code": "9113",
            "localite": "Degersheim"
        },
        {
            "code": "9114",
            "localite": "Hoffeld"
        },
        {
            "code": "9115",
            "localite": "Dicken"
        },
        {
            "code": "9116",
            "localite": "Wolfertswil"
        },
        {
            "code": "9122",
            "localite": "Ebersol"
        },
        {
            "code": "9122",
            "localite": "Mogelsberg"
        },
        {
            "code": "9123",
            "localite": "Nassen"
        },
        {
            "code": "9125",
            "localite": "Brunnadern"
        },
        {
            "code": "9126",
            "localite": "Necker"
        },
        {
            "code": "9127",
            "localite": "St. Peterzell"
        },
        {
            "code": "9200",
            "localite": "Gossau SG"
        },
        {
            "code": "9203",
            "localite": "Niederwil SG"
        },
        {
            "code": "9204",
            "localite": "Andwil SG"
        },
        {
            "code": "9205",
            "localite": "Waldkirch"
        },
        {
            "code": "9212",
            "localite": "Arnegg"
        },
        {
            "code": "9213",
            "localite": "Hauptwil"
        },
        {
            "code": "9214",
            "localite": "Kradolf"
        },
        {
            "code": "9215",
            "localite": "Buhwil"
        },
        {
            "code": "9215",
            "localite": "Schönenberg an der Thur"
        },
        {
            "code": "9216",
            "localite": "Heldswil"
        },
        {
            "code": "9216",
            "localite": "Hohentannen"
        },
        {
            "code": "9217",
            "localite": "Neukirch an der Thur"
        },
        {
            "code": "9220",
            "localite": "Bischofszell"
        },
        {
            "code": "9223",
            "localite": "Halden"
        },
        {
            "code": "9223",
            "localite": "Schweizersholz"
        },
        {
            "code": "9225",
            "localite": "St. Pelagiberg"
        },
        {
            "code": "9225",
            "localite": "Wilen (Gottshaus)"
        },
        {
            "code": "9230",
            "localite": "Flawil"
        },
        {
            "code": "9231",
            "localite": "Egg (Flawil)"
        },
        {
            "code": "9240",
            "localite": "Niederglatt SG"
        },
        {
            "code": "9240",
            "localite": "Uzwil"
        },
        {
            "code": "9242",
            "localite": "Oberuzwil"
        },
        {
            "code": "9243",
            "localite": "Jonschwil"
        },
        {
            "code": "9244",
            "localite": "Niederuzwil"
        },
        {
            "code": "9245",
            "localite": "Oberbüren"
        },
        {
            "code": "9245",
            "localite": "Sonnental"
        },
        {
            "code": "9246",
            "localite": "Niederbüren"
        },
        {
            "code": "9247",
            "localite": "Henau"
        },
        {
            "code": "9248",
            "localite": "Bichwil"
        },
        {
            "code": "9249",
            "localite": "Algetshausen"
        },
        {
            "code": "9249",
            "localite": "Niederstetten"
        },
        {
            "code": "9249",
            "localite": "Oberstetten"
        },
        {
            "code": "9300",
            "localite": "Wittenbach"
        },
        {
            "code": "9304",
            "localite": "Bernhardzell"
        },
        {
            "code": "9305",
            "localite": "Berg SG"
        },
        {
            "code": "9306",
            "localite": "Freidorf TG"
        },
        {
            "code": "9308",
            "localite": "Lömmenschwil"
        },
        {
            "code": "9312",
            "localite": "Häggenschwil"
        },
        {
            "code": "9313",
            "localite": "Muolen"
        },
        {
            "code": "9314",
            "localite": "Steinebrunn"
        },
        {
            "code": "9315",
            "localite": "Neukirch (Egnach)"
        },
        {
            "code": "9315",
            "localite": "Winden"
        },
        {
            "code": "9320",
            "localite": "Arbon"
        },
        {
            "code": "9320",
            "localite": "Frasnacht"
        },
        {
            "code": "9320",
            "localite": "Stachen"
        },
        {
            "code": "9322",
            "localite": "Egnach"
        },
        {
            "code": "9323",
            "localite": "Steinach"
        },
        {
            "code": "9325",
            "localite": "Roggwil TG"
        },
        {
            "code": "9326",
            "localite": "Horn"
        },
        {
            "code": "9327",
            "localite": "Tübach"
        },
        {
            "code": "9400",
            "localite": "Rorschach"
        },
        {
            "code": "9402",
            "localite": "Mörschwil"
        },
        {
            "code": "9403",
            "localite": "Goldach"
        },
        {
            "code": "9404",
            "localite": "Rorschacherberg"
        },
        {
            "code": "9405",
            "localite": "Wienacht-Tobel"
        },
        {
            "code": "9410",
            "localite": "Heiden"
        },
        {
            "code": "9411",
            "localite": "Reute AR"
        },
        {
            "code": "9411",
            "localite": "Schachen b. Reute"
        },
        {
            "code": "9413",
            "localite": "Oberegg"
        },
        {
            "code": "9422",
            "localite": "Staad SG"
        },
        {
            "code": "9423",
            "localite": "Altenrhein"
        },
        {
            "code": "9424",
            "localite": "Rheineck"
        },
        {
            "code": "9425",
            "localite": "Thal"
        },
        {
            "code": "9426",
            "localite": "Lutzenberg"
        },
        {
            "code": "9427",
            "localite": "Wolfhalden"
        },
        {
            "code": "9428",
            "localite": "Walzenhausen"
        },
        {
            "code": "9430",
            "localite": "St. Margrethen SG"
        },
        {
            "code": "9434",
            "localite": "Au SG"
        },
        {
            "code": "9435",
            "localite": "Heerbrugg"
        },
        {
            "code": "9436",
            "localite": "Balgach"
        },
        {
            "code": "9437",
            "localite": "Marbach SG"
        },
        {
            "code": "9442",
            "localite": "Berneck"
        },
        {
            "code": "9442",
            "localite": "Büriswilen"
        },
        {
            "code": "9443",
            "localite": "Widnau"
        },
        {
            "code": "9444",
            "localite": "Diepoldsau"
        },
        {
            "code": "9445",
            "localite": "Rebstein"
        },
        {
            "code": "9450",
            "localite": "Altstätten SG"
        },
        {
            "code": "9450",
            "localite": "Lüchingen"
        },
        {
            "code": "9451",
            "localite": "Kriessern"
        },
        {
            "code": "9452",
            "localite": "Hinterforst"
        },
        {
            "code": "9453",
            "localite": "Eichberg"
        },
        {
            "code": "9462",
            "localite": "Montlingen"
        },
        {
            "code": "9463",
            "localite": "Oberriet SG"
        },
        {
            "code": "9464",
            "localite": "Lienz"
        },
        {
            "code": "9464",
            "localite": "Rüthi (Rheintal)"
        },
        {
            "code": "9465",
            "localite": "Salez"
        },
        {
            "code": "9466",
            "localite": "Sennwald"
        },
        {
            "code": "9467",
            "localite": "Frümsen"
        },
        {
            "code": "9468",
            "localite": "Sax"
        },
        {
            "code": "9469",
            "localite": "Haag (Rheintal)"
        },
        {
            "code": "9470",
            "localite": "Buchs SG"
        },
        {
            "code": "9470",
            "localite": "Werdenberg"
        },
        {
            "code": "9472",
            "localite": "Grabs"
        },
        {
            "code": "9472",
            "localite": "Grabserberg"
        },
        {
            "code": "9473",
            "localite": "Gams"
        },
        {
            "code": "9475",
            "localite": "Sevelen"
        },
        {
            "code": "9476",
            "localite": "Fontnas"
        },
        {
            "code": "9476",
            "localite": "Weite"
        },
        {
            "code": "9477",
            "localite": "Trübbach"
        },
        {
            "code": "9478",
            "localite": "Azmoos"
        },
        {
            "code": "9479",
            "localite": "Gretschins"
        },
        {
            "code": "9479",
            "localite": "Malans SG"
        },
        {
            "code": "9479",
            "localite": "Oberschan"
        },
        {
            "code": "9485",
            "localite": "Nendeln"
        },
        {
            "code": "9486",
            "localite": "Schaanwald"
        },
        {
            "code": "9487",
            "localite": "Gamprin-Bendern"
        },
        {
            "code": "9488",
            "localite": "Schellenberg"
        },
        {
            "code": "9490",
            "localite": "Vaduz"
        },
        {
            "code": "9491",
            "localite": "Ruggell"
        },
        {
            "code": "9492",
            "localite": "Eschen"
        },
        {
            "code": "9493",
            "localite": "Mauren FL"
        },
        {
            "code": "9494",
            "localite": "Schaan"
        },
        {
            "code": "9495",
            "localite": "Triesen"
        },
        {
            "code": "9496",
            "localite": "Balzers"
        },
        {
            "code": "9497",
            "localite": "Triesenberg"
        },
        {
            "code": "9498",
            "localite": "Planken"
        },
        {
            "code": "9500",
            "localite": "Wil SG"
        },
        {
            "code": "9502",
            "localite": "Braunau"
        },
        {
            "code": "9503",
            "localite": "Lanterswil"
        },
        {
            "code": "9503",
            "localite": "Stehrenberg"
        },
        {
            "code": "9504",
            "localite": "Friltschen"
        },
        {
            "code": "9506",
            "localite": "Lommis"
        },
        {
            "code": "9507",
            "localite": "Stettfurt"
        },
        {
            "code": "9508",
            "localite": "Weingarten-Kalthäusern"
        },
        {
            "code": "9512",
            "localite": "Rossrüti"
        },
        {
            "code": "9514",
            "localite": "Wuppenau"
        },
        {
            "code": "9515",
            "localite": "Hosenruck"
        },
        {
            "code": "9517",
            "localite": "Mettlen"
        },
        {
            "code": "9523",
            "localite": "Züberwangen"
        },
        {
            "code": "9524",
            "localite": "Zuzwil SG"
        },
        {
            "code": "9525",
            "localite": "Lenggenwil"
        },
        {
            "code": "9526",
            "localite": "Zuckenriet"
        },
        {
            "code": "9527",
            "localite": "Niederhelfenschwil"
        },
        {
            "code": "9532",
            "localite": "Rickenbach b. Wil"
        },
        {
            "code": "9533",
            "localite": "Dietschwil"
        },
        {
            "code": "9533",
            "localite": "Kirchberg SG"
        },
        {
            "code": "9534",
            "localite": "Gähwil"
        },
        {
            "code": "9535",
            "localite": "Wilen b. Wil"
        },
        {
            "code": "9536",
            "localite": "Schwarzenbach SG"
        },
        {
            "code": "9542",
            "localite": "Münchwilen TG"
        },
        {
            "code": "9543",
            "localite": "St. Margarethen TG"
        },
        {
            "code": "9545",
            "localite": "Wängi"
        },
        {
            "code": "9546",
            "localite": "Tuttwil"
        },
        {
            "code": "9547",
            "localite": "Wittenwil"
        },
        {
            "code": "9548",
            "localite": "Matzingen"
        },
        {
            "code": "9552",
            "localite": "Bronschhofen"
        },
        {
            "code": "9553",
            "localite": "Bettwiesen"
        },
        {
            "code": "9554",
            "localite": "Tägerschen"
        },
        {
            "code": "9555",
            "localite": "Tobel"
        },
        {
            "code": "9556",
            "localite": "Affeltrangen"
        },
        {
            "code": "9556",
            "localite": "Zezikon"
        },
        {
            "code": "9562",
            "localite": "Buch b. Märwil"
        },
        {
            "code": "9562",
            "localite": "Märwil"
        },
        {
            "code": "9565",
            "localite": "Bussnang"
        },
        {
            "code": "9565",
            "localite": "Oberbussnang"
        },
        {
            "code": "9565",
            "localite": "Oppikon"
        },
        {
            "code": "9565",
            "localite": "Rothenhausen"
        },
        {
            "code": "9565",
            "localite": "Schmidshof"
        },
        {
            "code": "9573",
            "localite": "Littenheid"
        },
        {
            "code": "9601",
            "localite": "Lütisburg Station"
        },
        {
            "code": "9602",
            "localite": "Bazenheid"
        },
        {
            "code": "9602",
            "localite": "Müselbach"
        },
        {
            "code": "9604",
            "localite": "Lütisburg"
        },
        {
            "code": "9604",
            "localite": "Oberrindal"
        },
        {
            "code": "9604",
            "localite": "Unterrindal"
        },
        {
            "code": "9606",
            "localite": "Bütschwil"
        },
        {
            "code": "9607",
            "localite": "Mosnang"
        },
        {
            "code": "9608",
            "localite": "Ganterschwil"
        },
        {
            "code": "9612",
            "localite": "Dreien"
        },
        {
            "code": "9613",
            "localite": "Mühlrüti"
        },
        {
            "code": "9614",
            "localite": "Libingen"
        },
        {
            "code": "9615",
            "localite": "Dietfurt"
        },
        {
            "code": "9620",
            "localite": "Lichtensteig"
        },
        {
            "code": "9621",
            "localite": "Oberhelfenschwil"
        },
        {
            "code": "9622",
            "localite": "Krinau"
        },
        {
            "code": "9630",
            "localite": "Wattwil"
        },
        {
            "code": "9631",
            "localite": "Ulisbach"
        },
        {
            "code": "9633",
            "localite": "Bächli (Hemberg)"
        },
        {
            "code": "9633",
            "localite": "Hemberg"
        },
        {
            "code": "9642",
            "localite": "Ebnat-Kappel"
        },
        {
            "code": "9643",
            "localite": "Krummenau"
        },
        {
            "code": "9650",
            "localite": "Nesslau"
        },
        {
            "code": "9651",
            "localite": "Ennetbühl"
        },
        {
            "code": "9652",
            "localite": "Neu St. Johann"
        },
        {
            "code": "9655",
            "localite": "Stein SG"
        },
        {
            "code": "9656",
            "localite": "Alt St. Johann"
        },
        {
            "code": "9657",
            "localite": "Unterwasser"
        },
        {
            "code": "9658",
            "localite": "Wildhaus"
        }
    ]
};


export default function getLocalites(lang) {
    const lower_lang = lang.toLowerCase();
    if (localites.hasOwnProperty(lower_lang)) {
        return localites[lower_lang];
    } else {
        return [];
    }
}